import { supabase } from "./supabase";
import RfpModule, { VendorRfpPortal, VendorRfpDashCard, RfpLineCompare, RfpSectionCompare, VendorPurchaseOrders } from "./RfpModule";

//  Email helper 
const sendEmail = async (to, subject, html) => {
  if (!to) return;
  try {
    await fetch("/api/send-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ to, subject, html }),
    });
  } catch (e) {
    console.log("Email send failed:", e.message);
  }
};

const BASE_URL = "https://workroom.stretchfield.com";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
};

//  Auto-generate password from email 
const generatePassword = (email) => {
  if (!email || !email.includes("@")) return "Stretch@2026";
  const local = email.split("@")[0]; // part before @
  const domain = email.split("@")[1].split(".")[0]; // domain without extension
  // Take first 4 chars of local, capitalize first
  const part1 = (local.slice(0, 4).charAt(0).toUpperCase() + local.slice(1, 4)).replace(/[^a-zA-Z0-9]/g, "");
  // Take first 3 chars of domain
  const part2 = domain.slice(0, 3);
  // Add special char and number derived from email length
  const num = (email.length % 9) + 1;
  const specials = ["@", "#", "!", "$", "%"];
  const special = specials[email.length % specials.length];
  return `${part1}${special}${part2}${num}Sf`;
};

const emailHeader = (title) => `
<div style="background:linear-gradient(135deg,#060B14 0%,#0A1628 100%);padding:32px 40px 28px;border-radius:12px 12px 0 0;">
  <table style="border-collapse:collapse;">
    <tr>
      <td style="vertical-align:middle;padding-right:10px;">
        <img src="https://workroom.stretchfield.com/logo512.png" alt="Stretchfield" style="height:32px;width:32px;display:block;" onerror="this.style.display='none'" />
      </td>
      <td style="vertical-align:middle;">
        <span style="color:#00C8FF;font-size:13px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;line-height:32px;">STRETCHFIELD WORKROOM</span>
      </td>
    </tr>
  </table>
  <div style="margin-top:24px;padding-top:20px;border-top:1px solid #1A2E4A;">
    <div style="color:#E8F0FF;font-size:22px;font-weight:800;letter-spacing:-0.02em;line-height:1.3;">${title}</div>
  </div>
</div>`;
const emailFooter = () => `
<div style="background:#060B14;padding:24px 40px;border-radius:0 0 12px 12px;border-top:1px solid #0D1F36;">
  <table style="width:100%;border-collapse:collapse;">
    <tr>
      <td style="vertical-align:middle;">
        <div style="color:#3D5478;font-size:11px;font-style:italic;">We don't plan events. We engineer impact.</div>
        <div style="color:#1E3A5F;font-size:11px;margin-top:6px;line-height:1.8;">
          <a href="https://www.stretchfield.com" style="color:#3D5478;text-decoration:none;">www.stretchfield.com</a> &nbsp;·&nbsp;
          <a href="mailto:info@stretchfield.com" style="color:#3D5478;text-decoration:none;">info@stretchfield.com</a>
        </div>
        <div style="color:#1A2E4A;font-size:10px;margin-top:4px;">© ${new Date().getFullYear()} Stretchfield. All rights reserved. · Accra, Ghana</div>
      </td>
      <td style="text-align:right;vertical-align:middle;">
        <img src="https://workroom.stretchfield.com/logo512.png" alt="Stretchfield" style="height:36px;width:36px;display:inline-block;opacity:0.85;" onerror="this.style.display='none'" />
      </td>
    </tr>
  </table>
</div>`;
const emailBtn = (text, url) => `<a href="${url}" style="display:inline-block;background:linear-gradient(135deg,#00C8FF 0%,#00E5C8 100%);color:#060B14;padding:13px 32px;border-radius:8px;font-weight:800;font-size:13px;text-decoration:none;margin:20px 0;letter-spacing:0.02em;box-shadow:0 4px 14px rgba(0,200,255,0.3);">${text} →</a>`;
const emailRow = (label, value) => `<tr><td style="padding:8px 0;color:#5A6E8A;font-size:12px;font-weight:700;text-transform:uppercase;width:140px;">${label}</td><td style="padding:8px 0;color:#0A1628;font-size:13px;font-weight:600;">${value}</td></tr>`;
const emailWrap = (header, body) => `<div style="font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;max-width:600px;margin:0 auto;background:#ffffff;border-radius:12px;overflow:hidden;box-shadow:0 4px 24px rgba(0,0,0,0.12);">${header}<div style="padding:32px 40px;background:#F4F6FB;">${body}</div>${emailFooter()}</div>`;

const welcomeEmailHtml = ({ name, email, password, role }) => emailWrap(
  emailHeader(`Welcome, ${name}!`),
  `<p style="color:#0A1628;font-size:14px;margin:0 0 16px;">Your Stretchfield WorkRoom account has been created.</p>
  <div style="background:#fff;border:1px solid #C2C9DC;border-radius:8px;padding:20px 24px;margin-bottom:20px;">
    <table style="width:100%;border-collapse:collapse;">${emailRow("Role", role)}${emailRow("Email", email)}${emailRow("Password", `<code style="background:#E8EBF4;padding:2px 8px;border-radius:4px;">${password}</code>`)}</table>
  </div>
  <div style="background:#FFF3CD;border:1px solid #F59E0B;border-radius:6px;padding:10px 14px;margin-bottom:20px;color:#A86000;font-size:12px;"> Please change your password after first login via Account Settings.</div>
  ${emailBtn("Log In to WorkRoom", BASE_URL)}`
);

const notifEmailHtml = ({ name, title, message, actionUrl, actionLabel = "View in WorkRoom" }) => emailWrap(
  emailHeader(title),
  `<p style="color:#0A1628;font-size:14px;margin:0 0 20px;">Hi ${name || "there"},</p>
  <div style="background:#fff;border:1px solid #C2C9DC;border-left:4px solid #00C8FF;border-radius:8px;padding:16px 20px;margin-bottom:20px;">
    <p style="color:#0A1628;font-size:14px;margin:0;line-height:1.6;">${message}</p>
  </div>
  ${actionUrl ? emailBtn(actionLabel, actionUrl) : ""}
  <p style="color:#5A6E8A;font-size:12px;margin-top:20px;">You're receiving this because you have an active Stretchfield WorkRoom account.</p>`
);

const poEmailHtml = ({ vendorName, poNumber, eventName, amount, currency, notes }) => emailWrap(
  emailHeader(`Purchase Order — ${poNumber}`),
  `<p style="color:#0A1628;font-size:14px;margin:0 0 16px;">Dear <strong>${vendorName}</strong>,</p>
  <p style="color:#0A1628;font-size:14px;margin:0 0 14px;"><strong>Congratulations!</strong> Your award has been approved and the Purchase Order below has been signed by all parties.</p>
  <p style="color:#0A1628;font-size:14px;margin:0 0 20px;">This Purchase Order authorises you to start work. Please log in to your WorkRoom to cross-check the PO and the approved scope under <strong>Purchase Orders</strong>. Your invoice has already been recorded from your approved award, so there is no need to raise another one.</p>
  <div style="background:#fff;border:1px solid #C2C9DC;border-radius:8px;padding:20px 24px;margin-bottom:20px;">
    <table style="width:100%;border-collapse:collapse;">${emailRow("PO Number", `<strong style="color:#00C8FF;">${poNumber}</strong>`)}${emailRow("Event", eventName || "—")}${emailRow("Amount", `<strong>${currency} ${parseFloat(amount || 0).toLocaleString()}</strong>`)}${notes ? emailRow("Notes", notes) : ""}</table>
  </div>
  ${emailBtn("View Purchase Order in WorkRoom", BASE_URL)}`
);


const rffEmailHtml = ({ vendorName, rffTitle, eventName, deadline, category, notes }) => emailWrap(
  emailHeader(`Request for Quote — ${rffTitle}`),
  `<p style="color:#0A1628;font-size:14px;margin:0 0 16px;">Dear <strong>${vendorName}</strong>,</p>
  <p style="color:#0A1628;font-size:14px;margin:0 0 20px;">Stretchfield has selected you as a preferred vendor and would like to invite you to submit a quote for the following engagement.</p>
  <div style="background:#fff;border:1px solid #C2C9DC;border-radius:8px;padding:20px 24px;margin-bottom:20px;">
    <table style="width:100%;border-collapse:collapse;">
      ${emailRow("RFF Title", rffTitle)}
      ${emailRow("Event", eventName || "—")}
      ${emailRow("Category", category || "—")}
      ${deadline ? emailRow("Quote Deadline", new Date(deadline).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" })) : ""}
      ${notes ? emailRow("Notes", notes) : ""}
    </table>
  </div>
  <div style="background:#E8F8FF;border:1px solid #00C8FF30;border-radius:8px;padding:14px 18px;margin-bottom:20px;color:#0A1628;font-size:13px;line-height:1.6;">
    Please log in to the Stretchfield Vendor Portal to view full details and submit your quote. Quotes submitted after the deadline will not be considered.
  </div>
  ${emailBtn("Submit Your Quote", BASE_URL)}`
);

const paymentAuthorisedEmailHtml = ({ vendorName, amount, eventName, paymentMethod, paymentTerms, bankName, accountNumber, accountName, mobileNumber }) => emailWrap(
  emailHeader(`Payment Authorised — GHS ${parseFloat(amount || 0).toLocaleString()}`),
  `<p style="color:#0A1628;font-size:14px;margin:0 0 16px;">Dear <strong>${vendorName}</strong>,</p>
  <p style="color:#0A1628;font-size:14px;margin:0 0 20px;">We are pleased to confirm that your payment has been fully authorised and approved by Stretchfield leadership. You should expect to receive payment as per your agreed terms.</p>
  <div style="background:#fff;border:1px solid #C2C9DC;border-radius:8px;padding:20px 24px;margin-bottom:20px;">
    <table style="width:100%;border-collapse:collapse;">
      ${emailRow("Amount", `<strong style="color:#00C8FF;font-size:16px;">GHS ${parseFloat(amount || 0).toLocaleString()}</strong>`)}
      ${eventName ? emailRow("Event", eventName) : ""}
      ${paymentTerms ? emailRow("Payment Terms", paymentTerms) : ""}
      ${paymentMethod ? emailRow("Payment Method", paymentMethod.replace("_", " ").toUpperCase()) : ""}
      ${bankName ? emailRow("Bank", bankName) : ""}
      ${accountName ? emailRow("Account Name", accountName) : ""}
      ${accountNumber ? emailRow("Account Number", accountNumber) : ""}
      ${mobileNumber ? emailRow("Mobile Money", mobileNumber) : ""}
    </table>
  </div>
  <div style="background:#E8FFF5;border:1px solid #00E5C830;border-radius:8px;padding:14px 18px;margin-bottom:20px;color:#0A1628;font-size:13px;">
     This payment has been signed off by Stretchfield's Finance Manager and CEO. If you have any questions, please contact your Vendor Manager.
  </div>
  ${emailBtn("View in Vendor Portal", BASE_URL)}`
);

const taskEmailHtml = ({ staffName, taskName, eventName, deadline, assignedBy, notes }) => emailWrap(
  emailHeader(`New Task Assigned`),
  `<p style="color:#0A1628;font-size:14px;margin:0 0 16px;">Hi <strong>${staffName}</strong>,</p>
  <p style="color:#0A1628;font-size:14px;margin:0 0 20px;">A new task has been assigned to you on Stretchfield WorkRoom.</p>
  <div style="background:#fff;border:1px solid #C2C9DC;border-left:4px solid #00C8FF;border-radius:8px;padding:20px 24px;margin-bottom:20px;">
    <div style="color:#0A1628;font-size:16px;font-weight:800;margin-bottom:12px;">${taskName}</div>
    <table style="width:100%;border-collapse:collapse;">
      ${eventName ? emailRow("Event", eventName) : ""}
      ${deadline ? emailRow("Deadline", new Date(deadline).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })) : ""}
      ${assignedBy ? emailRow("Assigned By", assignedBy) : ""}
      ${notes ? emailRow("Notes", notes) : ""}
    </table>
  </div>
  ${emailBtn("View Task in WorkRoom", BASE_URL)}`
);

const paymentRequestEmailHtml = ({ financeName, vendorName, amount, eventName, paymentMethod, requestedBy, workConfirmed, invoiceMatchesPO }) => emailWrap(
  emailHeader(`Payment Request — ${vendorName}`),
  `<p style="color:#0A1628;font-size:14px;margin:0 0 16px;">Hi <strong>${financeName}</strong>,</p>
  <p style="color:#0A1628;font-size:14px;margin:0 0 20px;">A payment authorisation request has been submitted and requires your review and signature.</p>
  <div style="background:#fff;border:1px solid #C2C9DC;border-radius:8px;padding:20px 24px;margin-bottom:20px;">
    <table style="width:100%;border-collapse:collapse;">
      ${emailRow("Vendor", vendorName)}
      ${emailRow("Amount", `<strong style="color:#00C8FF;font-size:15px;">GHS ${parseFloat(amount || 0).toLocaleString()}</strong>`)}
      ${eventName ? emailRow("Event", eventName) : ""}
      ${paymentMethod ? emailRow("Payment Method", paymentMethod.replace("_", " ").toUpperCase()) : ""}
      ${emailRow("Requested By", requestedBy)}
      ${emailRow("Work Confirmed", workConfirmed ? " Yes" : "—")}
      ${emailRow("Invoice Matches PO", invoiceMatchesPO ? " Yes" : "—")}
    </table>
  </div>
  <div style="background:#FFF8E8;border:1px solid #F59E0B30;border-radius:8px;padding:14px 18px;margin-bottom:20px;color:#A86000;font-size:13px;">
    Please log in to WorkRoom to review the full details, verify payment information and add your digital signature.
  </div>
  ${emailBtn("Review & Sign Payment", BASE_URL)}`
);

const intelligenceReportEmailHtml = ({ ceoName, eventName, clientName, submittedBy, section }) => emailWrap(
  emailHeader(`Intelligence Report Update — ${eventName}`),
  `<p style="color:#0A1628;font-size:14px;margin:0 0 16px;">Hi <strong>${ceoName}</strong>,</p>
  <p style="color:#0A1628;font-size:14px;margin:0 0 20px;">A new section of the Event Intelligence Report has been submitted and is ready for your review.</p>
  <div style="background:#fff;border:1px solid #C2C9DC;border-left:4px solid #00E5C8;border-radius:8px;padding:20px 24px;margin-bottom:20px;">
    <table style="width:100%;border-collapse:collapse;">
      ${emailRow("Event", eventName)}
      ${clientName ? emailRow("Client", clientName) : ""}
      ${emailRow("Section Submitted", section)}
      ${emailRow("Submitted By", submittedBy)}
      ${emailRow("Date", new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }))}
    </table>
  </div>
  <p style="color:#0A1628;font-size:13px;margin:0 0 20px;">Once all sections are complete, you can log in to generate the AI-powered Intelligence Summary for this event.</p>
  ${emailBtn("View Intelligence Report", BASE_URL)}`
);



const sendNotificationEmail = async (userId, title, message, actionTab) => {
  try {
    const { data: profile } = await supabase.from("profiles").select("name, email").eq("id", userId).single();
    if (!profile?.email) return;
    const actionUrl = actionTab ? `https://workroom.stretchfield.com?tab=${actionTab}` : "https://workroom.stretchfield.com";
    const html = `
      <div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;">
        <div style="background:#060B14;padding:28px 32px;border-radius:8px 8px 0 0;">
          <div style="color:#00C8FF;font-size:11px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;margin-bottom:4px;">STRETCHFIELD</div>
          <div style="color:#E8F0FF;font-size:20px;font-weight:800;">${title}</div>
        </div>
        <div style="padding:28px 32px;background:#F0F2FA;">
          <p style="color:#0A1628;font-size:14px;margin:0 0 20px;">Hi ${profile.name || "there"},</p>
          <div style="background:#ffffff;border:1px solid #C2C9DC;border-left:4px solid #00C8FF;border-radius:8px;padding:16px 20px;margin-bottom:20px;">
            <p style="color:#0A1628;font-size:14px;margin:0;line-height:1.6;">${message}</p>
          </div>
          <a href="${actionUrl}" style="display:inline-block;background:linear-gradient(135deg,#00C8FF,#00E5C8);color:#060B14;padding:12px 28px;border-radius:8px;font-weight:800;font-size:13px;text-decoration:none;">View in WorkRoom</a>
          <p style="color:#5A6E8A;font-size:12px;margin-top:20px;">You're receiving this because you have an active account on Stretchfield WorkRoom.</p>
        </div>
        <div style="background:#060B14;padding:20px 32px;border-radius:0 0 8px 8px;text-align:center;">
          <div style="color:#3D5478;font-size:11px;font-style:italic;margin-bottom:6px;">We don't plan events. We engineer impact.</div>
          <div style="color:#1A2E4A;font-size:10px;">© ${new Date().getFullYear()} Stretchfield · www.stretchfield.com</div>
        </div>
      </div>`;
    await sendEmail(profile.email, `Stretchfield — ${title}`, html);
  } catch (e) {
    console.warn("Notification email failed:", e.message);
  }
};
import React, { useState, useEffect, useContext } from "react";
import { getEvents, createEvent, updateEvent, getTasks, createTask, getProfiles, deleteProfile, updateTask, getInvoices, createInvoice, updateInvoice, getRFFs, createRFF, updateRFF, uploadRFFDocument } from "./dataService";

//  LOGO 
const LOGO_SRC = "data:image/png;base64,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";

//  DATA 
const USERS = {
  ceo: { id: "ceo", name: "David Osei", role: "CEO", email: "david@stretchfield.com", avatar: "DO" },
  admin: { id: "admin", name: "Ama Mensah", role: "Country Manager", email: "ama@stretchfield.com", avatar: "AM" },
  vendorMgr: { id: "vendorMgr", name: "Kofi Asante", role: "Vendor Manager", email: "kofi@stretchfield.com", avatar: "KA" },
  events: { id: "events", name: "Abena Boateng", role: "Strategy & Events Lead", email: "abena@stretchfield.com", avatar: "AB" },
  marketing: { id: "marketing", name: "Kwame Darko", role: "Sales & Marketing", email: "kwame@stretchfield.com", avatar: "KD" },
  vendor: { id: "vendor", name: "TechPro Solutions", role: "Vendor", email: "info@techpro.com", avatar: "TP" },
  client: { id: "client", name: "Acme Corp", role: "Client", email: "events@acme.com", avatar: "AC" },
};

const PROJECTS = [
  { id: "p1", name: "Acme Brand Refresh", client: "Acme Corp", completion: 65, status: "active", deadline: "2025-08-30", phase: "Execution", tasks: 12, completed: 8 },
  { id: "p2", name: "TechPro Website Redesign", client: "TechPro Ltd", completion: 40, status: "active", deadline: "2025-09-15", phase: "Design", tasks: 18, completed: 7 },
  { id: "p3", name: "Sunrise Event Campaign", client: "Sunrise Hotels", completion: 90, status: "active", deadline: "2025-07-20", phase: "Review", tasks: 10, completed: 9 },
  { id: "p4", name: "MaxFin Digital Strategy", client: "MaxFin", completion: 20, status: "active", deadline: "2025-10-01", phase: "Planning", tasks: 15, completed: 3 },
];

const TASKS = [
  { id: "t1", event: "p1", name: "Logo Design v3", assignee: "vendor", status: "in-progress", progress: 75, deadline: "2025-07-15", comments: 3 },
  { id: "t2", event: "p1", name: "Brand Guidelines Document", assignee: "events", status: "completed", progress: 100, deadline: "2025-07-01", comments: 1 },
  { id: "t3", event: "p1", name: "Social Media Templates", assignee: "marketing", status: "in-progress", progress: 50, deadline: "2025-07-22", comments: 5 },
  { id: "t4", event: "p2", name: "UX Wireframes", assignee: "vendor", status: "pending", progress: 0, deadline: "2025-07-25", comments: 0 },
  { id: "t5", event: "p2", name: "Homepage Design", assignee: "vendor", status: "in-progress", progress: 30, deadline: "2025-08-01", comments: 2 },
  { id: "t6", event: "p3", name: "Event Concept Deck", assignee: "marketing", status: "completed", progress: 100, deadline: "2025-06-30", comments: 4 },
];

const RFFS = [
  { id: "rff1", title: "Brand Identity Package — Acme", vendor: "TechPro Solutions", event: "p1", status: "quote-submitted", deadline: "2025-07-10", amount: null },
  { id: "rff2", title: "Website Development — TechPro", vendor: "TechPro Solutions", event: "p2", status: "quote-approved", deadline: "2025-07-18", amount: 4500 },
  { id: "rff3", title: "Event Materials — Sunrise", vendor: "PrintMaster GH", event: "p3", status: "invoice-submitted", deadline: "2025-07-05", amount: 1200 },
  { id: "rff4", title: "Video Production — MaxFin", vendor: "VisualEdge Studios", event: "p4", status: "pending", deadline: "2025-08-01", amount: null },
];

const INVOICES = [
  { id: "inv1", vendor: "TechPro Solutions", event: "p2", amount: 4500, status: "approved", date: "2025-07-01", rff: "rff2" },
  { id: "inv2", vendor: "PrintMaster GH", event: "p3", amount: 1200, status: "pending", date: "2025-07-05", rff: "rff3" },
  { id: "inv3", vendor: "CreativeHub", event: "p1", amount: 2800, status: "paid", date: "2025-06-20", rff: "rff1" },
];

const NOTIFICATIONS = {
  ceo: [
    { id: 1, text: "Invoice #INV-002 pending approval", time: "2h ago", unread: true, type: "invoice" },
    { id: 2, text: "Event 'Sunrise Event Campaign' is 90% complete", time: "5h ago", unread: true, type: "event" },
    { id: 3, text: "New vendor quote submitted for RFF-001", time: "1d ago", unread: false, type: "vendor" },
  ],
  vendor: [
    { id: 1, text: "Your quote for RFF-002 has been approved", time: "3h ago", unread: true, type: "approval" },
    { id: 2, text: "New RFF assigned: Brand Identity Package", time: "1d ago", unread: true, type: "rff" },
    { id: 3, text: "Task 'Logo Design v3' comment from Kofi", time: "2d ago", unread: false, type: "task" },
  ],
  client: [
    { id: 1, text: "Task 'Brand Guidelines' has been completed", time: "1h ago", unread: true, type: "task" },
    { id: 2, text: "Event milestone reached: 65% completion", time: "6h ago", unread: true, type: "milestone" },
    { id: 3, text: "New report uploaded for your review", time: "2d ago", unread: false, type: "report" },
  ],
};

//  THEME — Deep Navy + Cyan/Blue/Magenta Luxury 
//  THEME SYSTEM 
const DARK_THEME = {
  bg:           "#060B14",
  bgDeep:       "#03070E",
  surface:      "#0C1525",
  surfaceRaise: "#0F1C30",
  surfaceHigh:  "#152238",
  border:       "#1A2E4A",
  borderLight:  "#223B5E",
  cyan:         "#00C8FF",
  cyanDim:      "#00C8FF18",
  cyanGlow:     "#00C8FF",
  magenta:      "#E040FB",
  magentaDim:   "#E040FB15",
  teal:         "#00E5C8",
  tealDim:      "#00E5C815",
  blue:         "#3B7BFF",
  blueDim:      "#3B7BFF15",
  amber:        "#F59E0B",
  amberDim:     "#F59E0B15",
  red:          "#F43F5E",
  redDim:       "#F43F5E15",
  gold:         "#C9A84C",
  goldDim:      "#C9A84C15",
  textPrimary:  "#E8F0FF",
  textSecondary:"#7A94BF",
  textMuted:    "#3D5478",
  textGhost:    "#243551",
  isDark:       true,
};

const LIGHT_THEME = {
  bg: "#E8EBF4",
  bgDeep: "#DCE0ED",
  surface: "#F0F2FA",
  border: "#C2C9DC",
  cyan: "#0077BB",
  teal: "#008870",
  amber: "#A86000",
  gold: "#8A6010",
  textPrimary: "#0A1628",
  textSecondary: "#2A3F5F",
  textMuted: "#5A6E8A",
  textGhost: "#B0BCCC",
  red: "#C0192A",
  magenta: "#A020C0",
  blue: "#2255CC",
  accent: "#0077BB",
  orange: "#A86000",
};

let T = DARK_THEME;

const ThemeContext = React.createContext({ isDark: true, toggleTheme: () => {}, theme: DARK_THEME });

const ThemeProvider = ({ children }) => {
  const getInitial = () => { try { return localStorage.getItem("sf-theme") !== "light"; } catch { return true; } };
  const [isDark, setIsDark] = React.useState(getInitial);

  const toggleTheme = () => {
    setIsDark(prev => {
      const next = !prev;
      try { localStorage.setItem("sf-theme", next ? "dark" : "light"); } catch {}
      return next;
    });
  };

  const theme = isDark ? DARK_THEME : LIGHT_THEME;
  // Keep global T in sync so inline styles using T still work
  T = theme;

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme, theme }}>
      <ThemeConsumer>{children}</ThemeConsumer>
    </ThemeContext.Provider>
  );
};

// Forces ALL children to re-render when theme changes by consuming context
const ThemeConsumer = ({ children }) => {
  const { theme } = React.useContext(ThemeContext);
  // Update global T on every render of any child tree
  T = theme;
  return (
    <div style={{ minHeight: "100vh", background: theme.bg, color: theme.textPrimary, transition: "background 0.3s, color 0.3s" }}>
      {children}
    </div>
  );
};

const useTheme = () => React.useContext(ThemeContext);


const SignatureInput = ({ label, canvasRef, onSignatureChange, savedSignature, isDrawing, setIsDrawing, lastPos, setLastPos }) => {
  const [mode, setMode] = React.useState(savedSignature ? "saved" : "draw");
  const [usingSaved, setUsingSaved] = React.useState(!!savedSignature);

  React.useEffect(() => {
    if (mode === "saved" && savedSignature) {
      onSignatureChange(savedSignature);
      setUsingSaved(true);
    } else if (mode === "draw") {
      setUsingSaved(false);
    }
  }, [mode, savedSignature]);

  // Auto-set saved signature on mount if available
  React.useEffect(() => {
    if (savedSignature) {
      onSignatureChange(savedSignature);
      setUsingSaved(true);
    }
  }, []);

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", marginBottom: 8 }}>{label || "Signature"}</div>
      {savedSignature && (
        <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
          <button onClick={() => setMode("saved")} style={{ padding: "5px 14px", borderRadius: 20, border: "1px solid "+(mode==="saved"?T.cyan:T.border), background: mode==="saved"?T.cyan+"20":"none", color: mode==="saved"?T.cyan:T.textMuted, fontSize: 11, fontWeight: 700, cursor: "pointer" }}> Use Saved Signature</button>
          <button onClick={() => { setMode("draw"); onSignatureChange(""); if(canvasRef?.current){const ctx=canvasRef.current.getContext("2d");ctx.clearRect(0,0,canvasRef.current.width,canvasRef.current.height);} }} style={{ padding: "5px 14px", borderRadius: 20, border: "1px solid "+(mode==="draw"?T.cyan:T.border), background: mode==="draw"?T.cyan+"20":"none", color: mode==="draw"?T.cyan:T.textMuted, fontSize: 11, fontWeight: 700, cursor: "pointer" }}> Draw New</button>
        </div>
      )}
      {mode === "saved" && savedSignature ? (
        <div style={{ background: "#fff", border: "1px solid "+T.teal+"40", borderRadius: 8, padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <img src={savedSignature} alt="Saved signature" style={{ maxHeight: 60, maxWidth: 220, objectFit: "contain" }} />
          <span style={{ color: T.teal, fontSize: 11, fontWeight: 700 }}> Saved</span>
        </div>
      ) : (
        <div>
          <div style={{ border: "1px solid "+T.border, borderRadius: 8, overflow: "hidden", background: "#fff" }}>
            <canvas ref={canvasRef} width={440} height={120}
              style={{ display: "block", cursor: "crosshair", touchAction: "none", width: "100%" }}
              onMouseDown={e=>{ setIsDrawing(true); const r=e.target.getBoundingClientRect(); const sx=440/r.width; setLastPos({x:(e.clientX-r.left)*sx,y:(e.clientY-r.top)*sx}); }}
              onMouseMove={e=>{ if(!isDrawing) return; const r=e.target.getBoundingClientRect(); const sx=440/r.width; const pos={x:(e.clientX-r.left)*sx,y:(e.clientY-r.top)*sx}; const ctx=canvasRef.current?.getContext("2d"); if(ctx&&lastPos){ctx.beginPath();ctx.moveTo(lastPos.x,lastPos.y);ctx.lineTo(pos.x,pos.y);ctx.strokeStyle="#1a365d";ctx.lineWidth=2;ctx.lineCap="round";ctx.stroke();} setLastPos(pos); }}
              onMouseUp={()=>{ setIsDrawing(false); onSignatureChange(canvasRef.current?.toDataURL()||""); }}
              onMouseLeave={()=>{ setIsDrawing(false); if(canvasRef.current) onSignatureChange(canvasRef.current.toDataURL()||""); }}
              onTouchStart={e=>{ e.preventDefault(); setIsDrawing(true); const r=e.target.getBoundingClientRect(); const sx=440/r.width; const t=e.touches[0]; setLastPos({x:(t.clientX-r.left)*sx,y:(t.clientY-r.top)*sx}); }}
              onTouchMove={e=>{ e.preventDefault(); if(!isDrawing) return; const r=e.target.getBoundingClientRect(); const sx=440/r.width; const t=e.touches[0]; const pos={x:(t.clientX-r.left)*sx,y:(t.clientY-r.top)*sx}; const ctx=canvasRef.current?.getContext("2d"); if(ctx&&lastPos){ctx.beginPath();ctx.moveTo(lastPos.x,lastPos.y);ctx.lineTo(pos.x,pos.y);ctx.strokeStyle="#1a365d";ctx.lineWidth=2;ctx.lineCap="round";ctx.stroke();} setLastPos(pos); }}
              onTouchEnd={()=>{ setIsDrawing(false); onSignatureChange(canvasRef.current?.toDataURL()||""); }}
            />
          </div>
          <button onClick={()=>{ const ctx=canvasRef.current?.getContext("2d"); if(ctx) ctx.clearRect(0,0,440,120); onSignatureChange(""); }} style={{ background:"none", border:"none", color:T.textMuted, fontSize:11, cursor:"pointer", marginTop:4 }}>Clear</button>
        </div>
      )}
    </div>
  );
};



const AccountSettingsModal = ({ user, onClose, onUpdate }) => {
  const [phone, setPhone] = React.useState(user?.phone || "");
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [avatarFile, setAvatarFile] = React.useState(null);
  const [avatarPreview, setAvatarPreview] = React.useState(user?.avatar_url || null);
  const [saving, setSaving] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);
  const [msg, setMsg] = React.useState("");
  const [error, setError] = React.useState("");
  const [savedSignature, setSavedSignature] = React.useState(user?.saved_signature || null);
  const [sigFile, setSigFile] = React.useState(null);
  const [sigUploading, setSigUploading] = React.useState(false);
  const fileRef = React.useRef();
  const sigFileRef = React.useRef();

  // Load fresh signature from DB on mount
  React.useEffect(() => {
    supabase.from("profiles").select("saved_signature").eq("id", user.id).single().then(({ data }) => {
      if (data?.saved_signature) setSavedSignature(data.saved_signature);
    });
  }, [user.id]);

  const handleAvatarChange = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setAvatarFile(f);
    setAvatarPreview(URL.createObjectURL(f));
  };

  const handleSave = async () => {
    setError(""); setMsg("");
    if (password && password !== confirmPassword) { setError("Passwords do not match."); return; }
    setSaving(true);
    let avatar_url = user.avatar_url || null;

    // Upload avatar if changed
    if (avatarFile) {
      setUploading(true);
      const ext = avatarFile.name.split(".").pop();
      const filename = `avatar_${user.id}_${Date.now()}.${ext}`;
      const { error: upErr } = await supabase.storage.from("avatars").upload(filename, avatarFile, { upsert: true });
      if (upErr) { setError("Upload failed: " + upErr.message); setSaving(false); setUploading(false); return; }
      const { data: urlData } = supabase.storage.from("avatars").getPublicUrl(filename);
      avatar_url = urlData.publicUrl;
      setUploading(false);
    }

    // Upload signature if changed
    let saved_signature = user.saved_signature || null;
    if (sigFile) {
      setSigUploading(true);
      const ext = sigFile.name.split(".").pop();
      const filename = "signature_"+user.id+"_"+Date.now()+"."+ext;
      const { error: sigErr } = await supabase.storage.from("avatars").upload(filename, sigFile, { upsert: true });
      if (!sigErr) {
        const { data: sigUrl } = supabase.storage.from("avatars").getPublicUrl(filename);
        saved_signature = sigUrl.publicUrl;
        setSavedSignature(saved_signature);
      }
      setSigUploading(false);
    }

    // Update profile
    const updates = { phone, avatar_url, saved_signature };
    await supabase.from("profiles").update(updates).eq("id", user.id);

    // Update password if provided
    if (password) {
      const { error: pwErr } = await supabase.auth.updateUser({ password });
      if (pwErr) { setError("Password update failed: " + pwErr.message); setSaving(false); return; }
    }

    setSaving(false);
    setMsg("Profile updated successfully.");
    onUpdate({ ...user, phone, avatar_url, saved_signature });
  };

  const initials = user.name ? user.name.split(" ").map(n => n[0]).join("").slice(0,2).toUpperCase() : "?";

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={onClose}>
      <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 480, boxShadow: `0 24px 80px rgba(0,0,0,0.5)`, animation: "fadeUp 0.25s ease" }}
        onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: "20px 24px", borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 4 }}>Account</div>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18 }}>Profile Settings</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, width: 32, height: 32, borderRadius: 8, cursor: "pointer", fontSize: 18, display: "flex", alignItems: "center", justifyContent: "center" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = T.red + "60"; e.currentTarget.style.color = T.red; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.color = T.textMuted; }}>×</button>
        </div>

        <div style={{ padding: "24px" }}>
          {/* Avatar upload */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 28 }}>
            <div onClick={() => fileRef.current.click()} style={{ width: 96, height: 96, borderRadius: "50%", overflow: "hidden", border: `3px solid ${T.cyan}40`, cursor: "pointer", position: "relative", background: T.bg, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 10 }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.cyan}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.cyan + "40"}>
              {avatarPreview ? (
                <img src={avatarPreview} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              ) : (
                <div style={{ width: "100%", height: "100%", background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span style={{ color: "#fff", fontWeight: 900, fontSize: 28 }}>{initials}</span>
                </div>
              )}
              {/* Overlay */}
              <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", opacity: 0, transition: "opacity 0.2s", borderRadius: "50%" }}
                onMouseEnter={e => e.currentTarget.style.opacity = 1}
                onMouseLeave={e => e.currentTarget.style.opacity = 0}>
                <span style={{ color: "#fff", fontSize: 22 }}></span>
              </div>
            </div>
            <input ref={fileRef} type="file" accept="image/*" onChange={handleAvatarChange} style={{ display: "none" }} />
            <div style={{ color: T.textMuted, fontSize: 11 }}>Click to change photo</div>
          </div>

          {/* Name (read only) */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Name</label>
            <div style={{ padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}44`, borderRadius: 8, color: T.textMuted, fontSize: 13 }}>{user.name}</div>
          </div>

          {/* Phone */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Phone Number</label>
            <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="+233 XX XXX XXXX"
              style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
              onFocus={e => e.target.style.borderColor = T.cyan + "60"}
              onBlur={e => e.target.style.borderColor = T.border} />
          </div>

          {/* New Password */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>New Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Leave blank to keep current"
              style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
              onFocus={e => e.target.style.borderColor = T.cyan + "60"}
              onBlur={e => e.target.style.borderColor = T.border} />
          </div>

          {/* Confirm Password */}
          <div style={{ marginBottom: 20 }}>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Confirm Password</label>
            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Repeat new password"
              style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
              onFocus={e => e.target.style.borderColor = T.cyan + "60"}
              onBlur={e => e.target.style.borderColor = T.border} />
          </div>

          {/*  SIGNATURE UPLOAD  */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 8 }}>Saved Signature</label>
            {savedSignature ? (
              <div style={{ marginBottom: 10 }}>
                <div style={{ background: "#fff", border: "1px solid "+T.border, borderRadius: 8, padding: "12px 16px", marginBottom: 8, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <img src={savedSignature} alt="Saved signature" style={{ maxHeight: 50, maxWidth: 200, objectFit: "contain" }} />
                  <button onClick={() => { setSavedSignature(null); setSigFile(null); }} style={{ background: T.red+"15", border: "1px solid "+T.red+"30", color: T.red, padding: "4px 10px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>Remove</button>
                </div>
                <div style={{ color: T.teal, fontSize: 11 }}> Signature saved — will be available in all signing modals</div>
              </div>
            ) : (
              <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 8 }}>No signature saved yet. Upload a PNG or JPG of your signature.</div>
            )}
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <input ref={sigFileRef} type="file" accept=".png,.jpg,.jpeg" onChange={e => { const f = e.target.files[0]; if (!f) return; setSigFile(f); setSavedSignature(URL.createObjectURL(f)); }} style={{ display: "none" }} />
              <button onClick={() => sigFileRef.current?.click()} style={{ background: T.cyan+"15", border: "1px solid "+T.cyan+"30", color: T.cyan, padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 12 }}>
                {sigFile ? " "+sigFile.name.slice(0,20) : " Upload Signature (PNG/JPG)"}
              </button>
              {sigUploading && <span style={{ color: T.textMuted, fontSize: 12 }}>Uploading...</span>}
            </div>
          </div>

          {error && <div style={{ color: T.red, fontSize: 12, marginBottom: 12, padding: "8px 12px", background: T.red + "12", borderRadius: 8 }}>{error}</div>}
          {msg && <div style={{ color: T.teal, fontSize: 12, marginBottom: 12, padding: "8px 12px", background: T.teal + "12", borderRadius: 8 }}> {msg}</div>}

          <button onClick={handleSave} disabled={saving} style={{
            width: "100%", padding: "11px", background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`,
            border: "none", borderRadius: 8, color: "#fff", fontWeight: 800, fontSize: 13,
            cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.7 : 1, fontFamily: "inherit",
          }}>{uploading || sigUploading ? "Uploading..." : saving ? "Saving..." : "Save Changes"}</button>
        </div>
      </div>
    </div>
  );
};

const ThemeToggle = ({ compact }) => {
  const { isDark, toggleTheme } = useTheme();
  return (
    <button onClick={toggleTheme} title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
      style={{
        background: "none", border: `1px solid ${T.border}`, borderRadius: 20,
        padding: compact ? "4px 10px" : "5px 14px", cursor: "pointer",
        display: "flex", alignItems: "center", gap: 6,
        color: T.textMuted, fontSize: 11, fontWeight: 600,
        letterSpacing: "0.06em", transition: "all 0.2s", flexShrink: 0,
      }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = T.cyan + "80"; e.currentTarget.style.color = T.cyan; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.color = T.textMuted; }}
    >
      <span style={{ fontSize: 13 }}>{isDark ? "" : ""}</span>
      {!compact && <span>{isDark ? "Light" : "Dark"}</span>}
    </button>
  );
};

//  HELPERS 
const getCurrency = (country) => (country === 'Nigeria') ? 'NGN' : 'GHS';
const fmtMoney = (amount, country) => getCurrency(country||'Ghana') + ' ' + parseFloat(amount||0).toLocaleString();

const statusMeta = (s) => ({
  "active":           { color: T.teal,    label: "Active" },
  "completed":        { color: T.cyan,    label: "Completed" },
  "in-progress":      { color: T.amber,   label: "In Progress" },
  "pending":          { color: T.textMuted, label: "Pending" },
  "quote-submitted":  { color: T.amber,   label: "Quote Submitted" },
  "quote-approved":   { color: T.teal,    label: "Quote Approved" },
  "invoice-submitted":{ color: T.blue,    label: "Invoice Submitted" },
  "approved":         { color: T.teal,    label: "Approved" },
  "paid":             { color: T.cyan,    label: "Paid" },
}[s] || { color: T.textMuted, label: s });

const Badge = ({ status }) => {
  const m = statusMeta(status);
  return (
    <span style={{
      background: m.color + "18",
      color: m.color,
      border: `1px solid ${m.color}35`,
      padding: "3px 10px",
      borderRadius: 3,
      fontSize: 10,
      fontWeight: 700,
      letterSpacing: "0.10em",
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      fontFamily: "'Cormorant Garamond', serif",
    }}>{m.label}</span>
  );
};

const ProgressBar = ({ value, color = T.cyan, height = 4 }) => (
  <div style={{ background: T.bgDeep, borderRadius: 0, height, overflow: "hidden", width: "100%", border: `1px solid ${T.border}` }}>
    <div style={{
      width: `${value}%`, height: "100%",
      background: `linear-gradient(90deg, ${color}88, ${color})`,
      transition: "width 0.8s cubic-bezier(0.22,1,0.36,1)",
    }} />
  </div>
);

const Avatar = ({ initials, size = 36, color = T.cyan }) => (
  <div style={{
    width: size, height: size,
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${color}22, ${color}08)`,
    border: `1px solid ${color}44`,
    color,
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: size * 0.30, fontWeight: 700, flexShrink: 0,
    letterSpacing: "0.06em",
    fontFamily: "'Cormorant Garamond', serif",
  }}>{initials}</div>
);

const Divider = () => (
  <div style={{ height: 1, background: `linear-gradient(90deg, transparent, ${T.borderLight}60, transparent)`, margin: "0" }} />
);

const Card = ({ children, style = {}, onClick, accent }) => (
  <div onClick={onClick} style={{
    background: T.surface,
    border: `1px solid ${accent ? accent + "30" : T.border}`,
    borderTop: accent ? `1px solid ${accent}60` : `1px solid ${T.borderLight}`,
    borderRadius: 2,
    padding: 24,
    cursor: onClick ? "pointer" : "default",
    transition: "border-color 0.25s, box-shadow 0.25s, transform 0.2s",
    position: "relative",
    overflow: "hidden",
    ...style,
  }}
    onMouseEnter={e => { if (onClick) { e.currentTarget.style.borderColor = T.cyan + "40"; e.currentTarget.style.boxShadow = `0 8px 40px ${T.cyan}10`; e.currentTarget.style.transform = "translateY(-2px)"; } }}
    onMouseLeave={e => { if (onClick) { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; } }}
  >
    {accent && <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 1, background: `linear-gradient(90deg, transparent, ${accent}80, transparent)` }} />}
    {children}
  </div>
);

const Stat = ({ label, value, sub, color = T.cyan, icon }) => (
  <Card accent={color} style={{ flex: 1, minWidth: 140 }}>
    <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, marginBottom: 12, display: "flex", alignItems: "center", gap: 6, textTransform: "uppercase", letterSpacing: "0.14em" }}>
      <span style={{ color }}>{icon}</span>{label}
    </div>
    <div style={{ fontSize: 32, fontWeight: 300, color, letterSpacing: "-0.03em", fontFamily: "'Cormorant Garamond', serif", lineHeight: 1 }}>{value}</div>
    {sub && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 8, letterSpacing: "0.04em" }}>{sub}</div>}
  </Card>
);

const SectionLabel = ({ children }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
    <div style={{ width: 3, height: 16, background: `linear-gradient(180deg, ${T.cyan}, ${T.magenta})`, borderRadius: 2 }} />
    <span style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.18em", textTransform: "uppercase" }}>{children}</span>
  </div>
);

const SectionHeader = ({ title, action, actionLabel }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
    <SectionLabel>{title}</SectionLabel>
    {action && <button onClick={action} style={{
      background: "transparent", color: T.cyan, border: `1px solid ${T.cyan}35`,
      borderRadius: 2, padding: "5px 14px", fontSize: 10, fontWeight: 700, cursor: "pointer",
      letterSpacing: "0.10em", textTransform: "uppercase", transition: "all 0.2s",
    }}
      onMouseEnter={e => { e.currentTarget.style.background = T.cyanDim; }}
      onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
    >{actionLabel}</button>}
  </div>
);

const Modal = ({ title, children, onClose }) => (
  <div style={{
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", zIndex: 1000,
    display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
    backdropFilter: "blur(4px)",
  }} onClick={onClose}>
    <div onClick={e => e.stopPropagation()} style={{
      background: T.surface,
      border: `1px solid ${T.borderLight}`,
      borderTop: `1px solid ${T.cyan}50`,
      borderRadius: 2,
      padding: 32,
      width: "100%", maxWidth: 520,
      maxHeight: "80vh", overflowY: "auto",
      boxShadow: `0 40px 100px rgba(0,0,0,0.6), 0 0 60px ${T.cyan}08`,
    }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 28 }}>
        <div>
          <div style={{ width: 24, height: 1, background: T.cyan, marginBottom: 10 }} />
          <h3 style={{ margin: 0, color: T.textPrimary, fontSize: 18, fontWeight: 300, letterSpacing: "0.06em", fontFamily: "'Cormorant Garamond', serif" }}>{title}</h3>
        </div>
        <button onClick={onClose} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, width: 32, height: 32, borderRadius: 2, cursor: "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}></button>
      </div>
      {children}
    </div>
  </div>
);

const Input = ({ label, placeholder, value, onChange, type = "text" }) => (
  <div style={{ marginBottom: 20 }}>
    <label style={{ display: "block", color: T.textMuted, fontSize: 10, fontWeight: 700, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.14em" }}>{label}</label>
    <input type={type} placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)}
      style={{
        width: "100%", boxSizing: "border-box",
        background: T.bgDeep, border: `1px solid ${T.border}`,
        borderRadius: 2, padding: "11px 14px", color: T.textPrimary,
        fontSize: 14, outline: "none", transition: "border-color 0.2s",
        fontFamily: "inherit",
      }}
      onFocus={e => { e.target.style.borderColor = T.cyan + "80"; e.target.style.background = T.surface; }}
      onBlur={e => { e.target.style.borderColor = T.border; e.target.style.background = T.bgDeep; }}
    />
  </div>
);

const Select = ({ label, options, value, onChange }) => (
  <div style={{ marginBottom: 20 }}>
    <label style={{ display: "block", color: T.textMuted, fontSize: 10, fontWeight: 700, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.14em" }}>{label}</label>
    <select value={value} onChange={e => onChange(e.target.value)}
      style={{
        width: "100%", background: T.bgDeep, border: `1px solid ${T.border}`,
        borderRadius: 2, padding: "11px 14px", color: T.textPrimary,
        fontSize: 14, outline: "none", cursor: "pointer", fontFamily: "inherit",
      }}>
      {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </div>
);

const Btn = ({ children, onClick, variant = "primary", small }) => {
  const styles = {
    primary:   { background: `linear-gradient(135deg, ${T.cyan}CC, ${T.blue}CC)`, color: T.bgDeep, border: "none" },
    secondary: { background: "transparent", color: T.cyan, border: `1px solid ${T.cyan}40` },
    danger:    { background: T.redDim, color: T.red, border: `1px solid ${T.red}40` },
    ghost:     { background: "transparent", color: T.textSecondary, border: `1px solid ${T.border}` },
  };
  return (
    <button onClick={onClick} style={{
      ...styles[variant], borderRadius: 2,
      padding: small ? "6px 14px" : "10px 22px",
      fontSize: small ? 10 : 12,
      fontWeight: 700, letterSpacing: "0.10em", textTransform: "uppercase",
      cursor: "pointer", transition: "all 0.2s", fontFamily: "inherit",
    }}
      onMouseEnter={e => { e.currentTarget.style.opacity = "0.80"; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }}
    >{children}</button>
  );
};

//  SIDEBAR 
const getNavItems = (role, user) => {
  const base = [{ id: "dashboard", label: "Dashboard", icon: "" }];
  if (["Country Manager","Vendor Manager","Strategy & Events Lead"].includes(role)) {
    base.push({ id: "events", label: "Events", icon: "" });
  }
  if (role === "Finance Manager") {
    base.push({ id: "events", label: "Events", icon: "" });
  }
  if (role === "CEO") {
    base.push({ id: "impact-intelligence", label: "Impact Intelligence", icon: "" });
  }
  if (["Strategy & Events Lead", "Vendor Manager"].includes(role)) {
    base.push({ id: "strategy-map", label: "Strategy Map", icon: "" });
  }
  if (["Sales & Marketing"].includes(role)) {
    base.push({ id: "events", label: "Events", icon: "" });
  }
  if (["CEO","Sales & Marketing","Country Manager"].includes(role)) {
    base.push({ id: "opportunities", label: "Opportunities", icon: "" });
  }
  if (["CEO","Sales & Marketing","Country Manager"].includes(role)) {
    base.push({ id: "crm", label: "CRM / Leads", icon: "" }, { id: "crm-insights", label: "CRM Insights", icon: "" }, { id: "sm-tasks", label: "S&M Tasks", icon: "" });
  }
  // ESL nav handled by return [] below
  if (["CEO","Country Manager"].includes(role)) {
    base.push({ id: "vendors", label: "Vendors & RFFs", icon: "" }, { id: "vendor-onboarding", label: "Add New Vendor", icon: "" }, { id: "rff-approvals", label: "RFF Approvals", icon: "" }, { id: "vendor-assignment", label: "Vendor Assignment", icon: "" }, { id: "quotes-received", label: "Quotes Received", icon: "" }, { id: "quote-comparison", label: "Quote Comparison", icon: "" }, { id: "contract-awards", label: "Contract Awards", icon: "" }, { id: "scorecards", label: "Vendor Scorecards", icon: "" }, { id: "vendor-analytics", label: "Vendor Analytics", icon: "" }, { id: "purchase-orders", label: "Sign Purchase Orders", icon: "" }, { id: "event-reports", label: "Event Reports", icon: "" });
  }
  if (role === "Country Manager") {
    return [
      { id: "dashboard", label: "Dashboard", group: true },
      { id: "grp-events", label: "Events & Operations", group: true, children: [
        { id: "events", label: "Events" },
        { id: "event-reports", label: "Event Reports" },
      ]},
      { id: "grp-crm", label: "CRM & Sales", group: true, children: [
        { id: "opportunities", label: "Opportunities" },
        { id: "crm", label: "CRM / Leads" },
        { id: "crm-insights", label: "CRM Insights" },
        { id: "sm-tasks", label: "S&M Tasks" },
      ]},
      { id: "grp-vendors", label: "Vendors & Procurement", group: true, children: [
        { id: "vendors", label: "Vendors & RFFs" },
        { id: "vendor-onboarding", label: "Vendor Applications" },
        { id: "rfps", label: "RFFs (New)" },
        { id: "rfp-approvals", label: "RFF Approvals (New)" },
        { id: "rff-approvals", label: "RFF Approvals" },
        { id: "vendor-assignment", label: "Vendor Assignment" },
        { id: "quotes-received", label: "Quotes Received" },
        { id: "quote-comparison", label: "Quote Comparison" },
        { id: "contract-awards", label: "Contract Awards" },
        { id: "scorecards", label: "Vendor Scorecards" },
        { id: "purchase-orders", label: "Sign Purchase Orders" },
      ]},
      { id: "grp-finance", label: "Finance", group: true, children: [
        { id: "finance", label: "Finance Operations" },
        { id: "payment-authorisation", label: "Payment Authorisation" },
        { id: "client-payments", label: "Client Payments" },
        { id: "vendor-invoices", label: "Vendor Invoices" },
        { id: "cash-flow", label: "Cash Flow" },
        { id: "sales-dashboard", label: "Sales Dashboard" },
        { id: "client-health", label: "Client Health" },
      ]},
      { id: "notifications", label: "Notifications", group: true },
      { id: "calendar", label: "Calendar", group: true },
    ];
  }
  if (role === "CEO") {
    base.push({ id: "vendor-onboarding", label: "Vendor Applications", icon: "" });
    base.push({ id: "contract-awards", label: "Contract Awards", icon: "" });
    base.push({ id: "event-analysis", label: "Event Analysis", icon: "" });
  }
  if (role === "CEO") {
    // CEO gets grouped nav — return special structure
    return [
      { id: "dashboard", label: "Dashboard", group: true },
      { id: "approval-queue", label: "Approval Queue", icon: "" },
      { id: "ceo-broadcast", label: "CEO Broadcast", icon: "" },
      { id: "grp-events", label: "Events & Operations", group: true, children: [
        { id: "events", label: "Events" },
        { id: "impact-intelligence", label: "Impact Intelligence" },
      ]},
      { id: "grp-crm", label: "CRM & Sales", group: true, children: [
        { id: "opportunities", label: "Opportunities" },
        { id: "crm", label: "CRM / Leads" },
        { id: "crm-insights", label: "CRM Insights" },
        { id: "sm-tasks", label: "S&M Tasks" },
      ]},
      { id: "grp-vendors", label: "Vendors & Procurement", group: true, children: [
        { id: "vendor-onboarding", label: "Vendor Applications" },
        { id: "vendors", label: "Vendors & RFFs" },
        { id: "rfps", label: "RFFs (New)" },
        { id: "rfp-approvals", label: "RFF Approvals (New)" },
        { id: "rff-approvals", label: "RFF Approvals" },
        { id: "vendor-assignment", label: "Vendor Assignment" },
        { id: "quote-comparison", label: "Quote Comparison" },
        { id: "contract-awards", label: "Contract Awards" },
        { id: "scorecards", label: "Vendor Scorecards" },
      ]},
      { id: "grp-finance", label: "Finance", group: true, children: [
        { id: "finance", label: "Finance Operations" },
        { id: "client-financials", label: "Client Financials" },
        { id: "purchase-orders", label: "Purchase Orders" },
            { id: "po-signing", label: "Sign Purchase Orders" },
        { id: "vendor-invoices", label: "Vendor Invoices" },
            { id: "payment-authorisation", label: "Payment Authorisation" },
            { id: "staff-payment-rates", label: "Staff Payment Rates" },
            { id: "budget-vs-actuals", label: "Budget vs Actuals" },
        { id: "client-payments", label: "Client Payments" },
        { id: "sales-dashboard", label: "Sales Dashboard" },
        { id: "cash-flow", label: "Cash Flow" },
        { id: "audit-trail", label: "Audit Trail" },
        { id: "zoho-sync-status", label: "Zoho Sync Status" },
        { id: "zoho-books", label: "Zoho Books" },
      ]},
      { id: "grp-clients", label: "Clients", group: true, children: [
        { id: "clients", label: "Client Database" },
        { id: "client-action-items", label: "Client Action Items" },
      ]},
      { id: "grp-people", label: "People", group: true, children: [
        { id: "users", label: "User Management" },
            { id: "email-test", label: "Email Templates" },
        { id: "hr", label: "HR" },
      ]},
      { id: "grp-intelligence", label: "Intelligence", group: true, children: [
        { id: "event-analysis", label: "Event Analysis" },
        { id: "strategy-map", label: "Strategy Map" },
        { id: "event-reports", label: "Event Reports" },
        { id: "board-report", label: "Board Report" },
        { id: "strategic-goals", label: "Strategic Goals & OKRs" },
        { id: "client-health", label: "Client Health" },
        { id: "team-performance", label: "Team Performance" },
        { id: "risk-register", label: "Risk Register" },
        { id: "decision-log", label: "Decision Log" },
        { id: "competitor-intel", label: "Competitor Intelligence" },
        { id: "revenue-forecast", label: "Revenue Forecast" },
      ]},
      { id: "notifications", label: "Notifications", group: true },
      { id: "calendar", label: "Calendar", group: true },
    ];
  }
  if (role === "Vendor Manager") {
    base.push(
      { id: "rfps", label: "RFFs (New)", icon: "" },
      { id: "vendors", label: "Vendors & RFFs", icon: "" },
      { id: "vendor-onboarding", label: "Vendor Directory", icon: "" },
      { id: "vendor-performance", label: "Vendor Performance", icon: "" },
      { id: "vendor-contracts", label: "Contract Management", icon: "" },
      { id: "preferred-vendors", label: "Preferred Vendors", icon: "" },
      { id: "vendor-watchlist", label: "Watchlist & Flags", icon: "" },
      { id: "vendor-comms", label: "Vendor Comms", icon: "" },
      { id: "vendor-assignment", label: "Vendor Assignment", icon: "" },
      { id: "quotes-received", label: "Quotes Received", icon: "" },
      { id: "quote-comparison", label: "Quote Comparison", icon: "" },
      { id: "scorecards", label: "Vendor Scorecards", icon: "" },
      { id: "vendor-analytics", label: "Vendor Analytics", icon: "" },
      { id: "vendor-sla", label: "SLA Tracker", icon: "" },
      { id: "market-rates", label: "Market Rates", icon: "" },
      { id: "purchase-orders", label: "Sign Purchase Orders", icon: "" },
      { id: "procurement-report", label: "Procurement Report", icon: "" },
      { id: "event-reports", label: "Event Reports", icon: "" },
      { id: "budget-vs-actuals", label: "Budget vs Actuals", icon: "" }
    );
  }
  if (["CEO","Country Manager","Vendor Manager","Finance Manager"].includes(role)) {
    base.push({ id: "invoices", label: "Invoices", icon: "" });
  }
  if (["CEO","Finance Manager"].includes(role)) {
    base.push({ id: "zoho-books", label: "Zoho Books", icon: "" });
  }
  if (["CEO","Country Manager","Finance Manager"].includes(role)) {
    base.push({ id: "finance", label: "Finance", icon: "" });
  }
  if (role === "Finance Manager") {
    base.push({ id: "purchase-orders", label: "Purchase Orders", icon: "" }, { id: "vendor-invoices", label: "Vendor Invoices", icon: "" }, { id: "payment-authorisation", label: "Payment Authorisation", icon: "" }, { id: "staff-payment-rates", label: "Staff Payment Rates", icon: "" }, { id: "client-payments", label: "Client Payments", icon: "" }, { id: "sales-dashboard", label: "Sales Dashboard", icon: "" }, { id: "payment-directory", label: "Payment Directory", icon: "" }, { id: "cash-flow", label: "Cash Flow", icon: "" }, { id: "audit-trail", label: "Audit Trail", icon: "" }, { id: "zoho-sync-status", label: "Zoho Sync Status", icon: "" });
  }
  if (["CEO"].includes(role)) {
    base.push({ id: "client-financials", label: "Client Financials", icon: "" });
  }
  if (["CEO"].includes(role)) {
    base.push({ id: "clients", label: "Clients", icon: "" }, { id: "users", label: "User Management", icon: "" });
  }
  if (role === "Vendor") {
    base.push({ id: "my-rfps", label: "My RFFs", icon: "" }, { id: "my-pos", label: "Purchase Orders", icon: "" }, { id: "vendor-invoices-submit", label: "Invoices", icon: "" }, { id: "vendor-transactions", label: "Financial Transactions", icon: "" });
  }
  if (role === "Client") {
    base.push({ id: "client-events", label: "My Events", icon: "" });
  }
  if (role === "Board of Directors") {
    return [{ id: "dashboard", label: "Dashboard", icon: "" }, { id: "notifications", label: "Notifications", icon: "" }];
  }
  if (role === "Strategy & Events Lead") {
    return [
      { id: "dashboard", label: "Dashboard", icon: "" },
      { id: "events", label: "Events", icon: "" },
      { id: "strategy-map", label: "Strategy Map", icon: "" },
      { id: "event-briefs", label: "Event Briefs", icon: "" },
      { id: "event-milestones", label: "Event Timeline", icon: "" },
      { id: "event-reports", label: "Event Reports", icon: "" },
      { id: "esl-performance", label: "My Performance", icon: "" },
      { id: "feedback-summary", label: "Feedback", icon: "" },
      ...(user?.has_sm_access ? [
        { id: "opportunities", label: "Opportunities", icon: "" },
        { id: "crm", label: "CRM / Leads", icon: "" },
        { id: "sm-tasks", label: "S&M Tasks", icon: "" },
        { id: "outreach-planner", label: "Outreach Planner", icon: "" },
      ] : []),

      { id: "notifications", label: "Notifications", icon: "" },
    ];
  }
  if (!["Vendor","Client","Strategy & Events Lead"].includes(role)) {
    base.push({ id: "feedback", label: "Feedback", icon: "" });
  }
  if (!["Client","Vendor"].includes(role)) base.push({ id: "calendar", label: "Calendar", icon: "" });
  if (role !== "Vendor") base.push({ id: "notifications", label: "Notifications", icon: "" });
  return base;
};

const Sidebar = ({ user, activeTab, onTab, collapsed, onToggle }) => {
  const navItems = getNavItems(user.role, user);
  return (
    <div style={{
      width: collapsed ? 64 : 240,
      background: T.bgDeep,
      borderRight: `1px solid ${T.border}`,
      display: "flex", flexDirection: "column",
      transition: "width 0.3s cubic-bezier(0.22,1,0.36,1)",
      flexShrink: 0, overflow: "hidden",
      position: "relative",
    }}>
      {/* Subtle vertical glow */}
      <div style={{ position: "absolute", top: 0, left: 0, width: 1, height: "100%", background: `linear-gradient(180deg, transparent, ${T.cyan}30, ${T.magenta}20, transparent)`, pointerEvents: "none" }} />

      {/* Logo */}
      <div style={{ padding: "20px 16px 18px", borderBottom: `1px solid ${T.border}`, display: "flex", alignItems: "center", gap: 10 }}>
        <img src={LOGO_SRC} alt="Stretchfield" style={{ width: 34, height: 34, objectFit: "contain", flexShrink: 0 }} />
        {!collapsed && (
          <div>
            <div style={{ color: T.textPrimary, fontWeight: 300, fontSize: 15, letterSpacing: "0.12em", fontFamily: "'Cormorant Garamond', serif", textTransform: "uppercase" }}>Stretchfield</div>
            <div style={{ color: T.textMuted, fontSize: 9, letterSpacing: "0.20em", textTransform: "uppercase", marginTop: 1 }}>WorkRoom</div>
          </div>
        )}
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: "16px 10px", overflowY: "auto" }}>
        {navItems.map(item => {
          const active = activeTab === item.id;
          return (
            <button key={item.id} onClick={() => onTab(item.id)} style={{
              width: "100%", display: "flex", alignItems: "center", gap: 10,
              padding: "9px 10px", borderRadius: 2, border: "none", cursor: "pointer",
              background: active ? `linear-gradient(90deg, ${T.cyan}14, transparent)` : "transparent",
              color: active ? T.cyan : T.textMuted,
              fontSize: 11, fontWeight: active ? 700 : 500,
              marginBottom: 1, transition: "all 0.15s",
              whiteSpace: "nowrap", overflow: "hidden",
              letterSpacing: active ? "0.08em" : "0.04em",
              textTransform: "uppercase",
              borderLeft: active ? `2px solid ${T.cyan}` : "2px solid transparent",
            }}
              onMouseEnter={e => { if (!active) { e.currentTarget.style.background = T.surfaceRaise; e.currentTarget.style.color = T.textSecondary; } }}
              onMouseLeave={e => { if (!active) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = T.textMuted; } }}
            >
              <span style={{ fontSize: 6, flexShrink: 0, color: active ? T.cyan : T.textGhost }}></span>
              {!collapsed && item.label}
            </button>
          );
        })}
      </nav>

      {/* User */}
      <div style={{ padding: "12px 10px", borderTop: `1px solid ${T.border}` }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 8px", borderRadius: 2 }}>
          <Avatar initials={user.avatar} size={32} color={T.cyan} />
          {!collapsed && (
            <div style={{ overflow: "hidden" }}>
              <div style={{ color: T.textPrimary, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", letterSpacing: "0.04em" }}>{user.name}</div>
              <div style={{ color: T.textMuted, fontSize: 10, letterSpacing: "0.06em" }}>{user.role}</div>
            </div>
          )}
        </div>
      </div>

      <button onClick={onToggle} style={{
        background: "none", border: "none", color: T.textGhost,
        padding: "10px", cursor: "pointer", fontSize: 12,
        borderTop: `1px solid ${T.border}`, letterSpacing: "0.10em",
        transition: "color 0.2s",
      }}
        onMouseEnter={e => e.currentTarget.style.color = T.cyan}
        onMouseLeave={e => e.currentTarget.style.color = T.textGhost}
      >{collapsed ? "›" : "‹"}</button>
    </div>
  );
};

//  PAGE HEADER 
const PageHeader = ({ title, subtitle }) => (
  <div style={{ marginBottom: 32 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 6 }}>
      <div style={{ width: 1, height: 28, background: `linear-gradient(180deg, ${T.cyan}, ${T.magenta})` }} />
      <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 300, letterSpacing: "0.10em", textTransform: "uppercase", fontFamily: "'Cormorant Garamond', serif" }}>{title}</h2>
    </div>
    {subtitle && <p style={{ margin: "0 0 0 17px", color: T.textMuted, fontSize: 11, letterSpacing: "0.08em" }}>{subtitle}</p>}
  </div>
);

//  DASHBOARDS 
const CEODashboard = ({ onTab, user, activeCountry = "All" }) => {
  const [events, setEvents] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [vendorProfiles, setVendorProfiles] = useState([]);
  const [scorecards, setScorecards] = useState([]);
  const [opportunities, setOpportunitys] = useState([]);
  const [targets, setTargets] = useState([]);
  const [feedback, setFeedback] = useState([]);
  const [clients, setClients] = useState([]);
  const [rffs, setRffs] = useState([]);
  const [paymentAuths, setPaymentAuths] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [awards, setAwards] = useState([]);
  const [clientPayments, setClientPayments] = useState([]);
  const [loading, setLoading] = React.useState(true);
  const [internalPortalEvent, setInternalPortalEvent] = useState(null);
  const [viewCountry, setViewCountry] = useState(user?.role === 'Country Manager' ? (user?.country||'Nigeria') : 'Ghana');

  // Sync with parent activeCountry
  React.useEffect(() => { if (activeCountry && user?.role !== 'Country Manager') setViewCountry(activeCountry); }, [activeCountry]);
  const [bankRequested, setBankRequested] = useState(false);
  const [bankSubmitted, setBankSubmitted] = useState(false);
  const [showBankForm, setShowBankForm] = useState(false);
  const [bankForm, setBankForm] = useState({ bank_name:"", bank_branch:"", bank_account_name:"", bank_account_number:"", mobile_money_number:"", presence:"GH", bank_name_ng:"", bank_account_name_ng:"", bank_account_number_ng:"", bank_branch_ng:"" });
  const [savingBank, setSavingBank] = useState(false);
  const [unreadBroadcasts, setUnreadBroadcasts] = useState([]);

  useEffect(() => {
    const loadAll = async () => {
      setLoading(true);
      const [ev, inv, tk, cl, fb, op, tg, rf, vp, sc, pa, vo, aw, cp] = await Promise.all([
        (!viewCountry || viewCountry === "All") ? supabase.from('projects').select('*').order('event_date',{ascending:true}) : supabase.from('projects').select('*').eq('country',viewCountry).order('event_date',{ascending:true}),
        supabase.from('invoices').select('*').order('created_at', { ascending: false }),
        supabase.from('tasks').select('*').order('created_at', { ascending: false }),
        (!viewCountry || viewCountry === "All") ? supabase.from('clients').select('*') : supabase.from('clients').select('*').eq('country',viewCountry),
        supabase.from('feedback').select('*').order('created_at', { ascending: false }),
        (!viewCountry || viewCountry === "All") ? supabase.from('opportunities').select('*').order('created_at',{ascending:false}) : supabase.from('opportunities').select('*').eq('country',viewCountry).order('created_at',{ascending:false}),
        supabase.from('sales_targets').select('*'),
        (!viewCountry || viewCountry === "All") ? supabase.from('rffs').select('*') : supabase.from('rffs').select('*').eq('country',viewCountry),
        (!viewCountry || viewCountry === "All") ? supabase.from('profiles').select('*').eq('role','Vendor') : supabase.from('profiles').select('*').eq('role','Vendor').eq('country',viewCountry),
        supabase.from('vendor_scorecards').select('*').order('created_at', { ascending: false }),
        supabase.from('payment_authorisations').select('*').order('created_at', { ascending: false }),
        (!viewCountry || viewCountry === "All") ? supabase.from('payment_vouchers').select('*').order('created_at',{ascending:false}) : supabase.from('payment_vouchers').select('*').eq('country',viewCountry).order('created_at',{ascending:false}),
        (!viewCountry || viewCountry === "All") ? supabase.from('rff_awards').select('*') : supabase.from('rff_awards').select('*').eq('country',viewCountry),
        (!viewCountry || viewCountry === "All") ? supabase.from('client_payments').select('*') : supabase.from('client_payments').select('*').eq('country',viewCountry),
      ]);
      setEvents(ev.data || []);
      setInvoices(inv.data || []);
      setTasks(tk.data || []);
      setClients(cl.data || []);
      setFeedback(fb.data || []);
      setOpportunitys(op.data || []);
      setTargets(tg.data || []);
      setRffs(rf.data || []);
      setVendors([...new Set((rf.data||[]).map(r => r.vendor).filter(Boolean))]);
      setVendorProfiles(vp.data || []);
      setScorecards(sc.data || []);
      setPaymentAuths(pa.data || []);
      setVouchers(vo.data || []);
      setAwards(aw.data || []);
      setClientPayments(cp?.data || []);
      setLoading(false);
      // Load unread broadcasts for CEO
      const { data: allBroadcasts } = await supabase.from("ceo_broadcasts").select("*").order("created_at", { ascending: false });
      if (allBroadcasts && allBroadcasts.length > 0) {
        const { data: reads } = await supabase.from("ceo_broadcast_reads").select("broadcast_id").eq("user_id", user.id);
        const readIds = new Set((reads||[]).map(r => r.broadcast_id));
        setUnreadBroadcasts((allBroadcasts||[]).filter(b => b.sent_by !== user?.id && !readIds.has(b.id)));
      }
      // Check bank details
      const { data: bp } = await supabase.from("profiles").select("bank_name,bank_account_number,bank_branch,bank_account_name,mobile_money_number,bank_details_requested").eq("id", user.id).single();
      if (bp) {
        setBankRequested(bp.bank_details_requested||false);
        setBankSubmitted(!!(bp.bank_name && bp.bank_account_number));
        if (bp.bank_name) setBankForm({ bank_name:bp.bank_name||"", bank_branch:bp.bank_branch||"", bank_account_name:bp.bank_account_name||"", bank_account_number:bp.bank_account_number||"", mobile_money_number:bp.mobile_money_number||"", presence:bp.presence||"GH", bank_name_ng:bp.bank_name_ng||"", bank_account_name_ng:bp.bank_account_name_ng||"", bank_account_number_ng:bp.bank_account_number_ng||"", bank_branch_ng:bp.bank_branch_ng||"" });
      }
    };
    loadAll();
  }, []);

  const saveBankDetailsCEO = async () => {
    if (!bankForm.bank_name || !bankForm.bank_account_number) { alert("Bank name and account number are required."); return; }
    setSavingBank(true);
    await supabase.from("profiles").update({ bank_name:bankForm.bank_name, bank_branch:bankForm.bank_branch, bank_account_name:bankForm.bank_account_name, bank_account_number:bankForm.bank_account_number, mobile_money_number:bankForm.mobile_money_number, presence:bankForm.presence||"GH", bank_name_ng:bankForm.bank_name_ng||null, bank_account_name_ng:bankForm.bank_account_name_ng||null, bank_account_number_ng:bankForm.bank_account_number_ng||null, bank_branch_ng:bankForm.bank_branch_ng||null }).eq("id", user?.id);
    const { data: fms } = await supabase.from("profiles").select("id").eq("role","Finance Manager");
    for (const fm of fms||[]) { await supabase.from("notifications").insert({ user_id:fm.id, title:"Bank Details Submitted — "+user.name, message:user.name+" submitted bank details: "+bankForm.bank_name+" · "+bankForm.bank_account_number, type:"finance" }); }
    setSavingBank(false);
    setBankSubmitted(true);
    setShowBankForm(false);
  };

  const now = new Date();
  const greeting = now.getHours() < 12 ? "Good Morning" : now.getHours() < 17 ? "Good Afternoon" : "Good Evening";

  // Key metrics
  const activeEvents = events.filter(e => !["Completed","Cancelled"].includes(e.phase||""));
  const upcomingEvents = events.filter(e => e.event_date && new Date(e.event_date) >= now).slice(0,3);
  const wonOpps = opportunities.filter(o => o.status === "won");
  const pipeline = opportunities.filter(o => !["won","lost"].includes(o.status));
  const pipelineValue = pipeline.reduce((s,o) => s+(o.value||0), 0);
  const revenueYTD = clientPayments.filter(p => p.payment_date && new Date(p.payment_date).getFullYear() === now.getFullYear()).reduce((s,p) => s+parseFloat(p.amount||0), 0);
  const totalClientRevenue = clientPayments.reduce((s,p) => s+parseFloat(p.amount||0), 0);
  const pendingPayments = paymentAuths.filter(p => p.status === "pending_ceo");
  const pendingTasks = tasks.filter(t => t.status !== "completed");
  // Filter by viewCountry for CEO country switcher
  const filteredVendorProfiles = viewCountry === 'All' ? vendorProfiles : vendorProfiles.filter(v => (v.country||'Ghana') === viewCountry);
  const filteredScorecards = viewCountry === 'All' ? scorecards : scorecards.filter(sc => filteredVendorProfiles.some(v => v.id === sc.vendor_id));
  const filteredEvents = viewCountry === 'All' ? events : events.filter(e => (e.country||'Ghana') === viewCountry);
  const filteredClients = viewCountry === 'All' ? clients : clients.filter(c => (c.country||'Ghana') === viewCountry);
  const filteredPayments = viewCountry === 'All' ? clientPayments : clientPayments.filter(p => (p.country||'Ghana') === viewCountry);
  const avgRating = filteredScorecards.length > 0 ? (filteredScorecards.reduce((s,sc) => s+(sc.total_pct||0), 0)/filteredScorecards.length).toFixed(0) : 0;
  const recentFeedback = feedback.slice(0,3);
  const totalBusiness = awards.reduce((s,a) => s+(parseFloat(a.agreed_amount)||0), 0);
  const totalVendorSpend = totalBusiness;

  if (loading) return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ width: 36, height: 36, border: "3px solid "+T.border, borderTop: "3px solid "+T.cyan, borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
    </div>
  );

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>

      {/*  CEO BROADCAST BANNERS (for CEO as recipient from board etc)  */}
      {unreadBroadcasts.map(b => {
        const priorityColor = b.priority==="urgent"?T.red:b.priority==="important"?T.amber:T.cyan;
        return (
          <div key={b.id} style={{ background:`linear-gradient(135deg,${priorityColor}12,${priorityColor}06)`, border:`1px solid ${priorityColor}40`, borderRadius:12, padding:"16px 20px", marginBottom:12 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
              <div style={{ flex:1 }}>
                <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14, marginBottom:4 }}>{b.title}</div>
                <div style={{ color:T.textSecondary, fontSize:13, lineHeight:1.6 }}>{b.message}</div>
              </div>
              <button onClick={async () => {
                await supabase.from("ceo_broadcast_reads").insert({ broadcast_id:b.id, user_id:user.id });
                setUnreadBroadcasts(prev => prev.filter(x => x.id !== b.id));
              }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"4px 12px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700, flexShrink:0, marginLeft:16 }}> Read</button>
            </div>
          </div>
        );
      })}

      {/*  BANK DETAILS BANNER  */}
      {bankRequested && !bankSubmitted && (
        <div style={{ background:`linear-gradient(135deg,${T.amber}12,${T.amber}06)`, border:`1px solid ${T.amber}40`, borderRadius:12, padding:"16px 20px", marginBottom:20 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12 }}>
            <div>
              <div style={{ color:T.amber, fontWeight:800, fontSize:14 }}> Bank Details Required</div>
              <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>Finance has requested your bank details for payment processing.</div>
            </div>
            <button onClick={() => setShowBankForm(!showBankForm)} style={{ background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"8px 18px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{showBankForm?"Close":"Submit Bank Details"}</button>
          </div>
          {showBankForm && (
            <div style={{ marginTop:16, display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
              {/* Presence */}
              <div style={{ gridColumn:"1/-1" }}>
                <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Country Presence</div>
                <select value={bankForm.presence||"GH"} onChange={e=>setBankForm(f=>({...f,presence:e.target.value}))} style={{ width:"100%", padding:"8px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="GH">🇬🇭 Ghana Only</option>
                  <option value="NG">🇳🇬 Nigeria Only</option>
                  <option value="GH+NG">🇬🇭 Ghana + 🇳🇬 Nigeria</option>
                  <option value="GH+NG+KE">🇬🇭 Ghana + 🇳🇬 Nigeria + 🇰🇪 Kenya</option>
                </select>
              </div>
              {/* Ghana bank details */}
              <div style={{ gridColumn:"1/-1", color:T.cyan, fontSize:11, fontWeight:700, textTransform:"uppercase", marginTop:8 }}>🇬🇭 Ghana Bank Details (GHS)</div>
              {[["Bank Name *","bank_name","e.g. GCB Bank"],["Branch Name","bank_branch","e.g. Accra Main"],["Account Name","bank_account_name","Name on account"],["Account Number *","bank_account_number","Account number"],["Mobile Money Number","mobile_money_number","e.g. 0244123456"]].map(([label,key,ph]) => (
                <div key={key}>
                  <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>{label}</div>
                  <input value={bankForm[key]} onChange={e=>setBankForm(f=>({...f,[key]:e.target.value}))} placeholder={ph}
                    style={{ width:"100%", padding:"8px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                </div>
              ))}
              {/* Nigeria bank details - show only if presence includes NG */}
              {(bankForm.presence||"GH").includes("NG") && <>
                <div style={{ gridColumn:"1/-1", color:"#10B981", fontSize:11, fontWeight:700, textTransform:"uppercase", marginTop:8 }}>🇳🇬 Nigeria Bank Details (NGN)</div>
                {[["Bank Name (NG)","bank_name_ng","e.g. GTBank"],["Branch Name (NG)","bank_branch_ng","e.g. Lagos Branch"],["Account Name (NG)","bank_account_name_ng","Name on account"],["Account Number (NG)","bank_account_number_ng","Account number"]].map(([label,key,ph]) => (
                  <div key={key}>
                    <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>{label}</div>
                    <input value={bankForm[key]||""} onChange={e=>setBankForm(f=>({...f,[key]:e.target.value}))} placeholder={ph}
                      style={{ width:"100%", padding:"8px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                  </div>
                ))}
              </>}
              <div style={{ gridColumn:"1/-1" }}>
                <button onClick={saveBankDetailsCEO} disabled={savingBank} style={{ background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"10px 24px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{savingBank?"Saving...":"Save Bank Details"}</button>
              </div>
            </div>
          )}
        </div>
      )}

      {/*  HERO GREETING  */}
      <div style={{ background: "linear-gradient(135deg, "+T.bgDeep+" 0%, #0D1F36 60%, "+T.bgDeep+" 100%)", border: "1px solid "+T.border, borderRadius: 16, padding: "32px 36px", marginBottom: 24, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -60, right: -60, width: 280, height: 280, background: "radial-gradient(circle, "+T.cyan+"08, transparent 70%)", pointerEvents: "none" }} />
        <div style={{ position: "absolute", bottom: -40, left: 200, width: 200, height: 200, background: "radial-gradient(circle, "+T.teal+"06, transparent 70%)", pointerEvents: "none" }} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 16 }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 6 }}>
              {now.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}
            </div>
            <h1 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 900, color: T.textPrimary, letterSpacing: "-0.03em" }}>{greeting}, {user?.name?.split(" ")[0]}.</h1>
            <div style={{ color: T.textMuted, fontSize: 14, maxWidth: 480 }}>
              {activeEvents.length} active event{activeEvents.length !== 1 ? "s" : ""} in flight
              {pendingPayments.length > 0 && <span style={{ color: T.amber, fontWeight: 700 }}> · {pendingPayments.length} payment{pendingPayments.length !== 1 ? "s" : ""} awaiting your signature</span>}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection:"column", gap: 10, alignItems:"flex-end" }}>
            {user?.role === 'Country Manager' && (
              <div style={{ background:T.cyan+"15", border:"1px solid "+T.cyan+"30", borderRadius:20, padding:"5px 14px", display:"flex", alignItems:"center", gap:6 }}>
                <span style={{ fontSize:14 }}>{user?.country==="Nigeria"?"NG":"GH"}</span>
                <span style={{ color:T.cyan, fontSize:11, fontWeight:800 }}>{user?.country} Operations</span>
              </div>
            )}
            <div style={{ display:"flex", gap:10 }}>
              {pendingPayments.length > 0 && (
                <button onClick={() => onTab("payment-authorisation")} style={{ background: T.amber+"15", border: "1px solid "+T.amber+"40", color: T.amber, padding: "10px 18px", borderRadius: 10, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>
                   Sign Payments ({pendingPayments.length})
                </button>
              )}
              <button onClick={() => onTab("events")} style={{ background: "linear-gradient(135deg,"+T.cyan+","+T.teal+")", border: "none", color: "#060B14", padding: "10px 20px", borderRadius: 10, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>
                View All Events →
              </button>
            </div>
          </div>
        </div>

        {/* Mini KPI bar */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginTop: 24, paddingTop: 20, borderTop: "1px solid "+T.border+"44" }}>
          {[
            { label: "Active Events", value: activeEvents.length, color: T.cyan, tab: "events" },
            { label: "Pipeline Value", value: getCurrency(viewCountry)+" "+Math.round(pipelineValue/1000)+"k", color: T.teal, tab: "opportunities" },
            { label: "Revenue YTD", value: getCurrency(viewCountry)+" "+Math.round(revenueYTD/1000)+"k", color: "#10B981", tab: "opportunities" },
            { label: "Open Tasks", value: pendingTasks.length, color: pendingTasks.length > 5 ? T.amber : T.textMuted, tab: "events" },
            { label: "Vendor Rating", value: avgRating+"%", color: parseInt(avgRating) >= 70 ? T.teal : T.amber, tab: "scorecards" },
            { label: "Vendor Spend", value: getCurrency(viewCountry)+" "+Math.round(totalBusiness/1000)+"k", color: T.amber, tab: "vendors" },
          ].map(k => (
            <div key={k.label} onClick={() => onTab(k.tab)} style={{ cursor: "pointer", padding: "12px 14px", background: T.bg+"80", border: "1px solid "+T.border+"44", borderRadius: 10, transition: "border-color 0.15s" }}
              onMouseEnter={e => e.currentTarget.style.borderColor = k.color+"60"}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.border+"44"}>
              <div style={{ color: k.color, fontSize: 18, fontWeight: 900, letterSpacing: "-0.02em" }}>{k.value}</div>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 3 }}>{k.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/*  TWO COLUMN LAYOUT  */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>

        {/* LEFT: Upcoming Events */}
        <div style={{ background: T.surface, border: "1px solid "+T.border, borderRadius: 14, padding: "20px 22px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div>
              <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Operations</div>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Upcoming Events</div>
            </div>
            <button onClick={() => onTab("events")} style={{ background: "none", border: "none", color: T.cyan, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>View all →</button>
          </div>
          {upcomingEvents.length === 0 ? (
            <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "20px 0" }}>No upcoming events</div>
          ) : upcomingEvents.map(e => {
            const days = Math.ceil((new Date(e.event_date) - now) / 86400000);
            const color = days <= 7 ? T.red : days <= 30 ? T.amber : T.teal;
            const PHASES = ["Brief","Planning","Pre-Production","Production","Live","Post-Production","Completed"];
            const phaseIdx = PHASES.indexOf(e.phase||"Planning");
            return (
              <div key={e.id} onClick={() => setInternalPortalEvent(e)} style={{ display: "flex", gap: 14, padding: "12px 0", borderBottom: "1px solid "+T.border+"33", cursor: "pointer" }}>
                <div style={{ width: 44, height: 44, borderRadius: 10, background: color+"15", border: "1px solid "+color+"30", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <div style={{ color, fontSize: 14, fontWeight: 900, lineHeight: 1 }}>{days > 0 ? days : "T"}</div>
                  <div style={{ color, fontSize: 8, textTransform: "uppercase", fontWeight: 700 }}>{days > 0 ? "days" : "oday"}</div>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{e.name}</div>
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{e.client} · {new Date(e.event_date).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}</div>
                  <div style={{ display: "flex", gap: 3, marginTop: 6 }}>
                    {PHASES.map((ph,i) => <div key={ph} style={{ flex: 1, height: 3, borderRadius: 2, background: i <= phaseIdx ? (i === phaseIdx ? T.cyan : T.teal+"80") : T.border+"44" }} />)}
                  </div>
                </div>
                <div style={{ flexShrink: 0 }}>
                  <span style={{ color: T.cyan, fontSize: 10, fontWeight: 700 }}>{e.phase||"Planning"}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* RIGHT: Pipeline & Revenue */}
        <div style={{ background: T.surface, border: "1px solid "+T.border, borderRadius: 14, padding: "20px 22px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div>
              <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Business Development</div>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Pipeline & Revenue</div>
            </div>
            <button onClick={() => onTab("opportunities")} style={{ background: "none", border: "none", color: T.cyan, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>View all →</button>
          </div>
          {/* Revenue bar */}
          {targets.length > 0 && (() => {
            const target = targets.reduce((latest, t) => !latest || new Date(t.created_at) > new Date(latest.created_at) ? t : latest, null);
            const pct = target ? Math.min(100, Math.round((revenueYTD / target.target_amount) * 100)) : 0;
            return (
              <div style={{ background: T.bg, borderRadius: 10, padding: "14px 16px", marginBottom: 14 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                  <span style={{ color: T.textMuted, fontSize: 11, fontWeight: 700 }}>Revenue vs Target</span>
                  <span style={{ color: T.teal, fontSize: 11, fontWeight: 800 }}>{pct}%</span>
                </div>
                <div style={{ height: 8, background: T.border+"44", borderRadius: 4, overflow: "hidden" }}>
                  <div style={{ height: "100%", width: pct+"%", background: "linear-gradient(90deg,"+T.cyan+","+T.teal+")", borderRadius: 4, transition: "width 0.8s ease" }} />
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
                  <span style={{ color: T.teal, fontSize: 11, fontWeight: 700 }}>{fmtMoney(revenueYTD, viewCountry)}</span>
                  <span style={{ color: T.textMuted, fontSize: 11 }}>Target: {fmtMoney(target?.target_amount||0, viewCountry)}</span>
                </div>
              </div>
            );
          })()}
          {/* Recent opportunities */}
          {pipeline.slice(0,4).map(o => (
            <div key={o.id} onClick={() => onTab("opportunities")} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid "+T.border+"33", cursor: "pointer" }}>
              <div>
                <div style={{ color: T.textPrimary, fontWeight: 600, fontSize: 13 }}>{o.company}</div>
                <div style={{ color: T.textMuted, fontSize: 11 }}>{o.event_type||o.stage}</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ color: T.amber, fontWeight: 700, fontSize: 13 }}>{fmtMoney(o.value||0, o.country||viewCountry)}</div>
                <div style={{ color: T.textMuted, fontSize: 10, textTransform: "uppercase" }}>{o.status}</div>
              </div>
            </div>
          ))}
          {pipeline.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "20px 0" }}>No active pipeline</div>}
        </div>
      </div>

      {/*  THREE COLUMN ROW  */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 20, marginBottom: 20 }}>

        {/* Pending Actions */}
        <div style={{ background: T.surface, border: "1px solid "+T.border, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Action Required</div>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 14 }}>Pending Actions</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {pendingPayments.length > 0 && (
              <div onClick={() => onTab("payment-authorisation")} style={{ background: T.amber+"10", border: "1px solid "+T.amber+"30", borderRadius: 8, padding: "10px 12px", cursor: "pointer" }}>
                <div style={{ color: T.amber, fontWeight: 800, fontSize: 12 }}> {pendingPayments.length} Payment{pendingPayments.length!==1?"s":""} to Sign</div>
                <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Awaiting your signature</div>
              </div>
            )}
            {(() => {
              const pendingApprovals = opportunities.filter(o => o.status === "pending_approval");
              return pendingApprovals.length > 0 ? (
                <div onClick={() => onTab("opportunities")} style={{ background: T.cyan+"10", border: "1px solid "+T.cyan+"30", borderRadius: 8, padding: "10px 12px", cursor: "pointer" }}>
                  <div style={{ color: T.cyan, fontWeight: 800, fontSize: 12 }}> {pendingApprovals.length} Lead{pendingApprovals.length!==1?"s":""} Won — Approve</div>
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Ready for approval</div>
                </div>
              ) : null;
            })()}
            {(() => {
              const pendingRFFs = rffs.filter(r => r.status === "pending_approval" || r.status === "submitted");
              return pendingRFFs.length > 0 ? (
                <div onClick={() => onTab("rff-approvals")} style={{ background: T.teal+"10", border: "1px solid "+T.teal+"30", borderRadius: 8, padding: "10px 12px", cursor: "pointer" }}>
                  <div style={{ color: T.teal, fontWeight: 800, fontSize: 12 }}> {pendingRFFs.length} RFF{pendingRFFs.length!==1?"s":""} to Approve</div>
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Awaiting CEO approval</div>
                </div>
              ) : null;
            })()}
            {pendingPayments.length === 0 && opportunities.filter(o=>o.status==="pending_approval").length === 0 && rffs.filter(r=>r.status==="pending_approval"||r.status==="submitted").length === 0 && (
              <div style={{ color: T.teal, fontSize: 13, fontWeight: 700, textAlign: "center", padding: "16px 0" }}> All clear</div>
            )}
          </div>
        </div>

        {/* Vendor Performance */}
        <div style={{ background: T.surface, border: "1px solid "+T.border, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Procurement</div>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 14 }}>Vendor Performance</div>
          <div style={{ background: T.bg, borderRadius: 10, padding: "12px 14px", marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div style={{ color: T.textMuted, fontSize: 10, textTransform: "uppercase", fontWeight: 700 }}>Avg Rating</div>
              <div style={{ color: avgRating >= 70 ? T.teal : T.amber, fontWeight: 900, fontSize: 24 }}>{avgRating}%</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ color: T.textMuted, fontSize: 10, textTransform: "uppercase", fontWeight: 700 }}>Active Vendors</div>
              <div style={{ color: T.cyan, fontWeight: 900, fontSize: 24 }}>{vendorProfiles.length}</div>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {scorecards.slice(0,3).map(sc => {
              const vp = vendorProfiles.find(v => v.id === sc.vendor_id);
              const tier = getTier(sc.total_pct);
              return (
                <div key={sc.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ color: T.textPrimary, fontSize: 12, fontWeight: 600, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{vp?.name || sc.vendor_name || "Vendor"}</div>
                  <span style={{ color: tier?.color||T.textMuted, fontSize: 11, fontWeight: 700, background: (tier?.color||T.textMuted)+"15", padding: "1px 8px", borderRadius: 20, marginLeft: 8 }}>{sc.total_pct}%</span>
                </div>
              );
            })}
          </div>
          <button onClick={() => onTab("scorecards")} style={{ background: "none", border: "none", color: T.cyan, fontSize: 11, fontWeight: 700, cursor: "pointer", marginTop: 10, padding: 0 }}>View all scorecards →</button>
        </div>

        {/* Client Feedback */}
        <div style={{ background: T.surface, border: "1px solid "+T.border, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Client Experience</div>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 14 }}>Recent Feedback</div>
          {recentFeedback.length === 0 ? (
            <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "16px 0" }}>No feedback yet</div>
          ) : recentFeedback.map(f => {
            const stars = f.rating || f.overall_rating || 0;
            return (
              <div key={f.id} style={{ padding: "10px 0", borderBottom: "1px solid "+T.border+"33" }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                  <span style={{ color: T.textPrimary, fontSize: 12, fontWeight: 700 }}>{f.client_name || f.name || "Client"}</span>
                  <span style={{ color: T.amber, fontSize: 12 }}>{"".repeat(Math.round(stars))}{"".repeat(5-Math.round(stars))}</span>
                </div>
                {f.comment && <div style={{ color: T.textMuted, fontSize: 11, lineHeight: 1.5, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{f.comment}</div>}
              </div>
            );
          })}
          <button onClick={() => onTab("feedback-summary")} style={{ background: "none", border: "none", color: T.cyan, fontSize: 11, fontWeight: 700, cursor: "pointer", marginTop: 10, padding: 0 }}>View all feedback →</button>
        </div>
      </div>

      {/*  FINANCIAL SNAPSHOT  */}
      <div style={{ background: "linear-gradient(135deg, "+T.bgDeep+", #0D1F36)", border: "1px solid "+T.border, borderRadius: 14, padding: "20px 24px", marginBottom: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Finance</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Financial Snapshot</div>
          </div>
          <button onClick={() => onTab("finance")} style={{ background: "none", border: "none", color: T.cyan, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Finance →</button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px,1fr))", gap: 12 }}>
          {[
            { label: "Total Vendor Spend", value: fmtMoney(totalBusiness, viewCountry), color: T.amber, tab: "vendor-analytics" },
            { label: "Pending Payments", value: fmtMoney(paymentAuths.filter(p=>p.status==="pending_ceo").reduce((s,p)=>s+(p.agreed_amount||0),0), viewCountry), color: T.amber, tab: "payment-authorisation" },
            { label: "Approved Payments", value: fmtMoney(paymentAuths.filter(p=>p.status==="approved").reduce((s,p)=>s+(p.agreed_amount||0),0), viewCountry), color: T.teal, tab: "payment-authorisation" },
            { label: "Vouchers Pending", value: vouchers.filter(v=>v.status==="pending_approval").length, color: T.cyan, tab: "finance" },
          ].map(k => (
            <div key={k.label} onClick={() => onTab(k.tab)} style={{ background: T.bg+"60", border: "1px solid "+T.border+"44", borderRadius: 10, padding: "14px 16px", cursor: "pointer" }}
              onMouseEnter={e => e.currentTarget.style.borderColor = k.color+"40"}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.border+"44"}>
              <div style={{ color: k.color, fontWeight: 900, fontSize: 16 }}>{k.value}</div>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginTop: 4 }}>{k.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Internal Event Portal Modal */}
      {internalPortalEvent && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", overflowY: "auto" }} onClick={() => setInternalPortalEvent(null)}>
          <div style={{ minHeight: "100vh", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "24px 20px" }}>
            <div style={{ background: T.bg, borderRadius: 16, width: "100%", maxWidth: 800, padding: 28 }} onClick={e => e.stopPropagation()}>
              <InternalEventPortal event={internalPortalEvent} user={user} allTasks={tasks} onClose={() => setInternalPortalEvent(null)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


const VendorManagerDashboard = ({ user, activeCountry = "All" }) => {
  const [vendors, setVendors] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [events, setEvents] = useState([]);
  const [notifs, setNotifs] = useState([]);
  const [rffs, setRffs] = useState([]);
  const [awards, setAwards] = useState([]);
  const [internalPortalEvent, setInternalPortalEvent] = useState(null);
  const [paymentRequests, setPaymentRequests] = useState([]);
  const [unreadBroadcasts, setUnreadBroadcasts] = useState([]);
  const [payReqModal, setPayReqModal] = useState(false);
  const [payReqForm, setPayReqForm] = useState({ project_id:"", description:"", _rates:null, selectedTypes:{ project_fee:false, per_diem:false, transport:false }, customAmount:"", customType:"", _receipt:null });
  const [savingPayReq, setSavingPayReq] = useState(false);
  const [pendingReportEvents, setPendingReportEvents] = useState([]);
  const [reportGateModal, setReportGateModal] = useState(false);
  const [showBankForm, setShowBankForm] = useState(false);
  const [bankForm, setBankForm] = useState({ bank_name:"", bank_branch:"", bank_account_name:"", bank_account_number:"", mobile_money_number:"", presence:"GH", bank_name_ng:"", bank_account_name_ng:"", bank_account_number_ng:"", bank_branch_ng:"" });
  const [bankSubmitted, setBankSubmitted] = useState(false);
  const [bankRequested, setBankRequested] = useState(false);
  const [savingBank, setSavingBank] = useState(false);

  const checkReportGate = async (onPass) => {
    // Get events assigned to this staff in Post-Event or Execution phase
    const { data: myEvents } = await supabase.from("projects").select("id,name,phase,assigned_to,assigned_to_name").or("assigned_to.eq."+user.id+",assigned_to_ids.cs.{"+user.id+"}").in("phase",["Post-Event","Execution","Completed"]);
    if (!myEvents || myEvents.length === 0) { onPass(); return; }
    // Check which ones have no debrief submitted by this user
    const { data: debriefs } = await supabase.from("event_debrief").select("project_id").eq("submitted_by", user.id);
    const submittedIds = new Set((debriefs||[]).map(d => d.project_id));
    const missing = myEvents.filter(e => !submittedIds.has(e.id));
    if (missing.length === 0) { onPass(); return; }
    setPendingReportEvents(missing);
    setReportGateModal(true);
  };


  const VENDOR_TYPES = ["Event Lighting","Events Ushering","Photography","Videography","Catering","Entertainment Provider (MC, DJ, Live Band, Performers)","Event Decor","Event Production Company","Event Refreshment","Furniture & Equipment Rental","Gift & Merchandise Supplier","Health & Safety Provider","Printing Company","Registration & Badging Service","Security Service","Technology Provider","Transportation (Shuttle, Car Rental)","Venue Provider","Other"];

  const saveVMBankDetails = async () => {
    if (!bankForm.bank_name || !bankForm.bank_account_number) { alert("Bank name and account number required."); return; }
    setSavingBank(true);
    await supabase.from("profiles").update({ bank_name:bankForm.bank_name, bank_branch:bankForm.bank_branch, bank_account_name:bankForm.bank_account_name, bank_account_number:bankForm.bank_account_number, mobile_money_number:bankForm.mobile_money_number, presence:bankForm.presence||"GH", bank_name_ng:bankForm.bank_name_ng||null, bank_account_name_ng:bankForm.bank_account_name_ng||null, bank_account_number_ng:bankForm.bank_account_number_ng||null, bank_branch_ng:bankForm.bank_branch_ng||null }).eq("id", user?.id);
    const { data: fms } = await supabase.from("profiles").select("id").eq("role","Finance Manager");
    for (const fm of fms||[]) await supabase.from("notifications").insert({ user_id:fm.id, title:"Bank Details Submitted — "+user.name, message:user.name+" submitted bank details: "+bankForm.bank_name+" · "+bankForm.bank_account_number, type:"finance" });
    setBankSubmitted(true); setShowBankForm(false); setSavingBank(false);
    alert(" Bank details saved and Finance notified.");
  };

  const loadVM = () => {
    Promise.all([
      (!activeCountry || activeCountry === "All")
        ? supabase.from("profiles").select("*").eq("role", "Vendor").order("name")
        : supabase.from("profiles").select("*").eq("role", "Vendor").or(`country.eq.${activeCountry},presence.like.%${activeCountry}%`).order("name"),
      supabase.from("tasks").select("*").eq("assignee_id", user.id),
      supabase.from("projects").select("*").eq("status", "active"),
      supabase.from("notifications").select("*").eq("user_id", user.id).eq("read", false).limit(5),
      (!activeCountry || activeCountry === "All") ? supabase.from("rffs").select("*").order("created_at", { ascending: false }) : supabase.from("rffs").select("*").eq("country", activeCountry).order("created_at", { ascending: false }),
      supabase.from("rff_awards").select("*").in("status", ["confirmed","po_created"]),
    ]).then(([v, t, ev, n, r, aw]) => {
      setVendors(v.data || []);
      setTasks(t.data || []);
      setEvents(ev.data || []);
      setNotifs(n.data || []);
      setRffs(r.data || []);
      setAwards(aw.data || []);
      supabase.from("staff_payment_requests").select("*").eq("staff_id", user.id).order("submitted_at", { ascending: false }).then(({ data: pr }) => setPaymentRequests(pr || []));
      // Load broadcasts
      supabase.from("ceo_broadcasts").select("*").order("created_at", { ascending: false }).then(async ({ data: broadcasts }) => {
        if (broadcasts && broadcasts.length > 0) {
          const { data: reads } = await supabase.from("ceo_broadcast_reads").select("broadcast_id").eq("user_id", user.id);
          const readIds = new Set((reads||[]).map(r => r.broadcast_id));
          setUnreadBroadcasts((broadcasts||[]).filter(b => !readIds.has(b.id)));
        }
      });
      // Load bank details
      supabase.from("profiles").select("bank_name,bank_account_number,bank_branch,bank_account_name,mobile_money_number,bank_details_requested").eq("id", user.id).single().then(({ data: bp }) => {
        if (bp) {
          setBankRequested(!!bp.bank_details_requested);
          setBankSubmitted(!!(bp.bank_name && bp.bank_account_number));
          if (bp.bank_name) setBankForm({ bank_name:bp.bank_name||"", bank_branch:bp.bank_branch||"", bank_account_name:bp.bank_account_name||"", bank_account_number:bp.bank_account_number||"", mobile_money_number:bp.mobile_money_number||"" });
        }
      });
    });
  };

  useEffect(() => { loadVM(); }, [user?.id, activeCountry]);



  const now = new Date();
  const greeting = now.getHours() < 12 ? "Good Morning" : now.getHours() < 17 ? "Good Afternoon" : "Good Evening";
  const dateStr = now.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
  const pending = tasks.filter(t => t.status !== "completed");
  const pendingRffs = rffs.filter(r => !r.approved);
  const upcomingEvents = events.filter(e => e.event_date && new Date(e.event_date) >= now).sort((a,b) => new Date(a.event_date) - new Date(b.event_date));

  // Group vendors by service_category
  const vendorsByCategory = VENDOR_TYPES.reduce((acc, type) => {
    const list = vendors.filter(v => v.service_category === type);
    if (list.length > 0) acc[type] = list;
    return acc;
  }, {});
  // Uncategorised vendors
  const uncategorised = vendors.filter(v => !v.service_category || !VENDOR_TYPES.includes(v.service_category));

  const getTierColor = (score, count) => {
    if (!count) return T.textMuted;
    if (score >= 85) return "#10B981";
    if (score >= 70) return T.teal;
    if (score >= 50) return T.amber;
    return T.red;
  };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>

      {/*  BANK DETAILS SECTION — always visible */}
      {(true) && (
        <div style={{ background:`linear-gradient(135deg,${T.amber}15,${T.amber}05)`, border:`1px solid ${T.amber}40`, borderRadius:12, padding:"16px 20px", marginBottom:16 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <div style={{ color:T.amber, fontWeight:800, fontSize:14, marginBottom:4 }}>
                {bankForm.bank_name ? " Bank Details" : " Bank Details Required"}
              </div>
              <div style={{ color:T.textMuted, fontSize:13 }}>
                {bankForm.bank_name 
                  ? `${bankForm.bank_name} · ${bankForm.bank_account_number} · Presence: ${bankForm.presence||"GH"}`
                  : "Add your bank details for payment processing."}
              </div>
            </div>
            <button onClick={() => setShowBankForm(!showBankForm)} style={{ background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"8px 18px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13, flexShrink:0, marginLeft:16 }}>{showBankForm?"Close": bankForm.bank_name ? "Edit" : "Add Bank Details"}</button>
          </div>
          {showBankForm && (
            <div style={{ marginTop:16, display:"flex", flexDirection:"column", gap:10 }}>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Bank Name *</label>
                <input value={bankForm.bank_name} onChange={e=>setBankForm(f=>({...f,bank_name:e.target.value}))} placeholder="e.g. GCB Bank" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Branch</label>
                <input value={bankForm.bank_branch} onChange={e=>setBankForm(f=>({...f,bank_branch:e.target.value}))} placeholder="Branch name" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              </div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Account Name *</label>
              <input value={bankForm.bank_account_name} onChange={e=>setBankForm(f=>({...f,bank_account_name:e.target.value}))} placeholder="Name on account" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Account Number *</label>
              <input value={bankForm.bank_account_number} onChange={e=>setBankForm(f=>({...f,bank_account_number:e.target.value}))} placeholder="Account number" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Mobile Money Number</label>
              <input value={bankForm.mobile_money_number} onChange={e=>setBankForm(f=>({...f,mobile_money_number:e.target.value}))} placeholder="e.g. 0244000000" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <button onClick={saveVMBankDetails} disabled={savingBank} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{savingBank?"Saving...":"Save Bank Details"}</button>
            </div>
          )}
        </div>
      )}
      {bankSubmitted && (
        <div style={{ background:T.teal+"12", border:"1px solid "+T.teal+"30", borderRadius:10, padding:"10px 16px", marginBottom:12, color:T.teal, fontSize:13, fontWeight:700 }}> Bank details submitted to Finance</div>
      )}

      {/*  HERO GREETING  */}
      <div style={{ background: `linear-gradient(135deg, ${T.bgDeep} 0%, #0D1F36 60%, ${T.bgDeep} 100%)`, border: `1px solid ${T.border}`, borderRadius: 16, padding: "32px 36px", marginBottom: 24, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -60, right: -60, width: 280, height: 280, background: `radial-gradient(circle, ${T.cyan}08, transparent 70%)`, pointerEvents: "none" }} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 16 }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 6 }}>{dateStr}</div>
            <h1 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 900, color: T.textPrimary, letterSpacing: "-0.03em" }}>{greeting}, {user?.name.split(" ")[0]}.</h1>
            <div style={{ color: T.textMuted, fontSize: 14 }}>Vendor network · {vendors.length} vendors · {events.length} active events</div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={() => {}} style={{ background: `linear-gradient(135deg,${T.cyan},${T.teal})`, border: "none", color: "#060B14", padding: "10px 20px", borderRadius: 10, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>Vendor Assignment →</button>
            <button onClick={() => { const link = window.location.origin + "/applyvendor"; navigator.clipboard.writeText(link); alert("Link copied! Share via WhatsApp or Email:\n\n" + link); }} style={{ background:T.surface, border:"1px solid "+T.border, color:T.textMuted, padding:"10px 18px", borderRadius:10, cursor:"pointer", fontWeight:700, fontSize:12 }}>Copy Vendor Form Link</button>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginTop: 24, paddingTop: 20, borderTop: `1px solid ${T.border}44` }}>
          {[
            { label: "Total Vendors", value: vendors.length, color: T.cyan },
            { label: "Active Events", value: events.length, color: T.teal },
            { label: "Pending RFFs", value: pendingRffs.length, color: T.amber },
            { label: "Confirmed Gigs", value: awards.length, color: "#10B981" },
            { label: "My Tasks", value: pending.length, color: pending.length > 3 ? T.amber : T.textMuted },
            { label: "Notifications", value: notifs.length, color: notifs.length > 0 ? T.cyan : T.textMuted },
          ].map(k => (
            <div key={k.label} style={{ padding: "12px 14px", background: `${T.bg}80`, border: `1px solid ${T.border}44`, borderRadius: 10 }}>
              <div style={{ color: k.color, fontSize: 18, fontWeight: 900 }}>{k.value}</div>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 3 }}>{k.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/*  BROADCAST BANNERS  */}
      {unreadBroadcasts && unreadBroadcasts.map && unreadBroadcasts.map(b => {
        const priorityColor = b.priority==="urgent"?T.red:b.priority==="important"?T.amber:T.cyan;
        const priorityLabel = b.priority==="urgent"?" Urgent":b.priority==="important"?" Important":" Team Update";
        return (
          <div key={b.id} style={{ background:`linear-gradient(135deg,${priorityColor}12,${priorityColor}06)`, border:`1px solid ${priorityColor}40`, borderRadius:12, padding:"16px 20px", marginBottom:12 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:6 }}>
                  <span style={{ background:priorityColor+"20", color:priorityColor, padding:"2px 10px", borderRadius:20, fontSize:10, fontWeight:800, textTransform:"uppercase" }}>{priorityLabel}</span>
                  <span style={{ color:T.textMuted, fontSize:11 }}>from {b.sent_by_name}</span>
                </div>
                <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14, marginBottom:4 }}>{b.title}</div>
                <div style={{ color:T.textSecondary, fontSize:13, lineHeight:1.6 }}>{b.message}</div>
              </div>
              <button onClick={async () => {
                await supabase.from("ceo_broadcast_reads").insert({ broadcast_id:b.id, user_id:user.id });
                setUnreadBroadcasts(prev => prev.filter(x => x.id !== b.id));
              }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"4px 12px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700, flexShrink:0, marginLeft:16 }}> Read</button>
            </div>
          </div>
        );
      })}

      {/*  ACTION ITEMS ALERT  */}
      {awards.filter(a => !events.find(e => e.id === rffs.find(r => r.id === a.rff_id)?.project_id && e.phase === "Completed")).length > 0 && (
        <div style={{ background:T.amber+"12", border:`1px solid ${T.amber}30`, borderRadius:12, padding:"14px 18px", marginBottom:16 }}>
          <div style={{ color:T.amber, fontWeight:800, fontSize:13, marginBottom:6 }}> Action Required</div>
          <div style={{ color:T.textSecondary, fontSize:12 }}>{awards.length} confirmed vendor gig{awards.length!==1?"s":""} awaiting Purchase Orders</div>
        </div>
      )}

      {/*  BROADCAST BANNERS  */}
      {unreadBroadcasts && unreadBroadcasts.map && unreadBroadcasts.map(b => {
        const priorityColor = b.priority==="urgent"?T.red:b.priority==="important"?T.amber:T.cyan;
        const priorityLabel = b.priority==="urgent"?" Urgent":b.priority==="important"?" Important":" Team Update";
        return (
          <div key={b.id} style={{ background:`linear-gradient(135deg,${priorityColor}12,${priorityColor}06)`, border:`1px solid ${priorityColor}40`, borderRadius:12, padding:"16px 20px", marginBottom:12 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:6 }}>
                  <span style={{ background:priorityColor+"20", color:priorityColor, padding:"2px 10px", borderRadius:20, fontSize:10, fontWeight:800, textTransform:"uppercase" }}>{priorityLabel}</span>
                  <span style={{ color:T.textMuted, fontSize:11 }}>from {b.sent_by_name}</span>
                </div>
                <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14, marginBottom:4 }}>{b.title}</div>
                <div style={{ color:T.textSecondary, fontSize:13, lineHeight:1.6 }}>{b.message}</div>
              </div>
              <button onClick={async () => {
                await supabase.from("ceo_broadcast_reads").insert({ broadcast_id:b.id, user_id:user.id });
                setUnreadBroadcasts(prev => prev.filter(x => x.id !== b.id));
              }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"4px 12px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700, flexShrink:0, marginLeft:16 }}> Read</button>
            </div>
          </div>
        );
      })}

      {/*  ACTION ITEMS ALERT  */}
      {awards.filter(a => !events.find(e => e.id === rffs.find(r => r.id === a.rff_id)?.project_id && e.phase === "Completed")).length > 0 && (
        <div style={{ background:T.amber+"12", border:`1px solid ${T.amber}30`, borderRadius:12, padding:"14px 18px", marginBottom:16 }}>
          <div style={{ color:T.amber, fontWeight:800, fontSize:13, marginBottom:6 }}> Action Required</div>
          <div style={{ color:T.textSecondary, fontSize:12 }}>{awards.length} confirmed vendor gig{awards.length!==1?"s":""} awaiting Purchase Orders</div>
        </div>
      )}

      {/*  TWO COLUMN  */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>

        {/* My Events */}
        {events.length > 0 && (
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "20px 22px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div>
                <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Operations</div>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Active Events</div>
              </div>
            </div>
            {upcomingEvents.slice(0,4).map(e => {
              const days = e.event_date ? Math.ceil((new Date(e.event_date) - now) / 86400000) : null;
              const color = days !== null ? (days <= 7 ? T.red : days <= 30 ? T.amber : T.teal) : T.teal;
              return (
                <div key={e.id} onClick={() => setInternalPortalEvent(e)} style={{ display: "flex", gap: 12, padding: "10px 0", borderBottom: `1px solid ${T.border}33`, cursor: "pointer" }}>
                  {days !== null && (
                    <div style={{ width: 40, height: 40, borderRadius: 8, background: `${color}15`, border: `1px solid ${color}30`, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <div style={{ color, fontSize: 13, fontWeight: 900, lineHeight: 1 }}>{days > 0 ? days : "T"}</div>
                      <div style={{ color, fontSize: 7, textTransform: "uppercase", fontWeight: 700 }}>{days > 0 ? "days" : "oday"}</div>
                    </div>
                  )}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{e.name}</div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{e.client} · {e.phase||"Planning"}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* RFFs & Awards */}
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "20px 22px" }}>
          <div style={{ marginBottom: 16 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Procurement</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>RFFs & Awards</div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {rffs.slice(0,5).map(r => (
              <div key={r.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: T.bg, borderRadius: 8, border: `1px solid ${T.border}44` }}>
                <div>
                  <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{r.title}</div>
                  <div style={{ color: T.textMuted, fontSize: 11 }}>{r.event_name}</div>
                </div>
                <span style={{ color: r.approved ? T.teal : T.amber, fontSize: 10, fontWeight: 800, background: (r.approved ? T.teal : T.amber)+"15", padding: "2px 8px", borderRadius: 20 }}>{r.approved ? "Approved" : "Pending"}</span>
              </div>
            ))}
            {rffs.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "16px 0" }}>No RFFs yet</div>}
          </div>
        </div>
      </div>

      {/*  PAYMENT REQUESTS  */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:14, padding:"18px 20px", marginBottom:20 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
          <div>
            <div style={{ color:T.textMuted, fontSize:9, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.12em", marginBottom:3 }}>Finance</div>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15 }}>My Payment Requests</div>
          </div>
          <button onClick={() => checkReportGate(() => setPayReqModal(true))} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"7px 14px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:12 }}>+ New Request</button>
        </div>
        {paymentRequests.length === 0 ? (
          <div style={{ color:T.textMuted, fontSize:13, textAlign:"center", padding:"12px 0" }}>No payment requests yet</div>
        ) : paymentRequests.slice(0,4).map(pr => {
          const statusColors = { pending:T.amber, approved:T.teal, rejected:T.red, paid:"#10B981" };
          return (
            <div key={pr.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:`1px solid ${T.border}33` }}>
              <div>
                <div style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{pr.description}</div>
                <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{(pr.request_type||"").replace(/_/g," ")} · {new Date(pr.submitted_at).toLocaleDateString("en-GB")}</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ color:T.amber, fontWeight:700, fontSize:13 }}>{fmtMoney(pr.amount||0, pr.country||"Ghana")}</div>
                <span style={{ color:statusColors[pr.status]||T.textMuted, fontSize:10, fontWeight:700 }}>{pr.status}</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Payment Request Modal */}
      {payReqModal && (
        <div style={{ position:"fixed", inset:0, zIndex:600, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setPayReqModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:460, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>New Payment Request</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:20 }}>Select your event and payment type — amounts are pre-set by CEO/Finance</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12, marginBottom:16 }}>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Related Event *</label>
                <select value={payReqForm.project_id} onChange={async e => {
                  const pid = e.target.value;
                  if (pid) {
                    const { data: rates } = await supabase.from("staff_payment_rates").select("*").eq("staff_id", user.id).eq("project_id", pid).maybeSingle();
                    setPayReqForm(f=>({...f, project_id:pid, _rates:rates||null, selectedTypes:{ project_fee:false, per_diem:false, transport:false }}));
                  } else {
                    setPayReqForm(f=>({...f, project_id:"", _rates:null, selectedTypes:{ project_fee:false, per_diem:false, transport:false }}));
                  }
                }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">Select event...</option>
                  {events.map(ev => <option key={ev.id} value={ev.id}>{ev.name}</option>)}
                </select>
              </div>
              {payReqForm.project_id && (
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:8 }}>Select Payment Types</label>
                  <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                    {[
                      { key:"project_fee", label:"Project Fee", amount: payReqForm._rates?.project_fee },
                      { key:"per_diem", label:"Per Diem", amount: payReqForm._rates?.per_diem },
                      { key:"transport", label:"Transport Allowance", amount: payReqForm._rates?.transport },
                    ].map(({ key, label, amount }) => (
                      <div key={key} onClick={() => amount && setPayReqForm(f=>({...f, selectedTypes:{...f.selectedTypes, [key]:!f.selectedTypes[key]}}))}
                        style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 14px", background: payReqForm.selectedTypes[key] ? T.cyan+"15" : T.bg, border:`1px solid ${payReqForm.selectedTypes[key] ? T.cyan+"60" : T.border}`, borderRadius:8, cursor: amount ? "pointer" : "default", opacity: amount ? 1 : 0.4 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                          <div style={{ width:18, height:18, borderRadius:4, border:`2px solid ${payReqForm.selectedTypes[key] ? T.cyan : T.border}`, background: payReqForm.selectedTypes[key] ? T.cyan : "transparent", display:"flex", alignItems:"center", justifyContent:"center" }}>
                            {payReqForm.selectedTypes[key] && <span style={{ color:"#060B14", fontSize:11, fontWeight:900 }}></span>}
                          </div>
                          <span style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{label}</span>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          {amount ? <span style={{ color:T.amber, fontWeight:800, fontSize:13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(amount).toLocaleString()).toLocaleString()}</span> : <span style={{ color:T.textMuted, fontSize:11 }}>Not set</span>}
                          {amount && <div style={{ color:T.teal, fontSize:9, fontWeight:700 }}> Set by CEO</div>}
                        </div>
                      </div>
                    ))}
                    {/* Custom / Reimbursement */}
                    <div style={{ padding:"10px 14px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8 }}>
                      <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, marginBottom:8 }}>ADD CUSTOM AMOUNT (Optional)</div>
                      <div style={{ display:"flex", gap:8 }}>
                        <select value={payReqForm.customType} onChange={e=>setPayReqForm(f=>({...f,customType:e.target.value}))}
                          style={{ flex:1, padding:"7px 10px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:12, fontFamily:"inherit", outline:"none" }}>
                          <option value="">Type...</option>
                          <option value="reimbursement">Reimbursement</option>
                          <option value="other">Other</option>
                        </select>
                        <input type="number" value={payReqForm.customAmount} onChange={e=>setPayReqForm(f=>({...f,customAmount:e.target.value}))} placeholder={`Amount (${getCurrency(activeCountry||user?.country||"Ghana")})`}
                          style={{ flex:1, padding:"7px 10px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:12, fontFamily:"inherit", outline:"none" }} />
                      </div>
                    </div>
                  </div>
                  {/* Total */}
                  {(() => {
                    const r = payReqForm._rates;
                    const total = (payReqForm.selectedTypes.project_fee ? parseFloat(r?.project_fee||0) : 0) +
                      (payReqForm.selectedTypes.per_diem ? parseFloat(r?.per_diem||0) : 0) +
                      (payReqForm.selectedTypes.transport ? parseFloat(r?.transport||0) : 0) +
                      (payReqForm.customAmount ? parseFloat(payReqForm.customAmount) : 0);
                    return total > 0 ? (
                      <div style={{ padding:"10px 14px", background:T.teal+"12", border:`1px solid ${T.teal}30`, borderRadius:8, display:"flex", justifyContent:"space-between" }}>
                        <span style={{ color:T.teal, fontWeight:700, fontSize:13 }}>Total Request</span>
                        <span style={{ color:T.teal, fontWeight:900, fontSize:15 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(total.toLocaleString()).toLocaleString()}</span>
                      </div>
                    ) : null;
                  })()}
                </div>
              )}
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Description *</label>
                <textarea value={payReqForm.description} onChange={e=>setPayReqForm(f=>({...f,description:e.target.value}))} rows={2} placeholder="Brief description of work done..." style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} />
              </div>
              {(payReqForm.customType) && (
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Upload Receipt (Optional)</label>
                  <input type="file" accept=".pdf,.png,.jpg,.jpeg" onChange={e=>setPayReqForm(f=>({...f,_receipt:e.target.files[0]}))} style={{ width:"100%", padding:"8px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:12, cursor:"pointer", boxSizing:"border-box" }} />
                  {payReqForm._receipt && <div style={{ color:T.teal, fontSize:11, marginTop:4 }}> {payReqForm._receipt.name}</div>}
                </div>
              )}
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={async () => {
                const r = payReqForm._rates;
                const requests = [];
                if (payReqForm.selectedTypes.project_fee && r?.project_fee) requests.push({ type:"project_fee", label:"Project Fee", amount: parseFloat(r.project_fee) });
                if (payReqForm.selectedTypes.per_diem && r?.per_diem) requests.push({ type:"per_diem", label:"Per Diem", amount: parseFloat(r.per_diem) });
                if (payReqForm.selectedTypes.transport && r?.transport) requests.push({ type:"transport", label:"Transport Allowance", amount: parseFloat(r.transport) });
                if (payReqForm.customType && payReqForm.customAmount) requests.push({ type: payReqForm.customType, label: payReqForm.customType, amount: parseFloat(payReqForm.customAmount) });
                if (requests.length === 0) { alert("Please select at least one payment type."); return; }
                if (!payReqForm.description) { alert("Please add a description."); return; }
                setSavingPayReq(true);
                let receipt_url = "";
                if (payReqForm._receipt) {
                  const ext = payReqForm._receipt.name.split(".").pop();
                  const path = "receipts/"+user.id+"_"+Date.now()+"."+ext;
                  const { error: upErr } = await supabase.storage.from("rffs").upload(path, payReqForm._receipt, { upsert:true });
                  if (!upErr) { const { data: urlData } = supabase.storage.from("rffs").getPublicUrl(path); receipt_url = urlData.publicUrl; }
                }
                const ev = events.find(e => e.id === payReqForm.project_id);
                const total = requests.reduce((s,r) => s+r.amount, 0);
                for (const req of requests) {
                  await supabase.from("staff_payment_requests").insert({ staff_id:user.id, staff_name:user.name, project_id:payReqForm.project_id||null, project_name:ev?.name||"", amount:req.amount, description:payReqForm.description, request_type:req.type, status:"pending", supporting_doc_url: receipt_url||"" });
                }
                const { data: fms } = await supabase.from("profiles").select("id").eq("role","Finance Manager");
                for (const fm of fms||[]) { await supabase.from("notifications").insert({ user_id:fm.id, title:"Staff Payment Request — "+user.name, message:user.name+" submitted payment requests totalling GHS "+total.toLocaleString()+" for "+payReqForm.description, type:"finance" }); }
                setSavingPayReq(false);
                setPayReqModal(false);
                setPayReqForm({ project_id:"", description:"", _rates:null, selectedTypes:{ project_fee:false, per_diem:false, transport:false }, customAmount:"", customType:"", _receipt:null });
                const { data: pr } = await supabase.from("staff_payment_requests").select("*").eq("staff_id", user.id).order("submitted_at", { ascending:false });
                setPaymentRequests(pr||[]);
              }} disabled={savingPayReq||!payReqForm.description} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13, opacity:(!payReqForm.description)?0.5:1 }}>{savingPayReq?"Submitting...":"Submit Request"}</button>
              <button onClick={() => setPayReqModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/*  REPORT GATE MODAL  */}
      {reportGateModal && (
        <div style={{ position:"fixed", inset:0, zIndex:800, background:"rgba(0,0,0,0.9)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setReportGateModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.amber}40`, borderRadius:16, width:"100%", maxWidth:480, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ fontSize:32, marginBottom:12, textAlign:"center" }}></div>
            <div style={{ color:T.amber, fontWeight:900, fontSize:18, marginBottom:8, textAlign:"center" }}>Report Required Before Payment</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:20, textAlign:"center", lineHeight:1.6 }}>You have outstanding event report(s) to submit. Please complete your debrief before making a payment request.</div>
            <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:20 }}>
              {pendingReportEvents.map(ev => (
                <div key={ev.id} style={{ background:T.amber+"12", border:`1px solid ${T.amber}30`, borderRadius:10, padding:"12px 16px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{ev.name}</div>
                    <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{ev.phase} · Debrief not submitted</div>
                  </div>
                  <span style={{ color:T.amber, fontSize:10, fontWeight:800 }}>PENDING</span>
                </div>
              ))}
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={() => setReportGateModal(false)} style={{ flex:1, background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>Go Submit Debrief</button>
              <button onClick={() => setReportGateModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/*  MY TASKS  */}
      {pending.length > 0 && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "20px 22px", marginBottom: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div>
              <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Tasks</div>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>My Open Tasks</div>
            </div>
            <span style={{ color: T.amber, fontSize: 11, fontWeight: 700 }}>{pending.length} pending</span>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {pending.slice(0,5).map(t => (
              <div key={t.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: T.bg, borderRadius: 8, border: `1px solid ${T.border}44` }}>
                <div>
                  <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{t.name}</div>
                  {t.deadline && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Due: {new Date(t.deadline).toLocaleDateString("en-GB")}</div>}
                </div>
                <Badge status={t.status} />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Internal Event Portal Modal */}
      {internalPortalEvent && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", overflowY: "auto" }} onClick={() => setInternalPortalEvent(null)}>
          <div style={{ minHeight: "100vh", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "24px 20px" }}>
            <div style={{ background: T.bg, borderRadius: 16, width: "100%", maxWidth: 800, padding: 28 }} onClick={e => e.stopPropagation()}>
              <InternalEventPortal event={internalPortalEvent} user={user} allTasks={tasks} onClose={() => setInternalPortalEvent(null)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};




const StaffDashboard = ({ user }) => {
  const [tasks, setTasks] = useState([]);
  const [internalPortalEvent, setInternalPortalEvent] = useState(null);
  const [paymentRequests, setPaymentRequests] = useState([]);
  const [payReqModal, setPayReqModal] = useState(false);
  const [payReqForm, setPayReqForm] = useState({ project_id:"", description:"", _rates:null, selectedTypes:{ project_fee:false, per_diem:false, transport:false }, customAmount:"", customType:"", _receipt:null });
  const [savingPayReq, setSavingPayReq] = useState(false);
  const [events, setEvents] = useState([]);
  const [notifs, setNotifs] = useState([]);
  const [bankForm, setBankForm] = useState({ bank_name:"", bank_branch:"", bank_account_name:"", bank_account_number:"", mobile_money_number:"" });
  const [showBankForm, setShowBankForm] = useState(false);
  const [savingBank, setSavingBank] = useState(false);
  const [bankSubmitted, setBankSubmitted] = useState(false);
  const [bankRequested, setBankRequested] = useState(false);
  const [pendingReportEvents, setPendingReportEvents] = useState([]);
  const [reportGateModal, setReportGateModal] = useState(false);

  const checkReportGate = async (onPass) => {
    const { data: myEvents } = await supabase.from("projects").select("id,name,phase,assigned_to").eq("assigned_to", user.id).in("phase",["Post-Event","Execution","Completed"]);
    if (!myEvents || myEvents.length === 0) { onPass(); return; }
    const { data: debriefs } = await supabase.from("event_debrief").select("project_id").eq("submitted_by", user.id);
    const submittedIds = new Set((debriefs||[]).map(d => d.project_id));
    const missing = myEvents.filter(e => !submittedIds.has(e.id));
    if (missing.length === 0) { onPass(); return; }
    setPendingReportEvents(missing);
    setReportGateModal(true);
  };

  useEffect(() => {
    // Check bank details status
    supabase.from("profiles").select("bank_name, bank_account_name, bank_account_number, bank_branch, mobile_money_number, bank_details_requested").eq("id", user.id).single().then(({ data }) => {
      if (data) {
        setBankRequested(data.bank_details_requested || false);
        setBankSubmitted(!!(data.bank_name && data.bank_account_number));
        if (data.bank_name) setBankForm({ bank_name: data.bank_name||"", bank_branch: data.bank_branch||"", bank_account_name: data.bank_account_name||"", bank_account_number: data.bank_account_number||"", mobile_money_number: data.mobile_money_number||"" });
      }
    });
    supabase.from("tasks").select("*").eq("assignee_id", user.id).order("created_at", { ascending: false }).then(({ data }) => setTasks(data || []));
    // For Strategy Lead: load all active events then filter client-side for multi-assign support
    supabase.from("projects").select("*").eq("status", "active").then(({ data }) => {
      if (user.role === "Strategy & Events Lead") {
        const myEvents = (data || []).filter(e => 
          e.assigned_to === user.id || 
          (Array.isArray(e.assigned_to_ids) && e.assigned_to_ids.includes(user.id))
        );
        setEvents(myEvents);
      } else {
        setEvents(data || []);
      }
    });
    supabase.from("notifications").select("*").eq("user_id", user.id).eq("read", false).order("created_at", { ascending: false }).limit(5).then(({ data }) => setNotifs(data || []));
  }, [user.id]);

  const now = new Date();
  const dateStr = now.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
  const greeting = now.getHours() < 12 ? "Good Morning" : now.getHours() < 17 ? "Good Afternoon" : "Good Evening";
  const pending = tasks.filter(t => t.status !== "completed");
  const dueSoon = tasks.filter(t => t.deadline && new Date(t.deadline) <= new Date(Date.now() + 3 * 86400000) && t.status !== "completed");

  const saveBankDetails = async () => {
    if (!bankForm.bank_name || !bankForm.bank_account_number) { alert("Bank name and account number are required."); return; }
    setSavingBank(true);
    await supabase.from("profiles").update({
      bank_name: bankForm.bank_name,
      bank_branch: bankForm.bank_branch,
      bank_account_name: bankForm.bank_account_name,
      bank_account_number: bankForm.bank_account_number,
      mobile_money_number: bankForm.mobile_money_number,
    }).eq("id", user.id);
    const { data: fms } = await supabase.from("profiles").select("id").eq("role","Finance Manager");
    for (const fm of fms||[]) {
      await supabase.from("notifications").insert({ user_id: fm.id, title: "Bank Details Submitted — " + user.name, message: user.name + " has submitted their bank details: " + bankForm.bank_name + " · Acc: " + bankForm.bank_account_number, type: "finance" });
    }
    setSavingBank(false);
    setBankSubmitted(true);
    setShowBankForm(false);
  };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>

      {/*  BANK DETAILS REQUEST BANNER  */}
      {bankRequested && !bankSubmitted && (
        <div style={{ background:`linear-gradient(135deg,${T.amber}12,${T.amber}06)`, border:`1px solid ${T.amber}40`, borderRadius:12, padding:"16px 20px", marginBottom:20 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12 }}>
            <div>
              <div style={{ color:T.amber, fontWeight:800, fontSize:14 }}> Bank Details Required</div>
              <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>Finance has requested your bank details for payment processing.</div>
            </div>
            <button onClick={() => setShowBankForm(!showBankForm)} style={{ background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"8px 18px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>
              {showBankForm ? "Close" : "Submit Bank Details"}
            </button>
          </div>
          {showBankForm && (
            <div style={{ marginTop:16 }}>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
                {[["Bank Name *","bank_name","e.g. GCB Bank"],["Branch Name","bank_branch","e.g. Accra Main"],["Account Name","bank_account_name","Name on account"],["Account Number *","bank_account_number","Account number"],["Mobile Money Number","mobile_money_number","e.g. 0244123456"]].map(([label,key,ph]) => (
                  <div key={key}>
                    <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>{label}</div>
                    <input value={bankForm[key]} onChange={e=>setBankForm(f=>({...f,[key]:e.target.value}))} placeholder={ph}
                      style={{ width:"100%", padding:"8px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                  </div>
                ))}
              </div>
              <button onClick={saveBankDetails} disabled={savingBank} style={{ background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"10px 24px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{savingBank?"Saving...":"Save Bank Details"}</button>
            </div>
          )}
        </div>
      )}

      {/*  HERO  */}
      <div style={{ background: `linear-gradient(135deg, ${T.bgDeep} 0%, #0D1F36 60%, ${T.bgDeep} 100%)`, border: `1px solid ${T.border}`, borderRadius: 16, padding: "32px 36px", marginBottom: 24, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -60, right: -60, width: 240, height: 240, background: `radial-gradient(circle, ${T.teal}08, transparent 70%)`, pointerEvents: "none" }} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 16 }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 6 }}>{now.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
            <h1 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 900, color: T.textPrimary, letterSpacing: "-0.03em" }}>{now.getHours() < 12 ? "Good Morning" : now.getHours() < 17 ? "Good Afternoon" : "Good Evening"}, {user.name.split(" ")[0]}.</h1>
            <div style={{ color: T.textMuted, fontSize: 14 }}>{user.role} · {pending.length > 0 ? <span style={{ color: T.amber, fontWeight: 700 }}>{pending.length} open task{pending.length !== 1 ? "s" : ""}</span> : <span style={{ color: T.teal, fontWeight: 700 }}>All tasks complete</span>}</div>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginTop: 24, paddingTop: 20, borderTop: `1px solid ${T.border}44` }}>
          {[
            { label: "My Events", value: events.length, color: T.cyan },
            { label: "Open Tasks", value: pending.length, color: pending.length > 0 ? T.amber : T.teal },
            { label: "Completed Tasks", value: tasks.filter(t => t.status === "completed").length, color: T.teal },
            { label: "Notifications", value: notifs.filter(n => !n.read).length, color: T.cyan },
          ].map(k => (
            <div key={k.label} style={{ padding: "12px 14px", background: `${T.bg}80`, border: `1px solid ${T.border}44`, borderRadius: 10 }}>
              <div style={{ color: k.color, fontSize: 18, fontWeight: 900 }}>{k.value}</div>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 3 }}>{k.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/*  MY EVENTS  */}
      {events.length > 0 && (
        <div style={{ marginBottom: 20 }}>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 12 }}>My Events</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {events.filter(e => !e.event_date || new Date(e.event_date) >= new Date(Date.now() - 30*86400000)).sort((a,b) => new Date(a.event_date||"9999") - new Date(b.event_date||"9999")).slice(0,5).map(e => {
              const daysLeft = e.event_date ? Math.ceil((new Date(e.event_date) - now) / 86400000) : null;
              const dotColor = daysLeft !== null ? (daysLeft <= 7 ? T.red : daysLeft <= 30 ? T.amber : T.teal) : T.teal;
              const myEventTasks = tasks.filter(t => t.project_id === e.id);
              const pendingCount = myEventTasks.filter(t => t.status !== "completed").length;
              return (
                <div key={e.id} onClick={() => setInternalPortalEvent(e)} style={{ background: T.surface, border: `1px solid ${T.border}`, borderLeft: `3px solid ${dotColor}`, borderRadius: 10, padding: "14px 16px", cursor: "pointer", transition: "border-color 0.15s" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{e.name}</div>
                      <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{e.client}{e.event_date ? " · " + new Date(e.event_date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : ""}</div>
                    </div>
                    <div style={{ display: "flex", gap: 6, flexShrink: 0, marginLeft: 12 }}>
                      {daysLeft !== null && <div style={{ background: `${dotColor}18`, border: `1px solid ${dotColor}30`, borderRadius: 8, padding: "4px 10px", textAlign: "center" }}><div style={{ color: dotColor, fontSize: 13, fontWeight: 900, lineHeight: 1 }}>{daysLeft > 0 ? daysLeft : "Today"}</div>{daysLeft > 0 && <div style={{ color: dotColor, fontSize: 8, textTransform: "uppercase" }}>days</div>}</div>}
                      {pendingCount > 0 && <div style={{ background: `${T.amber}18`, border: `1px solid ${T.amber}30`, borderRadius: 8, padding: "4px 10px", textAlign: "center" }}><div style={{ color: T.amber, fontSize: 13, fontWeight: 900, lineHeight: 1 }}>{pendingCount}</div><div style={{ color: T.amber, fontSize: 8, textTransform: "uppercase" }}>tasks</div></div>}
                    </div>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
                    <span style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, background: T.bg, padding: "2px 8px", borderRadius: 20, textTransform: "uppercase" }}>{e.phase || "Planning"}</span>
                    <span style={{ color: T.cyan, fontSize: 11, fontWeight: 700 }}>Open →</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/*  MY TASKS  */}
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "20px 22px", marginBottom: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Work</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>My Tasks</div>
          </div>
          <span style={{ color: T.textMuted, fontSize: 11 }}>{pending.length} open</span>
        </div>
        {tasks.length === 0 ? (
          <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "24px 0" }}>No tasks assigned yet.</div>
        ) : tasks.slice(0,6).map((t, i) => (
          <div key={t.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: i < Math.min(tasks.length,6)-1 ? `1px solid ${T.border}44` : "none" }}>
            <div>
              <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{t.name}</div>
              {t.deadline && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Due: {new Date(t.deadline).toLocaleDateString("en-GB")}</div>}
            </div>
            <Badge status={t.status} />
          </div>
        ))}
      </div>

      {/*  PAYMENT REQUESTS  */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:14, padding:"18px 20px", marginBottom:20 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
          <div>
            <div style={{ color:T.textMuted, fontSize:9, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.12em", marginBottom:3 }}>Finance</div>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15 }}>My Payment Requests</div>
          </div>
          <button onClick={() => checkReportGate(() => setPayReqModal(true))} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"8px 16px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:12 }}>+ New Request</button>
        </div>
        {paymentRequests.length === 0 ? (
          <div style={{ color:T.textMuted, fontSize:13, textAlign:"center", padding:"16px 0" }}>No payment requests submitted yet</div>
        ) : paymentRequests.slice(0,5).map(pr => {
          const statusColors = { pending:T.amber, approved:T.teal, rejected:T.red, paid:"#10B981" };
          return (
            <div key={pr.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:`1px solid ${T.border}33` }}>
              <div>
                <div style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{pr.description}</div>
                <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{pr.request_type?.replace("_"," ")} · {new Date(pr.submitted_at).toLocaleDateString("en-GB")}</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ color:T.amber, fontWeight:700, fontSize:13 }}>{fmtMoney(pr.amount||0, pr.country||"Ghana")}</div>
                <span style={{ color:statusColors[pr.status]||T.textMuted, fontSize:10, fontWeight:700 }}>{pr.status}</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Payment Request Modal */}
      {payReqModal && (
        <div style={{ position:"fixed", inset:0, zIndex:600, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setPayReqModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:460, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>New Payment Request</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:20 }}>Select your event and payment type — amounts are pre-set by CEO/Finance</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12, marginBottom:16 }}>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Related Event *</label>
                <select value={payReqForm.project_id} onChange={async e => {
                  const pid = e.target.value;
                  if (pid) {
                    const { data: rates } = await supabase.from("staff_payment_rates").select("*").eq("staff_id", user.id).eq("project_id", pid).maybeSingle();
                    setPayReqForm(f=>({...f, project_id:pid, _rates:rates||null, selectedTypes:{ project_fee:false, per_diem:false, transport:false }}));
                  } else {
                    setPayReqForm(f=>({...f, project_id:"", _rates:null, selectedTypes:{ project_fee:false, per_diem:false, transport:false }}));
                  }
                }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">Select event...</option>
                  {events.map(ev => <option key={ev.id} value={ev.id}>{ev.name}</option>)}
                </select>
              </div>
              {payReqForm.project_id && (
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:8 }}>Select Payment Types</label>
                  <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                    {[
                      { key:"project_fee", label:"Project Fee", amount: payReqForm._rates?.project_fee },
                      { key:"per_diem", label:"Per Diem", amount: payReqForm._rates?.per_diem },
                      { key:"transport", label:"Transport Allowance", amount: payReqForm._rates?.transport },
                    ].map(({ key, label, amount }) => (
                      <div key={key} onClick={() => amount && setPayReqForm(f=>({...f, selectedTypes:{...f.selectedTypes, [key]:!f.selectedTypes[key]}}))}
                        style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 14px", background: payReqForm.selectedTypes?.[key] ? T.cyan+"15" : T.bg, border:`1px solid ${payReqForm.selectedTypes?.[key] ? T.cyan+"60" : T.border}`, borderRadius:8, cursor: amount ? "pointer" : "default", opacity: amount ? 1 : 0.4 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                          <div style={{ width:18, height:18, borderRadius:4, border:`2px solid ${payReqForm.selectedTypes?.[key] ? T.cyan : T.border}`, background: payReqForm.selectedTypes?.[key] ? T.cyan : "transparent", display:"flex", alignItems:"center", justifyContent:"center" }}>
                            {payReqForm.selectedTypes?.[key] && <span style={{ color:"#060B14", fontSize:11, fontWeight:900 }}></span>}
                          </div>
                          <span style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{label}</span>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          {amount ? <span style={{ color:T.amber, fontWeight:800, fontSize:13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(amount).toLocaleString()).toLocaleString()}</span> : <span style={{ color:T.textMuted, fontSize:11 }}>Not set</span>}
                          {amount && <div style={{ color:T.teal, fontSize:9, fontWeight:700 }}> Set by CEO</div>}
                        </div>
                      </div>
                    ))}
                    <div style={{ padding:"10px 14px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8 }}>
                      <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, marginBottom:8 }}>ADD CUSTOM AMOUNT (Optional)</div>
                      <div style={{ display:"flex", gap:8 }}>
                        <select value={payReqForm.customType||""} onChange={e=>setPayReqForm(f=>({...f,customType:e.target.value}))}
                          style={{ flex:1, padding:"7px 10px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:12, fontFamily:"inherit", outline:"none" }}>
                          <option value="">Type...</option>
                          <option value="reimbursement">Reimbursement</option>
                          <option value="other">Other</option>
                        </select>
                        <input type="number" value={payReqForm.customAmount||""} onChange={e=>setPayReqForm(f=>({...f,customAmount:e.target.value}))} placeholder={`Amount (${getCurrency(activeCountry||user?.country||"Ghana")})`}
                          style={{ flex:1, padding:"7px 10px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:12, fontFamily:"inherit", outline:"none" }} />
                      </div>
                    </div>
                  </div>
                  {(() => {
                    const r = payReqForm._rates;
                    const total = (payReqForm.selectedTypes?.project_fee ? parseFloat(r?.project_fee||0) : 0) +
                      (payReqForm.selectedTypes?.per_diem ? parseFloat(r?.per_diem||0) : 0) +
                      (payReqForm.selectedTypes?.transport ? parseFloat(r?.transport||0) : 0) +
                      (payReqForm.customAmount ? parseFloat(payReqForm.customAmount) : 0);
                    return total > 0 ? (
                      <div style={{ marginTop:8, padding:"10px 14px", background:T.teal+"12", border:`1px solid ${T.teal}30`, borderRadius:8, display:"flex", justifyContent:"space-between" }}>
                        <span style={{ color:T.teal, fontWeight:700, fontSize:13 }}>Total Request</span>
                        <span style={{ color:T.teal, fontWeight:900, fontSize:15 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(total.toLocaleString()).toLocaleString()}</span>
                      </div>
                    ) : null;
                  })()}
                </div>
              )}
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Description *</label>
                <textarea value={payReqForm.description} onChange={e=>setPayReqForm(f=>({...f,description:e.target.value}))} rows={2} placeholder="Brief description of work done..." style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} />
              </div>
              {payReqForm.customType && (
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Upload Receipt (Optional)</label>
                  <input type="file" accept=".pdf,.png,.jpg,.jpeg" onChange={e=>setPayReqForm(f=>({...f,_receipt:e.target.files[0]}))} style={{ width:"100%", padding:"8px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:12, cursor:"pointer", boxSizing:"border-box" }} />
                  {payReqForm._receipt && <div style={{ color:T.teal, fontSize:11, marginTop:4 }}> {payReqForm._receipt.name}</div>}
                </div>
              )}
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={async () => {
                const r = payReqForm._rates;
                const requests = [];
                if (payReqForm.selectedTypes?.project_fee && r?.project_fee) requests.push({ type:"project_fee", amount: parseFloat(r.project_fee) });
                if (payReqForm.selectedTypes?.per_diem && r?.per_diem) requests.push({ type:"per_diem", amount: parseFloat(r.per_diem) });
                if (payReqForm.selectedTypes?.transport && r?.transport) requests.push({ type:"transport", amount: parseFloat(r.transport) });
                if (payReqForm.customType && payReqForm.customAmount) requests.push({ type: payReqForm.customType, amount: parseFloat(payReqForm.customAmount) });
                if (requests.length === 0) { alert("Please select at least one payment type."); return; }
                if (!payReqForm.description) { alert("Please add a description."); return; }
                setSavingPayReq(true);
                let receipt_url = "";
                if (payReqForm._receipt) {
                  const ext = payReqForm._receipt.name.split(".").pop();
                  const path = "receipts/"+user.id+"_"+Date.now()+"."+ext;
                  const { error: upErr } = await supabase.storage.from("rffs").upload(path, payReqForm._receipt, { upsert:true });
                  if (!upErr) { const { data: urlData } = supabase.storage.from("rffs").getPublicUrl(path); receipt_url = urlData.publicUrl; }
                }
                const ev = events.find(e => e.id === payReqForm.project_id);
                const total = requests.reduce((s,req) => s+req.amount, 0);
                for (const req of requests) {
                  await supabase.from("staff_payment_requests").insert({ staff_id:user.id, staff_name:user.name, project_id:payReqForm.project_id||null, project_name:ev?.name||"", amount:req.amount, description:payReqForm.description, request_type:req.type, status:"pending", supporting_doc_url: receipt_url||"" });
                }
                const { data: fms } = await supabase.from("profiles").select("id").eq("role","Finance Manager");
                for (const fm of fms||[]) { await supabase.from("notifications").insert({ user_id:fm.id, title:"Staff Payment Request — "+user.name, message:user.name+" submitted payment requests totalling GHS "+total.toLocaleString()+" for "+payReqForm.description, type:"finance" }); }
                setSavingPayReq(false);
                setPayReqModal(false);
                setPayReqForm({ project_id:"", description:"", _rates:null, selectedTypes:{ project_fee:false, per_diem:false, transport:false }, customAmount:"", customType:"", _receipt:null });
                const { data: pr } = await supabase.from("staff_payment_requests").select("*").eq("staff_id", user.id).order("submitted_at", { ascending:false });
                setPaymentRequests(pr||[]);
              }} disabled={savingPayReq||!payReqForm.description} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13, opacity:!payReqForm.description?0.5:1 }}>{savingPayReq?"Submitting...":"Submit Request"}</button>
              <button onClick={() => setPayReqModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/*  REPORT GATE MODAL  */}
      {reportGateModal && (
        <div style={{ position:"fixed", inset:0, zIndex:800, background:"rgba(0,0,0,0.9)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setReportGateModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.amber}40`, borderRadius:16, width:"100%", maxWidth:480, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ fontSize:32, marginBottom:12, textAlign:"center" }}></div>
            <div style={{ color:T.amber, fontWeight:900, fontSize:18, marginBottom:8, textAlign:"center" }}>Report Required Before Payment</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:20, textAlign:"center", lineHeight:1.6 }}>You have outstanding event report(s) to submit. Please complete your debrief report before making a payment request.</div>
            <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:20 }}>
              {pendingReportEvents.map(ev => (
                <div key={ev.id} style={{ background:T.amber+"12", border:`1px solid ${T.amber}30`, borderRadius:10, padding:"12px 16px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{ev.name}</div>
                    <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{ev.phase} · Report not submitted</div>
                  </div>
                  <span style={{ color:T.amber, fontSize:10, fontWeight:800 }}>PENDING</span>
                </div>
              ))}
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={() => { setReportGateModal(false); }} style={{ flex:1, background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>Go Submit Report</button>
              <button onClick={() => setReportGateModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/*  NOTIFICATIONS  */}
      {notifs.filter(n=>!n.read).length > 0 && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 12 }}>Alerts</div>
          {notifs.filter(n=>!n.read).map(n => (
            <div key={n.id} style={{ display: "flex", gap: 10, padding: "8px 0", borderBottom: `1px solid ${T.border}33` }}>
              <div style={{ width: 6, height: 6, borderRadius: "50%", background: T.cyan, marginTop: 6, flexShrink: 0 }} />
              <div>
                <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{n.title}</div>
                {n.message && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{n.message}</div>}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Internal Event Portal Modal */}
      {internalPortalEvent && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", overflowY: "auto" }} onClick={() => setInternalPortalEvent(null)}>
          <div style={{ minHeight: "100vh", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "24px 20px" }}>
            <div style={{ background: T.bg, borderRadius: 16, width: "100%", maxWidth: 800, padding: 28 }} onClick={e => e.stopPropagation()}>
              <InternalEventPortal event={internalPortalEvent} user={user} allTasks={tasks} onClose={() => setInternalPortalEvent(null)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


const VendorDashboard = ({ user, onNavigate }) => {
  const [assignments, setAssignments] = useState([]);
  const [rffs, setRffs] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [scorecards, setScorecards] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [awards, setAwards] = useState([]);
  const [profile, setProfile] = useState(null);
  const [pos, setPOs] = useState([]);

  const load = async () => {
    const [asn, tk, sc, inv, aw, pr, po, vsc] = await Promise.all([
      supabase.from("rff_vendor_assignments").select("*, rffs(id,title,event_name,status,quote_deadline)").eq("vendor_id", user.id).order("created_at", { ascending: false }),
      supabase.from("tasks").select("*").eq("assignee_id", user.id).order("created_at", { ascending: false }),
      supabase.from("vendor_scorecards").select("*").eq("vendor_id", user.id).order("created_at", { ascending: false }),
      supabase.from("vendor_invoices").select("*, paid_at, reviewed_at").eq("vendor_id", user.id).order("created_at", { ascending: false }),
      supabase.from("rff_awards").select("*").eq("vendor_id", user.id),
      supabase.from("profiles").select("*").eq("id", user.id).single(),
      supabase.from("purchase_orders").select("id,internal_po_number,event_name,amount,currency,status,notes,created_at,rff_id,rff_title,rff_category,vendor_name,vm_signature,vm_signed_at,vm_signed_by,ceo_signature,ceo_signed_at,ceo_signed_by,finance_signature,finance_signed_at,finance_signed_by,line_items").eq("vendor_id", user.id).in("status", ["sent","invoiced","paid","fully_signed","published"]).order("created_at", { ascending: false }),
      supabase.from("vendor_scorecards").select("*").eq("vendor_id", user.id).order("created_at", { ascending: false }),
    ]);
    setAssignments(asn.data || []);
    setRffs((asn.data || []).map(a => a.rffs).filter(Boolean));
    setTasks(tk.data || []);
    setScorecards(sc.data || []);
    setInvoices(inv.data || []);
    setAwards(aw.data || []);
    setProfile(pr.data || null);
    setPOs(po.data || []);
    setScorecards(vsc.data || []);
  };

  useEffect(() => { load(); }, [user.id]);

  const latestScore = scorecards.length > 0 ? scorecards[0] : null;
  const tier = latestScore ? getTier(latestScore.total_pct) : null;
  const pendingInvoices = invoices.filter(i => i.status === "pending" || i.status === "submitted");
  const paidInvoices = invoices.filter(i => i.status === "paid");
  const totalBusiness = awards.reduce((sum, a) => sum + (parseFloat(a.agreed_amount) || 0), 0);
  const completedJobs = awards.filter(a => a.status === "confirmed" || a.status === "po_created").length;
  const pendingTasks = tasks.filter(t => t.status !== "completed").length;
  const now2 = new Date();
  const greeting2 = now2.getHours() < 12 ? "Good Morning" : now2.getHours() < 17 ? "Good Afternoon" : "Good Evening";

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>

      {/*  HERO  */}
      <div style={{ background: `linear-gradient(135deg, ${T.bgDeep} 0%, #0D1F36 60%, ${T.bgDeep} 100%)`, border: `1px solid ${T.border}`, borderRadius: 16, padding: "32px 36px", marginBottom: 24, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -60, right: -60, width: 240, height: 240, background: `radial-gradient(circle, ${T.teal}08, transparent 70%)`, pointerEvents: "none" }} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 16 }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 6 }}>{now2.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
            <h1 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 900, color: T.textPrimary, letterSpacing: "-0.03em" }}>{greeting2}, {user.name.split(" ")[0]}.</h1>
            <div style={{ color: T.textMuted, fontSize: 14 }}>{profile?.service_category || "Vendor"} · {profile?.company_name || ""}</div>
          </div>
          {tier && (
            <div style={{ background: `${tier.color}15`, border: `1px solid ${tier.color}40`, borderRadius: 12, padding: "12px 20px", textAlign: "center" }}>
              <div style={{ color: tier.color, fontSize: 24, fontWeight: 900 }}>{latestScore.total_pct}%</div>
              <div style={{ color: tier.color, fontSize: 11, fontWeight: 700 }}>{tier.label}</div>
              <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>Stretchfield Rating</div>
            </div>
          )}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginTop: 24, paddingTop: 20, borderTop: `1px solid ${T.border}44` }}>
          {[
            { label: "Active RFFs", value: assignments.filter(a => a.status === "pending").length, color: T.cyan },
            { label: "Quotes Submitted", value: assignments.filter(a => a.status === "quote-submitted").length, color: T.amber },
            { label: "Jobs Done", value: completedJobs, color: T.teal },
            { label: "Total Business", value: (user?.country==="Nigeria"?"NGN":"GHS")+" "+Math.round(totalBusiness/1000)+"k", color: T.amber },
            { label: "Pending Invoices", value: pendingInvoices.length, color: pendingInvoices.length > 0 ? T.amber : T.textMuted },
            { label: "Paid Invoices", value: paidInvoices.length, color: T.teal },
          ].map(k => (
            <div key={k.label} style={{ padding: "12px 14px", background: `${T.bg}80`, border: `1px solid ${T.border}44`, borderRadius: 10 }}>
              <div style={{ color: k.color, fontSize: 18, fontWeight: 900 }}>{k.value}</div>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 3 }}>{k.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/*  TWO COLUMN  */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>

        {/* My RFPs (replaces My RFFs) */}
        <VendorRfpDashCard user={user} onNavigate={onNavigate} />
        <div style={{ display: "none", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Procurement</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>My RFFs</div>
          </div>
          {assignments.length === 0 ? (
            <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "16px 0" }}>No RFFs assigned yet</div>
          ) : assignments.slice(0,5).map(a => {
            const statusColors = { pending: T.textMuted, "quote-submitted": T.amber, "quote-approved": T.teal, "invoice-submitted": "#10B981" };
            const statusLabels = { pending: "Awaiting Quote", "quote-submitted": "Submitted", "quote-approved": "Approved", "invoice-submitted": "Invoiced" };
            const rff = a.rffs;
            return (
              <div key={a.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "10px 0", borderBottom: `1px solid ${T.border}33` }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 600, fontSize: 13, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{rff?.title || "RFF"}</div>
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{rff?.event_name}</div>
                  {a.quote_amount && <div style={{ color: T.amber, fontWeight: 700, fontSize: 12, marginTop: 3 }}>{getCurrency(a.rff_country||user?.country||"Ghana")+" "+(parseFloat(a.quote_amount).toLocaleString()).toLocaleString()}</div>}
                </div>
                <span style={{ color: statusColors[a.status]||T.textMuted, fontSize: 10, fontWeight: 700, background: (statusColors[a.status]||T.textMuted)+"18", padding: "2px 8px", borderRadius: 20, marginLeft: 8, flexShrink: 0 }}>{statusLabels[a.status]||a.status}</span>
              </div>
            );
          })}
        </div>

        {/* Purchase Orders */}
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Contracts</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Purchase Orders</div>
          </div>
          {pos.length === 0 ? (
            <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "16px 0" }}>No POs yet</div>
          ) : pos.map(po => {
            const statusColors = { draft: T.textMuted, sent: T.cyan, invoiced: T.amber, paid: T.teal };
            return (
              <div key={po.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "10px 0", borderBottom: `1px solid ${T.border}33` }}>
                <div>
                  <div style={{ color: T.cyan, fontWeight: 700, fontSize: 13 }}>{po.internal_po_number || "PO"}</div>
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{po.event_name}</div>
                  <div style={{ color: T.amber, fontWeight: 700, fontSize: 12, marginTop: 3 }}>{po.currency||(user?.country==="Nigeria"?"NGN":"GHS")} {parseFloat(po.amount||0).toLocaleString()}</div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-end" }}>
                  <span style={{ color: statusColors[po.status]||T.textMuted, fontSize: 10, fontWeight: 700, background: (statusColors[po.status]||T.textMuted)+"18", padding: "2px 8px", borderRadius: 20 }}>{po.status}</span>
                  <button onClick={() => downloadPDF(generatePOPDF(po, {name:po.vendor_name, email:user.email}, {title:po.rff_title||po.event_name}, {name:po.event_name}), "PO-"+(po.internal_po_number||po.id)+".html")} style={{ background: "none", border: "none", color: T.cyan, fontSize: 10, fontWeight: 700, cursor: "pointer", padding: 0 }}>↓ PDF</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/*  JOB HISTORY & RATINGS  */}
      {scorecards.length > 0 && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px", marginBottom: 20 }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Performance</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Job Ratings by Event</div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {scorecards.map((sc, i) => {
              const t = getTier(sc.total_pct);
              return (
                <div key={sc.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: i < scorecards.length-1 ? `1px solid ${T.border}33` : "none" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 700 }}>{sc.event_name || "Event"}</div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{new Date(sc.created_at).toLocaleDateString("en-GB", { day:"numeric", month:"short", year:"numeric" })}</div>
                    {sc.notes && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 4, fontStyle: "italic" }}>"{sc.notes}"</div>}
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ color: t?.color || T.amber, fontWeight: 900, fontSize: 20 }}>{sc.total_pct}%</div>
                    <div style={{ color: t?.color || T.amber, fontSize: 11, fontWeight: 700, background: (t?.color||T.amber)+"18", padding: "2px 10px", borderRadius: 20, display: "inline-block", marginTop: 2 }}>{t?.label}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/*  INVOICES  */}
      {invoices.length > 0 && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px", marginBottom: 20 }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Finance</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>My Invoices</div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {invoices.map((inv, i) => {
              const isPaid = inv.status === "paid" || inv.status === "mark_paid";
              const isReviewed = inv.status === "reviewed";
              const submittedDate = new Date(inv.created_at);
              const daysAgo = Math.floor((new Date() - submittedDate) / (1000*60*60*24));
              const isOverdue = !isPaid && daysAgo > 14;
              const statusColor = isPaid ? T.teal : isOverdue ? T.red : isReviewed ? T.cyan : T.amber;
              const statusLabel = isPaid ? " Paid" : isReviewed ? "Reviewed — Awaiting Payment" : isOverdue ? `Overdue by ${daysAgo - 14} days` : `Pending · ${daysAgo}d ago`;
              return (
                <div key={inv.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: i < invoices.length-1 ? `1px solid ${T.border}33` : "none" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{inv.title || inv.event_name || "Invoice"}</div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Submitted {submittedDate.toLocaleDateString("en-GB", { day:"numeric", month:"short", year:"numeric" })}</div>
                    {inv.document_url && <a href={inv.document_url} target="_blank" rel="noreferrer" style={{ color: T.cyan, fontSize: 10, fontWeight: 700 }}>↗ View Document</a>}
                  </div>
                  <div style={{ textAlign: "right", minWidth: 120 }}>
                    <div style={{ color: statusColor, fontWeight: 800, fontSize: 14 }}>{inv.currency||(user?.country==="Nigeria"?"NGN":"GHS")} {parseFloat(inv.amount||0).toLocaleString()}</div>
                    <div style={{ color: statusColor, fontSize: 10, fontWeight: 700, marginTop: 3, background: statusColor+"15", padding: "2px 8px", borderRadius: 20, display: "inline-block" }}>{statusLabel}</div>
                    {isPaid && inv.paid_at && <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>Paid {new Date(inv.paid_at).toLocaleDateString("en-GB")}</div>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/*  RATING BREAKDOWN  */}
      {latestScore && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px", marginBottom: 20 }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Performance</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Rating Breakdown</div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(100px,1fr))", gap: 10 }}>
            {(() => {
              const sc = latestScore;
              const avg = (...vals) => { const v = vals.filter(x=>x!=null); return v.length ? Math.round((v.reduce((a,b)=>a+b,0)/v.length)/5*100) : 0; };
              return [
                ["Quality", avg(sc.quality_product, sc.quality_execution, sc.quality_post_support, sc.quality_consistency)],
                ["Delivery", avg(sc.reliability_delivery, sc.reliability_punctuality, sc.reliability_dependability, sc.reliability_contingency)],
                ["Communication", avg(sc.comms_responsiveness, sc.comms_clarity, sc.comms_problem_solving, sc.comms_relationship)],
                ["Value", avg(sc.pricing_competitiveness, sc.pricing_clarity, sc.pricing_value, sc.pricing_payment_flexibility)],
                ["Flexibility", avg(sc.flexibility_adaptation, sc.flexibility_custom, sc.flexibility_negotiation, sc.flexibility_client_centric)],
                ["Innovation", avg(sc.innovation_creative, sc.innovation_customization, sc.innovation_suggestions, sc.innovation_trends)],
              ].map(([label, val]) => (
                <div key={label} style={{ background: T.bg, borderRadius: 8, padding: "12px", textAlign: "center" }}>
                  <div style={{ color: val>=80?T.teal:val>=60?T.amber:T.red, fontWeight: 900, fontSize: 18 }}>{val}%</div>
                  <div style={{ color: T.textMuted, fontSize: 10, textTransform: "uppercase", fontWeight: 700, marginTop: 3 }}>{label}</div>
                </div>
              ));
            })()}
          </div>
        </div>
      )}

      {/*  TASKS  */}
      {tasks.length > 0 && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 12 }}>My Tasks</div>
          {tasks.slice(0,4).map(t => (
            <div key={t.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${T.border}22` }}>
              <div style={{ color: T.textPrimary, fontSize: 13 }}>{t.name}</div>
              <Badge status={t.status} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};



const VendorRFFsView = ({ user }) => {
  const [rffs, setRffs] = useState([]);
  const [assignments, setAssignments] = useState({});
  const [quoteModal, setQuoteModal] = useState(null);
  const [invoiceModal, setInvoiceModal] = useState(null);
  const [now, setNow] = React.useState(new Date());
  React.useEffect(() => { const t = setInterval(() => setNow(new Date()), 60000); return () => clearInterval(t); }, []);
  const isQuoteDeadlinePassed = (rff) => rff.quote_deadline && new Date(rff.quote_deadline) < now;
  const [quoteAmount, setQuoteAmount] = useState('');
  const [quoteFile, setQuoteFile] = useState(null);
  const [invoiceAmount, setInvoiceAmount] = useState('');
  const [invoiceFile, setInvoiceFile] = useState(null);
  const [invoiceNotes, setInvoiceNotes] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const loadRffs = async () => {
    if (!user?.id) return;
    // Load vendor assignments with their own status
    const { data: myAssignments } = await supabase.from("rff_vendor_assignments").select("*").eq("vendor_id", user.id);
    if (!myAssignments || myAssignments.length === 0) { setRffs([]); return; }
    
    // Build assignment map by rff_id
    const assignMap = {};
    myAssignments.forEach(a => { assignMap[a.rff_id] = a; });
    setAssignments(assignMap);
    
    const rffIds = myAssignments.map(a => a.rff_id);
    const { data } = await supabase.from("rffs").select("*").in("id", rffIds).order("created_at", { ascending: false });
    setRffs(data || []);
  };

  useEffect(() => { loadRffs(); }, [user?.id]);

  // Get vendor-specific status for an RFF
  const getMyStatus = (rff) => assignments[rff.id]?.status || rff.status || 'pending';

  const handleSubmitQuote = async () => {
    if (!quoteAmount) { setError('Please enter your quote amount.'); return; }
    setSaving(true); setError('');

    let quote_url = '';
    let quote_filename = '';

    if (quoteFile) {
      const ext = quoteFile.name.split('.').pop();
      const filename = `quote_${Date.now()}.${ext}`;
      const { error: uploadErr } = await supabase.storage.from('rffs').upload(filename, quoteFile);
      if (uploadErr) { setError('Upload failed: ' + uploadErr.message); setSaving(false); return; }
      const { data: urlData } = supabase.storage.from('rffs').getPublicUrl(filename);
      quote_url = urlData.publicUrl;
      quote_filename = quoteFile.name;
    }

    // Save quote to vendor assignment only (not global RFF status)
    await supabase.from('rff_vendor_assignments').update({
      quote_amount: parseFloat(quoteAmount),
      quote_document_url: quote_url,
      quote_submitted_at: new Date().toISOString(),
      quote_notes: quoteFile?.name || "",
      status: 'quote-submitted',
    }).eq('rff_id', quoteModal.id).eq('vendor_id', user.id);

    // Update RFF to quote-received (not submitted — that is vendor-specific)
    await supabase.from('rffs').update({
      status: 'quote-received',
      quote_url,
      quote_filename,
    }).eq('id', quoteModal.id);

    // Notify Vendor Manager
    const { data: vms } = await supabase.from('profiles').select('id').eq('role', 'Vendor Manager');
    if (vms) await Promise.all(vms.map(vm => supabase.from('notifications').insert({
      user_id: vm.id,
      title: 'Quote Submitted',
      message: `${user?.name} submitted a quote of ${quoteModal?.country==="Nigeria"?"NGN":"GHS"} ${parseFloat(quoteAmount).toLocaleString()} for "${quoteModal.title}"`,
      type: 'rff',
    })));

    setQuoteModal(null);
    setQuoteAmount('');
    setQuoteFile(null);
    setSaving(false);
    loadRffs();
  };

  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}`, animation: "fadeUp 0.35s ease" }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Procurement</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Available RFFs</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Browse and submit your quotes</div>
      </div>
      {rffs.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No open RFFs</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>New RFFs will appear here when available.</div>
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
          {rffs.map(r => (
            <div key={r.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderTop: `3px solid ${T.cyan}`, borderRadius: 12, padding: "18px 20px", transition: "box-shadow 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = `0 4px 24px ${T.cyan}12`}
              onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>{r.title}</div>
                  <div style={{ color: T.cyan, fontSize: 11, marginTop: 4, fontWeight: 700 }}>{r.client_name}</div>
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{r.event_name} · Due {r.deadline}</div>
                {r.quote_deadline && (
                  <div style={{ marginTop: 8, padding: "8px 12px", background: isQuoteDeadlinePassed(r) ? "#F43F5E15" : T.amber+"15", border: "1px solid " + (isQuoteDeadlinePassed(r) ? "#F43F5E" : T.amber) + "40", borderRadius: 8 }}>
                    <div style={{ color: isQuoteDeadlinePassed(r) ? "#F43F5E" : T.amber, fontSize: 13, fontWeight: 800 }}>
                      {isQuoteDeadlinePassed(r) ? " Quote Submission CLOSED" : " Quote Deadline: " + new Date(r.quote_deadline).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                    </div>
                    {!isQuoteDeadlinePassed(r) && <div style={{ color: T.amber, fontSize: 11, marginTop: 2 }}>{Math.ceil((new Date(r.quote_deadline) - now) / (1000*60*60*24))} days remaining</div>}
                  </div>
                )}
                  {r.description && <div style={{ color: T.textMuted, fontSize: 12, marginTop: 8, fontStyle: "italic" }}>{r.description}</div>}
                </div>
                <Badge status={getMyStatus(r) === 'pending' ? 'vendor-assigned' : getMyStatus(r)} />
              </div>
              <div style={{ display: "flex", gap: 8, marginTop: 14, paddingTop: 12, borderTop: `1px solid ${T.border}44` }}>
                {r.document_url && (
                  <a href={r.document_url} target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: T.cyan, fontSize: 11, fontWeight: 700, textDecoration: "none", background: T.cyan + "12", padding: "6px 12px", borderRadius: 8, border: `1px solid ${T.cyan}30` }}> Download</a>
                )}
                {isQuoteDeadlinePassed(r) ? (
                  <div style={{ color: T.red, fontSize: 11, fontWeight: 700, padding: "5px 12px", background: T.red+"12", border: `1px solid ${T.red}30`, borderRadius: 6 }}> Submission Closed</div>
                ) : getMyStatus(r) === 'quote-submitted' ? (
                  <div style={{ color: T.amber, fontSize: 11, fontWeight: 700, padding: "5px 12px", background: T.amber+"12", border: `1px solid ${T.amber}30`, borderRadius: 6 }}>⏳ Quote Pending Review</div>
                ) : getMyStatus(r) === 'quote-approved' ? (
                  <button onClick={() => { setInvoiceModal(r); setInvoiceAmount(""); setInvoiceNotes(""); }} style={{ background: `linear-gradient(135deg, ${T.teal}, #10B981)`, border: "none", color: "#fff", padding: "5px 14px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700 }}> Submit Invoice</button>
                ) : getMyStatus(r) === 'invoice-submitted' ? (
                  <div style={{ color: T.teal, fontSize: 11, fontWeight: 700, padding: "5px 12px", background: T.teal+"12", border: `1px solid ${T.teal}30`, borderRadius: 6 }}> Invoice Submitted</div>
                ) : (
                  <Btn small onClick={() => { setQuoteModal(r); setQuoteAmount(""); }}>Submit Quote</Btn>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {quoteModal && (
        <Modal title={`Submit Quote — ${quoteModal.title}`} onClose={() => { setQuoteModal(null); setError(''); }}>
          <div style={{ color: T.textSecondary, fontSize: 13, marginBottom: 16, padding: '10px 14px', background: T.cyan + '10', borderRadius: 8, border: `1px solid ${T.cyan}22` }}>
            Client: <strong style={{ color: T.cyan }}>{quoteModal.client_name}</strong> · Event: <strong style={{ color: T.textPrimary }}>{quoteModal.event_name}</strong>
          </div>
          <Input label={`Quote Amount (${quoteModal?.country==="Nigeria"?"NGN":"GHS"})`} type="number" placeholder="e.g. 5000" value={quoteAmount} onChange={v => setQuoteAmount(v)} />
          <div style={{ marginBottom: 16 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Attach Invoice / Quotation Document</div>
            <input type="file" accept=".pdf,.doc,.docx,.xls,.xlsx" onChange={e => setQuoteFile(e.target.files[0])} style={{
              width: '100%', padding: '10px', background: T.bg,
              border: `1px solid ${T.border}`, borderRadius: 6,
              color: T.textSecondary, fontSize: 13, cursor: 'pointer',
            }} />
            {quoteFile && <div style={{ color: T.cyan, fontSize: 12, marginTop: 6 }}> {quoteFile.name}</div>}
          </div>
          {error && <div style={{ color: '#F43F5E', fontSize: 12, marginBottom: 8 }}>{error}</div>}
          <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
            <Btn onClick={handleSubmitQuote} disabled={saving}>{saving ? 'Submitting...' : 'Submit Quote'}</Btn>
            <Btn variant="ghost" onClick={() => { setQuoteModal(null); setError(''); }}>Cancel</Btn>
          </div>
        </Modal>
      )}
      {invoiceModal && (
        <Modal title={"Submit Invoice — " + invoiceModal.title} onClose={() => setInvoiceModal(null)}>
          <div style={{ background: T.teal+"10", border: `1px solid ${T.teal}30`, borderRadius: 8, padding: "10px 14px", marginBottom: 14, fontSize: 12, color: T.teal }}>
             Your quote was approved. Please submit your invoice below.
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Invoice Amount ({invoiceModal?.country==="Nigeria"?"NGN":"GHS"})</label>
            <input type="number" value={invoiceAmount} onChange={e => setInvoiceAmount(e.target.value)} placeholder="Enter invoice amount" style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Notes</label>
            <textarea value={invoiceNotes} onChange={e => setInvoiceNotes(e.target.value)} rows={3} placeholder="Any notes for this invoice..." style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", resize: "none", boxSizing: "border-box" }} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Upload Invoice (PDF)</label>
            <input type="file" accept=".pdf" onChange={e => setInvoiceFile(e.target.files[0])} style={{ width: "100%", padding: "10px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textSecondary, fontSize: 13 }} />
            {invoiceFile && <div style={{ color: T.cyan, fontSize: 12, marginTop: 6 }}> {invoiceFile.name}</div>}
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn onClick={async () => {
              if (!invoiceAmount) { alert("Please enter invoice amount"); return; }
              setSaving(true);
              let invoice_url = "";
              if (invoiceFile) {
                const ext = invoiceFile.name.split(".").pop();
                const fname = "invoice_" + Date.now() + "." + ext;
                const { error: upErr } = await supabase.storage.from("rffs").upload(fname, invoiceFile);
                if (!upErr) {
                  const { data: urlData } = supabase.storage.from("rffs").getPublicUrl(fname);
                  invoice_url = urlData.publicUrl;
                }
              }
              await supabase.from("rff_vendor_assignments").update({
                status: "invoice-submitted",
                invoice_amount: parseFloat(invoiceAmount),
                invoice_url,
                invoice_notes: invoiceNotes,
                invoice_submitted_at: new Date().toISOString(),
              }).eq("rff_id", invoiceModal.id).eq("vendor_id", user.id);
              // Notify Finance & CEO
              const { data: toNotify } = await supabase.from("profiles").select("id,name").in("role", ["CEO","Finance Manager","Vendor Manager"]);
              for (const p of toNotify || []) {
                await supabase.from("notifications").insert({ user_id: p.id, title: "Invoice Submitted — " + invoiceModal.title, message: user.name + " submitted an invoice of GHS " + parseFloat(invoiceAmount).toLocaleString() + " for " + invoiceModal.title, type: "rff" });
              }
              setSaving(false);
              setInvoiceModal(null);
              loadRffs();
            }} disabled={saving}>{saving ? "Submitting..." : "Submit Invoice"}</Btn>
            <Btn variant="ghost" onClick={() => setInvoiceModal(null)}>Cancel</Btn>
          </div>
        </Modal>
      )}


    </div>
  );
};

const UsersView = ({ user }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loginDetailsModal, setLoginDetailsModal] = useState(null);
  const [resetPwdModal, setResetPwdModal] = useState(null);
  const [newTempPwd, setNewTempPwd] = useState("");
  const [resetSaving, setResetSaving] = useState(false);
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(null);
  const [editForm, setEditForm] = useState({ name: '', role: '', country: '', phone: '', newPassword: '' });
  const [form, setForm] = useState({ name: '', email: '', role: 'Country Manager', password: '', country: 'Ghana' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const roleColors = {
    'CEO': T.cyan, 'Country Manager': T.blue, 'Vendor Manager': T.magenta,
    'Strategy & Events Lead': T.amber, 'Sales & Marketing': '#EC4899',
    'Vendor': '#06B6D4', 'Client': '#84CC16',
  };

  const load = async () => {
    setLoading(true);
    const { data } = await supabase.from('profiles').select('*').order('name');
    setUsers(data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    if (!form.name || !form.email || !form.password) { setError('All fields required.'); return; }
    setSaving(true); setError('');
    const { data: authData, error: authErr } = await supabase.auth.signUp({ email: form.email, password: form.password });
    if (authErr) { setError(authErr.message); setSaving(false); return; }
    const uid = authData.user?.id;
    const initials = form.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
    await supabase.from('profiles').insert({ id: uid, name: form.name, email: form.email, role: form.role, avatar: initials });
    setModal(false);
    setForm({ name: '', email: '', role: 'Country Manager', password: '' });
    setSaving(false);
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove this user? This cannot be undone.')) return;
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const res = await fetch(
        'https://okbduzenceoknkjqnrha.supabase.co/functions/v1/delete-user',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${session?.access_token}`,
          },
          body: JSON.stringify({ userId: id }),
        }
      );
      const result = await res.json();
      if (result.error) { alert('Delete failed: ' + result.error); return; }
      setUsers(prev => prev.filter(u => u.id !== id));
    } catch (err) {
      alert('Delete failed: ' + err.message);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Administration</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>User Management</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{users.length} total users</div>
        </div>
        <Btn onClick={() => setModal(true)}>+ Add User</Btn>
      </div>

      {/* KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px,1fr))", gap: 12, marginBottom: 24 }}>
        {[...new Set(users.map(u => u.role))].map((role, i) => {
          const roleColors = { "CEO": T.cyan, "Country Manager": T.teal, "Vendor Manager": T.amber, "Strategy & Events Lead": T.magenta, "Finance Manager": T.amber, "Sales & Marketing": T.blue, "Vendor": T.textSecondary, "Client": "#10B981", "Board of Directors": "#8B5CF6" };
          const color = roleColors[role] || T.textMuted;
          return (
            <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${color}`, borderRadius: 10 }}>
              <div style={{ color: color, fontSize: 20, fontWeight: 900 }}>{users.filter(u => u.role === role).length}</div>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em", marginTop: 4 }}>{role}</div>
            </div>
          );
        })}
      </div>
      {loading ? (
        <div style={{ color: T.textMuted, textAlign: 'center', padding: 60 }}>Loading...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
          {users.map(u => (
            <Card key={u.id}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 14 }}>
                <Avatar initials={u.avatar || '??'} size={44} color={roleColors[u.role] || T.textMuted} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>{u.name}</div>
                  <div style={{ color: T.textMuted, fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.email}</div>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ background: (roleColors[u.role] || T.textMuted) + '22', color: roleColors[u.role] || T.textMuted, padding: '3px 10px', borderRadius: 6, fontSize: 11, fontWeight: 700 }}>{u.role}</span>
                {u.email !== user?.email && (
                  <div style={{ display: "flex", gap: 4 }}>
                    <button onClick={() => openEdit(u)} style={{ background: T.cyan+"18", border: `1px solid ${T.cyan}40`, color: T.cyan, width: 28, height: 28, borderRadius: 6, cursor: "pointer", fontSize: 12, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}></button>
                    <button onClick={() => setLoginDetailsModal(u)} style={{ background: T.cyan+"15", border: "1px solid "+T.cyan+"30", color: T.cyan, padding: "3px 8px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}>Login</button>
                    <button onClick={() => { setResetPwdModal(u); setNewTempPwd("Stretch@" + u.name.split(" ")[0] + "2026"); }} style={{ background: T.amber+"15", border: "1px solid "+T.amber+"30", color: T.amber, padding: "3px 8px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}>Reset Pwd</button>
                    <button onClick={() => handleDelete(u.id)} style={{ background: 'none', border: 'none', color: T.textMuted, cursor: 'pointer', fontSize: 18, padding: '2px 6px' }}>×</button>
                  </div>
                )}
              </div>
            </Card>
          ))}
        </div>
      )}
      {/* Edit User Modal */}
      {editModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setEditModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 480, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Edit User</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>{editModal.email}</div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Full Name</label>
              <input value={editForm.name} onChange={e => setEditForm({...editForm, name: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
            </div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Role</label>
              <select value={editForm.role} onChange={e => setEditForm({...editForm, role: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
                <option value="Country Manager">Country Manager</option>
                <option value="Vendor Manager">Vendor Manager</option>
                <option value="Strategy & Events Lead">Strategy & Events Lead</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
                <option value="Finance Manager">Finance Manager</option>
                <option value="Board of Directors">Board of Directors</option>
                <option value="Vendor">Vendor</option>
                <option value="Client">Client</option>
              </select>
            </div>

            {editForm.role === 'Country Manager' && (
              <div style={{ marginBottom: 14 }}>
                <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Country</label>
                <select value={editForm.country} onChange={e => setEditForm({...editForm, country: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
                  <option value="Ghana">Ghana GH</option>
                  <option value="Nigeria">Nigeria NG</option>
                </select>
              </div>
            )}

            <div style={{ marginBottom: 14 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Phone</label>
              <input value={editForm.phone} onChange={e => setEditForm({...editForm, phone: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} placeholder="+233 XX XXX XXXX" />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>New Password (leave blank to keep current)</label>
              <div style={{ display: "flex", gap: 8 }}>
                <input type="text" value={editForm.newPassword} onChange={e => setEditForm({...editForm, newPassword: e.target.value})}
                  style={{ flex: 1, padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}
                  placeholder="Leave blank to keep current" />
                <button onClick={() => setEditForm({...editForm, newPassword: generatePassword(editModal.email)})}
                  style={{ background: T.cyan+"15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "9px 14px", borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}> Generate</button>
              </div>
            </div>

            {error && <div style={{ color: T.red, fontSize: 12, marginBottom: 12 }}>{error}</div>}
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleUserUpdate} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Saving..." : "Save Changes"}</button>
              <button onClick={() => setEditModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {modal && (
        <Modal title="Add New User" onClose={() => { setModal(false); setError(''); }}>
          <Input label="Full Name" placeholder="e.g. Ama Mensah" value={form.name} onChange={v => setForm({ ...form, name: v })} />
          <Input label="Email" type="email" placeholder="user@stretchfield.com" value={form.email} onChange={v => setForm({ ...form, email: v, password: generatePassword(v) })} />
          <div style={{ marginBottom: 14 }}>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Password</label>
            <div style={{ display: "flex", gap: 8 }}>
              <input type="text" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="Auto-generated from email" style={{ flex: 1, padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }} />
              <button type="button" onClick={() => setForm({...form, password: generatePassword(form.email)})} style={{ background: T.cyan+"15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "9px 14px", borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}> Generate</button>
            </div>
            {form.email && !form.password && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 5 }}>Click Generate to auto-create from email</div>}
            {form.password && <div style={{ color: T.teal, fontSize: 11, marginTop: 5 }}> Password set — will be emailed to user on creation</div>}
          </div>
          <Select label="Role" options={[
            { value: 'Country Manager', label: 'Country Manager' },
            { value: 'Vendor Manager', label: 'Vendor Manager' },
            { value: 'Strategy & Events Lead', label: 'Strategy & Events Lead' },
            { value: 'Sales & Marketing', label: 'Sales & Marketing' },
            { value: 'Finance Manager', label: 'Finance Manager' },
            { value: 'Board of Directors', label: 'Board of Directors' },
            { value: 'Vendor', label: 'Vendor' },
            { value: 'Client', label: 'Client' },
          ]} value={form.role} onChange={v => setForm({ ...form, role: v })} />
          {error && <div style={{ color: '#F43F5E', fontSize: 12, marginTop: 4 }}>{error}</div>}
          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <Btn onClick={handleCreate} disabled={saving}>{saving ? 'Creating...' : 'Create User'}</Btn>
            <Btn variant="ghost" onClick={() => { setModal(false); setError(''); }}>Cancel</Btn>
          </div>
        </Modal>
      )}

      {resetPwdModal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setResetPwdModal(null)}>
          <div style={{ background:T.surface, border:"1px solid "+T.amber+"30", borderRadius:16, width:"100%", maxWidth:420, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Reset Password</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:20 }}>{resetPwdModal.name} — {resetPwdModal.email}</div>
            <div style={{ marginBottom:16 }}>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:6 }}>New Temporary Password</label>
              <input value={newTempPwd} onChange={e=>setNewTempPwd(e.target.value)} style={{ width:"100%", padding:"10px 12px", background:T.bg, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:14, fontFamily:"monospace", outline:"none", boxSizing:"border-box" }} />
            </div>
            <div style={{ background:T.bg, border:"1px solid "+T.border, borderRadius:8, padding:"12px 16px", marginBottom:16 }}>
              <div style={{ color:T.textMuted, fontSize:11, marginBottom:4 }}>Share these details with the user:</div>
              <div style={{ color:T.textPrimary, fontSize:13, fontFamily:"monospace" }}>Email: {resetPwdModal.email}</div>
              <div style={{ color:T.cyan, fontSize:13, fontFamily:"monospace", fontWeight:700 }}>Password: {newTempPwd}</div>
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={async () => {
                if (!newTempPwd) { alert("Enter a password"); return; }
                setResetSaving(true);
                try {
                  const res = await fetch("/api/reset-password", { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ userId: resetPwdModal.id, email: resetPwdModal.email, newPassword: newTempPwd, name: resetPwdModal.name }) });
                  const result = await res.json();
                  if (result.success || res.ok) {
                    await supabase.from("profiles").update({ temp_password: newTempPwd }).eq("id", resetPwdModal.id);
                    navigator.clipboard.writeText("Email: " + resetPwdModal.email + " | Password: " + newTempPwd);
                    alert("Password reset! Details copied to clipboard.");
                    setResetPwdModal(null);
                  } else { alert("Error: " + (result.error || "Failed")); }
                } catch(e) { alert("Error: " + e.message); }
                setResetSaving(false);
              }} disabled={resetSaving} style={{ flex:1, background:"linear-gradient(135deg,"+T.amber+",#F59E0B)", border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{resetSaving?"Resetting...":"Reset & Copy"}</button>
              <button onClick={()=>setResetPwdModal(null)} style={{ background:"none", border:"1px solid "+T.border, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {loginDetailsModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.8)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setLoginDetailsModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 440, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 4 }}>Account Details</div>
                <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18 }}>{loginDetailsModal.name}</div>
                <div style={{ color: T.cyan, fontSize: 11, fontWeight: 700 }}>{loginDetailsModal.role}</div>
              </div>
              <button onClick={() => setLoginDetailsModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, width: 32, height: 32, borderRadius: 8, cursor: "pointer", fontSize: 18 }}>×</button>
            </div>
            <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 10, padding: "16px 18px", marginBottom: 16 }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <div>
                  <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>Email</div>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14, fontFamily: "monospace" }}>{loginDetailsModal.email}</div>
                </div>
                <div>
                  <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>Password</div>
                  {loginDetailsModal.temp_password ? (
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <div style={{ color:T.cyan, fontWeight:700, fontSize:14, fontFamily:"monospace" }}>{loginDetailsModal.temp_password}</div>
                      <button onClick={() => { navigator.clipboard.writeText(loginDetailsModal.temp_password); alert("Copied!"); }} style={{ background:T.cyan+"15", border:"1px solid "+T.cyan+"30", color:T.cyan, padding:"2px 8px", borderRadius:6, cursor:"pointer", fontSize:10, fontWeight:700 }}>Copy</button>
                    </div>
                  ) : (
                    <div>
                      <div style={{ color:T.amber, fontWeight:700, fontSize:13 }}>Click Reset Pwd to set a new password</div>
                    </div>
                  )}
                </div>
                <div>
                  <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>Role</div>
                  <div style={{ color: T.textPrimary, fontSize: 13 }}>{loginDetailsModal.role}</div>
                </div>
              </div>
            </div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              {loginDetailsModal.password_hash && (
                <button onClick={() => { navigator.clipboard.writeText("Email: " + loginDetailsModal.email + "\nPassword: " + loginDetailsModal.password_hash); alert("Copied!"); }} style={{ flex: 1, background: T.cyan+"15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "10px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>Copy Details</button>
              )}
              <button onClick={async () => {
                try {
                  const res = await fetch("/api/reset-password", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email: loginDetailsModal.email, name: loginDetailsModal.name }) });
                  const result = await res.json();
                  if (!res.ok || !result.action_link) { alert("Failed: " + (result.error || "Unknown error")); return; }
                  const html = `<div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;"><div style="height:6px;background:linear-gradient(90deg,#FF6B35,#FF3CAC,#784BA0,#2B86C5,#00C8FF);"></div><div style="background:#060B14;padding:28px 32px;"><table style="width:100%;"><tr><td><span style="color:#00C8FF;font-size:12px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;">STRETCHFIELD WORKROOM</span></td><td style="text-align:right;"><img src="https://workroom.stretchfield.com/logo512.png" style="height:32px;" /></td></tr></table><div style="color:#E8F0FF;font-size:20px;font-weight:800;margin-top:16px;padding-top:16px;border-top:1px solid #1A2E4A;">Set Your Password</div></div><div style="padding:28px 32px;background:#F4F6FB;"><p style="color:#0A1628;font-size:14px;">Hi <strong>${loginDetailsModal.name}</strong>,</p><p style="color:#0A1628;font-size:14px;">Click below to set your Stretchfield WorkRoom password.</p><a href="${result.action_link}" style="display:inline-block;background:linear-gradient(135deg,#00C8FF,#00E5C8);color:#060B14;padding:12px 28px;border-radius:8px;font-weight:800;font-size:13px;text-decoration:none;margin:16px 0;">Set My Password →</a><p style="color:#5A6E8A;font-size:12px;">Log in at workroom.stretchfield.com after setting your password.</p></div></div>`;
                  await fetch("/api/send-email", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ to: loginDetailsModal.email, subject: "Set Your Stretchfield WorkRoom Password", html }) });
                  alert("Password reset link sent to " + loginDetailsModal.email);
                } catch(e) { alert("Error: " + e.message); }
              }} style={{ flex: 1, background: T.amber+"15", border: `1px solid ${T.amber}30`, color: T.amber, padding: "10px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>↗ Send Reset Link</button>
              <button onClick={() => setLoginDetailsModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ClientsView = ({ user, activeCountry = "All" }) => {
  const [selectedClientPortal, setSelectedClientPortal] = useState(null);
  const [clients, setClients] = useState([]);
  const [profileEmails, setProfileEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [loginModal, setLoginModal] = useState(null);
  const [form, setForm] = useState({ name: '', company: '', email: '', phone: '', notes: '', country: activeCountry || 'Ghana' });
  const [loginForm, setLoginForm] = useState({ password: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      // Get current session first
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) { setLoading(false); return; }

      const [{ data: profileData, error: pe }, { data: clientData, error: ce }] = await Promise.all([
        supabase.from('profiles').select('id, name, email, phone, company_name, role, avatar, created_at').eq('role', 'Client').order('created_at', { ascending: false }),
        supabase.from('clients').select('*').order('created_at', { ascending: false }),
      ]);

      if (pe) console.error('Profiles error:', pe.message);
      if (ce) console.error('Clients error:', ce.message);

      const profileEmails = (profileData || []).map(p => p.email);
      const profiles = (profileData || []).map(p => ({
        ...p,
        company: p.company_name || "",
        has_portal: true,
        source: 'profile',
      }));
      const extraClients = (clientData || [])
        .filter(c => c.email && !profileEmails.includes(c.email))
        .map(c => ({ ...c, has_portal: false, source: 'clients' }));
      setClients([...profiles, ...extraClients]);
      setProfileEmails(profileEmails);
    } catch (e) {
      console.error('ClientsView load error:', e);
    }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    if (!form.name) { setError('Client name is required.'); return; }
    setSaving(true); setError('');
    // Insert into clients table for CRM reference
    await supabase.from('clients').insert({
      name: form.name, company: form.company, email: form.email,
      phone: form.phone, notes: form.notes,
      country: form.country || activeCountry || 'Ghana',
    });
    setModal(false);
    setForm({ name: '', company: '', email: '', phone: '', notes: '' });
    setSaving(false);
    load();
  };

  const handleCreateLogin = async () => {
    if (!loginModal.email) { setError('Client must have an email to create a login.'); return; }
    if (!loginForm.password) { setError('Password is required.'); return; }
    setSaving(true); setError(''); setSuccess('');
    try {
      const { data: { session } } = await supabase.auth.getSession();

      if (loginModal.has_portal) {
        // Client already has portal — just resend welcome email with new password reminder
        await sendEmail(
          loginModal.email,
          'Your Stretchfield WorkRoom Login Details',
          welcomeEmailHtml({ name: loginModal.name || loginModal.company, email: loginModal.email, password: loginForm.password, role: 'Client' })
        );
        setSuccess(`Login details resent to ${loginModal.email}.`);
        setSaving(false);
        return;
      }

      const res = await fetch('https://okbduzenceoknkjqnrha.supabase.co/functions/v1/create-vendor-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session?.access_token}` },
        body: JSON.stringify({
          email: loginModal.email,
          password: loginForm.password,
          name: loginModal.name || loginModal.company || '',
          role: 'Client',
          company_name: loginModal.company || '',
        }),
      });
      const result = await res.json();
      if (result.error) { setError(result.error); setSaving(false); return; }
      // Send welcome email
      await sendEmail(
        loginModal.email,
        'Welcome to Stretchfield WorkRoom — Your Client Portal Access',
        welcomeEmailHtml({ name: loginModal.name || loginModal.company, email: loginModal.email, password: loginForm.password, role: 'Client' })
      );
      setSuccess(`Portal login created for ${loginModal.name || loginModal.company}. Login details sent to ${loginModal.email}.`);
      setSaving(false);
      setLoginForm({ password: '' });
      load();
    } catch (e) {
      setError('Failed to create login: ' + e.message);
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove this client?')) return;
    const client = clients.find(c => c.id === id);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (client?.source === 'profile') {
        // Has auth account — delete via edge function
        const res = await fetch('https://okbduzenceoknkjqnrha.supabase.co/functions/v1/delete-user', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session?.access_token}` },
          body: JSON.stringify({ userId: id }),
        });
        const result = await res.json();
        if (result.error) { alert('Delete failed: ' + result.error); return; }
      } else {
        // No auth account — just delete from clients table
        const { error } = await supabase.from('clients').delete().eq('id', id);
        if (error) { alert('Delete failed: ' + error.message); return; }
      }
      // Clear FK references before deleting from clients table
      const { data: clientRecord } = await supabase.from('clients').select('id').eq('email', client?.email).single();
      if (clientRecord) {
        // Null out client_id on rffs referencing this client
        await supabase.from('rffs').update({ client_id: null }).eq('client_id', clientRecord.id);
        await supabase.from('projects').update({ client_id: null }).eq('client_id', clientRecord.id);
        await supabase.from('clients').delete().eq('id', clientRecord.id);
      }
      setClients(prev => prev.filter(c => c.id !== id));
    } catch (e) {
      alert('Delete failed: ' + e.message);
    }
  };

  const isCEOorAdmin = ['CEO', 'Country Manager'].includes(user?.role);

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {selectedClientPortal ? (
        <ClientPortalManager client={selectedClientPortal} user={user} onBack={() => setSelectedClientPortal(null)} />
      ) : <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>CRM</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Client Database</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{clients.length} client{clients.length !== 1 ? "s" : ""} in portfolio</div>
        </div>
        <Btn onClick={() => setModal(true)}>+ Add Client</Btn>
      </div>

      {loading ? (
        <div style={{ color: T.textMuted, textAlign: "center", padding: 60 }}>Loading...</div>
      ) : clients.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No clients yet</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>Click "+ Add Client" to get started.</div>
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
          {clients.map((c, idx) => (
            <div key={c.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "20px 22px", transition: "box-shadow 0.2s, border-color 0.2s" }}
              onMouseEnter={e => { e.currentTarget.style.boxShadow = `0 4px 24px ${T.cyan}10`; e.currentTarget.style.borderColor = T.cyan + "35"; }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.borderColor = T.border; }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 14 }}>
                <div style={{ width: 44, height: 44, borderRadius: 10, background: `linear-gradient(135deg, ${T.cyan}30, ${T.teal}20)`, border: `1px solid ${T.cyan}30`, display: "flex", alignItems: "center", justifyContent: "center", color: T.cyan, fontWeight: 800, fontSize: 15, flexShrink: 0 }}>
                  {(c.name || c.company || "?").split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2)}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{c.company || c.company_name || c.name || "—"}</div>
                  {(c.company || c.company_name) && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{c.name}</div>}
                </div>
                {isCEOorAdmin && c.has_portal && (
                  <div style={{ color: T.teal, fontSize: 10, fontWeight: 700, background: T.teal + "18", border: `1px solid ${T.teal}40`, padding: "2px 8px", borderRadius: 20, flexShrink: 0 }}> Portal</div>
                )}
              </div>
              <div style={{ borderTop: `1px solid ${T.border}44`, paddingTop: 12, marginBottom: 12 }}>
                {c.email && <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 4 }}> {c.email}</div>}
                {c.phone && <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 4 }}> {c.phone}</div>}
                {c.notes && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 8, fontStyle: "italic", lineHeight: 1.5 }}>{c.notes}</div>}
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                {isCEOorAdmin && c.email && (
                  <>
                  <Btn small onClick={() => setSelectedClientPortal(c)}>Manage Portal</Btn>
                  <Btn small onClick={() => { setLoginModal(c); setLoginForm({ password: generatePassword(c.email) }); setError(""); setSuccess(""); }}>
                    {c.has_portal ? "Resend Login" : "Create Login"}
                  </Btn>
                  </>
                )}
                <Btn small variant="ghost" onClick={() => handleDelete(c.id)}>Remove</Btn>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Add Client Modal */}
      {modal && (
        <Modal title="Add New Client" onClose={() => { setModal(false); setError(''); }}>
          <Input label="Full Name" placeholder="e.g. John Mensah" value={form.name} onChange={v => setForm({ ...form, name: v })} />
          <Input label="Company" placeholder="Company or organisation name" value={form.company} onChange={v => setForm({ ...form, company: v })} />
          <Input label="Email" type="email" placeholder="client@company.com" value={form.email} onChange={v => setForm({ ...form, email: v })} />
          <Input label="Phone" placeholder="+233 XX XXX XXXX" value={form.phone} onChange={v => setForm({ ...form, phone: v })} />
          <Input label="Notes" placeholder="Any additional notes..." value={form.notes} onChange={v => setForm({ ...form, notes: v })} />
          {error && <div style={{ color: '#F43F5E', fontSize: 12, marginTop: 4 }}>{error}</div>}
          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <Btn onClick={handleCreate} disabled={saving}>{saving ? 'Saving...' : 'Add Client'}</Btn>
            <Btn variant="ghost" onClick={() => { setModal(false); setError(''); }}>Cancel</Btn>
          </div>
        </Modal>
      )}

      {/*  Create / Resend Login Modal  */}
      {loginModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => { setLoginModal(null); setError(""); setSuccess(""); }}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 480, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>
              {loginModal.has_portal ? "Resend Login Details" : "Create Client Portal Login"}
            </div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>
              {loginModal.company || loginModal.company_name || loginModal.name} · {loginModal.email}
            </div>
            {loginModal.has_portal && (
              <div style={{ background: T.teal+"12", border: `1px solid ${T.teal}30`, borderRadius: 8, padding: "10px 14px", marginBottom: 16, color: T.teal, fontSize: 12 }}>
                 This client already has portal access. Resend their login details below.
              </div>
            )}
            <div style={{ background: T.cyan+"12", border: `1px solid ${T.cyan}30`, borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: T.cyan }}>
              Login details will be sent to <strong>{loginModal.email}</strong>
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Password</label>
              <div style={{ display: "flex", gap: 8 }}>
                <input type="text" value={loginForm.password} onChange={e => setLoginForm({...loginForm, password: e.target.value})}
                  style={{ flex: 1, padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}
                  placeholder="Auto-generated password" />
                <button onClick={() => setLoginForm({...loginForm, password: generatePassword(loginModal.email)})}
                  style={{ background: T.cyan+"15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "9px 14px", borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}> Generate</button>
              </div>
              {loginForm.password && <div style={{ color: T.teal, fontSize: 11, marginTop: 5 }}> Password will be emailed to client</div>}
            </div>
            {error && <div style={{ color: T.red, fontSize: 12, marginBottom: 12, padding: "8px 12px", background: T.red+"12", borderRadius: 6 }}>{error}</div>}
            {success && <div style={{ color: "#10B981", fontSize: 12, marginBottom: 12, padding: "8px 12px", background: "#10B98112", borderRadius: 6 }}>{success}</div>}
            {!success && (
              <div style={{ display: "flex", gap: 10 }}>
                <button onClick={handleCreateLogin} disabled={saving || !loginForm.password}
                  style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13, opacity: saving || !loginForm.password ? 0.6 : 1 }}>
                  {saving ? "Creating..." : loginModal.has_portal ? " Resend Login Email" : " Create Login & Send Email"}
                </button>
                <button onClick={() => { setLoginModal(null); setError(""); setSuccess(""); }}
                  style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
              </div>
            )}
            {success && (
              <button onClick={() => { setLoginModal(null); setError(""); setSuccess(""); load(); }}
                style={{ background: `linear-gradient(135deg, ${T.teal}, ${T.cyan})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>Done </button>
            )}
          </div>
        </div>
      )}
      </>}
    </div>
  );
};

const VendorQuotesView = ({ user }) => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    supabase.from('rffs').select('*')
      .eq('vendor', user.name)
      .not('status', 'eq', 'pending')
      .order('created_at', { ascending: false })
      .then(({ data }) => {
        setQuotes(data || []);
        setLoading(false);
      });
  }, [user.name]);

  // Group by event name
  const grouped = quotes.reduce((acc, q) => {
    const key = q.event_name || 'Unassigned';
    if (!acc[key]) acc[key] = [];
    acc[key].push(q);
    return acc;
  }, {});

  return (
    <div>
      <PageHeader title="My Quotes" subtitle={`${quotes.length} quotes submitted`} />

      {loading ? (
        <div style={{ color: T.textMuted, textAlign: 'center', padding: 60 }}>Loading...</div>
      ) : quotes.length === 0 ? (
        <Card style={{ textAlign: 'center', padding: 60 }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No quotes yet</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>Quotes you submit will appear here.</div>
        </Card>
      ) : Object.entries(grouped).map(([eventName, eventQuotes]) => (
        <div key={eventName} style={{ marginBottom: 28 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
            <div style={{ width: 3, height: 20, background: T.cyan, borderRadius: 2 }} />
            <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>{eventName}</div>
            <div style={{ color: T.textMuted, fontSize: 12, background: T.border, padding: '2px 10px', borderRadius: 20 }}>
              {eventQuotes.length} quote{eventQuotes.length > 1 ? 's' : ''}
            </div>
          </div>

          {eventQuotes.map(q => (
            <Card key={q.id} style={{ marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>{q.title}</div>
                  <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}> {q.client_name} · Due {q.deadline}</div>
                  <div style={{ color: T.amber, fontWeight: 700, fontSize: 14, marginTop: 6 }}>{getCurrency(user?.country||"Ghana")+" "+((q.amount || 0).toLocaleString()).toLocaleString()}</div>
                </div>
                <Badge status={q.status} />
              </div>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                {q.quote_url && (
                  <a href={q.quote_url} target="_blank" rel="noopener noreferrer" style={{
                    display: 'inline-flex', alignItems: 'center', gap: 6,
                    color: T.cyan, fontSize: 12, fontWeight: 600, textDecoration: 'none',
                    background: T.cyan + '15', padding: '5px 12px', borderRadius: 6,
                    border: `1px solid ${T.cyan}33`,
                  }}> {q.quote_filename || 'My Quote Document'}</a>
                )}
                {q.document_url && (
                  <a href={q.document_url} target="_blank" rel="noopener noreferrer" style={{
                    display: 'inline-flex', alignItems: 'center', gap: 6,
                    color: T.textMuted, fontSize: 12, fontWeight: 600, textDecoration: 'none',
                    background: T.border, padding: '5px 12px', borderRadius: 6,
                  }}> Original RFF</a>
                )}
              </div>
              {q.status === 'quote-approved' && (
                <div style={{ marginTop: 10, padding: '8px 12px', background: T.teal + '15', borderRadius: 6, border: `1px solid ${T.teal}33` }}>
                  <span style={{ color: T.teal, fontSize: 12, fontWeight: 700 }}> Quote Approved — Invoice has been generated</span>
                </div>
              )}
            </Card>
          ))}
        </div>
      ))}
    </div>
  );
};


const VendorTasksView = ({ user }) => {
  const [tasks, setTasks] = useState([]);
  const [detailTask, setDetailTask] = useState(null);
  const [taskNotes, setTaskNotes] = useState("");
  const [taskPhoto, setTaskPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => {
    supabase.from('tasks').select('*')
      .eq('assignee_id', user.id)
      .order('created_at', { ascending: false })
      .then(({ data }) => setTasks(data || []));
  };

  useEffect(() => { load(); }, [user.id]);

  const openDetail = (t) => {
    setDetailTask(t);
    setTaskNotes(t.notes || "");
    setTaskPhoto(null);
    setPhotoPreview(t.attachment_url || null);
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setTaskPhoto(file);
    const reader = new FileReader();
    reader.onload = (ev) => setPhotoPreview(ev.target.result);
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    setSaving(true);
    let attachment_url = detailTask.attachment_url || null;
    let attachment_name = detailTask.attachment_name || null;

    if (taskPhoto) {
      const ext = taskPhoto.name.split('.').pop();
      const filename = `task_${detailTask.id}_${Date.now()}.${ext}`;
      const { error: uploadErr } = await supabase.storage.from('rffs').upload(filename, taskPhoto);
      if (!uploadErr) {
        const { data: urlData } = supabase.storage.from('rffs').getPublicUrl(filename);
        attachment_url = urlData.publicUrl;
        attachment_name = taskPhoto.name;
      }
    }

    await supabase.from('tasks').update({
      progress: detailTask.progress,
      status: detailTask.status,
      notes: taskNotes,
      attachment_url,
      attachment_name,
    }).eq('id', detailTask.id);

    setSaving(false);
    setDetailTask(null);
    load();
  };

  return (
    <div>
      <PageHeader title="My Tasks" subtitle={`${tasks.length} tasks assigned to you`} />
      {tasks.length === 0 ? (
        <Card style={{ textAlign: 'center', padding: 60 }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No tasks yet</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>Tasks assigned to you will appear here.</div>
        </Card>
      ) : <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>{tasks.map(t => (
        <Card key={t.id} style={{ marginBottom: 0, cursor: 'pointer' }} onClick={() => openDetail(t)}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>{t.name}</div>
              <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Due {t.deadline}</div>
            </div>
            <Badge status={t.status} />
          </div>
          <ProgressBar value={t.progress || 0} />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6 }}>
            <div style={{ color: T.textMuted, fontSize: 11 }}>{t.progress || 0}% complete</div>
            <div style={{ display: 'flex', gap: 8 }}>
              {t.notes && <span style={{ color: T.cyan, fontSize: 11 }}> Notes</span>}
              {t.attachment_url && <span style={{ color: T.amber, fontSize: 11 }}> Attachment</span>}
            </div>
          </div>
        </Card>
      ))}</div>}

      {detailTask && (
        <Modal title="Update Task" onClose={() => setDetailTask(null)}>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 4 }}>{detailTask.name}</div>
          <div style={{ color: T.textMuted, fontSize: 13, marginBottom: 16 }}>Due {detailTask.deadline}</div>



          {/* Status */}
          <Select label="Status" options={[
            { value: 'pending', label: 'Pending' },
            { value: 'in-progress', label: 'In Progress' },
            { value: 'completed', label: 'Completed' },
          ]} value={detailTask.status} onChange={v => setDetailTask({ ...detailTask, status: v })} />

          {/* Notes */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Notes / Updates</div>
            <textarea value={taskNotes} onChange={e => setTaskNotes(e.target.value)}
              placeholder="Add progress notes, comments or updates..."
              style={{ width: '100%', minHeight: 100, padding: 10, background: T.bg, border: '1px solid ' + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 13, resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box' }} />
          </div>

          {/* Photo Attachment */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Attach Photo / Document</div>
            <input type="file" accept="image/*,.pdf,.doc,.docx" onChange={handlePhotoChange}
              style={{ width: '100%', padding: 10, background: T.bg, border: '1px solid ' + T.border, borderRadius: 8, color: T.textSecondary, fontSize: 13, cursor: 'pointer' }} />
            {photoPreview && (
              <div style={{ marginTop: 12 }}>
                {photoPreview.startsWith('data:image') || (detailTask.attachment_url && detailTask.attachment_url.match(/\.(jpg|jpeg|png|gif|webp)/i)) ? (
                  <img src={photoPreview} alt="Preview" style={{ width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 8, border: '1px solid ' + T.border }} />
                ) : (
                  <a href={photoPreview} target="_blank" rel="noopener noreferrer" style={{ color: T.cyan, fontSize: 13, fontWeight: 600 }}>
                     {detailTask.attachment_name || 'View Attachment'}
                  </a>
                )}
              </div>
            )}
          </div>

          <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
            <Btn onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save Update'}</Btn>
            <Btn variant="ghost" onClick={() => setDetailTask(null)}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};


//  CRM VIEW 
const STAGES = [
  { id: "new", label: "New", color: "#00C8FF" },
  { id: "contacted", label: "Contacted", color: "#3B82F6" },
  { id: "qualified", label: "Qualified", color: "#F59E0B" },
  { id: "proposal", label: "Proposal", color: "#E879F9" },
  { id: "won", label: "Won", color: "#00E5C8" },
  { id: "lost", label: "Lost", color: "#F43F5E" },
];

const LeadCard = ({ lead, selectedLead, setSelectedLead, activities, onReactivate }) => {
  const stage = STAGES.find(s => s.id === lead.status) || STAGES[0];
  const leadActivities = (activities || []).filter(a => a.lead_id === lead.id);
  const lastAct = leadActivities[0];
  const daysSince = lead.created_at ? Math.floor((new Date() - new Date(lead.created_at)) / (1000*60*60*24)) : 0;
  const isSelected = selectedLead?.id === lead.id;
  const isLost = lead.status === "lost";
  const tIcons = { note: "", call: "", meeting: "", email: "", demo: "", "follow-up": "" };
  return (
    <div onClick={() => setSelectedLead(isSelected ? null : lead)}
      style={{ background: isSelected ? T.surface : T.bg, border: `1px solid ${isSelected ? stage.color+"80" : T.border}`, borderLeft: `3px solid ${stage.color}`, borderRadius: 10, padding: "14px 16px", cursor: "pointer", transition: "all 0.2s", marginBottom: 8, opacity: isLost ? 0.7 : 1 }}
      onMouseEnter={e => { if (!isSelected) { e.currentTarget.style.borderColor = stage.color+"50"; e.currentTarget.style.background = T.surface; }}}
      onMouseLeave={e => { if (!isSelected) { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.background = T.bg; }}}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{lead.company}</div>
          {lead.event_name && <div style={{ color: T.cyan, fontSize: 11, fontWeight: 600, marginTop: 1 }}> {lead.event_name}</div>}
          {lead.contact_name && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 1 }}>{lead.contact_name}</div>}
        </div>
        {lead.status === "won" && !lead.approved && <span style={{ background: T.amber+"20", color: T.amber, fontSize: 9, fontWeight: 800, borderRadius: 20, padding: "2px 7px", flexShrink: 0, marginLeft: 6 }}>CEO</span>}
        {lead.status === "won" && lead.approved && <span style={{ background: "#10B98120", color: "#10B981", fontSize: 9, fontWeight: 800, borderRadius: 20, padding: "2px 7px", flexShrink: 0, marginLeft: 6 }}></span>}
      </div>
      <div style={{ color: T.amber, fontWeight: 900, fontSize: 15, marginBottom: 8 }}>{getCurrency(lead?.country||"Ghana")+" "+((lead.value||0).toLocaleString()).toLocaleString()}</div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <span style={{ color: T.textMuted, fontSize: 10 }}>{daysSince}d</span>
          {lastAct && <span style={{ fontSize: 10 }}>{tIcons[lastAct.type]}</span>}
          <span style={{ color: T.textMuted, fontSize: 10 }}>{leadActivities.length} act.</span>
          {lead.event_type && <span style={{ color: T.textMuted, fontSize: 9, background: T.border+"50", borderRadius: 4, padding: "1px 5px" }}>{lead.event_type}</span>}
        </div>
        {lead.assigned_name && <span style={{ color: T.cyan, fontSize: 10, fontWeight: 600 }}>{lead.assigned_name.split(" ")[0]}</span>}
      </div>
      {isLost && onReactivate && (
        <button onClick={e => { e.stopPropagation(); onReactivate(lead); }} style={{ marginTop: 8, width: "100%", padding: "5px", background: T.teal+"15", border: `1px solid ${T.teal}30`, borderRadius: 6, cursor: "pointer", color: T.teal, fontSize: 10, fontWeight: 700 }}> Reactivate Lead</button>
      )}
    </div>
  );
};

const LeadPanel = ({ lead, activities, canEdit, canApprove, addActivity, updateStatus, handleDelete, setApprovalModal, existingClients, setMatchedClient, onEditLead, onNavigate }) => {
  const stage = STAGES.find(s => s.id === lead.status) || STAGES[0];
  const leadActivities = (activities || []).filter(a => a.lead_id === lead.id).sort((a,b) => new Date(b.created_at) - new Date(a.created_at));
  const tColors = { note: T.textMuted, call: T.teal, meeting: T.cyan, email: T.blue, demo: T.amber, "follow-up": "#8B5CF6" };
  const tIcons = { note: "", call: "", meeting: "", email: "", demo: "", "follow-up": "" };
  const [actForm, setActForm] = React.useState({ type: "call", notes: "", scheduled_date: "", scheduled_time: "" });
  const [addingActLocal, setAddingActLocal] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  const [editVals, setEditVals] = React.useState({ value: lead.value || 0, contact_name: lead.contact_name || "", phone: lead.phone || "", email: lead.email || "", notes: lead.notes || "", event_name: lead.event_name || "", event_type: lead.event_type || "", event_date: lead.event_date || "" });
  const [savingEdit, setSavingEdit] = React.useState(false);

  const handleLog = async () => {
    if (!actForm.notes) return;
    setAddingActLocal(true);
    await addActivity(lead.id, lead.company, actForm);
    setActForm({ type: "call", notes: "", scheduled_date: "", scheduled_time: "" });
    setAddingActLocal(false);
  };

  const saveEdit = async () => {
    setSavingEdit(true);
    await supabase.from("leads").update({
      value: parseFloat(editVals.value) || 0,
      contact_name: editVals.contact_name,
      phone: editVals.phone,
      email: editVals.email,
      notes: editVals.notes,
      event_name: editVals.event_name,
      event_type: editVals.event_type,
      event_date: editVals.event_date || null,
    }).eq("id", lead.id);
    setSavingEdit(false);
    setEditMode(false);
    if (onEditLead) onEditLead();
  };

  return (
    <div style={{ width: 380, flexShrink: 0, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, display: "flex", flexDirection: "column", maxHeight: "calc(100vh - 200px)", overflow: "hidden" }}>
      <div style={{ padding: "18px 20px", borderBottom: `1px solid ${T.border}`, background: stage.color+"08" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div style={{ flex: 1 }}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 16 }}>{lead.company}</div>
            {lead.event_name && <div style={{ color: T.cyan, fontSize: 12, fontWeight: 700, marginTop: 2 }}> {lead.event_name}</div>}
            {lead.event_type && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 1 }}>{lead.event_type}{lead.event_date ? " · " + lead.event_date : ""}</div>}
            <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{lead.contact_name} {lead.phone ? "· "+lead.phone : ""}</div>
            {lead.email && <div style={{ color: T.cyan, fontSize: 11, marginTop: 2 }}>{lead.email}</div>}
          </div>
          {canEdit && <button onClick={() => setEditMode(!editMode)} style={{ background: editMode ? T.cyan+"20" : "none", border: `1px solid ${editMode ? T.cyan : T.border}`, color: editMode ? T.cyan : T.textMuted, padding: "4px 10px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700, flexShrink: 0 }}> Edit</button>}
        </div>

        {/* Edit Form */}
        {editMode && (
          <div style={{ marginTop: 12, background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, padding: 12 }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 8 }}>
              <div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Event Name</div>
                <input value={editVals.event_name} onChange={e => setEditVals(v => ({...v, event_name: e.target.value}))} style={{ width: "100%", padding: "6px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} placeholder="Event name" />
              </div>
              <div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Event Type</div>
                <select value={editVals.event_type} onChange={e => setEditVals(v => ({...v, event_type: e.target.value}))} style={{ width: "100%", padding: "6px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }}>
                  <option value="">Select...</option>
                  {["Conference/Seminar","Product Launch","Awards Ceremony","Corporate Party","Other"].map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 8 }}>
              <div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Value (${getCurrency(lead?.country||"Ghana")})</div>
                <input type="number" value={editVals.value} onChange={e => setEditVals(v => ({...v, value: e.target.value}))} style={{ width: "100%", padding: "6px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Event Date</div>
                <input type="date" value={editVals.event_date} onChange={e => setEditVals(v => ({...v, event_date: e.target.value}))} style={{ width: "100%", padding: "6px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 8 }}>
              <div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Contact Name</div>
                <input value={editVals.contact_name} onChange={e => setEditVals(v => ({...v, contact_name: e.target.value}))} style={{ width: "100%", padding: "6px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Phone</div>
                <input value={editVals.phone} onChange={e => setEditVals(v => ({...v, phone: e.target.value}))} style={{ width: "100%", padding: "6px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
              </div>
            </div>
            <div style={{ marginBottom: 8 }}>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Notes</div>
              <textarea value={editVals.notes} onChange={e => setEditVals(v => ({...v, notes: e.target.value}))} rows={2} style={{ width: "100%", padding: "6px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none", resize: "none", boxSizing: "border-box" }} />
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={saveEdit} disabled={savingEdit} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "6px 16px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>{savingEdit ? "Saving..." : "Save"}</button>
              <button onClick={() => setEditMode(false)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontSize: 11 }}>Cancel</button>
            </div>
          </div>
        )}

        <div style={{ display: "flex", gap: 8, marginTop: 12, alignItems: "center" }}>
          <span style={{ color: T.amber, fontWeight: 900, fontSize: 18 }}>{getCurrency(lead?.country||"Ghana")+" "+((lead.value||0).toLocaleString()).toLocaleString()}</span>
          <span style={{ background: stage.color+"20", color: stage.color, borderRadius: 20, padding: "2px 10px", fontSize: 10, fontWeight: 800, textTransform: "uppercase" }}>{lead.status}</span>
        </div>
        {canEdit && (
          <div style={{ display: "flex", gap: 4, marginTop: 12, flexWrap: "wrap" }}>
            {STAGES.map(s => (
              <button key={s.id} onClick={() => updateStatus(lead.id, s.id)} style={{ padding: "3px 10px", borderRadius: 20, border: `1px solid ${lead.status === s.id ? s.color : T.border}`, background: lead.status === s.id ? s.color+"20" : "none", color: lead.status === s.id ? s.color : T.textMuted, fontSize: 10, fontWeight: 700, cursor: "pointer" }}>{s.label}</button>
            ))}
          </div>
        )}
        {canApprove && lead.status === "won" && !lead.approved && (
          <button onClick={() => { setApprovalModal(lead); const mc = existingClients.find(c => c.email === lead.email || c.company === lead.company); setMatchedClient(mc||null); }} style={{ marginTop: 10, width: "100%", padding: "8px", background: `linear-gradient(135deg, ${T.teal}, ${T.cyan})`, border: "none", borderRadius: 8, cursor: "pointer", color: "#fff", fontSize: 12, fontWeight: 800 }}> Approve & Create Event</button>
        )}
        {canApprove && lead.status === "won" && lead.approved && !lead.project_id && (
          <button onClick={() => { setApprovalModal(lead); const mc = existingClients.find(c => c.email === lead.email || c.company === lead.company); setMatchedClient(mc||null); }} style={{ marginTop: 10, width: "100%", padding: "8px", background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", borderRadius: 8, cursor: "pointer", color: "#fff", fontSize: 12, fontWeight: 800 }}>+ Create Event</button>
        )}
        {lead.project_id && (
          <button onClick={() => onNavigate && onNavigate("events")} style={{ marginTop: 10, width: "100%", padding: "8px", background: T.teal+"15", border: `1px solid ${T.teal}40`, borderRadius: 8, cursor: "pointer", color: T.teal, fontSize: 12, fontWeight: 800 }}>View Event →</button>
        )}
      </div>
      {lead.notes && (
        <div style={{ padding: "12px 20px", borderBottom: `1px solid ${T.border}44`, background: T.bg }}>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>Notes</div>
          <div style={{ color: T.textSecondary, fontSize: 12, lineHeight: 1.5 }}>{lead.notes}</div>
        </div>
      )}
      <div style={{ flex: 1, overflow: "auto", padding: "14px 20px" }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>Activity Timeline</div>
        {canEdit && (
          <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "12px", marginBottom: 14 }}>
            <div style={{ display: "flex", gap: 4, marginBottom: 8, flexWrap: "wrap" }}>
              {["call","meeting","email","note","demo","follow-up"].map(t => (
                <button key={t} onClick={() => setActForm(f => ({...f, type: t}))} style={{ padding: "2px 8px", borderRadius: 20, border: `1px solid ${actForm.type === t ? tColors[t] : T.border}`, background: actForm.type === t ? tColors[t]+"20" : "none", color: actForm.type === t ? tColors[t] : T.textMuted, fontSize: 9, fontWeight: 700, cursor: "pointer", textTransform: "uppercase" }}>
                  {tIcons[t]} {t}
                </button>
              ))}
            </div>
            <textarea value={actForm.notes} onChange={e => setActForm(f => ({...f, notes: e.target.value}))} placeholder={`Log ${actForm.type}...`} rows={2} style={{ width: "100%", padding: "7px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", resize: "none", boxSizing: "border-box", marginBottom: 6 }} />
            {["call","meeting","demo","follow-up"].includes(actForm.type) && (
              <div style={{ display: "flex", gap: 6, marginBottom: 6 }}>
                <input type="date" value={actForm.scheduled_date} onChange={e => setActForm(f => ({...f, scheduled_date: e.target.value}))} style={{ flex: 1, padding: "5px 8px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 5, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                <input type="time" value={actForm.scheduled_time} onChange={e => setActForm(f => ({...f, scheduled_time: e.target.value}))} style={{ flex: 1, padding: "5px 8px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 5, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
              </div>
            )}
            {actForm.scheduled_date && <div style={{ color: "#8B5CF6", fontSize: 10, fontWeight: 700, marginBottom: 6 }}> {actForm.scheduled_date}{actForm.scheduled_time ? " at "+actForm.scheduled_time : ""} → calendar</div>}
            <button onClick={handleLog} disabled={addingActLocal || !actForm.notes} style={{ background: T.cyan, border: "none", color: "#000", padding: "5px 14px", borderRadius: 5, cursor: "pointer", fontSize: 11, fontWeight: 800, opacity: !actForm.notes ? 0.5 : 1 }}>{addingActLocal ? "..." : "Log"}</button>
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {leadActivities.length === 0 && <div style={{ color: T.textMuted, fontSize: 12, textAlign: "center", padding: "20px 0" }}>No activity yet</div>}
          {leadActivities.map((act, i) => {
            const color = tColors[act.type] || T.textMuted;
            return (
              <div key={act.id} style={{ display: "flex", gap: 10 }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <div style={{ width: 28, height: 28, borderRadius: "50%", background: color+"20", border: `1px solid ${color}40`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, flexShrink: 0 }}>{tIcons[act.type]}</div>
                  {i < leadActivities.length-1 && <div style={{ width: 1, flex: 1, background: T.border, marginTop: 4, minHeight: 12 }} />}
                </div>
                <div style={{ flex: 1, paddingBottom: 8 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                    <span style={{ color, fontSize: 10, fontWeight: 800, textTransform: "uppercase" }}>{act.type}</span>
                    <span style={{ color: T.textMuted, fontSize: 10 }}>{new Date(act.created_at).toLocaleDateString("en-GB")}</span>
                  </div>
                  <div style={{ color: T.textSecondary, fontSize: 12, lineHeight: 1.5 }}>{act.notes}</div>
                  {act.scheduled_date && <div style={{ color: "#8B5CF6", fontSize: 10, fontWeight: 700, marginTop: 3 }}> {act.scheduled_date}{act.scheduled_time ? " at "+act.scheduled_time : ""}</div>}
                  <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>— {act.created_by_name}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {canEdit && (
        <div style={{ padding: "12px 20px", borderTop: `1px solid ${T.border}`, display: "flex", gap: 8 }}>
          <button onClick={() => handleDelete(lead.id)} style={{ background: T.red+"15", border: `1px solid ${T.red}30`, color: T.red, padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>Delete</button>
        </div>
      )}
    </div>
  );
};

const CRMView = ({ user, activeCountry = "All", onNavigate }) => {
  const [leads, setLeads] = useState([]);
  const [activities, setActivities] = useState([]);
  const [proposals, setProposals] = useState([]);
  const [members, setMembers] = useState([]);
  const [existingClients, setExistingClients] = useState([]);
  const [view, setView] = useState("kanban"); // kanban | list
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [saving, setSaving] = useState(false);
  const [filter, setFilter] = useState("all");
  const [approvalModal, setApprovalModal] = useState(null);
  const [pickedClientId, setPickedClientId] = useState("");
  const [matchedClient, setMatchedClient] = useState(null);
  const [clientForm, setClientForm] = useState({ name: "", company: "", email: "", phone: "" });
  const [eventForm, setEventForm] = useState({ name: "", deadline: "", phase: "Planning" });
  const [createLogin, setCreateLogin] = useState(false);
  const [loginPassword, setLoginPassword] = useState("");
  const [actForm, setActForm] = useState({ type: "call", notes: "", scheduled_date: "", scheduled_time: "" });
  const [addingAct, setAddingAct] = useState(false);
  const [form, setForm] = useState({ company: "", contact_name: "", email: "", phone: "", source: "", value: "", notes: "", status: "new", assigned_to: "", assigned_name: "", event_name: "", event_type: "", event_date: "" });

  const canEdit = ["CEO", "Country Manager", "Sales & Marketing"].includes(user?.role);
  const canApprove = ["CEO", "Country Manager"].includes(user?.role);



  const load = async () => {
    const [l, a, p, m, c] = await Promise.all([
      ["CEO", "Country Manager", "Sales & Marketing"].includes(user?.role)
        ? (activeCountry && activeCountry !== "All" ? supabase.from("leads").select("*").eq("country",activeCountry).order("created_at",{ascending:false}) : supabase.from("leads").select("*").order("created_at",{ascending:false}))
        : supabase.from("leads").select("*").or(`assigned_to.eq.${user.id},created_by.eq.${user.id}`).order("created_at", { ascending: false }),
      supabase.from("crm_activities").select("*").order("created_at", { ascending: false }),
      supabase.from("proposals").select("*").order("created_at", { ascending: false }),
      supabase.from("profiles").select("*").not("role", "in", '("Client","Vendor")'),
      (!activeCountry || activeCountry === "All") ? supabase.from("clients").select("*") : supabase.from("clients").select("*").eq("country",activeCountry),
    ]);
    setLeads(l.data || []);
    setActivities(a.data || []);
    setProposals(p.data || []);
    setMembers(m.data || []);
    setExistingClients(c.data || []);
  };

  useEffect(() => { load(); }, [activeCountry]);

  const filteredLeads = leads.filter(l => {
    if (filter !== "all" && l.status !== filter) return false;
    if (search && !l.company?.toLowerCase().includes(search.toLowerCase()) && !l.contact_name?.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const totalPipeline = leads.filter(l => !["won","lost"].includes(l.status)).reduce((a,l) => a + (l.value||0), 0);
  const totalWon = leads.filter(l => l.status === "won").reduce((a,l) => a + (l.value||0), 0);
  const wonCount = leads.filter(l => l.status === "won").length;
  const pendingApproval = leads.filter(l => l.status === "won" && !l.approved).length;

  const handleCreate = async () => {
    if (!form.company) return;
    setSaving(true);
    await supabase.from("leads").insert({
      company: form.company, contact_name: form.contact_name, email: form.email,
      phone: form.phone, source: form.source, value: parseFloat(form.value) || 0,
      notes: form.notes, status: form.status || "new", created_by: user?.id,
      country: user?.country || activeCountry || 'Ghana',
      assigned_to: form.assigned_to || null, assigned_name: form.assigned_name || "",
      event_name: form.event_name || null, event_type: form.event_type || null,
      event_date: form.event_date || null,
    });
    setModal(false);
    setForm({ company: "", contact_name: "", email: "", phone: "", source: "", value: "", notes: "", status: "new", assigned_to: "", assigned_name: "", event_name: "", event_type: "", event_date: "" });
    setSaving(false);
    load();
  };

  const updateStatus = async (leadId, newStatus) => {
    if (newStatus === "won") {
      await supabase.from("leads").update({ status: "won", pending_approval: true, closed_date: new Date().toISOString().slice(0,10), sales_cycle_days: Math.round((new Date() - new Date(leads.find(l=>l.id===leadId)?.created_at||new Date()))/(1000*60*60*24)) }).eq("id", leadId);
      const { data: ceos } = await supabase.from("profiles").select("id, email, name").eq("role", "CEO");
      for (const ceo of ceos || []) {
        await supabase.from("notifications").insert({ user_id: ceo.id, title: "Lead Won — Action Required", message: `${leads.find(l=>l.id===leadId)?.company} has been marked as Won. Please review and approve.`, type: "crm" });
        if (ceo.email) await sendEmail(ceo.email, `Lead Won — ${leads.find(l=>l.id===leadId)?.company}`, notifEmailHtml({ name: ceo.name, title: "Lead Won — Your Approval Required", message: `<strong>${leads.find(l=>l.id===leadId)?.company}</strong> has been marked as Won. Please log in to review and approve.`, actionUrl: BASE_URL, actionLabel: "Review Lead" }));
      }
    } else {
      await supabase.from("leads").update({ status: newStatus }).eq("id", leadId);
    }
    load();
  };

  const addActivity = async (leadId, company, form) => {
    const af = form || actForm;
    if (!af.notes) return;
    setAddingAct(true);
    await supabase.from("crm_activities").insert({
      lead_id: leadId, type: af.type, notes: af.notes,
      scheduled_date: af.scheduled_date || null,
      scheduled_time: af.scheduled_time || null,
      activity_type: af.type,
      created_by: user.id, created_by_name: user.name,
    });
    if (actForm.scheduled_date && ["call","meeting","demo","follow-up"].includes(actForm.type)) {
      await supabase.from("itineraries").insert({
        title: `${actForm.type.charAt(0).toUpperCase()+actForm.type.slice(1)} — ${company}`,
        week_start: actForm.scheduled_date,
        items: JSON.stringify([{ date: actForm.scheduled_date, time: actForm.scheduled_time || "09:00", company, action: actForm.type, notes: actForm.notes }]),
        created_by: user.id,
      });
      const lead = leads.find(l => l.id === leadId);
      if (lead?.assigned_to) {
        await supabase.from("notifications").insert({ user_id: lead.assigned_to, title: `Follow-up Scheduled — ${company}`, message: `${actForm.type} scheduled on ${actForm.scheduled_date}${actForm.scheduled_time ? " at " + actForm.scheduled_time : ""}`, type: "crm" });
      }
    }
    setActForm({ type: "call", notes: "", scheduled_date: "", scheduled_time: "" });
    setAddingAct(false);
    load();
  };

  const typeColors = { note: T.textMuted, call: T.teal, meeting: T.cyan, email: T.blue, demo: T.amber, "follow-up": "#8B5CF6" };
  const typeIcons = { note: "", call: "", meeting: "", email: "", demo: "", "follow-up": "" };

  //  KANBAN CARD 
      const handleDelete = async (id) => {
    if (!window.confirm("Delete this lead?")) return;
    await supabase.from("opportunities").update({ converted_lead_id: null }).eq("converted_lead_id", id);
    await supabase.from("leads").delete().eq("id", id);
    setSelectedLead(null);
    load();
  }

  const handleReactivate = async (lead) => {
    await supabase.from("leads").update({ status: "new", previous_status: "lost" }).eq("id", lead.id);
    await supabase.from("crm_activities").insert({
      lead_id: lead.id, type: "note",
      notes: "Lead reactivated on " + new Date().toLocaleDateString("en-GB"),
      activity_type: "note", created_by: user.id, created_by_name: user.name,
    });
    load();
  };;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {/*  Header  */}
      <div style={{ marginBottom: 20, paddingBottom: 16, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 4 }}>Sales</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Leads Pipeline</h2>
          <div style={{ display: "flex", gap: 8 }}>
            {/* View toggle */}
            <div style={{ display: "flex", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, padding: 3 }}>
              {[["kanban","⊞"], ["list","≡"]].map(([v, icon]) => (
                <button key={v} onClick={() => setView(v)} style={{ padding: "4px 12px", borderRadius: 6, border: "none", cursor: "pointer", background: view === v ? T.surface : "none", color: view === v ? T.cyan : T.textMuted, fontSize: 14, fontWeight: 700, transition: "all 0.15s" }}>{icon}</button>
              ))}
            </div>
            {canEdit && <button onClick={() => setModal(true)} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "9px 20px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>+ New Lead</button>}
          </div>
        </div>
      </div>

      {/*  KPI Strip  */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px,1fr))", gap: 10, marginBottom: 20 }}>
        {[
          { label: "Total Leads", value: leads.length, color: T.cyan },
          { label: "Pipeline Value", value: getCurrency(activeCountry)+" "+totalPipeline.toLocaleString(), color: T.amber },
          { label: "Won", value: wonCount, sub: getCurrency(activeCountry)+" "+totalWon.toLocaleString(), color: T.teal },
          { label: "Pending Approval", value: pendingApproval, color: pendingApproval > 0 ? T.red : T.textMuted },
        ].map((k,i) => (
          <div key={i} style={{ padding: "12px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 20, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginTop: 2 }}>{k.label}</div>
            {k.sub && <div style={{ color: T.textMuted, fontSize: 10, marginTop: 1 }}>{k.sub}</div>}
          </div>
        ))}
      </div>

      {/*  Search + Filter  */}
      <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search leads..." style={{ flex: 1, minWidth: 180, padding: "8px 14px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }} />
        <div style={{ display: "flex", gap: 4 }}>
          {["all",...STAGES.map(s=>s.id)].map(f => (
            <button key={f} onClick={() => setFilter(f)} style={{ padding: "6px 12px", borderRadius: 20, border: `1px solid ${filter===f ? (STAGES.find(s=>s.id===f)?.color||T.cyan) : T.border}`, background: filter===f ? (STAGES.find(s=>s.id===f)?.color||T.cyan)+"18" : "none", color: filter===f ? (STAGES.find(s=>s.id===f)?.color||T.cyan) : T.textMuted, fontSize: 10, fontWeight: 700, cursor: "pointer", textTransform: "uppercase" }}>
              {f === "all" ? "All" : f}
            </button>
          ))}
        </div>
      </div>

      {/*  Main Content  */}
      <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
        {/* Kanban / List */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {view === "kanban" ? (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px,1fr))", gap: 12 }}>
              {STAGES.filter(s => filter === "all" || s.id === filter).map(stage => {
                const stageLeads = filteredLeads.filter(l => l.status === stage.id);
                const stageValue = stageLeads.reduce((a,l) => a+(l.value||0), 0);
                return (
                  <div key={stage.id}>
                    {/* Column Header */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, padding: "6px 10px", background: stage.color+"10", border: `1px solid ${stage.color}25`, borderRadius: 8 }}>
                      <div>
                        <span style={{ color: stage.color, fontWeight: 800, fontSize: 11, textTransform: "uppercase" }}>{stage.label}</span>
                        <span style={{ color: T.textMuted, fontSize: 10, marginLeft: 6 }}>({stageLeads.length})</span>
                      </div>
                      {stageValue > 0 && <span style={{ color: stage.color, fontSize: 10, fontWeight: 700 }}>{getCurrency(activeCountry)+" "+stageValue.toLocaleString()}</span>}
                    </div>
                    {/* Cards */}
                    <div style={{ minHeight: 80 }}>
                      {stageLeads.length === 0 && <div style={{ color: T.textMuted, fontSize: 11, textAlign: "center", padding: "20px 0", fontStyle: "italic" }}>Empty</div>}
                      {stageLeads.map(lead => <LeadCard key={lead.id} lead={lead} selectedLead={selectedLead} setSelectedLead={setSelectedLead} activities={activities} onReactivate={handleReactivate} />)}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            /* List View */
            <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                    {["Company","Contact","Value","Stage","Source","Assigned","Actions"].map(h => (
                      <th key={h} style={{ padding: "10px 14px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredLeads.map((lead,i) => {
                    const stage = STAGES.find(s => s.id === lead.status) || STAGES[0];
                    return (
                      <tr key={lead.id} style={{ borderBottom: i < filteredLeads.length-1 ? `1px solid ${T.border}44` : "none", cursor: "pointer" }}
                        onClick={() => setSelectedLead(selectedLead?.id === lead.id ? null : lead)}
                        onMouseEnter={e => e.currentTarget.style.background = T.bg}
                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                        <td style={{ padding: "10px 14px" }}>
                          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{lead.company}</div>
                          {lead.email && <div style={{ color: T.textMuted, fontSize: 11 }}>{lead.email}</div>}
                        </td>
                        <td style={{ padding: "10px 14px", color: T.textSecondary, fontSize: 12 }}>{lead.contact_name||"—"}<br/><span style={{ color: T.textMuted, fontSize: 11 }}>{lead.phone||""}</span></td>
                        <td style={{ padding: "10px 14px", color: T.amber, fontWeight: 800, fontSize: 13 }}>{getCurrency(activeCountry)+" "+(lead.value||0).toLocaleString()}</td>
                        <td style={{ padding: "10px 14px" }}><span style={{ background: stage.color+"18", color: stage.color, borderRadius: 20, padding: "2px 10px", fontSize: 10, fontWeight: 800, textTransform: "uppercase" }}>{stage.label}</span></td>
                        <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 12 }}>{lead.source||"—"}</td>
                        <td style={{ padding: "10px 14px", color: T.cyan, fontSize: 12 }}>{lead.assigned_name||"—"}</td>
                        <td style={{ padding: "10px 14px" }}>
                          <div style={{ display: "flex", gap: 6 }}>
                            {canApprove && lead.status === "won" && !lead.approved && (
                              <button onClick={e => { e.stopPropagation(); setApprovalModal(lead); const mc = existingClients.find(c => c.email === lead.email || c.company === lead.company); setMatchedClient(mc||null); }} style={{ background: T.teal+"15", border: `1px solid ${T.teal}30`, color: T.teal, padding: "3px 8px", borderRadius: 5, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Approve</button>
                            )}
                            {canEdit && <button onClick={e => { e.stopPropagation(); handleDelete(lead.id); }} style={{ background: T.red+"15", border: `1px solid ${T.red}30`, color: T.red, padding: "3px 8px", borderRadius: 5, cursor: "pointer", fontSize: 10, fontWeight: 700 }}>×</button>}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                  {filteredLeads.length === 0 && <tr><td colSpan={7} style={{ padding: "40px 0", textAlign: "center", color: T.textMuted }}>No leads found</td></tr>}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/*  Right Panel  */}
        {selectedLead && <LeadPanel key={selectedLead.id} lead={selectedLead} activities={activities} canEdit={canEdit} canApprove={canApprove} addActivity={addActivity} updateStatus={updateStatus} handleDelete={handleDelete} setApprovalModal={setApprovalModal} existingClients={existingClients} setMatchedClient={setMatchedClient} onEditLead={() => load()} onNavigate={onNavigate} />}
      </div>

      {/*  New Lead Modal  */}
      {modal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setModal(false)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 520, padding: 28, maxHeight: "90vh", overflow: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 20 }}>New Lead</div>
            {[
              ["Company *", "company", "text", "Company name"],
              ["Contact Name", "contact_name", "text", "Full name"],
              ["Email", "email", "email", "email@company.com"],
              ["Phone", "phone", "text", "+233 XX XXX XXXX"],
              ["Value ("+getCurrency(activeCountry)+")", "value", "number", "Estimated deal value"],
              ["Source", "source", "text", "Referral, LinkedIn, Cold call..."],
            ].map(([label, key, type, placeholder]) => (
              <div key={key} style={{ marginBottom: 12 }}>
                <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 4 }}>{label}</label>
                <input type={type} value={form[key]} onChange={e => setForm({...form, [key]: e.target.value})} placeholder={placeholder} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
              </div>
            ))}
            <div style={{ background: T.cyan+"08", border: `1px solid ${T.cyan}20`, borderRadius: 10, padding: "12px 14px", marginBottom: 12 }}>
              <div style={{ color: T.cyan, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>Event Details</div>
              <div style={{ marginBottom: 10 }}>
                <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 4 }}>Event Name</label>
                <input value={form.event_name} onChange={e => setForm({...form, event_name: e.target.value})} placeholder="e.g. MTN Annual Conference 2026" style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 4 }}>Event Type</label>
                  <select value={form.event_type} onChange={e => setForm({...form, event_type: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
                    <option value="">Select type...</option>
                    {["Conference/Seminar","Product Launch","Awards Ceremony","Corporate Party","Other"].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 4 }}>Approx. Date</label>
                  <input type="date" value={form.event_date} onChange={e => setForm({...form, event_date: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
                </div>
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 4 }}>Stage</label>
              <select value={form.status} onChange={e => setForm({...form, status: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
                {STAGES.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 4 }}>Assign To</label>
              <select value={form.assigned_to} onChange={e => { const m = members.find(x => x.id === e.target.value); setForm({...form, assigned_to: e.target.value, assigned_name: m?.name||""}); }} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
                <option value="">Unassigned</option>
                {members.map(m => <option key={m.id} value={m.id}>{m.name} — {m.role}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 4 }}>Notes</label>
              <textarea value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} rows={2} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", resize: "vertical", boxSizing: "border-box" }} />
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleCreate} disabled={saving || !form.company} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13, opacity: !form.company ? 0.6 : 1 }}>{saving ? "Saving..." : "Create Lead"}</button>
              <button onClick={() => setModal(false)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/*  APPROVE — CREATE CLIENT & PORTAL MODAL  */}
      {approvalModal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setApprovalModal(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.teal}40`, borderRadius:16, width:"100%", maxWidth:520, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:20, marginBottom:4 }}>Approve Lead & Create Event</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:20 }}>Approve <strong>{approvalModal.company}</strong>, link a client and create the event</div>

            {/* Pick existing client */}
            <div style={{ marginBottom:16 }}>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Client</label>
              <select value={pickedClientId} onChange={e=>setPickedClientId(e.target.value)} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">+ Create new client (use details below)</option>
                {existingClients.filter(cl => !approvalModal.country || !cl.country || cl.country === approvalModal.country).map(cl => <option key={cl.id} value={cl.id}>{cl.company || cl.name}{cl.email ? " — "+cl.email : ""}</option>)}
              </select>
              {pickedClientId && <div style={{ color:T.teal, fontSize:11, marginTop:4 }}>Using existing client. The details below are ignored.</div>}
            </div>
            {/* Client details */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
              {[
                ["Client/Company Name","name", approvalModal.company||""],
                ["Contact Person","contact_name", approvalModal.contact_name||""],
                ["Email","email", approvalModal.email||""],
                ["Phone","phone", approvalModal.phone||""],
              ].map(([label, field, def]) => (
                <div key={field}>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>{label}</label>
                  <input value={clientForm[field]||(clientForm[field]===undefined?def:"")} onChange={e=>setClientForm(f=>({...f,[field]:e.target.value}))} placeholder={def}
                    style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                </div>
              ))}
            </div>

            {/* Event details */}
            <div style={{ background:T.bg, border:`1px solid ${T.border}`, borderRadius:10, padding:"14px 16px", marginBottom:16 }}>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:10 }}>Event Details</div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                <div style={{ gridColumn:"1/-1" }}>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Event Name</label>
                  <input value={eventForm.name !== "" ? eventForm.name : (approvalModal.event_name||"")} onChange={e=>setEventForm(f=>({...f,name:e.target.value}))} placeholder={approvalModal.event_name||"e.g. Annual Conference 2026"}
                    style={{ width:"100%", padding:"9px 12px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                </div>
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Event Date</label>
                  <input type="date" value={eventForm.deadline !== "" ? eventForm.deadline : (approvalModal.event_date||"")} onChange={e=>setEventForm(f=>({...f,deadline:e.target.value}))}
                    style={{ width:"100%", padding:"9px 12px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                </div>
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Phase</label>
                  <select value={eventForm.phase} onChange={e=>setEventForm(f=>({...f,phase:e.target.value}))}
                    style={{ width:"100%", padding:"9px 12px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                    {["Planning","Pre-Production","Production","Live","Post-Production"].map(p=><option key={p}>{p}</option>)}
                  </select>
                </div>
              </div>
            </div>

            {/* Create login toggle */}
            <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer", marginBottom:16 }}>
              <input type="checkbox" checked={createLogin} onChange={e=>setCreateLogin(e.target.checked)} />
              <span style={{ color:T.textSecondary, fontSize:13 }}>Create WorkRoom login for client</span>
            </label>
            {createLogin && (
              <div style={{ marginBottom:16 }}>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Temporary Password</label>
                <input value={loginPassword} onChange={e=>setLoginPassword(e.target.value)} placeholder="Set a password for client login"
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
              </div>
            )}

            <div style={{ display:"flex", gap:10 }}>
              <button onClick={async () => {
                setSaving(true);
                const name = clientForm.name || approvalModal.company;
                const email = clientForm.email || approvalModal.email;
                const phone = clientForm.phone || approvalModal.phone;
                const contact = clientForm.contact_name || approvalModal.contact_name;

                // 1. Create client in clients table
                const oppCountry = approvalModal.country || user?.country || activeCountry || 'Ghana';
                const pickedClient = existingClients.find(cl => cl.id === pickedClientId);
                const { data: newClient } = pickedClient ? { data: pickedClient } : await supabase.from("clients").insert({
                  name: contact || name, company: name, email, phone,
                  country: oppCountry,
                }).select().single();

                // 2. Create event if name provided
                const finalEventName = eventForm.name || approvalModal.event_name || "";
                const finalEventDate = eventForm.deadline || approvalModal.event_date || null;
                if (finalEventName && newClient) {
                  await supabase.from("projects").insert({
                    name: finalEventName, client: name, client_id: newClient.id,
                    event_date: finalEventDate, phase: eventForm.phase || "Planning",
                    status: "active", event_category: approvalModal.event_type || "Conference/Seminar",
                    country: oppCountry,
                  });
                }

                const { data: newEvent } = (eventForm.name || approvalModal.event_name) && newClient ? await supabase.from("projects").select("id").eq("client_id", newClient.id).eq("name", eventForm.name || approvalModal.event_name).order("created_at",{ascending:false}).limit(1).maybeSingle() : { data: null };

                // 3. Create login if requested
                if (createLogin && email) {
                  try {
                    const { data: authUser } = await supabase.auth.admin.createUser({ email, password: loginPassword || "Stretch@2026", email_confirm: true });
                    if (authUser?.user) {
                      await supabase.from("profiles").insert({ id: authUser.user.id, name, email, phone, role: "Client", company_name: name, country: oppCountry });
                    }
                  } catch(e) { console.error("Login creation error:", e); }
                }

                // 4. Mark opportunity as approved
                await supabase.from("leads").update({ approved: true, pending_approval: false, project_id: newEvent?.id || null, converted_to_event_at: newEvent ? new Date().toISOString() : null }).eq("id", approvalModal.id);
                setPickedClientId("");

                // Notify team
                const { data: vms } = await supabase.from("profiles").select("id").in("role",["Vendor Manager","Strategy & Events Lead"]);
                for (const vm of vms||[]) {
                  await supabase.from("notifications").insert({ user_id:vm.id, title:"New Client — "+name, message:"CEO approved "+name+" as a client. "+( eventForm.name ? "Event '"+eventForm.name+"' created." : ""), type:"rff" });
                }

                setSaving(false);
                setApprovalModal(null);
                setClientForm({ name:"", company:"", email:"", phone:"" });
                setEventForm({ name:"", deadline:"", phase:"Planning" });
                setCreateLogin(false);
                setLoginPassword("");
                load();
                alert(" Client created" + (eventForm.name ? " and event added" : "") + (createLogin ? " with login access" : "") + "!");
              }} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.teal},#10B981)`, border:"none", color:"#fff", padding:"12px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:14 }}>{saving?"Creating...":" Approve & Create Event"}</button>
              <button onClick={() => setApprovalModal(null)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"12px 18px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const SMTasksView = ({ user }) => {
  const [tasks, setTasks] = useState([]);
  const [modal, setModal] = useState(false);
  const [detailTask, setDetailTask] = useState(null);
  const [form, setForm] = useState({ name: "", notes: "", deadline: "", assigned_to: "", assigned_name: "" });
  const [members, setMembers] = useState([]);
  const [saving, setSaving] = useState(false);

  const canCreate = ["CEO", "Country Manager", "Sales & Marketing"].includes(user?.role);

  const load = async () => {
    const [t, m] = await Promise.all([
      supabase.from("tasks").select("*").eq("task_type", "sm").order("created_at", { ascending: false }),
      supabase.from("profiles").select("*").or('role.in.("CEO","Country Manager","Sales & Marketing"),has_sm_access.eq.true'),
      (!activeCountry || activeCountry === "All") ? supabase.from("client_payments").select("*").order("created_at",{ascending:false}) : supabase.from("client_payments").select("*").eq("country",activeCountry).order("created_at",{ascending:false}),
    ]);
    setTasks(t.data || []);
    setMembers(m.data || []);
  };

  useEffect(() => { load(); }, [user.id]);

  const handleCreate = async () => {
    if (!form.name) return;
    setSaving(true);
    await supabase.from("tasks").insert({
      name: form.name, notes: form.notes, deadline: form.deadline || null,
      assignee_id: form.assigned_to || null, assignee_name: form.assigned_name || "",
      assigned_by: user.id, status: "pending", progress: 0,
      task_type: "sm", visible_to_client: false,
    });
    setModal(false);
    setForm({ name: "", notes: "", deadline: "", assigned_to: "", assigned_name: "" });
    setSaving(false);
    load();
  };

  const handleUpdate = async () => {
    await supabase.from("tasks").update({
      progress: detailTask.progress, status: detailTask.status, notes: detailTask.notes,
    }).eq("id", detailTask.id);
    setDetailTask(null);
    load();
  };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Sales</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>S&M Tasks</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Sales & Marketing internal tasks</div>
        </div>
        {canCreate && <Btn onClick={() => setModal(true)}>+ New Task</Btn>}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Total Tasks", value: tasks.length, color: T.cyan },
          { label: "In Progress", value: tasks.filter(t => t.status === "in-progress").length, color: T.amber },
          { label: "Completed", value: tasks.filter(t => t.status === "completed").length, color: T.teal },
        ].map((k, i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 22, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 600, marginTop: 4, textTransform: "uppercase", letterSpacing: "0.06em" }}>{k.label}</div>
          </div>
        ))}
      </div>
      {tasks.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No S&M tasks yet</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>Tasks between CEO and Sales & Marketing appear here.</div>
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
          {tasks.map((t, idx) => {
            const pct = t.progress || 0;
            const barColor = t.status === "completed" ? T.teal : pct > 66 ? T.cyan : pct > 33 ? T.amber : T.magenta;
            return (
              <div key={t.id} onClick={() => setDetailTask({ ...t })} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px", cursor: "pointer", transition: "box-shadow 0.2s, border-color 0.2s" }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = `0 4px 24px ${T.cyan}12`; e.currentTarget.style.borderColor = T.cyan + "40"; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.borderColor = T.border; }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, marginBottom: 4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{t.name}</div>
                    {t.assignee_name && <div style={{ color: T.cyan, fontSize: 10, fontWeight: 700 }}>→ {t.assignee_name}</div>}
                    {t.notes && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 4, fontStyle: "italic", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t.notes}</div>}
                  </div>
                  <Badge status={t.status} />
                </div>
                <div style={{ height: 3, background: T.border + "44", borderRadius: 2, marginBottom: 6 }}>
                  <div style={{ height: "100%", width: pct + "%", background: barColor, borderRadius: 2 }} />
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ color: T.textMuted, fontSize: 10 }}>{pct}% complete</div>
                  {t.deadline && <div style={{ color: T.textMuted, fontSize: 10 }}>Due {t.deadline}</div>}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {modal && (
        <Modal title="New S&M Task" onClose={() => setModal(false)}>
          <Input label="Task Name" placeholder="e.g. Prepare pitch deck" value={form.name} onChange={v => setForm({ ...form, name: v })} />
          <Select label="Assign To" options={[{ value: "", label: "Select..." }, ...members.map(m => ({ value: m.id, label: m.name + " — " + m.role }))]}
            value={form.assigned_to}
            onChange={v => { const m = members.find(x => x.id === v); setForm({ ...form, assigned_to: v, assigned_name: m ? m.name : "" }); }} />
          <Input label="Deadline" type="date" value={form.deadline} onChange={v => setForm({ ...form, deadline: v })} />
          <div style={{ marginBottom: 16 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.06em" }}>Notes</div>
            <textarea value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })}
              placeholder="Task details..."
              style={{ width: "100%", minHeight: 80, background: T.bg, border: "1px solid " + T.border, borderRadius: 6, padding: 10, color: T.textPrimary, fontSize: 13, resize: "vertical", fontFamily: "inherit" }} />
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn onClick={handleCreate} disabled={saving}>{saving ? "Saving..." : "Create Task"}</Btn>
            <Btn variant="ghost" onClick={() => setModal(false)}>Cancel</Btn>
          </div>
        </Modal>
      )}
      {detailTask && (
        <Modal title="Update Task" onClose={() => setDetailTask(null)}>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 12 }}>{detailTask.name}</div>

          <Select label="Status" options={[
            { value: "pending", label: "Pending" },
            { value: "in-progress", label: "In Progress" },
            { value: "completed", label: "Completed" },
          ]} value={detailTask.status} onChange={v => setDetailTask({ ...detailTask, status: v })} />
          <div style={{ marginBottom: 16, marginTop: 8 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.06em" }}>Notes</div>
            <textarea value={detailTask.notes || ""} onChange={e => setDetailTask({ ...detailTask, notes: e.target.value })}
              style={{ width: "100%", minHeight: 80, background: T.bg, border: "1px solid " + T.border, borderRadius: 6, padding: 10, color: T.textPrimary, fontSize: 13, resize: "vertical", fontFamily: "inherit" }} />
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn onClick={handleUpdate}>Save</Btn>
            <Btn variant="ghost" onClick={() => setDetailTask(null)}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};

//  FEEDBACK VIEW 

const CalendarView = ({ user, onNavigate }) => {
  const [today] = useState(new Date());
  const [current, setCurrent] = useState(new Date());
  const [items, setItems] = useState([]);
  const [selectedDay, setSelectedDay] = useState(null);
  const [loading, setLoading] = useState(true);
  const [itinModal, setItinModal] = useState(false);
  const [itinForm, setItinForm] = useState({ title: "", week_start: "", rows: [{ date: "", time: "", company: "", action: "", notes: "" }] });
  const [itinSaving, setItinSaving] = useState(false);
  const [itineraries, setItineraries] = useState([]);
  const [viewItinModal, setViewItinModal] = useState(null);
  const [opportunities, setOpportunitys] = useState([]);
  const [opps, setOpps] = useState([]);

  const role = user?.role;
  const uid = user?.id;
  const email = user?.email;

  const typeColors = {
    task: "#00C8FF",
    event: "#00E5C8",
    opportunity: "#F59E0B",
    rff: "#E879F9",
    invoice: "#C9A84C",
    activity: "#3B7BFF",
    smtask: "#10B981",
    itinerary: "#F472B6",
  };

  const loadOpportunitysOpps = async () => {
    const [{ data: l }, { data: o }, { data: itins }] = await Promise.all([
      supabase.from("opportunities").select("id, company, contact_name, status"),
      supabase.from("leads").select("id, company, sector, status").neq("status","Converted"),
      uid ? supabase.from("itineraries").select("*").eq("created_by", uid).order("created_at", { ascending: false }) : Promise.resolve({ data: [] }),
    ]);
    setOpportunitys(l || []);
    setOpps(o || []);
    setItineraries(itins || []);
  };

  const load = async () => {
    setLoading(true);
    const all = [];

    //  TASKS 
    const taskQ = ["CEO","Country Manager"].includes(role)
      ? supabase.from("tasks").select("*")
      : supabase.from("tasks").select("*").eq("assignee_id", uid);
    const { data: tasks } = await taskQ;
    (tasks || []).forEach(t => {
      if (t.deadline) all.push({ id: "task-"+t.id, date: t.deadline.slice(0,10), type: "task", label: t.name, sub: t.assignee_name || "", status: t.status, nav: "tasks" });
    });

    //  EVENTS (projects) 
    if (!["Vendor"].includes(role)) {
      let evQ;
      if (["Client"].includes(role)) {
        const { data: clientData } = await supabase.from("clients").select("id").eq("email", email).single();
        if (clientData) evQ = await supabase.from("projects").select("*").eq("client_id", clientData.id);
      } else {
        evQ = await supabase.from("projects").select("*");
      }
      const events = evQ?.data || [];
      events.forEach(e => {
        if (e.event_date) all.push({ id: "ev-"+e.id+"-d", date: e.event_date, type: "event", label: e.name, sub: "Event Day", nav: "events" });
        if (e.deadline) all.push({ id: "ev-"+e.id+"-dl", date: e.deadline.slice(0,10), type: "event", label: e.name, sub: "Planning Deadline", nav: "events" });
      });
    }

    //  LEADS (CEO, Admin, Sales & Marketing) 
    if (["CEO","Country Manager","Sales & Marketing"].includes(role)) {
      const { data: opportunities } = await supabase.from("opportunities").select("*");
      (opportunities || []).forEach(l => {
        if (l.created_at) all.push({ id: "opportunity-"+l.id, date: l.created_at.slice(0,10), type: "opportunity", label: l.company, sub: "Opportunity Created · " + l.status, nav: "crm" });
        if (l.closed_date) all.push({ id: "opportunity-"+l.id+"-c", date: l.closed_date, type: "opportunity", label: l.company, sub: "Opportunity Closed · Won", nav: "crm" });
      });
    }

    //  RFFs 
    if (["CEO","Country Manager","Vendor Manager"].includes(role)) {
      const { data: rffs } = await supabase.from("rffs").select("*");
      (rffs || []).filter(r => r.deadline).forEach(r => {
        const dl = r.deadline.slice(0,10);
        all.push({ id: "rff-"+r.id, date: dl, type: "rff", label: r.title || "RFF", sub: "RFF Deadline · " + (r.event_name || r.status || ""), nav: "vendors" });
      });
    } else if (role === "Vendor") {
      const { data: assignments } = await supabase.from("rff_vendor_assignments").select("*, rffs(*)").eq("vendor_id", uid);
      (assignments || []).forEach(a => {
        const r = a.rffs;
        if (r?.deadline) all.push({ id: "rff-"+r.id, date: r.deadline.slice(0,10), type: "rff", label: r.title || "RFF", sub: "RFF Deadline · " + (a.status || ""), nav: "my-rffs" });
      });
    }

    //  S&M TASKS 
    if (["CEO","Country Manager","Sales & Marketing"].includes(role)) {
      const smQ = ["CEO","Country Manager"].includes(role)
        ? supabase.from("tasks").select("*").not("assignee_id","is",null)
        : supabase.from("tasks").select("*").eq("assignee_id", uid);
      const { data: smTasks } = await smQ;
      (smTasks || []).forEach(t => {
        if (t.deadline && !["CEO","Country Manager"].includes(role)) {
          all.push({ id: "smt-"+t.id, date: t.deadline.slice(0,10), type: "smtask", label: t.name, sub: "S&M Task", nav: "sm-tasks" });
        }
      });
    }

    //  CLIENT INVOICES 
    if (role === "Client") {
      const { data: clientData } = await supabase.from("clients").select("id").eq("email", email).single();
      if (clientData) {
        const { data: invs } = await supabase.from("client_invoices").select("*").eq("client_id", clientData.id);
        (invs || []).forEach(inv => {
          if (inv.created_at) all.push({ id: "inv-"+inv.id, date: inv.created_at.slice(0,10), type: "invoice", label: inv.title || "Invoice", sub: "Invoice", nav: "client-finance" });
        });
      }
    }

    //  FINANCE INVOICES 
    if (["CEO","Country Manager","Finance Manager"].includes(role)) {
      const { data: invs } = await supabase.from("invoices").select("*");
      (invs || []).forEach(inv => {
        if (inv.created_at) all.push({ id: "finv-"+inv.id, date: inv.created_at.slice(0,10), type: "invoice", label: inv.vendor_name || "Invoice", sub: "Invoice · " + (inv.status || ""), nav: "invoices" });
      });
    }

    //  ITINERARIES / FOLLOW-UPS 
    {
      const { data: itins } = await supabase.from("itineraries").select("*");
      (itins || []).forEach(itin => {
        // Parse items if stored as JSON string
        let items = itin.items;
        if (typeof items === "string") { try { items = JSON.parse(items); } catch(e) { items = []; } }
        (items || []).forEach((item, idx) => {
          if (item.date) all.push({
            id: "itin-"+itin.id+"-"+idx,
            date: item.date,
            type: "itinerary",
            color: "#8B5CF6",
            label: item.company || itin.title || "Follow-up",
            sub: itin.title + (item.time ? " · " + item.time : "") + (item.action ? " · " + item.action : ""),
            nav: "calendar"
          });
        });
      });
    }

    setItems(all);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const year = current.getFullYear();
  const month = current.getMonth();
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const monthName = current.toLocaleString("default", { month: "long" });
  const todayStr = today.toISOString().slice(0,10);

  const itemsByDate = {};
  items.forEach(item => {
    if (!itemsByDate[item.date]) itemsByDate[item.date] = [];
    itemsByDate[item.date].push(item);
  });

  const dayItems = selectedDay ? (itemsByDate[selectedDay] || []) : [];

  const typeLabel = { task: "Task", event: "Event", opportunity: "Opportunity", rff: "RFF", invoice: "Invoice", activity: "Activity", smtask: "S&M Task", itinerary: "Itinerary" };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Personal</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Calendar</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{items.length} items across all your activities</div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 10 }}>
          {["CEO","Sales & Marketing"].includes(role) && (
            <button onClick={() => setItinModal(true)} style={{ background: `linear-gradient(135deg, #F472B6, #E879F9)`, border: "none", color: "#fff", padding: "9px 18px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>+ Create Itinerary</button>
          )}
          {["CEO","Strategy & Events Lead","Vendor Manager","Sales & Marketing","Vendor"].includes(role) && (
            <button onClick={() => {
              const feedUrl = `https://workroom.stretchfield.com/api/calendar-feed?user_id=${uid}`;
              navigator.clipboard.writeText(feedUrl).then(() => alert(
                " Calendar URL copied!\n\n" +
                "iPhone / Mac Calendar:\n" +
                "1. Settings → Calendar → Accounts\n" +
                "2. Add Account → Other\n" +
                "3. Add Subscribed Calendar\n" +
                "4. Paste URL → Next → Save\n\n" +
                "Mac Calendar App:\n" +
                "1. File → New Calendar Subscription\n" +
                "2. Paste URL → Subscribe\n" +
                "3. Set refresh to Every Hour → OK\n\n" +
                "Google Calendar (Android):\n" +
                "1. Open calendar.google.com on desktop\n" +
                "2. Other Calendars → + → From URL\n" +
                "3. Paste URL → Add Calendar"
              ));
            }} style={{ background: `linear-gradient(135deg, ${T.teal}, ${T.cyan})`, border: "none", color: "#fff", padding: "9px 18px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Sync to Phone</button>
          )}
          {/* Legend */}
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "flex-end" }}>
            {Object.entries(typeColors).map(([type, color]) => (
              <div key={type} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: color }} />
                <span style={{ color: T.textMuted, fontSize: 10, textTransform: "capitalize" }}>{typeLabel[type]}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: selectedDay ? "1fr 320px" : "1fr", gap: 20 }}>
        {/* Calendar grid */}
        <div>
          {/* Month nav */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <button onClick={() => setCurrent(new Date(year, month - 1, 1))} style={{ background: T.surface, border: `1px solid ${T.border}`, color: T.textPrimary, width: 34, height: 34, borderRadius: 8, cursor: "pointer", fontSize: 16 }}>‹</button>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 18 }}>{monthName} {year}</div>
            <button onClick={() => setCurrent(new Date(year, month + 1, 1))} style={{ background: T.surface, border: `1px solid ${T.border}`, color: T.textPrimary, width: 34, height: 34, borderRadius: 8, cursor: "pointer", fontSize: 16 }}>›</button>
          </div>

          {/* Day headers */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4, marginBottom: 4 }}>
            {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d => (
              <div key={d} style={{ textAlign: "center", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", padding: "6px 0" }}>{d}</div>
            ))}
          </div>

          {/* Day cells */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4 }}>
            {Array.from({ length: firstDay }).map((_, i) => <div key={"e"+i} />)}
            {Array.from({ length: daysInMonth }).map((_, i) => {
              const day = i + 1;
              const dateStr = `${year}-${String(month+1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;
              const dayItems = itemsByDate[dateStr] || [];
              const isToday = dateStr === todayStr;
              const isSelected = dateStr === selectedDay;
              const isPast = dateStr < todayStr;

              return (
                <div key={day} onClick={() => setSelectedDay(isSelected ? null : dateStr)}
                  style={{
                    minHeight: 80, padding: "6px 8px", borderRadius: 8, cursor: "pointer",
                    background: isSelected ? T.cyan + "18" : isToday ? T.teal + "12" : T.surface,
                    border: `1px solid ${isSelected ? T.cyan + "60" : isToday ? T.teal + "40" : T.border}`,
                    opacity: isPast && !isToday ? 0.7 : 1,
                    transition: "all 0.15s",
                  }}
                  onMouseEnter={e => { if (!isSelected) e.currentTarget.style.borderColor = T.cyan + "40"; }}
                  onMouseLeave={e => { if (!isSelected) e.currentTarget.style.borderColor = isToday ? T.teal + "40" : T.border; }}>
                  <div style={{ color: isToday ? T.teal : T.textPrimary, fontWeight: isToday ? 900 : 600, fontSize: 12, marginBottom: 4 }}>
                    {isToday ? <span style={{ background: T.teal, color: "#fff", borderRadius: "50%", width: 20, height: 20, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 11 }}>{day}</span> : day}
                  </div>
                  {dayItems.slice(0,3).map((item, idx) => (
                    <div key={idx} style={{ background: typeColors[item.type] + "25", borderLeft: `2px solid ${typeColors[item.type]}`, borderRadius: 3, padding: "1px 4px", marginBottom: 2, fontSize: 9, color: typeColors[item.type], fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {item.label}
                    </div>
                  ))}
                  {dayItems.length > 3 && <div style={{ color: T.textMuted, fontSize: 9 }}>+{dayItems.length - 3} more</div>}
                </div>
              );
            })}
          </div>
        </div>

        {/* Day detail panel */}
        {selectedDay && (
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: 20, height: "fit-content", position: "sticky", top: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em" }}>Selected</div>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 16 }}>{new Date(selectedDay + "T12:00:00").toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" })}</div>
              </div>
              <button onClick={() => setSelectedDay(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, width: 28, height: 28, borderRadius: 6, cursor: "pointer", fontSize: 16 }}>×</button>
            </div>

            {dayItems.length === 0 ? (
              <div style={{ textAlign: "center", padding: "30px 0", color: T.textMuted, fontSize: 13 }}>Nothing scheduled</div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {dayItems.map((item, idx) => (
                  <div key={idx} onClick={() => { if (onNavigate) onNavigate(item.nav); }}
                    style={{ padding: "10px 12px", background: T.bg, border: `1px solid ${typeColors[item.type]}30`, borderLeft: `3px solid ${typeColors[item.type]}`, borderRadius: 8, cursor: onNavigate ? "pointer" : "default", transition: "box-shadow 0.15s" }}
                    onMouseEnter={e => e.currentTarget.style.boxShadow = `0 2px 12px ${typeColors[item.type]}20`}
                    onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13, marginBottom: 2 }}>{item.label}</div>
                        <div style={{ color: T.textMuted, fontSize: 11 }}>{item.sub}</div>
                      </div>
                      <span style={{ background: typeColors[item.type] + "20", color: typeColors[item.type], borderRadius: 20, padding: "2px 8px", fontSize: 9, fontWeight: 800, textTransform: "uppercase", flexShrink: 0, marginLeft: 8 }}>{typeLabel[item.type]}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/*  Itineraries list below calendar  */}
      {["CEO","Sales & Marketing"].includes(role) && itineraries.length > 0 && (
        <div style={{ marginTop: 32 }}>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 12 }}>Your Itineraries</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 12 }}>
            {itineraries.map(itin => (
              <div key={itin.id} onClick={() => setViewItinModal(itin)}
                style={{ background: T.surface, border: `1px solid ${T.border}`, borderTop: "2px solid #F472B6", borderRadius: 10, padding: "14px 16px", cursor: "pointer" }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 20px #F472B620"}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14, marginBottom: 4 }}>{itin.title}</div>
                <div style={{ color: T.textMuted, fontSize: 11 }}>Week of {new Date(itin.week_start + "T12:00:00").toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}</div>
                <div style={{ color: "#F472B6", fontSize: 11, marginTop: 6, fontWeight: 700 }}>{(itin.items || []).length} stops</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/*  Create Itinerary Modal  */}
      {itinModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setItinModal(false)}>
          <div style={{ background: T.surface, border: `1px solid #F472B640`, borderRadius: 16, width: "100%", maxWidth: 800, maxHeight: "90vh", overflow: "auto", padding: 28, boxShadow: "0 24px 80px rgba(0,0,0,0.5)" }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 20, marginBottom: 4 }}>Create Weekly Itinerary</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>Build a weekly outreach or visit schedule from your opportunities and leads</div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 20 }}>
              <div>
                <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Itinerary Title</label>
                <input value={itinForm.title} onChange={e => setItinForm({ ...itinForm, title: e.target.value })} placeholder="e.g. Banking Sector Outreach Week" style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Week Starting</label>
                <input type="date" value={itinForm.week_start} onChange={e => setItinForm({ ...itinForm, week_start: e.target.value })} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
              </div>
            </div>

            {/* Rows */}
            <div style={{ marginBottom: 16 }}>
              <div style={{ display: "grid", gridTemplateColumns: "120px 80px 1fr 1fr 1fr 32px", gap: 8, marginBottom: 8 }}>
                {["Date","Time","Company","Action","Notes",""].map((h, i) => (
                  <div key={i} style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>{h}</div>
                ))}
              </div>
              {itinForm.rows.map((row, idx) => (
                <div key={idx} style={{ display: "grid", gridTemplateColumns: "120px 80px 1fr 1fr 1fr 32px", gap: 8, marginBottom: 8 }}>
                  <input type="date" value={row.date} onChange={e => { const rows = [...itinForm.rows]; rows[idx].date = e.target.value; setItinForm({ ...itinForm, rows }); }} style={{ padding: "7px 8px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                  <input value={row.time} onChange={e => { const rows = [...itinForm.rows]; rows[idx].time = e.target.value; setItinForm({ ...itinForm, rows }); }} placeholder="9:00am" style={{ padding: "7px 8px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                  <select value={row.company} onChange={e => { const rows = [...itinForm.rows]; rows[idx].company = e.target.value; setItinForm({ ...itinForm, rows }); }} style={{ padding: "7px 8px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: row.company ? T.textPrimary : T.textMuted, fontSize: 12, fontFamily: "inherit", outline: "none" }}>
                    <option value="">Select company...</option>
                    {opportunities.length > 0 && <optgroup label=" Opportunitys ">{opportunities.map(l => <option key={"l"+l.id} value={l.company}>{l.company}</option>)}</optgroup>}
                    {opps.length > 0 && <optgroup label=" Leads ">{opps.map(o => <option key={"o"+o.id} value={o.company}>{o.company}</option>)}</optgroup>}
                  </select>
                  <input value={row.action} onChange={e => { const rows = [...itinForm.rows]; rows[idx].action = e.target.value; setItinForm({ ...itinForm, rows }); }} placeholder="e.g. Cold call, Site visit" style={{ padding: "7px 8px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                  <input value={row.notes} onChange={e => { const rows = [...itinForm.rows]; rows[idx].notes = e.target.value; setItinForm({ ...itinForm, rows }); }} placeholder="Notes..." style={{ padding: "7px 8px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                  <button onClick={() => { const rows = itinForm.rows.filter((_, i) => i !== idx); setItinForm({ ...itinForm, rows: rows.length ? rows : [{ date: "", time: "", company: "", action: "", notes: "" }] }); }} style={{ background: T.red + "18", border: `1px solid ${T.red}30`, color: T.red, borderRadius: 6, cursor: "pointer", fontSize: 14, fontWeight: 700 }}>×</button>
                </div>
              ))}
              <button onClick={() => setItinForm({ ...itinForm, rows: [...itinForm.rows, { date: "", time: "", company: "", action: "", notes: "" }] })} style={{ background: "none", border: `1px dashed ${T.border}`, color: T.textMuted, padding: "7px 16px", borderRadius: 6, cursor: "pointer", fontSize: 12, width: "100%", marginTop: 4 }}>+ Add Row</button>
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={async () => {
                if (!itinForm.title || !itinForm.week_start) return;
                setItinSaving(true);
                const validRows = itinForm.rows.filter(r => r.date && r.company);
                await supabase.from("itineraries").insert({
                  title: itinForm.title,
                  week_start: itinForm.week_start,
                  created_by: uid,
                  created_by_name: user?.name || "",
                  items: validRows,
                });
                setItinSaving(false);
                setItinModal(false);
                setItinForm({ title: "", week_start: "", rows: [{ date: "", time: "", company: "", action: "", notes: "" }] });
                load();
                loadOpportunitysOpps();
              }} disabled={itinSaving || !itinForm.title || !itinForm.week_start} style={{ background: "linear-gradient(135deg, #F472B6, #E879F9)", border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 13, opacity: (!itinForm.title || !itinForm.week_start) ? 0.5 : 1 }}>{itinSaving ? "Saving..." : "Save & Add to Calendar"}</button>
              <button onClick={() => setItinModal(false)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/*  View Itinerary Modal  */}
      {viewItinModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setViewItinModal(null)}>
          <div style={{ background: T.surface, border: `1px solid #F472B640`, borderRadius: 16, width: "100%", maxWidth: 700, maxHeight: "85vh", overflow: "auto", padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
              <div>
                <div style={{ color: "#F472B6", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 4 }}>Itinerary</div>
                <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 20 }}>{viewItinModal.title}</div>
                <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Week of {new Date(viewItinModal.week_start + "T12:00:00").toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
              </div>
              <button onClick={() => setViewItinModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, width: 32, height: 32, borderRadius: 8, cursor: "pointer", fontSize: 18, display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {(viewItinModal.items || []).sort((a,b) => (a.date > b.date ? 1 : -1)).map((item, idx) => (
                <div key={idx} style={{ display: "grid", gridTemplateColumns: "140px 70px 1fr 1fr", gap: 12, padding: "12px 14px", background: T.bg, border: `1px solid ${T.border}`, borderLeft: "3px solid #F472B6", borderRadius: 8 }}>
                  <div><div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>Date</div><div style={{ color: T.textPrimary, fontSize: 12, fontWeight: 700 }}>{new Date(item.date + "T12:00:00").toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" })}</div></div>
                  <div><div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>Time</div><div style={{ color: T.textPrimary, fontSize: 12 }}>{item.time || "—"}</div></div>
                  <div><div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>Company</div><div style={{ color: "#F472B6", fontSize: 12, fontWeight: 700 }}>{item.company}</div><div style={{ color: T.textMuted, fontSize: 11 }}>{item.action}</div></div>
                  <div><div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>Notes</div><div style={{ color: T.textSecondary, fontSize: 12 }}>{item.notes || "—"}</div></div>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 16, display: "flex", gap: 10 }}>
              <button onClick={async () => { if (!window.confirm("Delete this itinerary?")) return; await supabase.from("itineraries").delete().eq("id", viewItinModal.id); setViewItinModal(null); loadOpportunitysOpps(); load(); }} style={{ background: T.red + "18", border: `1px solid ${T.red}40`, color: T.red, padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>Delete Itinerary</button>
              <button onClick={() => setViewItinModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


const EventTypeAnalysisView = ({ user }) => {
  const [rffs, setRffs] = useState([]);
  const [pos, setPOs] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [periodType, setPeriodType] = useState("year");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(true);

  const eventTypes = [
    { key: "Conference/Seminar", code: "CS", color: "#00C8FF", label: "Conference / Seminar" },
    { key: "Product Launch", code: "PL", color: "#E879F9", label: "Product Launch" },
    { key: "Awards Ceremony", code: "AWD", color: "#F59E0B", label: "Awards Ceremony" },
    { key: "Corporate Party", code: "CP", color: "#10B981", label: "Corporate Party" },
    { key: "Other", code: "OTH", color: "#8B5CF6", label: "Other" },
  ];

  const load = async () => {
    setLoading(true);
    const [{ data: rf }, { data: po }, { data: inv }] = await Promise.all([
      (!activeCountry || activeCountry === "All") ? supabase.from("rffs").select("*").not("event_type","is",null) : supabase.from("rffs").select("*").not("event_type","is",null).eq("country",activeCountry),
      (!activeCountry || activeCountry === "All") ? supabase.from("purchase_orders").select("*") : supabase.from("purchase_orders").select("*").eq("country",activeCountry),
      (!activeCountry || activeCountry === "All") ? supabase.from("vendor_invoices").select("*") : supabase.from("vendor_invoices").select("*").eq("country",activeCountry),
    ]);
    setRffs(rf || []);
    setPOs(po || []);
    setInvoices(inv || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const getDateRange = () => {
    if (periodType === "year") {
      return { from: `${selectedYear}-01-01`, to: `${selectedYear}-12-31` };
    }
    return { from: startDate, to: endDate };
  };

  const { from, to } = getDateRange();

  const filteredRffs = rffs.filter(r => {
    if (!r.created_at) return false;
    const d = r.created_at.slice(0, 10);
    return (!from || d >= from) && (!to || d <= to);
  });

  const totalRffs = filteredRffs.length;
  const totalBudget = filteredRffs.reduce((s, r) => s + (r.amount || 0), 0);

  const typeStats = eventTypes.map(et => {
    const typeRffs = filteredRffs.filter(r => r.event_type === et.key);
    const typePOs = pos.filter(p => p.internal_po_number?.includes(`/ST/${et.code}/`));
    const typeInvoices = invoices.filter(i => i.invoice_number?.includes(`/ST/${et.code}/`));
    const totalAmt = typeRffs.reduce((s, r) => s + (r.amount || 0), 0);
    const pct = totalRffs > 0 ? Math.round((typeRffs.length / totalRffs) * 100) : 0;
    return { ...et, count: typeRffs.length, pct, totalAmt, poCount: typePOs.length, invoiceCount: typeInvoices.length, rffs: typeRffs };
  });

  const years = ["2024", "2025", "2026", "2027", "2028"];

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>CEO</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Event Type Analysis</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Distribution of RFFs, POs and invoices by event category</div>
      </div>

      {/* Period Selector */}
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "16px 20px", marginBottom: 24 }}>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ display: "flex", gap: 6 }}>
            {["year", "custom"].map(pt => (
              <button key={pt} onClick={() => setPeriodType(pt)} style={{ padding: "6px 16px", borderRadius: 20, cursor: "pointer", fontSize: 11, fontWeight: 700, border: `1px solid ${periodType === pt ? T.cyan : T.border}`, background: periodType === pt ? T.cyan+"20" : "none", color: periodType === pt ? T.cyan : T.textMuted, textTransform: "uppercase" }}>{pt === "year" ? "By Year" : "Custom Range"}</button>
            ))}
          </div>
          {periodType === "year" ? (
            <select value={selectedYear} onChange={e => setSelectedYear(e.target.value)} style={{ padding: "7px 14px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
              {years.map(y => <option key={y}>{y}</option>)}
            </select>
          ) : (
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={{ padding: "7px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }} />
              <span style={{ color: T.textMuted }}>to</span>
              <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} style={{ padding: "7px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }} />
            </div>
          )}
          <div style={{ marginLeft: "auto", color: T.textMuted, fontSize: 12 }}>{filteredRffs.length} RFFs in period</div>
        </div>
      </div>

      {/* Summary KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Total RFFs", value: totalRffs, color: T.cyan },
          { label: "Total POs", value: pos.length, color: T.teal },
          { label: "Total Invoices", value: invoices.length, color: T.amber },
          { label: "Most Active Type", value: typeStats.sort((a,b)=>b.count-a.count)[0]?.label?.split("/")[0] || "—", color: "#10B981" },
        ].map((k,i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: i===3?16:20, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginTop: 4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Distribution Chart */}
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "20px 24px", marginBottom: 24 }}>
        <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 20 }}>RFF Distribution by Event Type</div>
        {typeStats.sort((a,b) => b.count - a.count).map((et, i) => (
          <div key={et.key} style={{ marginBottom: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 12, height: 12, borderRadius: "50%", background: et.color, flexShrink: 0 }} />
                <span style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{et.label}</span>
                <span style={{ background: et.color+"18", color: et.color, borderRadius: 20, padding: "1px 8px", fontSize: 10, fontWeight: 800 }}>ST/{et.code}</span>
              </div>
              <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
                <span style={{ color: T.textMuted, fontSize: 12 }}>{et.count} RFF{et.count!==1?"s":""}</span>
                <span style={{ color: et.color, fontWeight: 800, fontSize: 14 }}>{et.pct}%</span>
              </div>
            </div>
            <div style={{ height: 28, background: T.border+"44", borderRadius: 6, overflow: "hidden", position: "relative" }}>
              <div style={{ height: "100%", width: `${et.pct}%`, background: `linear-gradient(90deg, ${et.color}, ${et.color}99)`, borderRadius: 6, transition: "width 0.6s ease", minWidth: et.count > 0 ? 4 : 0 }} />
              {et.count > 0 && <div style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#fff", fontSize: 11, fontWeight: 700 }}>{et.count} RFF{et.count!==1?"s":""}</div>}
            </div>
          </div>
        ))}
      </div>

      {/* Detailed breakdown table */}
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden", marginBottom: 24 }}>
        <div style={{ padding: "16px 20px", borderBottom: `1px solid ${T.border}` }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Detailed Breakdown</div>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
              {["Event Type","Code Prefix","RFFs","POs Created","Invoices","% Share"].map(h => (
                <th key={h} style={{ padding: "10px 16px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {typeStats.map((et, i) => (
              <tr key={et.key} style={{ borderBottom: i < typeStats.length-1 ? `1px solid ${T.border}44` : "none" }}
                onMouseEnter={e => e.currentTarget.style.background = T.bg}
                onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                <td style={{ padding: "12px 16px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ width: 10, height: 10, borderRadius: "50%", background: et.color }} />
                    <span style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{et.label}</span>
                  </div>
                </td>
                <td style={{ padding: "12px 16px" }}><span style={{ background: et.color+"18", color: et.color, borderRadius: 20, padding: "2px 10px", fontSize: 10, fontWeight: 800 }}>ST/{et.code}/YY/###</span></td>
                <td style={{ padding: "12px 16px", color: et.count > 0 ? T.textPrimary : T.textMuted, fontWeight: et.count > 0 ? 700 : 400, fontSize: 13 }}>{et.count}</td>
                <td style={{ padding: "12px 16px", color: T.textPrimary, fontSize: 13 }}>{et.poCount}</td>
                <td style={{ padding: "12px 16px", color: T.textPrimary, fontSize: 13 }}>{et.invoiceCount}</td>
                <td style={{ padding: "12px 16px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ width: 60, height: 6, background: T.border+"44", borderRadius: 3, overflow: "hidden" }}>
                      <div style={{ height: "100%", width: `${et.pct}%`, background: et.color, borderRadius: 3 }} />
                    </div>
                    <span style={{ color: et.color, fontWeight: 800, fontSize: 12 }}>{et.pct}%</span>
                  </div>
                </td>
              </tr>
            ))}
            {/* Totals row */}
            <tr style={{ background: T.bg, borderTop: `2px solid ${T.border}` }}>
              <td style={{ padding: "12px 16px", color: T.textPrimary, fontWeight: 900, fontSize: 13 }}>TOTAL</td>
              <td style={{ padding: "12px 16px" }} />
              <td style={{ padding: "12px 16px", color: T.cyan, fontWeight: 900, fontSize: 13 }}>{totalRffs}</td>
              <td style={{ padding: "12px 16px", color: T.cyan, fontWeight: 900, fontSize: 13 }}>{pos.length}</td>
              <td style={{ padding: "12px 16px", color: T.cyan, fontWeight: 900, fontSize: 13 }}>{invoices.length}</td>
              <td style={{ padding: "12px 16px", color: T.cyan, fontWeight: 900, fontSize: 13 }}>100%</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Monthly trend for selected year */}
      {periodType === "year" && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "20px 24px" }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 16 }}>Monthly Activity — {selectedYear}</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(12,1fr)", gap: 6 }}>
            {Array.from({length:12},(_,i)=>i+1).map(month => {
              const monthRffs = filteredRffs.filter(r => {
                const d = new Date(r.created_at);
                return d.getFullYear() === parseInt(selectedYear) && d.getMonth()+1 === month;
              });
              const maxCount = Math.max(...Array.from({length:12},(_,i)=>filteredRffs.filter(r=>new Date(r.created_at).getMonth()===i).length), 1);
              const heightPct = monthRffs.length > 0 ? Math.max((monthRffs.length/maxCount)*80, 10) : 0;
              const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
              return (
                <div key={month} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                  <div style={{ height: 80, display: "flex", alignItems: "flex-end", width: "100%" }}>
                    <div style={{ width: "100%", height: `${heightPct}%`, background: monthRffs.length > 0 ? `linear-gradient(180deg, ${T.cyan}, ${T.teal})` : T.border+"44", borderRadius: "4px 4px 0 0", transition: "height 0.4s ease" }} />
                  </div>
                  {monthRffs.length > 0 && <div style={{ color: T.cyan, fontSize: 10, fontWeight: 800 }}>{monthRffs.length}</div>}
                  <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 600 }}>{months[month-1]}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};




const StrategyMapView = ({ user }) => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [brief, setBrief] = useState(null);
  const [scorecard, setScorecard] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    const evQ = (!activeCountry || activeCountry === "All") ? supabase.from("projects").select("*").order("event_date",{ascending:false}) : supabase.from("projects").select("*").eq("country",activeCountry).order("event_date",{ascending:false});
    const { data: ev } = await evQ;
    setEvents(ev || []);
  };

  useEffect(() => { load(); }, []);

  const loadEventData = async (eventId) => {
    setLoading(true);
    const [{ data: b }, { data: sc }] = await Promise.all([
      supabase.from("event_impact_briefs").select("*").eq("project_id", eventId).single(),
      supabase.from("event_scorecards").select("*").eq("project_id", eventId).single(),
    ]);
    setBrief(b || null);
    setScorecard(sc || null);
    setLoading(false);
  };

  const archetype = selectedEvent ? (EVENT_ARCHETYPES[selectedEvent.event_category] || EVENT_ARCHETYPES["Conference/Seminar"]) : null;

  const toolStatus = (val) => {
    if (val === "Yes") return { color: "#10B981", icon: "" };
    if (val === "No") return { color: T.red, icon: "" };
    return { color: T.textMuted, icon: "—" };
  };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Strategic</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Strategy Map</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Event impact briefs and strategic parameters to inform your planning</div>
      </div>

      {/* Event selector */}
      <div style={{ marginBottom: 24 }}>
        <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 8 }}>Select Event</label>
        <select value={selectedEvent?.id || ""} onChange={e => {
          const ev = events.find(x => x.id === e.target.value);
          setSelectedEvent(ev || null);
          if (ev) loadEventData(ev.id);
        }} style={{ width: "100%", maxWidth: 400, padding: "10px 14px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
          <option value="">Choose an event...</option>
          {events.map(ev => (
            <option key={ev.id} value={ev.id}>{ev.name} {ev.event_category ? `— ${ev.event_category}` : ""}</option>
          ))}
        </select>
      </div>

      {!selectedEvent && (
        <div style={{ textAlign: "center", padding: "60px 0", background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Select an event to view its strategy map</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>The strategy map shows the impact brief, KPIs and scorecard parameters defined by the CEO.</div>
        </div>
      )}

      {selectedEvent && loading && (
        <div style={{ textAlign: "center", padding: 40, color: T.textMuted }}>Loading strategy data...</div>
      )}

      {selectedEvent && !loading && (
        <div>
          {/* Event header card */}
          <div style={{ background: archetype ? archetype.color+"12" : T.surface, border: `1px solid ${archetype ? archetype.color+"40" : T.border}`, borderRadius: 12, padding: "20px 24px", marginBottom: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div>
                <div style={{ color: archetype?.color || T.cyan, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 4 }}>{selectedEvent.event_category || "Event"}</div>
                <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 20 }}>{selectedEvent.name}</div>
                <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{selectedEvent.client} · {selectedEvent.phase}</div>
                {selectedEvent.event_date && <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}> {new Date(selectedEvent.event_date+"T12:00:00").toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>}
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 4 }}>Completion</div>
                <div style={{ color: archetype?.color || T.cyan, fontWeight: 900, fontSize: 24 }}>
                  {(() => {
                    const priorityWeight = { Critical: 4, High: 3, Medium: 2, Low: 1 };
                    const statusPct = { pending: 0, 'in-progress': 50, completed: 100, done: 100 };
                    const eTasks = allTasks ? allTasks.filter(t => t.project_id === selectedEvent.id) : [];
                    if (eTasks.length === 0) return (selectedEvent.completion || 0) + '%';
                    const totalW = eTasks.reduce((s,t) => s+(priorityWeight[t.priority]||2), 0);
                    const earnedW = eTasks.reduce((s,t) => s+(priorityWeight[t.priority]||2)*((statusPct[t.status]||0)/100), 0);
                    return Math.round((earnedW/totalW)*100) + '%';
                  })()}
                </div>
              </div>
            </div>
          </div>

          {!brief && (
            <div style={{ background: T.amber+"12", border: `1px solid ${T.amber}30`, borderRadius: 10, padding: "14px 18px", marginBottom: 20 }}>
              <div style={{ color: T.amber, fontWeight: 700, fontSize: 13 }}> No Impact Brief set for this event yet</div>
              <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>The CEO or Strategy Opportunity needs to complete the Impact Brief in the Impact Intelligence tab first.</div>
            </div>
          )}

          {brief && (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>

              {/* Impact Objective */}
              <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px" }}>
                <div style={{ color: archetype?.color || T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}> Impact Objective</div>
                {brief.impact_objective && (
                  <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "12px 14px", marginBottom: 10 }}>
                    <div style={{ color: T.textPrimary, fontSize: 13, lineHeight: 1.6 }}>{brief.impact_objective}</div>
                  </div>
                )}
                {brief.target_audience && <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 4 }}><strong style={{ color: T.textSecondary }}>Who:</strong> {brief.target_audience}</div>}
                {brief.observable_signal && <div style={{ color: T.textMuted, fontSize: 12 }}><strong style={{ color: T.textSecondary }}>Signal:</strong> {brief.observable_signal}</div>}
              </div>

              {/* Measurement Tools */}
              <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px" }}>
                <div style={{ color: archetype?.color || T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}> Measurement Tools</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  {[
                    ["Pre-Event Survey", brief.tool_pre_survey],
                    ["Digital Tracking", brief.tool_digital_tracking],
                    ["Live Monitoring", brief.tool_live_monitoring],
                    ["Post-Event Survey", brief.tool_post_survey],
                    ["30-Day Follow-Up", brief.tool_30day_survey],
                    ["90-Day Tracking", brief.tool_90day_tracking],
                    ["Social Listening", brief.tool_social_listening],
                    ["Commercial Data", brief.tool_commercial_data],
                  ].map(([label, val]) => {
                    const s = toolStatus(val);
                    return (
                      <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px 0", borderBottom: `1px solid ${T.border}33` }}>
                        <span style={{ color: T.textSecondary, fontSize: 12 }}>{label}</span>
                        <span style={{ color: s.color, fontSize: 12, fontWeight: 700 }}>{s.icon} {val || "—"}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          {/* KPIs */}
          {brief && (brief.kpi1_name || brief.kpi2_name || brief.kpi3_name) && (
            <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px", marginBottom: 20 }}>
              <div style={{ color: archetype?.color || T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}> Success KPIs</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
                {[1,2,3].map(n => {
                  const name = brief[`kpi${n}_name`];
                  const target = brief[`kpi${n}_target`];
                  const method = brief[`kpi${n}_method`];
                  const timing = brief[`kpi${n}_timing`];
                  if (!name) return null;
                  return (
                    <div key={n} style={{ background: T.bg, border: `1px solid ${archetype?.color || T.cyan}25`, borderTop: `2px solid ${archetype?.color || T.cyan}`, borderRadius: 8, padding: "12px 14px" }}>
                      <div style={{ color: archetype?.color || T.cyan, fontSize: 10, fontWeight: 800, textTransform: "uppercase", marginBottom: 6 }}>KPI {n}</div>
                      <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{name}</div>
                      <div style={{ color: "#10B981", fontSize: 12, fontWeight: 700, marginBottom: 4 }}>Target: {target}</div>
                      <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 2 }}>Method: {method}</div>
                      <div style={{ color: T.textMuted, fontSize: 11 }}>When: {timing}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Scorecard dimensions */}
          {archetype && (
            <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px", marginBottom: 20 }}>
              <div style={{ color: archetype.color, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}> Impact Dimensions — What We Are Measuring</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {archetype.dimensions.map((dim, i) => {
                  const score = scorecard ? scorecard[dim.key+"_score"] : null;
                  return (
                    <div key={dim.key} style={{ display: "flex", alignItems: "center", gap: 14, padding: "10px 14px", background: T.bg, borderRadius: 8, border: `1px solid ${T.border}` }}>
                      <div style={{ width: 36, height: 36, borderRadius: "50%", background: archetype.color+"20", border: `2px solid ${archetype.color}40`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <span style={{ color: archetype.color, fontWeight: 900, fontSize: 12 }}>{Math.round(dim.weight*100)}%</span>
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{dim.label}</div>
                        <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{dim.description}</div>
                        <div style={{ color: archetype.color, fontSize: 10, marginTop: 2 }}>Benchmark: {dim.benchmark}</div>
                      </div>
                      {score !== null && score !== undefined && parseFloat(score) > 0 ? (
                        <div style={{ textAlign: "right", flexShrink: 0 }}>
                          <div style={{ color: getScoreLabel(parseFloat(score)).color, fontWeight: 900, fontSize: 20 }}>{score}</div>
                          <div style={{ color: T.textMuted, fontSize: 9 }}>/10</div>
                        </div>
                      ) : (
                        <div style={{ color: T.textMuted, fontSize: 11, flexShrink: 0 }}>Not scored</div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Story intent */}
          {brief && (brief.story_before || brief.story_design || brief.story_outcome) && (
            <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px" }}>
              <div style={{ color: archetype?.color || T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}> Impact Story We Are Engineering</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {brief.story_before && <div style={{ background: T.bg, borderLeft: `3px solid ${T.red}`, borderRadius: 6, padding: "10px 14px" }}><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>Before Stretchfield</div><div style={{ color: T.textSecondary, fontSize: 13 }}>{brief.story_before}</div></div>}
                {brief.story_design && <div style={{ background: T.bg, borderLeft: `3px solid ${archetype?.color||T.cyan}`, borderRadius: 6, padding: "10px 14px" }}><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>What We Are Engineering</div><div style={{ color: T.textSecondary, fontSize: 13 }}>{brief.story_design}</div></div>}
                {brief.story_outcome && <div style={{ background: T.bg, borderLeft: `3px solid #10B981`, borderRadius: 6, padding: "10px 14px" }}><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>Intended Outcome</div><div style={{ color: T.textSecondary, fontSize: 13 }}>{brief.story_outcome}</div></div>}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};


const STRETCHFIELD_DIMENSIONS = [
  {
    key: "revenue_sales",
    label: "Revenue & Sales Impact",
    icon: "",
    weight: 0.25,
    description: "Sales uplift, lead generation, conversion rates post-event",
    metrics: ["Sales Uplift %", "Leads Generated", "Conversion Rate %"],
    benchmark: ">10% sales uplift within 90 days",
  },
  {
    key: "market_share",
    label: "Market Share & Penetration",
    icon: "",
    weight: 0.20,
    description: "Market visibility gain, new customers reached, channel expansion",
    metrics: ["Market Share Change %", "New Customers Reached", "New Regions/Channels"],
    benchmark: ">5% market visibility improvement",
  },
  {
    key: "brand_awareness",
    label: "Brand Impact & Awareness",
    icon: "",
    weight: 0.20,
    description: "Brand recall, media reach, share of voice vs competitors",
    metrics: ["Brand Recall %", "Media Impressions", "Share of Voice Score"],
    benchmark: ">70% aided brand recall post-event",
  },
  {
    key: "org_performance",
    label: "Organisational Performance",
    icon: "",
    weight: 0.15,
    description: "Employee clarity, adoption rates, engagement & retention",
    metrics: ["Goal Clarity %", "Tool Adoption Rate %", "Engagement Score"],
    benchmark: ">80% employees report greater clarity",
  },
  {
    key: "innovation_partnerships",
    label: "Innovation & Partnerships",
    icon: "",
    weight: 0.10,
    description: "Partnerships formed, innovation adoption, investor commitments",
    metrics: ["Partnerships Formed", "New Initiatives", "Investor Commitments"],
    benchmark: ">2 new partnerships or initiatives",
  },
  {
    key: "roi_roe",
    label: "ROI / ROE",
    icon: "",
    weight: 0.10,
    description: "Return on Investment and Return on Engagement",
    metrics: ["ROI %", "ROE Score", "Event Cost vs Revenue Impact"],
    benchmark: "Positive ROI within 90 days",
  },
];

const EVENT_ARCHETYPES = {
  "Conference/Seminar": {
    color: "#00C8FF",
    code: "CS",
    dimensions: [
      { key: "behavioural_change", label: " Behavioural Change", weight: 0.25, description: "Commitment durability — % opportunityers executing summit commitments", benchmark: ">80% recall + active execution at 30 days" },
      { key: "emotional_impact", label: " Emotional Impact", weight: 0.20, description: "Strategic alignment score — clarity on strategic priorities", benchmark: "+3 point improvement in clarity score" },
      { key: "data_engagement", label: " Data & Engagement Quality", weight: 0.20, description: "Scientific engagement depth — avg dwell time on content", benchmark: ">5 min avg dwell time" },
      { key: "connection", label: " Connection & Community", weight: 0.15, description: "Cross-team collaboration — new cross-functional initiatives", benchmark: ">2 new cross-team initiatives per dept" },
      { key: "brand_visibility", label: " Brand Visibility", weight: 0.10, description: "Knowledge lift — recall of key data points post-event", benchmark: ">60% correct answer rate post vs <30% pre" },
      { key: "commercial", label: " Commercial Outcome", weight: 0.10, description: "Decision quality — speed and quality of post-summit decisions", benchmark: "Reduction in decision reversal rate" },
    ],
    kpiSuggestions: [
      { name: "Strategic Alignment Score", target: "+3 points on 10-point scale", method: "Pre/post alignment survey", timing: "Pre-event + event close" },
      { name: "Commitment Execution Rate", target: ">80% at 30 days", method: "Follow-up survey + manager confirmation", timing: "30 & 90 days post-event" },
      { name: "Cross-team Initiatives", target: ">2 per department", method: "HR/project management data", timing: "60 days post-event" },
    ],
    tools: { pre_survey: "Yes", digital_tracking: "No", live_monitoring: "Yes", post_survey: "Yes", day30_survey: "Yes", day90_tracking: "Yes", social_listening: "No", commercial_data: "Yes" },
    storyTemplate: { before: "struggled with strategic misalignment and siloed decision-making", design: "immersive opportunityership summit with structured commitment frameworks", outcome: "strategic alignment score improved and new cross-team initiatives launched" }
  },
  "Product Launch": {
    color: "#E879F9",
    code: "PL",
    dimensions: [
      { key: "behavioural_change", label: " Behavioural Change", weight: 0.25, description: "Intent to purchase/try — self-reported intent shift pre to post", benchmark: "+2 points on intent scale" },
      { key: "emotional_impact", label: " Emotional Impact", weight: 0.20, description: "Brand recall — % audience recalling 3+ product messages unaided", benchmark: ">65% unaided recall at 24hrs" },
      { key: "data_engagement", label: " Data & Engagement", weight: 0.20, description: "Social amplification — organic content generated by attendees", benchmark: "≥3 organic posts per 10 attendees" },
      { key: "connection", label: " Connection & Community", weight: 0.15, description: "Opportunity conversion — commercial pipeline from event", benchmark: "≥15% of qualified attendees enter pipeline" },
      { key: "brand_visibility", label: " Brand Visibility", weight: 0.10, description: "Media coverage — volume and quality of press/media mentions", benchmark: "≥3 earned media placements" },
      { key: "commercial", label: " Commercial Outcome", weight: 0.10, description: "Revenue/sales pipeline generated within 30 days post-event", benchmark: "+15% pipeline contribution" },
    ],
    kpiSuggestions: [
      { name: "Brand Recall Score", target: ">65% unaided at 24hrs", method: "Post-event quiz/survey", timing: "24hrs & 7 days post-event" },
      { name: "Purchase Intent Shift", target: "+2 points on NPS-style scale", method: "Pre/post intent survey", timing: "Pre-event + immediately post" },
      { name: "Organic Social Posts", target: "≥3 per 10 attendees", method: "Social listening/hashtag tracking", timing: "Event day + 48hrs" },
    ],
    tools: { pre_survey: "Yes", digital_tracking: "Yes", live_monitoring: "Yes", post_survey: "Yes", day30_survey: "Yes", day90_tracking: "No", social_listening: "Yes", commercial_data: "Yes" },
    storyTemplate: { before: "needed to cut through market noise and generate genuine product excitement", design: "immersive brand activation with multi-sensory product experience zones", outcome: "brand recall exceeded targets and measurable pipeline was generated" }
  },
  "Awards Ceremony": {
    color: "#F59E0B",
    code: "AWD",
    dimensions: [
      { key: "behavioural_change", label: " Behavioural Change", weight: 0.25, description: "Behaviour change — discretionary effort & engagement shift post-event", benchmark: ">20% lift in discretionary effort markers" },
      { key: "emotional_impact", label: " Emotional Impact", weight: 0.20, description: "Emotional impact — how valued employees/partners feel post-event", benchmark: ">80% feel genuinely recognised" },
      { key: "data_engagement", label: " Data & Engagement", weight: 0.20, description: "Award gravity — how proudly recipients display/share recognition", benchmark: ">60% of recipients share publicly" },
      { key: "connection", label: " Connection & Community", weight: 0.15, description: "Cultural adoption — brand values embodiment in daily behaviour", benchmark: ">70% peers observe values-aligned behaviour" },
      { key: "brand_visibility", label: " Brand Visibility", weight: 0.10, description: "Social amplification — organic content from award recipients", benchmark: ">50% of attendees share event content" },
      { key: "commercial", label: " Commercial Outcome", weight: 0.10, description: "Retention signal — staff/partner turnover trend post-event", benchmark: "10-30% reduction in voluntary exits" },
    ],
    kpiSuggestions: [
      { name: "Recognition Score", target: ">80% feel genuinely recognised", method: "Pulse survey (5-question, scored 1-10)", timing: "Event night + 2 weeks post" },
      { name: "Social Sharing Rate", target: ">60% of recipients share publicly", method: "Social media monitoring", timing: "Event night + 7 days" },
      { name: "Retention Signal", target: "10-30% reduction in voluntary exits", method: "HR attrition data", timing: "3 & 12 months post-event" },
    ],
    tools: { pre_survey: "No", digital_tracking: "No", live_monitoring: "Yes", post_survey: "Yes", day30_survey: "Yes", day90_tracking: "Yes", social_listening: "Yes", commercial_data: "Yes" },
    storyTemplate: { before: "struggled with staff/partner disengagement and recognition deficit", design: "precision-engineered awards experience with personalised recognition moments", outcome: "recognition scores exceeded target and retention signals improved" }
  },
  "Corporate Party": {
    color: "#10B981",
    code: "CP",
    dimensions: [
      { key: "behavioural_change", label: " Behavioural Change", weight: 0.25, description: "Pride index — self-reported pride in representing the brand", benchmark: ">85% score 8+/10 on pride" },
      { key: "emotional_impact", label: " Emotional Impact", weight: 0.20, description: "Inclusivity index — % attendees whose needs were fully met", benchmark: ">95% needs accommodated" },
      { key: "data_engagement", label: " Data & Engagement", weight: 0.20, description: "Community sentiment — net sentiment in social posts about event", benchmark: ">80% positive sentiment" },
      { key: "connection", label: " Connection & Community", weight: 0.15, description: "Quality of connections — verified professional connections per attendee", benchmark: ">3 verified connections per attendee" },
      { key: "brand_visibility", label: " Brand Visibility", weight: 0.10, description: "Brand advocacy — guest-generated content + word-of-mouth", benchmark: ">50% of attendees share event content" },
      { key: "commercial", label: " Commercial Outcome", weight: 0.10, description: "Return intent — % delegates who would return / recommend brand", benchmark: ">70% would return" },
    ],
    kpiSuggestions: [
      { name: "Pride Index", target: ">85% score 8+/10", method: "3-question pride pulse on event night", timing: "Event night" },
      { name: "Positive Sentiment", target: ">80% positive", method: "Social listening — sentiment analysis", timing: "Event + 7 days" },
      { name: "Return Intent", target: ">70% would return", method: "Post-event NPS + would you return?", timing: "Post-event" },
    ],
    tools: { pre_survey: "No", digital_tracking: "No", live_monitoring: "Yes", post_survey: "Yes", day30_survey: "No", day90_tracking: "No", social_listening: "Yes", commercial_data: "No" },
    storyTemplate: { before: "needed to strengthen team cohesion and brand pride beyond the office", design: "curated corporate experience with intentional connection moments", outcome: "pride index and brand advocacy exceeded targets" }
  },
  "Other": {
    color: "#8B5CF6",
    code: "OTH",
    dimensions: [
      { key: "behavioural_change", label: " Behavioural Change", weight: 0.25, description: "Measurable change in attendee behaviour post-event", benchmark: ">60% demonstrate target behaviour change" },
      { key: "emotional_impact", label: " Emotional Impact", weight: 0.20, description: "Attendee sentiment and satisfaction score", benchmark: ">80% positive sentiment" },
      { key: "data_engagement", label: " Data & Engagement", weight: 0.20, description: "Engagement metrics and dwell time", benchmark: ">70% active participation" },
      { key: "connection", label: " Connection & Community", weight: 0.15, description: "Connections and community building", benchmark: ">3 connections per attendee" },
      { key: "brand_visibility", label: " Brand Visibility", weight: 0.10, description: "Brand reach and amplification", benchmark: ">50% of attendees share content" },
      { key: "commercial", label: " Commercial Outcome", weight: 0.10, description: "Revenue or business outcome generated", benchmark: "Measurable commercial impact" },
    ],
    kpiSuggestions: [
      { name: "Attendee Satisfaction", target: ">8/10 satisfaction score", method: "Post-event survey", timing: "Event night + 48hrs" },
      { name: "Event Reach", target: ">50% of attendees share content", method: "Social listening", timing: "Event + 7 days" },
      { name: "Key Objective Achievement", target: "100% of stated objectives met", method: "Internal review", timing: "Post-event" },
    ],
    tools: { pre_survey: "No", digital_tracking: "No", live_monitoring: "Yes", post_survey: "Yes", day30_survey: "No", day90_tracking: "No", social_listening: "Yes", commercial_data: "No" },
    storyTemplate: { before: "needed a distinctive event experience beyond standard formats", design: "bespoke event concept tailored to specific objectives", outcome: "key objectives achieved and attendees exceeded expectations" }
  },
};




const getScoreLabel = (score) => {
  if (score >= 8) return { label: "Excellent", color: "#10B981" };
  if (score >= 6) return { label: "Good", color: T.teal };
  if (score >= 4) return { label: "Fair", color: T.amber };
  return { label: "Poor", color: T.red };
};

const ImpactIntelligenceSummary = ({ user }) => {
  const [events, setEvents] = useState([]);
  const [scorecards, setScorecardsData] = useState([]);
  const [briefs, setBriefs] = useState([]);
  const [reports, setReports] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const [{ data: ev }, { data: sc }, { data: br }, { data: rp }] = await Promise.all([
      supabase.from("projects").select("*").not("event_category", "is", null).order("event_date", { ascending: false }),
      supabase.from("event_scorecards").select("*"),
      supabase.from("event_impact_briefs").select("*"),
      supabase.from("event_impact_reports").select("*"),
    ]);
    setEvents(ev || []);
    setScorecardsData(sc || []);
    setBriefs(br || []);
    setReports(rp || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const getEventScore = (eventId) => {
    const sc = scorecards.find(s => s.project_id === eventId);
    return sc ? sc.overall_score : null;
  };

  const avgScore = scorecards.length > 0 ? (scorecards.reduce((s, sc) => s + (sc.overall_score || 0), 0) / scorecards.length).toFixed(1) : null;

  const categoryStats = Object.keys(EVENT_ARCHETYPES).map(cat => {
    const catEvents = events.filter(e => e.event_category === cat);
    const catScores = catEvents.map(e => getEventScore(e.id)).filter(s => s !== null);
    const avgCatScore = catScores.length > 0 ? (catScores.reduce((a,b) => a+b, 0) / catScores.length).toFixed(1) : null;
    return { category: cat, count: catEvents.length, avgScore: avgCatScore, color: (EVENT_ARCHETYPES[cat]?.color || T.teal) };
  }).filter(c => c.count > 0);

  if (loading) return <div style={{ padding: '60px 0', textAlign: 'center', color: T.textMuted, fontSize: 13 }}>Loading Impact Intelligence...</div>;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Strategic</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Impact Intelligence</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Cross-event impact scores, briefs and reports</div>
      </div>

      {/* KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Events Tracked", value: events.length, color: T.cyan },
          { label: "Briefs Completed", value: briefs.length, color: T.teal },
          { label: "Scorecards", value: scorecards.length, color: T.amber },
          { label: "Avg Impact Score", value: avgScore ? `${avgScore}/10` : "—", color: parseFloat(avgScore) >= 7 ? "#10B981" : parseFloat(avgScore) >= 5 ? T.amber : T.red },
        ].map((k,i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 20, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginTop: 4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Category performance */}
      {categoryStats.length > 0 && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "20px 24px", marginBottom: 24 }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 16 }}>Performance by Event Category</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px,1fr))", gap: 12 }}>
            {categoryStats.map(cat => (
              <div key={cat.category} style={{ background: T.bg, border: `1px solid ${cat.color}30`, borderTop: `3px solid ${cat.color}`, borderRadius: 10, padding: "14px 16px" }}>
                <div style={{ color: cat.color, fontSize: 10, fontWeight: 800, textTransform: "uppercase", marginBottom: 4 }}>{cat.category}</div>
                <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 28 }}>{cat.avgScore || "—"}<span style={{ fontSize: 14, color: T.textMuted }}>/10</span></div>
                <div style={{ color: T.textMuted, fontSize: 11, marginTop: 4 }}>{cat.count} event{cat.count!==1?"s":""}</div>
                {cat.avgScore && <div style={{ color: getScoreLabel(parseFloat(cat.avgScore)).color, fontSize: 11, fontWeight: 700, marginTop: 4 }}>{getScoreLabel(parseFloat(cat.avgScore)).label}</div>}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Events table */}
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
        <div style={{ padding: "16px 20px", borderBottom: `1px solid ${T.border}` }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>All Events — Impact Status</div>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
              {["Event","Category","Date","Brief","Score","Report","Action"].map(h => (
                <th key={h} style={{ padding: "10px 16px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {events.map((ev, i) => {
              const score = getEventScore(ev.id);
              const hasBrief = briefs.some(b => b.project_id === ev.id);
              const hasReport = reports.some(r => r.project_id === ev.id);
              const archetype = EVENT_ARCHETYPES[ev.event_category] || EVENT_ARCHETYPES["Conference/Seminar"];
              return (
                <tr key={ev.id} style={{ borderBottom: i < events.length-1 ? `1px solid ${T.border}44` : "none" }}
                  onMouseEnter={e => e.currentTarget.style.background = T.bg}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  <td style={{ padding: "12px 16px", color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{ev.name}</td>
                  <td style={{ padding: "12px 16px" }}>
                    <span style={{ background: (archetype?.color||T.cyan)+"18", color: archetype?.color||T.cyan, border: `1px solid ${(archetype?.color||T.cyan)}30`, borderRadius: 20, padding: "2px 8px", fontSize: 10, fontWeight: 800 }}>{ev.event_category}</span>
                  </td>
                  <td style={{ padding: "12px 16px", color: T.textMuted, fontSize: 12 }}>{ev.event_date ? new Date(ev.event_date+"T12:00:00").toLocaleDateString("en-GB") : "—"}</td>
                  <td style={{ padding: "12px 16px" }}>
                    <span style={{ color: hasBrief ? "#10B981" : T.amber, fontSize: 12, fontWeight: 700 }}>{hasBrief ? " Done" : "Pending"}</span>
                  </td>
                  <td style={{ padding: "12px 16px" }}>
                    {score !== null ? (
                      <span style={{ color: getScoreLabel(score).color, fontWeight: 900, fontSize: 14 }}>{score}/10</span>
                    ) : <span style={{ color: T.textMuted, fontSize: 12 }}>—</span>}
                  </td>
                  <td style={{ padding: "12px 16px" }}>
                    <span style={{ color: hasReport ? "#10B981" : T.textMuted, fontSize: 12, fontWeight: 700 }}>{hasReport ? " Done" : "—"}</span>
                  </td>
                  <td style={{ padding: "12px 16px" }}>
                    <button onClick={() => setSelectedEvent(selectedEvent?.id === ev.id ? null : ev)} style={{ background: (archetype?.color||T.cyan)+"15", border: `1px solid ${(archetype?.color||T.cyan)}30`, color: archetype?.color||T.cyan, padding: "4px 12px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>
                      {selectedEvent?.id === ev.id ? "Close" : "Open"}
                    </button>
                  </td>
                </tr>
              );
            })}
            {events.length === 0 && (
              <tr><td colSpan={7} style={{ padding: "40px 0", textAlign: "center", color: T.textMuted, fontSize: 13 }}>No events with categories yet. Add event categories to start tracking impact.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Expanded event impact view */}
      {selectedEvent && (
        <div style={{ marginTop: 24 }}>
          <EventImpactView user={user} project={selectedEvent} />
        </div>
      )}


    </div>
  );
};


const ZohoBooksView = ({ user }) => {
  const [connected, setConnected] = useState(false);
  const [checking, setChecking] = useState(true);
  const [tab, setTab] = useState("invoices");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncMsg, setSyncMsg] = useState("");
  const [clients, setClients] = useState([]);
  const [vendors, setVendors] = useState([]);

  const tabs = [
    { id: "invoices", label: "Invoices" },
    { id: "estimates", label: "Quotes / Estimates" },
    { id: "payments", label: "Payments Received" },
    { id: "expenses", label: "Expenses" },
    { id: "bills", label: "Bills" },
    { id: "purchaseorders", label: "Purchase Orders" },
    { id: "contacts", label: "Contacts" },
    { id: "sync", label: " Sync" },
  ];

  const checkConnection = async () => {
    setChecking(true);
    try {
      const res = await fetch("/api/zoho-sync?action=status");
      const json = await res.json();
      setConnected(!!json.connected);
    } catch {
      setConnected(false);
    }
    setChecking(false);
  };

  const fetchTab = async (t) => {
    setLoading(true);
    setData([]);
    try {
      const res = await fetch(`/api/zoho-sync?action=${t}`);
      const json = await res.json();
      const key = Object.keys(json).find(k => Array.isArray(json[k]));
      setData(key ? json[key] : []);
    } catch {
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    checkConnection();
    // Check if just connected via OAuth callback
    if (window.location.search.includes("zoho=connected")) {
      setSyncMsg(" Zoho Books connected successfully!");
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, []);

  useEffect(() => {
    if (connected && tab !== "sync") fetchTab(tab);
  }, [connected, tab]);

  const loadLocalData = async () => {
    const [{ data: cl }, { data: vn }] = await Promise.all([
      (!activeCountry || activeCountry === "All") ? supabase.from("clients").select("*").order("name") : supabase.from("clients").select("*").eq("country",activeCountry).order("name"),
      supabase.from("profiles").select("*").eq("role", "Vendor"),
    ]);
    setClients(cl || []);
    setVendors(vn || []);
  };

  useEffect(() => { loadLocalData(); }, []);

  const syncClient = async (client) => {
    setSyncing(true);
    setSyncMsg("");
    try {
      const res = await fetch("/api/zoho-sync?action=sync-client", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ client }),
      });
      const json = await res.json();
      if (json.contact) setSyncMsg(` ${client.name} synced to Zoho Books`);
      else setSyncMsg(` ${json.message || "Sync failed"}`);
    } catch (e) {
      setSyncMsg(" Error: " + e.message);
    }
    setSyncing(false);
  };

  const syncVendor = async (vendor) => {
    setSyncing(true);
    setSyncMsg("");
    try {
      const res = await fetch("/api/zoho-sync?action=sync-vendor", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ vendor }),
      });
      const json = await res.json();
      if (json.contact) setSyncMsg(` ${vendor.name} synced to Zoho Books`);
      else setSyncMsg(` ${json.message || "Sync failed"}`);
    } catch (e) {
      setSyncMsg(" Error: " + e.message);
    }
    setSyncing(false);
  };

  // Column definitions per tab
  const columns = {
    invoices: ["Invoice #", "Customer", "Date", "Due Date", "Amount", "Status"],
    estimates: ["Estimate #", "Customer", "Date", "Expiry", "Amount", "Status"],
    payments: ["Payment #", "Customer", "Date", "Amount", "Mode"],
    expenses: ["Date", "Category", "Description", "Amount", "Status"],
    bills: ["Bill #", "Vendor", "Date", "Due Date", "Amount", "Status"],
    purchaseorders: ["PO #", "Vendor", "Date", "Expected", "Amount", "Status"],
    contacts: ["Name", "Type", "Email", "Phone", "Balance"],
  };

  const getRow = (item, t) => {
    if (t === "invoices") return [item.invoice_number, item.customer_name, item.date, item.due_date, `${item.currency_code} ${(item.total || 0).toLocaleString()}`, item.status];
    if (t === "estimates") return [item.estimate_number, item.customer_name, item.date, item.expiry_date, `${item.currency_code} ${(item.total || 0).toLocaleString()}`, item.status];
    if (t === "payments") return [item.payment_number, item.customer_name, item.date, `${item.currency_code} ${(item.amount || 0).toLocaleString()}`, item.payment_mode];
    if (t === "expenses") return [item.date, item.account_name, item.description || item.reference_number, `${item.currency_code} ${(item.total || 0).toLocaleString()}`, item.status];
    if (t === "bills") return [item.bill_number, item.vendor_name, item.date, item.due_date, `${item.currency_code} ${(item.total || 0).toLocaleString()}`, item.status];
    if (t === "purchaseorders") return [item.purchaseorder_number, item.vendor_name, item.date, item.delivery_date, `${item.currency_code} ${(item.total || 0).toLocaleString()}`, item.status];
    if (t === "contacts") return [item.contact_name, item.contact_type, item.email, item.phone, `${item.currency_code || ""} ${(item.outstanding_receivable_amount || 0).toLocaleString()}`];
    return [];
  };

  const statusColor = (s) => {
    if (!s) return T.textMuted;
    const sl = s.toLowerCase();
    if (["paid","accepted","received","open"].includes(sl)) return T.teal;
    if (["overdue","expired"].includes(sl)) return T.red;
    if (["draft","pending","sent"].includes(sl)) return T.amber;
    return T.textMuted;
  };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Finance</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Zoho Books</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Live sync with your Zoho Books Professional account</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {checking ? (
            <span style={{ color: T.textMuted, fontSize: 12 }}>Checking connection...</span>
          ) : connected ? (
            <span style={{ background: T.teal + "18", color: T.teal, border: `1px solid ${T.teal}30`, borderRadius: 20, padding: "4px 14px", fontSize: 11, fontWeight: 700 }}> Connected</span>
          ) : (
            <a href="/api/zoho-auth" style={{ background: `linear-gradient(135deg, #E67E22, #F39C12)`, border: "none", color: "#fff", padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700, textDecoration: "none" }}>Connect Zoho Books</a>
          )}
          {connected && <button onClick={() => { if (tab !== "sync") fetchTab(tab); }} style={{ background: T.surface, border: `1px solid ${T.border}`, color: T.textMuted, padding: "8px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>↻ Refresh</button>}
          {connected && <a href="https://books.zoho.com" target="_blank" rel="noopener noreferrer" style={{ background: `linear-gradient(135deg, #E67E22, #F39C12)`, color: "#fff", padding: "8px 16px", borderRadius: 8, fontSize: 12, fontWeight: 700, textDecoration: "none" }}>Open Zoho Books ↗</a>}
        </div>
      </div>

      {!connected && !checking && (
        <div style={{ textAlign: "center", padding: "60px 0", background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 18, marginBottom: 8 }}>Connect Zoho Books</div>
          <div style={{ color: T.textMuted, fontSize: 13, marginBottom: 24 }}>Click "Connect Zoho Books" above to authorise access to your account.</div>
          <a href="/api/zoho-auth" style={{ background: `linear-gradient(135deg, #E67E22, #F39C12)`, color: "#fff", padding: "12px 28px", borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: "none" }}>Connect Now</a>
        </div>
      )}

      {connected && (
        <>
          {/* Tabs */}
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 20 }}>
            {tabs.map(t => (
              <button key={t.id} onClick={() => setTab(t.id)} style={{
                padding: "6px 16px", borderRadius: 20, cursor: "pointer", fontSize: 11, fontWeight: 700,
                border: `1px solid ${tab === t.id ? "#E67E22" : T.border}`,
                background: tab === t.id ? "#E67E2220" : "none",
                color: tab === t.id ? "#E67E22" : T.textMuted,
                letterSpacing: "0.04em", textTransform: "uppercase", transition: "all 0.15s",
              }}>{t.label}</button>
            ))}
          </div>

          {/* Sync tab */}
          {tab === "sync" && (
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 16, marginBottom: 16 }}>Sync WorkRoom Data to Zoho Books</div>
              {syncMsg && <div style={{ padding: "10px 14px", background: T.teal + "12", border: `1px solid ${T.teal}30`, borderRadius: 8, color: T.teal, fontSize: 13, marginBottom: 16 }}>{syncMsg}</div>}

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                {/* Clients */}
                <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: 20 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 4 }}>Clients → Zoho Customers</div>
                  <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 14 }}>Push WorkRoom clients to Zoho Books as customer contacts</div>
                  {clients.map(c => (
                    <div key={c.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: `1px solid ${T.border}44` }}>
                      <div>
                        <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{c.name}</div>
                        <div style={{ color: T.textMuted, fontSize: 11 }}>{c.email}</div>
                      </div>
                      <button onClick={() => syncClient(c)} disabled={syncing} style={{ background: "#E67E2218", border: "1px solid #E67E2230", color: "#E67E22", padding: "4px 12px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>
                        {c.zoho_contact_id ? "Re-sync" : "→ Zoho"}
                      </button>
                    </div>
                  ))}
                </div>

                {/* Vendors */}
                <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: 20 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 4 }}>Vendors → Zoho Vendors</div>
                  <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 14 }}>Push WorkRoom vendors to Zoho Books as vendor contacts</div>
                  {vendors.map(v => (
                    <div key={v.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: `1px solid ${T.border}44` }}>
                      <div>
                        <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{v.name}</div>
                        <div style={{ color: T.textMuted, fontSize: 11 }}>{v.email}</div>
                      </div>
                      <button onClick={() => syncVendor(v)} disabled={syncing} style={{ background: "#E67E2218", border: "1px solid #E67E2230", color: "#E67E22", padding: "4px 12px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>→ Zoho</button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Data table */}
          {tab !== "sync" && (
            <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
              {loading ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: T.textMuted }}>Loading from Zoho Books...</div>
              ) : data.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: T.textMuted, fontSize: 13 }}>No {tab} found in Zoho Books. <a href="https://books.zoho.com" target="_blank" rel="noopener noreferrer" style={{ color: "#E67E22", fontWeight: 700 }}>Create one in Zoho Books ↗</a></div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
                    <thead>
                      <tr style={{ borderBottom: `1px solid ${T.border}`, background: T.bg }}>
                        {(columns[tab] || []).map((h, i) => (
                          <th key={i} style={{ padding: "12px 16px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", whiteSpace: "nowrap" }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, idx) => {
                        const row = getRow(item, tab);
                        return (
                          <tr key={idx} style={{ borderBottom: idx < data.length - 1 ? `1px solid ${T.border}44` : "none" }}
                            onMouseEnter={e => e.currentTarget.style.background = T.bg}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            {row.map((cell, ci) => (
                              <td key={ci} style={{ padding: "11px 16px", fontSize: 12 }}>
                                {ci === row.length - 1 && tab !== "contacts" && tab !== "payments" ? (
                                  <span style={{ background: statusColor(cell) + "18", color: statusColor(cell), border: `1px solid ${statusColor(cell)}30`, borderRadius: 20, padding: "2px 10px", fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{cell}</span>
                                ) : (
                                  <span style={{ color: ci === 0 ? T.textPrimary : T.textSecondary, fontWeight: ci === 0 ? 700 : 400 }}>{cell}</span>
                                )}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};


const HRView = ({ user }) => {
  const [hrTab, setHrTab] = useState("staff");
  const [staff, setStaff] = useState([]);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [training, setTraining] = useState([]);
  const [trainingNeeds, setTrainingNeeds] = useState([]);
  const [saving, setSaving] = useState(false);

  // Modals
  const [leaveModal, setLeaveModal] = useState(false);
  const [reviewModal, setReviewModal] = useState(null);
  const [trainingModal, setTrainingModal] = useState(null);
  const [needModal, setNeedModal] = useState(false);

  // Forms
  const [leaveForm, setLeaveForm] = useState({ staff_id: "", staff_name: "", leave_type: "Annual", start_date: "", end_date: "", reason: "" });
  const [reviewForm, setReviewForm] = useState({ staff_id: "", staff_name: "", review_period: "", score: 7, strengths: "", improvements: "", goals: "", events_delivered: 0 });
  const [trainingForm, setTrainingForm] = useState({ staff_id: "", staff_name: "", training_name: "", training_type: "Internal", provider: "", date_completed: "", expiry_date: "", notes: "" });
  const [needForm, setNeedForm] = useState({ staff_id: "", staff_name: "", training_required: "", priority: "medium", reason: "" });

  const load = async () => {
    const [s, l, r, t, n] = await Promise.all([
      supabase.from("profiles").select("*").not("role", "in", '("Client","Vendor","Board of Directors")').order("name"),
      supabase.from("leave_requests").select("*").order("created_at", { ascending: false }),
      supabase.from("performance_reviews").select("*").order("created_at", { ascending: false }),
      supabase.from("training_records").select("*").order("created_at", { ascending: false }),
      supabase.from("training_needs").select("*").order("created_at", { ascending: false }),
    ]);
    setStaff(s.data || []);
    setLeaveRequests(l.data || []);
    setReviews(r.data || []);
    setTraining(t.data || []);
    setTrainingNeeds(n.data || []);
  };

  useEffect(() => { load(); }, []);

  const calcDays = (start, end) => {
    if (!start || !end) return 0;
    return Math.ceil((new Date(end) - new Date(start)) / (1000*60*60*24)) + 1;
  };

  const saveLeave = async () => {
    if (!leaveForm.staff_id || !leaveForm.start_date || !leaveForm.end_date) { alert("Please fill all required fields."); return; }
    setSaving(true);
    const days = calcDays(leaveForm.start_date, leaveForm.end_date);
    await supabase.from("leave_requests").insert({ ...leaveForm, days_requested: days, status: "pending" });
    // Notify staff member
    await supabase.from("notifications").insert({ user_id: leaveForm.staff_id, title: "Leave Request Submitted", message: `Your ${leaveForm.leave_type} leave request for ${days} day(s) has been submitted for approval.`, type: "task" });
    setSaving(false);
    setLeaveModal(false);
    setLeaveForm({ staff_id: "", staff_name: "", leave_type: "Annual", start_date: "", end_date: "", reason: "" });
    load();
  };

  const approveLeave = async (id, staffId, approved) => {
    await supabase.from("leave_requests").update({ status: approved ? "approved" : "declined", approved_by: user.id, approved_at: new Date().toISOString() }).eq("id", id);
    await supabase.from("notifications").insert({ user_id: staffId, title: approved ? "Leave Approved" : "Leave Declined", message: `Your leave request has been ${approved ? "approved" : "declined"} by CEO.`, type: "task" });
    load();
  };

  const saveReview = async () => {
    if (!reviewForm.staff_id || !reviewForm.review_period) { alert("Please fill all required fields."); return; }
    setSaving(true);
    await supabase.from("performance_reviews").insert({ ...reviewForm, reviewed_by: user.id, review_date: new Date().toISOString().slice(0,10) });
    await supabase.from("notifications").insert({ user_id: reviewForm.staff_id, title: "Performance Review Added", message: `Your performance review for ${reviewForm.review_period} has been completed.`, type: "task" });
    setSaving(false);
    setReviewModal(null);
    setReviewForm({ staff_id: "", staff_name: "", review_period: "", score: 7, strengths: "", improvements: "", goals: "", events_delivered: 0 });
    load();
  };

  const saveTraining = async () => {
    if (!trainingForm.staff_id || !trainingForm.training_name) { alert("Please fill all required fields."); return; }
    setSaving(true);
    await supabase.from("training_records").insert({ ...trainingForm, status: trainingForm.date_completed ? "completed" : "pending", created_by: user.id });
    setSaving(false);
    setTrainingModal(null);
    setTrainingForm({ staff_id: "", staff_name: "", training_name: "", training_type: "Internal", provider: "", date_completed: "", expiry_date: "", notes: "" });
    load();
  };

  const saveNeed = async () => {
    if (!needForm.staff_id || !needForm.training_required) { alert("Please fill all required fields."); return; }
    setSaving(true);
    await supabase.from("training_needs").insert({ ...needForm, status: "open", created_by: user.id });
    setSaving(false);
    setNeedModal(false);
    setNeedForm({ staff_id: "", staff_name: "", training_required: "", priority: "medium", reason: "" });
    load();
  };

  const inputStyle = { width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };
  const labelStyle = { color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 };
  const sectionHead = { color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 16 };

  const pendingLeave = leaveRequests.filter(l => l.status === "pending");
  const expiringCerts = training.filter(t => t.expiry_date && new Date(t.expiry_date) <= new Date(Date.now() + 30*24*60*60*1000) && t.status === "completed");
  const openNeeds = trainingNeeds.filter(n => n.status === "open");

  const staffSelect = [{ value: "", label: "Select staff member..." }, ...staff.map(s => ({ value: s.id, label: `${s.name} — ${s.role}` }))];

  const StatusPill = ({ status }) => {
    const map = { pending: [T.amber, "Pending"], approved: ["#10B981", "Approved"], declined: [T.red, "Declined"], completed: ["#10B981", "Completed"], open: [T.amber, "Open"], in_progress: [T.cyan, "In Progress"] };
    const [color, label] = map[status] || [T.textMuted, status];
    return <span style={{ background: color+"18", color, border: `1px solid ${color}30`, borderRadius: 20, padding: "2px 10px", fontSize: 10, fontWeight: 800 }}>{label}</span>;
  };

  const PriorityPill = ({ priority }) => {
    const map = { high: [T.red, "High"], medium: [T.amber, "Medium"], low: [T.teal, "Low"] };
    const [color, label] = map[priority] || [T.textMuted, priority];
    return <span style={{ background: color+"18", color, border: `1px solid ${color}30`, borderRadius: 20, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>{label}</span>;
  };

  const Modal = ({ title, onClose, children, maxWidth = 580 }) => (
    <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={onClose}>
      <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth, maxHeight: "90vh", overflow: "auto", padding: 28 }} onClick={e => e.stopPropagation()}>
        <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 20 }}>{title}</div>
        {children}
      </div>
    </div>
  );

  const Field = ({ label, children }) => (
    <div style={{ marginBottom: 14 }}><label style={labelStyle}>{label}</label>{children}</div>
  );

  const StaffSelect = ({ value, onChange }) => (
    <select value={value} onChange={e => { const s = staff.find(x => x.id === e.target.value); onChange(e.target.value, s?.name || ""); }} style={inputStyle}>
      {staffSelect.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );

  const hrTabs = [
    { id: "staff", label: "Staff Records", badge: 0 },
    { id: "leave", label: "Leave", badge: pendingLeave.length },
    { id: "performance", label: "Performance", badge: 0 },
    { id: "training", label: "Training", badge: expiringCerts.length + openNeeds.length },
  ];

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>People</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800 }}>Human Resources</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{staff.length} staff members · {pendingLeave.length} leave pending · {openNeeds.length} training needs open</div>
      </div>

      {/* KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Total Staff", value: staff.length, color: T.cyan },
          { label: "Leave Pending", value: pendingLeave.length, color: T.amber },
          { label: "Training Needs", value: openNeeds.length, color: T.red },
          { label: "Expiring Certs", value: expiringCerts.length, color: expiringCerts.length > 0 ? T.red : T.teal },
        ].map((k,i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 22, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginTop: 4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* HR Tabs */}
      <div style={{ display: "flex", gap: 0, marginBottom: 24, borderBottom: `1px solid ${T.border}` }}>
        {hrTabs.map(t => (
          <button key={t.id} onClick={() => setHrTab(t.id)} style={{ padding: "10px 18px", border: "none", cursor: "pointer", background: "none", color: hrTab === t.id ? T.textPrimary : T.textMuted, fontWeight: hrTab === t.id ? 700 : 400, fontSize: 12, letterSpacing: "0.06em", textTransform: "uppercase", borderBottom: hrTab === t.id ? `2px solid ${T.cyan}` : "2px solid transparent", marginBottom: -1, position: "relative" }}>
            {t.label}
            {t.badge > 0 && <span style={{ marginLeft: 5, background: T.amber, color: "#000", fontSize: 9, fontWeight: 900, borderRadius: 20, padding: "1px 5px" }}>{t.badge}</span>}
          </button>
        ))}
      </div>

      {/*  STAFF RECORDS  */}
      {hrTab === "staff" && (
        <div>
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                  {["Name","Role","Email","Country","Leave Taken","Reviews","Training"].map(h => (
                    <th key={h} style={{ padding: "10px 14px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {staff.map((s, i) => {
                  const staffLeave = leaveRequests.filter(l => l.staff_id === s.id && l.status === "approved").reduce((sum, l) => sum + (l.days_requested || 0), 0);
                  const staffReviews = reviews.filter(r => r.staff_id === s.id).length;
                  const staffTraining = training.filter(t => t.staff_id === s.id && t.status === "completed").length;
                  const latestReview = reviews.filter(r => r.staff_id === s.id).sort((a,b) => new Date(b.created_at) - new Date(a.created_at))[0];
                  const roleColor = { CEO: T.cyan, "Country Manager": T.teal, "Vendor Manager": T.amber, "Strategy & Events Lead": "#E879F9", "Finance Manager": "#F59E0B", "Sales & Marketing": T.blue }[s.role] || T.textMuted;
                  return (
                    <tr key={s.id} style={{ borderBottom: i < staff.length-1 ? `1px solid ${T.border}44` : "none" }}
                      onMouseEnter={e => e.currentTarget.style.background = T.bg}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <td style={{ padding: "10px 14px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <div style={{ width: 28, height: 28, borderRadius: "50%", background: roleColor+"20", border: `1px solid ${roleColor}40`, display: "flex", alignItems: "center", justifyContent: "center", color: roleColor, fontWeight: 800, fontSize: 10 }}>{(s.name||"?").slice(0,2).toUpperCase()}</div>
                          <span style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{s.name}</span>
                        </div>
                      </td>
                      <td style={{ padding: "10px 14px" }}><span style={{ background: roleColor+"15", color: roleColor, borderRadius: 20, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>{s.role}</span></td>
                      <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 11 }}>{s.email}</td>
                      <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 12 }}>{s.country || "Ghana"}</td>
                      <td style={{ padding: "10px 14px", color: T.textPrimary, fontSize: 12, fontWeight: 600 }}>{staffLeave} days</td>
                      <td style={{ padding: "10px 14px" }}>
                        <div style={{ color: staffReviews > 0 ? T.teal : T.textMuted, fontSize: 12 }}>
                          {staffReviews > 0 ? `${staffReviews} reviews` : "—"}
                          {latestReview && <div style={{ color: T.textMuted, fontSize: 10 }}>Last: {latestReview.score}/10</div>}
                        </div>
                      </td>
                      <td style={{ padding: "10px 14px", color: staffTraining > 0 ? T.cyan : T.textMuted, fontSize: 12 }}>{staffTraining > 0 ? `${staffTraining} completed` : "—"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/*  LEAVE MANAGEMENT  */}
      {hrTab === "leave" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div style={sectionHead}>Leave Requests</div>
            <button onClick={() => setLeaveModal(true)} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "9px 20px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>+ Add Leave Request</button>
          </div>
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                  {["Staff","Type","From","To","Days","Reason","Status","Actions"].map(h => (
                    <th key={h} style={{ padding: "10px 14px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {leaveRequests.map((l, i) => (
                  <tr key={l.id} style={{ borderBottom: i < leaveRequests.length-1 ? `1px solid ${T.border}44` : "none" }}
                    onMouseEnter={e => e.currentTarget.style.background = T.bg}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                    <td style={{ padding: "10px 14px", color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{l.staff_name}</td>
                    <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 12 }}>{l.leave_type}</td>
                    <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 12 }}>{l.start_date}</td>
                    <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 12 }}>{l.end_date}</td>
                    <td style={{ padding: "10px 14px", color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{l.days_requested}</td>
                    <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 11, maxWidth: 160 }}>{l.reason}</td>
                    <td style={{ padding: "10px 14px" }}><StatusPill status={l.status} /></td>
                    <td style={{ padding: "10px 14px" }}>
                      {l.status === "pending" && (
                        <div style={{ display: "flex", gap: 6 }}>
                          <button onClick={() => approveLeave(l.id, l.staff_id, true)} style={{ background: "#10B98118", border: "1px solid #10B98130", color: "#10B981", padding: "3px 10px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Approve</button>
                          <button onClick={() => approveLeave(l.id, l.staff_id, false)} style={{ background: T.red+"18", border: `1px solid ${T.red}30`, color: T.red, padding: "3px 10px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Decline</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
                {leaveRequests.length === 0 && <tr><td colSpan={8} style={{ padding: "30px 0", textAlign: "center", color: T.textMuted }}>No leave requests yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/*  PERFORMANCE REVIEWS  */}
      {hrTab === "performance" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div style={sectionHead}>Performance Reviews</div>
            <button onClick={() => setReviewModal(true)} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "9px 20px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>+ Add Review</button>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14 }}>
            {staff.map(s => {
              const staffReviews = reviews.filter(r => r.staff_id === s.id).sort((a,b) => new Date(b.created_at) - new Date(a.created_at));
              const latest = staffReviews[0];
              const avgScore = staffReviews.length > 0 ? (staffReviews.reduce((sum,r) => sum + (r.score||0), 0) / staffReviews.length).toFixed(1) : null;
              const scoreColor = avgScore >= 8 ? "#10B981" : avgScore >= 6 ? T.teal : avgScore >= 4 ? T.amber : T.red;
              return (
                <div key={s.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "16px 18px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                    <div>
                      <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>{s.name}</div>
                      <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{s.role}</div>
                    </div>
                    {avgScore && <div style={{ textAlign: "right" }}><div style={{ color: scoreColor, fontWeight: 900, fontSize: 22 }}>{avgScore}</div><div style={{ color: T.textMuted, fontSize: 9 }}>avg /10</div></div>}
                  </div>
                  {latest ? (
                    <div>
                      <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 4 }}>Latest: {latest.review_period} · Score: {latest.score}/10</div>
                      {latest.strengths && <div style={{ color: T.textSecondary, fontSize: 11, marginBottom: 2 }}> {latest.strengths?.slice(0,60)}...</div>}
                      {latest.improvements && <div style={{ color: T.amber, fontSize: 11 }}>↑ {latest.improvements?.slice(0,60)}...</div>}
                      <div style={{ color: T.textMuted, fontSize: 10, marginTop: 6 }}>{staffReviews.length} review{staffReviews.length !== 1 ? "s" : ""} total</div>
                    </div>
                  ) : (
                    <div style={{ color: T.textMuted, fontSize: 12, fontStyle: "italic" }}>No reviews yet</div>
                  )}
                  <button onClick={() => setReviewModal({ staff_id: s.id, staff_name: s.name })} style={{ marginTop: 12, width: "100%", background: T.cyan+"12", border: `1px solid ${T.cyan}25`, color: T.cyan, padding: "6px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>+ Add Review</button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/*  TRAINING  */}
      {hrTab === "training" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div style={sectionHead}>Training & Development</div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => setNeedModal(true)} style={{ background: T.amber+"15", border: `1px solid ${T.amber}30`, color: T.amber, padding: "9px 16px", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 12 }}>+ Training Need</button>
              <button onClick={() => setTrainingModal(true)} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "9px 20px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>+ Log Training</button>
            </div>
          </div>

          {/* Training Needs */}
          {trainingNeeds.length > 0 && (
            <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden", marginBottom: 20 }}>
              <div style={{ padding: "12px 16px", borderBottom: `1px solid ${T.border}`, color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>Training Needs — {openNeeds.length} open</div>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                  {["Staff","Training Required","Priority","Reason","Status"].map(h => <th key={h} style={{ padding: "8px 14px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</th>)}
                </tr></thead>
                <tbody>
                  {trainingNeeds.map((n, i) => (
                    <tr key={n.id} style={{ borderBottom: i < trainingNeeds.length-1 ? `1px solid ${T.border}44` : "none" }}
                      onMouseEnter={e => e.currentTarget.style.background = T.bg}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <td style={{ padding: "10px 14px", color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{n.staff_name}</td>
                      <td style={{ padding: "10px 14px", color: T.textSecondary, fontSize: 12 }}>{n.training_required}</td>
                      <td style={{ padding: "10px 14px" }}><PriorityPill priority={n.priority} /></td>
                      <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 11 }}>{n.reason}</td>
                      <td style={{ padding: "10px 14px" }}>
                        <select value={n.status} onChange={async e => { await supabase.from("training_needs").update({ status: e.target.value }).eq("id", n.id); load(); }} style={{ padding: "4px 8px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 11, fontFamily: "inherit", outline: "none" }}>
                          <option value="open">Open</option>
                          <option value="in_progress">In Progress</option>
                          <option value="completed">Completed</option>
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Training Records */}
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
            <div style={{ padding: "12px 16px", borderBottom: `1px solid ${T.border}`, color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>Training Records</div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                {["Staff","Training","Type","Provider","Date","Expiry","Status"].map(h => <th key={h} style={{ padding: "8px 14px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</th>)}
              </tr></thead>
              <tbody>
                {training.map((t, i) => {
                  const isExpiring = t.expiry_date && new Date(t.expiry_date) <= new Date(Date.now() + 30*24*60*60*1000);
                  return (
                    <tr key={t.id} style={{ borderBottom: i < training.length-1 ? `1px solid ${T.border}44` : "none", background: isExpiring ? T.red+"05" : "transparent" }}
                      onMouseEnter={e => e.currentTarget.style.background = T.bg}
                      onMouseLeave={e => e.currentTarget.style.background = isExpiring ? T.red+"05" : "transparent"}>
                      <td style={{ padding: "10px 14px", color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{t.staff_name}</td>
                      <td style={{ padding: "10px 14px", color: T.textSecondary, fontSize: 12 }}>{t.training_name}</td>
                      <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 11 }}>{t.training_type}</td>
                      <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 11 }}>{t.provider || "—"}</td>
                      <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 11 }}>{t.date_completed || "—"}</td>
                      <td style={{ padding: "10px 14px", color: isExpiring ? T.red : T.textMuted, fontSize: 11, fontWeight: isExpiring ? 700 : 400 }}>{t.expiry_date || "—"}{isExpiring && " "}</td>
                      <td style={{ padding: "10px 14px" }}><StatusPill status={t.status} /></td>
                    </tr>
                  );
                })}
                {training.length === 0 && <tr><td colSpan={7} style={{ padding: "30px 0", textAlign: "center", color: T.textMuted }}>No training records yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/*  MODALS  */}

      {/* Leave Request Modal */}
      {leaveModal && (
        <Modal title="Add Leave Request" onClose={() => setLeaveModal(false)}>
          <Field label="Staff Member *"><StaffSelect value={leaveForm.staff_id} onChange={(id, name) => setLeaveForm({...leaveForm, staff_id: id, staff_name: name})} form={form} setForm={setForm} /></Field>
          <Field label="Leave Type">
            <select value={leaveForm.leave_type} onChange={e => setLeaveForm({...leaveForm, leave_type: e.target.value})} style={inputStyle}>
              {["Annual","Sick","Emergency","Maternity/Paternity","Study","Other"].map(t => <option key={t}>{t}</option>)}
            </select>
          </Field>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Field label="Start Date *"><input type="date" value={leaveForm.start_date} onChange={e => setLeaveForm({...leaveForm, start_date: e.target.value})} style={inputStyle} form={form} setForm={setForm} /></Field>
            <Field label="End Date *"><input type="date" value={leaveForm.end_date} onChange={e => setLeaveForm({...leaveForm, end_date: e.target.value})} style={inputStyle} form={form} setForm={setForm} /></Field>
          </div>
          {leaveForm.start_date && leaveForm.end_date && <div style={{ color: T.cyan, fontSize: 12, marginBottom: 14, fontWeight: 700 }}> {calcDays(leaveForm.start_date, leaveForm.end_date)} days requested</div>}
          <Field label="Reason"><textarea value={leaveForm.reason} onChange={e => setLeaveForm({...leaveForm, reason: e.target.value})} rows={3} style={{...inputStyle, resize: "vertical"}} placeholder="Reason for leave..." form={form} setForm={setForm} /></Field>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={saveLeave} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Saving..." : "Submit Leave Request"}</button>
            <button onClick={() => setLeaveModal(false)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
          </div>
        </Modal>
      )}

      {/* Performance Review Modal */}
      {reviewModal && (
        <Modal title="Add Performance Review" onClose={() => setReviewModal(null)}>
          {!reviewModal.staff_id ? (
            <Field label="Staff Member *"><StaffSelect value={reviewForm.staff_id} onChange={(id, name) => setReviewForm({...reviewForm, staff_id: id, staff_name: name})} form={form} setForm={setForm} /></Field>
          ) : (
            <div style={{ background: T.cyan+"12", border: `1px solid ${T.cyan}30`, borderRadius: 8, padding: "10px 14px", marginBottom: 16, color: T.cyan, fontSize: 13, fontWeight: 700 }}>{reviewModal.staff_name}</div>
          )}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Field label="Review Period *"><input value={reviewForm.review_period} onChange={e => setReviewForm({...reviewForm, review_period: e.target.value})} style={inputStyle} placeholder="e.g. Q1 2026" form={form} setForm={setForm} /></Field>
            <Field label="Events Delivered"><input type="number" value={reviewForm.events_delivered} onChange={e => setReviewForm({...reviewForm, events_delivered: parseInt(e.target.value)||0})} style={inputStyle} form={form} setForm={setForm} /></Field>
          </div>
          <Field label={`Performance Score: ${reviewForm.score}/10`}>
            <input type="range" min="1" max="10" step="0.5" value={reviewForm.score} onChange={e => setReviewForm({...reviewForm, score: parseFloat(e.target.value)})}
              style={{ width: "100%", accentColor: T.cyan }} />
            <div style={{ display: "flex", justifyContent: "space-between", color: T.textMuted, fontSize: 10, marginTop: 2 }}><span>1 — Poor</span><span style={{ color: T.cyan, fontWeight: 700 }}>{reviewForm.score}/10</span><span>10 — Exceptional</span></div>
          </Field>
          <Field label="Strengths"><textarea value={reviewForm.strengths} onChange={e => setReviewForm({...reviewForm, strengths: e.target.value})} rows={2} style={{...inputStyle, resize: "vertical"}} placeholder="Key strengths observed..." form={form} setForm={setForm} /></Field>
          <Field label="Areas for Improvement"><textarea value={reviewForm.improvements} onChange={e => setReviewForm({...reviewForm, improvements: e.target.value})} rows={2} style={{...inputStyle, resize: "vertical"}} placeholder="Areas to develop..." form={form} setForm={setForm} /></Field>
          <Field label="Goals for Next Period"><textarea value={reviewForm.goals} onChange={e => setReviewForm({...reviewForm, goals: e.target.value})} rows={2} style={{...inputStyle, resize: "vertical"}} placeholder="Goals and objectives..." form={form} setForm={setForm} /></Field>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={() => { if(reviewModal.staff_id) setReviewForm(f => ({...f, staff_id: reviewModal.staff_id, staff_name: reviewModal.staff_name})); saveReview(); }} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Saving..." : "Save Review"}</button>
            <button onClick={() => setReviewModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
          </div>
        </Modal>
      )}

      {/* Training Log Modal */}
      {trainingModal && (
        <Modal title="Log Training" onClose={() => setTrainingModal(null)}>
          <Field label="Staff Member *"><StaffSelect value={trainingForm.staff_id} onChange={(id, name) => setTrainingForm({...trainingForm, staff_id: id, staff_name: name})} form={form} setForm={setForm} /></Field>
          <Field label="Training Name *"><input value={trainingForm.training_name} onChange={e => setTrainingForm({...trainingForm, training_name: e.target.value})} style={inputStyle} placeholder="e.g. Event Safety Certification" form={form} setForm={setForm} /></Field>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Field label="Training Type">
              <select value={trainingForm.training_type} onChange={e => setTrainingForm({...trainingForm, training_type: e.target.value})} style={inputStyle}>
                {["Internal","External","Certification","Workshop","Online","Conference"].map(t => <option key={t}>{t}</option>)}
              </select>
            </Field>
            <Field label="Provider / Institution"><input value={trainingForm.provider} onChange={e => setTrainingForm({...trainingForm, provider: e.target.value})} style={inputStyle} placeholder="Who delivered it?" form={form} setForm={setForm} /></Field>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Field label="Date Completed"><input type="date" value={trainingForm.date_completed} onChange={e => setTrainingForm({...trainingForm, date_completed: e.target.value})} style={inputStyle} form={form} setForm={setForm} /></Field>
            <Field label="Expiry Date (if applicable)"><input type="date" value={trainingForm.expiry_date} onChange={e => setTrainingForm({...trainingForm, expiry_date: e.target.value})} style={inputStyle} form={form} setForm={setForm} /></Field>
          </div>
          <Field label="Notes"><textarea value={trainingForm.notes} onChange={e => setTrainingForm({...trainingForm, notes: e.target.value})} rows={2} style={{...inputStyle, resize: "vertical"}} form={form} setForm={setForm} /></Field>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={saveTraining} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Saving..." : "Save Training Record"}</button>
            <button onClick={() => setTrainingModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
          </div>
        </Modal>
      )}

      {/* Training Need Modal */}
      {needModal && (
        <Modal title="Flag Training Need" onClose={() => setNeedModal(false)}>
          <Field label="Staff Member *"><StaffSelect value={needForm.staff_id} onChange={(id, name) => setNeedForm({...needForm, staff_id: id, staff_name: name})} form={form} setForm={setForm} /></Field>
          <Field label="Training Required *"><input value={needForm.training_required} onChange={e => setNeedForm({...needForm, training_required: e.target.value})} style={inputStyle} placeholder="e.g. Client Management, Protocol Training" form={form} setForm={setForm} /></Field>
          <Field label="Priority">
            <select value={needForm.priority} onChange={e => setNeedForm({...needForm, priority: e.target.value})} style={inputStyle}>
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="low">Low</option>
            </select>
          </Field>
          <Field label="Reason / Context"><textarea value={needForm.reason} onChange={e => setNeedForm({...needForm, reason: e.target.value})} rows={3} style={{...inputStyle, resize: "vertical"}} placeholder="Why is this training needed?" form={form} setForm={setForm} /></Field>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={saveNeed} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.amber}, ${T.amber}99)`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Saving..." : "Flag Training Need"}</button>
            <button onClick={() => setNeedModal(false)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
          </div>
        </Modal>
      )}
    </div>
  );
};



const StaffPaymentRatesView = ({ user }) => {
  const [events, setEvents] = useState([]);
  const [staffProfiles, setStaffProfiles] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [paymentRates, setPaymentRates] = useState([]);
  const [saving, setSaving] = useState(false);
  const isCEO = user?.role === "CEO";

  useEffect(() => {
    supabase.from("projects").select("*").order("event_date", { ascending: false }).then(({ data }) => setEvents(data || []));
    supabase.from("profiles").select("id,name,role").not("role", "in", "(Client,Vendor,Board of Directors,CEO)").then(({ data }) => setStaffProfiles(data || []));
  }, []);

  const loadRates = async (eventId) => {
    const { data } = await supabase.from("staff_payment_rates").select("*").eq("project_id", eventId);
    setPaymentRates(data || []);
  };

  const handleEventSelect = (eventId) => {
    const ev = events.find(e => e.id === eventId);
    setSelectedEvent(ev || null);
    if (eventId) loadRates(eventId);
    else setPaymentRates([]);
  };

  const updateRate = (staffId, field, value) => {
    setPaymentRates(prev => {
      const existing = prev.find(r => r.staff_id === staffId);
      if (existing) return prev.map(r => r.staff_id === staffId ? { ...r, [field]: value } : r);
      return [...prev, { staff_id: staffId, project_id: selectedEvent?.id, [field]: value }];
    });
  };

  const getRate = (staffId, field) => paymentRates.find(r => r.staff_id === staffId)?.[field] || "";

  const saveRates = async () => {
    if (!selectedEvent) return;
    setSaving(true);
    for (const staff of staffProfiles) {
      const rate = paymentRates.find(r => r.staff_id === staff.id);
      if (!rate) continue;
      const { data: existing } = await supabase.from("staff_payment_rates").select("id").eq("project_id", selectedEvent.id).eq("staff_id", staff.id).maybeSingle();
      if (existing) {
        await supabase.from("staff_payment_rates").update({ project_fee: parseFloat(rate.project_fee)||0, per_diem: parseFloat(rate.per_diem)||0, transport: parseFloat(rate.transport)||0 }).eq("id", existing.id);
      } else if (rate.project_fee || rate.per_diem || rate.transport) {
        await supabase.from("staff_payment_rates").insert({ project_id: selectedEvent.id, staff_id: staff.id, staff_name: staff.name, project_fee: parseFloat(rate.project_fee)||0, per_diem: parseFloat(rate.per_diem)||0, transport: parseFloat(rate.transport)||0 });
      }
    }
    const { data: fms } = await supabase.from("profiles").select("id").eq("role","Finance Manager");
    for (const fm of fms||[]) {
      await supabase.from("notifications").insert({ user_id: fm.id, title: "Staff Payment Rates Set — " + selectedEvent.name, message: "CEO has set staff payment rates for " + selectedEvent.name + ". Staff can now submit payment requests.", type: "finance" });
    }
    setSaving(false);
    alert("Rates saved.");
    loadRates(selectedEvent.id);
  };

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Finance</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Staff Payment Rates</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Set project fee, per diem and transport per staff per event. Staff see locked amounts when submitting requests.</div>
      </div>
      <select value={selectedEvent?.id||""} onChange={e => handleEventSelect(e.target.value)}
        style={{ width:"100%", maxWidth:480, padding:"10px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:10, color:T.textPrimary, fontSize:14, fontFamily:"inherit", marginBottom:20 }}>
        <option value="">Select an event...</option>
        {events.map(e => <option key={e.id} value={e.id}>{e.name}{e.client ? " — "+e.client : ""}</option>)}
      </select>
      {selectedEvent && (
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:14, overflow:"hidden" }}>
          <div style={{ padding:"14px 20px", borderBottom:`1px solid ${T.border}`, background:T.bg }}>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15 }}>{selectedEvent.name}</div>
            <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>Rates set here are locked for staff payment requests on this event</div>
          </div>
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ background:T.bg }}>
                  {["Staff Member","Role",`Project Fee (${getCurrency(activeCountry||user?.country||"Ghana")})`,`Per Diem (${getCurrency(activeCountry||user?.country||"Ghana")})`,`Transport (${getCurrency(activeCountry||user?.country||"Ghana")})`,"Total"].map(h => (
                    <th key={h} style={{ padding:"10px 16px", color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {staffProfiles.map((staff, i) => {
                  const fee = parseFloat(getRate(staff.id,"project_fee")||0);
                  const diem = parseFloat(getRate(staff.id,"per_diem")||0);
                  const transport = parseFloat(getRate(staff.id,"transport")||0);
                  const total = fee + diem + transport;
                  return (
                    <tr key={staff.id} style={{ borderBottom:`1px solid ${T.border}44`, background:i%2===0?"transparent":T.bg+"40" }}>
                      <td style={{ padding:"12px 16px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{staff.name}</td>
                      <td style={{ padding:"12px 16px", color:T.textMuted, fontSize:12 }}>{staff.role}</td>
                      {["project_fee","per_diem","transport"].map(field => (
                        <td key={field} style={{ padding:"8px 16px" }}>
                          <input type="number" value={getRate(staff.id,field)} onChange={e => updateRate(staff.id,field,e.target.value)}
                            placeholder="0" disabled={!isCEO}
                            style={{ width:110, padding:"6px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }} />
                        </td>
                      ))}
                      <td style={{ padding:"12px 16px", color:total>0?T.teal:T.textMuted, fontWeight:800, fontSize:13 }}>{total>0?getCurrency(activeCountry||user?.country||"Ghana")+" "+(total).toLocaleString():"—"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {isCEO && (
            <div style={{ padding:"16px 20px", borderTop:`1px solid ${T.border}` }}>
              <button onClick={saveRates} disabled={saving} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px 28px", borderRadius:10, cursor:"pointer", fontWeight:800, fontSize:14 }}>{saving?"Saving...":"Save Payment Rates"}</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};



const PaymentDirectoryView = ({ user }) => {
  const [staff, setStaff] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [vendorApps, setVendorApps] = useState([]);
  const [tab, setTab] = useState("staff");
  const [search, setSearch] = useState("");

  const load = async () => {
    const [{ data: s }, { data: v }, { data: va }] = await Promise.all([
      supabase.from("profiles").select("id,name,role,bank_name,bank_branch,bank_account_name,bank_account_number,mobile_money_number,bank_details_requested").not("role","in","(Client,Vendor,Board of Directors)").order("name"),
      supabase.from("profiles").select("id,name,service_category,phone,email").eq("role","Vendor").order("name"),
      supabase.from("vendor_applications").select("vendor_name,contact_email,bank_name,bank_address,bank_account_name,account_no,payment_terms,phone,contact_person").eq("status","login-created"),
    ]);
    setStaff(s || []);
    setVendors(v || []);
    setVendorApps(va || []);
  };
  useEffect(() => { load(); }, []);

  const filteredStaff = staff.filter(s => s.name?.toLowerCase().includes(search.toLowerCase()) || s.role?.toLowerCase().includes(search.toLowerCase()));
  const filteredVendors = vendors.filter(v => v.name?.toLowerCase().includes(search.toLowerCase()) || v.service_category?.toLowerCase().includes(search.toLowerCase()));

  const staffWithBank = staff.filter(s => s.bank_name && s.bank_account_number).length;
  const staffWithout = staff.filter(s => !s.bank_name || !s.bank_account_number).length;
  const vendorsWithBank = vendorApps.filter(v => v.bank_name && v.account_no).length;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Finance</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Payment Directory</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Bank details for all staff and vendors</div>
      </div>

      {/* KPI Strip */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:12, marginBottom:24 }}>
        {[
          { label:"Staff with Bank Details", value:staffWithBank+"/"+staff.length, color:T.teal },
          { label:"Staff Missing Details", value:staffWithout, color:staffWithout>0?T.amber:T.teal },
          { label:"Vendors with Bank Details", value:vendorsWithBank+"/"+vendors.length, color:T.cyan },
        ].map(k => (
          <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10 }}>
            <div style={{ color:k.color, fontSize:20, fontWeight:900 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Search + Tabs */}
      <div style={{ display:"flex", gap:12, marginBottom:20, alignItems:"center" }}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search by name or role..."
          style={{ flex:1, padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }} />
        {["staff","vendors"].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{ padding:"8px 20px", borderRadius:20, border:`1px solid ${tab===t?T.cyan:T.border}`, background:tab===t?T.cyan+"20":"none", color:tab===t?T.cyan:T.textMuted, fontWeight:700, fontSize:12, cursor:"pointer", textTransform:"capitalize" }}>{t}</button>
        ))}
      </div>

      {/* Staff Tab */}
      {tab === "staff" && (
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ background:T.bg }}>
                {["Name","Role","Bank Name","Branch","Account Name","Account Number","Mobile Money"].map(h => (
                  <th key={h} style={{ padding:"10px 14px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredStaff.map((s,i) => (
                <tr key={s.id} style={{ borderBottom:i<filteredStaff.length-1?`1px solid ${T.border}44`:"none", background:i%2===0?"transparent":T.bg+"30" }}>
                  <td style={{ padding:"12px 14px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{s.name}</td>
                  <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12 }}>{s.role}</td>
                  <td style={{ padding:"12px 14px", color:s.bank_name?T.textPrimary:T.red, fontSize:12 }}>{s.bank_name||"—"}</td>
                  <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12 }}>{s.bank_branch||"—"}</td>
                  <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12 }}>{s.bank_account_name||"—"}</td>
                  <td style={{ padding:"12px 14px", color:s.bank_account_number?T.teal:T.red, fontWeight:s.bank_account_number?700:400, fontSize:12 }}>{s.bank_account_number||"Missing"}</td>
                  <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12 }}>{s.mobile_money_number||"—"}</td>
                </tr>
              ))}
              {filteredStaff.length===0 && <tr><td colSpan={7} style={{ padding:"40px 0", textAlign:"center", color:T.textMuted }}>No staff found</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {/* Vendors Tab */}
      {tab === "vendors" && (
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ background:T.bg }}>
                {["Vendor","Category","Contact","Bank Name","Account Name","Account Number","Payment Terms"].map(h => (
                  <th key={h} style={{ padding:"10px 14px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredVendors.map((v,i) => {
                const app = vendorApps.find(a => a.contact_email === v.email || a.vendor_name?.trim() === v.name?.trim());
                return (
                  <tr key={v.id} style={{ borderBottom:i<filteredVendors.length-1?`1px solid ${T.border}44`:"none", background:i%2===0?"transparent":T.bg+"30" }}>
                    <td style={{ padding:"12px 14px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{v.name}</td>
                    <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12 }}>{v.service_category||"—"}</td>
                    <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12 }}>{v.phone||"—"}</td>
                    <td style={{ padding:"12px 14px", color:app?.bank_name?T.textPrimary:T.red, fontSize:12 }}>{app?.bank_name||"—"}</td>
                    <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12 }}>{app?.bank_account_name||"—"}</td>
                    <td style={{ padding:"12px 14px", color:app?.account_no?T.teal:T.red, fontWeight:app?.account_no?700:400, fontSize:12 }}>{app?.account_no||"Missing"}</td>
                    <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12 }}>{app?.payment_terms||"—"}</td>
                  </tr>
                );
              })}
              {filteredVendors.length===0 && <tr><td colSpan={7} style={{ padding:"40px 0", textAlign:"center", color:T.textMuted }}>No vendors found</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const ClientPaymentsView = ({ user, activeCountry = "All" }) => {
  const [payments, setPayments] = useState([]);
  const [clients, setClients] = useState([]);
  const [events, setEvents] = useState([]);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ client_id:"", client_name:"", project_id:"", event_name:"", amount:"", payment_date: new Date().toISOString().slice(0,10), payment_method:"Bank Transfer", reference_number:"", zoho_invoice_url:"", notes:"", sales_rep_id:"", sales_rep_name:"" });
  const isFM = user?.role === "Finance Manager";
  const isCEO = user?.role === "CEO";
  const [salesReps, setSalesReps] = useState([]);
  const [editPayment, setEditPayment] = useState(null);

  const load = async () => {
    const [{ data: p }, { data: c }, { data: e }, { data: sr }] = await Promise.all([
      user.role === 'Country Manager'
        ? supabase.from("client_payments").select("*").eq("country", activeCountry).order("payment_date", { ascending: false })
        : supabase.from("client_payments").select("*").order("payment_date", { ascending: false }),
      supabase.from("clients").select("*").order("name"),
      supabase.from("projects").select("*").order("name"),
      supabase.from("profiles").select("id,name,role").or('role.in.("CEO","Sales & Marketing"),has_sm_access.eq.true'),
    ]);
    setPayments(p || []);
    setClients(c || []);
    setEvents(e || []);
    setSalesReps(sr || []);
  };
  useEffect(() => { load(); }, []);

  const totalReceived = payments.reduce((s,p) => s + parseFloat(p.amount||0), 0);
  const thisYear = new Date().getFullYear();
  const ytd = payments.filter(p => p.payment_date && new Date(p.payment_date).getFullYear() === thisYear).reduce((s,p) => s + parseFloat(p.amount||0), 0);

  const handleSave = async () => {
    if (!form.amount || !form.payment_date) { alert("Amount and date are required."); return; }
    setSaving(true);
    await supabase.from("client_payments").insert({
      ...form,
      amount: parseFloat(form.amount),
      recorded_by: user.id,
      recorded_by_name: user.name,
      sales_rep_id: form.sales_rep_id || null,
      sales_rep_name: form.sales_rep_name || null,
    });
    // Notify CEO if recorded by Finance
    if (isFM) {
      const { data: ceos } = await supabase.from("profiles").select("id").eq("role","CEO");
      for (const ceo of ceos||[]) {
        await supabase.from("notifications").insert({ user_id: ceo.id, title: "Client Payment Recorded — " + (form.client_name||"Client"), message: user.name + " recorded a payment of GHS " + parseFloat(form.amount).toLocaleString() + " from " + (form.client_name||"client") + " for " + (form.event_name||"event"), type: "finance" });
      }
    }
    setSaving(false);
    setModal(false);
    setForm({ client_id:"", client_name:"", project_id:"", event_name:"", amount:"", payment_date: new Date().toISOString().slice(0,10), payment_method:"Bank Transfer", reference_number:"", zoho_invoice_url:"", notes:"", sales_rep_id:"", sales_rep_name:"" });
    load();
  };

  const methodColors = { "Bank Transfer": T.cyan, "Cheque": T.amber, "Cash": T.teal, "Mobile Money": "#8B5CF6", "Other": T.textMuted };

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Finance</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Client Payments</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Record and track payments received from clients</div>
        </div>
        {isFM && <button onClick={() => setModal(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Record Payment</button>}
      </div>

      {/* KPI Strip */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(160px,1fr))", gap:12, marginBottom:24 }}>
        {[
          { label:"Total Received", value:fmtMoney(totalReceived, activeCountry), color:T.teal },
          { label:"Revenue YTD", value:fmtMoney(ytd, activeCountry), color:T.cyan },
          { label:"Payments Recorded", value:payments.length, color:T.amber },
          { label:"This Month", value:fmtMoney(payments.filter(p => { const d = new Date(p.payment_date); const n = new Date(); return d.getMonth()===n.getMonth()&&d.getFullYear()===n.getFullYear(); }).reduce((s,p)=>s+parseFloat(p.amount||0),0), activeCountry), color:T.magenta },
        ].map(k => (
          <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10 }}>
            <div style={{ color:k.color, fontSize:18, fontWeight:900 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Payments Table */}
      {payments.length === 0 ? (
        <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}>
          <div style={{ fontSize:40, marginBottom:16 }}></div>
          <div style={{ color:T.textPrimary, fontWeight:700, fontSize:16 }}>No payments recorded yet</div>
          {isFM && <div style={{ color:T.textMuted, fontSize:13, marginTop:8 }}>Click + Record Payment to log a client payment</div>}
        </div>
      ) : (
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ background:T.bg }}>
                {["Client","Event","Amount","Date","Method","Reference","Sales Rep","Recorded By",""].map(h => (
                  <th key={h} style={{ padding:"10px 16px", color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {payments.map((p, i) => (
                <tr key={p.id} style={{ borderBottom: i<payments.length-1?`1px solid ${T.border}44`:"none", background:i%2===0?"transparent":T.bg+"30" }}>
                  <td style={{ padding:"12px 16px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{p.client_name||"—"}</td>
                  <td style={{ padding:"12px 16px", color:T.textSecondary, fontSize:12 }}>{p.event_name||"—"}</td>
                  <td style={{ padding:"12px 16px", color:T.teal, fontWeight:800, fontSize:13 }}>{fmtMoney(p.amount||0, p.country||"Ghana")}</td>
                  <td style={{ padding:"12px 16px", color:T.textMuted, fontSize:12 }}>{p.payment_date ? new Date(p.payment_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : "—"}</td>
                  <td style={{ padding:"12px 16px" }}>
                    <span style={{ background:(methodColors[p.payment_method]||T.textMuted)+"18", color:methodColors[p.payment_method]||T.textMuted, padding:"2px 10px", borderRadius:20, fontSize:11, fontWeight:700 }}>{p.payment_method||"—"}</span>
                  </td>
                  <td style={{ padding:"12px 16px", color:T.textMuted, fontSize:12 }}>{p.reference_number||"—"}</td>
                  <td style={{ padding:"12px 16px" }}>
                    {p.sales_rep_name ? <span style={{ color:T.cyan, fontSize:12, fontWeight:600 }}>{p.sales_rep_name}</span> : <span style={{ color:T.red, fontSize:11 }}>Unassigned</span>}
                  </td>
                  <td style={{ padding:"12px 16px", color:T.textMuted, fontSize:11 }}>{p.recorded_by_name||"—"}</td>
                  <td style={{ padding:"12px 16px" }}>
                    <button onClick={() => setEditPayment(p)} style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"3px 10px", borderRadius:6, cursor:"pointer", fontSize:10, fontWeight:700 }}> Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Edit Payment Modal */}
      {editPayment && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setEditPayment(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:440, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Edit Payment</div>
            <div style={{ color:T.teal, fontWeight:800, fontSize:16, marginBottom:20 }}>{(user?.country==="Nigeria"?"NGN":"GHS")+" "}{parseFloat(editPayment.amount||0).toLocaleString()} — {editPayment.client_name}</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Assign Sales Rep</label>
              <select value={editPayment.sales_rep_id||""} onChange={e=>{ const r=salesReps.find(x=>x.id===e.target.value); setEditPayment(p=>({...p,sales_rep_id:e.target.value,sales_rep_name:r?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">No attribution</option>
                {salesReps.map(r=><option key={r.id} value={r.id}>{r.name} ({r.role})</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Commission Rate (%)</label>
              <input type="number" value={editPayment.commission_rate||5} onChange={e=>setEditPayment(p=>({...p,commission_rate:parseFloat(e.target.value)||5,commission_amount:parseFloat(editPayment.amount||0)*parseFloat(e.target.value||5)/100}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div style={{ background:T.amber+"10", border:`1px solid ${T.amber}30`, borderRadius:8, padding:"12px 16px", display:"flex", justifyContent:"space-between" }}>
                <span style={{ color:T.textMuted, fontSize:12 }}>Commission Payable</span>
                <span style={{ color:T.amber, fontWeight:900, fontSize:18 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+((parseFloat(editPayment.amount||0)*(editPayment.commission_rate||5)/100).toLocaleString()).toLocaleString()}</span>
              </div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={async () => {
                const commAmt = parseFloat(editPayment.amount||0)*(editPayment.commission_rate||5)/100;
                await supabase.from("client_payments").update({ sales_rep_id:editPayment.sales_rep_id||null, sales_rep_name:editPayment.sales_rep_name||null, commission_rate:editPayment.commission_rate||5, commission_amount:commAmt }).eq("id", editPayment.id);
                setEditPayment(null); load();
              }} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>Save</button>
              <button onClick={()=>setEditPayment(null)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Record Payment Modal */}
      {modal && isFM && (
        <div style={{ position:"fixed", inset:0, zIndex:600, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:520, maxHeight:"90vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Record Client Payment</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:20 }}>Log a payment received from a client</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Client *</label>
                <select value={form.client_id} onChange={e => { const c = clients.find(x => x.id===e.target.value); setForm(f=>({...f, client_id:e.target.value, client_name:c?.name||c?.company||""})); }}
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">Select client...</option>
                  {clients.map(c => <option key={c.id} value={c.id}>{c.company||c.name}</option>)}
                </select>
              </div>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Event</label>
                <select value={form.project_id} onChange={e => { const ev = events.find(x => x.id===e.target.value); setForm(f=>({...f, project_id:e.target.value, event_name:ev?.name||""})); }}
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">Select event...</option>
                  {events.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
                </select>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Amount (${getCurrency(activeCountry||user?.country||"Ghana")}) *</label>
                  <input type="number" value={form.amount} onChange={e=>setForm(f=>({...f,amount:e.target.value}))} placeholder="0.00"
                    style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                </div>
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Payment Date *</label>
                  <input type="date" value={form.payment_date} onChange={e=>setForm(f=>({...f,payment_date:e.target.value}))}
                    style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                </div>
              </div>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Payment Method</label>
                <select value={form.payment_method} onChange={e=>setForm(f=>({...f,payment_method:e.target.value}))}
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {["Bank Transfer","Cheque","Cash","Mobile Money","Other"].map(m => <option key={m}>{m}</option>)}
                </select>
              </div>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Reference Number</label>
                <input value={form.reference_number} onChange={e=>setForm(f=>({...f,reference_number:e.target.value}))} placeholder="Bank ref, cheque no, etc."
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
              </div>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Zoho Invoice URL (Optional)</label>
                <input value={form.zoho_invoice_url} onChange={e=>setForm(f=>({...f,zoho_invoice_url:e.target.value}))} placeholder="https://..."
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
              </div>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Notes</label>
                <textarea value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} rows={2} placeholder="Any additional notes..."
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} />
              </div>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Attribute to Sales Rep</label>
                <select value={form.sales_rep_id} onChange={e=>{ const r=salesReps.find(x=>x.id===e.target.value); setForm(f=>({...f,sales_rep_id:e.target.value,sales_rep_name:r?.name||""})); }}
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">No attribution</option>
                  {salesReps.map(r=><option key={r.id} value={r.id}>{r.name} ({r.role})</option>)}
                </select>
              </div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Record Payment"}</button>
              <button onClick={() => setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};



const ClientActionItemsView = ({ user }) => {
  const [clients, setClients] = useState([]);
  const [events, setEvents] = useState([]);
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ client_id:"", project_id:"", title:"", description:"", due_date:"" });

  const load = async () => {
    const [{ data: c }, { data: e }, { data: i }] = await Promise.all([
      supabase.from("clients").select("id,name,company").order("name"),
      supabase.from("projects").select("id,name").order("name"),
      supabase.from("client_action_items").select("*").order("created_at", { ascending: false }),
    ]);
    setClients(c || []);
    setEvents(e || []);
    setItems(i || []);
  };
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    if (!form.title || !form.client_id) { alert("Title and client are required."); return; }
    setSaving(true);
    await supabase.from("client_action_items").insert({ ...form, created_by: user.id, status:"pending" });
    // Notify client
    const { data: clientProfile } = await supabase.from("clients").select("profile_id").eq("id", form.client_id).single();
    if (clientProfile?.profile_id) {
      await supabase.from("notifications").insert({ user_id: clientProfile.profile_id, title:"Action Required — "+form.title, message: form.description || "Stretchfield requires your attention on: "+form.title+(form.due_date?" Due: "+new Date(form.due_date).toLocaleDateString("en-GB"):""), type:"task" });
    }
    setSaving(false);
    setModal(false);
    setForm({ client_id:"", project_id:"", title:"", description:"", due_date:"" });
    load();
  };

  const pending = items.filter(i => i.status === "pending").length;
  const completed = items.filter(i => i.status === "completed").length;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Clients</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Client Action Items</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{pending} pending · {completed} completed</div>
        </div>
        {["CEO","Strategy & Events Lead"].includes(user.role) && (
          <button onClick={() => setModal(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Add Action Item</button>
        )}
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {items.map(item => {
          const client = clients.find(c => c.id === item.client_id);
          const event = events.find(e => e.id === item.project_id);
          const isOverdue = item.due_date && new Date(item.due_date) < new Date() && item.status === "pending";
          const statusColor = item.status==="completed" ? T.teal : isOverdue ? T.red : T.amber;
          return (
            <div key={item.id} style={{ background:T.surface, border:`1px solid ${isOverdue?T.red+"30":T.border}`, borderLeft:`3px solid ${statusColor}`, borderRadius:12, padding:"16px 20px", display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:4 }}>
                  <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>{item.title}</div>
                  <span style={{ background:statusColor+"18", color:statusColor, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700 }}>{item.status==="completed"?"Done":isOverdue?"Overdue":"Pending"}</span>
                </div>
                <div style={{ color:T.textMuted, fontSize:12 }}>{client?.company||client?.name||"—"} {event?" · "+event.name:""}</div>
                {item.description && <div style={{ color:T.textSecondary, fontSize:12, marginTop:4 }}>{item.description}</div>}
                {item.due_date && <div style={{ color:isOverdue?T.red:T.textMuted, fontSize:11, marginTop:4 }}>Due: {new Date(item.due_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</div>}
              </div>
            </div>
          );
        })}
        {items.length === 0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, color:T.textMuted }}>No action items yet</div>}
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:500, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>New Client Action Item</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Client *</label>
                <select value={form.client_id} onChange={e=>setForm(f=>({...f,client_id:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">Select client...</option>
                  {clients.map(c => <option key={c.id} value={c.id}>{c.company||c.name}</option>)}
                </select>
              </div>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Event</label>
                <select value={form.project_id} onChange={e=>setForm(f=>({...f,project_id:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">Select event...</option>
                  {events.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
                </select>
              </div>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Action Title *</label>
                <input value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} placeholder="e.g. Approve final run of show"
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
              </div>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Description</label>
                <textarea value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} rows={2} placeholder="Additional context..."
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} />
              </div>
              <div>
                <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Due Date</label>
                <input type="date" value={form.due_date} onChange={e=>setForm(f=>({...f,due_date:e.target.value}))}
                  style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
              </div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Create Action Item"}</button>
              <button onClick={() => setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ClientEventsView = ({ user }) => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Find client record by profile_id, then filter projects by client_id
    supabase.from("clients").select("id").eq("profile_id", user.id).maybeSingle().then(({ data: clientRecord }) => {
      if (!clientRecord) {
        // Fallback: match by email
        supabase.from("clients").select("id").eq("email", user.email).maybeSingle().then(({ data: clientByEmail }) => {
          if (!clientByEmail) { setLoading(false); return; }
          supabase.from("projects").select("*").eq("client_id", clientByEmail.id).order("event_date", { ascending: false }).then(({ data }) => {
            setEvents(data || []);
            setLoading(false);
          });
        });
        return;
      }
      supabase.from("projects").select("*").eq("client_id", clientRecord.id).order("event_date", { ascending: false }).then(({ data }) => {
        setEvents(data || []);
        setLoading(false);
      });
    });
  }, [user.id]);

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  if (selectedEvent) return <EventClientPortalPanel event={selectedEvent} client={{email: user?.email, name: user?.name}} user={user} onClose={() => setSelectedEvent(null)} />;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Events</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Your Events</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{events.length} event{events.length!==1?"s":""} managed by Stretchfield</div>
      </div>
      {events.length === 0 ? (
        <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}>
          <div style={{ fontSize:40, marginBottom:16 }}></div>
          <div style={{ color:T.textPrimary, fontWeight:700, fontSize:16 }}>No events yet</div>
        </div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
          {events.map(e => {
            const eventDate = e.event_date ? new Date(e.event_date) : null;
            const now = new Date();
            const daysLeft = eventDate ? Math.ceil((eventDate - now) / 86400000) : null;
            const isPast = daysLeft !== null && daysLeft < 0;
            const dotColor = isPast ? T.textMuted : daysLeft !== null && daysLeft <= 7 ? T.red : T.teal;
            return (
              <div key={e.id} onClick={() => setSelectedEvent(e)} style={{ background:T.surface, border:`1px solid ${T.border}`, borderLeft:`3px solid ${dotColor}`, borderRadius:12, padding:"18px 20px", cursor:"pointer" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                  <div>
                    <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:4 }}>{e.event_category||"Event"}</div>
                    <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16 }}>{e.name}</div>
                    <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{eventDate ? eventDate.toLocaleDateString("en-GB",{weekday:"long",day:"numeric",month:"long",year:"numeric"}) : "Date TBC"}</div>
                  </div>
                  <div style={{ display:"flex", gap:8, alignItems:"center", flexShrink:0, marginLeft:16 }}>
                    {daysLeft !== null && (
                      <div style={{ background:`${dotColor}18`, border:`1px solid ${dotColor}30`, borderRadius:8, padding:"6px 12px", textAlign:"center" }}>
                        <div style={{ color:dotColor, fontSize:16, fontWeight:900 }}>{isPast ? Math.abs(daysLeft) : daysLeft===0?"Today":daysLeft}</div>
                        <div style={{ color:dotColor, fontSize:9, textTransform:"uppercase" }}>{isPast?"days ago":"days"}</div>
                      </div>
                    )}
                    <span style={{ color:T.cyan, fontSize:12, fontWeight:700 }}>Open →</span>
                  </div>
                </div>
                <div style={{ marginTop:10, display:"flex", gap:8, flexWrap:"wrap" }}>
                  <span style={{ background:T.bg, color:T.textMuted, padding:"2px 10px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"uppercase" }}>{e.phase||"Planning"}</span>
                  {e.client && <span style={{ background:T.cyan+"15", color:T.cyan, padding:"2px 10px", borderRadius:20, fontSize:10, fontWeight:700 }}>{e.client}</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};


const PublicVendorApplicationForm = () => {
  const [form, setForm] = React.useState({
    vendor_name: "", vendor_type: "", contact_person: "", contact_email: "",
    phone: "", address: "", country: "Ghana",
    bank_name: "", bank_address: "", bank_account_name: "", account_no: "",
    swift_code: "", bank_phone: "", bank_email: "", payment_terms: "",
    form_completed_by: "", position_in_company: "", date_submitted: new Date().toISOString().slice(0,10),
  });
  const [saving, setSaving] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState("");
  const [step, setStep] = React.useState(1);
  const [busRegFile, setBusRegFile] = React.useState(null);
  const [vatFile, setVatFile] = React.useState(null);
  const [uploadProgress, setUploadProgress] = React.useState("");

  const VENDOR_TYPES = ["Event Lighting","Events Ushering","Photography","Videography","Catering",
    "Entertainment Provider (MC, DJ, Live Band, Performers)","Event Decor","Event Production Company",
    "Event Refreshment","Furniture & Equipment Rental","Gift & Merchandise Supplier",
    "Health & Safety Provider","Printing Company","Registration & Badging Service",
    "Security Service","Technology Provider","Transportation (Shuttle, Car Rental)","Venue Provider","Audio Visual","Other"];

  const handleSubmit = async () => {
    if (!form.vendor_name || !form.contact_email || !form.vendor_type || !form.country) {
      setError("Company name, email, vendor type and country are required."); return;
    }
    setSaving(true); setError("");
    let busRegUrl = null;
    let vatUrl = null;
    // Upload business registration
    if (busRegFile) {
      setUploadProgress("Uploading business registration...");
      const ext = busRegFile.name.split('.').pop();
      const path = `${Date.now()}-busreg.${ext}`;
      const { error: upErr } = await supabase.storage.from('vendor-docs').upload(path, busRegFile, { upsert: true });
      if (!upErr) {
        const { data: urlData } = supabase.storage.from('vendor-docs').getPublicUrl(path);
        busRegUrl = urlData.publicUrl;
      } else { console.error('Business reg upload error:', upErr.message); }
    }
    if (vatFile) {
      setUploadProgress("Uploading VAT certificate...");
      const ext = vatFile.name.split('.').pop();
      const path = `${Date.now()}-vat.${ext}`;
      const { error: upErr } = await supabase.storage.from('vendor-docs').upload(path, vatFile, { upsert: true });
      if (!upErr) {
        const { data: urlData } = supabase.storage.from('vendor-docs').getPublicUrl(path);
        vatUrl = urlData.publicUrl;
      } else { console.error('VAT upload error:', upErr.message); }
    }
    setUploadProgress("Submitting application...");
    const { error: err } = await supabase.from("vendor_applications").insert({
      ...form,
      status: "submitted",
      date_submitted: new Date().toISOString().slice(0,10),
      business_reg_url: busRegUrl,
      vat_cert_url: vatUrl,
    });
    if (err) { setError("Submission failed: " + err.message); setSaving(false); return; }
    // Notify VM
    const { data: vms } = await supabase.from("profiles").select("id").eq("role","Vendor Manager");
    for (const vm of vms||[]) {
      await supabase.from("notifications").insert({ user_id: vm.id, title: "New Vendor Application — "+form.vendor_name, message: form.vendor_name+" has submitted a vendor application for "+form.vendor_type+". Review in Vendor Applications.", type: "vendor_application" });
    }
    setSaving(false); setSubmitted(true);
  };

  const inputStyle = { width:"100%", padding:"10px 14px", background:"#F8FAFC", border:"1px solid #E2E8F0", borderRadius:8, color:"#0F172A", fontSize:14, fontFamily:"inherit", outline:"none", boxSizing:"border-box" };
  const labelStyle = { color:"#64748B", fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", display:"block", marginBottom:5 };
  const sectionStyle = { marginBottom:28 };
  const sectionTitle = { color:"#00C8FF", fontSize:12, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:14, paddingBottom:8, borderBottom:"2px solid #00C8FF20" };

  if (submitted) return (
    <div style={{ minHeight:"100vh", background:"#F1F5F9", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"#fff", borderRadius:20, padding:"48px 40px", maxWidth:480, width:"100%", textAlign:"center", boxShadow:"0 20px 60px rgba(0,0,0,0.1)" }}>
        <div style={{ width:64, height:64, background:"#10B98115", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 20px", fontSize:28 }}></div>
        <h2 style={{ color:"#0F172A", fontWeight:900, fontSize:24, marginBottom:12 }}>Application Submitted!</h2>
        <p style={{ color:"#64748B", fontSize:15, lineHeight:1.6, marginBottom:24 }}>Thank you <strong>{form.vendor_name}</strong>. Your application has been received and is under review. Our team will contact you at <strong>{form.contact_email}</strong> within 2-3 business days.</p>
        <div style={{ background:"#F8FAFC", borderRadius:10, padding:"14px 18px", marginBottom:24 }}>
          <div style={{ color:"#64748B", fontSize:12 }}>Reference</div>
          <div style={{ color:"#00C8FF", fontWeight:800, fontSize:16, fontFamily:"monospace" }}>APP-{Date.now().toString().slice(-6)}</div>
        </div>
        <p style={{ color:"#94A3B8", fontSize:12 }}>Stretchfield WorkRoom · workroom.stretchfield.com</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", background:"#F1F5F9", padding:"32px 20px" }}>
      <div style={{ maxWidth:680, margin:"0 auto" }}>
        {/* Header */}
        <div style={{ background:"#060B14", borderRadius:"16px 16px 0 0", padding:"28px 36px", marginBottom:0 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div style={{ display:"flex", alignItems:"center", gap:14 }}>
              <img src="/stretchfield-logo.png" alt="Stretchfield" style={{ height:44, objectFit:"contain" }} />
              <div>
                <div style={{ color:"#00C8FF", fontSize:18, fontWeight:900, letterSpacing:"0.05em" }}>STRETCHFIELD</div>
                <div style={{ color:"#5A6E8A", fontSize:11, marginTop:2 }}>Vendor Registration Form</div>
              </div>
            </div>
            <div style={{ color:"#5A6E8A", fontSize:11, textAlign:"right" }}>
              <div style={{ color:"#E8F0FF", fontWeight:700 }}>Step {step} of 3</div>
              <div style={{ width:120, height:4, background:"#1A2E4A", borderRadius:2, marginTop:6 }}>
                <div style={{ width:(step/3*100)+"%", height:"100%", background:"linear-gradient(90deg,#00C8FF,#00E5C8)", borderRadius:2, transition:"width 0.3s" }} />
              </div>
            </div>
          </div>
        </div>

        {/* Form Body */}
        <div style={{ background:"#fff", borderRadius:"0 0 16px 16px", padding:"36px", boxShadow:"0 10px 40px rgba(0,0,0,0.08)" }}>
          {error && <div style={{ background:"#FEF2F2", border:"1px solid #FCA5A5", borderRadius:8, padding:"10px 14px", color:"#DC2626", fontSize:13, marginBottom:20 }}>{error}</div>}

          {step === 1 && (
            <div>
              <h3 style={{ color:"#0F172A", fontWeight:900, fontSize:18, marginBottom:6 }}>Company Information</h3>
              <p style={{ color:"#64748B", fontSize:13, marginBottom:24 }}>Tell us about your business</p>
              <div style={sectionStyle}>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
                  <div style={{ gridColumn:"1/-1" }}>
                    <label style={labelStyle}>Company / Vendor Name *</label>
                    <input value={form.vendor_name} onChange={e=>setForm(f=>({...f,vendor_name:e.target.value}))} style={inputStyle} placeholder="e.g. Acme Events Ltd" />
                  </div>
                  <div style={{ gridColumn:"1/-1" }}>
                    <label style={labelStyle}>Service Category *</label>
                    <select value={form.vendor_type} onChange={e=>setForm(f=>({...f,vendor_type:e.target.value}))} style={inputStyle}>
                      <option value="">Select your service category...</option>
                      {VENDOR_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Country *</label>
                    <select value={form.country} onChange={e=>setForm(f=>({...f,country:e.target.value}))} style={inputStyle}>
                      <option value="Ghana">Ghana</option>
                      <option value="Nigeria">Nigeria</option>
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Phone Number *</label>
                    <input value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value}))} style={inputStyle} placeholder="+233 XX XXX XXXX" />
                  </div>
                  <div style={{ gridColumn:"1/-1" }}>
                    <label style={labelStyle}>Address</label>
                    <input value={form.address} onChange={e=>setForm(f=>({...f,address:e.target.value}))} style={inputStyle} placeholder="Street, City" />
                  </div>
                </div>
              </div>
            </div>
          )}

          {step === 2 && (
            <div>
              <h3 style={{ color:"#0F172A", fontWeight:900, fontSize:18, marginBottom:6 }}>Contact Details</h3>
              <p style={{ color:"#64748B", fontSize:13, marginBottom:24 }}>Primary contact information</p>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
                <div>
                  <label style={labelStyle}>Contact Person *</label>
                  <input value={form.contact_person} onChange={e=>setForm(f=>({...f,contact_person:e.target.value}))} style={inputStyle} placeholder="Full name" />
                </div>
                <div>
                  <label style={labelStyle}>Position in Company</label>
                  <input value={form.position_in_company} onChange={e=>setForm(f=>({...f,position_in_company:e.target.value}))} style={inputStyle} placeholder="e.g. CEO, Manager" />
                </div>
                <div style={{ gridColumn:"1/-1" }}>
                  <label style={labelStyle}>Email Address *</label>
                  <input type="email" value={form.contact_email} onChange={e=>setForm(f=>({...f,contact_email:e.target.value}))} style={inputStyle} placeholder="email@company.com" />
                </div>
              </div>
            </div>
          )}

          {step === 3 && (
            <div>
              <h3 style={{ color:"#0F172A", fontWeight:900, fontSize:18, marginBottom:6 }}>Bank Details</h3>
              <p style={{ color:"#64748B", fontSize:13, marginBottom:24 }}>Payment information (optional — can be completed later)</p>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
                <div>
                  <label style={labelStyle}>Bank Name</label>
                  <input value={form.bank_name} onChange={e=>setForm(f=>({...f,bank_name:e.target.value}))} style={inputStyle} placeholder="e.g. GCB Bank" />
                </div>
                <div>
                  <label style={labelStyle}>Account Number</label>
                  <input value={form.account_no} onChange={e=>setForm(f=>({...f,account_no:e.target.value}))} style={inputStyle} placeholder="Account number" />
                </div>
                <div>
                  <label style={labelStyle}>Account Name</label>
                  <input value={form.bank_account_name} onChange={e=>setForm(f=>({...f,bank_account_name:e.target.value}))} style={inputStyle} placeholder="Name on account" />
                </div>
                <div>
                  <label style={labelStyle}>Payment Terms</label>
                  <select value={form.payment_terms} onChange={e=>setForm(f=>({...f,payment_terms:e.target.value}))} style={inputStyle}>
                    <option value="">Select...</option>
                    <option value="Immediate">Immediate</option>
                    <option value="Net 7 days">Net 7 days</option>
                    <option value="Net 14 days">Net 14 days</option>
                    <option value="Net 30 days">Net 30 days</option>
                    <option value="50% upfront, balance on completion">50% upfront, balance on completion</option>
                    <option value="100% upfront">100% upfront</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Form Completed By</label>
                  <input value={form.form_completed_by} onChange={e=>setForm(f=>({...f,form_completed_by:e.target.value}))} style={inputStyle} placeholder="Full name" />
                </div>
                <div>
                  <label style={labelStyle}>Date</label>
                  <input type="date" value={form.date_submitted} onChange={e=>setForm(f=>({...f,date_submitted:e.target.value}))} style={inputStyle} />
                </div>
              </div>
              {/* Document uploads */}
              <div style={{ marginTop:20, paddingTop:20, borderTop:"1px solid #E2E8F0" }}>
                <div style={{ color:"#0F172A", fontWeight:800, fontSize:14, marginBottom:14 }}>Supporting Documents</div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
                  <div>
                    <label style={labelStyle}>Business Registration Certificate</label>
                    <div style={{ border:"2px dashed #CBD5E1", borderRadius:8, padding:"16px", textAlign:"center", cursor:"pointer", background:"#F8FAFC" }}
                      onClick={() => document.getElementById('busreg-upload').click()}>
                      <div style={{ color:"#64748B", fontSize:12 }}>{busRegFile ? busRegFile.name : "Click to upload PDF or image"}</div>
                      <input id="busreg-upload" type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display:"none" }} onChange={e=>setBusRegFile(e.target.files[0])} />
                    </div>
                  </div>
                  <div>
                    <label style={labelStyle}>VAT Certificate (optional)</label>
                    <div style={{ border:"2px dashed #CBD5E1", borderRadius:8, padding:"16px", textAlign:"center", cursor:"pointer", background:"#F8FAFC" }}
                      onClick={() => document.getElementById('vat-upload').click()}>
                      <div style={{ color:"#64748B", fontSize:12 }}>{vatFile ? vatFile.name : "Click to upload PDF or image"}</div>
                      <input id="vat-upload" type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display:"none" }} onChange={e=>setVatFile(e.target.files[0])} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Navigation */}
          <div style={{ display:"flex", gap:12, marginTop:32, paddingTop:24, borderTop:"1px solid #E2E8F0" }}>
            {step > 1 && (
              <button onClick={() => setStep(s => s-1)} style={{ padding:"12px 24px", borderRadius:8, border:"1px solid #E2E8F0", background:"none", color:"#64748B", fontWeight:700, fontSize:14, cursor:"pointer" }}>Back</button>
            )}
            {step < 3 ? (
              <button onClick={() => {
                if (step === 1 && (!form.vendor_name || !form.vendor_type || !form.country)) { setError("Please fill in all required fields."); return; }
                if (step === 2 && (!form.contact_person || !form.contact_email)) { setError("Contact person and email are required."); return; }
                setError(""); setStep(s => s+1);
              }} style={{ flex:1, padding:"12px", borderRadius:8, border:"none", background:"linear-gradient(135deg,#00C8FF,#00E5C8)", color:"#060B14", fontWeight:800, fontSize:14, cursor:"pointer" }}>Continue</button>
            ) : (
              <button onClick={handleSubmit} disabled={saving} style={{ flex:1, padding:"12px", borderRadius:8, border:"none", background:"linear-gradient(135deg,#00C8FF,#00E5C8)", color:"#060B14", fontWeight:800, fontSize:14, cursor:saving?"not-allowed":"pointer", opacity:saving?0.7:1 }}>{saving?(uploadProgress||"Submitting..."):"Submit Application"}</button>
            )}
          </div>
        </div>

        <p style={{ textAlign:"center", color:"#94A3B8", fontSize:11, marginTop:16 }}>Stretchfield WorkRoom · workroom.stretchfield.com · Secure submission</p>
      </div>
    </div>
  );
};


const CMDashboard = ({ user, onTab, activeCountry }) => {
  const [events, setEvents] = React.useState([]);
  const [opportunities, setOpps] = React.useState([]);
  const [vendors, setVendors] = React.useState([]);
  const [clientPayments, setClientPayments] = React.useState([]);
  const [vouchers, setVouchers] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const country = user?.country || 'Nigeria';
  const currency = country === 'Nigeria' ? 'NGN' : 'GHS';

  React.useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const [ev, op, vp, cp, vo] = await Promise.all([
          supabase.from('projects').select('*').eq('country', country).order('event_date', { ascending: true }),
          supabase.from('opportunities').select('*').eq('country', country).order('created_at', { ascending: false }),
          supabase.from('profiles').select('*').eq('role', 'Vendor').eq('country', country),
          supabase.from('client_payments').select('*').eq('country', country).order('payment_date', { ascending: false }),
          supabase.from('payment_vouchers').select('*').eq('country', country).order('created_at', { ascending: false }),
        ]);
        setEvents(ev.data || []);
        setOpps(op.data || []);
        setVendors(vp.data || []);
        setClientPayments(cp.data || []);
        setVouchers(vo.data || []);
      } catch(e) { console.error('CM Dashboard load error:', e); }
      setLoading(false);
    };
    load();
  }, [country]);

  const now = new Date();
  const greeting = now.getHours() < 12 ? 'Good Morning' : now.getHours() < 17 ? 'Good Afternoon' : 'Good Evening';
  const dateStr = now.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  const activeEvents = events.filter(e => !['Completed','Cancelled','completed','cancelled'].includes(e.phase||''));
  const upcomingEvents = events.filter(e => e.event_date && new Date(e.event_date) >= now).slice(0, 3);
  const totalRevenue = clientPayments.reduce((s, p) => s + parseFloat(p.amount||0), 0);
  const pipelineValue = opportunities.filter(o => !['won','lost','Converted'].includes(o.status)).reduce((s,o) => s + parseFloat(o.value||0), 0);
  const pendingVouchers = vouchers.filter(v => ['pending_approval','approved'].includes(v.status));
  const recentOpps = opportunities.slice(0, 4);

  const fmtAmt = (amt) => currency + ' ' + parseFloat(amt||0).toLocaleString();

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'60vh' }}>
      <div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
    </div>
  );

  return (
    <div style={{ animation:'fadeUp 0.35s ease' }}>
      {/* Hero */}
      <div style={{ background:`linear-gradient(135deg, ${T.bgDeep} 0%, #0D1F36 60%, ${T.bgDeep} 100%)`, border:`1px solid ${T.border}`, borderRadius:16, padding:'32px 36px', marginBottom:24, position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', top:-60, right:-60, width:280, height:280, background:`radial-gradient(circle, ${T.cyan}08, transparent 70%)`, pointerEvents:'none' }} />
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:16 }}>
          <div>
            <div style={{ color:T.textMuted, fontSize:11, fontWeight:600, letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:6 }}>{dateStr}</div>
            <h1 style={{ margin:'0 0 6px', fontSize:28, fontWeight:900, color:T.textPrimary, letterSpacing:'-0.03em' }}>{greeting}, {user?.name?.split(' ')[0]}.</h1>
            <div style={{ color:T.textMuted, fontSize:14, marginTop:4 }}>
              {activeEvents.length} active event{activeEvents.length!==1?'s':''} in flight
              {pendingVouchers.length > 0 && <span style={{ color:T.amber, fontWeight:700 }}> · {pendingVouchers.length} payment{pendingVouchers.length!==1?'s':''} awaiting signature</span>}
            </div>
          </div>
          <div style={{ display:'flex', gap:8, alignItems:'center' }}>

            {pendingVouchers.length > 0 && (
              <button onClick={() => onTab && onTab('payment-authorisation')} style={{ background:T.amber+'15', border:`1px solid ${T.amber}40`, color:T.amber, padding:'10px 18px', borderRadius:10, cursor:'pointer', fontWeight:800, fontSize:13 }}>
                Sign Payments ({pendingVouchers.length})
              </button>
            )}
            <button onClick={() => onTab && onTab('events')} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:'none', color:'#060B14', padding:'10px 20px', borderRadius:10, cursor:'pointer', fontWeight:800, fontSize:13 }}>
              View All Events
            </button>
          </div>
        </div>
        {/* KPI Stats */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(130px,1fr))', gap:12, marginTop:24, paddingTop:20, borderTop:`1px solid ${T.border}44` }}>
          {[
            { label:'Active Events', value:activeEvents.length, color:T.cyan },
            { label:'Pipeline Value', value:fmtAmt(Math.round(pipelineValue/1000))+'k', color:T.teal },
            { label:'Revenue YTD', value:fmtAmt(Math.round(totalRevenue/1000))+'k', color:'#10B981' },
            { label:'Active Vendors', value:vendors.length, color:T.textSecondary },
            { label:'Pending Payments', value:pendingVouchers.length, color:pendingVouchers.length>0?T.amber:T.textMuted },
          ].map(stat => (
            <div key={stat.label} style={{ background:`${T.bg}80`, borderRadius:10, padding:'12px 14px' }}>
              <div style={{ color:stat.color, fontWeight:900, fontSize:20 }}>{stat.value}</div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', marginTop:3 }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Two column */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20, marginBottom:20 }}>
        {/* Upcoming Events */}
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:24 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.1em' }}>Operations</div>
            <button onClick={() => onTab && onTab('events')} style={{ background:'none', border:'none', color:T.cyan, cursor:'pointer', fontSize:12, fontWeight:700 }}>View all</button>
          </div>
          <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16, marginBottom:12 }}>Upcoming Events</div>
          {upcomingEvents.length === 0 ? (
            <div style={{ color:T.textMuted, fontSize:13, textAlign:'center', padding:'20px 0' }}>No upcoming events</div>
          ) : upcomingEvents.map(e => (
            <div key={e.id} style={{ padding:'10px 0', borderBottom:`1px solid ${T.border}44` }}>
              <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{e.name}</div>
              <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{e.client} · {e.event_date ? new Date(e.event_date).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) : 'TBC'}</div>
              <span style={{ background:T.cyan+'18', color:T.cyan, borderRadius:20, padding:'2px 8px', fontSize:10, fontWeight:700 }}>{e.phase||'Planning'}</span>
            </div>
          ))}
        </div>

        {/* Pipeline */}
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:24 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.1em' }}>Business Development</div>
            <button onClick={() => onTab && onTab('opportunities')} style={{ background:'none', border:'none', color:T.cyan, cursor:'pointer', fontSize:12, fontWeight:700 }}>View all</button>
          </div>
          <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16, marginBottom:12 }}>Pipeline & Revenue</div>
          <div style={{ background:T.bg, borderRadius:8, padding:'12px 14px', marginBottom:12 }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
              <span style={{ color:T.textMuted, fontSize:12 }}>Revenue vs Target</span>
            </div>
            <div style={{ height:6, background:T.border, borderRadius:3, marginBottom:6 }}>
              <div style={{ width:totalRevenue > 0 ? '100%' : '0%', height:'100%', background:`linear-gradient(90deg,${T.cyan},${T.teal})`, borderRadius:3 }} />
            </div>
            <div style={{ color:T.teal, fontSize:13, fontWeight:700 }}>{fmtAmt(totalRevenue)}</div>
          </div>
          {recentOpps.length === 0 ? (
            <div style={{ color:T.textMuted, fontSize:13, textAlign:'center', padding:'20px 0' }}>No opportunities yet</div>
          ) : recentOpps.map(o => (
            <div key={o.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 0', borderBottom:`1px solid ${T.border}44` }}>
              <div>
                <div style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{o.company}</div>
                <div style={{ color:T.textMuted, fontSize:10, textTransform:'uppercase' }}>{o.status}</div>
              </div>
              <div style={{ color:T.amber, fontWeight:700, fontSize:13 }}>{fmtAmt(o.value||0)}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Finance Snapshot */}
      <div style={{ background:`linear-gradient(135deg, #060B14 0%, #0A1628 100%)`, border:`1px solid ${T.border}`, borderRadius:12, padding:24 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
          <div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.1em' }}>Finance</div>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16 }}>Financial Snapshot</div>
          </div>
          <button onClick={() => onTab && onTab('finance')} style={{ background:'none', border:'none', color:T.cyan, cursor:'pointer', fontSize:12, fontWeight:700 }}>Finance</button>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(150px,1fr))', gap:12 }}>
          {[
            { label:'Total Revenue', value:fmtAmt(totalRevenue), color:T.teal },
            { label:'Pending Payments', value:fmtAmt(pendingVouchers.reduce((s,v)=>s+parseFloat(v.amount||0),0)), color:T.amber },
            { label:'Approved Payments', value:fmtAmt(vouchers.filter(v=>v.status==='approved').reduce((s,v)=>s+parseFloat(v.amount||0),0)), color:T.cyan },
            { label:'Vouchers Pending', value:pendingVouchers.length, color:pendingVouchers.length>0?T.amber:T.textMuted },
          ].map(stat => (
            <div key={stat.label} style={{ background:`${T.surface}80`, borderRadius:10, padding:'14px 16px' }}>
              <div style={{ color:stat.color, fontWeight:900, fontSize:18 }}>{stat.value}</div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', marginTop:3 }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


const VendorTransactionsView = ({ user }) => {
  const [invoices, setInvoices] = React.useState([]);
  const [vouchers, setVouchers] = React.useState([]);
  const [pos, setPOs] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [profile, setProfile] = React.useState(null);
  const isMultiCountry = profile?.presence && profile.presence.includes('+');
  const defaultCountry = user?.country || 'Ghana';
  const [selectedCountry, setSelectedCountry] = React.useState(defaultCountry);

  React.useEffect(() => {
    const load = async () => {
      setLoading(true);
      const [inv, pv, po, pr] = await Promise.all([
        supabase.from("vendor_invoices").select("*").eq("vendor_id", user?.id).order("created_at", { ascending: false }),
        supabase.from("payment_vouchers").select("*").eq("payee", user?.name).order("created_at", { ascending: false }),
        supabase.from("purchase_orders").select("*").eq("vendor_id", user?.id).order("created_at", { ascending: false }),
        supabase.from("profiles").select("presence,country").eq("id", user?.id).single(),
      ]);
      setInvoices(inv.data || []);
      setVouchers(pv.data || []);
      setPOs(po.data || []);
      setProfile(pr.data || null);
      setLoading(false);
    };
    load();
  }, [user?.id]);

  const presenceCountries = profile?.presence ? 
    profile.presence.split('+').map(c => c === 'GH' ? 'Ghana' : c === 'NG' ? 'Nigeria' : c === 'KE' ? 'Kenya' : c) : 
    [defaultCountry];

  const filteredInvoices = invoices.filter(i => !isMultiCountry || (i.country||'Ghana') === selectedCountry);
  const filteredVouchers = vouchers.filter(v => !isMultiCountry || (v.country||'Ghana') === selectedCountry);
  const filteredPOs = pos.filter(p => !isMultiCountry || (p.country||'Ghana') === selectedCountry);

  const totalInvoiced = filteredInvoices.reduce((s, i) => s + parseFloat(i.amount||0), 0);
  const totalPaid = filteredVouchers.filter(v => v.status === 'paid').reduce((s, v) => s + parseFloat(v.amount||0), 0);
  const totalPending = filteredVouchers.filter(v => ['pending_approval','approved'].includes(v.status)).reduce((s, v) => s + parseFloat(v.amount||0), 0);
  const outstanding = totalInvoiced - totalPaid;
  const currency = selectedCountry === 'Nigeria' ? 'NGN' : 'GHS';
  const fmt = (amt) => currency + ' ' + parseFloat(amt||0).toLocaleString();

  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'40vh' }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:'50%', animation:'spin 0.8s linear infinite' }} /></div>;

  return (
    <div style={{ animation:'fadeUp 0.35s ease' }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
          <div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:'0.14em', textTransform:'uppercase', marginBottom:6 }}>Finance</div>
            <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Financial Transactions</h2>
            <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Your invoices, payments and outstanding balances</div>
          </div>
          {isMultiCountry && (
            <div>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:'uppercase', display:'block', marginBottom:4 }}>Country</label>
              <select value={selectedCountry} onChange={e => setSelectedCountry(e.target.value)} style={{ padding:'8px 12px', background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:'inherit', outline:'none' }}>
                {presenceCountries.map(c => <option key={c} value={c}>{c === 'Nigeria' ? '🇳🇬' : c === 'Ghana' ? '🇬🇭' : '🌍'} {c}</option>)}
              </select>
            </div>
          )}
        </div>
      </div>

      {/* KPI Cards */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(160px,1fr))', gap:12, marginBottom:28 }}>
        {[
          { label:'Total Invoiced', value:fmt(totalInvoiced), color:T.cyan },
          { label:'Total Paid', value:fmt(totalPaid), color:'#10B981' },
          { label:'Payment in Progress', value:fmt(totalPending), color:T.amber },
          { label:'Outstanding Balance', value:fmt(outstanding), color:outstanding > 0 ? T.red : T.teal },
        ].map(k => (
          <div key={k.label} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:'16px 18px' }}>
            <div style={{ color:k.color, fontWeight:900, fontSize:18 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', marginTop:4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Invoices */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, marginBottom:20 }}>
        <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15, marginBottom:14 }}>Invoices Submitted</div>
        {filteredInvoices.length === 0 ? (
          <div style={{ color:T.textMuted, fontSize:13, textAlign:'center', padding:'20px 0' }}>No invoices submitted yet</div>
        ) : (
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ borderBottom:`1px solid ${T.border}` }}>
                {['Event','Amount','Submitted','Status'].map(h => (
                  <th key={h} style={{ padding:'8px 12px', textAlign:'left', color:T.textMuted, fontSize:10, fontWeight:700, textTransform:'uppercase' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredInvoices.map(inv => {
                const statusColor = { submitted:T.amber, reviewed:T.cyan, approved:T.teal, paid:'#10B981', rejected:T.red }[inv.status] || T.textMuted;
                return (
                  <tr key={inv.id} style={{ borderBottom:`1px solid ${T.border}44` }}>
                    <td style={{ padding:'10px 12px', color:T.textPrimary, fontSize:13 }}>{inv.event_name||'—'}</td>
                    <td style={{ padding:'10px 12px', color:T.textPrimary, fontWeight:700, fontSize:13 }}>{fmt(inv.amount)}</td>
                    <td style={{ padding:'10px 12px', color:T.textMuted, fontSize:12 }}>{inv.created_at ? new Date(inv.created_at).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) : '—'}</td>
                    <td style={{ padding:'10px 12px' }}>
                      <span style={{ background:statusColor+'18', color:statusColor, border:`1px solid ${statusColor}30`, borderRadius:20, padding:'2px 10px', fontSize:10, fontWeight:700, textTransform:'uppercase' }}>{inv.status}</span>
                      {inv.invoice_url && <a href={inv.invoice_url} target="_blank" rel="noreferrer" style={{ marginLeft:8, color:T.cyan, fontSize:10, fontWeight:700 }}>View</a>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Payments */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20, marginBottom:20 }}>
        <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15, marginBottom:14 }}>Payment History</div>
        {filteredVouchers.length === 0 ? (
          <div style={{ color:T.textMuted, fontSize:13, textAlign:'center', padding:'20px 0' }}>No payments processed yet</div>
        ) : (
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ borderBottom:`1px solid ${T.border}` }}>
                {['Voucher','Description','Amount','Date','Status'].map(h => (
                  <th key={h} style={{ padding:'8px 12px', textAlign:'left', color:T.textMuted, fontSize:10, fontWeight:700, textTransform:'uppercase' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredVouchers.map(v => {
                const sc = { paid:'#10B981', approved:T.teal, pending_approval:T.amber, rejected:T.red }[v.status] || T.textMuted;
                return (
                  <tr key={v.id} style={{ borderBottom:`1px solid ${T.border}44` }}>
                    <td style={{ padding:'10px 12px', color:T.cyan, fontWeight:700, fontSize:12 }}>{v.voucher_number}</td>
                    <td style={{ padding:'10px 12px', color:T.textMuted, fontSize:12 }}>{v.description||'—'}</td>
                    <td style={{ padding:'10px 12px', color:T.textPrimary, fontWeight:700 }}>{fmt(v.amount)}</td>
                    <td style={{ padding:'10px 12px', color:T.textMuted, fontSize:12 }}>{v.paid_at ? new Date(v.paid_at).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) : '—'}</td>
                    <td style={{ padding:'10px 12px' }}>
                      <span style={{ background:sc+'18', color:sc, border:`1px solid ${sc}30`, borderRadius:20, padding:'2px 10px', fontSize:10, fontWeight:700, textTransform:'uppercase' }}>{v.status==='paid'?'Paid':v.status==='approved'?'Processing':v.status==='pending_approval'?'Pending':'—'}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Purchase Orders */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20 }}>
        <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15, marginBottom:14 }}>Purchase Orders</div>
        {pos.length === 0 ? (
          <div style={{ color:T.textMuted, fontSize:13, textAlign:'center', padding:'20px 0' }}>No purchase orders yet</div>
        ) : (
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ borderBottom:`1px solid ${T.border}` }}>
                {['PO Number','Event','Amount','Status'].map(h => (
                  <th key={h} style={{ padding:'8px 12px', textAlign:'left', color:T.textMuted, fontSize:10, fontWeight:700, textTransform:'uppercase' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredPOs.map(po => {
                const sc = { paid:'#10B981', sent:T.cyan, invoiced:T.amber, fully_signed:T.teal }[po.status] || T.textMuted;
                return (
                  <tr key={po.id} style={{ borderBottom:`1px solid ${T.border}44` }}>
                    <td style={{ padding:'10px 12px', color:T.cyan, fontWeight:700, fontSize:12 }}>{po.internal_po_number}</td>
                    <td style={{ padding:'10px 12px', color:T.textPrimary, fontSize:13 }}>{po.event_name||'—'}</td>
                    <td style={{ padding:'10px 12px', color:T.textPrimary, fontWeight:700 }}>{fmt(po.amount)}</td>
                    <td style={{ padding:'10px 12px' }}>
                      <span style={{ background:sc+'18', color:sc, border:`1px solid ${sc}30`, borderRadius:20, padding:'2px 10px', fontSize:10, fontWeight:700, textTransform:'uppercase' }}>{po.status}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export { PublicVendorApplicationForm };
export default function StretchfieldWorkRoom({ user: propUser, profile: propProfile, onLogout }) {
  // Public vendor application route
  if (typeof window !== 'undefined' && window.location.search.includes('apply=vendor')) {
    return <PublicVendorApplicationForm />;
  }
  const [activeTab, setActiveTab] = useState("dashboard");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [openGroups, setOpenGroups] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [pendingResourceId, setPendingResourceId] = useState(null);
  const [showAccountSettings, setShowAccountSettings] = useState(false);
  const [activeCountry, setActiveCountry] = useState("Ghana");
  const isMobile = useIsMobile();

  const buildUser = (p) => p ? {
    id: p.id,
    name: p.name,
    role: p.role,
    email: p.email,
    avatar: p.avatar,
    avatar_url: p.avatar_url || null,
    phone: p.phone || "",
    has_sm_access: p.has_sm_access || false,
    country: p.country || 'Ghana',
    saved_signature: p.saved_signature || null,
  } : null;

  const [currentUser, setCurrentUser] = useState(() => buildUser(propProfile));

  // Sync if propProfile changes (e.g. on login)
  React.useEffect(() => {
    if (propProfile) setCurrentUser(buildUser(propProfile));
  }, [propProfile?.id]);

  useEffect(() => {
    if (!currentUser?.id) return;
    const fetchUnread = async () => {
      const { data } = await supabase.from('notifications').select('id').eq('user_id', currentUser.id).eq('read', false);
      setUnreadCount((data || []).length);
    };
    fetchUnread();
    const sub = supabase.channel('live-notif-' + currentUser.id)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'notifications', filter: 'user_id=eq.' + currentUser.id }, () => fetchUnread())
      .subscribe();
    return () => supabase.removeChannel(sub);
  }, [currentUser?.id]);

  if (!currentUser) return (
    <div style={{ minHeight: "100vh", background: T.bg, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16, fontFamily: "DM Sans, sans-serif" }}>
      <div style={{ width: 44, height: 44, border: `3px solid ${T.border}`, borderTop: `3px solid ${T.cyan}`, borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
      <div style={{ color: T.textMuted, fontSize: 13, letterSpacing: "0.06em" }}>Loading WorkRoom...</div>
    </div>
  );

  const renderContent = () => {
    try {
    const role = currentUser.role;
    switch (activeTab) {
      case "dashboard":
        if (role === "CEO") return <CEODashboard onTab={setActiveTab} user={currentUser} activeCountry={activeCountry} />;
        if (role === "Board of Directors") return <BoardDashboard user={currentUser} />;
        if (role === "Country Manager") return <CMDashboard onTab={setActiveTab} user={currentUser} activeCountry={currentUser.country} />;
        if (role === "Vendor") return <VendorDashboard user={currentUser} onNavigate={setActiveTab} />;
        if (role === "Client") return <ClientDashboard user={currentUser} />;
        if (role === "Finance Manager") return <FinanceManagerDashboard user={currentUser} onTab={setActiveTab} activeCountry={activeCountry} />;
        if (role === "Sales & Marketing") return <CRMDashboardSM user={currentUser} />;
        if (role === "Strategy & Events Lead") return <StaffDashboard user={currentUser} />;
        if (role === "Vendor Manager") return <VendorManagerDashboard user={currentUser} activeCountry={activeCountry} />;
        return <StaffDashboard user={currentUser} />;
      case "events": return <EventsView user={currentUser} userRole={currentUser.role} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "tasks": return <EventsView user={currentUser} userRole={currentUser.role} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "vendors": return <VendorsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "invoices": return <InvoicesView />;
      case "clients": return <ClientsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "users": return <UsersView user={currentUser} />;
      case "email-test": return <EmailTestPanel user={currentUser} />;
      case "crm": return <CRMView onNavigate={setActiveTab} user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "crm-insights": return ["CEO","Country Manager"].includes(currentUser.role) ? <CRMDashboardCEO user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} /> : <CRMDashboardSM user={currentUser} />;
      case "sales-dashboard": return <SalesDashboardView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "sm-tasks": return <SMTasksView user={currentUser} />;
      case "strategy-overview": return <StrategyOverviewView />;
      case "opportunities": return <OpportunitiesView user={currentUser} onNavigate={(tab) => setActiveTab(tab)} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "client-financials": return <CEOClientFinanceView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "client-finance": return <ClientFinanceView user={currentUser} />;
      case "feedback-summary": return <FeedbackView userRole={currentUser.role} />;
      case "finance": return <FinanceDashboard user={currentUser} onTab={setActiveTab} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "finance-approvals": return <FinanceApprovalsView user={currentUser} />;
      case "scorecards": return <VendorScorecardsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "vendor-analytics": return <VendorAnalyticsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "payment-authorisation": return <PaymentAuthorisationView user={currentUser} onNavigate={(tab) => setActiveTab(tab)} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "staff-payment-rates": return <StaffPaymentRatesView user={currentUser} />;
      case "client-payments": return <ClientPaymentsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "payment-directory": return <PaymentDirectoryView user={currentUser} />;
      case "budget-vs-actuals": return <BudgetVsActualsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "cash-flow": return <CashFlowView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "zoho-sync-status": return <ZohoSyncStatusView user={currentUser} />;
      case "audit-trail": return <AuditTrailView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "board-report": return <BoardReportView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "strategic-goals": return <StrategicGoalsView user={currentUser} />;
      case "client-health": return <ClientHealthView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "team-performance": return <TeamPerformanceView user={currentUser} />;
      case "risk-register": return <RiskRegisterView user={currentUser} />;
      case "decision-log": return <DecisionLogView user={currentUser} />;
      case "competitor-intel": return <CompetitorIntelView user={currentUser} />;
      case "revenue-forecast": return <RevenueForecastView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "vendor-performance": return <VendorPerformanceView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "vendor-contracts": return <VendorContractsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "preferred-vendors": return <PreferredVendorsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "vendor-watchlist": return <VendorWatchlistView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "vendor-comms": return <VendorCommsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "vendor-sla": return <VendorSLAView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "market-rates": return <MarketRatesView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "procurement-report": return <ProcurementReportView user={currentUser} />;
      case "event-briefs": return <EventBriefsView user={currentUser} />;
      case "event-milestones": return <EventMilestonesView user={currentUser} />;
      case "esl-performance": return <ESLPerformanceView user={currentUser} />;
      case "outreach-planner": return <OutreachPlannerView user={currentUser} />;
      case "ceo-broadcast": return <CEOBroadcastView user={currentUser} />;
      case "approval-queue": return <ApprovalQueueView user={currentUser} onNavigate={setActiveTab} activeCountry={activeCountry} />;
      case "vendor-ratings": return <VendorRatingsView user={currentUser} />;
      case "rfps": return <RfpModule user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "rfp-approvals": return <RfpModule mode="approvals" user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "my-rfps": return <VendorRfpPortal user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "rff-approvals": return <RFFApprovalsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "vendor-assignment": return <VendorAssignmentView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "budgets": return <BudgetView user={currentUser} />;
      case "expenses": return <ExpenseView user={currentUser} />;
      case "finance-reports": return <FinanceReportsView user={currentUser} />;
      case "event-reports": return <EventReportsView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "feedback": return <FeedbackView userRole={currentUser.role} />;
      case "calendar": return <CalendarView user={currentUser} onNavigate={(tab) => setActiveTab(tab)} />;
      case "zoho-books": return <ZohoBooksView user={currentUser} />;
      case "vendor-onboarding": return <VendorOnboardingView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "event-analysis": return <EventTypeAnalysisView user={currentUser} />;
      case "impact-intelligence": return <ImpactIntelligenceSummary user={currentUser} />;
      case "hr": return <HRView user={currentUser} />;
      case "strategy-map": return <StrategyMapView user={currentUser} />;
      case "quotes-received": return <QuotesReceivedView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "quote-comparison": return <QuoteComparisonView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "contract-awards": return <ContractAwardApprovalView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "gig-confirmation": return <GigConfirmationView user={currentUser} />;
      case "purchase-orders": return <PurchaseOrderView user={currentUser} activeCountry={currentUser.role === "CEO" ? activeCountry : ["Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "po-signing": return <PurchaseOrderView user={currentUser} />;
      case "vendor-invoices": return <FinanceInvoicesView user={currentUser} activeCountry={["CEO","Finance Manager","Vendor Manager"].includes(currentUser.role) ? activeCountry : currentUser.country} />;
      case "vendor-invoices-submit": return <VendorInvoiceView user={currentUser} />;
      case "vendor-transactions": return <VendorTransactionsView user={currentUser} />;
      case "notifications": return <NotificationsView user={currentUser} onNavigate={(tab, resourceId) => { setActiveTab(tab); if (resourceId) setPendingResourceId(resourceId); }} />;
      case "rffs": return <VendorRFFsView user={currentUser} />;
      case "my-pos": return <VendorPurchaseOrders user={currentUser} onNavigate={setActiveTab} onDownload={(po) => downloadPDF(generatePOPDF(po, { name: po.vendor_name, email: currentUser.email }, { title: po.rff_title || po.event_name }, { name: po.event_name }), "PO-" + (po.internal_po_number || po.id) + ".html")} />;
      case "quotes": return <VendorQuotesView user={currentUser} />;
      case "vendor-tasks": return <VendorTasksView user={currentUser} />;
      case "client-events": return <ClientEventsView user={currentUser} />;
      case "client-action-items": return <ClientActionItemsView user={currentUser} />;
      case "client-docs": return <div style={{ color: T.textSecondary }}>Documents will appear here.</div>;
      default: return null;
    }
    } catch(e) {
      return <div style={{color:"red", padding:20}}>{e.message} — {e.stack?.split("\n")[1]}</div>;
    }
  };

  return (
    <ThemeProvider>
    <div className="sf-layout" style={{ display: "flex", height: "100vh", background: T.bg, fontFamily: "'DM Sans', sans-serif", color: T.textPrimary, overflow: "hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;0,9..40,900&family=Cormorant+Garamond:wght@300;400;500;600;700&display=swap');
        * { box-sizing: border-box; }
        * { -webkit-tap-highlight-color: transparent; box-sizing: border-box; }
        ::-webkit-scrollbar { width: 6px; } ::-webkit-scrollbar-track { background: ${T.bg}; } ::-webkit-scrollbar-thumb { background: ${T.border}44; border-radius: 3px; }
        input, select, textarea { font-family: inherit; }
        .sf-bottom-nav { display: none; }
        .sf-mobile-header { display: none; }
        .sf-drawer { display: none; }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes slideIn { from { transform: translateX(-100%); } to { transform: translateX(0); } }
        @keyframes slideUp { from { transform: translateY(100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .sf-animate { animation: fadeUp 0.35s ease forwards; }
        @media (max-width: 768px) {
          .sf-mobile-header { display: flex !important; }
          .sf-sidebar { display: none !important; }
          .sf-bottom-nav { display: flex !important; }
          .sf-drawer { display: flex !important; }
          .sf-content { padding: 12px !important; padding-top: 68px !important; padding-bottom: 76px !important; margin-left: 0 !important; }
          .sf-layout { flex-direction: column !important; }
          .sf-hide-mobile { display: none !important; }
          .sf-full-mobile { width: 100% !important; max-width: 100% !important; }
          .sf-stack-mobile { flex-direction: column !important; }
          .sf-card-mobile { border-radius: 12px !important; }
          table { display: block; overflow-x: auto; -webkit-overflow-scrolling: touch; }
          input, select, textarea, button { font-size: 16px !important; }
        }
      `}</style>

      <div className="sf-sidebar" style={{ display: isMobile ? "none" : "flex", width: sidebarCollapsed ? 58 : 228, background: T.bgDeep, borderRight: `1px solid ${T.border}`, flexDirection: "column", transition: "width 0.28s cubic-bezier(0.22,1,0.36,1)", flexShrink: 0, overflow: "hidden", position: "relative" }}>
        <div style={{ position: "absolute", top: 0, right: 0, width: 1, height: "100%", background: `linear-gradient(180deg, transparent, ${T.cyan}25, ${T.magenta}18, transparent)`, pointerEvents: "none" }} />
        <div style={{ padding: "16px 12px 14px", borderBottom: `1px solid ${T.border}`, display: "flex", alignItems: "center", gap: 10, minHeight: 60 }}>
          <img src={LOGO_SRC} alt="S" style={{ width: 28, height: 28, objectFit: "contain", flexShrink: 0, borderRadius: 6 }} />
          {!sidebarCollapsed && (
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13, letterSpacing: "0.05em" }}>Stretchfield</div>
              <div style={{ color: T.textMuted, fontSize: 9, letterSpacing: "0.18em", textTransform: "uppercase", marginTop: 1 }}>WorkRoom</div>
            </div>
          )}
        </div>
        <nav style={{ flex: 1, padding: "10px 8px", overflowY: "auto" }}>
          {(() => {
            const navItems = getNavItems(currentUser.role, currentUser);
            const isGroupedNav = ["CEO","Country Manager"].includes(currentUser.role);

            if (!isGroupedNav) {
              return navItems.map(item => {
                const active = activeTab === item.id;
                return (
                  <button key={item.id} onClick={() => setActiveTab(item.id)} style={{
                    width: "100%", display: "flex", alignItems: "center", gap: 10,
                    padding: "9px 10px", borderRadius: 6, border: "none", cursor: "pointer",
                    background: active ? T.cyan + "18" : "none",
                    color: active ? T.cyan : T.textMuted,
                    fontWeight: active ? 700 : 400, fontSize: 11,
                    marginBottom: 1, textAlign: "left",
                    borderLeft: active ? `2px solid ${T.cyan}` : "2px solid transparent",
                    letterSpacing: "0.04em", textTransform: "uppercase",
                    transition: "all 0.15s", whiteSpace: "nowrap", overflow: "hidden",
                  }}
                    onMouseEnter={e => { if (!active) { e.currentTarget.style.background = T.surface; e.currentTarget.style.color = T.textSecondary; } }}
                    onMouseLeave={e => { if (!active) { e.currentTarget.style.background = "none"; e.currentTarget.style.color = T.textMuted; } }}
                  >
                    <span style={{ fontSize: 5, flexShrink: 0, color: active ? T.cyan : T.textGhost }}></span>
                    {!sidebarCollapsed && item.label}
                  </button>
                );
              });
            }

            // Grouped nav (CEO + Country Manager)
            return navItems.map(item => {
              if (!item.children) {
                // Top level single item (Dashboard, Notifications, Calendar)
                const active = activeTab === item.id;
                return (
                  <button key={item.id} onClick={() => setActiveTab(item.id)} style={{
                    width: "100%", display: "flex", alignItems: "center", gap: 8,
                    padding: "9px 10px", borderRadius: 6, border: "none", cursor: "pointer",
                    background: active ? T.cyan+"18" : "none",
                    color: active ? T.cyan : T.textMuted,
                    fontWeight: active ? 700 : 400, fontSize: 11,
                    marginBottom: 2, textAlign: "left",
                    borderLeft: active ? `2px solid ${T.cyan}` : "2px solid transparent",
                    letterSpacing: "0.04em", textTransform: "uppercase",
                    transition: "all 0.15s",
                  }}>
                    {!sidebarCollapsed && item.label}
                    {sidebarCollapsed && item.label?.slice(0,2)}
                  </button>
                );
              }

              // Group item with children
              const isGroupActive = item.children && item.children.some(c => c.id === activeTab);
              const groupOpen = openGroups[item.id] !== false; // default open

              return (
                <div key={item.id} style={{ marginBottom: 2 }}>
                  <button onClick={() => setOpenGroups(g => ({...g, [item.id]: !groupOpen}))} style={{
                    width: "100%", display: "flex", alignItems: "center", gap: 8,
                    padding: "8px 10px", borderRadius: 6, border: "none", cursor: "pointer",
                    background: isGroupActive ? T.cyan+"10" : "none",
                    color: isGroupActive ? T.cyan : T.textSecondary,
                    fontWeight: 700, fontSize: 10,
                    textAlign: "left", letterSpacing: "0.06em", textTransform: "uppercase",
                    transition: "all 0.15s",
                  }}>
                    {!sidebarCollapsed && (
                      <>
                        <span style={{ flex: 1 }}>{item.label}</span>
                        <span style={{ fontSize: 11, transition: "transform 0.2s", transform: groupOpen ? "rotate(90deg)" : "rotate(0deg)", opacity: 0.7, fontWeight: 700 }}>›</span>
                      </>
                    )}
                    {sidebarCollapsed && <span style={{ fontSize: 9 }}></span>}
                  </button>
                  {groupOpen && !sidebarCollapsed && (
                    <div style={{ paddingLeft: 12, marginTop: 2 }}>
                      {item.children.map(child => {
                        const active = activeTab === child.id;
                        return (
                          <button key={child.id} onClick={() => setActiveTab(child.id)} style={{
                            width: "100%", display: "flex", alignItems: "center", gap: 8,
                            padding: "7px 10px", borderRadius: 5, border: "none", cursor: "pointer",
                            background: active ? T.cyan+"20" : "none",
                            color: active ? T.cyan : T.textMuted,
                            fontWeight: active ? 700 : 400, fontSize: 11,
                            marginBottom: 1, textAlign: "left",
                            borderLeft: active ? `2px solid ${T.cyan}` : "2px solid transparent",
                            letterSpacing: "0.03em",
                            transition: "all 0.15s",
                          }}
                            onMouseEnter={e => { if (!active) { e.currentTarget.style.background = T.surface; e.currentTarget.style.color = T.textSecondary; } }}
                            onMouseLeave={e => { if (!active) { e.currentTarget.style.background = "none"; e.currentTarget.style.color = T.textMuted; } }}
                          >
                            <span style={{ fontSize: 4, color: active ? T.cyan : T.textGhost }}></span>
                            {child.label}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            });
          })()}
        </nav>
        <div style={{ padding: "10px 10px 12px", borderTop: `1px solid ${T.border}` }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px", borderRadius: 6, marginBottom: 8 }}>
            <Avatar initials={currentUser.avatar} size={28} color={T.cyan} />
            {!sidebarCollapsed && <div style={{ overflow: "hidden", flex: 1 }}>
              <div style={{ color: T.textPrimary, fontSize: 11, fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{currentUser.name}</div>
              <div style={{ color: T.textMuted, fontSize: 10 }}>{currentUser.role}</div>
            </div>}
          </div>
          {!sidebarCollapsed && <div style={{ marginBottom: 6 }}><ThemeToggle /></div>}
          <button onClick={() => setSidebarCollapsed(!sidebarCollapsed)} style={{ width: "100%", background: "none", border: `1px solid ${T.border}`, color: T.textMuted, borderRadius: 6, padding: "5px", cursor: "pointer", fontSize: 13, transition: "all 0.15s" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = T.cyan + "60"; e.currentTarget.style.color = T.cyan; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.color = T.textMuted; }}
          >{sidebarCollapsed ? "›" : "‹"}</button>
        </div>
      </div>

      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ padding: "0 24px", height: 56, display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: `1px solid ${T.border}`, background: T.bgDeep, flexShrink: 0, position: "relative" }}>
          {/* Left — country toggle or breadcrumb */}
          <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0, flex: 1 }}>
            <div style={{ background:T.cyan+"15", border:"1px solid "+T.cyan+"30", borderRadius:20, padding:"4px 12px" }}>
              <span style={{ color:T.cyan, fontSize:11, fontWeight:800 }}>🇬🇭 Ghana WorkRoom</span>
            </div>
          </div>

          {/* Tagline — positioned safely left of controls */}
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none", overflow: "hidden", padding: "0 20px" }}>
            <span style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontStyle: "italic",
              fontWeight: 500,
              fontSize: 12,
              letterSpacing: "0.06em",
              color: T.textMuted,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
            }}>We don't plan events. We engineer impact.</span>
          </div>

          {/* Right — controls */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1, justifyContent: "flex-end" }}>

            <span style={{ color: T.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: "0.04em" }}>{currentUser.name}</span>
            <div style={{ background: T.cyan + "18", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "3px 12px", borderRadius: 20, fontSize: 10, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase" }}>{currentUser.role}</div>
            <button onClick={() => setActiveTab("notifications")} style={{ position: "relative", background: activeTab === "notifications" ? T.cyan + "18" : "none", border: "1px solid " + (activeTab === "notifications" ? T.cyan + "40" : T.border), color: activeTab === "notifications" ? T.cyan : T.textMuted, width: 34, height: 34, borderRadius: 8, cursor: "pointer", fontSize: 15, display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.15s" }}>
              🔔
              {unreadCount > 0 && (
                <span style={{ position: "absolute", top: -5, right: -5, background: T.red, color: "#fff", fontSize: 9, fontWeight: 900, borderRadius: "50%", width: 17, height: 17, display: "flex", alignItems: "center", justifyContent: "center", border: "2px solid " + T.bgDeep, boxShadow: `0 0 8px ${T.red}80` }}>
                  {unreadCount > 9 ? "9+" : unreadCount}
                </span>
              )}
            </button>
            <button onClick={() => setShowAccountSettings(true)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "5px 14px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 600, letterSpacing: "0.06em", transition: "all 0.15s" }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = T.cyan + "60"; e.currentTarget.style.color = T.cyan; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.color = T.textMuted; }}
            > Settings</button>
            <button onClick={onLogout} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "5px 14px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 600, letterSpacing: "0.06em", transition: "all 0.15s" }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = T.red + "60"; e.currentTarget.style.color = T.red; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.color = T.textMuted; }}
            >Sign Out</button>
          </div>
        </div>

        <div className="sf-content" style={{ flex: 1, overflowY: "auto", padding: isMobile ? "72px 16px 16px" : 24 }}>
          {renderContent()}
        </div>
      </div>

      {/* Mobile Header */}
      {/*  LUXURY MOBILE HEADER  */}
      <div className="sf-mobile-header" style={{ display: isMobile ? "flex" : "none", position: "fixed", top: 0, left: 0, right: 0, height: 60, background: T.bgDeep+"f0", borderBottom: `1px solid ${T.border}`, alignItems: "center", justifyContent: "space-between", padding: "0 20px", zIndex: 400, backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src={LOGO_SRC} alt="S" style={{ width: 26, height: 26, objectFit: "contain", borderRadius: 6 }} />
          <div>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 13, letterSpacing: "0.04em" }}>Stretchfield</div>
            <div style={{ color: T.textMuted, fontSize: 9, letterSpacing: "0.16em", textTransform: "uppercase" }}>WorkRoom</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ textAlign: "right" }}>
            <div style={{ color: T.textPrimary, fontSize: 11, fontWeight: 700 }}>{currentUser.name?.split(" ")[0]}</div>
            <div style={{ color: T.cyan, fontSize: 9, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase" }}>{currentUser.role}</div>
          </div>
          {unreadCount > 0 && (
            <button onClick={() => setActiveTab("notifications")} style={{ position: "relative", background: "none", border: `1px solid ${T.red}40`, color: T.red, width: 34, height: 34, borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {unreadCount > 9 ? "9+" : unreadCount}
              <div style={{ position: "absolute", top: -3, right: -3, width: 8, height: 8, borderRadius: "50%", background: T.red }} />
            </button>
          )}
          <button onClick={() => setMobileMenuOpen(true)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textPrimary, width: 34, height: 34, borderRadius: 8, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 4 }}>
            <div style={{ width: 14, height: 1.5, background: T.textPrimary, borderRadius: 1 }} />
            <div style={{ width: 10, height: 1.5, background: T.textMuted, borderRadius: 1 }} />
            <div style={{ width: 14, height: 1.5, background: T.textPrimary, borderRadius: 1 }} />
          </button>
        </div>
      </div>

      {/*  LUXURY MOBILE BOTTOM NAV  */}
      {isMobile && (() => {
        const role = currentUser.role;
        const bottomTabs = {
          "CEO": [
            { id: "dashboard", label: "Home" },
            { id: "events", label: "Events" },
            { id: "crm", label: "Leads" },
            { id: "vendors", label: "Vendors" },
            { id: "finance", label: "Finance" },
          ],
          "Country Manager": [
            { id: "dashboard", label: "Home" },
            { id: "events", label: "Events" },
            { id: "vendors", label: "Vendors" },
            { id: "finance", label: "Finance" },
            { id: "calendar", label: "Calendar" },
          ],
          "Strategy & Events Lead": [
            { id: "dashboard", label: "Home" },
            { id: "events", label: "Events" },
            
            { id: "calendar", label: "Calendar" },
            { id: "notifications", label: "Alerts" },
          ],
          "Vendor Manager": [
            { id: "dashboard", label: "Home" },
            { id: "vendors", label: "Vendors" },
            { id: "vendor-assignment", label: "Assign" },
            { id: "vendor-onboarding", label: "Onboard" },
            { id: "calendar", label: "Calendar" },
          ],
          "Finance Manager": [
            { id: "dashboard", label: "Home" },
            { id: "finance", label: "Finance" },
            { id: "purchase-orders", label: "Orders" },
            { id: "vendor-invoices", label: "Invoices" },
            { id: "calendar", label: "Calendar" },
          ],
          "Sales & Marketing": [
            { id: "dashboard", label: "Home" },
            { id: "opportunities", label: "Targets" },
            { id: "crm", label: "Pipeline" },
            { id: "sm-tasks", label: "Tasks" },
            { id: "calendar", label: "Calendar" },
          ],
          "Vendor": [
            { id: "dashboard", label: "Home" },
            { id: "rffs", label: "RFFs" },
            { id: "quotes", label: "Quotes" },
            { id: "vendor-invoices-submit", label: "Invoices" },
            { id: "vendor-tasks", label: "Tasks" },
          ],
          "Client": [
            { id: "dashboard", label: "Home" },
            { id: "client-events", label: "Events" },
            { id: "client-finance", label: "Finance" },
            { id: "notifications", label: "Alerts" },
            { id: "calendar", label: "Calendar" },
          ],
          "Board of Directors": [
            { id: "dashboard", label: "Home" },
            { id: "events", label: "Events" },
            { id: "finance", label: "Finance" },
            { id: "impact-intelligence", label: "Impact" },
            { id: "notifications", label: "Alerts" },
          ],
        };
        const tabs = bottomTabs[role] || [
          { id: "dashboard", label: "Home" },
          { id: "notifications", label: "Alerts" },
          { id: "calendar", label: "Calendar" },
        ];
        return (
          <div className="sf-bottom-nav" style={{
            position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 400,
            background: T.bgDeep+"f0", borderTop: `1px solid ${T.border}`,
            display: "none", alignItems: "stretch",
            paddingBottom: "max(8px, env(safe-area-inset-bottom))",
            backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)",
          }}>
            {tabs.map(tab => {
              const active = activeTab === tab.id;
              return (
                <button key={tab.id} onClick={() => { setActiveTab(tab.id); setMobileMenuOpen(false); }} style={{
                  flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                  gap: 3, background: "none", border: "none", cursor: "pointer",
                  padding: "10px 4px 6px", minWidth: 0, position: "relative",
                }}>
                  {active && <div style={{ position: "absolute", top: 0, left: "20%", right: "20%", height: 2, background: T.cyan, borderRadius: "0 0 2px 2px" }} />}
                  <span style={{
                    color: active ? T.cyan : T.textMuted,
                    fontSize: active ? 10 : 9,
                    fontWeight: active ? 800 : 500,
                    letterSpacing: active ? "0.06em" : "0.04em",
                    textTransform: "uppercase",
                    transition: "all 0.15s",
                    lineHeight: 1.2,
                    textAlign: "center",
                  }}>{tab.label}</span>
                  {tab.id === "notifications" && unreadCount > 0 && (
                    <div style={{ position: "absolute", top: 6, right: "18%", width: 6, height: 6, borderRadius: "50%", background: T.red }} />
                  )}
                </button>
              );
            })}
          </div>
        );
      })()}

      {/*  LUXURY MOBILE DRAWER  */}
      {mobileMenuOpen && (
        <div style={{ position: "fixed", inset: 0, zIndex: 500, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(12px)" }} onClick={() => setMobileMenuOpen(false)}>
          <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: "82vw", maxWidth: 340, background: T.bgDeep, borderRight: `1px solid ${T.border}`, display: "flex", flexDirection: "column", animation: "slideIn 0.28s cubic-bezier(0.22,1,0.36,1)" }} onClick={e => e.stopPropagation()}>

            {/* Drawer Header */}
            <div style={{ padding: "24px 20px 18px", borderBottom: `1px solid ${T.border}` }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                <img src={LOGO_SRC} alt="S" style={{ width: 36, height: 36, objectFit: "contain", borderRadius: 8 }} />
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 15, letterSpacing: "0.04em" }}>Stretchfield</div>
                  <div style={{ color: T.textMuted, fontSize: 9, letterSpacing: "0.2em", textTransform: "uppercase" }}>WorkRoom</div>
                </div>
              </div>
              <div style={{ padding: "12px 14px", background: T.surface, borderRadius: 10, border: `1px solid ${T.border}` }}>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>{currentUser.name}</div>
                <div style={{ color: T.cyan, fontSize: 10, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", marginTop: 2 }}>{currentUser.role}</div>
                {currentUser.country && <div style={{ color: T.textMuted, fontSize: 10, marginTop: 1 }}>{currentUser.country}</div>}
              </div>
            </div>

            {/* Nav Items */}
            <nav style={{ flex: 1, overflowY: "auto", padding: "12px 12px" }}>
              {(() => {
                const navItems = getNavItems(currentUser.role, currentUser);
                const isCEONav = currentUser.role === "CEO";
                if (!isCEONav) {
                  return navItems.map(item => {
                    const active = activeTab === item.id;
                    return (
                      <button key={item.id} onClick={() => { setActiveTab(item.id); setMobileMenuOpen(false); }} style={{
                        width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
                        padding: "12px 14px", borderRadius: 8, border: "none", cursor: "pointer",
                        background: active ? T.cyan+"14" : "none",
                        marginBottom: 2, textAlign: "left",
                        borderLeft: active ? `2px solid ${T.cyan}` : "2px solid transparent",
                      }}>
                        <span style={{ color: active ? T.cyan : T.textSecondary, fontWeight: active ? 700 : 400, fontSize: 13, letterSpacing: "0.03em" }}>{item.label}</span>
                        {active && <div style={{ width: 4, height: 4, borderRadius: "50%", background: T.cyan }} />}
                      </button>
                    );
                  });
                }
                return navItems.map(item => {
                  if (!item.children) {
                    const active = activeTab === item.id;
                    return (
                      <button key={item.id} onClick={() => { setActiveTab(item.id); setMobileMenuOpen(false); }} style={{
                        width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
                        padding: "10px 14px", borderRadius: 8, border: "none", cursor: "pointer",
                        background: active ? T.cyan+"14" : "none",
                        marginBottom: 2, textAlign: "left",
                        color: active ? T.cyan : T.textMuted,
                        fontWeight: active ? 700 : 400, fontSize: 11,
                        letterSpacing: "0.1em", textTransform: "uppercase",
                      }}>{item.label}</button>
                    );
                  }
                  const isGroupActive = item.children && item.children.some(c => c.id === activeTab);
                  const [groupOpen, setGroupOpen] = React.useState(true);
                  return (
                    <div key={item.id} style={{ marginBottom: 2 }}>
                      <button onClick={() => setGroupOpen(o => !o)} style={{
                        width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
                        padding: "10px 14px", borderRadius: 8, border: "none", cursor: "pointer",
                        background: isGroupActive ? T.cyan+"10" : "none",
                        color: isGroupActive ? T.cyan : T.textMuted,
                        fontWeight: 800, fontSize: 9, letterSpacing: "0.14em", textTransform: "uppercase",
                        textAlign: "left",
                      }}>
                        <span>{item.label}</span>
                        <span style={{ fontSize: 9, opacity: 0.5, transform: groupOpen ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}></span>
                      </button>
                      {groupOpen && (
                        <div style={{ paddingLeft: 12, paddingBottom: 4 }}>
                          {item.children.map(child => {
                            const active = activeTab === child.id;
                            return (
                              <button key={child.id} onClick={() => { setActiveTab(child.id); setMobileMenuOpen(false); }} style={{
                                width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
                                padding: "10px 14px", borderRadius: 6, border: "none", cursor: "pointer",
                                background: active ? T.cyan+"18" : "none",
                                marginBottom: 1, textAlign: "left",
                                borderLeft: active ? `2px solid ${T.cyan}` : "2px solid transparent",
                              }}>
                                <span style={{ color: active ? T.cyan : T.textMuted, fontWeight: active ? 700 : 400, fontSize: 13 }}>{child.label}</span>
                                {active && <div style={{ width: 4, height: 4, borderRadius: "50%", background: T.cyan }} />}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                });
              })()}
            </nav>

            {/* Drawer Footer */}
            <div style={{ padding: "14px 16px", borderTop: `1px solid ${T.border}`, display: "flex", gap: 8 }}>
              <button onClick={() => { setShowAccountSettings(true); setMobileMenuOpen(false); }} style={{ flex: 1, padding: "10px", background: T.surface, border: `1px solid ${T.border}`, color: T.textMuted, borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase" }}>Settings</button>
              <button onClick={onLogout} style={{ flex: 1, padding: "10px", background: T.red+"12", border: `1px solid ${T.red}25`, color: T.red, borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase" }}>Sign Out</button>
            </div>
          </div>
        </div>
      )}


      {showAccountSettings && (
        <AccountSettingsModal
          user={currentUser}
          onClose={() => setShowAccountSettings(false)}
          onUpdate={async (updated) => {
            // Re-fetch fresh profile from DB to get saved_signature
            const { data: freshProfile } = await supabase.from("profiles").select("*").eq("id", updated.id).single();
            setCurrentUser(freshProfile ? { ...updated, ...freshProfile } : updated);
            setShowAccountSettings(false);
          }}
        />
      )}
    </div>
    </ThemeProvider>
  );
}

const CRMDashboardCEO = ({ user, activeCountry = "All" }) => {
  const [opportunities, setOpportunitys] = useState([]);
  const [targets, setTargets] = useState([]);
  const [members, setMembers] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ rep_id: "", rep_name: "", target_amount: "", period: "monthly", start_date: "", end_date: "" });
  const [saving, setSaving] = useState(false);
  const [editTarget, setEditTarget] = useState(null);
  const [editTargetForm, setEditTargetForm] = useState({});
  const [crmPayments, setCrmPayments] = useState([]);

  const load = async () => {
    const [l, t, m, cp] = await Promise.all([
      (activeCountry && activeCountry !== "All") ? supabase.from("opportunities").select("*").eq("country",activeCountry) : supabase.from("opportunities").select("*"),
      supabase.from("sales_targets").select("*").order("created_at", { ascending: false }),
      supabase.from("profiles").select("*").or('role.in.("CEO","Country Manager","Sales & Marketing"),has_sm_access.eq.true'),
      (activeCountry && activeCountry !== "All") ? supabase.from("client_payments").select("*").eq("country",activeCountry).order("created_at",{ascending:false}) : supabase.from("client_payments").select("*").order("created_at",{ascending:false}),
    ]);
    setOpportunitys(l.data || []);
    setTargets(t.data || []);
    const allMembers = (m.data || []).filter((mem, i, self) => self.findIndex(x => x.id === mem.id) === i);
    const countryMembers = (activeCountry && activeCountry !== "All") ? allMembers.filter(mem => (mem.country||"Ghana") === activeCountry) : allMembers;
    setMembers(countryMembers);
    setCrmPayments(cp.data || []);
  };

  useEffect(() => { load(); }, []);

  const handleDeleteTarget = async (id) => {
    if (!window.confirm("Delete this sales target?")) return;
    await supabase.from("sales_targets").delete().eq("id", id);
    load();
  };

  const handleUpdateTarget = async () => {
    if (!editTarget) return;
    await supabase.from("sales_targets").update({
      target_amount: parseFloat(editTargetForm.target_amount) || 0,
      period: editTargetForm.period,
      start_date: editTargetForm.start_date || null,
      end_date: editTargetForm.end_date || null,
    }).eq("id", editTarget.id);
    setEditTarget(null);
    load();
  };

  const wonOpportunitys = opportunities.filter(l => l.status === "won" || l.status === "Converted");
  const now = new Date();
  const startOfYear = new Date(now.getFullYear(), 0, 1);
  const totalRevenue = crmPayments.reduce((a, p) => a + parseFloat(p.amount||0), 0);
  const ytdRevenue = crmPayments.filter(p => p.payment_date && new Date(p.payment_date) >= startOfYear).reduce((a, p) => a + parseFloat(p.amount||0), 0);
  const avgCycle = wonOpportunitys.filter(l => l.sales_cycle_days).length
    ? Math.round(wonOpportunitys.filter(l => l.sales_cycle_days).reduce((a, l) => a + l.sales_cycle_days, 0) / wonOpportunitys.filter(l => l.sales_cycle_days).length) : 0;
  const closingPct = opportunities.length ? Math.round((wonOpportunitys.length / opportunities.length) * 100) : 0;

  const repStats = members.map(m => {
    const repOpportunitys = opportunities.filter(l => l.assigned_to === m.id || l.created_by === m.id);
    const repWon = repOpportunitys.filter(l => l.status === "won");
    // Use actual client payments attributed to this rep
    const repPayments = crmPayments.filter(p => p.sales_rep_id === m.id);
    const repRevenue = repPayments.reduce((a, p) => a + parseFloat(p.amount||0), 0);
    const repTarget = targets.find(t => t.rep_id === m.id);
    const repCycle = repWon.filter(l => l.sales_cycle_days).length
      ? Math.round(repWon.filter(l => l.sales_cycle_days).reduce((a, l) => a + l.sales_cycle_days, 0) / repWon.filter(l => l.sales_cycle_days).length) : 0;
    return { ...m, repOpportunitys, repWon, repRevenue, repTarget, repCycle, repPayments, closingPct: repOpportunitys.length ? Math.round((repWon.length / repOpportunitys.length) * 100) : 0 };
  }).filter(m => targets.find(t => t.rep_id === m.id) || m.repOpportunitys.length > 0).sort((a, b) => b.repRevenue - a.repRevenue);

  const clientEarnings = wonOpportunitys.reduce((acc, l) => { acc[l.company] = (acc[l.company] || 0) + (l.value || 0); return acc; }, {});

  const handleCreateTarget = async () => {
    if (!form.rep_id || !form.target_amount) return;
    setSaving(true);
    await supabase.from("sales_targets").insert({
      rep_id: form.rep_id, rep_name: form.rep_name,
      target_amount: parseFloat(form.target_amount),
      period: form.period, start_date: form.start_date || null,
      end_date: form.end_date || null, created_by: user.id,
    });
    setModal(false);
    setForm({ rep_id: "", rep_name: "", target_amount: "", period: "monthly", start_date: "", end_date: "" });
    setSaving(false);
    load();
  };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Sales Analytics</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>CRM Insights</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Team performance and revenue overview</div>
        </div>
        <Btn onClick={() => setModal(true)}>+ Set Target</Btn>
      </div>

      {/* KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Total Revenue", value: getCurrency(activeCountry)+" " + totalRevenue.toLocaleString(), color: T.teal },
          { label: "YTD Revenue", value: getCurrency(activeCountry)+" " + ytdRevenue.toLocaleString(), color: T.cyan },
          { label: "Closing Rate", value: closingPct + "%", color: T.blue },
          { label: "Avg Cycle", value: avgCycle + "d", color: T.amber },
          { label: "Deals Won", value: wonOpportunitys.length + " / " + opportunities.length, color: T.magenta },
        ].map((k, i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 18, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 600, marginTop: 4, textTransform: "uppercase", letterSpacing: "0.06em" }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Rep Performance + Revenue by Client */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 16, marginBottom: 16 }}>
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px" }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 16 }}>Rep Performance vs Target</div>
          {repStats.length === 0 ? <div style={{ color: T.textMuted, fontSize: 13 }}>No reps yet.</div>
          : repStats.map((rep, i) => {
            const target = rep.repTarget ? rep.repTarget.target_amount : 0;
            const pct = target ? Math.min(100, Math.round((rep.repRevenue / target) * 100)) : 0;
            const barColor = pct >= 100 ? T.teal : pct >= 60 ? T.cyan : T.amber;
            return (
              <div key={rep.id} style={{ marginBottom: 18, paddingBottom: 18, borderBottom: `1px solid ${T.border}44` }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <div>
                    <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 12 }}>{i === 0 && <span style={{ color: T.amber }}> </span>}Sales Rep {i+1}</div>
                    <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>{rep.repWon.length} won · {rep.closingPct}% close · {rep.repCycle}d</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ color: T.teal, fontWeight: 800, fontSize: 13 }}>{getCurrency(activeCountry)+" "+rep.repRevenue.toLocaleString()}</div>
                    {target > 0 && <div style={{ color: T.textMuted, fontSize: 10 }}>{`of ${getCurrency(activeCountry)} ${target.toLocaleString()}`}</div>}
                  </div>
                </div>
                {target > 0 && (
                  <>
                    <div style={{ height: 4, background: T.border + "44", borderRadius: 2, marginBottom: 4 }}>
                      <div style={{ height: "100%", width: pct + "%", background: barColor, borderRadius: 2 }} />
                    </div>
                    <div style={{ color: T.textMuted, fontSize: 10 }}>{pct}% of target</div>
                  </>
                )}
              </div>
            );
          })}
        </div>

        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px" }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 16 }}>Revenue by Client</div>
          {Object.keys(clientEarnings).length === 0 ? <div style={{ color: T.textMuted, fontSize: 13 }}>No won deals yet.</div>
          : Object.entries(clientEarnings).sort((a,b) => b[1]-a[1]).map(([company, amount]) => (
            <div key={company} style={{ marginBottom: 14 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <div style={{ color: T.textPrimary, fontSize: 12, fontWeight: 600 }}>{company}</div>
                <div style={{ color: T.amber, fontWeight: 800, fontSize: 12 }}>{getCurrency(activeCountry)+" "+amount.toLocaleString()}</div>
              </div>
              <div style={{ height: 3, background: T.border + "44", borderRadius: 2 }}>
                <div style={{ height: "100%", width: Math.round((amount / totalRevenue) * 100) + "%", background: `linear-gradient(90deg, ${T.cyan}, ${T.teal})`, borderRadius: 2 }} />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Sales Targets */}
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, textTransform: "uppercase", letterSpacing: "0.06em" }}>Sales Targets</div>
          <button onClick={() => setModal(true)} style={{ background: "none", border: "none", color: T.cyan, fontSize: 11, cursor: "pointer", fontWeight: 700 }}>+ Set Target →</button>
        </div>
        {targets.length === 0 ? <div style={{ color: T.textMuted, fontSize: 13, padding: "16px 0" }}>No targets set yet.</div>
        : targets.map(t => {
          const rep = repStats.find(r => r.id === t.rep_id);
          const pct = rep ? Math.min(100, Math.round(((rep.repRevenue || 0) / t.target_amount) * 100)) : 0;
          return (
            <div key={t.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: `1px solid ${T.border}44` }}>
              <div>
                <div style={{ color: T.textPrimary, fontWeight: 600, fontSize: 12 }}>{t.rep_name}</div>
                <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>{t.period} · {t.start_date} → {t.end_date}</div>
                <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
                  <button onClick={() => { setEditTarget(t); setEditTargetForm({ target_amount: t.target_amount, period: t.period, start_date: t.start_date || "", end_date: t.end_date || "" }); }} style={{ background: T.cyan+"15", border: "1px solid "+T.cyan+"30", color: T.cyan, padding: "2px 8px", borderRadius: 5, cursor: "pointer", fontSize: 10, fontWeight: 700 }}>Edit</button>
                  <button onClick={() => handleDeleteTarget(t.id)} style={{ background: "#F43F5E15", border: "1px solid #F43F5E30", color: "#F43F5E", padding: "2px 8px", borderRadius: 5, cursor: "pointer", fontSize: 10, fontWeight: 700 }}>Delete</button>
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ color: T.amber, fontWeight: 800, fontSize: 13 }}>{getCurrency(activeCountry)+" "+t.target_amount.toLocaleString()}</div>
                <div style={{ color: pct >= 100 ? T.teal : T.textMuted, fontSize: 10, marginTop: 2 }}>{pct}% achieved</div>
              </div>
            </div>
          );
        })}
      </div>
      {editTarget && (
        <Modal title="Edit Sales Target" onClose={() => setEditTarget(null)}>
          <Input label={`Target Amount (${getCurrency(activeCountry)})`} type="number" value={editTargetForm.target_amount} onChange={v => setEditTargetForm({...editTargetForm, target_amount: v})} />
          <Select label="Period" options={[{ value: "monthly", label: "Monthly" }, { value: "quarterly", label: "Quarterly" }, { value: "yearly", label: "Yearly" }]} value={editTargetForm.period} onChange={v => setEditTargetForm({...editTargetForm, period: v})} />
          <Input label="Start Date" type="date" value={editTargetForm.start_date} onChange={v => setEditTargetForm({...editTargetForm, start_date: v})} />
          <Input label="End Date" type="date" value={editTargetForm.end_date} onChange={v => setEditTargetForm({...editTargetForm, end_date: v})} />
          <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
            <Btn onClick={handleUpdateTarget}>Save Changes</Btn>
            <Btn variant="ghost" onClick={() => setEditTarget(null)}>Cancel</Btn>
          </div>
        </Modal>
      )}

      {modal && (
        <Modal title="Set Sales Target" onClose={() => setModal(false)}>
          <Select label="Sales Rep" options={[{ value: "", label: "Select rep..." }, ...members.map(m => ({ value: m.id, label: m.name + " — " + m.role }))]}
            value={form.rep_id} onChange={v => { const m = members.find(x => x.id === v); setForm({ ...form, rep_id: v, rep_name: m ? m.name : "" }); }} />
          <Input label={`Target Amount (${getCurrency(activeCountry)})`} type="number" placeholder="0" value={form.target_amount} onChange={v => setForm({ ...form, target_amount: v })} />
          <Select label="Period" options={[{ value: "monthly", label: "Monthly" }, { value: "quarterly", label: "Quarterly" }, { value: "yearly", label: "Yearly" }]}
            value={form.period} onChange={v => setForm({ ...form, period: v })} />
          <Input label="Start Date" type="date" value={form.start_date} onChange={v => setForm({ ...form, start_date: v })} />
          <Input label="End Date" type="date" value={form.end_date} onChange={v => setForm({ ...form, end_date: v })} />
          <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
            <Btn onClick={handleCreateTarget} disabled={saving}>{saving ? "Saving..." : "Set Target"}</Btn>
            <Btn variant="ghost" onClick={() => setModal(false)}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};



const NotificationsView = ({ user, onNavigate }) => {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('notifications')
      .select('*')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });
    setNotes(data || []);
    setLoading(false);
  };

  useEffect(() => {
    load();
    const sub = supabase.channel('notif-view-' + user.id)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'notifications', filter: 'user_id=eq.' + user.id }, () => load())
      .subscribe();
    return () => supabase.removeChannel(sub);
  }, [user.id]);

  const getNavTarget = (note) => {
    const typeMap = {
      invoice: 'invoices', task: 'tasks', quote: 'vendors', rff: 'vendors',
      crm: 'crm', approval: 'vendors', event: 'events', finance: 'finance',
      budget: 'budgets', expense: 'expenses', scorecard: 'scorecards',
    };
    return typeMap[note.type] || null;
  };

  const handleNoteClick = async (note) => {
    // Mark as read
    await supabase.from('notifications').update({ read: true }).eq('id', note.id);
    load();
    // Navigate to source
    const target = getNavTarget(note);
    if (target && onNavigate) {
      // Deep-link routing by notification title keywords
      let resolvedTarget = "notifications";
      const t = note.title?.toLowerCase() || "";
      const m = note.message?.toLowerCase() || "";
      const role = user?.role || "";

      //  COMPREHENSIVE SMART ROUTING BY ROLE + TITLE 
      const isVendor = role === "Vendor";
      const isCEORole = role === "CEO";
      const isFM = role === "Finance Manager";
      const isVMRole = role === "Vendor Manager";
      const isESL = role === "Strategy & Events Lead";
      const isClient = role === "Client";

      // PO & Signing
      if (t.includes("po signature") || t.includes("purchase order") || t.includes("sign purchase") || t.includes("awaiting your signature")) {
        if (isVendor) resolvedTarget = "dashboard";
        else if (isFM) resolvedTarget = "purchase-orders";
        else if (isVMRole) resolvedTarget = "purchase-orders";
        else resolvedTarget = "purchase-orders";

      // RFF & Vendor Assignment
      } else if (t.includes("new rff assignment") || t.includes("request for quote") || t.includes("rff assigned")) {
        resolvedTarget = isVendor ? "dashboard" : "vendor-assignment";
      } else if (t.includes("rff approved") || t.includes("rff approved with budget")) {
        resolvedTarget = isVMRole ? "vendor-assignment" : "rff-approvals";
      } else if (t.includes("rff declined")) {
        resolvedTarget = "rff-approvals";
      } else if (t.includes("new rff") || t.includes("rff submitted")) {
        resolvedTarget = isCEORole ? "rff-approvals" : "vendors";

      // Quotes
      } else if (t.includes("quote submitted") || t.includes("quotes received") || t.includes("new quote")) {
        resolvedTarget = isVMRole || isCEORole ? "quotes-received" : "vendors";

      // Contract Awards & Gig Confirmation
      } else if (t.includes("contract award confirmed") || t.includes("gig confirmed") || t.includes("award confirmed")) {
        if (isFM) resolvedTarget = "purchase-orders";
        else if (isVMRole) resolvedTarget = "purchase-orders";
        else if (isVendor) resolvedTarget = "dashboard";
        else resolvedTarget = "purchase-orders";
      } else if (t.includes("contract award") || t.includes("award submitted")) {
        resolvedTarget = isCEORole ? "contract-awards" : "quote-comparison";

      // Vendor Invoice
      } else if (t.includes("invoice submitted") || t.includes("new invoice")) {
        if (isVendor) resolvedTarget = "dashboard";
        else resolvedTarget = "vendor-invoices";
      } else if (t.includes("invoice") && isVendor) {
        resolvedTarget = "dashboard";
      } else if (t.includes("invoice")) {
        resolvedTarget = isFM ? "vendor-invoices" : "vendor-invoices";

      // Payment & Finance
      } else if (t.includes("payment authoris") || t.includes("payment approved") || t.includes("payment request")) {
        if (isVendor || isClient) resolvedTarget = "dashboard";
        else resolvedTarget = "payment-authorisation";
      } else if (t.includes("voucher") || t.includes("petty cash")) {
        resolvedTarget = "finance";
      } else if (t.includes("staff payment") || t.includes("payment rate")) {
        resolvedTarget = isFM || isCEORole ? "finance" : "dashboard";

      // Event Reports & Intelligence
      } else if (t.includes("report section") || t.includes("intelligence report") || t.includes("vendor section") || t.includes("report submitted")) {
        resolvedTarget = "event-reports";
      } else if (t.includes("performance report") || t.includes("scorecard") || t.includes("vendor scorecard")) {
        if (isVendor) resolvedTarget = "dashboard";
        else if (isVMRole) resolvedTarget = "scorecards";
        else resolvedTarget = "scorecards";

      // Tasks
      } else if (t.includes("task assigned") || t.includes("new task") || t.includes("task due") || t.includes("task updated")) {
        resolvedTarget = "events";

      // CRM & Leads
      } else if (t.includes("lead won") || t.includes("new client") || t.includes("client approved")) {
        resolvedTarget = isCEORole ? "opportunities" : "crm";
      } else if (t.includes("follow-up") || t.includes("crm") || t.includes("lead assigned")) {
        resolvedTarget = "crm";

      // Client portal
      } else if (isClient) {
        if (t.includes("budget") || t.includes("invoice") || t.includes("expense")) resolvedTarget = "dashboard";
        else resolvedTarget = "dashboard";

      // HR & Leave
      } else if (t.includes("leave approved") || t.includes("leave declined") || t.includes("leave request")) {
        resolvedTarget = "dashboard";
      } else if (t.includes("performance review")) {
        resolvedTarget = "dashboard";

      // Vendor onboarding
      } else if (t.includes("vendor application") || t.includes("vendor approved") || t.includes("portal login")) {
        resolvedTarget = "vendor-onboarding";

      // Fallback by type
      } else if (note.type === "rff") {
        if (isVendor) resolvedTarget = "dashboard";
        else if (isVMRole) resolvedTarget = "vendors";
        else resolvedTarget = "rff-approvals";
      } else if (note.type === "task") {
        resolvedTarget = "events";
      } else if (note.type === "crm") {
        resolvedTarget = "crm";
      } else if (note.type === "finance") {
        resolvedTarget = isFM || isCEORole ? "finance" : "dashboard";
      } else {
        resolvedTarget = "dashboard";
      }
      onNavigate(resolvedTarget, note.resource_id || null);
    }
  };

  const markRead = async (id) => {
    await supabase.from('notifications').update({ read: true }).eq('id', id);
    load();
  };

  const markAllRead = async () => {
    await supabase.from('notifications').update({ read: true }).eq('user_id', user.id);
    load();
  };

  const deleteNote = async (id) => {
    await supabase.from('notifications').delete().eq('id', id);
    load();
  };

  const typeIcon = (type) => {
    const icons = { invoice: '', task: '', quote: '', info: 'ℹ', event: '' };
    return icons[type] || '';
  };

  const unread = notes.filter(n => !n.read).length;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>System</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Notifications</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{unread > 0 ? <span style={{ color: T.cyan, fontWeight: 700 }}>{unread} unread</span> : "All caught up"}</div>
        </div>
        {unread > 0 && <Btn small onClick={markAllRead}> Mark All Read</Btn>}
      </div>
      {loading ? (
        <div style={{ color: T.textMuted, textAlign: "center", padding: 60 }}>Loading...</div>
      ) : notes.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No notifications</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>You're all caught up.</div>
        </div>
      ) : (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
          {notes.map((n, i) => (
            <div key={n.id} onClick={() => { if (!n.read) markRead(n.id); handleNoteClick(n); }} style={{
              display: "flex", alignItems: "flex-start", gap: 14,
              padding: "16px 20px",
              borderBottom: i < notes.length - 1 ? `1px solid ${T.border}44` : "none",
              background: !n.read ? T.cyan + "08" : "transparent",
              cursor: "pointer", transition: "background 0.15s",
            }}
              onMouseEnter={e => e.currentTarget.style.background = !n.read ? T.cyan + "12" : T.bg + "80"}
              onMouseLeave={e => e.currentTarget.style.background = !n.read ? T.cyan + "08" : "transparent"}
            >
              <div style={{ fontSize: 18, flexShrink: 0, marginTop: 2 }}>{typeIcon(n.type)}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ color: !n.read ? T.textPrimary : T.textMuted, fontSize: 13, fontWeight: !n.read ? 700 : 500 }}>{n.title}</div>
                {n.message && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 3 }}>{n.message}</div>}
                <div style={{ color: T.textMuted, fontSize: 10, marginTop: 5 }}>
                  {new Date(n.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                </div>
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
                {!n.read && <div style={{ width: 7, height: 7, borderRadius: "50%", background: T.cyan, boxShadow: `0 0 6px ${T.cyan}` }} />}
                <button onClick={(e) => { e.stopPropagation(); deleteNote(n.id); }} style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 16, padding: "2px 6px", borderRadius: 4, transition: "color 0.15s" }}
                  onMouseEnter={e => e.currentTarget.style.color = T.red}
                  onMouseLeave={e => e.currentTarget.style.color = T.textMuted}
                >×</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const CRMDashboardSM = ({ user }) => {
  const [opportunities, setOpportunitys] = useState([]);
  const [target, setTarget] = useState(null);
  const [period, setPeriod] = useState("mtd");

  const load = async () => {
    const [l, t] = await Promise.all([
      supabase.from("opportunities").select("*").or("assigned_to.eq." + user.id + ",created_by.eq." + user.id),
      supabase.from("sales_targets").select("*").eq("rep_id", user.id).order("created_at", { ascending: false }).limit(1),
    ]);
    setOpportunitys(l.data || []);
    setTarget(t.data && t.data[0] ? t.data[0] : null);
  };

  useEffect(() => { load(); }, [user.id]);

  const now = new Date();
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const startOfYear = new Date(now.getFullYear(), 0, 1);

  const filterByPeriod = (arr, p) => arr.filter(l => {
    if (!l.closed_date) return false;
    const d = new Date(l.closed_date);
    if (p === "mtd") return d >= startOfMonth;
    if (p === "ytd") return d >= startOfYear;
    return true;
  });

  const wonOpportunitys = opportunities.filter(l => l.status === "won");
  const periodRevenue = filterByPeriod(wonOpportunitys, period).reduce((a, l) => a + (l.value || 0), 0);
  const ytdRevenue = filterByPeriod(wonOpportunitys, "ytd").reduce((a, l) => a + (l.value || 0), 0);
  const totalRevenue = wonOpportunitys.reduce((a, l) => a + (l.value || 0), 0);
  const pipelineValue = opportunities.filter(l => !["won","lost"].includes(l.status)).reduce((a, l) => a + (l.value || 0), 0);
  const targetAmount = target ? target.target_amount : 0;
  const targetPct = targetAmount ? Math.min(100, Math.round((periodRevenue / targetAmount) * 100)) : 0;
  const ytdTargetPct = targetAmount ? Math.min(100, Math.round((ytdRevenue / targetAmount) * 100)) : 0;
  const avgCycle = wonOpportunitys.filter(l => l.sales_cycle_days).length
    ? Math.round(wonOpportunitys.filter(l => l.sales_cycle_days).reduce((a, l) => a + l.sales_cycle_days, 0) / wonOpportunitys.filter(l => l.sales_cycle_days).length) : 0;
  const closingPct = opportunities.length ? Math.round((wonOpportunitys.length / opportunities.length) * 100) : 0;
  const clientSpread = wonOpportunitys.reduce((acc, l) => { acc[l.company] = (acc[l.company] || 0) + (l.value || 0); return acc; }, {});
  const periodLabel = period === "mtd" ? "Month to Date" : period === "ytd" ? "Year to Date" : "All Time";

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Sales Analytics</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>My CRM Insights</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Performance overview for {user.name}</div>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          {[["mtd","MTD"],["ytd","YTD"],["all","All"]].map(([val, label]) => (
            <button key={val} onClick={() => setPeriod(val)} style={{
              padding: "6px 16px", borderRadius: 20, cursor: "pointer", fontSize: 11, fontWeight: 700,
              letterSpacing: "0.06em", border: `1px solid ${period === val ? T.cyan : T.border}`,
              background: period === val ? T.cyan + "20" : "none",
              color: period === val ? T.cyan : T.textMuted, transition: "all 0.15s",
            }}>{label}</button>
          ))}
        </div>
      </div>

      {/* KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 12, marginBottom: 24 }}>
        {[
          { label: periodLabel + " Revenue", value: getCurrency(activeCountry||user?.country||"Ghana")+" "+(periodRevenue).toLocaleString(), color: T.teal },
          { label: "YTD Revenue", value: getCurrency(activeCountry||user?.country||"Ghana")+" "+(ytdRevenue).toLocaleString(), color: T.cyan },
          { label: "Pipeline", value: getCurrency(activeCountry||user?.country||"Ghana")+" "+(pipelineValue).toLocaleString(), color: T.amber },
          { label: "Close Rate", value: closingPct + "%", color: T.magenta },
          { label: "Avg Cycle", value: avgCycle + "d", color: T.blue },
        ].map((k, i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 15, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 600, marginTop: 4, textTransform: "uppercase", letterSpacing: "0.06em" }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Target Tracking */}
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "20px 22px", marginBottom: 16 }}>
        <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 16 }}>Target Tracking — {periodLabel}</div>
        {!target ? (
          <div style={{ color: T.textMuted, fontSize: 13, padding: "8px 0" }}>No target set. Ask your CEO to set a target.</div>
        ) : (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 12 }}>
              <div>
                <div style={{ color: T.textMuted, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.06em" }}>{target.period} target</div>
                <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>{target.start_date} → {target.end_date}</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ color: T.teal, fontWeight: 900, fontSize: 24 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(periodRevenue.toLocaleString()).toLocaleString()}</div>
                <div style={{ color: T.textMuted, fontSize: 11 }}>of GHS {targetAmount.toLocaleString()}</div>
              </div>
            </div>
            <div style={{ height: 8, background: T.border + "44", borderRadius: 4, marginBottom: 8 }}>
              <div style={{ height: "100%", width: targetPct + "%", background: targetPct >= 100 ? T.teal : targetPct >= 60 ? T.cyan : T.amber, borderRadius: 4, transition: "width 0.4s ease" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ color: targetPct >= 100 ? T.teal : T.amber, fontSize: 13, fontWeight: 700 }}>{targetPct}%</div>
              <div style={{ color: T.textMuted, fontSize: 11 }}>{targetAmount - periodRevenue > 0 ? getCurrency(activeCountry||user?.country||"Ghana")+" "+((targetAmount - periodRevenue)).toLocaleString() + " to go" : " Target exceeded!"}</div>
            </div>
            <div style={{ marginTop: 16, paddingTop: 14, borderTop: `1px solid ${T.border}44` }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em" }}>Year to Date</div>
                <div style={{ color: T.cyan, fontWeight: 700, fontSize: 12 }}>GHS {ytdRevenue.toLocaleString()} <span style={{ color: T.textMuted, fontWeight: 400 }}>({ytdTargetPct}%)</span></div>
              </div>
              <div style={{ height: 4, background: T.border + "44", borderRadius: 2 }}>
                <div style={{ height: "100%", width: ytdTargetPct + "%", background: T.blue, borderRadius: 2 }} />
              </div>
            </div>
          </>
        )}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 16 }}>
        {/* Pipeline by Stage */}
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px" }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 14 }}>Pipeline by Stage</div>
          {["new","contacted","qualified","proposal","won","lost"].map(s => {
            const count = opportunities.filter(l => l.status === s).length;
            const val = opportunities.filter(l => l.status === s).reduce((a, l) => a + (l.value || 0), 0);
            if (!count) return null;
            const colors = { new: T.cyan, contacted: T.blue, qualified: T.amber, proposal: T.magenta, won: T.teal, lost: T.red };
            return (
              <div key={s} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "9px 0", borderBottom: `1px solid ${T.border}44` }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ width: 6, height: 6, borderRadius: "50%", background: colors[s], boxShadow: `0 0 5px ${colors[s]}` }} />
                  <div style={{ color: T.textPrimary, fontSize: 12, fontWeight: 600 }}>{s.charAt(0).toUpperCase() + s.slice(1)}</div>
                </div>
                <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
                  <div style={{ color: T.textMuted, fontSize: 11 }}>{count}</div>
                  <div style={{ color: colors[s], fontWeight: 800, fontSize: 12, minWidth: 90, textAlign: "right" }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(val.toLocaleString()).toLocaleString()}</div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Business Spread */}
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px" }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 14 }}>Business Spread by Client</div>
          {Object.keys(clientSpread).length === 0 ? <div style={{ color: T.textMuted, fontSize: 13 }}>No won deals yet.</div>
          : Object.entries(clientSpread).sort((a,b) => b[1]-a[1]).map(([company, amount]) => (
            <div key={company} style={{ marginBottom: 14 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                <div style={{ color: T.textPrimary, fontSize: 12, fontWeight: 600 }}>{company}</div>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <div style={{ color: T.textMuted, fontSize: 10 }}>{totalRevenue ? Math.round((amount / totalRevenue) * 100) : 0}%</div>
                  <div style={{ color: T.amber, fontWeight: 800, fontSize: 12 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(amount.toLocaleString()).toLocaleString()}</div>
                </div>
              </div>
              <div style={{ height: 3, background: T.border + "44", borderRadius: 2 }}>
                <div style={{ height: "100%", width: (totalRevenue ? Math.round((amount / totalRevenue) * 100) : 0) + "%", background: `linear-gradient(90deg, ${T.cyan}, ${T.teal})`, borderRadius: 2 }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

//  FINANCE DASHBOARD 

const FinanceManagerDashboard = ({ user, onTab, activeCountry = "All" }) => {
  const [vouchers, setVouchers] = useState([]);
  const [estimates, setEstimates] = useState([]);
  const [pettyCash, setPettyCash] = useState(null);
  const [dailyBalances, setDailyBalances] = useState([]);
  const [clientInvoices, setClientInvoices] = useState([]);
  const [vendorInvoices, setVendorInvoices] = useState([]);
  const [pos, setPOs] = useState([]);
  const [events, setEvents] = useState([]);
  const [fmTasks, setFmTasks] = useState([]);
  const [internalPortalEvent, setInternalPortalEvent] = useState(null);
  const [paymentRequests, setPaymentRequests] = useState([]);
  const [payReqModal, setPayReqModal] = useState(false);
  const [payReqForm, setPayReqForm] = useState({ project_id:"", description:"", _rates:null, selectedTypes:{ project_fee:false, per_diem:false, transport:false }, customAmount:"", customType:"", _receipt:null });
  const [savingPayReq, setSavingPayReq] = useState(false);

  const load = async () => {
    const [v, est, pc, db, ci, vi, po, ev] = await Promise.all([
      (!activeCountry || activeCountry === "All")
        ? supabase.from('payment_vouchers').select('*').order('created_at', { ascending: false })
        : supabase.from('payment_vouchers').select('*').eq('country', activeCountry).order('created_at', { ascending: false }),
      supabase.from('estimates').select('*').order('created_at', { ascending: false }),
      supabase.from('petty_cash').select('*').limit(1).maybeSingle(),
      supabase.from('daily_balances').select('*').order('report_date', { ascending: false }).limit(1),
      supabase.from('client_payments').select('*').order('created_at', { ascending: false }),
      supabase.from('vendor_invoices').select('*').order('created_at', { ascending: false }),
      supabase.from('purchase_orders').select('*').order('created_at', { ascending: false }),
      supabase.from('projects').select('*').order('event_date', { ascending: true }),
    ]);
    setVouchers(v.data || []);
    setEstimates(est.data || []);
    setPettyCash(pc.data || null);
    setDailyBalances(db.data || []);
    setClientInvoices(ci.data || []);
    setVendorInvoices(vi.data || []);
    setPOs(po.data || []);
    setEvents(ev.data || []);
    const { data: myTasks } = await supabase.from("tasks").select("*").eq("assignee_id", user.id);
    setFmTasks(myTasks || []);
  };

  useEffect(() => { load(); }, []);

  const now = new Date();
  const totalRevenue = clientInvoices.reduce((s,i) => s+parseFloat(i.amount||0), 0);
  const outstanding = 0;
  const pendingVouchers = vouchers.filter(v => v.status === 'pending_approval');
  const approvedVouchers = vouchers.filter(v => v.status === 'approved');
  const paidVouchers = vouchers.filter(v => v.status === 'paid');
  const totalInflows = clientInvoices.reduce((s,i) => s + (i.amount||0), 0);
  const totalPaidOut = paidVouchers.reduce((s,v) => s + (v.amount||0), 0);
  const pendingVendorInvoices = vendorInvoices.filter(i => i.status !== 'paid');
  const pcDefault = activeCountry === 'Nigeria' ? 20000 : 200;
  const pcBalance = pettyCash?.float_balance ?? pettyCash?.total_float ?? pcDefault;
  const pcTotal = pettyCash?.total_float || pcDefault;
  const pcPct = pcTotal > 0 ? Math.round((pcBalance/pcTotal)*100) : 100;
  const todayBalance = dailyBalances[0];
  const upcomingEvents = events.filter(e => e.event_date && new Date(e.event_date) >= now).slice(0,3);
  const grossProfit = totalInflows - totalPaidOut;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>

      {/*  HERO  */}
      <div style={{ background: `linear-gradient(135deg, ${T.bgDeep} 0%, #0D1F36 60%, ${T.bgDeep} 100%)`, border: `1px solid ${T.border}`, borderRadius: 16, padding: "32px 36px", marginBottom: 24, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -60, right: -60, width: 240, height: 240, background: `radial-gradient(circle, ${T.amber}08, transparent 70%)`, pointerEvents: "none" }} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 16 }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 6 }}>{now.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
            <h1 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 900, color: T.textPrimary, letterSpacing: "-0.03em" }}>{now.getHours() < 12 ? "Good Morning" : now.getHours() < 17 ? "Good Afternoon" : "Good Evening"}, {user?.name.split(" ")[0]}.</h1>
            <div style={{ color: T.textMuted, fontSize: 14 }}>Finance Manager · Financial operations overview</div>
          </div>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            {pendingVouchers.length > 0 && <button onClick={() => onTab && onTab("finance")} style={{ background: T.amber+"15", border: "1px solid "+T.amber+"40", color: T.amber, padding: "10px 18px", borderRadius: 10, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{pendingVouchers.length} Voucher{pendingVouchers.length!==1?"s":""} Pending</button>}
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px,1fr))", gap: 12, marginTop: 24, paddingTop: 20, borderTop: `1px solid ${T.border}44` }}>
          {[
            { label: "Total Revenue", value: getCurrency(activeCountry)+" "+Math.round(totalRevenue/1000)+"k", color: T.teal },
            { label: "Outstanding", value: getCurrency(activeCountry)+" "+Math.round(outstanding/1000)+"k", color: outstanding > 0 ? T.amber : T.textMuted },
            { label: "Vendor Invoices", value: vendorInvoices.length, color: T.cyan },
            { label: "Pending Vouchers", value: pendingVouchers.length, color: pendingVouchers.length > 0 ? T.amber : T.textMuted },
            { label: "Active Events", value: events.length, color: T.teal },
          ].map(k => (
            <div key={k.label} style={{ padding: "12px 14px", background: `${T.bg}80`, border: `1px solid ${T.border}44`, borderRadius: 10 }}>
              <div style={{ color: k.color, fontSize: 18, fontWeight: 900 }}>{k.value}</div>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 3 }}>{k.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/*  MY EVENTS  */}
      {events.filter(e => fmTasks.some(t => t.project_id === e.id)).length > 0 && (
        <div style={{ marginBottom: 20 }}>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 12 }}>My Events</div>
          {events.filter(e => fmTasks.some(t => t.project_id === e.id)).slice(0,4).map(e => {
            const daysLeft = e.event_date ? Math.ceil((new Date(e.event_date) - now) / 86400000) : null;
            const dotColor = daysLeft !== null ? (daysLeft <= 7 ? T.red : daysLeft <= 30 ? T.amber : T.teal) : T.teal;
            const pendingCount = fmTasks.filter(t => t.project_id === e.id && t.status !== "completed").length;
            return (
              <div key={e.id} onClick={() => setInternalPortalEvent(e)} style={{ background: T.surface, border: `1px solid ${T.border}`, borderLeft: `3px solid ${dotColor}`, borderRadius: 10, padding: "12px 16px", cursor: "pointer", marginBottom: 8 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13 }}>{e.name}</div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{e.client}{e.event_date ? " · " + new Date(e.event_date).toLocaleDateString("en-GB", { day: "numeric", month: "short" }) : ""}</div>
                  </div>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    {daysLeft !== null && <div style={{ background: `${dotColor}18`, borderRadius: 6, padding: "4px 8px", textAlign: "center" }}><div style={{ color: dotColor, fontSize: 12, fontWeight: 900 }}>{daysLeft > 0 ? daysLeft : "Today"}</div>{daysLeft > 0 && <div style={{ color: dotColor, fontSize: 8, textTransform: "uppercase" }}>days</div>}</div>}
                    {pendingCount > 0 && <div style={{ background: `${T.amber}18`, borderRadius: 6, padding: "4px 8px", textAlign: "center" }}><div style={{ color: T.amber, fontSize: 12, fontWeight: 900 }}>{pendingCount}</div><div style={{ color: T.amber, fontSize: 8, textTransform: "uppercase" }}>tasks</div></div>}
                    <span style={{ color: T.cyan, fontSize: 11, fontWeight: 700 }}>Open →</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/*  TWO COLUMN  */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>

        {/* Recent Vouchers */}
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Payments</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Payment Vouchers</div>
          </div>
          {vouchers.slice(0,5).map(v => (
            <div key={v.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${T.border}33` }}>
              <div>
                <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{v.voucher_number}</div>
                <div style={{ color: T.textMuted, fontSize: 11 }}>{v.payee}</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ color: T.amber, fontWeight: 700, fontSize: 13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+((v.amount||0).toLocaleString()).toLocaleString()}</div>
                <div style={{ color: v.status==="approved"?T.teal:v.status==="pending_approval"?T.amber:T.textMuted, fontSize: 10, fontWeight: 700 }}>{v.status}</div>
              </div>
            </div>
          ))}
          {vouchers.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "16px 0" }}>No vouchers yet</div>}
          <button onClick={() => onTab && onTab("finance")} style={{ background: "none", border: "none", color: T.cyan, fontSize: 11, fontWeight: 700, cursor: "pointer", marginTop: 10, padding: 0 }}>View all →</button>
        </div>

        {/* Vendor Invoices */}
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Procurement</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Vendor Invoices</div>
          </div>
          {vendorInvoices.slice(0,5).map(inv => (
            <div key={inv.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${T.border}33` }}>
              <div>
                <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{inv.vendor_name || "Vendor"}</div>
                <div style={{ color: T.textMuted, fontSize: 11 }}>{inv.event_name}</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ color: T.amber, fontWeight: 700, fontSize: 13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+((inv.amount||0).toLocaleString()).toLocaleString()}</div>
                <div style={{ color: inv.status==="paid"?T.teal:T.amber, fontSize: 10, fontWeight: 700 }}>{inv.status}</div>
              </div>
            </div>
          ))}
          {vendorInvoices.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "16px 0" }}>No invoices yet</div>}
          <button onClick={() => onTab && onTab("vendor-invoices")} style={{ background: "none", border: "none", color: T.cyan, fontSize: 11, fontWeight: 700, cursor: "pointer", marginTop: 10, padding: 0 }}>View all →</button>
        </div>
      </div>

      {/* Internal Event Portal Modal */}
      {internalPortalEvent && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", overflowY: "auto" }} onClick={() => setInternalPortalEvent(null)}>
          <div style={{ minHeight: "100vh", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "24px 20px" }}>
            <div style={{ background: T.bg, borderRadius: 16, width: "100%", maxWidth: 800, padding: 28 }} onClick={e => e.stopPropagation()}>
              <InternalEventPortal event={internalPortalEvent} user={user} allTasks={fmTasks} onClose={() => setInternalPortalEvent(null)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};



const FinanceDashboard = ({ user, onTab, activeCountry = "All" }) => {
  const [financeTab, setFinanceTab] = useState("overview");
  const [staffRequests, setStaffRequests] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [estimates, setEstimates] = useState([]);
  const [pettyCash, setPettyCash] = useState(null);
  const [pettyCashVouchers, setPettyCashVouchers] = useState([]);
  const [dailyBalances, setDailyBalances] = useState([]);
  const [events, setEvents] = useState([]);
  const [clients, setClients] = useState([]);
  const [pos, setPOs] = useState([]);
  const [clientInvoices, setClientInvoices] = useState([]);
  const [vendorInvoices, setVendorInvoices] = useState([]);
  const [saving, setSaving] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [installmentModal, setInstallmentModal] = useState(null);
  const [installments, setInstallments] = useState([]);
  const [installForm, setInstallForm] = useState({ description: '', amount: '', percentage: '', due_date: '', notes: '' });
  const [installSaving, setInstallSaving] = useState(false);


  // Voucher form
  const [voucherModal, setVoucherModal] = useState(null);
  const [fmSignModal, setFmSignModal] = useState(null);
  const [ceoVoucherSignModal, setCeoVoucherSignModal] = useState(null);
  const [voucherSignature, setVoucherSignature] = useState("");
  const [voucherSignSaving, setVoucherSignSaving] = useState(false);
  const voucherCanvasRef = React.useRef(null);
  const [savedSigFM, setSavedSigFM] = React.useState(user?.saved_signature || null);
  React.useEffect(() => { supabase.from("profiles").select("saved_signature").eq("id", user.id).single().then(({ data }) => { if (data?.saved_signature) setSavedSigFM(data.saved_signature); }); }, [user.id]);
  const [vIsDrawing, setVIsDrawing] = useState(false);
  const [vLastPos, setVLastPos] = useState(null);
  const [vForm, setVForm] = useState({ payment_type: 'project', payee: '', description: '', amount: '', currency: activeCountry === 'Nigeria' ? 'NGN' : 'GHS', project_id: '', event_name: '', invoice_ref: '', department: '', welfare_type: '', admin_type: '', statutory_type: '', due_date: '', notes: '' });

  // Estimate form
  const [estimateModal, setEstimateModal] = useState(null);
  const [eForm, setEForm] = useState({ client_name: '', project_id: '', event_name: '', line_items: [{ description: '', qty: 1, unit_price: '' }], tax_pct: 0, notes: '' });

  // Petty cash voucher form
  const [pcModal, setPcModal] = useState(false);
  const [pcForm, setPcForm] = useState({ payee: '', purpose: '', amount: '' });

  // Daily balance form
  const [dbModal, setDbModal] = useState(false);
  const [dbForm, setDbForm] = useState({ report_date: new Date().toISOString().slice(0,10), opening_balance: '', expected_inflows: '', expected_expenditure: '', actual_inflows: '', actual_payments: '', notes: '' });

  const canApprove = ['CEO', 'Country Manager'].includes(user?.role);
  const isFinance = ['Finance Manager', 'CEO'].includes(user?.role);
  const [financeLoading, setFinanceLoading] = useState(true);

  const load = async () => {
    setFinanceLoading(true);
    const ac = activeCountry && activeCountry !== "All" ? activeCountry : null;
    const [v, est, pc, pcv, db, ev, cl, po, ci, vi] = await Promise.all([
      ac ? supabase.from('payment_vouchers').select('*').eq('country',ac).order('created_at',{ascending:false}) : supabase.from('payment_vouchers').select('*').order('created_at',{ascending:false}),
      supabase.from('estimates').select('*').order('created_at', { ascending: false }),
      supabase.from('petty_cash').select('*').limit(1).maybeSingle(),
      supabase.from('petty_cash_vouchers').select('*').order('created_at', { ascending: false }),
      supabase.from('daily_balances').select('*').order('report_date', { ascending: false }),
      ac ? supabase.from('projects').select('*').eq('country',ac).order('name') : supabase.from('projects').select('*').order('name'),
      supabase.from('profiles').select('*').eq('role', 'Client'),
      ac ? supabase.from('purchase_orders').select('*').eq('country',ac) : supabase.from('purchase_orders').select('*'),
      supabase.from('client_invoices').select('*'),
      ac ? supabase.from('vendor_invoices').select('*').eq('country',ac) : supabase.from('vendor_invoices').select('*'),
    ]);
    setVouchers(v.data || []);
    setEstimates(est.data || []);
    setPettyCash(pc.data || null);
    setPettyCashVouchers(pcv.data || []);
    setDailyBalances(db.data || []);
    setEvents(ev.data || []);
    setClients(cl.data || []);
    setPOs(po.data || []);
    setClientInvoices(ci.data || []);
    setVendorInvoices(vi.data || []);
    const srQuery = (!activeCountry || (!activeCountry || activeCountry === "All"))
      ? supabase.from("staff_payment_requests").select("*").order("submitted_at", { ascending: false })
      : supabase.from("staff_payment_requests").select("*").eq("country", activeCountry).order("submitted_at", { ascending: false });
    const { data: sr } = await srQuery;
    setStaffRequests(sr || []);
    const { data: sl } = await supabase.from("profiles").select("id,name,role").in("role",["Finance Manager","Vendor Manager","Strategy & Events Lead","CEO","Board of Directors","Sales & Marketing"]);
    setStaffList(sl || []);
    const { data: vl } = await supabase.from("profiles").select("id,name").eq("role","Vendor");
    setVendors(vl || []);
    setFinanceLoading(false);
  };

  useEffect(() => { load(); }, [activeCountry]);

  useEffect(() => {
    if (financeTab === 'staff-requests') {
      const q = (!activeCountry || activeCountry === "All")
        ? supabase.from("staff_payment_requests").select("*").order("submitted_at", { ascending: false })
        : supabase.from("staff_payment_requests").select("*").eq("country", activeCountry).order("submitted_at", { ascending: false });
      q.then(({ data }) => setStaffRequests(data || []));
    }
    if (financeTab === 'vouchers') {
      const q = (!activeCountry || activeCountry === "All")
        ? supabase.from("payment_vouchers").select("*").order("created_at", { ascending: false })
        : supabase.from("payment_vouchers").select("*").eq("country", activeCountry).order("created_at", { ascending: false });
      q.then(({ data }) => setVouchers(data || []));
    }
  }, [financeTab, activeCountry]);

  // Auto-generate voucher number
  const genVoucherNumber = async (type) => {
    const prefixes = { project: 'PV', cheque: 'CHQ', petty_cash: 'PC', staff_welfare: 'SW', administrative: 'ADM', statutory: 'STAT' };
    const prefix = prefixes[type] || 'PV';
    const year = new Date().getFullYear().toString().slice(-2);
    const { data: existing } = await supabase.from("payment_vouchers").select("voucher_number").ilike("voucher_number", prefix + "/" + year + "/%").order("voucher_number", { ascending: false }).limit(1);
    const lastNum = existing?.[0]?.voucher_number?.split("/")?.[2];
    const nextNum = String((parseInt(lastNum)||0) + 1).padStart(3,"0");
    return `${prefix}/${year}/${nextNum}`;
  };

  const genEstimateNumber = () => {
    const year = new Date().getFullYear().toString().slice(-2);
    return `EST/${year}/${String(estimates.length + 1).padStart(3,'0')}`;
  };

  // Save voucher
  const saveVoucher = async () => {
    if (!vForm.payee || !vForm.amount) { alert('Payee and amount are required.'); return; }
    setSaving(true);
    const voucherNumber = await genVoucherNumber(vForm.payment_type);
    await supabase.from('payment_vouchers').insert({
      ...vForm,
      voucher_number: voucherNumber,
      amount: parseFloat(vForm.amount) || 0,
      raised_by: user?.id,
      status: 'pending_approval',
      fm_signature: voucherSignature || null,
      fm_signed_at: voucherSignature ? new Date().toISOString() : null,
      fm_signed_by: user?.name,
    });
    setVoucherSignature("");
    // Notify CEO for approval
    const { data: ceos } = await supabase.from('profiles').select('id, email, name').eq('role', 'CEO');
    for (const ceo of ceos || []) {
      await supabase.from('notifications').insert({ user_id: ceo.id, title: 'Payment Voucher Raised', message: `${user.name} raised voucher ${voucherNumber} for ${getCurrency(activeCountry)} ${parseFloat(vForm.amount).toLocaleString()} — ${vForm.description}`, type: 'rff' });
      if (ceo.email) await sendEmail(ceo.email, `Payment Voucher — ${voucherNumber}`, notifEmailHtml({ name: ceo.name, title: 'Payment Voucher Raised', message: `Finance Manager raised voucher <strong>${voucherNumber}</strong> for <strong>${getCurrency(activeCountry)} ${parseFloat(vForm.amount).toLocaleString()}</strong>.<br><br>Payee: ${vForm.payee}<br>Description: ${vForm.description}<br>Type: ${vForm.payment_type}`, actionUrl: 'https://workroom.stretchfield.com', actionLabel: 'Review Voucher' }));
    }
    setSaving(false);
    setVoucherModal(null);
    setVForm({ payment_type: 'project', payee: '', description: '', amount: '', currency: getCurrency(activeCountry), project_id: '', event_name: '', invoice_ref: '', department: '', welfare_type: '', admin_type: '', statutory_type: '', due_date: '', notes: '' });
    load();
  };

  // Approve voucher (CEO) — now requires signature via modal
  const approveVoucherWithSignature = async (v, signature) => {
    await supabase.from('payment_vouchers').update({ status: 'approved', approved_by: user.id, approved_at: new Date().toISOString(), ceo_signature: signature, ceo_signed_at: new Date().toISOString() }).eq('id', v.id);
    // Notify Finance Manager
    const { data: fms } = await supabase.from('profiles').select('id, email, name').eq('role', 'Finance Manager');
    for (const fm of fms || []) {
      await supabase.from('notifications').insert({ user_id: fm.id, title: 'Voucher Approved', message: `Voucher ${v.voucher_number} has been approved. Proceed with payment.`, type: 'rff' });
      if (fm.email) await sendEmail(fm.email, `Voucher Approved — ${v.voucher_number}`, notifEmailHtml({ name: fm.name, title: 'Voucher Approved — Action Required', message: `Voucher <strong>${v.voucher_number}</strong> for <strong>${getCurrency(activeCountry)} ${(v.amount||0).toLocaleString()}</strong> has been approved by CEO. Please proceed with payment within 3 working days.`, actionUrl: 'https://workroom.stretchfield.com', actionLabel: 'View Voucher' }));
    }
    load();
  };

  // Mark voucher paid
  const markPaid = async (v) => {
    await supabase.from('payment_vouchers').update({ status: 'paid', paid_at: new Date().toISOString() }).eq('id', v.id);
    
    // Send payment confirmation email to payee
    const currency = getCurrency(v.country || activeCountry || 'Ghana');
    const paymentDate = new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    
    // Find payee email from vendor profiles or staff
    const payeeVendor = vendors.find(vn => vn.name === v.payee);
    const payeeStaff = staffList.find(s => s.name === v.payee);
    const payeeEmail = payeeVendor?.email || payeeStaff?.email || null;
    
    if (payeeEmail) {
      const emailHtml = `
        <div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;">
          <div style="height:6px;background:linear-gradient(90deg,#00C8FF,#00E5C8);"></div>
          <div style="background:#060B14;padding:24px 32px;">
            <div style="color:#00C8FF;font-size:13px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;">STRETCHFIELD</div>
            <div style="color:#5A6E8A;font-size:11px;margin-top:4px;">Payment Confirmation</div>
          </div>
          <div style="padding:32px;background:#F4F6FB;">
            <p style="color:#0A1628;font-size:15px;font-weight:700;">Dear ${v.payee},</p>
            <p style="color:#0A1628;font-size:14px;">We are pleased to confirm that payment has been processed for the following:</p>
            <div style="background:#fff;border:1px solid #E2E8F0;border-radius:8px;padding:20px;margin:20px 0;">
              <table style="width:100%;border-collapse:collapse;">
                <tr><td style="padding:8px 0;color:#64748B;font-size:13px;">Voucher Number</td><td style="padding:8px 0;color:#0A1628;font-weight:700;font-size:13px;text-align:right;">${v.voucher_number}</td></tr>
                <tr style="border-top:1px solid #E2E8F0;"><td style="padding:8px 0;color:#64748B;font-size:13px;">Amount Paid</td><td style="padding:8px 0;color:#00C8FF;font-weight:800;font-size:15px;text-align:right;">${currency} ${parseFloat(v.amount||0).toLocaleString()}</td></tr>
                <tr style="border-top:1px solid #E2E8F0;"><td style="padding:8px 0;color:#64748B;font-size:13px;">Payment Date</td><td style="padding:8px 0;color:#0A1628;font-weight:700;font-size:13px;text-align:right;">${paymentDate}</td></tr>
                <tr style="border-top:1px solid #E2E8F0;"><td style="padding:8px 0;color:#64748B;font-size:13px;">Description</td><td style="padding:8px 0;color:#0A1628;font-size:13px;text-align:right;">${v.description||'—'}</td></tr>
                ${v.bank_name ? `<tr style="border-top:1px solid #E2E8F0;"><td style="padding:8px 0;color:#64748B;font-size:13px;">Bank</td><td style="padding:8px 0;color:#0A1628;font-size:13px;text-align:right;">${v.bank_name}</td></tr>` : ''}
                ${v.account_number ? `<tr style="border-top:1px solid #E2E8F0;"><td style="padding:8px 0;color:#64748B;font-size:13px;">Account</td><td style="padding:8px 0;color:#0A1628;font-size:13px;text-align:right;">${v.account_name||''} · ${v.account_number}</td></tr>` : ''}
              </table>
            </div>
            <p style="color:#64748B;font-size:13px;">Please allow 1-3 business days for the funds to reflect in your account. If you have any queries, contact us at finance@stretchfield.com.</p>
            <p style="color:#0A1628;font-size:13px;font-weight:700;margin-top:20px;">Thank you for working with Stretchfield.</p>
          </div>
          <div style="background:#060B14;padding:16px 32px;text-align:center;">
            <p style="color:#5A6E8A;font-size:11px;margin:0;">Stretchfield · workroom.stretchfield.com · finance@stretchfield.com</p>
          </div>
        </div>`;
      
      try {
        await sendEmail(payeeEmail, `Payment Confirmation — ${v.voucher_number} | ${currency} ${parseFloat(v.amount||0).toLocaleString()}`, emailHtml);
        console.log('Payment confirmation sent to', payeeEmail);
      } catch(e) {
        console.error('Email send error:', e);
      }
    }
    
    load();
  };

  // Reject voucher
  const rejectVoucher = async (v) => {
    const reason = window.prompt('Reason for rejection:');
    if (!reason) return;
    await supabase.from('payment_vouchers').update({ status: 'rejected', notes: (v.notes||'') + ' | Rejected: ' + reason }).eq('id', v.id);
    load();
  };

  // Save estimate
  const saveEstimate = async () => {
    if (!eForm.client_name) { alert('Client name is required.'); return; }
    setSaving(true);
    const lineItems = eForm.line_items.filter(l => l.description && l.unit_price);
    const subtotal = lineItems.reduce((s,l) => s + (parseFloat(l.unit_price)||0) * (parseInt(l.qty)||1), 0);
    const tax = subtotal * ((parseFloat(eForm.tax_pct)||0) / 100);
    const total = subtotal + tax;
    await supabase.from('estimates').insert({
      estimate_number: genEstimateNumber(),
      client_name: eForm.client_name,
      project_id: eForm.project_id || null,
      event_name: eForm.event_name,
      line_items: lineItems,
      subtotal, tax_pct: parseFloat(eForm.tax_pct)||0,
      total, notes: eForm.notes,
      status: 'draft',
      created_by: user?.id,
    });
    setSaving(false);
    setEstimateModal(null);
    setEForm({ client_name: '', project_id: '', event_name: '', line_items: [{ description: '', qty: 1, unit_price: '' }], tax_pct: 0, notes: '' });
    load();
  };

  // Convert estimate to invoice
  const convertEstimate = async (est) => {
    if (!window.confirm(`Convert estimate ${est.estimate_number} to invoice? This confirms client approval.`)) return;
    const invoiceNum = est.estimate_number.replace('EST/', 'INV/');
    const { data: inv } = await supabase.from('client_invoices').insert({
      title: invoiceNum,
      client_name: est.client_name,
      project_id: est.project_id,
      event_name: est.event_name,
      amount: est.total,
      status: 'pending',
      created_by: user?.id,
    }).select().single();
    await supabase.from('estimates').update({ status: 'converted', converted_invoice_id: inv?.id }).eq('id', est.id);
    load();
  };

  // Petty cash voucher
  const savePCVoucher = async () => {
    if (!pcForm.payee || !pcForm.amount) { alert('Payee and amount required.'); return; }
    const amt = parseFloat(pcForm.amount);
    const pettyLimit = activeCountry === 'Nigeria' ? 200000 : 200;
    if (amt > pettyLimit) { alert(`Single petty cash payment cannot exceed ${getCurrency(activeCountry)} ${pettyLimit.toLocaleString()}. Use cheque payment for amounts over ${getCurrency(activeCountry)} ${pettyLimit.toLocaleString()}.`); return; }
    setSaving(true);
    const year = new Date().getFullYear().toString().slice(-2);
    const count = pettyCashVouchers.length + 1;
    await supabase.from('petty_cash_vouchers').insert({
      voucher_number: `PC/${year}/${String(count).padStart(3,'0')}`,
      payee: pcForm.payee, purpose: pcForm.purpose, amount: amt,
      created_by: user.id, status: 'pending',
    });
    // Update petty cash float
    const currentBalance = pettyCash?.float_balance || 0;
    const newBalance = currentBalance - amt;
    const totalFloat = pettyCash?.total_float || 200;
    if (pettyCash) {
      await supabase.from('petty_cash').update({ float_balance: newBalance }).eq('id', pettyCash.id);
    } else {
      await supabase.from('petty_cash').insert({ float_balance: totalFloat - amt, total_float: totalFloat });
    }
    setSaving(false);
    setPcModal(false);
    setPcForm({ payee: '', purpose: '', amount: '' });
    load();
  };

  // Daily balance
  const saveDailyBalance = async () => {
    setSaving(true);
    const closing = (parseFloat(dbForm.opening_balance)||0) + (parseFloat(dbForm.actual_inflows)||0) - (parseFloat(dbForm.actual_payments)||0);
    await supabase.from('daily_balances').insert({
      ...dbForm,
      closing_balance: closing,
      prepared_by: user.id,
    });
    setSaving(false);
    setDbModal(false);
    setDbForm({ report_date: new Date().toISOString().slice(0,10), opening_balance: '', expected_inflows: '', expected_expenditure: '', actual_inflows: '', actual_payments: '', notes: '' });
    load();
  };

  // Metrics
  const pendingVouchers = vouchers.filter(v => v.status === 'pending_approval');
  const approvedVouchers = vouchers.filter(v => v.status === 'approved');
  const paidVouchers = vouchers.filter(v => v.status === 'paid');
  const totalVouchersPaid = paidVouchers.reduce((s,v) => s + (v.amount||0), 0);
  const totalPendingAmt = pendingVouchers.reduce((s,v) => s + (v.amount||0), 0);
  const totalClientInflows = clientInvoices.reduce((s,i) => s + (i.amount||0), 0);
  const pcDefault = activeCountry === 'Nigeria' ? 20000 : 200;
  const pcBalance = pettyCash?.float_balance ?? pettyCash?.total_float ?? pcDefault;
  const pcTotal = pettyCash?.total_float || pcDefault;
  const pcPct = pcTotal > 0 ? Math.round((pcBalance / pcTotal) * 100) : 100;
  const todayBalance = dailyBalances[0];

  const inputStyle = { width: '100%', padding: '9px 12px', background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' };
  const labelStyle = { color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: 5 };

  const statusBadge = (status) => {
    const map = { pending_approval: [T.amber, 'Pending Approval'], approved: [T.teal, 'Approved'], paid: ['#10B981', 'Paid'], rejected: [T.red, 'Rejected'], draft: [T.textMuted, 'Draft'] };
    const [color, label] = map[status] || [T.textMuted, status];
    return <span style={{ background: color+'18', color, border: `1px solid ${color}30`, borderRadius: 20, padding: '2px 10px', fontSize: 10, fontWeight: 800 }}>{label}</span>;
  };

  const typeBadge = (type) => {
    const map = { project: [T.cyan, 'Project'], cheque: [T.blue, 'Cheque'], petty_cash: [T.teal, 'Petty Cash'], staff_welfare: ['#E879F9', 'Staff Welfare'], administrative: [T.amber, 'Administrative'], statutory: [T.red, 'Statutory'] };
    const [color, label] = map[type] || [T.textMuted, type];
    return <span style={{ background: color+'18', color, border: `1px solid ${color}30`, borderRadius: 20, padding: '2px 8px', fontSize: 10, fontWeight: 700 }}>{label}</span>;
  };

  return (
    <div style={{ animation: 'fadeUp 0.35s ease' }}>
      {/* Header */}
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6 }}>Finance</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <div>
            <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: '-0.02em' }}>Finance Operations</h2>
            <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>
              Vouchers · Estimates · Petty Cash · Daily Balances
              {user?.role === 'Country Manager' && <span style={{ marginLeft: 8, background: (user?.country||'Ghana') === 'Nigeria' ? '#10B98120' : T.amber+'20', color: (user?.country||'Ghana') === 'Nigeria' ? '#10B981' : T.amber, borderRadius: 20, padding: '1px 8px', fontSize: 10, fontWeight: 700 }}>{(user?.country||'Ghana') === 'Nigeria' ? 'NG' : 'GH'} {user?.country||'Ghana'} only</span>}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {pendingVouchers.length > 0 && canApprove && (
              <div onClick={() => setFinanceTab('vouchers')} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 14px', background: T.amber+'15', border: `1px solid ${T.amber}40`, borderRadius: 20, cursor: 'pointer' }}>
                <div style={{ width: 7, height: 7, borderRadius: '50%', background: T.amber, boxShadow: `0 0 8px ${T.amber}` }} />
                <span style={{ color: T.amber, fontSize: 11, fontWeight: 700 }}>{pendingVouchers.length} voucher{pendingVouchers.length>1?'s':''} pending</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Tab Nav */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 28, borderBottom: `1px solid ${T.border}` }}>
        {[
          { id: 'overview', label: 'Overview' },
          { id: 'staff-requests', label: 'Staff Requests', badge: (staffRequests||[]).filter(r=>['pending','pending_ceo'].includes(r.status)).length },
          { id: 'vouchers', label: 'Payment Vouchers', badge: pendingVouchers.length },
          { id: 'estimates', label: 'Estimates & Invoices' },
          { id: 'petty-cash', label: 'Petty Cash' },
          { id: 'daily-balance', label: 'Daily Balance' },
          { id: 'reports', label: 'Reports' },
        ].map(tab => (
          <button key={tab.id} onClick={() => setFinanceTab(tab.id)} style={{ padding: '10px 16px', border: 'none', cursor: 'pointer', background: 'none', color: financeTab === tab.id ? T.textPrimary : T.textMuted, fontWeight: financeTab === tab.id ? 700 : 400, fontSize: 12, letterSpacing: '0.04em', textTransform: 'uppercase', borderBottom: financeTab === tab.id ? `2px solid ${T.cyan}` : '2px solid transparent', marginBottom: -1, transition: 'all 0.15s', position: 'relative' }}>
            {tab.label}
            {tab.badge > 0 && <span style={{ marginLeft: 5, background: T.amber, color: '#000', fontSize: 9, fontWeight: 900, borderRadius: 20, padding: '1px 5px' }}>{tab.badge}</span>}
          </button>
        ))}
      </div>

      {/*  OVERVIEW TAB  */}
      {financeTab === 'overview' && (
        <div>
          {/* KPI strip */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 14, marginBottom: 24 }}>
            {[
              { label: 'Total Inflows', value: `${getCurrency(activeCountry)} ${totalClientInflows.toLocaleString()}`, sub: `${clientInvoices.length} client invoices`, color: '#10B981', icon: '' },
              { label: 'Total Paid Out', value: `${getCurrency(activeCountry)} ${totalVouchersPaid.toLocaleString()}`, sub: `${paidVouchers.length} vouchers paid`, color: T.red, icon: '' },
              { label: 'Pending Approval', value: `${getCurrency(activeCountry)} ${totalPendingAmt.toLocaleString()}`, sub: `${pendingVouchers.length} vouchers`, color: T.amber, icon: '⏳' },
              { label: 'Petty Cash Float', value: `${getCurrency(activeCountry||user?.country||"Ghana")} ${(pcBalance.toLocaleString())}`, sub: `${pcPct}% remaining`, color: pcPct < 10 ? T.red : T.cyan, icon: '' },
            ].map((k,i) => (
              <div key={i} style={{ padding: '16px 18px', background: T.surface, border: `1px solid ${T.border}`, borderTop: `3px solid ${k.color}`, borderRadius: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>{k.label}</div>
                    <div style={{ color: k.color, fontSize: 22, fontWeight: 900 }}>{k.value}</div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 4 }}>{k.sub}</div>
                  </div>
                  <span style={{ fontSize: 24, opacity: 0.4 }}>{k.icon}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Today's balance */}
          {todayBalance && (
            <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 12, padding: '18px 22px', marginBottom: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <div style={{ color: T.cyan, fontWeight: 800, fontSize: 14 }}> Daily Balance — {new Date(todayBalance.report_date+'T12:00:00').toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
                <div style={{ color: T.textMuted, fontSize: 11 }}>Prepared by Finance</div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 12 }}>
                {[
                  ['Opening Balance', todayBalance.opening_balance, T.textMuted],
                  ['Expected Inflows', todayBalance.expected_inflows, '#10B981'],
                  ['Expected Expenditure', todayBalance.expected_expenditure, T.amber],
                  ['Actual Inflows', todayBalance.actual_inflows, '#10B981'],
                  ['Closing Balance', todayBalance.closing_balance, todayBalance.closing_balance >= 0 ? T.teal : T.red],
                ].map(([label, val, color]) => (
                  <div key={label} style={{ textAlign: 'center' }}>
                    <div style={{ color, fontWeight: 900, fontSize: 18 }}>{getCurrency(activeCountry)+" "}{(val||0).toLocaleString()}</div>
                    <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 600, marginTop: 3 }}>{label}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Petty cash alert */}
          {pcPct < 10 && (
            <div style={{ background: T.red+'12', border: `1px solid ${T.red}30`, borderRadius: 10, padding: '12px 16px', marginBottom: 16, color: T.red, fontWeight: 700, fontSize: 13 }}>
               Petty cash float is below 10% (GHS {pcBalance.toLocaleString()} remaining). Replenishment required.
            </div>
          )}

          {/* Recent vouchers */}
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ padding: '14px 18px', borderBottom: `1px solid ${T.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>Recent Payment Vouchers</div>
              <button onClick={() => setFinanceTab('vouchers')} style={{ background: 'none', border: `1px solid ${T.border}`, color: T.textMuted, padding: '4px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 11 }}>View All</button>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                  {['Voucher #','Type','Payee','Amount','Status','Date'].map(h => (
                    <th key={h} style={{ padding: '8px 14px', textAlign: 'left', color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {vouchers.slice(0,6).map((v,i) => (
                  <tr key={v.id} style={{ borderBottom: i < 5 ? `1px solid ${T.border}44` : 'none' }}
                    onMouseEnter={e => e.currentTarget.style.background = T.bg}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 14px', color: T.cyan, fontWeight: 700, fontSize: 12 }}>{v.voucher_number}</td>
                    <td style={{ padding: '10px 14px' }}>{typeBadge(v.payment_type)}</td>
                    <td style={{ padding: '10px 14px', color: T.textPrimary, fontSize: 12 }}>{v.payee}</td>
                    <td style={{ padding: '10px 14px', color: T.textPrimary, fontWeight: 700, fontSize: 12 }}>{getCurrency(activeCountry)+" "}{(v.amount||0).toLocaleString()}</td>
                    <td style={{ padding: '10px 14px' }}>{statusBadge(v.status)}</td>
                    <td style={{ padding: '10px 14px', color: T.textMuted, fontSize: 11 }}>{new Date(v.created_at).toLocaleDateString('en-GB')}</td>
                  </tr>
                ))}
                {vouchers.length === 0 && <tr><td colSpan={6} style={{ padding: '30px 0', textAlign: 'center', color: T.textMuted, fontSize: 13 }}>No vouchers yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/*  PAYMENT VOUCHERS TAB  */}
      {financeTab === 'vouchers' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 16 }}>Payment Vouchers</div>
            {isFinance && <button onClick={() => setVoucherModal(true)} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: 'none', color: '#fff', padding: '9px 20px', borderRadius: 8, cursor: 'pointer', fontWeight: 800, fontSize: 13 }}>+ Raise Voucher</button>}
          </div>

          {/* Filter tabs */}
          {['all','pending_approval','approved','paid','rejected'].map(s => {
            const count = s === 'all' ? vouchers.length : vouchers.filter(v => v.status === s).length;
            return <button key={s} onClick={() => {}} style={{ marginRight: 8, marginBottom: 16, padding: '5px 14px', borderRadius: 20, border: `1px solid ${T.border}`, background: 'none', color: T.textMuted, fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>{s === 'all' ? 'All' : s.replace('_',' ').replace(/\w/g, l => l.toUpperCase())} ({count})</button>;
          })}

          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                  {['Voucher #','Type','Payee','Description','Amount','Status','Due','Actions'].map(h => (
                    <th key={h} style={{ padding: '10px 12px', textAlign: 'left', color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {vouchers.map((v,i) => (
                  <tr key={v.id} style={{ borderBottom: i < vouchers.length-1 ? `1px solid ${T.border}44` : 'none' }}
                    onMouseEnter={e => e.currentTarget.style.background = T.bg}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 12px', color: T.cyan, fontWeight: 700, fontSize: 12 }}>{v.voucher_number}</td>
                    <td style={{ padding: '10px 12px' }}>{typeBadge(v.payment_type)}</td>
                    <td style={{ padding: '10px 12px', color: T.textPrimary, fontSize: 12, fontWeight: 600 }}>{v.payee}</td>
                    <td style={{ padding: '10px 12px', color: T.textMuted, fontSize: 11, maxWidth: 200 }}>{v.description}</td>
                    <td style={{ padding: '10px 12px', color: T.textPrimary, fontWeight: 800, fontSize: 13 }}>{fmtMoney(v.amount||0, v.country||"Ghana")}</td>
                    <td style={{ padding: '10px 12px' }}>{statusBadge(v.status)}</td>
                    <td style={{ padding: '10px 12px', color: v.due_date && new Date(v.due_date) < new Date() && v.status !== 'paid' ? T.red : T.textMuted, fontSize: 11 }}>{v.due_date || '—'}</td>
                    <td style={{ padding: '10px 12px' }}>
                      <div style={{ display: 'flex', gap: 4 }}>
                        {isFinance && !v.fm_signature && v.status !== 'rejected' && (
                          <button onClick={() => { setFmSignModal(v); setVoucherSignature(""); }} style={{ background: T.amber+'18', border: `1px solid ${T.amber}30`, color: T.amber, padding: '3px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 10, fontWeight: 700 }}> Sign</button>
                        )}
                        {isFinance && v.fm_signature && v.status !== 'rejected' && (
                          <span style={{ color: T.teal, fontSize: 10, fontWeight: 700, padding: '3px 8px' }}>FM </span>
                        )}
                        {v.ceo_signature && (
                          <span style={{ color: T.cyan, fontSize: 10, fontWeight: 700, padding: '3px 8px' }}>CEO </span>
                        )}
                        {!v.ceo_signature && v.status === 'approved' && (
                          <span style={{ color: T.amber, fontSize: 10, fontWeight: 700, padding: '3px 8px' }}>CEO pending</span>
                        )}
                        {canApprove && v.status === 'pending_approval' && (
                          <>
                            <button onClick={() => { setCeoVoucherSignModal(v); setVoucherSignature(""); }} style={{ background: '#10B98118', border: '1px solid #10B98130', color: '#10B981', padding: '3px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 10, fontWeight: 700 }}> Sign & Approve</button>
                            <button onClick={() => rejectVoucher(v)} style={{ background: T.red+'18', border: `1px solid ${T.red}30`, color: T.red, padding: '3px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 10, fontWeight: 700 }}></button>
                          </>
                        )}
                        {canApprove && v.status === 'approved' && v.ceo_signature && (
                          <span style={{ color: T.teal, fontSize: 10, fontWeight: 700, padding: '3px 8px' }}>CEO </span>
                        )}
                        {isFinance && v.status === 'approved' && (
                          <button onClick={() => markPaid(v)} style={{ background: T.cyan+'18', border: `1px solid ${T.cyan}30`, color: T.cyan, padding: '3px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 10, fontWeight: 700 }}>Mark Paid</button>
                        )}
                        {isFinance && (
                        <button onClick={async () => {
                          const { data: inst } = await supabase.from('payment_installments').select('*').eq('voucher_id', v.id).order('installment_number');
                          setInstallments(inst || []);
                          setInstallmentModal(v);
                          setInstallForm({ description: '', amount: '', percentage: '', due_date: '', notes: '' });
                        }} style={{ background: '#8B5CF618', border: '1px solid #8B5CF630', color: '#8B5CF6', padding: '3px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 10, fontWeight: 700 }}>Split Payment</button>
                        )}
                        <button onClick={async () => {
                          const { data: ceo } = await supabase.from('profiles').select('name').eq('role','CEO').single();
                          const { data: fm } = await supabase.from('profiles').select('name').eq('role','Finance Manager').single();
                          downloadPDF(generateVoucherPDF(v, ceo, fm), `Voucher-${v.voucher_number}.html`);
                        }} style={{ background: T.teal+'15', border: `1px solid ${T.teal}30`, color: T.teal, padding: '3px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 10, fontWeight: 700 }}>↓ PDF</button>
                        {/* Bank Advice Upload */}
                        {isFinance && (
                          v.bank_advice_url ? (
                            <a href={v.bank_advice_url} target="_blank" rel="noreferrer" style={{ color:T.teal, fontSize:10, fontWeight:700, textDecoration:"none" }}> Advice</a>
                          ) : (
                            <label style={{ cursor:"pointer" }}>
                              <span style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"3px 8px", borderRadius:6, fontSize:10, fontWeight:700 }}>↑ Advice</span>
                              <input type="file" accept=".pdf,.png,.jpg,.jpeg" style={{ display:"none" }} onChange={async e => {
                                const file = e.target.files[0]; if (!file) return;
                                const ext = file.name.split(".").pop();
                                const path = "bank_advice/"+v.id+"_"+Date.now()+"."+ext;
                                const { error } = await supabase.storage.from("rffs").upload(path, file, { upsert:true });
                                if (error) { alert("Upload failed: "+error.message); return; }
                                const { data: urlData } = supabase.storage.from("rffs").getPublicUrl(path);
                                await supabase.from("payment_vouchers").update({ bank_advice_url:urlData.publicUrl, bank_advice_uploaded_at:new Date().toISOString(), bank_advice_uploaded_by:user.id }).eq("id", v.id);
                                load();
                              }} />
                            </label>
                          )
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
                {vouchers.length === 0 && <tr><td colSpan={8} style={{ padding: '40px 0', textAlign: 'center', color: T.textMuted }}>No payment vouchers yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/*  ESTIMATES & INVOICES TAB  */}
      {financeTab === 'estimates' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 16 }}>Estimates & Invoices</div>
            {isFinance && <button onClick={() => setEstimateModal(true)} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: 'none', color: '#fff', padding: '9px 20px', borderRadius: 8, cursor: 'pointer', fontWeight: 800, fontSize: 13 }}>+ New Estimate</button>}
          </div>
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: 'hidden', marginBottom: 20 }}>
            <div style={{ padding: '12px 16px', borderBottom: `1px solid ${T.border}`, color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}>Estimates</div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                  {['Estimate #','Client','Event','Total','Status','Action'].map(h => (
                    <th key={h} style={{ padding: '8px 14px', textAlign: 'left', color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {estimates.map((est,i) => (
                  <tr key={est.id} style={{ borderBottom: i < estimates.length-1 ? `1px solid ${T.border}44` : 'none' }}
                    onMouseEnter={e => e.currentTarget.style.background = T.bg}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 14px', color: T.cyan, fontWeight: 700, fontSize: 12 }}>{est.estimate_number}</td>
                    <td style={{ padding: '10px 14px', color: T.textPrimary, fontSize: 12 }}>{est.client_name}</td>
                    <td style={{ padding: '10px 14px', color: T.textMuted, fontSize: 11 }}>{est.event_name || '—'}</td>
                    <td style={{ padding: '10px 14px', color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{getCurrency(activeCountry)+" "}{(est.total||0).toLocaleString()}</td>
                    <td style={{ padding: '10px 14px' }}>
                      <span style={{ background: est.status==='converted' ? '#10B98118' : est.status==='approved' ? T.teal+'18' : T.amber+'18', color: est.status==='converted' ? '#10B981' : est.status==='approved' ? T.teal : T.amber, borderRadius: 20, padding: '2px 8px', fontSize: 10, fontWeight: 700 }}>{est.status}</span>
                    </td>
                    <td style={{ padding: '10px 14px' }}>
                      {est.status !== 'converted' && isFinance && (
                        <button onClick={() => convertEstimate(est)} style={{ background: T.teal+'18', border: `1px solid ${T.teal}30`, color: T.teal, padding: '4px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 10, fontWeight: 700 }}>→ Convert to Invoice</button>
                      )}
                      {est.status === 'converted' && <span style={{ color: T.textMuted, fontSize: 11 }}> Converted</span>}
                    </td>
                  </tr>
                ))}
                {estimates.length === 0 && <tr><td colSpan={6} style={{ padding: '30px 0', textAlign: 'center', color: T.textMuted }}>No estimates yet</td></tr>}
              </tbody>
            </table>
          </div>

          {/* Client Invoices */}
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ padding: '12px 16px', borderBottom: `1px solid ${T.border}`, color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}>Client Invoices (Statement of Claim)</div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                  {['Invoice','Client','Event','Amount','Status'].map(h => (
                    <th key={h} style={{ padding: '8px 14px', textAlign: 'left', color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {clientInvoices.map((inv,i) => (
                  <tr key={inv.id} style={{ borderBottom: i < clientInvoices.length-1 ? `1px solid ${T.border}44` : 'none' }}
                    onMouseEnter={e => e.currentTarget.style.background = T.bg}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 14px', color: T.cyan, fontWeight: 700, fontSize: 12 }}>{inv.title}</td>
                    <td style={{ padding: '10px 14px', color: T.textPrimary, fontSize: 12 }}>{inv.client_name || '—'}</td>
                    <td style={{ padding: '10px 14px', color: T.textMuted, fontSize: 11 }}>{inv.event_name || '—'}</td>
                    <td style={{ padding: '10px 14px', color: T.textPrimary, fontWeight: 700 }}>{fmtMoney(inv.amount||0, inv.country||"Ghana")}</td>
                    <td style={{ padding: '10px 14px' }}><span style={{ color: inv.status==='paid' ? '#10B981' : T.amber, fontWeight: 700, fontSize: 11 }}>{inv.status || 'pending'}</span></td>
                  </tr>
                ))}
                {clientInvoices.length === 0 && <tr><td colSpan={5} style={{ padding: '30px 0', textAlign: 'center', color: T.textMuted }}>No client invoices yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/*  STAFF REQUESTS TAB  */}
      {financeTab === 'staff-requests' && (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
            <div>
              <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16 }}>Staff Payment Requests</div>
              <span style={{ color:T.amber, fontSize:12, fontWeight:700 }}>{(staffRequests||[]).filter(r=>["pending","pending_ceo"].includes(r.status)).length} pending</span>
            </div>
            <button onClick={async () => {
              const { data: staff } = await supabase.from("profiles").select("id,name,role,bank_name,bank_account_number").not("role","in","(Client,Vendor,Board of Directors,Finance Manager)");
              const noBank = staff?.filter(s => !s.bank_name || !s.bank_account_number) || [];
              if (noBank.length === 0) { alert("All staff have submitted bank details."); return; }
              const names = noBank.map((s,i) => (i+1)+". "+s.name+" ("+s.role+")").join("\n");
              const choice = window.prompt("Request bank details from:\n\n"+names+"\n\nEnter number (or 0 for all):");
              if (choice === null) return;
              const targets = choice === "0" ? noBank : [noBank[parseInt(choice)-1]].filter(Boolean);
              for (const s of targets) {
                await supabase.from("profiles").update({ bank_details_requested: true }).eq("id", s.id);
                await supabase.from("notifications").insert({ user_id: s.id, title: "Bank Details Required", message: "Finance has requested your bank details for payment processing. Please log in and submit your details.", type: "finance" });
              }
              alert("Request sent to "+targets.map(s=>s.name).join(", "));
            }} style={{ background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"8px 16px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:12 }}> Request Bank Details</button>
          </div>
          {/* Staff with submitted bank details */}
          {(() => {
            return null; // Bank details shown in separate section below
          })()}
          {(() => {
            const displayRequests = (!activeCountry || activeCountry === "All") ? (staffRequests||[]) : (staffRequests||[]).filter(r => (r.country||"Ghana") === activeCountry);
            if (displayRequests.length === 0) return <div style={{ color:T.textMuted, fontSize:13, textAlign:"center", padding:"40px 0" }}>No staff payment requests{activeCountry !== "All" ? " for "+activeCountry : ""} yet</div>;
            return displayRequests.map(req => {
            const statusColors = { pending:T.amber, pending_ceo:T.cyan, approved:T.teal, rejected:T.red, paid:"#10B981" };
            const statusLabels = { pending:"Pending Finance Review", pending_ceo:"Sent to CEO — Awaiting Approval", approved:"CEO Approved — Ready to Pay", rejected:"Rejected", paid:"Paid " };
            return (
              <div key={req.id} style={{ background:T.surface, border:`1px solid ${req.status==="pending"?T.amber+"30":T.border}`, borderLeft:`4px solid ${statusColors[req.status]||T.border}`, borderRadius:12, padding:"16px 20px", marginBottom:10 }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14 }}>{req.staff_name}</div>
                    <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{(req.request_type||"").replace(/_/g," ")} {req.project_name ? "· "+req.project_name : ""}</div>
                    <div style={{ color:T.textSecondary, fontSize:13, marginTop:4 }}>{req.description}</div>
                    <div style={{ color:T.textMuted, fontSize:11, marginTop:3 }}>{new Date(req.submitted_at).toLocaleDateString("en-GB", { day:"numeric", month:"short", year:"numeric" })}</div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ color:T.amber, fontWeight:900, fontSize:18 }}>{fmtMoney(req.amount||0, req.country||"Ghana")}</div>
                    <span style={{ color:statusColors[req.status]||T.textMuted, fontSize:10, fontWeight:800, background:(statusColors[req.status]||T.textMuted)+"15", padding:"2px 8px", borderRadius:20 }}>{req.status}</span>
                  </div>
                </div>
                {req.status === "pending" && isFinance && (
                  <div style={{ display:"flex", gap:8 }}>
                    <button onClick={async () => {
                      await supabase.from("staff_payment_requests").update({ status:"pending_ceo", reviewed_by:user.id, reviewed_at:new Date().toISOString() }).eq("id", req.id);
                      const { data: ceos } = await supabase.from("profiles").select("id").eq("role","CEO");
                      for (const ceo of ceos||[]) {
                        await supabase.from("notifications").insert({ user_id: ceo.id, title: "Staff Payment Approval Required — " + req.staff_name, message: "Finance has reviewed " + req.staff_name + "'s payment request of GHS " + parseFloat(req.amount).toLocaleString() + " for " + req.description + ". Awaiting your approval.", type: "finance" });
                      }
                      await supabase.from("notifications").insert({ user_id:req.staff_id, title:"Payment Request Approved", message:"Your payment request of GHS "+parseFloat(req.amount).toLocaleString()+" has been approved.", type:"finance" });
                      const { data: sr } = await supabase.from("staff_payment_requests").select("*").order("submitted_at", { ascending:false });
                      setStaffRequests(sr||[]);
                    }} style={{ background:`linear-gradient(135deg,${T.teal},#10B981)`, border:"none", color:"#fff", padding:"7px 16px", borderRadius:7, cursor:"pointer", fontWeight:800, fontSize:12 }}> Send to CEO</button>
                    <button onClick={async () => {
                      const reason = window.prompt("Reason for rejection:");
                      if (!reason) return;
                      await supabase.from("staff_payment_requests").update({ status:"rejected", notes:reason, reviewed_by:user.id, reviewed_at:new Date().toISOString() }).eq("id", req.id);
                      await supabase.from("notifications").insert({ user_id:req.staff_id, title:"Payment Request Rejected", message:"Your payment request of GHS "+parseFloat(req.amount).toLocaleString()+" was rejected. Reason: "+reason, type:"finance" });
                      const { data: sr } = await supabase.from("staff_payment_requests").select("*").order("submitted_at", { ascending:false });
                      setStaffRequests(sr||[]);
                    }} style={{ background:T.red+"15", border:`1px solid ${T.red}30`, color:T.red, padding:"7px 14px", borderRadius:7, cursor:"pointer", fontSize:12, fontWeight:700 }}> Reject</button>
                  </div>
                )}
                {req.status === "approved" && isFinance && (
                  <div style={{ display:"flex", gap:8, alignItems:"center", marginTop:4 }}>
                    <div style={{ color:T.teal, fontSize:12, fontWeight:700 }}> CEO Approved — Ready to Process</div>
                    <button onClick={async () => {
                      // Get staff bank details
                      const { data: staffProfile } = await supabase.from("profiles").select("bank_name,bank_branch,bank_account_name,bank_account_number,mobile_money_number").eq("id", req.staff_id).single();
                      const year = new Date().getFullYear().toString().slice(-2);
                      const { data: existingVouchers } = await supabase.from("payment_vouchers").select("id").eq("payment_type","staff_welfare");
                      const count = (existingVouchers?.length||0) + 1;
                      const voucherNumber = `SW/${year}/${String(count).padStart(3,"0")}`;
                      await supabase.from("payment_vouchers").insert({
                        voucher_number: voucherNumber,
                        payee: req.staff_name,
                        payment_type: "staff_welfare",
                        description: req.description + " ("+req.request_type?.replace(/_/g," ")+")",
                        amount: parseFloat(req.amount),
                        project_name: req.project_name || "",
                        bank_name: staffProfile?.bank_name || "",
                        bank_branch: staffProfile?.bank_branch || "",
                        account_name: staffProfile?.bank_account_name || "",
                        account_number: staffProfile?.bank_account_number || "",
                        mobile_money: staffProfile?.mobile_money_number || "",
                        raised_by: user.id,
                        status: "pending_approval",
                        staff_request_id: req.id,
                      });
                      await supabase.from("staff_payment_requests").update({ status:"voucher_created" }).eq("id", req.id);
                      await supabase.from("notifications").insert({ user_id: req.staff_id, title:"Payment Being Processed — "+req.staff_name, message:"Finance is processing your payment of GHS "+parseFloat(req.amount).toLocaleString()+". A payment voucher has been raised.", type:"finance" });
                      const { data: sr } = await supabase.from("staff_payment_requests").select("*").order("submitted_at", { ascending:false });
                      setStaffRequests(sr||[]);
                      setFinanceTab("vouchers");
                    }} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"7px 16px", borderRadius:7, cursor:"pointer", fontWeight:800, fontSize:12 }}> Create Payment Voucher</button>
                  </div>
                )}
              </div>
            );
          });
          })()}
        </div>
      )}

      {/*  PETTY CASH TAB  */}
      {financeTab === 'petty-cash' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 16 }}>Petty Cash</div>
            {isFinance && <button onClick={() => setPcModal(true)} style={{ background: `linear-gradient(135deg, ${T.teal}, ${T.cyan})`, border: 'none', color: '#fff', padding: '9px 20px', borderRadius: 8, cursor: 'pointer', fontWeight: 800, fontSize: 13 }}>+ Petty Cash Voucher</button>}
          </div>

          {/* Float status */}
          <div style={{ background: T.surface, border: `1px solid ${pcPct < 10 ? T.red : T.border}`, borderRadius: 12, padding: '20px 24px', marginBottom: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div>
                <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>Current Float Balance</div>
                <div style={{ color: pcPct < 10 ? T.red : '#10B981', fontWeight: 900, fontSize: 36 }}>{getCurrency(activeCountry)+" "}{pcBalance.toLocaleString()}</div>
                <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>of GHS {pcTotal.toLocaleString()} total float · {pcPct}% remaining</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 6 }}>Max single payment: <strong style={{ color: T.textPrimary }}>GHS 200</strong></div>
                <div style={{ color: T.textMuted, fontSize: 11 }}>Replenish trigger: <strong style={{ color: T.amber }}>at 90% exhaustion</strong></div>
                {pcPct < 10 && <div style={{ color: T.red, fontWeight: 700, fontSize: 12, marginTop: 8 }}> Replenishment required!</div>}
              </div>
            </div>
            <div style={{ height: 8, background: T.border+'44', borderRadius: 4, overflow: 'hidden' }}>
              <div style={{ height: '100%', width: `${pcPct}%`, background: pcPct < 10 ? T.red : pcPct < 30 ? T.amber : '#10B981', borderRadius: 4, transition: 'width 0.4s ease' }} />
            </div>
          </div>

          {/* Petty cash vouchers */}
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                  {['Voucher #','Payee','Purpose','Amount','Status','Date'].map(h => (
                    <th key={h} style={{ padding: '10px 14px', textAlign: 'left', color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pettyCashVouchers.map((v,i) => (
                  <tr key={v.id} style={{ borderBottom: i < pettyCashVouchers.length-1 ? `1px solid ${T.border}44` : 'none' }}
                    onMouseEnter={e => e.currentTarget.style.background = T.bg}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 14px', color: T.teal, fontWeight: 700, fontSize: 12 }}>{v.voucher_number}</td>
                    <td style={{ padding: '10px 14px', color: T.textPrimary, fontSize: 12 }}>{v.payee}</td>
                    <td style={{ padding: '10px 14px', color: T.textMuted, fontSize: 11 }}>{v.purpose}</td>
                    <td style={{ padding: '10px 14px', color: T.textPrimary, fontWeight: 700 }}>{getCurrency(activeCountry)+" "}{(v.amount||0).toLocaleString()}</td>
                    <td style={{ padding: '10px 14px' }}><span style={{ color: v.status==='approved' ? '#10B981' : T.amber, fontWeight: 700, fontSize: 11 }}>{v.status}</span></td>
                    <td style={{ padding: '10px 14px', color: T.textMuted, fontSize: 11 }}>{new Date(v.created_at).toLocaleDateString('en-GB')}</td>
                  </tr>
                ))}
                {pettyCashVouchers.length === 0 && <tr><td colSpan={6} style={{ padding: '30px 0', textAlign: 'center', color: T.textMuted }}>No petty cash vouchers yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/*  DAILY BALANCE TAB  */}
      {financeTab === 'daily-balance' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 16 }}>Daily Balance Reports</div>
              <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>Prepared each morning and sent to Director — previous payments, inflows, expected inflows and expenditure</div>
            </div>
            {isFinance && <button onClick={() => setDbModal(true)} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: 'none', color: '#fff', padding: '9px 20px', borderRadius: 8, cursor: 'pointer', fontWeight: 800, fontSize: 13 }}>+ Today's Balance</button>}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {dailyBalances.map((db,i) => (
              <div key={db.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: '16px 20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>{new Date(db.report_date+'T12:00:00').toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</div>
                  <div style={{ color: db.closing_balance >= 0 ? '#10B981' : T.red, fontWeight: 900, fontSize: 18 }}>Closing: GHS {(db.closing_balance||0).toLocaleString()}</div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 10 }}>
                  {[
                    ['Opening', db.opening_balance, T.textMuted],
                    ['Expected Inflows', db.expected_inflows, '#10B981'],
                    ['Expected Spend', db.expected_expenditure, T.amber],
                    ['Actual Inflows', db.actual_inflows, '#10B981'],
                    ['Actual Payments', db.actual_payments, T.red],
                  ].map(([label, val, color]) => (
                    <div key={label} style={{ textAlign: 'center', background: T.bg, borderRadius: 8, padding: '10px 8px' }}>
                      <div style={{ color, fontWeight: 800, fontSize: 16 }}>{getCurrency(activeCountry)+" "}{(val||0).toLocaleString()}</div>
                      <div style={{ color: T.textMuted, fontSize: 10, marginTop: 3 }}>{label}</div>
                    </div>
                  ))}
                </div>
                {db.notes && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 10, fontStyle: 'italic' }}>{db.notes}</div>}
              </div>
            ))}
            {dailyBalances.length === 0 && <div style={{ textAlign: 'center', padding: 40, background: T.surface, borderRadius: 12, border: `1px solid ${T.border}`, color: T.textMuted }}>No daily balance reports yet. Finance Manager prepares one each morning.</div>}
          </div>
        </div>
      )}

      {/*  REPORTS TAB  */}
      {financeTab === 'reports' && <FinanceReportsView user={user} />}

      {/*  MODALS  */}

      {/* Payment Voucher Modal */}
      {voucherModal && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 600, background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }} onClick={() => setVoucherModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: '100%', maxWidth: 640, maxHeight: '90vh', overflow: 'auto', padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Raise Payment Voucher</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>All payments require a voucher. Amounts over GHS 200 require CEO authorization.</div>

            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Payment Type *</label>
              <select value={vForm.payment_type} onChange={e => setVForm({...vForm, payment_type: e.target.value})} style={inputStyle}>
                <option value="project">Project Payment</option>
                <option value="cheque">Cheque Payment (&gt;GHS 200)</option>
                <option value="petty_cash">Petty Cash (≤GHS 200)</option>
                <option value="staff_welfare">Staff Welfare</option>
                <option value="administrative">Administrative</option>
                <option value="statutory">Statutory Payment</option>
              </select>
            </div>

            {vForm.payment_type === 'staff_welfare' && (
              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>Welfare Type</label>
                <select value={vForm.welfare_type} onChange={e => setVForm({...vForm, welfare_type: e.target.value})} style={inputStyle}>
                  <option value="">Select...</option>
                  <option value="loan">Staff Loan</option>
                  <option value="birthday">Birthday</option>
                  <option value="travel">Travel</option>
                  <option value="donation">Donation</option>
                </select>
              </div>
            )}

            {vForm.payment_type === 'administrative' && (
              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>Administrative Type</label>
                <select value={vForm.admin_type} onChange={e => setVForm({...vForm, admin_type: e.target.value})} style={inputStyle}>
                  <option value="">Select...</option>
                  <option value="internet">Internet Subscription</option>
                  <option value="telephone">Telephone</option>
                  <option value="stationery">Stationery & Toiletries</option>
                  <option value="other">Other</option>
                </select>
              </div>
            )}

            {vForm.payment_type === 'statutory' && (
              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>Statutory Type</label>
                <select value={vForm.statutory_type} onChange={e => setVForm({...vForm, statutory_type: e.target.value})} style={inputStyle}>
                  <option value="">Select...</option>
                  <option value="PAYE">PAYE</option>
                  <option value="SSNIT">SSNIT</option>
                  <option value="VAT">VAT</option>
                  <option value="self_assessment">Self Assessment</option>
                  <option value="withholding_tax">Withholding Tax</option>
                </select>
              </div>
            )}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div><label style={labelStyle}>Payee / Supplier *</label>
                <select value={vForm.payee} onChange={e => {
                  const val = e.target.value;
                  if (val === '__manual__') { setVForm({...vForm, payee: ''}); }
                  else {
                    // Auto-fill bank details from vendor/staff profile
                    const vendor = vendors.find(v => v.name === val) || staffList.find(s => s.name === val);
                    setVForm({...vForm, payee: val,
                      account_name: vendor?.bank_account_name || vendor?.bank_account_number ? vendor.bank_account_name : vForm.account_name,
                      account_number: vendor?.bank_account_number || vForm.account_number,
                      bank_name: vendor?.bank_name || vForm.bank_name,
                    });
                  }
                }} style={inputStyle}>
                  <option value="">Select payee...</option>
                  {vendors.length > 0 && <optgroup label="Approved Vendors">
                    {vendors.filter(v => v.name).map(v => <option key={v.id} value={v.name}>{v.name}{v.service_category ? ' — '+v.service_category : ''}</option>)}
                  </optgroup>}
                  {staffList.length > 0 && <optgroup label="Staff">
                    {staffList.filter(s => s.name).map(s => <option key={s.id} value={s.name}>{s.name} — {s.role}</option>)}
                  </optgroup>}
                  <option value="__manual__">+ Enter manually...</option>
                </select>
                {vForm.payee === '' && <input value={vForm.payee} onChange={e => setVForm({...vForm, payee: e.target.value})} style={{...inputStyle, marginTop:6}} placeholder="Enter payee name manually" />}
              </div>
              <div><label style={labelStyle}>Amount ({getCurrency(activeCountry)}) *</label><input type="number" value={vForm.amount} onChange={e => setVForm({...vForm, amount: e.target.value})} style={inputStyle} placeholder="0.00" /></div>
            </div>

            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Description / Purpose</label>
              <input value={vForm.description} onChange={e => setVForm({...vForm, description: e.target.value})} style={inputStyle} placeholder="What is this payment for?" />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={labelStyle}>Linked Event</label>
                <select value={vForm.project_id} onChange={e => { const ev = events.find(x => x.id === e.target.value); setVForm({...vForm, project_id: e.target.value, event_name: ev?.name||''}); }} style={inputStyle}>
                  <option value="">Select event (optional)...</option>
                  {events.map(ev => <option key={ev.id} value={ev.id}>{ev.name}</option>)}
                </select>
              </div>
              <div><label style={labelStyle}>Invoice / PO Reference</label><input value={vForm.invoice_ref} onChange={e => setVForm({...vForm, invoice_ref: e.target.value})} style={inputStyle} placeholder="e.g. INV/ST/CS/26/001" /></div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={labelStyle}>Currency</label>
                <select value={vForm.currency} onChange={e => setVForm({...vForm, currency: e.target.value})} style={inputStyle}>
                  {['GHS','USD','EUR','GBP','NGN','KES'].map(c => <option key={c}>{c}</option>)}
                </select>
              </div>
              <div><label style={labelStyle}>Due Date (pay by)</label><input type="date" value={vForm.due_date} onChange={e => setVForm({...vForm, due_date: e.target.value})} style={inputStyle} /></div>
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Notes</label>
              <textarea value={vForm.notes} onChange={e => setVForm({...vForm, notes: e.target.value})} rows={2} style={{...inputStyle, resize: 'vertical'}} placeholder="Additional notes or supporting document reference..." />
            </div>

            {parseFloat(vForm.amount) > 200 && vForm.payment_type !== 'petty_cash' && (
              <div style={{ background: T.amber+'12', border: `1px solid ${T.amber}30`, borderRadius: 8, padding: '10px 14px', marginBottom: 16, color: T.amber, fontSize: 12 }}>
                 Amount exceeds GHS 200 — this voucher will require CEO authorization before payment.
              </div>
            )}

            {/* FM Signature */}
            <div style={{ marginBottom:16 }}>
              <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", marginBottom:6 }}>Your Signature (Finance Manager)</div>
              <div style={{ border:`1px solid ${T.border}`, borderRadius:8, overflow:"hidden", background:"#fff", position:"relative" }}>
                <canvas ref={voucherCanvasRef} width={500} height={120}
                  style={{ display:"block", cursor:"crosshair", touchAction:"none" }}
                  onMouseDown={e=>{ setVIsDrawing(true); const r=e.target.getBoundingClientRect(); setVLastPos({x:e.clientX-r.left,y:e.clientY-r.top}); }}
                  onMouseMove={e=>{ if(!vIsDrawing) return; const r=e.target.getBoundingClientRect(); const pos={x:e.clientX-r.left,y:e.clientY-r.top}; const ctx=voucherCanvasRef.current?.getContext("2d"); if(ctx&&vLastPos){ctx.beginPath();ctx.moveTo(vLastPos.x,vLastPos.y);ctx.lineTo(pos.x,pos.y);ctx.strokeStyle="#1a365d";ctx.lineWidth=2;ctx.lineCap="round";ctx.stroke();} setVLastPos(pos); }}
                  onMouseUp={()=>{ setVIsDrawing(false); setVoucherSignature(voucherCanvasRef.current?.toDataURL()||""); }}
                  onMouseLeave={()=>{ setVIsDrawing(false); if(voucherCanvasRef.current) setVoucherSignature(voucherCanvasRef.current.toDataURL()||""); }}
                  onTouchStart={e=>{ e.preventDefault(); setVIsDrawing(true); const r=e.target.getBoundingClientRect(); const t=e.touches[0]; setVLastPos({x:t.clientX-r.left,y:t.clientY-r.top}); }}
                  onTouchMove={e=>{ e.preventDefault(); if(!vIsDrawing) return; const r=e.target.getBoundingClientRect(); const t=e.touches[0]; const pos={x:t.clientX-r.left,y:t.clientY-r.top}; const ctx=voucherCanvasRef.current?.getContext("2d"); if(ctx&&vLastPos){ctx.beginPath();ctx.moveTo(vLastPos.x,vLastPos.y);ctx.lineTo(pos.x,pos.y);ctx.strokeStyle="#1a365d";ctx.lineWidth=2;ctx.lineCap="round";ctx.stroke();} setVLastPos(pos); }}
                  onTouchEnd={()=>{ setVIsDrawing(false); setVoucherSignature(voucherCanvasRef.current?.toDataURL()||""); }}
                />
              </div>
              <button onClick={()=>{ const ctx=voucherCanvasRef.current?.getContext("2d"); if(ctx) ctx.clearRect(0,0,500,120); setVoucherSignature(""); }} style={{ background:"none", border:"none", color:T.textMuted, fontSize:11, cursor:"pointer", marginTop:4 }}>Clear signature</button>
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={saveVoucher} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: 'none', color: '#fff', padding: '10px 24px', borderRadius: 8, cursor: 'pointer', fontWeight: 800, fontSize: 13 }}>{saving ? 'Saving...' : 'Raise Voucher'}</button>
              <button onClick={() => setVoucherModal(null)} style={{ background: 'none', border: `1px solid ${T.border}`, color: T.textMuted, padding: '10px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* FM Sign Voucher Modal */}
            {installmentModal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setInstallmentModal(null)}>
          <div style={{ background:T.surface, border:"1px solid #8B5CF630", borderRadius:16, width:"100%", maxWidth:600, padding:28, maxHeight:"90vh", overflowY:"auto" }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
              <div>
                <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18 }}>Split Payment — {installmentModal.voucher_number}</div>
                <div style={{ color:T.textMuted, fontSize:13, marginTop:2 }}>{installmentModal.payee} · {getCurrency(installmentModal.country||"Ghana")} {parseFloat(installmentModal.amount||0).toLocaleString()} total</div>
              </div>
              <button onClick={() => setInstallmentModal(null)} style={{ background:"none", border:"1px solid "+T.border, color:T.textMuted, width:32, height:32, borderRadius:8, cursor:"pointer", fontSize:18 }}>×</button>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:20 }}>
              {[
                { label:"Total Amount", value:getCurrency(installmentModal.country||"Ghana")+" "+parseFloat(installmentModal.amount||0).toLocaleString(), color:T.cyan },
                { label:"Total Paid", value:getCurrency(installmentModal.country||"Ghana")+" "+installments.filter(i=>i.status==="paid").reduce((s,i)=>s+parseFloat(i.amount||0),0).toLocaleString(), color:"#10B981" },
                { label:"Outstanding", value:getCurrency(installmentModal.country||"Ghana")+" "+(parseFloat(installmentModal.amount||0)-installments.filter(i=>i.status==="paid").reduce((s,i)=>s+parseFloat(i.amount||0),0)).toLocaleString(), color:T.amber },
              ].map(k => (
                <div key={k.label} style={{ background:T.bg, borderRadius:8, padding:"12px 14px" }}>
                  <div style={{ color:k.color, fontWeight:800, fontSize:16 }}>{k.value}</div>
                  <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:3 }}>{k.label}</div>
                </div>
              ))}
            </div>
            {installments.length > 0 && (
              <div style={{ marginBottom:20 }}>
                <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14, marginBottom:10 }}>Payment Schedule</div>
                {installments.map(inst => (
                  <div key={inst.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 14px", background:T.bg, borderRadius:8, marginBottom:6, border:"1px solid "+(inst.status==="paid"?"#10B98130":T.border) }}>
                    <div>
                      <div style={{ color:T.textPrimary, fontSize:13, fontWeight:700 }}>Payment {inst.installment_number} — {inst.description||"Installment"}</div>
                      <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>
                        {getCurrency(installmentModal.country||"Ghana")} {parseFloat(inst.amount||0).toLocaleString()}
                        {inst.percentage ? ` (${inst.percentage}%)` : ""}
                        {inst.due_date ? " · Due "+new Date(inst.due_date).toLocaleDateString("en-GB",{day:"numeric",month:"short"}) : ""}
                      </div>
                    </div>
                    <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                      <span style={{ background:inst.status==="paid"?"#10B98120":T.amber+"20", color:inst.status==="paid"?"#10B981":T.amber, borderRadius:20, padding:"2px 10px", fontSize:10, fontWeight:700 }}>{inst.status==="paid"?"Paid":"Pending"}</span>
                      {inst.status !== "paid" && (
                        <button onClick={async () => {
                          await supabase.from("payment_installments").update({ status:"paid", paid_at:new Date().toISOString(), paid_by:user?.id, paid_by_name:user?.name }).eq("id",inst.id);
                          const newTotalPaid = installments.filter(ii=>ii.status==="paid"||ii.id===inst.id).reduce((s,ii)=>s+parseFloat(ii.amount||0),0);
                          const allPaid = newTotalPaid >= parseFloat(installmentModal.amount||0);
                          await supabase.from("payment_vouchers").update({ total_paid:newTotalPaid, status:allPaid?"paid":"approved" }).eq("id",installmentModal.id);
                          const payeeVendor = vendors.find(v => v.name === installmentModal.payee);
                          if (payeeVendor?.email) {
                            const cur = getCurrency(installmentModal.country||"Ghana");
                            const html = "<div style='font-family:Arial;max-width:600px;'><div style='height:6px;background:linear-gradient(90deg,#00C8FF,#00E5C8)'></div><div style='background:#060B14;padding:20px 28px'><div style='color:#00C8FF;font-weight:700'>STRETCHFIELD</div></div><div style='padding:28px;background:#F4F6FB'><p style='color:#0A1628;font-size:15px;font-weight:700'>Payment "+inst.installment_number+" Confirmed</p><p style='color:#0A1628'>Amount: <strong>"+cur+" "+parseFloat(inst.amount||0).toLocaleString()+"</strong></p><p style='color:#0A1628'>Voucher: "+installmentModal.voucher_number+"</p><p style='color:#64748B;font-size:12px'>Remaining: "+cur+" "+(parseFloat(installmentModal.amount||0)-newTotalPaid).toLocaleString()+"</p></div></div>";
                            await sendEmail(payeeVendor.email, "Payment "+inst.installment_number+" Confirmed — "+cur+" "+parseFloat(inst.amount||0).toLocaleString(), html);
                          }
                          const { data: upd } = await supabase.from("payment_installments").select("*").eq("voucher_id",installmentModal.id).order("installment_number");
                          setInstallments(upd||[]);
                          if (allPaid) { setInstallmentModal(null); load(); }
                        }} style={{ background:"#10B98115", border:"1px solid #10B98130", color:"#10B981", padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:10, fontWeight:700 }}>Mark Paid</button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div style={{ background:T.bg, borderRadius:10, padding:"16px 18px", marginBottom:16 }}>
              <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14, marginBottom:12 }}>Add Payment</div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Description</label>
                  <input value={installForm.description} onChange={e=>setInstallForm(f=>({...f,description:e.target.value}))} placeholder="e.g. 50% Upfront" style={{ width:"100%", padding:"9px 12px", background:T.surface, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, outline:"none", boxSizing:"border-box" }} />
                </div>
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Amount</label>
                  <input type="number" value={installForm.amount} onChange={e=>{ const amt=e.target.value; const pct=installmentModal.amount?Math.round((parseFloat(amt)/parseFloat(installmentModal.amount))*100):""; setInstallForm(f=>({...f,amount:amt,percentage:pct})); }} placeholder="0" style={{ width:"100%", padding:"9px 12px", background:T.surface, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, outline:"none", boxSizing:"border-box" }} />
                </div>
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Percentage (%)</label>
                  <input type="number" value={installForm.percentage} onChange={e=>{ const pct=e.target.value; const amt=installmentModal.amount?Math.round((parseFloat(pct)/100)*parseFloat(installmentModal.amount)):""; setInstallForm(f=>({...f,percentage:pct,amount:amt})); }} placeholder="50" style={{ width:"100%", padding:"9px 12px", background:T.surface, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, outline:"none", boxSizing:"border-box" }} />
                </div>
                <div>
                  <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Due Date</label>
                  <input type="date" value={installForm.due_date} onChange={e=>setInstallForm(f=>({...f,due_date:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.surface, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, outline:"none", boxSizing:"border-box" }} />
                </div>
              </div>
              <button onClick={async () => {
                if (!installForm.amount) { alert("Enter an amount"); return; }
                setInstallSaving(true);
                const nextNum = (installments.length||0)+1;
                await supabase.from("payment_installments").insert({ voucher_id:installmentModal.id, installment_number:nextNum, description:installForm.description||"Payment "+nextNum, amount:parseFloat(installForm.amount), percentage:parseFloat(installForm.percentage)||null, due_date:installForm.due_date||null, status:"pending", country:installmentModal.country||"Ghana" });
                await supabase.from("payment_vouchers").update({ payment_schedule:"split", installments_count:nextNum }).eq("id",installmentModal.id);
                const { data: upd } = await supabase.from("payment_installments").select("*").eq("voucher_id",installmentModal.id).order("installment_number");
                setInstallments(upd||[]);
                setInstallForm({ description:"", amount:"", percentage:"", due_date:"", notes:"" });
                setInstallSaving(false);
              }} disabled={installSaving} style={{ background:"linear-gradient(135deg,#8B5CF6,#7C3AED)", border:"none", color:"#fff", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{installSaving?"Adding...":"+ Add Payment"}</button>
            </div>
            <button onClick={() => setInstallmentModal(null)} style={{ width:"100%", background:"none", border:"1px solid "+T.border, color:T.textMuted, padding:"10px", borderRadius:8, cursor:"pointer" }}>Close</button>
          </div>
        </div>
      )}

{fmSignModal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setFmSignModal(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.amber}30`, borderRadius:16, width:"100%", maxWidth:500, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Finance Manager Signature</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:6 }}>{fmSignModal.voucher_number} — {fmSignModal.payee}</div>
            <div style={{ color:T.amber, fontWeight:800, fontSize:18, marginBottom:20 }}>{fmtMoney(fmSignModal.amount||0, fmSignModal.country||"Ghana")}</div>
            <SignatureInput label="Your Signature (Finance Manager)" canvasRef={voucherCanvasRef} onSignatureChange={setVoucherSignature} savedSignature={savedSigFM||user.saved_signature} isDrawing={vIsDrawing} setIsDrawing={setVIsDrawing} lastPos={vLastPos} setLastPos={setVLastPos} />
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={async () => {
                const sig = voucherSignature || savedSigFM || user.saved_signature || voucherCanvasRef.current?.toDataURL() || "";
                setVoucherSignSaving(true);
                await supabase.from("payment_vouchers").update({ fm_signature: sig, fm_signed_at: new Date().toISOString(), fm_signed_by: user.name }).eq("id", fmSignModal.id);
                setVoucherSignSaving(false);
                setFmSignModal(null);
                setVoucherSignature("");
                const ctx = voucherCanvasRef.current?.getContext("2d");
                if (ctx) ctx.clearRect(0,0,440,120);
                load();
              }} disabled={voucherSignSaving} style={{ flex:1, background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{voucherSignSaving?"Saving...":" Save Signature"}</button>
              <button onClick={()=>{ setFmSignModal(null); setVoucherSignature(""); const ctx=voucherCanvasRef.current?.getContext("2d"); if(ctx) ctx.clearRect(0,0,440,120); }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* CEO Sign & Approve Voucher Modal */}
      {ceoVoucherSignModal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setCeoVoucherSignModal(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.teal}30`, borderRadius:16, width:"100%", maxWidth:500, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Sign & Approve Voucher</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:6 }}>{ceoVoucherSignModal.voucher_number} — {ceoVoucherSignModal.payee}</div>
            <div style={{ color:T.teal, fontWeight:800, fontSize:18, marginBottom:20 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(ceoVoucherSignModal.amount||0).toLocaleString()).toLocaleString()}</div>
            <div style={{ marginBottom:16 }}>
              <SignatureInput label="CEO Authorisation Signature" canvasRef={voucherCanvasRef} onSignatureChange={setVoucherSignature} savedSignature={user?.saved_signature||savedSigFM} isDrawing={vIsDrawing} setIsDrawing={setVIsDrawing} lastPos={vLastPos} setLastPos={setVLastPos} />
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={async () => {
                const sig = voucherSignature || savedSigFM || user?.saved_signature || voucherCanvasRef.current?.toDataURL() || "";
                if (!sig || sig === "data:,") { alert("Please select or draw your signature first."); return; }
                setVoucherSignSaving(true);
                await approveVoucherWithSignature(ceoVoucherSignModal, sig);
                setVoucherSignSaving(false);
                setCeoVoucherSignModal(null);
                setVoucherSignature("");
                const ctx = voucherCanvasRef.current?.getContext("2d");
                if (ctx) ctx.clearRect(0,0,440,120);
              }} disabled={voucherSignSaving} style={{ flex:1, background:`linear-gradient(135deg,${T.teal},#10B981)`, border:"none", color:"#fff", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{voucherSignSaving?"Saving...":" Sign & Approve"}</button>
              <button onClick={()=>{ setCeoVoucherSignModal(null); setVoucherSignature(""); const ctx=voucherCanvasRef.current?.getContext("2d"); if(ctx) ctx.clearRect(0,0,440,120); }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Estimate Modal */}
      {estimateModal && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 600, background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }} onClick={() => setEstimateModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: '100%', maxWidth: 680, maxHeight: '90vh', overflow: 'auto', padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>New Estimate</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>Create an estimate. Once client approves, convert it to an invoice.</div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div><label style={labelStyle}>Client Name *</label><input value={eForm.client_name} onChange={e => setEForm({...eForm, client_name: e.target.value})} style={inputStyle} placeholder="Client or company name" /></div>
              <div>
                <label style={labelStyle}>Linked Event</label>
                <select value={eForm.project_id} onChange={e => { const ev = events.find(x => x.id === e.target.value); setEForm({...eForm, project_id: e.target.value, event_name: ev?.name||''}); }} style={inputStyle}>
                  <option value="">Select event (optional)...</option>
                  {events.map(ev => <option key={ev.id} value={ev.id}>{ev.name}</option>)}
                </select>
              </div>
            </div>

            <div style={{ marginBottom: 14 }}>
              <div style={{ color: T.cyan, fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 8, paddingBottom: 6, borderBottom: `1px solid ${T.cyan}30` }}>Line Items</div>
              <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr 1fr 28px', gap: 8, marginBottom: 6 }}>
                {['Description','Qty','Unit Price',''].map(h => <div key={h} style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>{h}</div>)}
              </div>
              {eForm.line_items.map((item, idx) => (
                <div key={idx} style={{ display: 'grid', gridTemplateColumns: '3fr 1fr 1fr 28px', gap: 8, marginBottom: 8 }}>
                  <input value={item.description} onChange={e => { const l = [...eForm.line_items]; l[idx].description = e.target.value; setEForm({...eForm, line_items: l}); }} style={inputStyle} placeholder="Service description" />
                  <input type="number" value={item.qty} onChange={e => { const l = [...eForm.line_items]; l[idx].qty = e.target.value; setEForm({...eForm, line_items: l}); }} style={inputStyle} placeholder="1" />
                  <input type="number" value={item.unit_price} onChange={e => { const l = [...eForm.line_items]; l[idx].unit_price = e.target.value; setEForm({...eForm, line_items: l}); }} style={inputStyle} placeholder="0.00" />
                  <button onClick={() => setEForm({...eForm, line_items: eForm.line_items.filter((_,i) => i!==idx)})} style={{ background: T.red+'18', border: `1px solid ${T.red}30`, color: T.red, borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>×</button>
                </div>
              ))}
              <button onClick={() => setEForm({...eForm, line_items: [...eForm.line_items, { description: '', qty: 1, unit_price: '' }]})} style={{ background: 'none', border: `1px dashed ${T.border}`, color: T.textMuted, padding: '6px 16px', borderRadius: 6, cursor: 'pointer', fontSize: 12, width: '100%' }}>+ Add Line Item</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div><label style={labelStyle}>Tax / VAT %</label><input type="number" value={eForm.tax_pct} onChange={e => setEForm({...eForm, tax_pct: e.target.value})} style={inputStyle} placeholder="0" /></div>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                {(() => { const sub = eForm.line_items.reduce((s,l) => s+(parseFloat(l.unit_price)||0)*(parseInt(l.qty)||1),0); const tax = sub*((parseFloat(eForm.tax_pct)||0)/100); return <div style={{ background: T.bg, border: `1px solid ${T.cyan}30`, borderRadius: 8, padding: '10px 14px' }}><div style={{ color: T.textMuted, fontSize: 11 }}>Subtotal: GHS {sub.toLocaleString()}</div><div style={{ color: T.textMuted, fontSize: 11 }}>Tax: GHS {tax.toLocaleString()}</div><div style={{ color: T.cyan, fontWeight: 900, fontSize: 16 }}>Total: GHS {(sub+tax).toLocaleString()}</div></div>; })()}
              </div>
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Notes</label>
              <textarea value={eForm.notes} onChange={e => setEForm({...eForm, notes: e.target.value})} rows={2} style={{...inputStyle, resize: 'vertical'}} placeholder="Terms, conditions or notes..." />
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={saveEstimate} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: 'none', color: '#fff', padding: '10px 24px', borderRadius: 8, cursor: 'pointer', fontWeight: 800, fontSize: 13 }}>{saving ? 'Saving...' : 'Save Estimate'}</button>
              <button onClick={() => setEstimateModal(null)} style={{ background: 'none', border: `1px solid ${T.border}`, color: T.textMuted, padding: '10px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Petty Cash Voucher Modal */}
      {pcModal && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 600, background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }} onClick={() => setPcModal(false)}>
          <div style={{ background: T.surface, border: `1px solid ${T.teal}30`, borderRadius: 16, width: '100%', maxWidth: 480, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Petty Cash Voucher</div>
            <div style={{ color: T.amber, fontSize: 12, marginBottom: 20 }}> Maximum single payment: GHS 200. Use cheque for larger amounts.</div>
            <div style={{ marginBottom: 14 }}><label style={labelStyle}>Payee *</label><input value={pcForm.payee} onChange={e => setPcForm({...pcForm, payee: e.target.value})} style={inputStyle} placeholder="Who is being paid?" /></div>
            <div style={{ marginBottom: 14 }}><label style={labelStyle}>Purpose</label><input value={pcForm.purpose} onChange={e => setPcForm({...pcForm, purpose: e.target.value})} style={inputStyle} placeholder="What is this for?" /></div>
            <div style={{ marginBottom: 20 }}><label style={labelStyle}>Amount (${getCurrency(activeCountry||user?.country||"Ghana")}) *</label><input type="number" max="200" value={pcForm.amount} onChange={e => setPcForm({...pcForm, amount: e.target.value})} style={inputStyle} placeholder="Max GHS 200" /></div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={savePCVoucher} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.teal}, ${T.cyan})`, border: 'none', color: '#fff', padding: '10px 24px', borderRadius: 8, cursor: 'pointer', fontWeight: 800, fontSize: 13 }}>{saving ? 'Saving...' : 'Submit Voucher'}</button>
              <button onClick={() => setPcModal(false)} style={{ background: 'none', border: `1px solid ${T.border}`, color: T.textMuted, padding: '10px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Daily Balance Modal */}
      {dbModal && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 600, background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }} onClick={() => setDbModal(false)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: '100%', maxWidth: 560, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Daily Balance Report</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>Prepared each morning and sent to the Director. Shows previous payments, inflows and expected transactions.</div>
            <div style={{ marginBottom: 14 }}><label style={labelStyle}>Report Date</label><input type="date" value={dbForm.report_date} onChange={e => setDbForm({...dbForm, report_date: e.target.value})} style={inputStyle} /></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div><label style={labelStyle}>Opening Balance (${getCurrency(activeCountry||user?.country||"Ghana")})</label><input type="number" value={dbForm.opening_balance} onChange={e => setDbForm({...dbForm, opening_balance: e.target.value})} style={inputStyle} placeholder="0.00" /></div>
              <div><label style={labelStyle}>Expected Inflows (${getCurrency(activeCountry||user?.country||"Ghana")})</label><input type="number" value={dbForm.expected_inflows} onChange={e => setDbForm({...dbForm, expected_inflows: e.target.value})} style={inputStyle} placeholder="0.00" /></div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div><label style={labelStyle}>Expected Expenditure (${getCurrency(activeCountry||user?.country||"Ghana")})</label><input type="number" value={dbForm.expected_expenditure} onChange={e => setDbForm({...dbForm, expected_expenditure: e.target.value})} style={inputStyle} placeholder="0.00" /></div>
              <div><label style={labelStyle}>Actual Inflows (${getCurrency(activeCountry||user?.country||"Ghana")})</label><input type="number" value={dbForm.actual_inflows} onChange={e => setDbForm({...dbForm, actual_inflows: e.target.value})} style={inputStyle} placeholder="0.00" /></div>
            </div>
            <div style={{ marginBottom: 14 }}><label style={labelStyle}>Actual Payments Made (${getCurrency(activeCountry||user?.country||"Ghana")})</label><input type="number" value={dbForm.actual_payments} onChange={e => setDbForm({...dbForm, actual_payments: e.target.value})} style={inputStyle} placeholder="0.00" /></div>
            {(dbForm.opening_balance || dbForm.actual_inflows || dbForm.actual_payments) && (
              <div style={{ background: T.bg, border: `1px solid ${T.cyan}30`, borderRadius: 8, padding: '10px 14px', marginBottom: 14 }}>
                <div style={{ color: T.cyan, fontWeight: 900, fontSize: 16 }}>Closing Balance: GHS {((parseFloat(dbForm.opening_balance)||0) + (parseFloat(dbForm.actual_inflows)||0) - (parseFloat(dbForm.actual_payments)||0)).toLocaleString()}</div>
              </div>
            )}
            <div style={{ marginBottom: 20 }}><label style={labelStyle}>Notes</label><textarea value={dbForm.notes} onChange={e => setDbForm({...dbForm, notes: e.target.value})} rows={2} style={{...inputStyle, resize: 'vertical'}} placeholder="Any notable transactions or observations..." /></div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={saveDailyBalance} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: 'none', color: '#fff', padding: '10px 24px', borderRadius: 8, cursor: 'pointer', fontWeight: 800, fontSize: 13 }}>{saving ? 'Saving...' : 'Save Report'}</button>
              <button onClick={() => setDbModal(false)} style={{ background: 'none', border: `1px solid ${T.border}`, color: T.textMuted, padding: '10px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const FinanceReportsView = ({ user }) => {
  const [invoices, setInvoices] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [opportunities, setOpportunitys] = useState([]);
  const [period, setPeriod] = useState("mtd");

  useEffect(() => {
    Promise.all([
      supabase.from("invoices").select("*"),
      supabase.from("expenses").select("*"),
      supabase.from("opportunities").select("*").eq("status", "won"),
    ]).then(([inv, exp, l]) => {
      setInvoices(inv.data || []);
      setExpenses(exp.data || []);
      setOpportunitys(l.data || []);
    });
  }, []);

  const now = new Date();
  const ranges = {
    mtd: new Date(now.getFullYear(), now.getMonth(), 1),
    ytd: new Date(now.getFullYear(), 0, 1),
    all: new Date(0),
  };
  const start = ranges[period];

  const periodRevenue = opportunities.filter(l => l.closed_date && new Date(l.closed_date) >= start).reduce((a, l) => a + (l.value || 0), 0);
  const periodExpenses = expenses.filter(e => e.date && new Date(e.date) >= start).reduce((a, e) => a + (e.amount || 0), 0);
  const periodInvoiced = invoices.filter(i => i.created_at && new Date(i.created_at) >= start).reduce((a, i) => a + (i.amount || 0), 0);
  const periodPaid = invoices.filter(i => i.status === "paid" && i.created_at && new Date(i.created_at) >= start).reduce((a, i) => a + (i.amount || 0), 0);
  const grossProfit = periodRevenue - periodExpenses;
  const margin = periodRevenue ? Math.round((grossProfit / periodRevenue) * 100) : 0;

  const monthlyData = Array.from({ length: 6 }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - (5 - i), 1);
    const next = new Date(now.getFullYear(), now.getMonth() - (5 - i) + 1, 1);
    const label = d.toLocaleString("default", { month: "short" });
    const rev = opportunities.filter(l => l.closed_date && new Date(l.closed_date) >= d && new Date(l.closed_date) < next).reduce((a, l) => a + (l.value || 0), 0);
    const exp = expenses.filter(e => e.date && new Date(e.date) >= d && new Date(e.date) < next).reduce((a, e) => a + (e.amount || 0), 0);
    return { label, rev, exp, profit: rev - exp };
  });

  const maxVal = Math.max(...monthlyData.map(m => Math.max(m.rev, m.exp)), 1);

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Finance</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Financial Reports</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>P&L and cash flow analysis</div>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          {[["mtd","MTD"],["ytd","YTD"],["all","All Time"]].map(([val, label]) => (
            <button key={val} onClick={() => setPeriod(val)} style={{ padding: "6px 16px", borderRadius: 20, cursor: "pointer", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", border: `1px solid ${period === val ? T.cyan : T.border}`, background: period === val ? T.cyan + "20" : "none", color: period === val ? T.cyan : T.textMuted, transition: "all 0.15s" }}>{label}</button>
          ))}
        </div>
      </div>

      {/* KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Revenue", value: getCurrency(activeCountry||user?.country||"Ghana")+" "+(periodRevenue).toLocaleString(), color: T.teal, grad: `linear-gradient(135deg, ${T.teal}20, ${T.teal}08)` },
          { label: "Gross Profit", value: getCurrency(activeCountry||user?.country||"Ghana")+" "+(grossProfit).toLocaleString(), sub: margin + "% margin", color: grossProfit >= 0 ? T.cyan : T.red, grad: `linear-gradient(135deg, ${grossProfit >= 0 ? T.cyan : T.red}20, transparent)` },
          { label: "Total Expenses", value: getCurrency(activeCountry||user?.country||"Ghana")+" "+(periodExpenses).toLocaleString(), color: T.amber, grad: `linear-gradient(135deg, ${T.amber}20, ${T.amber}08)` },
        ].map((k, i) => (
          <div key={i} style={{ padding: "18px 20px", background: k.grad, border: `1px solid ${k.color}30`, borderRadius: 12 }}>
            <div style={{ color: k.color, fontSize: 10, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</div>
            <div style={{ color: T.textPrimary, fontSize: 20, fontWeight: 900 }}>{k.value}</div>
            {k.sub && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 3 }}>{k.sub}</div>}
          </div>
        ))}
      </div>

      {/* P&L Summary */}
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px", marginBottom: 20 }}>
        <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 16 }}>P&L Summary</div>
        {[
          ["Revenue (Won Deals)", periodRevenue, T.teal],
          ["Total Expenses", periodExpenses, T.amber],
          ["Total Invoiced", periodInvoiced, T.blue],
          ["Invoices Paid", periodPaid, T.cyan],
        ].map(([label, val, color]) => (
          <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: `1px solid ${T.border}44` }}>
            <div style={{ color: T.textMuted, fontSize: 13 }}>{label}</div>
            <div style={{ color, fontWeight: 700, fontSize: 15 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(val.toLocaleString()).toLocaleString()}</div>
          </div>
        ))}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 0" }}>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>Gross Profit</div>
          <div style={{ color: grossProfit >= 0 ? T.teal : "#F43F5E", fontWeight: 800, fontSize: 18 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(grossProfit.toLocaleString()).toLocaleString()}</div>
        </div>
        <div style={{ padding: "12px 16px", background: (grossProfit >= 0 ? T.teal : T.red) + "15", borderRadius: 8, border: `1px solid ${(grossProfit >= 0 ? T.teal : T.red)}33` }}>
          <div style={{ color: grossProfit >= 0 ? T.teal : T.red, fontWeight: 700, fontSize: 13 }}>Profit Margin: {margin}%</div>
        </div>
      </div>

      {/* 6-Month Chart */}
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px", marginBottom: 20 }}>
        <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 16 }}>6-Month Revenue vs Expenses</div>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 12, height: 160, padding: "10px 0" }}>
          {monthlyData.map(m => (
            <div key={m.label} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
              <div style={{ width: "100%", display: "flex", gap: 3, alignItems: "flex-end", height: 120 }}>
                <div style={{ flex: 1, background: T.teal + "80", borderRadius: "3px 3px 0 0", height: Math.max(4, (m.rev / maxVal) * 120) + "px", transition: "height 0.3s" }} title={"Revenue: GHS " + m.rev.toLocaleString()} />
                <div style={{ flex: 1, background: T.amber + "80", borderRadius: "3px 3px 0 0", height: Math.max(4, (m.exp / maxVal) * 120) + "px", transition: "height 0.3s" }} title={"Expenses: GHS " + m.exp.toLocaleString()} />
              </div>
              <div style={{ color: T.textMuted, fontSize: 11, textAlign: "center" }}>{m.label}</div>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", gap: 20, justifyContent: "center", marginTop: 8 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}><div style={{ width: 12, height: 12, borderRadius: 2, background: T.teal + "80" }} /><span style={{ color: T.textMuted, fontSize: 12 }}>Revenue</span></div>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}><div style={{ width: 12, height: 12, borderRadius: 2, background: T.amber + "80" }} /><span style={{ color: T.textMuted, fontSize: 12 }}>Expenses</span></div>
        </div>
      </div>
    </div>
  );
};


//  VENDOR SCORECARD 
const SCORECARD_CATEGORIES = [
  {
    key: "pricing", label: "1. Pricing & Cost Efficiency", weight: 0.15,
    fields: [
      { key: "pricing_competitiveness", label: "Competitiveness" },
      { key: "pricing_clarity", label: "Clarity of Pricing" },
      { key: "pricing_value", label: "Value-for-Money" },
      { key: "pricing_payment_flexibility", label: "Payment Flexibility & Terms" },
    ]
  },
  {
    key: "quality", label: "2. Quality of Service/Product", weight: 0.20,
    fields: [
      { key: "quality_product", label: "Product/Service Quality" },
      { key: "quality_execution", label: "Execution Excellence" },
      { key: "quality_post_support", label: "Post-Service Support" },
      { key: "quality_consistency", label: "Consistency" },
    ]
  },
  {
    key: "reliability", label: "3. Reliability & Consistency", weight: 0.15,
    fields: [
      { key: "reliability_delivery", label: "Delivery Accuracy" },
      { key: "reliability_punctuality", label: "Punctuality" },
      { key: "reliability_dependability", label: "Dependability" },
      { key: "reliability_contingency", label: "Contingency Management" },
    ]
  },
  {
    key: "comms", label: "4. Customer Service & Communication", weight: 0.15,
    fields: [
      { key: "comms_responsiveness", label: "Responsiveness" },
      { key: "comms_clarity", label: "Clarity & Proactivity" },
      { key: "comms_problem_solving", label: "Problem-Solving" },
      { key: "comms_relationship", label: "Relationship Management" },
    ]
  },
  {
    key: "innovation", label: "5. Innovation & Value-Addition", weight: 0.10,
    fields: [
      { key: "innovation_creative", label: "Creative Solutions" },
      { key: "innovation_customization", label: "Customization Capabilities" },
      { key: "innovation_suggestions", label: "Suggestions for Improvement" },
      { key: "innovation_trends", label: "Trend Awareness" },
    ]
  },
  {
    key: "flexibility", label: "6. Flexibility & Adaptability", weight: 0.10,
    fields: [
      { key: "flexibility_adaptation", label: "Adaptation to Change" },
      { key: "flexibility_custom", label: "Custom Solutions" },
      { key: "flexibility_negotiation", label: "Negotiation Flexibility" },
      { key: "flexibility_client_centric", label: "Client-Centric Approach" },
    ]
  },
  {
    key: "sustainability", label: "7. Sustainability & Social Responsibility", weight: 0.10,
    fields: [
      { key: "sustainability_eco", label: "Eco-Friendliness" },
      { key: "sustainability_ethics", label: "Ethical Standards" },
      { key: "sustainability_community", label: "Community Engagement" },
      { key: "sustainability_certifications", label: "Certifications & Reporting" },
    ]
  },
  {
    key: "fee", label: "8. Fee Summary", weight: 0.05,
    fields: [
      { key: "fee_transparency", label: "Fee Transparency" },
      { key: "fee_vs_budget", label: "Fees vs Budget" },
      { key: "fee_hidden", label: "Hidden Charges" },
      { key: "fee_invoice_clarity", label: "Invoice Clarity" },
      { key: "fee_other", label: "Other Fees" },
    ]
  },
];

const getTier = (pct) => {
  if (pct >= 85) return { label: "Impressive", color: "#10B981", bg: "#10B98120", desc: "Exceeds expectations — Elite pick" };
  if (pct >= 70) return { label: "Very Good", color: "#06B6D4", bg: "#06B6D420", desc: "Reliable — Strong performer" };
  if (pct >= 50) return { label: "Good", color: "#F59E0B", bg: "#F59E0B20", desc: "Satisfactory — Use with caution" };
  return { label: "Poor", color: "#F43F5E", bg: "#F43F5E20", desc: "Below standard — Cannot engage" };
};

const calcScore = (scores) => {
  let total = 0;
  SCORECARD_CATEGORIES.forEach(cat => {
    const vals = cat.fields.map(f => parseFloat(scores[f.key] || 0)).filter(v => v > 0);
    if (vals.length > 0) {
      const avg = vals.reduce((a, b) => a + b, 0) / vals.length;
      total += avg * cat.weight;
    }
  });
  return Math.round((total / 5) * 100 * 10) / 10;
};

const VendorScorecardModal = ({ vendor, events, user, onClose, onSaved }) => {
  const initScores = {};
  SCORECARD_CATEGORIES.forEach(cat => cat.fields.forEach(f => { initScores[f.key] = 0; }));
  const [scores, setScores] = useState(initScores);
  const [categoryNotes, setCategoryNotes] = useState({});
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);
  const [expandedCat, setExpandedCat] = useState(null);
  const [selectedEventId, setSelectedEventId] = useState("");
  const [reportModal, setReportModal] = useState(null);
  const [reportText, setReportText] = useState("");
  const [pushingReport, setPushingReport] = useState(false);

  const selectedEvent = events.find(e => e.id === selectedEventId) || null;
  const liveScore = calcScore(scores);
  const tier = getTier(liveScore);

  const setScore = (key, val) => setScores(prev => ({ ...prev, [key]: val }));

  const handleSave = async () => {
    if (!selectedEventId) { alert("Please select an event before saving."); return; }
    setSaving(true);
    const pct = calcScore(scores);
    const tierLabel = getTier(pct).label;
    const { error } = await supabase.from("vendor_scorecards").insert({
      vendor_id: vendor.id, vendor_name: vendor.name,
      project_id: selectedEvent?.id || null, event_name: selectedEvent?.name || "",
      ...scores, total_score: (pct / 20), total_pct: pct, tier: tierLabel,
      notes, category_notes: categoryNotes, scored_by: user.id,
    });
    if (!error) {
      // Update vendor profile with most recent score
      const { data: allScores } = await supabase.from("vendor_scorecards").select("total_pct, created_at").eq("vendor_id", vendor.id).order("created_at", { ascending: false });
      if (allScores && allScores.length > 0) {
        // Average last 2 scorecards
        const last2 = allScores.slice(0, 2);
        const avgScore = last2.reduce((sum, s) => sum + (s.total_pct || 0), 0) / last2.length;
        await supabase.from("profiles").update({
          vendor_score: Math.round(avgScore * 10) / 10,
          vendor_tier: getTier(avgScore).label,
          vendor_scorecard_count: allScores.length,
        }).eq("id", vendor.id);
      }
      onSaved();
      onClose();
    }
    setSaving(false);
  };

  const StarInput = ({ fieldKey }) => (
    <div style={{ display: "flex", gap: 4 }}>
      {[1,2,3,4,5].map(s => (
        <button key={s} onClick={() => setScore(fieldKey, s)} style={{
          background: "none", border: "none", cursor: "pointer",
          fontSize: 22, color: s <= scores[fieldKey] ? "#F59E0B" : T.border,
          padding: "2px", transition: "color 0.1s",
        }}></button>
      ))}
      {scores[fieldKey] > 0 && <span style={{ color: T.textMuted, fontSize: 11, alignSelf: "center", marginLeft: 4 }}>{scores[fieldKey]}/5</span>}
    </div>
  );

  return (
    <Modal title={"Scorecard — " + vendor.name} onClose={onClose}>
      {/* Event Selector */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.06em" }}>Select Event to Score</div>
        <select value={selectedEventId} onChange={e => setSelectedEventId(e.target.value)} style={{ width: "100%", padding: "10px 12px", background: T.bg, border: "1px solid " + (selectedEventId ? T.cyan : T.border), borderRadius: 8, color: selectedEventId ? T.textPrimary : T.textMuted, fontSize: 13, fontFamily: "inherit" }}>
          <option value="">Select event...</option>
          {events.map(ev => <option key={ev.id} value={ev.id}>{ev.name} — {ev.client || ""}</option>)}
        </select>
        {!selectedEventId && <div style={{ color: T.amber, fontSize: 11, marginTop: 6 }}> Please select an event to proceed</div>}
      </div>

      {/* Live Score */}
      <div style={{ padding: 16, background: tier.bg, border: "1px solid " + tier.color + "44", borderRadius: 10, marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ color: tier.color, fontWeight: 800, fontSize: 28 }}>{liveScore}%</div>
          <div style={{ color: tier.color, fontWeight: 700, fontSize: 14 }}>{tier.label}</div>
          <div style={{ color: T.textMuted, fontSize: 12 }}>{tier.desc}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          {selectedEvent && <div style={{ color: T.cyan, fontSize: 12, fontWeight: 600 }}> {selectedEvent.name}</div>}
          <div style={{ color: T.textMuted, fontSize: 11, marginTop: 4 }}>Score updates as you fill in</div>
        </div>
      </div>

      {/* Categories */}
      {SCORECARD_CATEGORIES.map(cat => {
        const catVals = cat.fields.map(f => scores[f.key]).filter(v => v > 0);
        const catAvg = catVals.length ? (catVals.reduce((a,b) => a+b,0) / catVals.length).toFixed(1) : "-";
        const isOpen = expandedCat === cat.key;
        return (
          <div key={cat.key} style={{ marginBottom: 8 }}>
            <button onClick={() => setExpandedCat(isOpen ? null : cat.key)} style={{
              width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "10px 14px", background: isOpen ? T.cyan + "15" : T.bg,
              border: "1px solid " + (isOpen ? T.cyan + "44" : T.border),
              borderRadius: 8, cursor: "pointer",
            }}>
              <div style={{ color: isOpen ? T.cyan : T.textPrimary, fontWeight: 600, fontSize: 13 }}>{cat.label}</div>
              <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                <span style={{ color: T.amber, fontSize: 12, fontWeight: 700 }}>Avg: {catAvg}/5</span>
                <span style={{ color: T.textMuted, fontSize: 11 }}>Weight: {Math.round(cat.weight * 100)}%</span>
                <span style={{ color: T.textMuted, fontSize: 12 }}>{isOpen ? "" : ""}</span>
              </div>
            </button>
            {isOpen && (
              <div style={{ padding: "12px 14px", background: T.surface, border: "1px solid " + T.border, borderTop: "none", borderRadius: "0 0 8px 8px" }}>
                {cat.fields.map(f => (
                  <div key={f.key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: "1px solid " + T.border + "66" }}>
                    <div style={{ color: T.textSecondary, fontSize: 13 }}>{f.label}</div>
                    <StarInput fieldKey={f.key} />
                  </div>
                ))}
                <div style={{ marginTop: 12 }}>
                  <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 5 }}>Category Notes — Reason for scores above</div>
                  <textarea
                    value={categoryNotes[cat.key] || ""}
                    onChange={e => setCategoryNotes(prev => ({ ...prev, [cat.key]: e.target.value }))}
                    placeholder={"Explain the scores given for " + cat.label + "..."}
                    rows={3}
                    style={{ width: "100%", padding: "8px 10px", background: T.bg, border: "1px solid " + T.cyan + "44", borderRadius: 7, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box", outline: "none" }}
                  />
                </div>
              </div>
            )}
          </div>
        );
      })}

      {/* Notes */}
      <div style={{ marginTop: 16, marginBottom: 16 }}>
        <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.06em" }}>Notes</div>
        <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Additional observations..."
          style={{ width: "100%", minHeight: 80, padding: 10, background: T.bg, border: "1px solid " + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 13, resize: "vertical", fontFamily: "inherit" }} />
      </div>

      <div style={{ display: "flex", gap: 10 }}>
        <Btn onClick={async () => {
          await handleSave();
          if (!selectedEventId) return;
          const workedItems = [];
          const needsWorkItems = [];
          SCORECARD_CATEGORIES.forEach(cat => {
            cat.fields.forEach(f => {
              const score = scores[f.key] || 0;
              const note = lineItemNotes[f.key] || "";
              if (score >= 4) workedItems.push("• " + f.label + ": " + score + "/5" + (note ? " — " + note : ""));
              else if (score > 0) needsWorkItems.push("• " + f.label + ": " + score + "/5 — " + (note || "No reason provided"));
            });
          });
          const selectedEvent = events.find(e => e.id === selectedEventId);
          const reportLines = ["VENDOR PERFORMANCE REPORT", "Vendor: " + vendor.name, "Event: " + (selectedEvent?.name||""), "Score: " + liveScore + "% — " + tier.label, "Date: " + new Date().toLocaleDateString("en-GB", {day:"numeric",month:"long",year:"numeric"}), "", "WHAT WORKED WELL", ...(workedItems.length > 0 ? workedItems : ["• No items scored at full marks"]), "", "AREAS FOR IMPROVEMENT", ...(needsWorkItems.length > 0 ? needsWorkItems : ["• All areas met expectations"]), "", "OVERALL ASSESSMENT", vendor.name + " delivered a " + tier.label.toLowerCase() + " performance on " + (selectedEvent?.name||"this event") + " with an overall score of " + liveScore + "%. " + (liveScore >= 85 ? "We strongly recommend this vendor for future engagements." : liveScore >= 70 ? "We recommend this vendor with minor improvements noted above." : liveScore >= 50 ? "This vendor may be considered for future events subject to addressing the areas noted above." : "We do not recommend this vendor for future engagements without significant improvement.")];
          const report = reportLines.join("\n");
          setReportText(report);
          setReportModal({ vendor, event: selectedEvent, score: liveScore, tier });
        }} disabled={saving}>{saving ? "Saving..." : "Submit & Generate Report"}</Btn>
        <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
      </div>

      {/* Report Preview Modal */}
      {reportModal && (
        <div style={{ position:"fixed", inset:0, zIndex:800, background:"rgba(0,0,0,0.9)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setReportModal(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:600, maxHeight:"85vh", overflow:"hidden", display:"flex", flexDirection:"column" }} onClick={e=>e.stopPropagation()}>
            <div style={{ padding:"18px 22px", borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div>
                <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16 }}>Vendor Performance Report</div>
                <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{reportModal.vendor.name} · {reportModal.score}% · {reportModal.tier.label}</div>
              </div>
              <button onClick={() => setReportModal(null)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"5px 10px", borderRadius:6, cursor:"pointer", fontSize:13 }}></button>
            </div>
            <div style={{ flex:1, overflowY:"auto", padding:"18px 22px" }}>
              <div style={{ color:T.textMuted, fontSize:11, marginBottom:8 }}>Review and edit before pushing to vendor:</div>
              <textarea value={reportText} onChange={e=>setReportText(e.target.value)} rows={18}
                style={{ width:"100%", padding:"12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:12, fontFamily:"monospace", outline:"none", resize:"vertical", boxSizing:"border-box", lineHeight:1.6 }} />
            </div>
            <div style={{ padding:"14px 22px", borderTop:`1px solid ${T.border}`, display:"flex", gap:10 }}>
              <button onClick={async () => {
                setPushingReport(true);
                const { data: sc } = await supabase.from("vendor_scorecards").select("id").eq("vendor_id", vendor.id).eq("project_id", selectedEventId).order("created_at", { ascending:false }).limit(1).single();
                if (sc) {
                  await supabase.from("vendor_scorecards").update({ scorecard_report:reportText, report_generated_at:new Date().toISOString(), report_pushed_at:new Date().toISOString(), visible_to_vendor:true, category_notes:categoryNotes }).eq("id", sc.id);
                }
                await supabase.from("notifications").insert({ user_id:vendor.id, title:"Performance Report — " + (reportModal.event?.name||""), message:"Stretchfield has published your performance report. Log in to view your scorecard.", type:"rff" });
                const emailHtml = `<div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;"><div style="height:6px;background:linear-gradient(90deg,#FF6B35,#FF3CAC,#784BA0,#2B86C5,#00C8FF);"></div><div style="background:#060B14;padding:28px 32px;"><table style="width:100%;"><tr><td><span style="color:#00C8FF;font-size:12px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;">STRETCHFIELD WORKROOM</span></td><td style="text-align:right;"><img src="https://workroom.stretchfield.com/logo512.png" style="height:32px;" /></td></tr></table><div style="color:#E8F0FF;font-size:20px;font-weight:800;margin-top:16px;padding-top:16px;border-top:1px solid #1A2E4A;">Your Performance Report is Ready</div></div><div style="padding:28px 32px;background:#F4F6FB;"><p style="color:#0A1628;font-size:14px;">Hi <strong>${vendor.name}</strong>,</p><p style="color:#0A1628;font-size:14px;">Your performance report for <strong>${reportModal.event?.name||""}</strong> has been published.</p><p style="color:#0A1628;font-size:14px;"><strong style="color:#00C8FF;">${reportModal.score}% — ${reportModal.tier.label}</strong></p><a href="https://workroom.stretchfield.com" style="display:inline-block;background:linear-gradient(135deg,#00C8FF,#00E5C8);color:#060B14;padding:12px 28px;border-radius:8px;font-weight:800;font-size:13px;text-decoration:none;margin:16px 0;">View in WorkRoom →</a><p style="color:#5A6E8A;font-size:12px;">Log in at workroom.stretchfield.com to view your full report.</p></div></div>`;
                await fetch("/api/send-email", { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ to:vendor.email, subject:"Your Performance Report — " + (reportModal.event?.name||"") + " — Stretchfield", html:emailHtml }) });
                setPushingReport(false);
                setReportModal(null);
                onSaved();
                onClose();
              }} disabled={pushingReport} style={{ flex:1, background:`linear-gradient(135deg,${T.teal},#10B981)`, border:"none", color:"#fff", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{pushingReport?"Pushing...":"Push to Vendor →"}</button>
              <button onClick={() => setReportModal(null)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 18px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Edit Later</button>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

const VendorScorecardsView = ({ user, activeCountry = "All" }) => {
  const [vendors, setVendors] = useState([]);
  const [events, setEvents] = useState([]);
  const [scorecards, setScorecards] = useState([]);
  const [scoreModal, setScoreModal] = useState(null);
  const [historyVendor, setHistoryVendor] = useState(null);

  const canScore = ["CEO", "Country Manager", "Vendor Manager"].includes(user?.role);

  const [awards, setAwards] = useState([]);

  const load = async () => {
    const [v, e, s, aw] = await Promise.all([
      (!activeCountry || activeCountry === "All") ? supabase.from("profiles").select("*").eq("role","Vendor") : supabase.from("profiles").select("*").eq("role","Vendor").eq("country",activeCountry),
      (!activeCountry || activeCountry === "All") ? supabase.from("projects").select("*") : supabase.from("projects").select("*").eq("country", activeCountry),
      supabase.from("vendor_scorecards").select("*").order("created_at", { ascending: false }),
      (!activeCountry || activeCountry === "All") ? supabase.from("rff_awards").select("*, rffs(project_id, event_name)") : supabase.from("rff_awards").select("*, rffs(project_id, event_name)").eq("country", activeCountry),
    ]);
    setVendors(v.data || []);
    setEvents(e.data || []);
    setScorecards(s.data || []);
    setAwards(aw.data || []);
  };

  useEffect(() => { load(); }, [activeCountry]);

  const getTierBadge = (tier, score) => {
    const t = tier ? getTier(score) : { label: "Unrated", color: T.textMuted, bg: T.bg };
    return (
      <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: t.bg, color: t.color, border: "1px solid " + t.color + "44" }}>
        {t.label} {score > 0 ? score + "%" : ""}
      </span>
    );
  };

  const impressive = vendors.filter(v => (v.vendor_score || 0) >= 85).length;
  const veryGood = vendors.filter(v => (v.vendor_score || 0) >= 70 && (v.vendor_score || 0) < 85).length;
  const good = vendors.filter(v => (v.vendor_score || 0) >= 50 && (v.vendor_score || 0) < 70).length;
  const poor = vendors.filter(v => v.vendor_scorecard_count > 0 && (v.vendor_score || 0) < 50).length;
  const unrated = vendors.filter(v => !v.vendor_scorecard_count).length;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Vendors</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Vendor Scorecards</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Performance ratings based on Stretchfield scoring formula</div>
      </div>

      {/* Tier distribution strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 10, marginBottom: 24 }}>
        {[
          { label: "Total", value: vendors.length, color: T.cyan },
          { label: "Impressive", value: impressive, color: "#10B981" },
          { label: "Very Good", value: veryGood, color: T.blue },
          { label: "Good", value: good, color: T.amber },
          { label: "Poor / Blocked", value: poor, color: T.red },
        ].map((k, i) => (
          <div key={i} style={{ padding: "12px 14px", background: T.surface, border: `1px solid ${k.color}30`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 20, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 600, marginTop: 3, textTransform: "uppercase", letterSpacing: "0.06em" }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Vendor Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
        {vendors.sort((a, b) => (b.vendor_score || 0) - (a.vendor_score || 0)).map(v => {
          const score = v.vendor_score || 0;
          const tier = getTier(score);
          const vendorCards = scorecards.filter(s => s.vendor_id === v.id);
          const isPoor = v.vendor_scorecard_count > 0 && score < 50;
          const isUnrated = !v.vendor_scorecard_count;
          const accentColor = isPoor ? T.red : score >= 85 ? "#10B981" : score >= 70 ? T.cyan : score >= 50 ? T.amber : T.border;
          const initials = v.name.slice(0,2).toUpperCase();

          return (
            <div key={v.id} style={{
              background: T.surface,
              border: `1px solid ${isPoor ? T.red + "40" : T.border}`,
              borderTop: `3px solid ${accentColor}`,
              borderRadius: 12, padding: "18px 20px",
              transition: "box-shadow 0.2s, border-color 0.2s",
            }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = `0 4px 24px ${accentColor}18`}
              onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
            >
              {/* Header row */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 38, height: 38, borderRadius: 9, background: `linear-gradient(135deg, ${accentColor}30, ${accentColor}10)`, border: `1px solid ${accentColor}40`, display: "flex", alignItems: "center", justifyContent: "center", color: accentColor, fontWeight: 900, fontSize: 12, flexShrink: 0 }}>{initials}</div>
                  <div>
                    <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13 }}>{v.name}</div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 1 }}>{v.email}</div>
                  </div>
                </div>
                {/* Score dial */}
                <div style={{ textAlign: "center", flexShrink: 0 }}>
                  <div style={{ fontSize: 26, fontWeight: 900, lineHeight: 1, color: isUnrated ? T.textMuted : accentColor }}>
                    {score > 0 ? score + "%" : "—"}
                  </div>
                  <div style={{ color: T.textMuted, fontSize: 9, marginTop: 2 }}>{v.vendor_scorecard_count || 0} scored</div>
                </div>
              </div>

              {/* Tier badge + score bar */}
              <div style={{ marginBottom: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                  <span style={{ padding: "2px 10px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: accentColor + "18", color: accentColor, border: `1px solid ${accentColor}30` }}>
                    {tier.label}
                  </span>
                  {isPoor && <span style={{ color: T.red, fontSize: 10, fontWeight: 700 }}> Blocked</span>}
                  {score >= 85 && <span style={{ color: "#10B981", fontSize: 10, fontWeight: 700 }}> Priority</span>}
                </div>
                {score > 0 && (
                  <div style={{ height: 4, background: T.border + "44", borderRadius: 2 }}>
                    <div style={{ height: "100%", width: score + "%", background: `linear-gradient(90deg, ${accentColor}, ${accentColor}99)`, borderRadius: 2, transition: "width 0.4s ease" }} />
                  </div>
                )}
              </div>

              {/* Recent scores */}
              {vendorCards.length > 0 && (
                <div style={{ marginBottom: 12, paddingBottom: 12, borderBottom: `1px solid ${T.border}33` }}>
                  <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Recent</div>
                  {vendorCards.slice(0, 2).map(sc => (
                    <div key={sc.id} style={{ display: "flex", justifyContent: "space-between", padding: "3px 0" }}>
                      <div style={{ color: T.textMuted, fontSize: 11 }}>{sc.event_name || "General"}</div>
                      <div style={{ color: getTier(sc.total_pct).color, fontWeight: 800, fontSize: 11 }}>{sc.total_pct}%</div>
                    </div>
                  ))}
                </div>
              )}

              {/* Actions */}
              <div style={{ display: "flex", gap: 8 }}>
                {canScore && !isPoor && (
                  <button onClick={() => setScoreModal(v)} style={{ flex: 1, padding: "7px", background: T.cyan + "12", border: `1px solid ${T.cyan}30`, borderRadius: 8, cursor: "pointer", color: T.cyan, fontSize: 11, fontWeight: 700, letterSpacing: "0.04em" }}>
                    + Score
                  </button>
                )}
                {vendorCards.length > 0 && (
                  <button onClick={() => setHistoryVendor(v)} style={{ flex: 1, padding: "7px", background: "none", border: `1px solid ${T.border}`, borderRadius: 8, cursor: "pointer", color: T.textMuted, fontSize: 11, fontWeight: 600 }}>
                    History
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Score Modal */}
      {scoreModal && (
        <VendorScorecardModal
          vendor={scoreModal}
          events={(() => {
            const vendorAwards = awards.filter(a => a.vendor_id === scoreModal.id);
            const awardedEventIds = vendorAwards.map(a => a.rffs?.project_id).filter(Boolean);
            const filtered = events.filter(e => awardedEventIds.includes(e.id));
            return filtered.length > 0 ? filtered : events;
          })()}
          user={user}
          onClose={() => setScoreModal(null)}
          onSaved={load}
        />
      )}

      {/* History Modal */}
      {historyVendor && (
        <Modal title={"Scorecard History — " + historyVendor.name} onClose={() => setHistoryVendor(null)}>
          {scorecards.filter(s => s.vendor_id === historyVendor.id).map(sc => {
            const t = getTier(sc.total_pct);
            return (
              <div key={sc.id} style={{ padding: "14px 0", borderBottom: `1px solid ${T.border}44` }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{sc.event_name || "General"}</div>
                  <span style={{ color: t.color, fontWeight: 900, fontSize: 18 }}>{sc.total_pct}%</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ padding: "2px 10px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: t.color + "18", color: t.color, border: `1px solid ${t.color}30` }}>{t.label}</span>
                  <div style={{ color: T.textMuted, fontSize: 11 }}>{new Date(sc.created_at).toLocaleDateString()}</div>
                </div>
                <div style={{ height: 3, background: T.border + "44", borderRadius: 2, marginTop: 8 }}>
                  <div style={{ height: "100%", width: sc.total_pct + "%", background: t.color, borderRadius: 2 }} />
                </div>
                {sc.notes && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 8, fontStyle: "italic", borderTop: `1px solid ${T.border}33`, paddingTop: 8 }}>{sc.notes}</div>}
              </div>
            );
          })}
        </Modal>
      )}
    </div>
  );
};



//  VENDOR RATINGS VIEW (CEO/Admin/Strategy read-only) 
const VendorRatingsView = ({ user }) => {
  const [vendors, setVendors] = useState([]);
  const [scorecards, setScorecards] = useState([]);
  const [rffs, setRffs] = useState([]);
  const [events, setEvents] = useState([]);
  const [historyVendor, setHistoryVendor] = useState(null);
  const [viewMode, setViewMode] = useState("by-event");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [period, setPeriod] = useState("all"); // "all" | "this-month" | "last-3" | "this-year"

  const load = async () => {
    const [v, s, r, e] = await Promise.all([
      supabase.from("profiles").select("*").eq("role", "Vendor"),
      supabase.from("vendor_scorecards").select("*").order("created_at", { ascending: false }),
      (!activeCountry || activeCountry === "All") ? supabase.from("rffs").select("*").eq("status","quote-approved") : supabase.from("rffs").select("*").eq("status","quote-approved").eq("country",activeCountry),
      (!activeCountry || activeCountry === "All") ? supabase.from("projects").select("*").order("created_at",{ascending:false}) : supabase.from("projects").select("*").eq("country",activeCountry).order("created_at",{ascending:false}),
    ]);
    setVendors(v.data || []);
    setScorecards(s.data || []);
    setRffs(r.data || []);
    setEvents(e.data || []);
  };

  useEffect(() => { load(); }, []);

  // Period filter
  const now = new Date();
  const filteredScorecards = scorecards.filter(sc => {
    if (period === "all") return true;
    const d = new Date(sc.created_at);
    if (period === "this-month") return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    if (period === "last-3") return d >= new Date(now.getFullYear(), now.getMonth() - 3, 1);
    if (period === "this-year") return d.getFullYear() === now.getFullYear();
    return true;
  });

  // Analytics
  const scoredVendors = vendors.filter(v => filteredScorecards.some(s => s.vendor_id === v.id));
  const avgScore = scoredVendors.length ? Math.round(filteredScorecards.reduce((a, s) => a + s.total_pct, 0) / filteredScorecards.length) : 0;
  const topVendor = filteredScorecards.length ? vendors.find(v => v.id === [...filteredScorecards].sort((a,b) => b.total_pct - a.total_pct)[0]?.vendor_id) : null;
  const poorVendors = vendors.filter(v => { const sc = filteredScorecards.filter(s => s.vendor_id === v.id); return sc.length > 0 && sc[sc.length-1].total_pct < 50; });

  // Build event → vendors map from approved RFFs
  const eventVendorMap = events.map(ev => {
    const eventRffs = rffs.filter(r => r.project_id === ev.id);
    const vendorIds = [...new Set(eventRffs.map(r => r.vendor).filter(Boolean))];
    const vendorsForEvent = eventRffs.map(r => {
      const vendorProfile = vendors.find(v => v.name === r.vendor || v.id === r.vendor_id);
      const scorecard = filteredScorecards.find(s => s.vendor_id === vendorProfile?.id && s.project_id === ev.id);
      return {
        rff: r, vendorProfile,
        scorecard, score: scorecard?.total_pct || null,
        tier: scorecard ? getTier(scorecard.total_pct) : null,
      };
    });
    return { event: ev, vendors: vendorsForEvent };
  }).filter(e => e.vendors.length > 0);

  const sorted = [...vendors].sort((a, b) => (b.vendor_score || 0) - (a.vendor_score || 0));

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Vendors</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Vendor Ratings</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Performance ratings per event and overall</div>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          {[["all","All"],["this-month","Month"],["last-3","3M"],["this-year","YTD"]].map(([val, label]) => (
            <button key={val} onClick={() => setPeriod(val)} style={{ padding: "5px 14px", borderRadius: 20, border: `1px solid ${period === val ? T.cyan : T.border}`, cursor: "pointer", background: period === val ? T.cyan + "20" : "none", color: period === val ? T.cyan : T.textMuted, fontWeight: 700, fontSize: 11, letterSpacing: "0.04em", transition: "all 0.15s" }}>{label}</button>
          ))}
        </div>
      </div>

      {/* KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 10, marginBottom: 24 }}>
        {[
          { label: "Scorecards", value: filteredScorecards.length, color: T.cyan },
          { label: "Avg Score", value: filteredScorecards.length ? avgScore + "%" : "—", color: T.amber },
          { label: "Top Vendor", value: topVendor?.name?.split(" ")[0] || "—", color: "#10B981" },
          { label: "Do Not Engage", value: poorVendors.length, color: T.red },
          { label: "Impressive", value: filteredScorecards.filter(s => s.total_pct >= 85).length, color: "#10B981" },
          { label: "Poor (<50%)", value: filteredScorecards.filter(s => s.total_pct < 50).length, color: T.red },
        ].map((k, i) => (
          <div key={i} style={{ padding: "12px 14px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 16, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 600, marginTop: 3, textTransform: "uppercase", letterSpacing: "0.06em" }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* View Toggle */}
      <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        {["by-event", "by-vendor"].map(mode => (
          <button key={mode} onClick={() => setViewMode(mode)} style={{
            padding: "8px 20px", borderRadius: 20, border: "none", cursor: "pointer",
            background: viewMode === mode ? T.cyan : T.bg,
            color: viewMode === mode ? "#000" : T.textMuted,
            fontWeight: viewMode === mode ? 700 : 500, fontSize: 12,
            textTransform: "uppercase", letterSpacing: "0.06em",
          }}>{mode === "by-event" ? "By Event" : "By Vendor"}</button>
        ))}
      </div>

      {/* BY EVENT VIEW */}
      {viewMode === "by-event" && (
        <div>
          {eventVendorMap.length === 0 ? (
            <Card style={{ textAlign: "center", padding: 60 }}>
              <div style={{ fontSize: 40, marginBottom: 16 }}></div>
              <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16 }}>No scored vendors yet</div>
              <div style={{ color: T.textMuted, fontSize: 13, marginTop: 8 }}>Vendor Manager scores vendors after each event.</div>
            </Card>
          ) : eventVendorMap.map(({ event: ev, vendors: evVendors }) => (
            <div key={ev.id} style={{ marginBottom: 24 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
                <div style={{ width: 3, height: 20, background: T.cyan, borderRadius: 2 }} />
                <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>{ev.name}</div>
                <div style={{ color: T.textMuted, fontSize: 12 }}>· {evVendors.length} vendor{evVendors.length > 1 ? "s" : ""}</div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 12 }}>
                {evVendors.map((vd, i) => {
                  const score = vd.score;
                  const tier = score !== null ? getTier(score) : null;
                  const isPoor = score !== null && score < 50;
                  return (
                    <div key={i} style={{ background: T.surface, border: `1px solid ${score === null ? T.border : isPoor ? T.red + "40" : tier.color + "40"}`, borderTop: `2px solid ${score === null ? T.border : isPoor ? T.red : tier.color}`, borderRadius: 10, padding: "14px 16px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13 }}>{vd.rff.vendor}</div>
                          <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{vd.rff.title}</div>
                          {score !== null && (
                            <span style={{ display: "inline-block", marginTop: 6, padding: "2px 9px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: tier.color + "18", color: tier.color, border: `1px solid ${tier.color}30` }}>
                              {tier.label}
                            </span>
                          )}
                        </div>
                        <div style={{ textAlign: "center", minWidth: 48, flexShrink: 0 }}>
                          <div style={{ fontSize: 22, fontWeight: 900, color: score === null ? T.textMuted : isPoor ? T.red : tier.color }}>
                            {score !== null ? score + "%" : "—"}
                          </div>
                          <div style={{ color: T.textMuted, fontSize: 9 }}>{score === null ? "Unscored" : "Score"}</div>
                        </div>
                      </div>
                      {isPoor && <div style={{ marginTop: 8, color: T.red, fontSize: 10, fontWeight: 700 }}> Do not re-engage</div>}
                      {score !== null && score >= 85 && <div style={{ marginTop: 8, color: "#10B981", fontSize: 10, fontWeight: 700 }}> Priority pick</div>}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* BY VENDOR VIEW */}
      {viewMode === "by-vendor" && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 16 }}>
          {sorted.map(v => {
            const score = v.vendor_score || 0;
            const tier = getTier(score);
            const vendorCards = scorecards.filter(s => s.vendor_id === v.id);
            const isPoor = v.vendor_scorecard_count > 0 && score < 50;
            const isUnrated = !v.vendor_scorecard_count;
            return (
              <div key={v.id} style={{ background: T.surface, border: `1px solid ${isPoor ? T.red + "40" : T.border}`, borderTop: `3px solid ${isPoor ? T.red : isUnrated ? T.border : tier.color}`, borderRadius: 12, padding: "18px 20px", transition: "box-shadow 0.2s" }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = `0 4px 20px ${isPoor ? T.red : isUnrated ? T.border : tier.color}15`}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13 }}>{v.name}</div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{v.email}</div>
                    <div style={{ marginTop: 7 }}>
                      <span style={{ padding: "2px 9px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: isUnrated ? T.bg : tier.color + "18", color: isUnrated ? T.textMuted : tier.color, border: `1px solid ${isUnrated ? T.border : tier.color + "30"}` }}>
                        {isUnrated ? "Unrated" : tier.label}
                      </span>
                    </div>
                  </div>
                  <div style={{ textAlign: "center", flexShrink: 0 }}>
                    <div style={{ fontSize: 26, fontWeight: 900, color: isUnrated ? T.textMuted : tier.color }}>{isUnrated ? "—" : score + "%"}</div>
                    <div style={{ color: T.textMuted, fontSize: 9 }}>{v.vendor_scorecard_count || 0} scored</div>
                  </div>
                </div>
                {!isUnrated && score > 0 && (
                  <div style={{ height: 3, background: T.border + "44", borderRadius: 2, marginBottom: 10 }}>
                    <div style={{ height: "100%", width: score + "%", background: isPoor ? T.red : tier.color, borderRadius: 2 }} />
                  </div>
                )}
                {isPoor && <div style={{ padding: "6px 12px", background: T.red + "12", borderRadius: 6, border: `1px solid ${T.red}30`, marginBottom: 8 }}><div style={{ color: T.red, fontSize: 11, fontWeight: 700 }}> Do not engage</div></div>}
                {score >= 85 && <div style={{ padding: "6px 12px", background: "#10B98112", borderRadius: 6, border: "1px solid #10B98130", marginBottom: 8 }}><div style={{ color: "#10B981", fontSize: 11, fontWeight: 700 }}> Priority vendor</div></div>}
                {vendorCards.length > 0 && (
                  <div style={{ marginBottom: 10 }}>
                    {filteredScorecards.filter(s => s.vendor_id === v.id).slice(0, 3).map(sc => (
                      <div key={sc.id} style={{ display: "flex", justifyContent: "space-between", padding: "3px 0" }}>
                        <div style={{ color: T.textMuted, fontSize: 11 }}>{sc.event_name || "General"}</div>
                        <div style={{ color: getTier(sc.total_pct).color, fontWeight: 800, fontSize: 11 }}>{sc.total_pct}%</div>
                      </div>
                    ))}
                  </div>
                )}
                {vendorCards.length > 0 && (
                  <button onClick={() => setHistoryVendor(v)} style={{ width: "100%", padding: "7px", background: "none", border: `1px solid ${T.border}`, borderRadius: 8, cursor: "pointer", color: T.textMuted, fontSize: 11, fontWeight: 600 }}>View All Scorecards</button>
                )}
              </div>
            );
          })}
        </div>
      )}

      {historyVendor && (
        <Modal title={"Scorecard History — " + historyVendor.name} onClose={() => setHistoryVendor(null)}>
          {scorecards.filter(s => s.vendor_id === historyVendor.id).map(sc => {
            const t = getTier(sc.total_pct);
            return (
              <div key={sc.id} style={{ padding: "12px 0", borderBottom: "1px solid " + T.border }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 700 }}>{sc.event_name || "General"}</div>
                  <span style={{ color: t.color, fontWeight: 800, fontSize: 16 }}>{sc.total_pct}%</span>
                </div>
                <div style={{ color: t.color, fontSize: 12, fontWeight: 600, marginBottom: 4 }}>{t.label}</div>
                <div style={{ color: T.textMuted, fontSize: 11 }}>{new Date(sc.created_at).toLocaleDateString()}</div>
                {sc.notes && <div style={{ color: T.textSecondary, fontSize: 12, marginTop: 6, fontStyle: "italic" }}>{sc.notes}</div>}
              </div>
            );
          })}
        </Modal>
      )}
    </div>
  );
};


//  RFF APPROVAL QUEUE (CEO) 


const ContractAwardApprovalView = ({ user, activeCountry = "All" }) => {
  const [awards, setAwards] = useState([]);
  const [previewAward, setPreviewAward] = useState(null);
  const [awardLines, setAwardLines] = useState([]);
  useEffect(() => {
    if (!previewAward) { setAwardLines([]); return; }
    (async () => {
      const { data } = await supabase.from("rfp_item_awards").select("*, rfp_items(*, rfp_sections(code, title))").eq("award_id", previewAward.id);
      const ls = (data || []).filter(x => x.rfp_items).sort((a, b) => a.rfp_items.line_no - b.rfp_items.line_no);
      if (!ls.length) return setAwardLines([]);
      const { data: qs } = await supabase.from("rfp_item_quotes").select("item_id, unit_price").eq("vendor_id", previewAward.vendor_id).in("item_id", ls.map(x => x.item_id));
      const { data: axs } = await supabase.from("rfp_award_extras").select("*").eq("award_id", previewAward.id);
      const exRows = (axs || []).map((e, k) => ({ id: "ex" + e.id, note: "", actual_unit_price: e.amount, quoted: e.quoted_amount, rfp_items: { line_no: 900 + k + 1, description: e.label, qty: 1, days: 1, unit: "lot", projected_unit_cost: 0, rfp_sections: { code: "", title: "Other charges" } } }));
      setAwardLines([...ls.map(x => ({ ...x, quoted: (qs || []).find(q => q.item_id === x.item_id)?.unit_price })), ...exRows]);
    })();
  }, [previewAward]);
  const [ceoNotes, setCeoNotes] = useState("");
  const [saving, setSaving] = useState(false);
  const [rffs, setRffs] = useState([]);
  const [budgets, setBudgets] = useState([]);

  const load = async () => {
    const awQuery = (!activeCountry || activeCountry === "All") ? supabase.from("rff_awards").select("*").order("created_at", { ascending: false }) : supabase.from("rff_awards").select("*").eq("country", activeCountry).order("created_at", { ascending: false });
    const { data: aw } = await awQuery;
    const rfQuery = (!activeCountry || activeCountry === "All") ? supabase.from("rffs").select("*") : supabase.from("rffs").select("*").eq("country", activeCountry);
    const { data: rf } = await rfQuery;
    const { data: bud } = await supabase.from("rff_budgets").select("*");
    setAwards(aw || []);
    setRffs(rf || []);
    setBudgets(bud || []);
  };

  useEffect(() => { load(); }, [activeCountry]);

  const handleApprove = async (award) => {
    setSaving(true);
    // CEO approves AND confirms in one step
    await supabase.from("rff_awards").update({
      status: "confirmed",
      approved_by: user.id,
      ceo_notes: ceoNotes,
      confirmed_at: new Date().toISOString(),
    }).eq("id", award.id);
    // Notify Finance Manager
    const { data: fms } = await supabase.from("profiles").select("id, email, name").in("role", ["Finance Manager"]);
    for (const fm of fms || []) {
      await supabase.from("notifications").insert({
        user_id: fm.id,
        title: "Gig Confirmed — Create PO",
        message: `CEO confirmed ${award.vendor_name} for this gig. Please create a Purchase Order.`,
        type: "finance",
      });
      if (fm.email) await sendEmail(fm.email, `Gig Confirmed — Create PO for ${award.vendor_name}`, notifEmailHtml({ name: fm.name, title: "Gig Confirmed — Create Purchase Order", message: `CEO has confirmed <strong>${award.vendor_name}</strong> for <strong>${award.event_name||"a gig"}</strong>. Please log in to Finance → Purchase Orders to generate the Purchase Order.`, actionUrl: BASE_URL, actionLabel: "Go to Purchase Orders" }));
    }
    // Notify Vendor Manager
    const { data: vms } = await supabase.from("profiles").select("id, email, name").eq("role", "Vendor Manager");
    for (const vm of vms || []) {
      await supabase.from("notifications").insert({
        user_id: vm.id,
        title: "Contract Award Confirmed",
        message: `CEO approved and confirmed ${award.vendor_name} for the gig. Finance has been notified to create a PO.`,
        type: "rff",
      });
      if (vm.email) await sendEmail(vm.email, `Contract Award Confirmed — ${award.vendor_name}`, notifEmailHtml({ name: vm.name, title: "Contract Award Confirmed", message: `CEO has approved and confirmed <strong>${award.vendor_name}</strong> for the gig. Finance has been notified to create a Purchase Order.`, actionUrl: BASE_URL, actionLabel: "View in WorkRoom" }));
    }
    // RFP awards: the invoice must equal the approved lines, not the vendor's whole quote
    let rfpLineCount = 0;
    try { const { count } = await supabase.from("rfp_item_awards").select("id", { count: "exact", head: true }).eq("award_id", award.id); rfpLineCount = count || 0; } catch (e) { /* not an RFP award */ }
    // Auto-create invoice from quote if vendor has submitted one unchanged
    const { data: assignment } = await supabase.from("rff_vendor_assignments").select("*").eq("rff_id", award.rff_id).eq("vendor_id", award.vendor_id).single();
    if (assignment && rfpLineCount > 0 && award.agreed_amount != null) assignment.quote_amount = award.agreed_amount;
    if (assignment?.quote_document_url && assignment?.quote_amount) {
      // Check if invoice already exists for this vendor+rff
      const { data: existingInv } = await supabase.from("vendor_invoices").select("id").eq("vendor_id", award.vendor_id).eq("invoice_number", "INV-QUOTE-"+award.rff_id.slice(0,8)).maybeSingle();
      if (!existingInv) {
        // Get RFF and event details
        const { data: rff } = await supabase.from("rffs").select("rff_code,event_name,project_id").eq("id", award.rff_id).single();
        const invNum = "INV/" + (rff?.rff_code || award.rff_id.slice(0,8)) + (rfpLineCount > 0 ? "-" + award.id.slice(0,4).toUpperCase() : "");
        await supabase.from("vendor_invoices").insert({
          vendor_id: award.vendor_id,
          vendor_name: award.vendor_name,
          event_name: rff?.event_name || "",
          amount: assignment.quote_amount,
          invoice_url: assignment.quote_document_url,
          invoice_filename: assignment.quote_notes || "Quote document",
          invoice_number: invNum,
          status: "submitted",
          country: award.country || "Ghana",
          notes: "Auto-generated from approved quote — no revision requested",
          created_at: new Date().toISOString(),
        });
        // Notify Finance about auto-invoice
        for (const fm of fms || []) {
          await supabase.from("notifications").insert({
            user_id: fm.id,
            title: "Invoice Auto-Created — " + award.vendor_name,
            message: award.vendor_name + "'s approved quote has been automatically submitted as invoice " + invNum + " for " + getCurrency(award.country||activeCountry||"Ghana") + " " + parseFloat(assignment.quote_amount).toLocaleString() + ". Go to Vendor Invoices to review.",
            type: "finance",
          });
        }
        // Notify vendor that their quote is being used as invoice
        await supabase.from("notifications").insert({
          user_id: award.vendor_id,
          title: "Quote Accepted as Invoice",
          message: "Your quote of " + getCurrency(award.country||activeCountry||"Ghana") + " " + parseFloat(assignment.quote_amount).toLocaleString() + " has been approved and automatically submitted as your invoice " + invNum + ". Finance will process payment shortly.",
          type: "finance",
        });
        // Notify VM
        for (const vm of vms || []) {
          await supabase.from("notifications").insert({
            user_id: vm.id,
            title: "Auto-Invoice Created — " + award.vendor_name,
            message: award.vendor_name + "'s quote used as invoice " + invNum + ". No revision was requested so the original quote stands.",
            type: "rff",
          });
        }
      }
    }
    setSaving(false); setPreviewAward(null); setCeoNotes(""); load();
  };

  const handleDecline = async (award) => {
    if (!ceoNotes) { alert("Please add notes explaining the decline."); return; }
    setSaving(true);
    await supabase.from("rff_awards").update({ status: "declined_ceo", ceo_notes: ceoNotes }).eq("id", award.id);
    const { data: vms } = await supabase.from("profiles").select("id").eq("role", "Vendor Manager");
    for (const vm of vms || []) {
      await supabase.from("notifications").insert({
        user_id: vm.id,
        title: "Contract Award Declined",
        message: `CEO declined the award for ${award.vendor_name}. Notes: ${ceoNotes.slice(0,100)}`,
        type: "rff",
      });
    }
    setSaving(false); setPreviewAward(null); setCeoNotes(""); load();
  };

  const statusColor = { pending_ceo: T.amber, approved_ceo: T.teal, declined_ceo: T.red, confirmed: "#10B981", po_created: T.cyan };
  const statusLabel = { pending_ceo: "Pending CEO Approval", declined_ceo: "Declined by CEO", confirmed: "Confirmed by CEO", po_created: "PO Created" };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Procurement</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Contract Awards</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{awards.filter(a => a.status === "pending_ceo").length} pending your approval</div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px,1fr))", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Pending Approval", value: awards.filter(a => a.status === "pending_ceo").length, color: T.amber },
          { label: "Approved", value: awards.filter(a => ["approved_ceo","confirmed","po_created"].includes(a.status)).length, color: T.teal },
          { label: "Confirmed", value: awards.filter(a => a.status === "confirmed").length, color: "#10B981" },
          { label: "PO Created", value: awards.filter(a => a.status === "po_created").length, color: T.cyan },
        ].map((k,i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 20, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginTop: 4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {awards.length === 0 && <div style={{ textAlign: "center", padding: 40, color: T.textMuted }}>No contract awards yet.</div>}
        {awards.map(award => {
          const rff = rffs.find(r => r.id === award.rff_id);
          const rffBudgets = budgets.filter(b => b.rff_id === award.rff_id);
          const totalBudget = rffBudgets.reduce((s, b) => s + (b.proposed_amount || 0), 0);
          return (
            <div key={award.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderLeft: `3px solid ${statusColor[award.status] || T.textMuted}`, borderRadius: 12, padding: "18px 20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>{award.vendor_name}</div>
                  <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{rff?.title} · {rff?.event_name}</div>
                  <div style={{ display: "flex", gap: 16, marginTop: 6 }}>
                    <span style={{ color: T.amber, fontWeight: 700, fontSize: 13 }}>Quote: {getCurrency(award.country||activeCountry||"Ghana")} {(award.quoted_amount || 0).toLocaleString()}</span>
                    {totalBudget > 0 && <span style={{ color: T.cyan, fontSize: 13 }}>Budget: {getCurrency(award.country||activeCountry||"Ghana")} {totalBudget.toLocaleString()}</span>}
                  </div>
                  {award.vendor_manager_notes && <div style={{ color: T.textMuted, fontSize: 12, marginTop: 6, fontStyle: "italic" }}>VM Notes: {award.vendor_manager_notes}</div>}
                </div>
                <span style={{ background: (statusColor[award.status] || T.textMuted) + "18", color: statusColor[award.status] || T.textMuted, border: `1px solid ${(statusColor[award.status] || T.textMuted)}30`, borderRadius: 20, padding: "3px 12px", fontSize: 10, fontWeight: 800, textTransform: "uppercase" }}>{statusLabel[award.status] || award.status}</span>
              </div>
              <button onClick={() => { setPreviewAward(award); setCeoNotes(award.ceo_notes || ""); }} style={{ background: T.cyan + "15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "6px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Review</button>
            </div>
          );
        })}
      </div>

      {/* Preview Modal */}
      {previewAward && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.8)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setPreviewAward(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: awardLines.length ? 860 : 560, padding: 28, maxHeight: "92vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Contract Award Review</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>{previewAward.vendor_name}</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 12, background: T.bg, borderRadius: 10, padding: "14px 16px", marginBottom: 16 }}>
              {[
                ["Vendor", previewAward.vendor_name],
                ["Quoted Amount", `${getCurrency(previewAward?.country||activeCountry||"Ghana")} ${((previewAward.quoted_amount||0).toLocaleString())}`],
                ["Proposed Budget", `${getCurrency(previewAward?.country||activeCountry||"Ghana")} ${((previewAward.proposed_budget||0).toLocaleString())}`],
                ["Variance", previewAward.quoted_amount <= (previewAward.proposed_budget||0) ? " Within budget" : ` Over by ${getCurrency(previewAward?.country||activeCountry||"Ghana")} ${((previewAward.quoted_amount||0)-(previewAward.proposed_budget||0)).toLocaleString()}`],
              ].map(([l,v]) => (
                <div key={l}><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{l}</div><div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600, marginTop: 3 }}>{v}</div></div>
              ))}
            </div>
            {previewAward.vendor_manager_notes && (
              <div style={{ background: T.cyan + "10", border: `1px solid ${T.cyan}25`, borderRadius: 8, padding: "10px 14px", marginBottom: 16 }}>
                <div style={{ color: T.cyan, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>Vendor Manager Notes</div>
                <div style={{ color: T.textSecondary, fontSize: 13 }}>{previewAward.vendor_manager_notes}</div>
              </div>
            )}
            {awardLines.length > 0 && (() => {
              const cur = getCurrency(previewAward?.country || activeCountry || "Ghana");
              const lt = (x, p) => Number(p || 0) * Number(x.rfp_items.qty || 1) * Number(x.rfp_items.days || 1);
              const totA = awardLines.reduce((t, x) => t + lt(x, x.actual_unit_price), 0), totP = awardLines.reduce((t, x) => t + lt(x, x.rfp_items.projected_unit_cost), 0), totQ = awardLines.reduce((t, x) => t + lt(x, x.quoted), 0);
              return (
                <div style={{ marginBottom: 16 }}>
                  <div style={{ color: T.cyan, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 6 }}>Awarded line items ({awardLines.length}) — this is what the PO will contain</div>
                  <div style={{ maxHeight: 280, overflow: "auto", border: `1px solid ${T.border}`, borderRadius: 8 }}>
                    <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
                      <thead><tr style={{ color: T.textMuted, textAlign: "left", background: T.bg }}><th style={{ padding: "6px 8px" }}>#</th><th>Item</th><th>Qty</th><th>Projected</th><th>Quoted</th><th>Agreed</th><th style={{ textAlign: "right", paddingRight: 8 }}>Line total</th></tr></thead>
                      <tbody>{awardLines.map(x => (
                        <tr key={x.id} style={{ borderTop: `1px solid ${T.border}`, color: T.textPrimary }}>
                          <td style={{ padding: "6px 8px" }}>{x.rfp_items.line_no}</td>
                          <td>{x.rfp_items.description}<div style={{ color: T.textMuted, fontSize: 10 }}>{[x.rfp_items.rfp_sections?.code, x.rfp_items.rfp_sections?.title].filter(Boolean).join(" ")}{x.note ? " · " + x.note : ""}</div></td>
                          <td>{x.rfp_items.qty}{x.rfp_items.days > 1 ? " × " + x.rfp_items.days : ""} {x.rfp_items.unit}</td>
                          <td style={{ color: T.textMuted }}>{Number(x.rfp_items.projected_unit_cost || 0).toLocaleString()}</td>
                          <td>{x.quoted != null ? Number(x.quoted).toLocaleString() : "—"}</td>
                          <td style={{ color: x.quoted != null && Number(x.actual_unit_price) < Number(x.quoted) ? T.teal : T.textPrimary, fontWeight: 700 }}>{Number(x.actual_unit_price).toLocaleString()}</td>
                          <td style={{ textAlign: "right", paddingRight: 8, fontWeight: 700 }}>{lt(x, x.actual_unit_price).toLocaleString()}</td>
                        </tr>))}
                        <tr style={{ borderTop: `2px solid ${T.border}`, fontWeight: 900, color: T.textPrimary }}><td /><td>Totals</td><td /><td>{cur} {totP.toLocaleString()}</td><td>{cur} {totQ.toLocaleString()}</td><td /><td style={{ textAlign: "right", paddingRight: 8, color: T.cyan }}>{cur} {totA.toLocaleString()}</td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })()}
            {previewAward.status === "pending_ceo" && (
              <>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>CEO Notes</label>
                  <textarea value={ceoNotes} onChange={e => setCeoNotes(e.target.value)} rows={3} placeholder="Add notes..." style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box", resize: "vertical" }} />
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <button onClick={() => handleApprove(previewAward)} disabled={saving} style={{ background: "linear-gradient(135deg, #10B981, #059669)", border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}> Approve & Confirm Gig</button>
                  <button onClick={() => handleDecline(previewAward)} disabled={saving} style={{ background: T.red + "18", border: `1px solid ${T.red}40`, color: T.red, padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}> Decline</button>
                  <button onClick={() => setPreviewAward(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
                </div>
              </>
            )}
            {previewAward.status !== "pending_ceo" && (
              <button onClick={() => setPreviewAward(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Close</button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const GigConfirmationView = ({ user }) => {
  const [awards, setAwards] = useState([]);
  const [rffs, setRffs] = useState([]);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const { data: aw } = await supabase.from("rff_awards").select("*").in("status", ["approved_ceo","confirmed"]).order("created_at", { ascending: false });
    const rfQuery = supabase.from("rffs").select("*");
    const { data: rf } = await rfQuery;
    setAwards(aw || []);
    setRffs(rf || []);
  };

  useEffect(() => { load(); }, []);

  const handleConfirm = async (award) => {
    if (!window.confirm(`Confirm gig for ${award.vendor_name}? This will notify Finance to create a Purchase Order.`)) return;
    setSaving(true);
    await supabase.from("rff_awards").update({ status: "confirmed", confirmed_at: new Date().toISOString() }).eq("id", award.id);
    // Notify Finance Manager
    const { data: fms } = await supabase.from("profiles").select("id").in("role", ["Finance Manager","CEO"]);
    for (const fm of fms || []) {
      await supabase.from("notifications").insert({
        user_id: fm.id,
        title: "Gig Confirmed — Create PO",
        message: `${award.vendor_name} confirmed for "${rffs.find(r => r.id === award.rff_id)?.title}". Please create a Purchase Order.`,
        type: "rff",
      });
    }
    setSaving(false); load();
  };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Procurement</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Confirm Gigs</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{awards.filter(a => a.status === "approved_ceo").length} awaiting your confirmation</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {awards.length === 0 && <div style={{ textAlign: "center", padding: 40, color: T.textMuted }}>No approved awards to confirm.</div>}
        {awards.map(award => {
          const rff = rffs.find(r => r.id === award.rff_id);
          return (
            <div key={award.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderLeft: `3px solid ${award.status === "confirmed" ? "#10B981" : T.teal}`, borderRadius: 12, padding: "18px 20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>{award.vendor_name}</div>
                  <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{rff?.title} · {rff?.event_name}</div>
                  <div style={{ color: T.amber, fontWeight: 700, fontSize: 13, marginTop: 4 }}>{getCurrency(user?.country||"Ghana")+" "+((award.quoted_amount || 0).toLocaleString()).toLocaleString()}</div>
                  {award.ceo_notes && <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4, fontStyle: "italic" }}>CEO: {award.ceo_notes}</div>}
                </div>
                {award.status === "approved_ceo" && (
                  <button onClick={() => handleConfirm(award)} disabled={saving} style={{ background: "linear-gradient(135deg, #10B981, #059669)", border: "none", color: "#fff", padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}> Confirm Gig</button>
                )}
                {award.status === "confirmed" && <span style={{ color: "#10B981", fontWeight: 700, fontSize: 13 }}> Confirmed</span>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};


//  PDF Generator Utilities 
const generatePOPDF = (po, vendor, rff, event) => {
  const poNumber = po.internal_po_number || po.zoho_po_number || "PO-" + po.id?.slice(0,8);
  const poLineRows = Array.isArray(po.line_items) && po.line_items.length ? po.line_items : null;
  const date = new Date(po.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: Arial, sans-serif; color: #0A1628; background: #fff; }
  .page { width: 794px; min-height: 1123px; margin: 0 auto; padding: 48px 56px; }
  .header { display: flex; justify-content: space-between; align-items: flex-start; padding-bottom: 28px; border-bottom: 3px solid #00C8FF; margin-bottom: 32px; background: linear-gradient(135deg, #f8faff 0%, #eef2ff 100%); margin: -48px -56px 32px; padding: 48px 56px 28px; }
  .logo-area .company { font-size: 22px; font-weight: 900; color: #060B14; letter-spacing: -0.02em; }
  .logo-area .tagline { font-size: 11px; color: #5A6E8A; font-style: italic; margin-top: 4px; }
  .logo-area .contact { font-size: 11px; color: #5A6E8A; margin-top: 8px; line-height: 1.6; }
  .po-title { text-align: right; }
  .po-title .label { font-size: 11px; font-weight: 700; color: #00C8FF; letter-spacing: 0.14em; text-transform: uppercase; }
  .po-title .number { font-size: 28px; font-weight: 900; color: #060B14; letter-spacing: -0.02em; margin-top: 4px; }
  .po-title .date { font-size: 12px; color: #5A6E8A; margin-top: 4px; }
  .meta-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-bottom: 32px; }
  .meta-box { background: #F4F6FB; border-radius: 8px; padding: 16px 20px; }
  .meta-box .label { font-size: 10px; font-weight: 700; color: #00C8FF; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 8px; }
  .meta-box .value { font-size: 13px; color: #0A1628; font-weight: 600; line-height: 1.6; }
  .meta-box .sub { font-size: 11px; color: #5A6E8A; margin-top: 2px; }
  .section-title { font-size: 10px; font-weight: 700; color: #5A6E8A; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 10px; }
  table.items { width: 100%; border-collapse: collapse; margin-bottom: 24px; }
  table.items thead tr { background: #060B14; }
  table.items thead th { padding: 10px 14px; text-align: left; font-size: 10px; font-weight: 700; color: #00C8FF; text-transform: uppercase; letter-spacing: 0.08em; }
  table.items tbody tr { border-bottom: 1px solid #E8EBF4; }
  table.items tbody td { padding: 12px 14px; font-size: 13px; color: #0A1628; }
  .total-row { background: #F4F6FB; }
  .total-row td { font-weight: 800; font-size: 15px; }
  .total-amount { color: #00C8FF; font-size: 18px; font-weight: 900; }
  .terms-box { background: #F4F6FB; border-left: 4px solid #00C8FF; border-radius: 0 8px 8px 0; padding: 14px 18px; margin-bottom: 28px; }
  .terms-box .label { font-size: 10px; font-weight: 700; color: #5A6E8A; text-transform: uppercase; margin-bottom: 6px; }
  .terms-box .value { font-size: 13px; color: #0A1628; line-height: 1.6; }
  .signatures { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px,1fr)); gap: 20px; margin-top: 40px; }
  .sig-box { padding-top: 10px; }
  .sig-box .name { font-size: 12px; font-weight: 700; color: #0A1628; margin-top: 4px; }
  .sig-box .role { font-size: 10px; color: #5A6E8A; }
  .footer { margin-top: 40px; padding-top: 20px; border-top: 1px solid #E8EBF4; display: flex; justify-content: space-between; align-items: center; }
  .footer .left { font-size: 10px; color: #5A6E8A; line-height: 1.8; }
  .footer .right { font-size: 10px; color: #5A6E8A; text-align: right; }
  .badge { display: inline-block; background: #00C8FF18; color: #00C8FF; border: 1px solid #00C8FF40; border-radius: 20px; padding: 3px 12px; font-size: 10px; font-weight: 700; text-transform: uppercase; }
</style>
</head>
<body>
<div style="height:6px;background:linear-gradient(90deg,#FF6B35,#FF3CAC,#784BA0,#2B86C5,#00C8FF);width:100%;"></div>
<div class="page">
  <!-- Header -->
  <div class="header">
    <div class="logo-area">
      <div style="display:flex;align-items:center;gap:12px;margin-bottom:8px;">
        <img src="https://workroom.stretchfield.com/logo512.png" alt="Stretchfield" style="height:48px;width:48px;display:block;" onerror="this.style.display='none'" />
        <div class="company">STRETCHFIELD</div>
      </div>
      <div class="tagline">We don't plan events. We engineer impact.</div>
      <div class="contact">
        info@stretchfield.com · www.stretchfield.com<br>
        ${po.country === "Nigeria" ? "Lagos, Nigeria" : "Accra, Ghana"}
      </div>
    </div>
    <div class="po-title">
      <div class="label">Purchase Order</div>
      <div class="number">${poNumber}</div>
      <div class="date">Issued: ${date}</div>
      ${po.zoho_po_number ? '<div class="date" style="color:#00C8FF;">Zoho: ' + po.zoho_po_number + '</div>' : ''}
    </div>
  </div>

  <!-- Meta Grid -->
  <div class="meta-grid">
    <div class="meta-box">
      <div class="label">Vendor / Supplier</div>
      <div class="value">${po.vendor_name}</div>
      ${vendor?.email ? '<div class="sub">' + vendor.email + '</div>' : ''}
      ${vendor?.phone ? '<div class="sub">' + vendor.phone + '</div>' : ''}
      ${vendor?.service_category ? '<div class="sub">' + vendor.service_category + '</div>' : ''}
    </div>
    <div class="meta-box">
      <div class="label">Event / Project</div>
      <div class="value">${po.event_name || event?.name || "—"}</div>
      ${rff?.title ? '<div class="sub">RFF: ' + rff.title + '</div>' : ''}
      ${event?.event_date ? '<div class="sub">Event Date: ' + new Date(event.event_date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) + '</div>' : ''}
      ${event?.client ? '<div class="sub">Client: ' + event.client + '</div>' : ''}
    </div>
  </div>

  <!-- Line Items -->
${poLineRows ? `  <div class="section-title">Approved Scope — Line Items</div>
  <table class="items">
    <thead><tr><th style="width:5%">#</th><th style="width:38%">Description</th><th>Category</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit price</th><th style="text-align:right">Amount</th></tr></thead>
    <tbody>
      ${poLineRows.map(l => `<tr><td>${l.no}</td><td><strong>${l.description}</strong>${l.spec ? '<div style="font-size:11px;color:#5A6E8A;margin-top:2px;">' + l.spec + '</div>' : ''}${l.note ? '<div style="font-size:11px;color:#5A6E8A;font-style:italic;margin-top:2px;">' + l.note + '</div>' : ''}</td><td style="font-size:11px;">${l.category || "—"}</td><td style="text-align:right;">${l.qty}${l.days > 1 ? " × " + l.days : ""} ${l.unit}</td><td style="text-align:right;">${po.currency || "GHS"} ${Number(l.unit_price).toLocaleString()}</td><td style="text-align:right;font-weight:700;">${po.currency || "GHS"} ${Number(l.total).toLocaleString()}</td></tr>`).join("")}
      ${po.notes ? '<tr><td colspan="6" style="color:#5A6E8A;font-size:12px;font-style:italic;">Note: ' + po.notes + '</td></tr>' : ''}
    </tbody>
    <tfoot>
      <tr class="total-row">
        <td colspan="5" style="text-align:right;padding:12px 14px;">Total Amount</td>
        <td style="text-align:right;padding:12px 14px;" class="total-amount">${po.currency || (po.country === "Nigeria" ? "NGN" : "GHS")} ${parseFloat(po.amount||0).toLocaleString()}</td>
      </tr>
    </tfoot>
  </table>
` : `  <div class="section-title">Service Details</div>
  <table class="items">
    <thead>
      <tr>
        <th style="width:50%">Description</th>
        <th>Category</th>
        <th style="text-align:right">Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <strong>${vendor?.service_category || po.rff_category || "Professional Services"}</strong>
          ${(rff?.description || po.notes) ? '<div style="font-size:11px;color:#5A6E8A;margin-top:3px;">' + (rff?.description || po.notes) + '</div>' : ''}
          <div style="font-size:11px;color:#5A6E8A;margin-top:3px;">Event: ${po.event_name || rff?.event_name || "—"} · RFF: ${po.rff_title || rff?.title || poNumber}</div>
        </td>
        <td>${po.rff_category || rff?.event_type || vendor?.service_category || "—"}</td>
        <td style="text-align:right;font-weight:700;">${po.currency || "GHS"} ${parseFloat(po.amount||0).toLocaleString()}</td>
      </tr>
      ${po.notes ? '<tr><td colspan="3" style="color:#5A6E8A;font-size:12px;font-style:italic;">Note: ' + po.notes + '</td></tr>' : ''}
    </tbody>
    <tfoot>
      <tr class="total-row">
        <td colspan="2" style="text-align:right;padding:12px 14px;">Total Amount</td>
        <td style="text-align:right;padding:12px 14px;" class="total-amount">${po.currency || (po.country === "Nigeria" ? "NGN" : "GHS")} ${parseFloat(po.amount||0).toLocaleString()}</td>
      </tr>
    </tfoot>
  </table>
`}

  <!-- Terms -->
  <div class="terms-box">
    <div class="label">Payment Terms & Instructions</div>
    <div class="value">
      Please log in to <strong>Stretchfield WorkRoom</strong> at <strong>workroom.stretchfield.com</strong> to submit your invoice referencing PO Number <strong>${poNumber}</strong> upon completion of service delivery.<br>
      Do not send invoices via email. All invoices must be submitted through the Stretchfield WorkRoom Vendor Portal.<br>
      Payment will be processed in accordance with your agreed payment terms once your invoice is verified.
    </div>
  </div>

  <!-- Signatures -->
  <div class="section-title">Authorisation</div>
  <div class="signatures">
    <div class="sig-box">
      <div style="height:52px;display:flex;align-items:flex-end;padding-bottom:4px;">
        ${po.finance_signature ? '<img src="' + po.finance_signature + '" style="height:48px;max-width:160px;object-fit:contain;" />' : ''}
      </div>
      <div style="border-bottom:1px solid #C2C9DC;margin-bottom:5px;"></div>
      <div class="name">Finance Manager</div>
      <div class="role">Reviewed by</div>
      ${po.finance_signed_at ? '<div style="font-size:9px;color:#5A6E8A;margin-top:2px;">' + new Date(po.finance_signed_at).toLocaleDateString("en-GB") + '</div>' : ''}
    </div>
    <div class="sig-box">
      <div style="height:52px;display:flex;align-items:flex-end;padding-bottom:4px;">
        ${po.vm_signature ? '<img src="' + po.vm_signature + '" style="height:48px;max-width:160px;object-fit:contain;" />' : ''}
      </div>
      <div style="border-bottom:1px solid #C2C9DC;margin-bottom:5px;"></div>
      <div class="name">Vendor Manager</div>
      <div class="role">Prepared by</div>
      ${po.vm_signed_at ? '<div style="font-size:9px;color:#5A6E8A;margin-top:2px;">' + new Date(po.vm_signed_at).toLocaleDateString("en-GB") + '</div>' : ''}
    </div>
    ${po.country === "Nigeria" ? `
    <div class="sig-box">
      <div style="height:52px;display:flex;align-items:flex-end;padding-bottom:4px;">
        ${po.cm_signature ? '<img src="' + po.cm_signature + '" style="height:48px;max-width:160px;object-fit:contain;" />' : ''}
      </div>
      <div style="border-bottom:1px solid #C2C9DC;margin-bottom:5px;"></div>
      <div class="name">Country Manager — Nigeria</div>
      <div class="role">Confirmed by</div>
      ${po.cm_signed_at ? '<div style="font-size:9px;color:#5A6E8A;margin-top:2px;">' + new Date(po.cm_signed_at).toLocaleDateString("en-GB") + '</div>' : ''}
    </div>` : ''}
    <div class="sig-box">
      <div style="height:52px;display:flex;align-items:flex-end;padding-bottom:4px;">
        ${po.ceo_signature ? '<img src="' + po.ceo_signature + '" style="height:48px;max-width:160px;object-fit:contain;" />' : ''}
      </div>
      <div style="border-bottom:1px solid #C2C9DC;margin-bottom:5px;"></div>
      <div class="name">CEO</div>
      <div class="role">Authorised by · Stretchfield</div>
      ${po.ceo_signed_at ? '<div style="font-size:9px;color:#5A6E8A;margin-top:2px;">' + new Date(po.ceo_signed_at).toLocaleDateString("en-GB") + '</div>' : ''}
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <div class="left">
      <strong>STRETCHFIELD</strong><br>
      www.stretchfield.com · info@stretchfield.com<br>
      © ${new Date().getFullYear()} Stretchfield. All rights reserved.
    </div>
    <div class="right">
      <span class="badge">${po.status?.toUpperCase() || "DRAFT"}</span><br>
      <span style="margin-top:4px;display:block;">Document ID: ${po.id?.slice(0,8).toUpperCase()}</span>
    </div>
  </div>
</div>
</body>
</html>`;
  return html;
};

const generateImpactReportPDF = (event, brief, scorecard, postData, report, impactReport) => {
  const date = new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  const overallScore = scorecard ? STRETCHFIELD_DIMENSIONS.reduce((s,d) => s + (parseFloat(scorecard[d.key+"_score"]||0) * d.weight), 0).toFixed(1) : "—";
  const roi = scorecard?.event_cost && scorecard?.revenue_impact
    ? (((scorecard.revenue_impact - scorecard.event_cost) / scorecard.event_cost) * 100).toFixed(1) + "%"
    : "—";
  const currency = event?.country === "Nigeria" ? "NGN" : "GHS";

  return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
* { margin:0; padding:0; box-sizing:border-box; }
body { font-family: Arial, sans-serif; color: #0A1628; background: #fff; }
.page { width: 794px; min-height: 1123px; margin: 0 auto; padding: 48px 56px; }
.rainbow { height: 6px; background: linear-gradient(90deg,#FF6B35,#FF3CAC,#784BA0,#2B86C5,#00C8FF); width: 100%; }
.header { display: flex; justify-content: space-between; align-items: flex-start; padding: 32px 0 24px; border-bottom: 2px solid #00C8FF; margin-bottom: 28px; }
.company { font-size: 20px; font-weight: 900; color: #060B14; }
.tagline { font-size: 10px; color: #5A6E8A; margin-top: 3px; font-style: italic; }
.report-label { font-size: 10px; font-weight: 700; color: #00C8FF; text-transform: uppercase; letter-spacing: 0.14em; text-align: right; }
.report-title { font-size: 22px; font-weight: 900; color: #060B14; text-align: right; margin-top: 4px; }
.report-sub { font-size: 11px; color: #5A6E8A; text-align: right; margin-top: 3px; }
.section-title { font-size: 10px; font-weight: 700; color: #00C8FF; text-transform: uppercase; letter-spacing: 0.1em; margin: 24px 0 10px; padding-bottom: 6px; border-bottom: 1px solid #00C8FF30; }
.kpi-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 16px; }
.kpi-box { background: #F4F6FB; border-radius: 8px; padding: 14px 16px; }
.kpi-label { font-size: 9px; font-weight: 700; color: #5A6E8A; text-transform: uppercase; margin-bottom: 4px; }
.kpi-value { font-size: 20px; font-weight: 900; color: #00C8FF; }
.kpi-sub { font-size: 10px; color: #5A6E8A; margin-top: 2px; }
.score-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 16px; }
.score-box { background: #F4F6FB; border-radius: 8px; padding: 12px 14px; border-left: 4px solid #00C8FF; }
.score-dim { font-size: 10px; font-weight: 700; color: #5A6E8A; text-transform: uppercase; }
.score-val { font-size: 18px; font-weight: 900; color: #060B14; margin-top: 2px; }
.score-actual { font-size: 10px; color: #5A6E8A; margin-top: 2px; }
.narrative { font-size: 13px; color: #0A1628; line-height: 1.8; white-space: pre-wrap; margin-bottom: 16px; }
.overall-box { background: linear-gradient(135deg, #00C8FF12, #00C8FF05); border: 2px solid #00C8FF40; border-radius: 10px; padding: 16px 20px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.footer { margin-top: 40px; padding-top: 16px; border-top: 1px solid #E8EBF4; display: flex; justify-content: space-between; font-size: 10px; color: #5A6E8A; }
</style>
</head>
<body>
<div class="rainbow"></div>
<div class="page">
  <div class="header">
    <div>
      <div class="company">STRETCHFIELD</div>
      <div class="tagline">We don't plan events. We engineer impact.</div>
      <div style="font-size:10px;color:#5A6E8A;margin-top:6px;">info@stretchfield.com · www.stretchfield.com</div>
    </div>
    <div>
      <div class="report-label">Impact Intelligence Report</div>
      <div class="report-title">${event?.name || "Event"}</div>
      <div class="report-sub">${event?.client || ""} · ${date}</div>
    </div>
  </div>

  ${brief ? `
  <div class="section-title">Impact Objective</div>
  <p style="font-size:13px;color:#0A1628;font-weight:600;margin-bottom:8px;">${brief.impact_objective || "—"}</p>
  <p style="font-size:12px;color:#5A6E8A;margin-bottom:4px;">Target Audience: ${brief.target_audience || "—"}</p>
  <p style="font-size:12px;color:#5A6E8A;margin-bottom:16px;">Observable Signal: ${brief.observable_signal || "—"}</p>

  <div class="section-title">KPI Targets</div>
  <div class="kpi-grid">
    ${[["KPI 1", brief.kpi1_name, brief.kpi1_target], ["KPI 2", brief.kpi2_name, brief.kpi2_target], ["KPI 3", brief.kpi3_name, brief.kpi3_target]].filter(([,n]) => n).map(([label, name, target]) => `
    <div class="kpi-box">
      <div class="kpi-label">${label}</div>
      <div style="font-size:13px;font-weight:700;color:#060B14;">${name}</div>
      <div class="kpi-sub">Target: ${target || "—"}</div>
    </div>`).join("")}
  </div>` : ""}

  ${postData ? `
  <div class="section-title">Post-Event Performance</div>
  <div class="kpi-grid">
    ${[["Attendees", postData.total_attendees, ""], ["Satisfaction", postData.satisfaction_score ? postData.satisfaction_score+"/10" : "—", ""], ["NPS Score", postData.nps_score || "—", ""], ["Sentiment", postData.positive_sentiment_pct ? postData.positive_sentiment_pct+"%" : "—", "Positive"], ["Leads Generated", postData.opportunities_generated || "—", ""], ["Revenue Shift", postData.revenue_shift_pct ? postData.revenue_shift_pct+"%" : "—", ""]].map(([label, value, sub]) => `
    <div class="kpi-box">
      <div class="kpi-label">${label}</div>
      <div class="kpi-value">${value || "—"}</div>
      ${sub ? `<div class="kpi-sub">${sub}</div>` : ""}
    </div>`).join("")}
  </div>` : ""}

  ${scorecard ? `
  <div class="section-title">Impact Scorecard — Stretchfield 6-Dimension Framework</div>
  <div class="score-grid">
    ${STRETCHFIELD_DIMENSIONS.map(dim => {
      const score = parseFloat(scorecard[dim.key+"_score"]||0);
      const color = score >= 8 ? "#10B981" : score >= 6 ? "#00C8FF" : score >= 4 ? "#F59E0B" : "#F43F5E";
      return `<div class="score-box" style="border-left-color:${color}">
        <div class="score-dim">${dim.label}</div>
        <div class="score-val" style="color:${color}">${score}/10</div>
        <div class="score-actual">${scorecard[dim.key+"_actual"] || "—"}</div>
      </div>`;
    }).join("")}
  </div>
  <div class="overall-box">
    <div>
      <div style="font-size:14px;font-weight:800;color:#060B14;">Overall Impact Score</div>
      <div style="font-size:11px;color:#5A6E8A;margin-top:2px;">Weighted across all 6 dimensions</div>
    </div>
    <div style="text-align:right;">
      <div style="font-size:36px;font-weight:900;color:#00C8FF;">${overallScore}/10</div>
      ${scorecard.event_cost && scorecard.revenue_impact ? `<div style="font-size:12px;color:#10B981;font-weight:700;">ROI: ${roi}</div>` : ""}
    </div>
  </div>
  ${scorecard.event_cost ? `
  <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:20px;">
    <div class="kpi-box"><div class="kpi-label">Event Cost</div><div style="font-size:14px;font-weight:800;color:#060B14;">${currency} ${parseFloat(scorecard.event_cost||0).toLocaleString()}</div></div>
    <div class="kpi-box"><div class="kpi-label">Revenue Impact</div><div style="font-size:14px;font-weight:800;color:#10B981;">${currency} ${parseFloat(scorecard.revenue_impact||0).toLocaleString()}</div></div>
    <div class="kpi-box"><div class="kpi-label">ROI</div><div style="font-size:14px;font-weight:800;color:${parseFloat(roi)>=0?"#10B981":"#F43F5E"};">${roi}</div></div>
  </div>` : ""}` : ""}

  ${(impactReport?.one_line_story || report?.one_line_story) ? `
  <div class="section-title">Impact Narrative</div>
  <div class="narrative">${impactReport?.one_line_story || report?.one_line_story}</div>` : ""}

  ${scorecard?.commentary ? `
  <div class="section-title">Commentary & Observations</div>
  <div class="narrative">${scorecard.commentary}</div>` : ""}

  <div class="footer">
    <div><strong>STRETCHFIELD</strong> · www.stretchfield.com · info@stretchfield.com<br>${event?.country === "Nigeria" ? "Lagos, Nigeria" : "Accra, Ghana"}</div>
    <div style="text-align:right;">Confidential & Proprietary<br>© ${new Date().getFullYear()} Stretchfield. All rights reserved.</div>
  </div>
</div>
</body>
</html>`;
};

const downloadPDF = (html, filename) => {
  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (win) {
    win.onload = () => {
      win.print();
    };
  }
};

const generateVoucherPDF = (voucher, approver, financeManager) => {
  const date = new Date(voucher.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: Arial, sans-serif; color: #0A1628; background: #fff; }
  .page { width: 794px; min-height: 1123px; margin: 0 auto; padding: 48px 56px; }
  .header { display: flex; justify-content: space-between; align-items: flex-start; padding-bottom: 24px; border-bottom: 3px solid #00C8FF; margin-bottom: 28px; }
  .company { font-size: 22px; font-weight: 900; color: #060B14; }
  .tagline { font-size: 11px; color: #5A6E8A; font-style: italic; margin-top: 3px; }
  .voucher-title { text-align: right; }
  .voucher-title .label { font-size: 11px; font-weight: 700; color: #00C8FF; letter-spacing: 0.14em; text-transform: uppercase; }
  .voucher-title .number { font-size: 26px; font-weight: 900; color: #060B14; margin-top: 4px; }
  .amount-hero { background: linear-gradient(135deg, #060B14, #0A1628); border-radius: 10px; padding: 24px 28px; margin-bottom: 28px; display: flex; justify-content: space-between; align-items: center; }
  .amount-hero .label { font-size: 10px; font-weight: 700; color: #5A7A9A; text-transform: uppercase; letter-spacing: 0.1em; }
  .amount-hero .amount { font-size: 32px; font-weight: 900; color: #00C8FF; margin-top: 4px; }
  .amount-hero .right { text-align: right; }
  .amount-hero .type { font-size: 11px; color: #5A7A9A; }
  .amount-hero .type-val { font-size: 14px; font-weight: 700; color: #E8F0FF; margin-top: 3px; }
  .detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 24px; }
  .detail-box { background: #F4F6FB; border-radius: 8px; padding: 14px 18px; }
  .detail-box .label { font-size: 10px; font-weight: 700; color: #5A6E8A; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 5px; }
  .detail-box .value { font-size: 13px; color: #0A1628; font-weight: 600; line-height: 1.5; }
  .sig-section { margin-top: 36px; }
  .sig-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 28px; margin-top: 12px; }
  .sig-box { border: 1px solid #C2C9DC; border-radius: 8px; padding: 16px 18px; min-height: 100px; }
  .sig-box .label { font-size: 10px; font-weight: 700; color: #5A6E8A; text-transform: uppercase; margin-bottom: 8px; }
  .sig-box img { max-height: 50px; max-width: 100%; }
  .sig-box .name { font-size: 12px; font-weight: 700; color: #0A1628; margin-top: 8px; border-top: 1px solid #E8EBF4; padding-top: 6px; }
  .sig-box .date { font-size: 10px; color: #5A6E8A; }
  .footer { margin-top: 40px; padding-top: 16px; border-top: 1px solid #E8EBF4; display: flex; justify-content: space-between; font-size: 10px; color: #5A6E8A; }
</style>
</head>
<body>
<div style="height:6px;background:linear-gradient(90deg,#FF6B35,#FF3CAC,#784BA0,#2B86C5,#00C8FF);width:100%;"></div>
<div class="page">
  <div class="header">
    <div>
      <img src="https://workroom.stretchfield.com/logo512.png" alt="Stretchfield" style="height:40px;width:40px;display:block;margin-bottom:8px;" />
      <div class="company">STRETCHFIELD</div>
      <div class="tagline">We don't plan events. We engineer impact.</div>
      <div style="font-size:11px;color:#5A6E8A;margin-top:6px;">info@stretchfield.com · www.stretchfield.com</div>
    </div>
    <div class="voucher-title">
      <div class="label">Payment Voucher</div>
      <div class="number">${voucher.voucher_number}</div>
      <div style="font-size:12px;color:#5A6E8A;margin-top:4px;">${date}</div>
    </div>
  </div>

  <div class="amount-hero">
    <div>
      <div class="label">Amount to Pay</div>
      <div class="amount">GHS ${parseFloat(voucher.amount||0).toLocaleString()}</div>
    </div>
    <div class="right">
      <div class="type">Payment Type</div>
      <div class="type-val">${(voucher.payment_type||"").replace(/_/g," ").toUpperCase()}</div>
      <div class="type" style="margin-top:8px;">Status</div>
      <div class="type-val" style="color:#00E5C8;">${(voucher.status||"").toUpperCase()}</div>
    </div>
  </div>

  <div class="detail-grid">
    <div class="detail-box">
      <div class="label">Payee</div>
      <div class="value">${voucher.payee}</div>
    </div>
    <div class="detail-box">
      <div class="label">Description</div>
      <div class="value">${voucher.description}</div>
    </div>
    <div class="detail-box">
      <div class="label">Account / Category</div>
      <div class="value">${voucher.account || "—"}</div>
    </div>
    <div class="detail-box">
      <div class="label">Reference</div>
      <div class="value">${voucher.reference || voucher.voucher_number}</div>
    </div>
    ${voucher.event_name ? '<div class="detail-box"><div class="label">Event</div><div class="value">' + voucher.event_name + '</div></div>' : ''}
    <div class="detail-box">
      <div class="label">Raised By</div>
      <div class="value">${financeManager?.name || "Finance Manager"}</div>
    </div>
  </div>

  <div class="sig-section">
    <div style="font-size:10px;font-weight:700;color:#5A6E8A;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:12px;">Authorisation Signatures</div>
    <div class="sig-grid">
      <div class="sig-box">
        <div class="label">Finance Manager</div>
        <div style="height:60px;display:flex;align-items:flex-end;padding-bottom:4px;">
          ${voucher.fm_signature ? '<img src="' + voucher.fm_signature + '" style="max-height:55px;max-width:160px;object-fit:contain;" />' : ''}
        </div>
        <div style="border-bottom:1px solid #C2C9DC;margin-bottom:6px;"></div>
        <div class="name">${financeManager?.name || "Finance Manager"}</div>
        <div class="date">${voucher.fm_signed_at ? new Date(voucher.fm_signed_at).toLocaleDateString("en-GB") : voucher.created_at ? new Date(voucher.created_at).toLocaleDateString("en-GB") : ""}</div>
      </div>
      <div class="sig-box">
        <div class="label">CEO Authorisation</div>
        <div style="height:60px;display:flex;align-items:flex-end;padding-bottom:4px;">
          ${voucher.ceo_signature ? '<img src="' + voucher.ceo_signature + '" style="max-height:55px;max-width:160px;object-fit:contain;" />' : ''}
        </div>
        <div style="border-bottom:1px solid #C2C9DC;margin-bottom:6px;"></div>
        <div class="name">${approver?.name || "CEO"}</div>
        <div class="date">${voucher.ceo_signed_at ? new Date(voucher.ceo_signed_at).toLocaleDateString("en-GB") : "Pending approval"}</div>
      </div>
    </div>
  </div>

  <div class="footer">
    <span>STRETCHFIELD · www.stretchfield.com · Accra, Ghana</span>
    <span>Voucher ID: ${voucher.id?.slice(0,8).toUpperCase()} · © ${new Date().getFullYear()} Stretchfield</span>
  </div>
</div>
</body>
</html>`;
  return html;
};

const PurchaseOrderView = ({ user, activeCountry = "All" }) => {
  const [awards, setAwards] = useState([]);
  const [pos, setPOs] = useState([]);
  const [rffs, setRffs] = useState([]);
  const [events, setEvents] = useState([]);
  const [vendorProfiles, setVendorProfiles] = useState([]);
  const [vendorApps, setVendorApps] = useState([]);
  const [saving, setSaving] = useState(false);
  const [zohoStatus, setZohoStatus] = useState("");
  const [previewPO, setPreviewPO] = useState(null);
  const [notesModal, setNotesModal] = useState(null);
  const [editNotes, setEditNotes] = useState("");
  const [poForm, setPoForm] = useState({ currency: activeCountry === "Nigeria" ? "NGN" : "GHS", notes: "" });
  const [signingPO, setSigningPO] = useState(null);
  const sigCanvas = React.useRef(null);
  const [sigDrawing, setSigDrawing] = useState(false);
  const [sigData, setSigData] = useState("");
  const [savedSig, setSavedSig] = useState(user?.saved_signature || null);

  React.useEffect(() => {
    supabase.from("profiles").select("saved_signature").eq("id", user.id).single().then(({ data }) => {
      if (data?.saved_signature) setSavedSig(data.saved_signature);
    });
  }, [user.id]);

  const load = async () => {
    const [{ data: aw }, { data: po }, { data: rf }, { data: ev }, { data: vp }, { data: va }] = await Promise.all([
      (!activeCountry || activeCountry === "All") ? supabase.from("rff_awards").select("*").in("status",["confirmed","po_created","invoiced","paid"]) : supabase.from("rff_awards").select("*").in("status",["confirmed","po_created","invoiced","paid"]).eq("country",activeCountry),
      (!activeCountry || activeCountry === "All") ? supabase.from("purchase_orders").select("*").order("created_at", { ascending: false }) : supabase.from("purchase_orders").select("*").or(`country.eq.${activeCountry},status.eq.pending_signatures`).order("created_at", { ascending: false }),
      (!activeCountry || activeCountry === "All") ? supabase.from("rffs").select("*") : supabase.from("rffs").select("*").eq("country",activeCountry),
      (!activeCountry || activeCountry === "All") ? supabase.from("projects").select("*") : supabase.from("projects").select("*").eq("country",activeCountry),
      supabase.from("profiles").select("id,name,email,phone,company_name,service_category").eq("role","Vendor"),
      supabase.from("vendor_applications").select("*").eq("status","login-created"),
    ]);
    setAwards(aw || []);
    setPOs(po || []);
    setRffs(rf || []);
    setEvents(ev || []);
    setVendorProfiles(vp || []);
    setVendorApps(va || []);
  };

  useEffect(() => {
    load();
    // Realtime subscription for signature updates
    const sub = supabase.channel("po-sigs")
      .on("postgres_changes", { event: "UPDATE", schema: "public", table: "purchase_orders" }, () => load())
      .subscribe();
    return () => supabase.removeChannel(sub);
  }, [activeCountry]);

  const handleCreatePO = async (award) => {
    console.log("handleCreatePO called", award);
    setSaving(true);
    setZohoStatus("");
    try {
    const rff = rffs.find(r => r.id === award.rff_id);
    const event = events.find(e => e.id === rff?.project_id);
    const vendor = vendorProfiles.find(v => v.id === award.vendor_id);
    const vApp = vendorApps.find(a => a.profile_id === award.vendor_id || a.submitted_by === award.vendor_id);
    console.log("rff:", rff, "event:", event, "vendor:", vendor);

    // Generate PO number
    let internalPoNumber = "";
    if (rff?.rff_code) {
      const { data: existingPos } = await supabase.from("purchase_orders").select("id").eq("rff_id", award.rff_id);
      const vendorSuffix = (existingPos?.length || 0) === 0 ? "" : String(existingPos.length + 1);
      internalPoNumber = "PO/" + rff.rff_code + vendorSuffix;
    } else {
      const year = new Date().getFullYear();
      const { data: allPos } = await supabase.from("purchase_orders").select("id");
      internalPoNumber = "PO/" + year + "/" + String((allPos?.length||0)+1).padStart(3,"0");
    }

    // RFP lines approved for this award (frozen onto the PO)
    let poLines = null; let poLinesTotal = 0;
    try {
      const { data: awLines } = await supabase.from("rfp_item_awards").select("*, rfp_items(*, rfp_sections(code, title))").eq("award_id", award.id);
      const ls = (awLines || []).filter(x => x.rfp_items).sort((a, b) => a.rfp_items.line_no - b.rfp_items.line_no).map(x => {
        const it = x.rfp_items; const qty = Number(it.qty || 1); const days = Number(it.days || 1); const up = Number(x.actual_unit_price || 0);
        return { no: it.line_no, category: [it.rfp_sections?.code, it.rfp_sections?.title].filter(Boolean).join(" "), description: it.description, spec: it.spec || "", qty, unit: it.unit, days, unit_price: up, total: up * qty * days, note: x.note || "" };
      });
      try { const { data: exA } = await supabase.from("rfp_award_extras").select("*").eq("award_id", award.id); (exA || []).forEach((e, k) => ls.push({ no: 900 + k + 1, category: "Other charges", description: e.label, spec: e.note || "", qty: 1, unit: "lot", days: 1, unit_price: Number(e.amount || 0), total: Number(e.amount || 0), note: "" })); } catch (e2) { /* no extras table yet */ }
      if (ls.length) { poLines = ls; poLinesTotal = ls.reduce((t, l) => t + l.total, 0); }
    } catch (e) { console.log("PO lines lookup skipped:", e.message); }

    const { data: po, error: poErr } = await supabase.from("purchase_orders").insert({
      rff_id: award.rff_id,
      rff_award_id: award.id,
      vendor_id: award.vendor_id,
      vendor_name: award.vendor_name,
      event_id: rff?.project_id,
      event_name: rff?.event_name || event?.name,
      amount: poLines ? poLinesTotal : (award.agreed_amount || award.quoted_amount),
      currency: award.country === "Nigeria" ? "NGN" : (poForm.currency || "GHS"),
      notes: poForm.notes,
      status: "draft",
      created_by: user.id,
      internal_po_number: internalPoNumber,
      country: award.country || activeCountry || "Ghana",
      rff_title: rff?.title || "",
      rff_category: rff?.event_type || "",
      line_items: poLines,
    }).select().single();
    console.log("PO insert result:", po, poErr);
    if (poErr) { console.error("PO insert error:", poErr); setSaving(false); alert("Failed to create PO: " + poErr.message); return; }

    // Sync to Zoho
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const zohoRes = await fetch("/api/zoho-sync?action=create-po", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + session?.access_token },
        body: JSON.stringify({ vendor_name: award.vendor_name, amount: award.agreed_amount || award.quoted_amount, currency: poForm.currency, notes: poForm.notes, rff_title: rff?.title, event_name: rff?.event_name, po_id: po?.id }),
      });
      const zohoData = await zohoRes.json();
      if (zohoData.purchaseorder) {
        await supabase.from("purchase_orders").update({ zoho_po_id: zohoData.purchaseorder.purchaseorder_id, zoho_po_number: zohoData.purchaseorder.purchaseorder_number }).eq("id", po.id);
        setZohoStatus(" PO " + zohoData.purchaseorder.purchaseorder_number + " created in Zoho Books");
      }
    } catch (e) {
      setZohoStatus(" PO saved locally. Zoho sync failed: " + e.message);
    }

    await supabase.from("rff_awards").update({ status: "po_created" }).eq("id", award.id);
    setSaving(false);
    setPoForm({ currency: award.country === "Nigeria" ? "NGN" : "GHS", notes: "" });
    // Force reload
    const { data: freshPOs } = await supabase.from("purchase_orders").select("*").order("created_at", { ascending: false });
    setPOs(freshPOs || []);
    const { data: freshAwards } = await supabase.from("rff_awards").select("*").in("status", ["confirmed","po_created","invoiced","paid"]);
    setAwards(freshAwards || []);
    } catch(e) { console.error("PO creation error:", e); setSaving(false); alert("Error: " + e.message); }
  };

  const deletePO = async (po) => {
    if (!window.confirm("Delete PO " + po.internal_po_number + "? This cannot be undone.")) return;
    await supabase.from("purchase_orders").delete().eq("id", po.id);
    // Reset award status back to confirmed
    if (po.rff_award_id) await supabase.from("rff_awards").update({ status: "confirmed" }).eq("id", po.rff_award_id);
    load();
  };

  const sendForSigning = async (po) => {
    // Finance must sign first
    setSigningPO({ po, role: "finance" });
  };

  const sendForSigningAfterFinance = async (po) => {
    await supabase.from("purchase_orders").update({ status: "pending_signatures" }).eq("id", po.id);
    // Notify VM
    const { data: vms } = await supabase.from("profiles").select("id,email,name").eq("role", "Vendor Manager");
    for (const vm of vms || []) {
      await supabase.from("notifications").insert({ user_id: vm.id, title: "PO Signature Required — " + po.internal_po_number, message: "Finance has requested your signature on Purchase Order " + po.internal_po_number + " for " + (po.vendor_name||"vendor") + ".", type: "rff" });
    }
    // Notify CEO
    const { data: ceos } = await supabase.from("profiles").select("id,email,name").eq("role", "CEO");
    for (const ceo of ceos || []) {
      await supabase.from("notifications").insert({ user_id: ceo.id, title: "PO Signature Required — " + po.internal_po_number, message: "Finance has requested your signature on Purchase Order " + po.internal_po_number + " for " + (po.vendor_name||"vendor") + ".", type: "rff" });
    }
    // Notify CM Nigeria if Nigeria PO
    if (po.country === "Nigeria") {
      const { data: cms } = await supabase.from("profiles").select("id,email,name").eq("role","Country Manager").eq("country","Nigeria");
      for (const cm of cms || []) {
        await supabase.from("notifications").insert({ user_id: cm.id, title: "PO Signature Required — " + po.internal_po_number, message: "Your signature is required on Purchase Order " + po.internal_po_number + " for " + (po.vendor_name||"vendor") + " — " + (po.event_name||"WHX Lagos") + ".", type: "rff" });
      }
    }
    load();
    alert("PO sent to VM, CEO" + (po.country === "Nigeria" ? " and CM Nigeria" : "") + " for signing.");
  };

  const signPO = async (po, role) => {
    if (!sigData) { alert("Please draw your signature first."); return; }
    const updates = {};
    const now = new Date().toISOString();

    if (role === "finance") {
      updates.finance_signature = sigData;
      updates.finance_signed_at = now;
      updates.finance_signed_by = user.id;
      updates.status = "draft"; // still draft until sent for signing
      await supabase.from("purchase_orders").update(updates).eq("id", po.id);
      setSigningPO(null); setSigData(""); load();
      // Now send for VM and CEO signing
      const updatedPo = { ...po, ...updates };
      await sendForSigningAfterFinance(updatedPo);
      return;
    } else if (role === "vm") {
      updates.vm_signature = sigData;
      updates.vm_signed_at = now;
      updates.vm_signed_by = user.id;
      const ceoSigned = po.ceo_signed_at;
      const financeSigned = po.finance_signed_at || updates.finance_signed_at;
      const cmSigned = po.cm_signed_at || (po.country !== "Nigeria");
      updates.status = (ceoSigned && financeSigned && cmSigned) ? "fully_signed" : "vm_signed";
    } else if (role === "ceo") {
      updates.ceo_signature = sigData;
      updates.ceo_signed_at = now;
      updates.ceo_signed_by = user.id;
      const vmSigned = po.vm_signed_at;
      const financeSigned = po.finance_signed_at;
      const cmSigned = po.cm_signed_at || (po.country !== "Nigeria");
      updates.status = (vmSigned && financeSigned && cmSigned) ? "fully_signed" : "ceo_signed";
      // CEO is always last - mark fully signed if all others done
    } else if (role === "cm") {
      updates.cm_signature = sigData;
      updates.cm_signed_at = now;
      updates.cm_signed_by = user.id;
      const vmSigned = po.vm_signed_at;
      const financeSigned = po.finance_signed_at;
      const ceoSigned = po.ceo_signed_at;
      updates.status = (vmSigned && financeSigned && ceoSigned) ? "fully_signed" : "cm_signed";
    }

    await supabase.from("purchase_orders").update(updates).eq("id", po.id);

    // Check if fully signed
    const isFullySigned = updates.status === "fully_signed";

    if (isFullySigned) {
      const { data: fms } = await supabase.from("profiles").select("id").eq("role", "Finance Manager");
      for (const fm of fms || []) {
        await supabase.from("notifications").insert({ user_id: fm.id, title: "PO Fully Signed — " + po.internal_po_number, message: "All parties have signed PO " + po.internal_po_number + ". It has been sent to the vendor automatically.", type: "finance" });
      }
      await publishPO(po, true); // fully signed: issue to the vendor now
    } else {
      const { data: fms } = await supabase.from("profiles").select("id").eq("role", "Finance Manager");
      for (const fm of fms || []) {
        await supabase.from("notifications").insert({ user_id: fm.id, title: (role==="vm"?"VM":"CEO") + " Signed PO — " + po.internal_po_number, message: (role==="vm"?"Vendor Manager":"CEO") + " has signed PO " + po.internal_po_number + ". Awaiting " + (role==="vm"?"CEO":"VM") + " signature.", type: "finance" });
      }
    }
    setSigningPO(null);
    setSigData("");
    load();
  };

  const publishPO = async (po, auto) => {
    if (!auto && !window.confirm("Publish this PO to the vendor portal? The vendor will be notified and can download it.")) return;
    await supabase.from("purchase_orders").update({ status: "sent" }).eq("id", po.id);
    await supabase.from("notifications").insert({ user_id: po.vendor_id, title: "Purchase Order — " + po.internal_po_number, message: "A Purchase Order has been issued for " + (po.event_name||"your services") + ". This PO authorises you to start work. Log in to your platform (Purchase Orders) to cross-check and download it.", type: "rff" });
    const { data: vp } = await supabase.from("profiles").select("email,name").eq("id", po.vendor_id).single();
    if (vp?.email) await sendEmail(vp.email, "Purchase Order " + po.internal_po_number + " — Stretchfield", poEmailHtml({ vendorName: vp.name, poNumber: po.internal_po_number, eventName: po.event_name||"", amount: po.amount, currency: po.currency||(user?.country==="Nigeria"?"NGN":"GHS"), notes: po.notes||"" }));
    load();
  };

  const saveNotes = async () => {
    if (!notesModal) return;
    await supabase.from("purchase_orders").update({ notes: editNotes }).eq("id", notesModal.id);
    setNotesModal(null);
    load();
  };

  // Awards that don't have a PO yet (confirmed OR po_created with no actual PO in DB)
  const pendingAwards = awards.filter(a => ["confirmed","po_created"].includes(a.status) && !pos.find(p => p.rff_award_id === a.id));

  const inputStyle = { width:"100%", padding:"9px 12px", background:T.bg, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: "1px solid "+T.border }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Finance</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Purchase Orders</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{pendingAwards.length} confirmed gig{pendingAwards.length!==1?"s":""} awaiting PO · {pos.length} PO{pos.length!==1?"s":""} created · Managed by Finance</div>
      </div>

      {zohoStatus && <div style={{ padding:"10px 14px", background:T.teal+"12", border:"1px solid "+T.teal+"30", borderRadius:8, color:T.teal, fontSize:13, marginBottom:16 }}>{zohoStatus}</div>}

      {/* Confirmed Awards Awaiting PO */}
      {pendingAwards.length > 0 && (
        <div style={{ marginBottom:28 }}>
          <div style={{ color:T.textMuted, fontSize:11, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:12 }}>Awaiting Purchase Order</div>
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {pendingAwards.map(award => {
              const rff = rffs.find(r => r.id === award.rff_id);
              const event = events.find(e => e.id === rff?.project_id);
              const vendor = vendorProfiles.find(v => v.id === award.vendor_id);
              const vApp = vendorApps.find(a => a.vendor_id === award.vendor_id || a.linked_vendor_id === award.vendor_id);
              const amount = award.agreed_amount || award.quoted_amount;
              return (
                <div key={award.id} style={{ background:T.surface, border:"1px solid "+T.cyan+"30", borderLeft:"4px solid "+T.cyan, borderRadius:12, padding:"18px 20px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
                    <div>
                      <div style={{ color:T.textPrimary, fontWeight:900, fontSize:16 }}>{award.vendor_name}</div>
                      <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{rff?.title} {event?.name ? "· "+event.name : ""}</div>
                      <div style={{ color:T.amber, fontWeight:900, fontSize:18, marginTop:6 }}>{fmtMoney(amount||0, award.country||activeCountry||"Ghana")}</div>
                      <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>Approved quote — locked and non-editable</div>
                    </div>
                    <span style={{ color:T.cyan, fontSize:10, fontWeight:800, background:T.cyan+"15", padding:"3px 10px", borderRadius:20 }}>CONFIRMED</span>
                  </div>

                  {/* Auto-filled vendor details */}
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:8, marginBottom:14 }}>
                    {[
                      ["Vendor", award.vendor_name],
                      ["Category", rff?.category || vendor?.service_category || "—"],
                      ["Bank", vApp?.bank_name || "—"],
                      ["Account", vApp?.account_no || "—"],
                      ["Payment Terms", vApp?.payment_terms || "—"],
                    ].map(([label, val]) => (
                      <div key={label} style={{ background:T.bg, borderRadius:6, padding:"8px 10px" }}>
                        <div style={{ color:T.textMuted, fontSize:9, fontWeight:700, textTransform:"uppercase", marginBottom:2 }}>{label}</div>
                        <div style={{ color:T.textPrimary, fontSize:12, fontWeight:600 }}>{val}</div>
                      </div>
                    ))}
                  </div>

                  {/* Notes only editable field */}
                  <div style={{ marginBottom:12 }}>
                    <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Notes (optional)</label>
                    <textarea value={poForm.notes} onChange={e => setPoForm(f=>({...f,notes:e.target.value}))} placeholder="Any special instructions or notes for this PO..." rows={2} style={{ ...inputStyle, resize:"none" }} />
                  </div>

                  <button onClick={() => handleCreatePO(award)} disabled={saving} style={{ background:"linear-gradient(135deg,"+T.cyan+","+T.teal+")", border:"none", color:"#fff", padding:"10px 24px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13, opacity: saving ? 0.6 : 1 }}>{saving ? "Generating..." : "Generate Purchase Order"}</button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Existing POs */}
      {pos.length > 0 && (
        <div>
          <div style={{ color:T.textMuted, fontSize:11, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:12 }}>Purchase Orders</div>
          <div style={{ background:T.surface, border:"1px solid "+T.border, borderRadius:12, overflow:"hidden" }}>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ background:T.bg, borderBottom:"1px solid "+T.border }}>
                  {["PO Number","Vendor","Event","Amount","Zoho","Status","Actions"].map(h => (
                    <th key={h} style={{ padding:"10px 14px", textAlign:"left", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pos.map((po, i) => {
                  const vendor = vendorProfiles.find(v => v.id === po.vendor_id);
                  const rff = rffs.find(r => r.id === po.rff_id);
                  const event = events.find(e => e.id === po.event_id);
                  const statusColors = { draft:T.amber, sent:T.teal, invoiced:T.cyan, paid:T.teal };
                  return (
                    <tr key={po.id} style={{ borderBottom:i<pos.length-1?"1px solid "+T.border+"44":"none" }}>
                      <td style={{ padding:"10px 14px" }}>
                        <div style={{ color:T.cyan, fontSize:12, fontWeight:700 }}>{po.internal_po_number||"—"}</div>
                        {po.zoho_po_number && <div style={{ color:T.textMuted, fontSize:10 }}>Zoho: {po.zoho_po_number}</div>}
                      </td>
                      <td style={{ padding:"10px 14px", color:T.textPrimary, fontSize:12, fontWeight:600 }}>{po.vendor_name}</td>
                      <td style={{ padding:"10px 14px", color:T.textSecondary, fontSize:12 }}>{po.event_name}</td>
                      <td style={{ padding:"10px 14px", color:T.amber, fontSize:12, fontWeight:700 }}>{po.currency||(po.country==="Nigeria"?"NGN":activeCountry==="Nigeria"?"NGN":"GHS")} {(po.amount||0).toLocaleString()}</td>
                      <td style={{ padding:"10px 14px" }}><span style={{ color:po.zoho_po_id?T.teal:T.textMuted, fontSize:11 }}>{po.zoho_po_id?" Zoho":"Local"}</span></td>
                      <td style={{ padding:"10px 14px" }}>
                        <span style={{ background:(statusColors[po.status]||T.textMuted)+"18", color:statusColors[po.status]||T.textMuted, borderRadius:20, padding:"2px 10px", fontSize:10, fontWeight:700, textTransform:"uppercase" }}>{po.status}</span>
                      </td>
                      <td style={{ padding:"10px 14px" }}>
                        <div style={{ display:"flex", gap:6, flexWrap:"wrap", alignItems:"center" }}>
                          <button onClick={() => setPreviewPO({ po, vendor, rff, event })} style={{ background:T.cyan+"15", border:"1px solid "+T.cyan+"30", color:T.cyan, padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}>Preview</button>
                          <button onClick={() => downloadPDF(generatePOPDF(po, vendor, rff, event), "PO-"+(po.internal_po_number||po.id)+".html")} style={{ background:T.surface, border:"1px solid "+T.border, color:T.textMuted, padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}>↓ PDF</button>
                          {po.status === "draft" && <button onClick={() => { setNotesModal(po); setEditNotes(po.notes||""); }} style={{ background:T.amber+"15", border:"1px solid "+T.amber+"30", color:T.amber, padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}>Notes</button>}
                          {["draft","pending_signatures","vm_signed","ceo_signed","fully_signed"].includes(po.status) && !po.finance_signed_at && user.role === "Finance Manager" && <button onClick={() => sendForSigning(po)} style={{ background:"linear-gradient(135deg,"+T.cyan+","+T.teal+")", border:"none", color:"#fff", padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}> Sign</button>}
                          {po.status === "draft" && po.finance_signed_at && user.role === "Finance Manager" && <button onClick={() => sendForSigningAfterFinance(po)} style={{ background:"linear-gradient(135deg,"+T.cyan+","+T.teal+")", border:"none", color:"#fff", padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}>→ Send to VM & CEO</button>}
                          {["pending_signatures","vm_signed","ceo_signed","fully_signed"].includes(po.status) && (
                            <div style={{ display:"flex", flexDirection:"column", gap:3 }}>
                              <div style={{ display:"flex", gap:4, alignItems:"center" }}>
                                <span style={{ width:8, height:8, borderRadius:"50%", background: po.finance_signed_at ? T.teal : T.amber, display:"inline-block" }} />
                                <span style={{ color: po.finance_signed_at ? T.teal : T.amber, fontSize:10, fontWeight:700 }}>Finance {po.finance_signed_at ? "" : "Pending"}</span>
                              </div>
                              <div style={{ display:"flex", gap:4, alignItems:"center" }}>
                                <span style={{ width:8, height:8, borderRadius:"50%", background: po.vm_signed_at ? T.teal : T.amber, display:"inline-block" }} />
                                <span style={{ color: po.vm_signed_at ? T.teal : T.amber, fontSize:10, fontWeight:700 }}>VM {po.vm_signed_at ? "" : "Pending"}</span>
                              </div>
                              <div style={{ display:"flex", gap:4, alignItems:"center" }}>
                                <span style={{ width:8, height:8, borderRadius:"50%", background: po.ceo_signed_at ? T.teal : T.amber, display:"inline-block" }} />
                                <span style={{ color: po.ceo_signed_at ? T.teal : T.amber, fontSize:10, fontWeight:700 }}>CEO {po.ceo_signed_at ? "" : "Pending"}</span>
                              </div>
                              {po.country === "Nigeria" && (
                                <div style={{ display:"flex", gap:4, alignItems:"center" }}>
                                  <span style={{ width:8, height:8, borderRadius:"50%", background: po.cm_signed_at ? T.teal : T.amber, display:"inline-block" }} />
                                  <span style={{ color: po.cm_signed_at ? T.teal : T.amber, fontSize:10, fontWeight:700 }}>CM Nigeria {po.cm_signed_at ? "" : "Pending"}</span>
                                </div>
                              )}
                            </div>
                          )}
                          {po.status === "fully_signed" && ["CEO","Finance Manager"].includes(user.role) && <button onClick={() => publishPO(po)} style={{ background:"linear-gradient(135deg,"+T.teal+",#10B981)", border:"none", color:"#fff", padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}>↑ Publish</button>}
                          {po.status === "sent" && <span style={{ color:T.teal, fontSize:10, fontWeight:700 }}> Published</span>}
                          {/* VM Sign button */}
                          {["pending_signatures","ceo_signed"].includes(po.status) && user.role === "Vendor Manager" && !po.vm_signed_at && (
                            <button onClick={() => setSigningPO({ po, role:"vm" })} style={{ background:"linear-gradient(135deg,"+T.cyan+","+T.teal+")", border:"none", color:"#fff", padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}> Sign</button>
                          )}
                          {/* CM Nigeria Sign button - signs before CEO */}
                          {["pending_signatures","vm_signed"].includes(po.status) && user.role === "Country Manager" && po.country === "Nigeria" && !po.cm_signed_at && (
                            <button onClick={() => setSigningPO({ po, role:"cm" })} style={{ background:"linear-gradient(135deg,"+T.cyan+","+T.teal+")", border:"none", color:"#fff", padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}> Sign</button>
                          )}
                          {/* CEO Sign button - last to sign */}
                          {["pending_signatures","vm_signed","cm_signed"].includes(po.status) && user.role === "CEO" && !po.ceo_signed_at && (po.country !== "Nigeria" || po.cm_signed_at) && (
                            <button onClick={() => setSigningPO({ po, role:"ceo" })} style={{ background:"linear-gradient(135deg,"+T.cyan+","+T.teal+")", border:"none", color:"#fff", padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}> Sign</button>
                          )}
                          {["draft","pending_signatures","vm_signed","ceo_signed","fully_signed"].includes(po.status) && po.status !== "sent" && user.role === "Finance Manager" && (
                            <button onClick={() => deletePO(po)} style={{ background:T.red+"15", border:"1px solid "+T.red+"30", color:T.red, padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}></button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* PO Preview Modal */}
      {previewPO && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.9)", backdropFilter:"blur(8px)", overflowY:"auto" }} onClick={() => setPreviewPO(null)}>
          <div style={{ minHeight:"100vh", display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"24px 20px" }}>
            <div style={{ background:"#fff", borderRadius:12, width:"100%", maxWidth:794, overflow:"hidden" }} onClick={e => e.stopPropagation()}>
              {/* Modal actions */}
              <div style={{ background:T.bgDeep, padding:"12px 20px", display:"flex", justifyContent:"space-between", alignItems:"center", borderBottom:"1px solid "+T.border }}>
                <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>PO Preview — {previewPO.po.internal_po_number}</div>
                <div style={{ display:"flex", gap:8 }}>
                  <button onClick={() => downloadPDF(generatePOPDF(previewPO.po, previewPO.vendor, previewPO.rff, previewPO.event), "PO-"+(previewPO.po.internal_po_number||previewPO.po.id)+".html")} style={{ background:T.cyan+"15", border:"1px solid "+T.cyan+"30", color:T.cyan, padding:"6px 14px", borderRadius:6, cursor:"pointer", fontSize:12, fontWeight:700 }}>↓ Download PDF</button>
                  {previewPO.po.status === "draft" && ["CEO","Finance Manager"].includes(user.role) && <button onClick={() => { publishPO(previewPO.po); setPreviewPO(null); }} style={{ background:"linear-gradient(135deg,"+T.teal+","+T.cyan+")", border:"none", color:"#fff", padding:"6px 14px", borderRadius:6, cursor:"pointer", fontSize:12, fontWeight:700 }}>↑ Publish to Vendor</button>}
                  <button onClick={() => setPreviewPO(null)} style={{ background:"none", border:"1px solid "+T.border, color:T.textMuted, padding:"6px 12px", borderRadius:6, cursor:"pointer", fontSize:12 }}> Close</button>
                </div>
              </div>
              {/* PO HTML preview */}
              <iframe
                srcDoc={generatePOPDF(previewPO.po, previewPO.vendor, previewPO.rff, previewPO.event)}
                style={{ width:"100%", height:"80vh", border:"none" }}
                title="PO Preview"
              />
            </div>
          </div>
        </div>
      )}

      {/* PO Signing Modal — for VM and CEO */}
      {signingPO && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setSigningPO(null)}>
          <div style={{ background:T.surface, border:"1px solid "+T.cyan+"40", borderRadius:16, width:"100%", maxWidth:480, padding:28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Sign Purchase Order</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:20 }}>{signingPO.po.internal_po_number} — {signingPO.po.vendor_name}</div>
            <div style={{ background:T.bg, border:"2px solid "+T.cyan+"40", borderRadius:10, padding:4, marginBottom:12, position:"relative" }}>
              <canvas ref={sigCanvas} width={420} height={130}
                style={{ display:"block", width:"100%", height:130, cursor:"crosshair", borderRadius:8, touchAction:"none" }}
                onMouseDown={e => { setSigDrawing(true); const c=sigCanvas.current; const r=c.getBoundingClientRect(); const ctx=c.getContext("2d"); ctx.beginPath(); ctx.moveTo(e.clientX-r.left, e.clientY-r.top); }}
                onMouseMove={e => { if(!sigDrawing) return; const c=sigCanvas.current; const r=c.getBoundingClientRect(); const ctx=c.getContext("2d"); ctx.strokeStyle="#00C8FF"; ctx.lineWidth=2; ctx.lineTo(e.clientX-r.left, e.clientY-r.top); ctx.stroke(); }}
                onMouseUp={() => { setSigDrawing(false); setSigData(sigCanvas.current.toDataURL()); }}
                onMouseLeave={() => { if(sigDrawing){setSigDrawing(false); setSigData(sigCanvas.current.toDataURL());} }}
                onTouchStart={e => { e.preventDefault(); setSigDrawing(true); const c=sigCanvas.current; const r=c.getBoundingClientRect(); const t=e.touches[0]; const ctx=c.getContext("2d"); ctx.beginPath(); ctx.moveTo(t.clientX-r.left, t.clientY-r.top); }}
                onTouchMove={e => { e.preventDefault(); if(!sigDrawing) return; const c=sigCanvas.current; const r=c.getBoundingClientRect(); const t=e.touches[0]; const ctx=c.getContext("2d"); ctx.strokeStyle="#00C8FF"; ctx.lineWidth=2; ctx.lineTo(t.clientX-r.left, t.clientY-r.top); ctx.stroke(); }}
                onTouchEnd={() => { setSigDrawing(false); setSigData(sigCanvas.current.toDataURL()); }}
              />
              <div style={{ position:"absolute", bottom:8, right:10, color:T.textMuted, fontSize:10, pointerEvents:"none" }}>Sign above</div>
              <button onClick={() => { const c=sigCanvas.current; c.getContext("2d").clearRect(0,0,c.width,c.height); setSigData(""); }} style={{ position:"absolute", top:6, right:6, background:T.surface, border:"1px solid "+T.border, color:T.textMuted, padding:"2px 8px", borderRadius:5, cursor:"pointer", fontSize:10 }}>Clear</button>
            </div>
            {/* Saved signature option */}
            {savedSig && !sigData && (
              <div style={{ background:T.teal+"10", border:"1px solid "+T.teal+"30", borderRadius:8, padding:"10px 14px", marginBottom:12, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <div>
                  <div style={{ color:T.teal, fontSize:11, fontWeight:700, marginBottom:4 }}> Use Saved Signature</div>
                  <img src={savedSig} style={{ height:48, maxWidth:200, objectFit:"contain", background:"#fff", padding:4, borderRadius:4 }} alt="saved" />
                </div>
                <button onClick={() => setSigData(savedSig)} style={{ background:"linear-gradient(135deg,"+T.teal+","+T.cyan+")", border:"none", color:"#fff", padding:"7px 14px", borderRadius:7, cursor:"pointer", fontSize:12, fontWeight:700 }}>Use This</button>
              </div>
            )}
            {savedSig && sigData === savedSig && (
              <div style={{ background:T.teal+"12", border:"1px solid "+T.teal+"30", borderRadius:8, padding:"8px 14px", marginBottom:8, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <span style={{ color:T.teal, fontSize:12, fontWeight:700 }}> Using saved signature</span>
                <button onClick={() => setSigData("")} style={{ background:"none", border:"none", color:T.textMuted, fontSize:11, cursor:"pointer" }}>Draw instead</button>
              </div>
            )}
            {savedSig && !sigData && (
              <button onClick={() => setSigData(savedSig)} style={{ width:"100%", background:T.teal+"15", border:"1px solid "+T.teal+"30", color:T.teal, padding:"8px", borderRadius:8, cursor:"pointer", fontWeight:700, fontSize:12, marginTop:4, marginBottom:4 }}>Use Saved Signature</button>
            )}
            {sigData && savedSig && sigData !== savedSig && (
              <div style={{ color:T.teal, fontSize:11, marginTop:4 }}>Custom signature drawn</div>
            )}
            <div style={{ display:"flex", gap:10, marginTop:8 }}>
              <button onClick={() => signPO(signingPO.po, signingPO.role)} disabled={!sigData} style={{ flex:1, background:"linear-gradient(135deg,"+T.cyan+","+T.teal+")", border:"none", color:"#fff", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13, opacity:!sigData?0.5:1 }}>Confirm Signature</button>
              <button onClick={() => { setSigningPO(null); setSigData(""); }} style={{ background:"none", border:"1px solid "+T.border, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Notes Edit Modal */}
      {notesModal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.8)", backdropFilter:"blur(6px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setNotesModal(null)}>
          <div style={{ background:T.surface, border:"1px solid "+T.amber+"40", borderRadius:14, width:"100%", maxWidth:440, padding:28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16, marginBottom:4 }}>Edit Notes</div>
            <div style={{ color:T.textMuted, fontSize:12, marginBottom:16 }}>{notesModal.internal_po_number} — notes only. Amount and vendor details are locked.</div>
            <textarea value={editNotes} onChange={e => setEditNotes(e.target.value)} rows={4} placeholder="Add notes or instructions..." style={{ ...inputStyle, resize:"none", marginBottom:14 }} />
            <div style={{ display:"flex", gap:8 }}>
              <button onClick={saveNotes} style={{ flex:1, background:"linear-gradient(135deg,"+T.cyan+","+T.teal+")", border:"none", color:"#fff", padding:"10px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>Save Notes</button>
              <button onClick={() => setNotesModal(null)} style={{ background:"none", border:"1px solid "+T.border, color:T.textMuted, padding:"10px 16px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


const VendorInvoiceView = ({ user }) => {
  const [invoices, setInvoices] = useState([]);
  const [pos, setPOs] = useState([]);
  const [events, setEvents] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ event_id: "", purchase_order_id: "", amount: "", notes: "" });
  const [invoiceFile, setInvoiceFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const fileRef = React.useRef();

  const load = async () => {
    const [{ data: inv }, { data: po }, { data: awards }] = await Promise.all([
      supabase.from("vendor_invoices").select("*, paid_at, reviewed_at").eq("vendor_id", user.id).order("created_at", { ascending: false }),
      supabase.from("purchase_orders").select("*").eq("vendor_id", user.id),
      supabase.from("rff_awards").select("*, rffs(project_id, event_name, title)").eq("vendor_id", user.id).in("status", ["confirmed","po_created"]),
    ]);
    setInvoices(inv || []);
    setPOs(po || []);
    // Only show events where vendor has a confirmed/awarded gig
    const awardedEventIds = [...new Set((awards || []).map(a => a.rffs?.project_id).filter(Boolean))];
    if (awardedEventIds.length > 0) {
      const { data: ev } = await supabase.from("projects").select("*").in("id", awardedEventIds);
      setEvents(ev || []);
    } else {
      // Fallback: show events from purchase orders
      const poEventIds = [...new Set((po || []).map(p => p.event_id).filter(Boolean))];
      if (poEventIds.length > 0) {
        const { data: ev } = await supabase.from("projects").select("*").in("id", poEventIds);
        setEvents(ev || []);
      } else {
        setEvents([]);
      }
    }
  };

  useEffect(() => { load(); }, []);

  const handleSubmit = async () => {
    if (!form.event_id || !form.amount) { alert("Please select an event and enter the amount."); return; }
    setSaving(true);
    let invoice_url = "", invoice_filename = "";
    if (invoiceFile) {
      const ext = invoiceFile.name.split(".").pop();
      const filename = `invoice_${Date.now()}.${ext}`;
      const { error } = await supabase.storage.from("rffs").upload(filename, invoiceFile, { upsert: true });
      if (!error) {
        const { data } = supabase.storage.from("rffs").getPublicUrl(filename);
        invoice_url = data.publicUrl;
        invoice_filename = invoiceFile.name;
      }
    }
    const event = events.find(e => e.id === form.event_id);
    const po = pos.find(p => p.id === form.purchase_order_id);
    // Generate invoice number from PO internal number
    let invoiceNumber = "";
    if (po?.internal_po_number) {
      invoiceNumber = po.internal_po_number.replace("PO/", "INV/");
    }
    await supabase.from("vendor_invoices").insert({
      vendor_id: user.id,
      vendor_name: user.name,
      event_id: form.event_id,
      event_name: event?.name || "",
      purchase_order_id: form.purchase_order_id || null,
      amount: parseFloat(form.amount) || 0,
      invoice_url,
      invoice_filename,
      notes: form.notes,
      status: "submitted",
      invoice_number: invoiceNumber,
      country: event?.country || user?.country || "Ghana",
    });
    // Notify Finance
    const { data: fms } = await supabase.from("profiles").select("id").in("role", ["Finance Manager","CEO"]);
    for (const fm of fms || []) {
      await supabase.from("notifications").insert({
        user_id: fm.id,
        title: "Invoice Received",
        message: `${user.name} submitted an invoice of ${user?.country==="Nigeria"?"NGN":"GHS"} ${parseFloat(form.amount).toLocaleString()} for "${event?.name}".`,
        type: "rff",
      });
    }
    setSaving(false);
    setModal(false);
    setForm({ event_id: "", purchase_order_id: "", amount: "", notes: "" });
    setInvoiceFile(null);
    load();
  };

  const statusColor = { submitted: T.amber, reviewed: T.cyan, voucher_created: T.teal, paid: "#10B981", approved: T.teal, rejected: T.red };
  const statusLabel = { submitted: "Under Review", reviewed: "Reviewed", voucher_created: "Payment Processing", paid: "Paid ", approved: "Approved", rejected: "Rejected" };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Finance</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>My Invoices</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Submit invoices per event</div>
        </div>
        <button onClick={() => setModal(true)} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 13 }}>+ Submit Invoice</button>
      </div>

      {invoices.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No invoices submitted</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>Submit your first invoice using the button above.</div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {invoices.map(inv => (
            <div key={inv.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderLeft: `3px solid ${statusColor[inv.status] || T.textMuted}`, borderRadius: 10, padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14 }}>{inv.event_name}</div>
                {inv.invoice_number && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2, fontWeight: 600 }}>{inv.invoice_number}</div>}
                <div style={{ color: T.amber, fontWeight: 700, fontSize: 13, marginTop: 3 }}>{getCurrency(inv.country||user?.country||"Ghana")+" "+(parseFloat(inv.amount||0).toLocaleString()).toLocaleString()}</div>
                <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Submitted {new Date(inv.created_at).toLocaleDateString("en-GB", {day:"numeric",month:"short",year:"numeric"})}</div>
                {inv.paid_at && <div style={{ color:"#10B981", fontSize:11, fontWeight:700, marginTop:2 }}> Paid {new Date(inv.paid_at).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</div>}
                {inv.notes && inv.status === "rejected" && <div style={{ color:T.red, fontSize:11, marginTop:4, background:T.red+"10", padding:"4px 8px", borderRadius:6 }}>Reason: {inv.notes}</div>}
              </div>
              <div style={{ display: "flex", flexDirection:"column", gap: 8, alignItems: "flex-end" }}>
                <span style={{ background: (statusColor[inv.status]||T.textMuted)+"18", color: statusColor[inv.status]||T.textMuted, border: `1px solid ${(statusColor[inv.status]||T.textMuted)}30`, borderRadius: 20, padding: "3px 12px", fontSize: 10, fontWeight: 800, textTransform: "uppercase" }}>{statusLabel[inv.status]||inv.status}</span>
                {inv.invoice_url && <a href={inv.invoice_url} target="_blank" rel="noopener noreferrer" style={{ color: T.cyan, fontSize: 12, fontWeight: 700 }}> View Invoice</a>}
              </div>
            </div>
          ))}
        </div>
      )}

      {modal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setModal(false)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 480, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 20 }}>Submit Invoice</div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Event</label>
              <select value={form.event_id} onChange={e => setForm({...form, event_id: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
                <option value="">Select event...</option>
                {events.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
              </select>
            </div>
            {pos.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Purchase Order (if any)</label>
                <select value={form.purchase_order_id} onChange={e => setForm({...form, purchase_order_id: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
                  <option value="">No PO / Select PO...</option>
                  {pos.map(p => <option key={p.id} value={p.id}>{p.zoho_po_number || "PO"} · {p.event_name} · GHS {(p.amount||0).toLocaleString()}</option>)}
                </select>
              </div>
            )}
            <div style={{ marginBottom: 14 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Invoice Amount (${getCurrency(user?.country||"Ghana")})</label>
              <input type="number" value={form.amount} onChange={e => setForm({...form, amount: e.target.value})} placeholder="0.00" style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Upload Invoice Document</label>
              <div onClick={() => fileRef.current.click()} style={{ border: `2px dashed ${T.border}`, borderRadius: 8, padding: "14px", textAlign: "center", cursor: "pointer", background: T.bg }}
                onMouseEnter={e => e.currentTarget.style.borderColor = T.cyan + "60"}
                onMouseLeave={e => e.currentTarget.style.borderColor = T.border}>
                <div style={{ color: T.textMuted, fontSize: 12 }}>{invoiceFile ? ` ${invoiceFile.name}` : "Drop file here or browse"}</div>
              </div>
              <input ref={fileRef} type="file" onChange={e => setInvoiceFile(e.target.files[0])} style={{ display: "none" }} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Notes</label>
              <textarea value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} rows={2} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box", resize: "vertical" }} />
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleSubmit} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Submitting..." : "Submit Invoice"}</button>
              <button onClick={() => setModal(false)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const FinanceInvoicesView = ({ user, activeCountry = "All" }) => {
  const [invoices, setInvoices] = useState([]);
  const [saving, setSaving] = useState(false);
  const [rejectModal, setRejectModal] = useState(null);
  const [rejectComment, setRejectComment] = useState("");
  const [rejecting, setRejecting] = useState(false);

  const load = async () => {
    const invQuery = (!activeCountry || activeCountry === "All")
      ? supabase.from("vendor_invoices").select("*").order("created_at", { ascending: false })
      : supabase.from("vendor_invoices").select("*").eq("country", activeCountry).order("created_at", { ascending: false });
    const { data } = await invQuery;
    setInvoices(data || []);
  };

  useEffect(() => { load(); }, [activeCountry]);

  const updateStatus = async (id, status) => {
    const updates = { status, reviewed_by: user.id };
    if (status === "paid") updates.paid_at = new Date().toISOString();
    if (status === "reviewed") updates.reviewed_at = new Date().toISOString();
    await supabase.from("vendor_invoices").update(updates).eq("id", id);
    load();
  };

  const statusColor = { submitted: T.amber, reviewed: T.cyan, voucher_created: T.teal, paid: "#10B981", rejected: T.red };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: "1px solid "+T.border }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Finance</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800 }}>Vendor Invoices</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{invoices.filter(i => i.status === "submitted").length} new invoices to review</div>
      </div>
      <div style={{ background: T.surface, border: "1px solid "+T.border, borderRadius: 12, overflow: "hidden" }}>
        {invoices.length === 0 ? (
          <div style={{ textAlign: "center", padding: 40, color: T.textMuted }}>No invoices received yet.</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: T.bg, borderBottom: "1px solid "+T.border }}>
                {["Vendor","Event","Amount","Document","Date","Status","Actions"].map(h => (
                  <th key={h} style={{ padding: "10px 14px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {invoices.map((inv, i) => (
                <tr key={inv.id} style={{ borderBottom: i < invoices.length-1 ? "1px solid "+T.border+"44" : "none" }}>
                  <td style={{ padding: "10px 14px", color: T.textPrimary, fontSize: 12, fontWeight: 700 }}>{inv.vendor_name}</td>
                  <td style={{ padding: "10px 14px", color: T.textSecondary, fontSize: 12 }}>{inv.event_name}</td>
                  <td style={{ padding: "10px 14px", color: T.amber, fontSize: 12, fontWeight: 700 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(inv.amount||0).toLocaleString()).toLocaleString()}</td>
                  <td style={{ padding: "10px 14px" }}>{inv.invoice_url ? <a href={inv.invoice_url} target="_blank" rel="noopener noreferrer" style={{ color: T.cyan, fontSize: 12, fontWeight: 700 }}> View</a> : <span style={{ color: T.textMuted, fontSize: 11 }}>No doc</span>}</td>
                  <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 11 }}>{new Date(inv.created_at).toLocaleDateString("en-GB")}</td>
                  <td style={{ padding: "10px 14px" }}><span style={{ background: (statusColor[inv.status]||T.textMuted)+"18", color: statusColor[inv.status]||T.textMuted, borderRadius: 20, padding: "2px 10px", fontSize: 10, fontWeight: 800, textTransform: "uppercase" }}>{inv.status}</span></td>
                  <td style={{ padding: "10px 14px" }}>
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                      {inv.status === "submitted" && (
                        <>
                          <button onClick={async () => { await updateStatus(inv.id, "reviewed"); if (inv.vendor_id) await supabase.from("notifications").insert({ user_id: inv.vendor_id, title: "Invoice Under Review", message: "Your invoice " + (inv.invoice_number||"") + " is being reviewed by Finance.", type: "finance" }); }} style={{ background: T.teal+"18", border: "1px solid "+T.teal+"30", color: T.teal, padding: "3px 10px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Review</button>
                          <button onClick={() => { setRejectModal(inv); setRejectComment(""); }} style={{ background: T.red+"18", border: "1px solid "+T.red+"30", color: T.red, padding: "3px 10px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Reject</button>
                        </>
                      )}
                      {inv.status === "reviewed" && (
                        <button onClick={async () => {
                          setSaving(true);
                          try {
                            const yr = new Date().getFullYear().toString().slice(-2);
                            const { data: ex } = await supabase.from("payment_vouchers").select("voucher_number").ilike("voucher_number", "PV/"+yr+"/%").order("voucher_number", { ascending: false }).limit(1);
                            const lastNum = ex?.[0]?.voucher_number?.split("/")?.[2];
                            const vNum = "PV/"+yr+"/"+String((parseInt(lastNum)||0)+1).padStart(3,"0");
                            const { data: newV, error: ve } = await supabase.from("payment_vouchers").insert({ payment_type: "project", payee: inv.vendor_name, payee_type: "vendor", description: "Payment for "+(inv.event_name||"services")+" — Invoice "+(inv.invoice_number||inv.id.slice(0,8)), amount: parseFloat(inv.amount||0), currency: activeCountry === "Nigeria" ? "NGN" : "GHS", event_name: inv.event_name, invoice_ref: inv.invoice_number, raised_by: user.id, status: "pending_approval", voucher_number: vNum }).select().single();
                            if (ve) { alert("Error: "+ve.message); setSaving(false); return; }
                            if (newV) {
                              await supabase.from("vendor_invoices").update({ status: "voucher_created", purchase_order_id: newV.id }).eq("id", inv.id);
                              const { data: ceos } = await supabase.from("profiles").select("id").eq("role","CEO");
                              for (const ceo of ceos||[]) await supabase.from("notifications").insert({ user_id: ceo.id, title: "Payment Voucher Raised", message: user.name+" raised voucher "+vNum+" for GHS "+parseFloat(inv.amount||0).toLocaleString()+" — "+inv.vendor_name, type: "finance" });
                              alert("Voucher "+vNum+" created. Go to Payment Vouchers tab to sign.");
                            }
                          } catch(e) { alert("Error: "+e.message); }
                          setSaving(false); load();
                        }} disabled={saving} style={{ background: T.cyan+"18", border: "1px solid "+T.cyan+"30", color: T.cyan, padding: "3px 10px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Create Voucher</button>
                      )}
                      {inv.status === "voucher_created" && <span style={{ color: T.teal, fontSize: 10, fontWeight: 700 }}> Voucher Raised</span>}
                      {inv.status === "paid" && <span style={{ color: "#10B981", fontSize: 10, fontWeight: 700 }}> Paid</span>}
                      {inv.invoice_url && inv.status !== "submitted" && <a href={inv.invoice_url} target="_blank" rel="noreferrer" style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, padding: "3px 8px", border: "1px solid "+T.border, borderRadius: 6 }}> Doc</a>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {rejectModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 700, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setRejectModal(null)}>
          <div style={{ background: T.surface, border: "1px solid "+T.red+"30", borderRadius: 16, width: "100%", maxWidth: 480, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Reject Invoice</div>
            <div style={{ color: T.textMuted, fontSize: 13, marginBottom: 20 }}>{rejectModal.vendor_name} — {rejectModal.invoice_number} — GHS {parseFloat(rejectModal.amount||0).toLocaleString()}</div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Reason for Rejection *</label>
              <textarea value={rejectComment} onChange={e => setRejectComment(e.target.value)} rows={4} placeholder="Explain what needs to be corrected — the vendor will receive this via email..." style={{ width: "100%", padding: "10px 12px", background: T.bg, border: "1px solid "+T.border, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", resize: "none", boxSizing: "border-box" }} />
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={async () => {
                if (!rejectComment.trim()) { alert("Please provide a rejection reason."); return; }
                setRejecting(true);
                await supabase.from("vendor_invoices").update({ status: "rejected", notes: rejectComment, reviewed_by: user.id, reviewed_at: new Date().toISOString() }).eq("id", rejectModal.id);
                if (rejectModal.vendor_id) {
                  await supabase.from("notifications").insert({ user_id: rejectModal.vendor_id, title: "Invoice Rejected — Action Required", message: "Your invoice "+(rejectModal.invoice_number||"")+" has been rejected. Reason: "+rejectComment, type: "finance" });
                  const { data: vp } = await supabase.from("profiles").select("email,name").eq("id", rejectModal.vendor_id).single();
                  if (vp && vp.email) {
                    const body = "<h2>Invoice Rejected</h2><p>Hi "+vp.name+",</p><p>Your invoice of <strong>GHS "+parseFloat(rejectModal.amount||0).toLocaleString()+"</strong> for <strong>"+(rejectModal.event_name||"services")+"</strong> requires correction.</p><p><strong>Reason:</strong> "+rejectComment+"</p><p>Please correct and resubmit via <a href='https://workroom.stretchfield.com'>WorkRoom</a>.</p>";
                    await fetch("/api/send-email", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ to: vp.email, subject: "Invoice Rejected — "+(rejectModal.invoice_number||"Your Invoice")+" — Action Required", html: body }) });
                  }
                }
                setRejecting(false); setRejectModal(null); setRejectComment(""); load();
                alert("Invoice rejected and vendor notified by email.");
              }} disabled={rejecting} style={{ flex: 1, background: "linear-gradient(135deg,#EF4444,#F97316)", border: "none", color: "#fff", padding: "11px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{rejecting ? "Sending..." : "Reject & Notify Vendor"}</button>
              <button onClick={() => { setRejectModal(null); setRejectComment(""); }} style={{ background: "none", border: "1px solid "+T.border, color: T.textMuted, padding: "11px 16px", borderRadius: 8, cursor: "pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const QuotesReceivedView = ({ user, activeCountry = "All" }) => {
  const [events, setEvents] = useState([]);
  const [rffs, setRffs] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("all");
  const [selectedRff, setSelectedRff] = useState(null);

  const load = async () => {
    const [{ data: ev }, { data: rf }, { data: asn }] = await Promise.all([
      (!activeCountry || activeCountry === "All") ? supabase.from("projects").select("*").order("name") : supabase.from("projects").select("*").eq("country",activeCountry).order("name"),
      (!activeCountry || activeCountry === "All") ? supabase.from("rffs").select("*").eq("approved",true).order("created_at",{ascending:false}) : supabase.from("rffs").select("*").eq("approved",true).eq("country",activeCountry).order("created_at",{ascending:false}),
      supabase.from("rff_vendor_assignments").select("*").order("created_at", { ascending: false }),
    ]);
    setEvents(ev || []);
    setRffs(rf || []);
    setAssignments(asn || []);
  };

  useEffect(() => { load(); }, [activeCountry]);

  const filteredRffs = selectedEvent === "all" ? rffs : rffs.filter(r => r.project_id === selectedEvent);
  const rffsWithQuotes = filteredRffs.filter(r => {
    const rffAssignments = assignments.filter(a => a.rff_id === r.id);
    return rffAssignments.some(a => a.quote_amount);
  });
  const totalQuotes = assignments.filter(a => a.quote_amount).length;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Procurement</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Quotes Received</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Quotes received across active RFFs</div>
        </div>
        <select value={selectedEvent} onChange={e => setSelectedEvent(e.target.value)} style={{ padding: "9px 14px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
          <option value="all">All Events</option>
          {events.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
        </select>
      </div>

      {/* KPI Strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px,1fr))", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Total RFFs", value: filteredRffs.length, color: T.cyan },
          { label: "RFFs with Quotes", value: rffsWithQuotes.length, color: T.teal },
          { label: "Total Quotes", value: totalQuotes, color: T.amber },
          { label: "Pending Quotes", value: assignments.filter(a => !a.quote_amount).length, color: T.textMuted },
        ].map((k, i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 20, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginTop: 4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* RFF Cards grouped by event */}
      {filteredRffs.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16 }}>No RFFs found</div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {filteredRffs.map(rff => {
            const rffAssignments = assignments.filter(a => a.rff_id === rff.id);
            const quotedAssignments = rffAssignments.filter(a => a.quote_amount);
            const event = events.find(e => e.id === rff.project_id);
            const isExpanded = selectedRff === rff.id;

            return (
              <div key={rff.id} style={{ background: T.surface, border: `1px solid ${isExpanded ? T.cyan + "60" : T.border}`, borderRadius: 12, overflow: "hidden", transition: "border-color 0.2s" }}>
                {/* RFF Header */}
                <div onClick={() => setSelectedRff(isExpanded ? null : rff.id)} style={{ padding: "16px 20px", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  onMouseEnter={e => e.currentTarget.style.background = T.bg}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  <div>
                    <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>{rff.title}</div>
                    <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{event?.name || rff.event_name}</div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Event Deadline: {rff.deadline ? new Date(rff.deadline).toLocaleDateString("en-GB") : "—"}</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
                      <div style={{ color: rff.quote_deadline ? T.amber : T.textMuted, fontSize: 11, fontWeight: rff.quote_deadline ? 700 : 400 }}>
                        {rff.quote_deadline ? " Quote Due: " + new Date(rff.quote_deadline).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "No quote deadline set"}
                      </div>
                      <button onClick={e => { e.stopPropagation(); const dl = window.prompt("Set quote submission deadline (YYYY-MM-DDTHH:MM):", rff.quote_deadline ? rff.quote_deadline.slice(0,16) : new Date(Date.now()+7*24*60*60*1000).toISOString().slice(0,16)); if (dl) { supabase.from("rffs").update({ quote_deadline: dl }).eq("id", rff.id).then(() => load()); } }} style={{ background: T.amber+"15", border: `1px solid ${T.amber}30`, color: T.amber, padding: "2px 8px", borderRadius: 4, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Set Deadline</button>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ color: quotedAssignments.length > 0 ? T.teal : T.amber, fontWeight: 900, fontSize: 18 }}>{quotedAssignments.length}</div>
                      <div style={{ color: T.textMuted, fontSize: 10, textTransform: "uppercase" }}>of {rffAssignments.length} quoted</div>
                    </div>
                    <div style={{ color: T.textMuted, fontSize: 18, transition: "transform 0.2s", transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)" }}>›</div>
                  </div>
                </div>

                {/* Expanded Quotes */}
                {isExpanded && (
                  <div style={{ borderTop: `1px solid ${T.border}`, padding: "16px 20px" }}>
                    {rffAssignments.length === 0 ? (
                      <div style={{ color: T.textMuted, fontSize: 13 }}>No vendors assigned yet.</div>
                    ) : (
                      <div>
                        <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1.2fr 1fr 1fr 1fr 40px", gap: 8, marginBottom: 8 }}>
                          {["Vendor","Category","Quote Amount","Document","Submitted",""].map(h => (
                            <div key={h} style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>{h}</div>
                          ))}
                        </div>
                        {rffAssignments.map(a => (
                          <div key={a.id} style={{ display: "grid", gridTemplateColumns: "1.5fr 1.2fr 1fr 1fr 1fr 40px", gap: 8, padding: "10px 0", borderBottom: `1px solid ${T.border}44`, alignItems: "center" }}>
                            <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{a.vendor_name}</div>
                            <div style={{ color: T.textMuted, fontSize: 12 }}>—</div>
                            <div style={{ color: a.quote_amount ? T.amber : T.textMuted, fontWeight: a.quote_amount ? 800 : 400, fontSize: 13 }}>
                              {a.quote_amount ? `${getCurrency(rff?.country||activeCountry||"Ghana")} ${(parseFloat(a.quote_amount).toLocaleString())}` : "Pending"}
                            </div>
                            <div>
                              {a.quote_document_url ? (
                                <a href={a.quote_document_url} target="_blank" rel="noopener noreferrer" style={{ color: T.cyan, fontSize: 12, fontWeight: 700, textDecoration: "none" }}> View</a>
                              ) : <span style={{ color: T.textMuted, fontSize: 12 }}>No doc</span>}
                            </div>
                            <div style={{ color: T.textMuted, fontSize: 11 }}>
                              {a.quote_submitted_at ? new Date(a.quote_submitted_at).toLocaleDateString("en-GB") : "—"}
                            </div>
                            <div>
                              {a.quote_amount && (
                                <button onClick={async () => {
                                  if (!window.confirm("Remove quote from " + a.vendor_name + "? This will reset them to pending.")) return;
                                  await supabase.from("rff_vendor_assignments").update({ quote_amount: null, quote_document_url: null, quote_submitted_at: null, quote_notes: null, status: "pending" }).eq("id", a.id);
                                  load();
                                }} style={{ background: T.red+"15", border: `1px solid ${T.red}30`, color: T.red, borderRadius: 6, padding: "3px 7px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>×</button>
                              )}
                            </div>
                          </div>
                        ))}

                        {/* Go to Compare button */}
                        {quotedAssignments.length > 0 && (
                          <div style={{ marginTop: 14, display: "flex", gap: 8 }}>
                            <a href={BASE_URL + "?tab=quote-comparison"} onClick={e => { e.preventDefault(); }} style={{ background: "linear-gradient(135deg," + T.cyan + "," + T.teal + ")", border: "none", color: "#fff", padding: "8px 18px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700, textDecoration: "none", display: "inline-block" }}>Go to Quote Comparison & Award →</a>
                          </div>
                        )}
                        {/* Summary */}
                        {quotedAssignments.length > 0 && (
                          <div style={{ marginTop: 14, paddingTop: 12, borderTop: `1px solid ${T.border}44`, display: "flex", gap: 20 }}>
                            <span style={{ color: T.textMuted, fontSize: 12 }}>Lowest: <strong style={{ color: T.teal }}>{getCurrency(rff?.country||activeCountry||"Ghana")+" "+(Math.min(...quotedAssignments.map(a => parseFloat(a.quote_amount))).toLocaleString()).toLocaleString()}</strong></span>
                            <span style={{ color: T.textMuted, fontSize: 12 }}>Highest: <strong style={{ color: T.amber }}>{getCurrency(rff?.country||activeCountry||"Ghana")+" "+(Math.max(...quotedAssignments.map(a => parseFloat(a.quote_amount))).toLocaleString()).toLocaleString()}</strong></span>
                            <span style={{ color: T.textMuted, fontSize: 12 }}>Avg: <strong style={{ color: T.cyan }}>{getCurrency(rff?.country||activeCountry||"Ghana")+" "+(Math.round(quotedAssignments.reduce((s,a) => s + parseFloat(a.quote_amount), 0) / quotedAssignments.length).toLocaleString()).toLocaleString()}</strong></span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const QuoteComparisonView = ({ user, activeCountry = "All" }) => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [rffs, setRffs] = useState([]);
  const [selectedRff, setSelectedRff] = useState("");
  const [assignments, setAssignments] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [compareVendors, setCompareVendors] = useState([]);
  const [awardModal, setAwardModal] = useState(null);
  const [awardNotes, setAwardNotes] = useState("");
  const [agreedAmount, setAgreedAmount] = useState("");
  const [changeOrderModal, setChangeOrderModal] = useState(null);
  const [changeOrderForm, setChangeOrderForm] = useState({ new_amount: "", reason: "", effective_date: "" });
  const [savingCO, setSavingCO] = useState(false);
  const [saving, setSaving] = useState(false);
  const [awards, setAwards] = useState([]);
  const [changeOrders, setChangeOrders] = useState([]);
  const [vendorProfiles, setVendorProfiles] = useState([]);
  const [vendorApps, setVendorApps] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);

  const load = async () => {
    const [{ data: ev }, { data: aw }, { data: co }, { data: vp }, { data: va }] = await Promise.all([
      (!activeCountry || activeCountry === "All") ? supabase.from("projects").select("*").order("name") : supabase.from("projects").select("*").eq("country",activeCountry).order("name"),
      (!activeCountry || activeCountry === "All") ? supabase.from("rff_awards").select("*") : supabase.from("rff_awards").select("*").eq("country",activeCountry),
      supabase.from("change_orders").select("*"),
      supabase.from("profiles").select("*").eq("role", "Vendor"),
      supabase.from("vendor_applications").select("*").eq("status", "login-created"),
    ]);
    setEvents(ev || []);
    setAwards(aw || []);
    setVendorProfiles(vp || []);
    setVendorApps(va || []);
  };

  useEffect(() => { load(); }, [activeCountry]);

  const loadRffs = async (eventId) => {
    const rffsQuery = (!activeCountry || activeCountry === "All")
      ? supabase.from("rffs").select("*").order("created_at", { ascending: false })
      : supabase.from("rffs").select("*").eq("country", activeCountry).order("created_at", { ascending: false });
    const { data } = await rffsQuery;
    setRffs(data || []);
    setSelectedRff("");
    setAssignments([]);
    setBudgets([]);
  };

  const loadQuotes = async (rffId) => {
    const [{ data: asn }, { data: bud }, { data: rff }] = await Promise.all([
      supabase.from("rff_vendor_assignments").select("*").eq("rff_id", rffId),
      supabase.from("rff_budgets").select("*").eq("rff_id", rffId),
      supabase.from("rffs").select("*").eq("id", rffId).single(),
    ]);
    // Merge rff-level quote data as fallback for old submissions
    const enriched = (asn || []).map(a => ({
      ...a,
      quote_amount: a.quote_amount || (rff?.amount && rff?.vendor === a.vendor_name ? rff.amount : null),
      quote_document_url: a.quote_document_url || rff?.quote_url || null,
    }));
    setAssignments(enriched);
    setBudgets(bud || []);
    setSelectedCategory("all");
    setCompareVendors([]);
  };

  // Define all derived values in correct dependency order
  const quotedAssignments = assignments.filter(a => a.quote_amount && parseFloat(a.quote_amount) > 0);

  const categoryFilteredAssignments = selectedCategory === "all"
    ? quotedAssignments
    : quotedAssignments.filter(a => {
        const vp = vendorProfiles.find(v => v.id === a.vendor_id);
        const va = vendorApps.find(v => v.vendor_name === a.vendor_name);
        const vendorCat = (vp?.service_category || va?.vendor_type || "").toLowerCase().trim();
        const selCat = selectedCategory.toLowerCase().trim();
        const budgetCats = budgets.map(b => b.category.toLowerCase().trim()).filter(c => c !== "other");
        const isOtherCategory = selCat === "other";
        if (isOtherCategory) {
          // Other = vendors whose exact category is not in any specific budget category AND not matched by vendor category
          return !budgetCats.some(bc => vendorCat === bc);
        }
        // Match vendor category directly OR match budget category label
        const vendorCatNorm = vendorCat.replace(/\s+/g, " ");
        const selCatNorm = selCat.replace(/\s+/g, " ");
        return vendorCatNorm === selCatNorm;
      });

  const filteredAssignments = categoryFilteredAssignments;

  const totalBudget = budgets.reduce((sum, b) => sum + (b.proposed_amount || 0), 0);
  const [rfpChart, setRfpChart] = useState(null);
  const activeBudget = selectedCategory === "all"
    ? totalBudget
    : (budgets.find(b => b.category.trim() === selectedCategory.trim())?.proposed_amount || 0);

  // Derive categories from budget lines or vendor service categories
  // Always use budget categories as primary source - shows all categories CEO defined
  const budgetCategories = [...new Set(budgets.map(b => b.category.trim()).filter(Boolean))];
  // Fall back to vendor categories if no budget lines
  const vendorCategories = [...new Set(
    assignments.filter(a => a.quote_amount).map(a => {
      const vp = vendorProfiles.find(v => v.id === a.vendor_id);
      const va = vendorApps.find(v => v.vendor_name === a.vendor_name);
      return (vp?.service_category || va?.vendor_type || "").trim() || null;
    }).filter(Boolean)
  )];
  // Merge budget categories + vendor categories so all submitted quote categories appear
  const allCategories = [...new Set([...budgetCategories, ...vendorCategories])];
  const categories = allCategories;

  const toggleCompare = (id) => {
    setCompareVendors(prev => prev.includes(id) ? prev.filter(v => v !== id) : prev.length < 5 ? [...prev, id] : [...prev.slice(1), id]);
  };

  const handleAward = async () => {
    if (!awardModal) return;
    setSaving(true);
    const assignment = assignments.find(a => a.id === awardModal.id);
    const rff = rffs.find(r => r.id === selectedRff);
    const finalAmount = parseFloat(agreedAmount) || awardModal.quote_amount;
    await supabase.from("rff_awards").insert({
      rff_id: selectedRff,
      vendor_id: awardModal.vendor_id,
      vendor_name: awardModal.vendor_name,
      quoted_amount: awardModal.quote_amount,
      agreed_amount: finalAmount,
      proposed_budget: activeBudget || totalBudget,
      vendor_manager_notes: awardNotes,
      status: "pending_ceo",
      awarded_by: user.id,
      country: rff?.country || activeCountry || "Ghana",
      event_name: rff?.event_name || "",
    });
    // Notify CEO
    const { data: ceos } = await supabase.from("profiles").select("id").eq("role", "CEO");
    for (const ceo of ceos || []) {
      await supabase.from("notifications").insert({
        user_id: ceo.id,
        title: "Contract Award Pending Approval",
        message: `${user.name} has nominated ${awardModal.vendor_name} for "${rff?.title}". Agreed Amount: ${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${finalAmount?.toLocaleString()}${finalAmount !== awardModal.quote_amount ? ` (Original: ${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${awardModal.quote_amount?.toLocaleString()})` : ""}. Please review.`,
        type: "rff",
      });
    }
    setSaving(false);
    setAwardModal(null);
    setAwardNotes("");
    setAgreedAmount("");
    load();
    loadQuotes(selectedRff);
  };

  const selectedRffData = rffs.find(r => r.id === selectedRff);
  const compareData = compareVendors.map(id => assignments.find(a => a.id === id)).filter(Boolean);

  //  Weighted Scoring Engine 
  const scoreVendor = (a) => {
    const vp = vendorProfiles.find(v => v.id === a.vendor_id);
    const allQuotes = filteredAssignments.filter(x => x.quote_amount).map(x => x.quote_amount);
    const minQuote = Math.min(...allQuotes);
    const maxQuote = Math.max(...allQuotes);

    // 1. Price Competitiveness (35%) — lower is better
    const priceScore = allQuotes.length > 1
      ? ((maxQuote - a.quote_amount) / (maxQuote - minQuote || 1)) * 100
      : 75;

    // 2. Vendor Rating (25%) — from scorecard or AI default
    const rawRating = vp?.vendor_score || 0;
    const completedGigs = pastEvents.filter(e => e.vendor_id === a.vendor_id && e.status === "quote-submitted").length;
    const ratingScore = rawRating > 0 ? rawRating
      : completedGigs > 5 ? 70
      : completedGigs > 2 ? 55
      : completedGigs > 0 ? 45
      : 35; // new vendor default

    // 3. Experience (20%) — gigs with Stretchfield
    const expScore = Math.min(100, completedGigs * 15 + 25);

    // 4. Reliability (15%) — invoice completion ratio
    const totalAssigned = pastEvents.filter(e => e.vendor_id === a.vendor_id).length;
    const reliabilityScore = totalAssigned > 0
      ? Math.min(100, (completedGigs / totalAssigned) * 100)
      : rawRating > 0 ? 60 : 40;

    // 5. Response Speed (5%) — days from assignment to quote
    let speedScore = 60;
    if (a.quote_submitted_at && a.created_at) {
      const days = Math.ceil((new Date(a.quote_submitted_at) - new Date(a.created_at)) / (1000*60*60*24));
      speedScore = days <= 1 ? 100 : days <= 3 ? 85 : days <= 7 ? 70 : days <= 14 ? 50 : 30;
    }

    const total = (priceScore * 0.35) + (ratingScore * 0.25) + (expScore * 0.20) + (reliabilityScore * 0.15) + (speedScore * 0.05);

    return {
      total: Math.round(total),
      breakdown: { price: Math.round(priceScore), rating: Math.round(ratingScore), experience: Math.round(expScore), reliability: Math.round(reliabilityScore), speed: Math.round(speedScore) },
      isNewVendor: completedGigs === 0 && rawRating === 0,
      completedGigs,
    };
  };

  const generateRecommendation = (scored) => {
    if (scored.length === 0) return null;
    const sorted = [...scored].sort((a, b) => b.score.total - a.score.total);
    const winner = sorted[0];
    const runnerUp = sorted[1];
    const diff = runnerUp ? winner.score.total - runnerUp.score.total : 100;
    const vp = vendorProfiles.find(v => v.id === winner.assignment.vendor_id);
    const category = vp?.service_category || "this category";

    let confidence = diff >= 15 ? "High" : diff >= 8 ? "Moderate" : "Marginal";
    let reasoning = "";
    let risk = "";

    if (winner.score.breakdown.price >= 80) reasoning += "Offers the most competitive pricing. ";
    else if (winner.score.breakdown.price >= 60) reasoning += "Pricing is competitive relative to peers. ";
    else reasoning += "Pricing is higher but offset by other strengths. ";

    if (winner.score.completedGigs > 3) reasoning += `Has ${winner.score.completedGigs} completed engagements with Stretchfield. `;
    else if (winner.score.completedGigs > 0) reasoning += "Has prior experience with Stretchfield. ";
    else reasoning += "No prior Stretchfield history — first engagement. ";

    if (winner.score.breakdown.rating >= 70) reasoning += "Strong vendor rating supports selection.";
    else if (winner.score.breakdown.rating >= 50) reasoning += "Adequate vendor standing.";

    if (winner.score.isNewVendor) risk = "New vendor with no track record. Consider requesting references or a smaller initial engagement.";
    else if (winner.score.breakdown.price < 40) risk = "Selected primarily on non-price factors. Verify quality can match the premium.";
    else if (diff < 8) risk = "Scores are very close — any of the top vendors would be a reasonable choice.";

    return { winner, runnerUp, confidence, reasoning, risk, sorted };
  };

  const scoredData = compareData.map(a => ({ assignment: a, score: scoreVendor(a) }));
  const recommendation = compareData.length >= 2 ? generateRecommendation(scoredData) : null;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Procurement</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Quote Comparison</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Compare vendor quotes against proposed budgets per event</div>
      </div>

      {/* Filters */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14, marginBottom: 24 }}>
        <div>
          <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Select Event</label>
          <select value={selectedEvent} onChange={e => { setSelectedEvent(e.target.value); loadRffs(e.target.value); }} style={{ width: "100%", padding: "9px 12px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
            <option value="">Choose event...</option>
            {events.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
          </select>
        </div>
        <div>
          <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Select RFF</label>
          <select value={selectedRff} onChange={e => { setSelectedRff(e.target.value); loadQuotes(e.target.value); }} style={{ width: "100%", padding: "9px 12px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }} disabled={!selectedEvent}>
            <option value="">Choose RFF...</option>
            {rffs.filter(r => !selectedEvent || r.project_id === selectedEvent).map(r => <option key={r.id} value={r.id}>{r.title}</option>)}
          </select>
        </div>
        <div>
          <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Filter by Category</label>
          <select value={selectedCategory} onChange={e => { setSelectedCategory(e.target.value); setCompareVendors([]); }} style={{ width: "100%", padding: "9px 12px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }} disabled={!selectedRff}>
            <option value="all">All Categories</option>
            {categories.map(cat => {
              const budgetLine = budgets.find(b => b.category.trim() === cat.trim());
              const catVendors = quotedAssignments.filter(a => {
                const vp = vendorProfiles.find(v => v.id === a.vendor_id);
                const va = vendorApps.find(v => v.vendor_name === a.vendor_name);
                const vendorCat = (vp?.service_category || va?.vendor_type || "").toLowerCase().trim();
                const selCat = cat.toLowerCase().trim();
                const allBudgetCats = budgets.map(b => b.category.toLowerCase().trim()).filter(c => c !== "other");
                if (selCat === "other") return !allBudgetCats.some(bc => vendorCat === bc);
                return vendorCat === selCat;
              });
              return (
                <option key={cat} value={cat}>
                  {cat}{catVendors.length > 0 ? " — " + catVendors.length + " vendor" + (catVendors.length !== 1 ? "s" : "") : " — no quotes yet"}{budgetLine ? " (" + getCurrency(selectedRff?.country||activeCountry||"Ghana") + " " + (budgetLine.proposed_amount||0).toLocaleString() + ")" : ""}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      {selectedRff && (
        <>
          {/* Budget vs Quotes KPI */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px,1fr))", gap: 12, marginBottom: 24 }}>
            {[
              { label: "Total Budget", value: totalBudget > 0 ? `${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${(totalBudget.toLocaleString())}` : "Not set", color: totalBudget > 0 ? T.cyan : T.textMuted },
              { label: "Quotes Received", value: filteredAssignments.length, color: T.teal },
              { label: rfpChart ? "Closest to projected" : "Lowest Quote", value: rfpChart ? rfpChart.best : filteredAssignments.length > 0 ? `${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${(Math.min(...filteredAssignments.map(a => a.quote_amount)).toLocaleString())}` : "—", color: "#10B981" },
              { label: rfpChart ? "Furthest from projected" : "Highest Quote", value: rfpChart ? rfpChart.worst : filteredAssignments.length > 0 ? `${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${(Math.max(...filteredAssignments.map(a => a.quote_amount)).toLocaleString())}` : "—", color: T.amber },
            ].map((k, i) => (
              <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
                <div style={{ color: k.color, fontSize: 18, fontWeight: 900 }}>{k.value}</div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginTop: 4 }}>{k.label}</div>
              </div>
            ))}
          </div>

          {/* Budget Lines */}
          {budgets.length > 0 && (
            <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 12, padding: "16px 20px", marginBottom: 20 }}>
              <div style={{ color: T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>CEO Proposed Budget Breakdown</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 10 }}>
                {budgets.map(b => (
                  <div key={b.id} style={{ background: T.bg, borderRadius: 8, padding: "10px 14px", border: `1px solid ${T.border}` }}>
                    <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{b.category}</div>
                    <div style={{ color: T.cyan, fontWeight: 900, fontSize: 16, marginTop: 4 }}>{getCurrency(selectedRff?.country||activeCountry||"Ghana")+" "+((b.proposed_amount || 0).toLocaleString()).toLocaleString()}</div>
                    {b.notes && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{b.notes}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Quote Comparison Chart */}
          {selectedRff && <RfpSectionCompare user={user} rffId={selectedRff} onFound={setRfpChart} />}
          {quotedAssignments.length > 0 && !rfpChart && (
            <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "20px", marginBottom: 20 }}>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 16 }}>Quote Comparison Chart</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {/* Budget line */}
                {(activeBudget > 0 || totalBudget > 0) && (
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{ width: 120, color: T.cyan, fontSize: 11, fontWeight: 700, textAlign: "right", flexShrink: 0 }}>{selectedCategory === "all" ? "Total Budget" : selectedCategory}</div>
                    <div style={{ flex: 1, height: 28, background: T.border + "44", borderRadius: 4, overflow: "hidden", position: "relative" }}>
                      <div style={{ height: "100%", width: "100%", background: `linear-gradient(90deg, ${T.cyan}40, ${T.cyan}20)`, borderRadius: 4, border: `2px dashed ${T.cyan}`, boxSizing: "border-box" }} />
                    </div>
                    <div style={{ width: 120, color: T.cyan, fontSize: 12, fontWeight: 700, flexShrink: 0 }}>{getCurrency(selectedRff?.country||activeCountry||"Ghana")+" "+(activeBudget.toLocaleString()).toLocaleString()}</div>
                  </div>
                )}
                {/* Group by vendor category */}
                {(() => {
                  const grouped = {};
                  filteredAssignments.forEach(a => {
                    const vp = vendorProfiles.find(v => v.id === a.vendor_id);
                    const va2 = vendorApps.find(v => v.vendor_name === a.vendor_name);
                    const cat = vp?.service_category || va2?.vendor_type || "Other";
                    if (!grouped[cat]) grouped[cat] = [];
                    grouped[cat].push(a);
                  });
                  return Object.entries(grouped).map(([cat, catAssignments]) => (
                    <div key={cat} style={{ marginBottom:16 }}>
                      <div style={{ color:T.textMuted, fontSize:10, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:8, paddingLeft:152, borderBottom:`1px solid ${T.border}44`, paddingBottom:4 }}>{cat}</div>
                      {catAssignments.map((a, idx) => {
                  const pct = activeBudget > 0 ? Math.min((a.quote_amount / activeBudget) * 100, 150) : 50;
                  const barColor = a.quote_amount <= activeBudget ? T.teal : T.red;
                  const isSelected = compareVendors.includes(a.id);
                  const isAwarded = awards.some(aw => aw.rff_id === selectedRff && aw.vendor_id === a.vendor_id);
                  const vProfile = vendorProfiles.find(v => v.id === a.vendor_id);
                  const vApp = vendorApps.find(v => v.vendor_name === a.vendor_name);
                  const tier = vProfile ? getTier(vProfile.vendor_score || 0) : null;
                  const expCount = pastEvents.filter(e => e.vendor_id === a.vendor_id && e.quote_submitted_at).length;
                  const variancePct = activeBudget > 0 ? (((a.quote_amount - activeBudget) / activeBudget) * 100).toFixed(1) : null;
                  const daysToRespond = a.quote_submitted_at && a.created_at ? Math.ceil((new Date(a.quote_submitted_at) - new Date(a.created_at)) / (1000*60*60*24)) : null;
                  return (
                    <div key={a.id} style={{ background: isSelected ? T.amber+"08" : "transparent", border: isSelected ? `1px solid ${T.amber}30` : "1px solid transparent", borderRadius: 8, padding: "8px 0" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{ width: 140, flexShrink: 0, textAlign: "right" }}>
                          <div style={{ color: isSelected ? T.amber : T.textPrimary, fontSize: 12, fontWeight: 800, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.vendor_name}</div>
                          {tier && vProfile?.vendor_scorecard_count > 0 && (
                            <span style={{ background: tier.color+"20", color: tier.color, border: `1px solid ${tier.color}40`, borderRadius: 20, padding: "1px 6px", fontSize: 9, fontWeight: 800 }}>{tier.label}</span>
                          )}
                          {(!vProfile || vProfile.vendor_scorecard_count === 0) && (
                            <span style={{ color: T.textMuted, fontSize: 9 }}>Unrated</span>
                          )}
                        </div>
                        <div style={{ flex: 1, height: 28, background: T.border + "44", borderRadius: 4, overflow: "hidden", position: "relative", cursor: "pointer" }} onClick={() => toggleCompare(a.id)}>
                          <div style={{ height: "100%", width: `${pct}%`, background: `linear-gradient(90deg, ${barColor}, ${barColor}99)`, borderRadius: 4, transition: "width 0.4s ease", border: isSelected ? `2px solid ${T.amber}` : "none", boxSizing: "border-box" }} />
                        </div>
                        <div style={{ width: 130, flexShrink: 0 }}>
                          <div style={{ color: barColor, fontSize: 12, fontWeight: 700 }}>{getCurrency(selectedRff?.country||activeCountry||"Ghana")+" "+((a.quote_amount || 0).toLocaleString()).toLocaleString()}</div>
                          {variancePct !== null && (
                            <div style={{ color: parseFloat(variancePct) <= 0 ? T.teal : T.red, fontSize: 10, fontWeight: 700 }}>
                              {parseFloat(variancePct) <= 0 ? ` ${Math.abs(variancePct)}% under` : ` ${variancePct}% over`}
                            </div>
                          )}
                        </div>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 4, width: 200, flexShrink: 0 }}>
                          {expCount > 0 && <span style={{ background: T.blue+"15", color: T.blue, borderRadius: 20, padding: "1px 7px", fontSize: 9, fontWeight: 700 }}> {expCount} event{expCount>1?"s":""}</span>}
                          {daysToRespond !== null && <span style={{ background: daysToRespond <= 2 ? T.teal+"15" : T.amber+"15", color: daysToRespond <= 2 ? T.teal : T.amber, borderRadius: 20, padding: "1px 7px", fontSize: 9, fontWeight: 700 }}> {daysToRespond}d response</span>}
                          {a.quote_document_url ? <span style={{ background: T.teal+"15", color: T.teal, borderRadius: 20, padding: "1px 7px", fontSize: 9, fontWeight: 700 }}> Doc </span> : <span style={{ background: T.red+"15", color: T.red, borderRadius: 20, padding: "1px 7px", fontSize: 9, fontWeight: 700 }}>No doc</span>}
                          {vApp?.payment_terms && <span style={{ background: T.amber+"15", color: T.amber, borderRadius: 20, padding: "1px 7px", fontSize: 9, fontWeight: 700 }}> {vApp.payment_terms.slice(0,15)}</span>}
                        </div>
                        <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                          <button onClick={() => toggleCompare(a.id)} style={{ background: isSelected ? T.amber+"20" : T.surface, border: `1px solid ${isSelected ? T.amber : T.border}`, color: isSelected ? T.amber : T.textMuted, padding: "3px 10px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}>{isSelected ? " Selected" : "Compare"}</button>
                          {a.quote_document_url && <a href={a.quote_document_url} target="_blank" rel="noopener noreferrer" style={{ background: T.cyan+"15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "3px 10px", borderRadius: 6, fontSize: 10, fontWeight: 700, textDecoration: "none" }}>View</a>}
                          {!isAwarded && user?.role === "Vendor Manager" && (
                            <button onClick={() => { setAwardModal(a); setAgreedAmount(a.quote_amount || ""); }} style={{ background: "#10B98115", border: "1px solid #10B98130", color: "#10B981", padding: "3px 10px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Award</button>
                          )}
                          {isAwarded && <span style={{ color: "#10B981", fontSize: 10, fontWeight: 700 }}> Awarded</span>}
                        </div>
                      </div>
                    </div>
                  );
                      })}
                    </div>
                  ));
                })()}
              </div>
            </div>
          )}

          {/*  Weighted Scoring Matrix  */}
          {/* Single vendor vs budget analysis */}
          {(() => {
            // Auto-show single vendor analysis when only 1 vendor in filtered list
            const autoSingle = filteredAssignments.length === 1
              ? filteredAssignments
              : compareData.length === 1 ? compareData : [];
            if (autoSingle.length !== 1) return null;
            const a = autoSingle[0];
            const s = scoredData.find(x => x.assignment.id === a.id)?.score || scoredData[0]?.score;
            const diff = a.quote_amount - activeBudget;
            const pct = ((diff / activeBudget) * 100).toFixed(1);
            const isOver = diff > 0;
            return (
              <div style={{ background: T.surface, border: `1px solid ${isOver ? T.red : T.teal}30`, borderRadius: 14, padding: "20px 24px", marginBottom: 20 }}>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 12 }}>Single Vendor Analysis vs Budget</div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 20, flexWrap: "wrap" }}>
                  <div>
                    <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18 }}>{a.vendor_name}</div>
                    <div style={{ color: T.amber, fontWeight: 900, fontSize: 22, marginTop: 4 }}>{getCurrency(selectedRff?.country||activeCountry||"Ghana")+" "+(a.quote_amount.toLocaleString()).toLocaleString()}</div>
                    <div style={{ color: isOver ? T.red : T.teal, fontWeight: 700, fontSize: 13, marginTop: 4 }}>
                      {isOver ? ` ${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${Math.abs(diff).toLocaleString()} over budget (${pct}%)` : ` ${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${Math.abs(diff).toLocaleString()} under budget (${Math.abs(pct)}%)`}
                    </div>
                  </div>
                  <div style={{ background: T.bg, borderRadius: 10, padding: "14px 18px", minWidth: 160 }}>
                    <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 8 }}>Proposed Budget</div>
                    <div style={{ color: T.cyan, fontWeight: 900, fontSize: 20 }}>{getCurrency(selectedRff?.country||activeCountry||"Ghana")+" "+(activeBudget.toLocaleString()).toLocaleString()}</div>
                  </div>
                </div>
                {s && (
                  <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 6 }}>
                    <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", marginBottom: 4 }}>Vendor Score</div>
                    {[["Price vs Budget", isOver ? Math.max(0, 100 - parseFloat(pct)) : 100, "35%"],
                      ["Rating", s.breakdown.rating, "25%"],
                      ["Experience", s.breakdown.experience, "20%"],
                      ["Reliability", s.breakdown.reliability, "15%"],
                      ["Response Speed", s.breakdown.speed, "5%"],
                    ].map(([label, val, weight]) => (
                      <div key={label}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                          <span style={{ color: T.textMuted, fontSize: 11 }}>{label} <span style={{ color: T.textGhost, fontSize: 9 }}>({weight})</span></span>
                          <span style={{ color: val >= 70 ? T.teal : val >= 50 ? T.amber : T.red, fontSize: 11, fontWeight: 700 }}>{Math.round(val)}</span>
                        </div>
                        <div style={{ height: 4, background: T.border+"33", borderRadius: 2, overflow: "hidden" }}>
                          <div style={{ width: Math.round(val)+"%", height: "100%", background: val >= 70 ? T.teal : val >= 50 ? T.amber : T.red, borderRadius: 2 }} />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ marginTop: 16, padding: "12px 16px", background: isOver ? T.red+"10" : T.teal+"10", borderRadius: 8, border: `1px solid ${isOver ? T.red : T.teal}20` }}>
                  <div style={{ color: isOver ? T.red : T.teal, fontWeight: 700, fontSize: 13, marginBottom: 4 }}>
                    {isOver ? "Recommendation: Negotiate" : "Recommendation: Proceed"}
                  </div>
                  <div style={{ color: T.textSecondary, fontSize: 12, lineHeight: 1.6 }}>
                    {isOver
                      ? `${a.vendor_name} has quoted GHS ${Math.abs(diff).toLocaleString()} above the proposed budget. Consider negotiating the price down or reviewing the budget allocation before proceeding.`
                      : `${a.vendor_name}'s quote is within budget with ${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${Math.abs(diff).toLocaleString()} to spare. ${s?.isNewVendor ? "Note: This is a new vendor with no prior Stretchfield history." : "Vendor has prior engagement history."} You may proceed or invite more quotes for comparison.`}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
                  <button onClick={() => { setAwardModal(a); setAwardNotes(""); setAgreedAmount(a.quote_amount || ""); }} style={{ background: `linear-gradient(135deg, ${T.teal}, #10B981)`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>Award Gig</button>
                  <button onClick={async () => {
                    const msg = window.prompt("Message to vendor (explain what needs to change):", "Please review your quote. Our proposed budget for this category is GHS " + (activeBudget||0).toLocaleString() + ". Kindly revise and resubmit.");
                    if (!msg) return;
                    await supabase.from("rff_vendor_assignments").update({ status: "pending", quote_amount: null, quote_document_url: null, quote_submitted_at: null }).eq("id", a.id);
                    await supabase.from("notifications").insert({ user_id: a.vendor_id, title: "Quote Revision Requested — " + (selectedRffData?.title || ""), message: msg, type: "rff" });
                    load(); loadQuotes(selectedRff);
                  }} style={{ background: T.amber+"15", border: "1px solid "+T.amber+"40", color: T.amber, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 13 }}>Request Revision</button>
                </div>
              </div>
            );
          })()}

          {compareData.length === 2 && selectedRff && <RfpLineCompare user={user} rffId={selectedRff} vendorIds={compareData.map(x => x.vendor_id)} />}
          {compareData.length >= 2 && (
            <div style={{ marginBottom: 20 }}>

              {/* AI Recommendation Banner */}
              {recommendation && (
                <div style={{ background: `linear-gradient(135deg, ${T.teal}18, ${T.cyan}12)`, border: `1px solid ${T.teal}40`, borderRadius: 14, padding: "20px 24px", marginBottom: 20 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                    <div>
                      <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 4 }}>Stretchfield Intelligence — Recommendation</div>
                      <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18 }}>Award to {recommendation.winner.assignment.vendor_name}</div>
                      <div style={{ color: T.teal, fontSize: 13, fontWeight: 700, marginTop: 2 }}>Score: {recommendation.winner.score.total}/100 · {recommendation.confidence} Confidence</div>
                    </div>
                    <div style={{ background: T.teal+"20", border: `1px solid ${T.teal}40`, borderRadius: 10, padding: "8px 16px", textAlign: "center" }}>
                      <div style={{ color: T.teal, fontSize: 24, fontWeight: 900 }}>{recommendation.winner.score.total}</div>
                      <div style={{ color: T.textMuted, fontSize: 9, textTransform: "uppercase", letterSpacing: "0.08em" }}>Score</div>
                    </div>
                  </div>
                  <div style={{ color: T.textSecondary, fontSize: 13, lineHeight: 1.6, marginBottom: recommendation.risk ? 10 : 0 }}>{recommendation.reasoning}</div>
                  {recommendation.risk && (
                    <div style={{ background: T.amber+"15", border: `1px solid ${T.amber}30`, borderRadius: 8, padding: "8px 12px", marginTop: 8 }}>
                      <span style={{ color: T.amber, fontSize: 11, fontWeight: 800 }}>Risk Note: </span>
                      <span style={{ color: T.textSecondary, fontSize: 12 }}>{recommendation.risk}</span>
                    </div>
                  )}
                </div>
              )}

              {/* Score Cards */}
              <div style={{ display: "grid", gridTemplateColumns: `repeat(${compareData.length}, 1fr)`, gap: 12, marginBottom: 20 }}>
                {scoredData.sort((a,b) => b.score.total - a.score.total).map((item, idx) => {
                  const a = item.assignment;
                  const s = item.score;
                  const isWinner = idx === 0;
                  const vp = vendorProfiles.find(v => v.id === a.vendor_id);
                  return (
                    <div key={a.id} style={{ background: isWinner ? `linear-gradient(160deg, ${T.teal}18, ${T.surface})` : T.surface, border: `2px solid ${isWinner ? T.teal : T.border}`, borderRadius: 12, padding: "18px 16px", position: "relative" }}>
                      {isWinner && <div style={{ position: "absolute", top: -10, left: "50%", transform: "translateX(-50%)", background: T.teal, color: "#fff", fontSize: 9, fontWeight: 900, padding: "2px 12px", borderRadius: 20, textTransform: "uppercase", letterSpacing: "0.08em", whiteSpace: "nowrap" }}>Recommended</div>}
                      <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 15, marginBottom: 4, marginTop: isWinner ? 4 : 0 }}>{a.vendor_name}</div>
                      {vp?.service_category && <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 12 }}>{vp.service_category}</div>}

                      {/* Total Score */}
                      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                        <div style={{ flex: 1, height: 8, background: T.border+"44", borderRadius: 4, overflow: "hidden" }}>
                          <div style={{ width: s.total+"%", height: "100%", background: isWinner ? `linear-gradient(90deg, ${T.teal}, ${T.cyan})` : T.amber, borderRadius: 4, transition: "width 0.8s ease" }} />
                        </div>
                        <span style={{ color: isWinner ? T.teal : T.amber, fontWeight: 900, fontSize: 16, minWidth: 36 }}>{s.total}</span>
                      </div>

                      {/* Quote Amount */}
                      <div style={{ marginBottom: 14, padding: "10px 12px", background: T.bg, borderRadius: 8 }}>
                        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Quote Amount</div>
                        <div style={{ color: T.amber, fontWeight: 900, fontSize: 17 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+((a.quote_amount||0).toLocaleString()).toLocaleString()}</div>
                        {activeBudget > 0 && (
                          <div style={{ color: a.quote_amount <= activeBudget ? T.teal : "#F43F5E", fontSize: 11, fontWeight: 700, marginTop: 3 }}>
                            {a.quote_amount <= activeBudget ? ` ${((1 - a.quote_amount/activeBudget)*100).toFixed(1)}% under budget` : ` ${(((a.quote_amount-activeBudget)/activeBudget)*100).toFixed(1)}% over budget`}
                          </div>
                        )}
                      </div>

                      {/* Score Breakdown */}
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        {[
                          ["Price", s.breakdown.price, "35%"],
                          ["Rating", s.breakdown.rating, "25%"],
                          ["Experience", s.breakdown.experience, "20%"],
                          ["Reliability", s.breakdown.reliability, "15%"],
                          ["Speed", s.breakdown.speed, "5%"],
                        ].map(([label, val, weight]) => (
                          <div key={label}>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                              <span style={{ color: T.textMuted, fontSize: 10 }}>{label} <span style={{ color: T.textGhost, fontSize: 9 }}>({weight})</span></span>
                              <span style={{ color: val >= 70 ? T.teal : val >= 50 ? T.amber : "#F43F5E", fontSize: 10, fontWeight: 700 }}>{val}</span>
                            </div>
                            <div style={{ height: 4, background: T.border+"33", borderRadius: 2, overflow: "hidden" }}>
                              <div style={{ width: val+"%", height: "100%", background: val >= 70 ? T.teal : val >= 50 ? T.amber : "#F43F5E", borderRadius: 2 }} />
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Details */}
                      <div style={{ marginTop: 14, paddingTop: 12, borderTop: `1px solid ${T.border}44` }}>
                        <div style={{ color: T.textMuted, fontSize: 11 }}>Gigs with Stretchfield: <strong style={{ color: T.textPrimary }}>{s.completedGigs || "None"}</strong></div>
                        {s.isNewVendor && <div style={{ color: T.amber, fontSize: 10, fontWeight: 700, marginTop: 4 }}>New vendor — no prior history</div>}
                        {a.quote_document_url && <div style={{ marginTop: 6 }}><a href={a.quote_document_url} target="_blank" rel="noreferrer" style={{ color: T.cyan, fontSize: 11, fontWeight: 700 }}>View Quote Document</a></div>}
                      </div>

                      <button onClick={() => { setAwardModal(a); setAwardNotes(""); setAgreedAmount(a.quote_amount || ""); }} style={{ width: "100%", marginTop: 14, padding: "9px", background: isWinner ? `linear-gradient(135deg, ${T.teal}, #10B981)` : T.surface, border: isWinner ? "none" : `1px solid ${T.border}`, color: isWinner ? "#fff" : T.textMuted, borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 800 }}>
                        {isWinner ? "Award Gig" : "Award Anyway"}
                      </button>
                    </div>
                  );
                })}
              </div>

              {/* Comparison Table */}
              <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
                <div style={{ padding: "14px 20px", borderBottom: `1px solid ${T.border}`, color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em" }}>Detailed Comparison</div>
                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ padding: "10px 16px", color: T.textMuted, fontSize: 11, fontWeight: 700, textAlign: "left", borderBottom: `1px solid ${T.border}` }}>Criteria</th>
                        {scoredData.sort((a,b) => b.score.total - a.score.total).map(item => (
                          <th key={item.assignment.id} style={{ padding: "10px 16px", color: T.textPrimary, fontSize: 12, fontWeight: 800, textAlign: "center", borderBottom: `1px solid ${T.border}`, background: item === scoredData.sort((a,b)=>b.score.total-a.score.total)[0] ? T.teal+"10" : "none" }}>{item.assignment.vendor_name}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Quote Amount", a => getCurrency(activeCountry||user?.country||"Ghana")+" "+((a.quote_amount||0)).toLocaleString()],
                        ["vs Budget", a => { if (!activeBudget) return "—"; const v = (((a.quote_amount - activeBudget)/activeBudget)*100).toFixed(1); return parseFloat(v) <= 0 ? " "+Math.abs(v)+"% under" : " "+v+"% over"; }],
                        ["Payment Terms", a => { const va = vendorApps.find(v => v.vendor_name === a.vendor_name); return va?.payment_terms || "Not specified"; }],
                        ["Response Time", a => { if (!a.quote_submitted_at || !a.created_at) return "—"; const d = Math.ceil((new Date(a.quote_submitted_at)-new Date(a.created_at))/(1000*60*60*24)); return d+" day"+(d!==1?"s":""); }],
                        ["Quote Document", a => a.quote_document_url ? " Submitted" : " Not submitted"],
                        ["Submitted On", a => a.quote_submitted_at ? new Date(a.quote_submitted_at).toLocaleDateString("en-GB") : "—"],
                        ["Overall Score", a => { const s = scoredData.find(x => x.assignment.id === a.id); return s ? s.score.total + "/100" : "—"; }],
                      ].map(([label, fn]) => (
                        <tr key={label}>
                          <td style={{ padding: "10px 16px", color: T.textMuted, fontSize: 12, borderBottom: `1px solid ${T.border}22` }}>{label}</td>
                          {scoredData.sort((a,b)=>b.score.total-a.score.total).map(item => (
                            <td key={item.assignment.id} style={{ padding: "10px 16px", color: T.textPrimary, fontSize: 13, fontWeight: 600, textAlign: "center", borderBottom: `1px solid ${T.border}22`, background: item === scoredData.sort((a,b)=>b.score.total-a.score.total)[0] ? T.teal+"06" : "none" }}>{fn(item.assignment)}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {quotedAssignments.length === 0 && (
            <div style={{ textAlign: "center", padding: "40px 0", background: T.surface, borderRadius: 12, border: `1px solid ${T.border}`, color: T.textMuted, fontSize: 13 }}>No quotes submitted for this RFF yet.</div>
          )}
        </>
      )}

      {!selectedRff && (
        <div style={{ textAlign: "center", padding: "60px 0", background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Select an Event and RFF</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>Choose an event and RFF above to compare vendor quotes.</div>
        </div>
      )}

      {/* Change Order Modal */}
      {changeOrderModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 700, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setChangeOrderModal(null)}>
          <div style={{ background: T.surface, border: "1px solid " + T.amber+"40", borderRadius: 16, width: "100%", maxWidth: 480, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Raise Change Order</div>
            <div style={{ color: T.textMuted, fontSize: 13, marginBottom: 20 }}>{changeOrderModal.vendor_name} — contract amendment</div>

            <div style={{ background: T.bg, border: "1px solid " + T.border, borderRadius: 10, padding: "12px 16px", marginBottom: 16 }}>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>Current Agreed Amount</div>
              <div style={{ color: T.amber, fontWeight: 900, fontSize: 20 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(changeOrderModal.agreed_amount || changeOrderModal.quoted_amount || 0).toLocaleString()).toLocaleString()}</div>
              <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Original quote: GHS {parseFloat(changeOrderModal.quoted_amount || 0).toLocaleString()}</div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 16 }}>
              <div>
                <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>New Agreed Amount (${getCurrency(activeCountry||user?.country||"Ghana")})</label>
                <input type="number" value={changeOrderForm.new_amount} onChange={e => setChangeOrderForm(f => ({...f, new_amount: e.target.value}))} placeholder="Enter new amount" style={{ width: "100%", padding: "10px 12px", background: T.bg, border: "1px solid " + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 14, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
                {changeOrderForm.new_amount && (
                  <div style={{ marginTop: 6, color: parseFloat(changeOrderForm.new_amount) > parseFloat(changeOrderModal.agreed_amount || changeOrderModal.quoted_amount) ? T.red : T.teal, fontSize: 12, fontWeight: 700 }}>
                    {parseFloat(changeOrderForm.new_amount) > parseFloat(changeOrderModal.agreed_amount || changeOrderModal.quoted_amount) ? "" : ""} GHS {Math.abs(parseFloat(changeOrderForm.new_amount) - parseFloat(changeOrderModal.agreed_amount || changeOrderModal.quoted_amount)).toLocaleString()} {parseFloat(changeOrderForm.new_amount) > parseFloat(changeOrderModal.agreed_amount || changeOrderModal.quoted_amount) ? "increase" : "decrease"}
                  </div>
                )}
              </div>
              <div>
                <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Reason for Change *</label>
                <textarea value={changeOrderForm.reason} onChange={e => setChangeOrderForm(f => ({...f, reason: e.target.value}))} placeholder="e.g. Client increased usher count from 10 to 15, 3 days before event" rows={3} style={{ width: "100%", padding: "10px 12px", background: T.bg, border: "1px solid " + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", resize: "none", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Effective Date</label>
                <input type="date" value={changeOrderForm.effective_date} onChange={e => setChangeOrderForm(f => ({...f, effective_date: e.target.value}))} style={{ width: "100%", padding: "10px 12px", background: T.bg, border: "1px solid " + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
              </div>
            </div>

            <div style={{ background: T.amber+"10", border: "1px solid " + T.amber+"30", borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: T.amber }}>
              This will update the agreed amount in Quote Comparison, Purchase Order and Payment Authorisation. VM and vendor will be notified.
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleChangeOrder} disabled={savingCO || !changeOrderForm.new_amount || !changeOrderForm.reason} style={{ flex: 1, background: "linear-gradient(135deg," + T.amber + ",#F59E0B)", border: "none", color: "#fff", padding: "11px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13, opacity: (!changeOrderForm.new_amount || !changeOrderForm.reason) ? 0.5 : 1 }}>{savingCO ? "Saving..." : "Confirm Change Order"}</button>
              <button onClick={() => setChangeOrderModal(null)} style={{ background: "none", border: "1px solid " + T.border, color: T.textMuted, padding: "11px 18px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>

            {/* Change order history */}
            {changeOrders.filter(co => co.rff_award_id === changeOrderModal.id).length > 0 && (
              <div style={{ marginTop: 20, paddingTop: 16, borderTop: "1px solid " + T.border }}>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 8 }}>Amendment History</div>
                {changeOrders.filter(co => co.rff_award_id === changeOrderModal.id).map(co => (
                  <div key={co.id} style={{ padding: "8px 0", borderBottom: "1px solid " + T.border+"22", fontSize: 12 }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ color: T.textPrimary, fontWeight: 600 }}>GHS {co.original_amount.toLocaleString()} → GHS {co.new_amount.toLocaleString()}</span>
                      <span style={{ color: co.difference >= 0 ? T.red : T.teal, fontWeight: 700 }}>{co.difference >= 0 ? "+" : ""}GHS {co.difference.toLocaleString()}</span>
                    </div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{co.reason}</div>
                    <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>{co.raised_by_name} · {new Date(co.created_at).toLocaleDateString("en-GB")}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Award Modal */}
      {awardModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setAwardModal(null)}>
          <div style={{ background: T.surface, border: `1px solid #10B98140`, borderRadius: 16, width: "100%", maxWidth: 500, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Award Contract</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>Nominate {awardModal.vendor_name} for this RFF</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 12, marginBottom: 16, background: T.bg, borderRadius: 8, padding: "12px 14px" }}>
              <div><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>Vendor</div><div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13, marginTop: 3 }}>{awardModal.vendor_name}</div></div>
              <div><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>Original Quote</div><div style={{ color: "#10B981", fontWeight: 900, fontSize: 16, marginTop: 3 }}>{getCurrency(selectedRff?.country||activeCountry||"Ghana")+" "+((awardModal.quote_amount || 0).toLocaleString()).toLocaleString()}</div></div>
              <div><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>Proposed Budget</div><div style={{ color: T.cyan, fontWeight: 700, fontSize: 13, marginTop: 3 }}>{getCurrency(selectedRff?.country||activeCountry||"Ghana")+" "+((activeBudget || totalBudget).toLocaleString()).toLocaleString()}</div></div>
              <div><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>Variance</div><div style={{ color: (parseFloat(agreedAmount)||awardModal.quote_amount) <= (activeBudget||totalBudget) ? T.teal : T.red, fontWeight: 700, fontSize: 13, marginTop: 3 }}>{(parseFloat(agreedAmount)||awardModal.quote_amount) <= (activeBudget||totalBudget) ? " Within budget" : ` Over by ${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${((parseFloat(agreedAmount)||awardModal.quote_amount) - (activeBudget||totalBudget)).toLocaleString()}`}</div></div>
            </div>

            {/* Agreed Amount — editable */}
            <div style={{ marginBottom: 16, background: T.amber+"10", border: `1px solid ${T.amber}30`, borderRadius: 8, padding: "12px 14px" }}>
              <label style={{ color: T.amber, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Agreed Amount (${getCurrency(selectedRff?.country||activeCountry||"Ghana")}) — edit if negotiated</label>
              <input type="number" value={agreedAmount} onChange={e => setAgreedAmount(e.target.value)}
                style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.amber}40`, borderRadius: 8, color: T.textPrimary, fontSize: 15, fontWeight: 700, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
                placeholder={awardModal.quote_amount || "Enter agreed amount"} />
              {agreedAmount && parseFloat(agreedAmount) !== awardModal.quote_amount && (
                <div style={{ color: T.amber, fontSize: 11, marginTop: 5, fontWeight: 600 }}>
                  {parseFloat(agreedAmount) < awardModal.quote_amount
                    ? ` Negotiated down by ${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${(awardModal.quote_amount - parseFloat(agreedAmount)).toLocaleString()}`
                    : `↑ Increased by ${getCurrency(selectedRff?.country||activeCountry||"Ghana")} ${(parseFloat(agreedAmount) - awardModal.quote_amount).toLocaleString()}`}
                </div>
              )}
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Award Notes (sent to CEO)</label>
              <textarea value={awardNotes} onChange={e => setAwardNotes(e.target.value)} rows={3} placeholder="Reason for selection, notes for CEO..." style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box", resize: "vertical" }} />
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleAward} disabled={saving} style={{ background: "linear-gradient(135deg, #10B981, #059669)", border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Submitting..." : " Nominate & Send to CEO"}</button>
              <button onClick={() => setAwardModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const RFFApprovalsView = ({ user, activeCountry = "All" }) => {
  const [rffs, setRffs] = useState([]);
  const [actionModal, setActionModal] = useState(null);
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);
  const [budgetLines, setBudgetLines] = useState([{ category: "", proposed_amount: "", notes: "" }]);
  const [budgetEditModal, setBudgetEditModal] = useState(null);
  const [existingBudgets, setExistingBudgets] = useState([]);
  const [allRffs, setAllRffs] = useState([]);

  const load = () => {
    const rffsQuery = (!activeCountry || activeCountry === "All")
      ? supabase.from("rffs").select("*").order("created_at", { ascending: false })
      : supabase.from("rffs").select("*").eq("country", activeCountry).order("created_at", { ascending: false });
    rffsQuery.then(({ data }) => setRffs(data || []));
    const allRffsQuery = (!activeCountry || activeCountry === "All")
      ? supabase.from("rffs").select("*").eq("approved", true).order("created_at", { ascending: false })
      : supabase.from("rffs").select("*").eq("approved", true).eq("country", activeCountry).order("created_at", { ascending: false });
    allRffsQuery.then(({ data }) => setAllRffs(data || []));
    supabase.from("rff_budgets").select("*").then(({ data }) => setExistingBudgets(data || []));
  };

  useEffect(() => { load(); }, [activeCountry]);

  const handleApprove = async (rff) => {
    setSaving(true);
    await supabase.from("rffs").update({ approved: true, status: "approved", status_notes: notes }).eq("id", rff.id);
    // Save budget lines
    const validLines = budgetLines.filter(l => l.category && l.proposed_amount);
    if (validLines.length > 0) {
      await supabase.from("rff_budgets").insert(validLines.map(l => ({
        rff_id: rff.id,
        category: l.category,
        proposed_amount: parseFloat(l.proposed_amount) || 0,
        notes: l.notes || "",
        created_by: user.id,
      })));
    }
    // Notify Vendor Manager
    const { data: vms } = await supabase.from("profiles").select("id").eq("role", "Vendor Manager");
    if (vms) await Promise.all(vms.map(async vm => {
      await supabase.from("notifications").insert({ user_id: vm.id, title: "RFF Approved with Budget", message: `RFF "${rff.title}" for ${rff.event_name} has been approved with proposed budget. Proceed to vendor assignment.`, type: "rff" });
      const { data: vmProfile } = await supabase.from("profiles").select("email, name").eq("id", vm.id).single();
      if (vmProfile?.email) await sendEmail(vmProfile.email, `RFF Approved — ${rff.title}`, notifEmailHtml({ name: vmProfile.name, title: "RFF Approved with Budget", message: `RFF "${rff.title}" for ${rff.event_name} has been approved with proposed budget. You may now proceed to vendor assignment.`, actionUrl: BASE_URL, actionLabel: "Go to Vendor Assignment" }));
    }));
    setSaving(false); setActionModal(null); setNotes(""); setBudgetLines([{ category: "", proposed_amount: "", notes: "" }]); load();
  };

  const handleDecline = async (rff) => {
    if (!notes) { alert("Please add notes explaining why this RFF is declined."); return; }
    setSaving(true);
    await supabase.from("rffs").update({ approved: false, status: "declined", declined_notes: notes }).eq("id", rff.id);
    // Notify Vendor Manager
    const { data: vms } = await supabase.from("profiles").select("id").eq("role", "Vendor Manager");
    if (vms) await Promise.all(vms.map(async vm => {
      await supabase.from("notifications").insert({ user_id: vm.id, title: "RFF Declined", message: `RFF "${rff.title}" was declined. Notes: ${notes}`, type: "rff" });
      const { data: vmProfile } = await supabase.from("profiles").select("email, name").eq("id", vm.id).single();
      if (vmProfile?.email) await sendEmail(vmProfile.email, `RFF Declined — ${rff.title}`, notifEmailHtml({ name: vmProfile.name, title: "RFF Declined", message: `RFF "${rff.title}" was declined by the CEO.<br><br><strong>Notes:</strong> ${notes}`, actionUrl: BASE_URL, actionLabel: "View RFF" }));
    }));
    setSaving(false); setActionModal(null); setNotes(""); load();
  };

  const pending = rffs.filter(r => r.status === "pending");
  const declined = rffs.filter(r => r.status === "declined");

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Procurement</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>RFF Approval Queue</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{pending.length} pending review</div>
      </div>

      {/* KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Pending Review", value: pending.length, color: T.amber },
          { label: "Approved", value: rffs.filter(r => r.approved).length, color: T.teal },
          { label: "Declined", value: rffs.filter(r => r.status === "declined").length, color: T.red },
        ].map((k, i) => (
          <div key={i} style={{ padding: "16px 18px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 22, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {rffs.length === 0 ? (
        <Card style={{ textAlign: "center", padding: 60 }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16 }}>No RFFs awaiting approval</div>
          <div style={{ color: T.textMuted, fontSize: 13, marginTop: 8 }}>New RFF submissions will appear here.</div>
        </Card>
      ) : (
        <div>
          {pending.length > 0 && (
            <div style={{ marginBottom: 28 }}>
              <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>Pending Review ({pending.length})</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 16 }}>
                {pending.map(r => (
                  <Card key={r.id} style={{ borderLeft: "3px solid " + T.amber, marginBottom: 0 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                      <div>
                        <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>{r.title}</div>
                        <div style={{ color: T.cyan, fontSize: 12, marginTop: 3, fontWeight: 600 }}> {r.event_name}</div>
                        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}> {r.client_name} · Due {r.deadline}</div>
                        {r.description && <div style={{ color: T.textSecondary, fontSize: 12, marginTop: 6 }}>{r.description}</div>}
                      </div>
                      <Badge status="pending" />
                    </div>
                    {r.document_url && <a href={r.document_url} target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: T.cyan, fontSize: 12, fontWeight: 600, textDecoration: "none", background: T.cyan + "15", padding: "5px 12px", borderRadius: 6, border: "1px solid " + T.cyan + "33", marginBottom: 12 }}> View RFF Document</a>}
                    <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
                      <button onClick={() => { setActionModal({ rff: r, action: "approve" }); setNotes(""); setBudgetLines([{ category: "", proposed_amount: "", notes: "" }]); }} style={{ flex: 1, padding: "8px", background: T.teal + "20", border: "1px solid " + T.teal + "44", borderRadius: 8, cursor: "pointer", color: T.teal, fontSize: 12, fontWeight: 700 }}> Approve + Budget</button>
                      <button onClick={() => { setActionModal({ rff: r, action: "decline" }); setNotes(""); }} style={{ flex: 1, padding: "8px", background: "#F43F5E15", border: "1px solid #F43F5E44", borderRadius: 8, cursor: "pointer", color: "#F43F5E", fontSize: 12, fontWeight: 700 }}> Decline</button>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          )}

          {declined.length > 0 && (
            <div>
              <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>Previously Declined ({declined.length})</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 16 }}>
                {declined.map(r => (
                  <Card key={r.id} style={{ borderLeft: "3px solid #F43F5E", marginBottom: 0 }}>
                    <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{r.title}</div>
                    <div style={{ color: T.cyan, fontSize: 12, fontWeight: 600 }}> {r.event_name}</div>
                    {r.declined_notes && <div style={{ marginTop: 8, padding: "8px 12px", background: "#F43F5E10", border: "1px solid #F43F5E33", borderRadius: 6 }}><div style={{ color: "#F43F5E", fontSize: 11, fontWeight: 700, marginBottom: 2 }}>Decline Notes:</div><div style={{ color: T.textSecondary, fontSize: 12 }}>{r.declined_notes}</div></div>}
                    <button onClick={() => { setActionModal({ rff: r, action: "approve" }); setNotes(""); }} style={{ marginTop: 10, width: "100%", padding: "8px", background: T.teal + "20", border: "1px solid " + T.teal + "44", borderRadius: 8, cursor: "pointer", color: T.teal, fontSize: 12, fontWeight: 700 }}> Approve Now</button>
                  </Card>
                ))}
              </div>
            </div>
          )}
        </div>
      )}


      {/*  Approved RFFs — CEO can edit budgets  */}
      {allRffs.length > 0 && (
        <div style={{ marginTop: 32 }}>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 12 }}>Approved RFFs — Edit Budgets</div>
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: T.bg, borderBottom: `1px solid ${T.border}` }}>
                  {["RFF Title","Event","Budget Lines","Total Budget",""].map((h,i) => (
                    <th key={i} style={{ padding: "10px 14px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {allRffs.map((rff, i) => {
                  const rfBudgets = existingBudgets.filter(b => b.rff_id === rff.id);
                  const total = rfBudgets.reduce((s, b) => s + (b.proposed_amount || 0), 0);
                  return (
                    <tr key={rff.id} style={{ borderBottom: i < allRffs.length-1 ? `1px solid ${T.border}44` : "none" }}
                      onMouseEnter={e => e.currentTarget.style.background = T.bg}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <td style={{ padding: "10px 14px", color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{rff.title}</td>
                      <td style={{ padding: "10px 14px", color: T.textMuted, fontSize: 12 }}>{rff.event_name}</td>
                      <td style={{ padding: "10px 14px" }}>
                        {rfBudgets.length === 0 ? (
                          <span style={{ color: T.amber, fontSize: 11, fontWeight: 700 }}>No budget set</span>
                        ) : (
                          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                            {rfBudgets.map(b => (
                              <span key={b.id} style={{ background: T.cyan+"15", color: T.cyan, border: `1px solid ${T.cyan}30`, borderRadius: 20, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>{b.category}: {getCurrency(activeCountry||user?.country||"Ghana")} {(b.proposed_amount||0).toLocaleString()}</span>
                            ))}
                          </div>
                        )}
                      </td>
                      <td style={{ padding: "10px 14px", color: total > 0 ? T.teal : T.textMuted, fontWeight: 700, fontSize: 13 }}>{total > 0 ? `${getCurrency(rff.country||activeCountry||"Ghana")} ${(total.toLocaleString())}` : "—"}</td>
                      <td style={{ padding: "10px 14px" }}>
                        <button onClick={() => {
                          const existing = existingBudgets.filter(b => b.rff_id === rff.id);
                          setBudgetEditModal(rff);
                          setBudgetLines(existing.length > 0 ? existing.map(b => ({ id: b.id, category: b.category, proposed_amount: b.proposed_amount, notes: b.notes || "" })) : [{ category: "", proposed_amount: "", notes: "" }]);
                        }} style={{ background: T.cyan+"15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "5px 14px", borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>
                          {existingBudgets.filter(b => b.rff_id === rff.id).length > 0 ? " Edit Budget" : "+ Add Budget"}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Budget Edit Modal */}
      {budgetEditModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setBudgetEditModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 620, maxHeight: "85vh", overflow: "auto", padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Edit Budget — {budgetEditModal.title}</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>{budgetEditModal.event_name} · {budgetEditModal.client_name}</div>

            <div style={{ color: T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8, paddingBottom: 6, borderBottom: `1px solid ${T.cyan}30` }}>Budget Line Items</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 32px", gap: 8, marginBottom: 6 }}>
              {["Category",`Proposed Amount (${getCurrency(actionModal?.rff?.country||activeCountry||"Ghana")})`,"Notes",""].map((h,i) => (
                <div key={i} style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</div>
              ))}
            </div>
            {budgetLines.map((line, idx) => (
              <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 32px", gap: 8, marginBottom: 8 }}>
                <select value={line.category} onChange={e => { const l = [...budgetLines]; l[idx].category = e.target.value; setBudgetLines(l); }} style={{ padding: "7px 10px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: line.category ? T.textPrimary : T.textMuted, fontSize: 12, fontFamily: "inherit", outline: "none" }}>
                  <option value="">Select category...</option>
                  {["Event Lighting","Events Ushering","Photography","Videography","Catering","Entertainment Provider (MC, DJ, Live Band, Performers)","Event Decor","Event Production Company","Event Refreshment","Furniture & Equipment Rental","Gift & Merchandise Supplier","Health & Safety Provider","Printing Company","Registration & Badging Service","Security Service","Technology Provider","Transportation (Shuttle, Car Rental)","Venue Provider","Other"].map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                <input type="number" value={line.proposed_amount} onChange={e => { const l = [...budgetLines]; l[idx].proposed_amount = e.target.value; setBudgetLines(l); }} placeholder="0.00" style={{ padding: "7px 10px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                <input value={line.notes || ""} onChange={e => { const l = [...budgetLines]; l[idx].notes = e.target.value; setBudgetLines(l); }} placeholder="Notes..." style={{ padding: "7px 10px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                <button onClick={() => setBudgetLines(budgetLines.filter((_,i) => i !== idx))} style={{ background: T.red+"18", border: `1px solid ${T.red}30`, color: T.red, borderRadius: 6, cursor: "pointer", fontSize: 14, fontWeight: 700 }}>×</button>
              </div>
            ))}
            <button onClick={() => setBudgetLines([...budgetLines, { category: "", proposed_amount: "", notes: "" }])} style={{ background: "none", border: `1px dashed ${T.border}`, color: T.textMuted, padding: "6px 16px", borderRadius: 6, cursor: "pointer", fontSize: 12, width: "100%", marginTop: 4, marginBottom: 20 }}>+ Add Line Item</button>

            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={async () => {
                setSaving(true);
                const validLines = budgetLines.filter(l => l.category && l.proposed_amount);
                // Delete existing budgets for this RFF
                await supabase.from("rff_budgets").delete().eq("rff_id", budgetEditModal.id);
                // Insert new ones
                if (validLines.length > 0) {
                  await supabase.from("rff_budgets").insert(validLines.map(l => ({
                    rff_id: budgetEditModal.id,
                    category: l.category,
                    proposed_amount: parseFloat(l.proposed_amount) || 0,
                    notes: l.notes || "",
                    created_by: user.id,
                  })));
                }
                setSaving(false);
                setBudgetEditModal(null);
                load();
              }} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Saving..." : "Save Budget"}</button>
              <button onClick={() => setBudgetEditModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* RFF Action Modal with Budget Template */}
      {actionModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 500, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setActionModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 600, maxHeight: "90vh", overflow: "auto", padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>{actionModal.action === "approve" ? "Approve RFF + Set Budget" : "Decline RFF"}</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>{actionModal.rff.title} · {actionModal.rff.event_name}</div>

            {actionModal.action === "approve" && (
              <div style={{ marginBottom: 20 }}>
                <div style={{ color: T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8, paddingBottom: 6, borderBottom: `1px solid ${T.cyan}30` }}>Proposed Budget Template</div>
                <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 10 }}>Add budget line items for this RFF. These will be used to compare vendor quotes.</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 32px", gap: 8, marginBottom: 6 }}>
                  {["Category",`Proposed Amount (${getCurrency(actionModal?.rff?.country||activeCountry||"Ghana")})`,"Notes",""].map((h,i) => (
                    <div key={i} style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</div>
                  ))}
                </div>
                {budgetLines.map((line, idx) => (
                  <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 32px", gap: 8, marginBottom: 8 }}>
                    <select value={line.category} onChange={e => { const l = [...budgetLines]; l[idx].category = e.target.value; setBudgetLines(l); }} style={{ padding: "7px 10px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: line.category ? T.textPrimary : T.textMuted, fontSize: 12, fontFamily: "inherit", outline: "none" }}>
                      <option value="">Select category...</option>
                      {["Event Lighting","Events Ushering","Photography","Videography","Catering","Entertainment Provider (MC, DJ, Live Band, Performers)","Event Decor","Event Production Company","Event Refreshment","Furniture & Equipment Rental","Gift & Merchandise Supplier","Health & Safety Provider","Printing Company","Registration & Badging Service","Security Service","Technology Provider","Transportation (Shuttle, Car Rental)","Venue Provider","Other"].map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                    <input type="number" value={line.proposed_amount} onChange={e => { const l = [...budgetLines]; l[idx].proposed_amount = e.target.value; setBudgetLines(l); }} placeholder="0.00" style={{ padding: "7px 10px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                    <input value={line.notes} onChange={e => { const l = [...budgetLines]; l[idx].notes = e.target.value; setBudgetLines(l); }} placeholder="Notes..." style={{ padding: "7px 10px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                    <button onClick={() => setBudgetLines(budgetLines.filter((_,i) => i !== idx))} style={{ background: T.red+"18", border: `1px solid ${T.red}30`, color: T.red, borderRadius: 6, cursor: "pointer", fontSize: 14, fontWeight: 700 }}>×</button>
                  </div>
                ))}
                <button onClick={() => setBudgetLines([...budgetLines, { category: "", proposed_amount: "", notes: "" }])} style={{ background: "none", border: `1px dashed ${T.border}`, color: T.textMuted, padding: "6px 16px", borderRadius: 6, cursor: "pointer", fontSize: 12, width: "100%", marginTop: 4 }}>+ Add Line Item</button>
              </div>
            )}

            <div style={{ marginBottom: 16 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>{actionModal.action === "approve" ? "Approval Notes (optional)" : "Reason for Decline *"}</label>
              <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={3} placeholder="Add notes..." style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box", resize: "vertical" }} />
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              {actionModal.action === "approve" ? (
                <button onClick={() => handleApprove(actionModal.rff)} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.teal}, #10B981)`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Approving..." : " Approve & Send Budget"}</button>
              ) : (
                <button onClick={() => handleDecline(actionModal.rff)} disabled={saving} style={{ background: T.red+"18", border: `1px solid ${T.red}40`, color: T.red, padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Declining..." : " Decline RFF"}</button>
              )}
              <button onClick={() => setActionModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

//  VENDOR ASSIGNMENT TAB 

const VendorApplicationModal = ({ user, onClose, onSubmitted }) => {
  const [form, setForm] = useState({
    vendor_name: "", vendor_type: "", contact_person: "", contact_email: "",
    phone: "", address: "", country: "", bank_name: "", bank_address: "",
    bank_account_name: "", account_no: "", swift_code: "", bank_phone: "",
    bank_email: "", payment_terms: "", form_completed_by: "", position_in_company: "",
    signature: "", date_submitted: new Date().toISOString().slice(0,10),
  });
  const [busRegFile, setBusRegFile] = useState(null);
  const [vatFile, setVatFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const busRegRef = React.useRef();
  const vatRef = React.useRef();

  const vendorTypes = ["Event Lighting","Events Ushering","Photography","Videography","Catering","Entertainment Provider (MC, DJ, Live Band, Performers)","Event Decor","Event Production Company","Event Refreshment","Furniture & Equipment Rental","Gift & Merchandise Supplier","Health & Safety Provider","Printing Company","Registration & Badging Service","Security Service","Technology Provider","Transportation (Shuttle, Car Rental)","Venue Provider","Other"];

  const inputStyle = { width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };
  const labelStyle = { color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 };
  const sectionStyle = { color: T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 12, marginTop: 20, paddingBottom: 6, borderBottom: `1px solid ${T.cyan}30` };

  const uploadFile = async (file, bucket) => {
    if (!file) return null;
    const ext = file.name.split(".").pop();
    const filename = `${bucket}_${Date.now()}.${ext}`;
    const { error } = await supabase.storage.from("vendor-docs").upload(filename, file, { upsert: true });
    if (error) return null;
    const { data } = supabase.storage.from("vendor-docs").getPublicUrl(filename);
    return data.publicUrl;
  };

  const handleSubmit = async () => {
    if (!form.vendor_name || !form.contact_email || !form.contact_person) {
      setError("Please fill in Vendor Name, Contact Person and Email.");
      return;
    }
    setSaving(true);
    setError("");

    const busRegUrl = await uploadFile(busRegFile, "bus_reg");
    const vatUrl = await uploadFile(vatFile, "vat");

    const { error: insErr } = await supabase.from("vendor_applications").insert({
      ...form,
      business_reg_url: busRegUrl,
      vat_cert_url: vatUrl,
      submitted_by: user.id,
      status: "pending",
    });

    if (insErr) { setError("Submit failed: " + insErr.message); setSaving(false); return; }

    // Notify CEO
    const { data: ceos } = await supabase.from("profiles").select("id, email, name").eq("role", "CEO");
    for (const ceo of ceos || []) {
      await supabase.from("notifications").insert({
        user_id: ceo.id,
        title: "New Vendor Application",
        message: `${form.vendor_name} has been submitted for approval by ${user.name}.`,
        type: "task",
      });
      if (ceo.email) await sendEmail(ceo.email, `New Vendor Application — ${form.vendor_name}`, notifEmailHtml({ name: ceo.name, title: "New Vendor Application", message: `<strong>${form.vendor_name}</strong> has been submitted for approval by ${user.name}. Please log in to review the application.`, actionUrl: BASE_URL, actionLabel: "Review Application" }));
    }

    setSaving(false);
    onSubmitted();
  };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.8)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={onClose}>
      <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 700, maxHeight: "90vh", overflow: "auto", padding: 28, boxShadow: "0 24px 80px rgba(0,0,0,0.5)" }} onClick={e => e.stopPropagation()}>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 4 }}>Vendor Onboarding</div>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 20 }}>New Vendor Application</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, width: 32, height: 32, borderRadius: 8, cursor: "pointer", fontSize: 18 }}>×</button>
        </div>

        {/* Vendor Info */}
        <div style={sectionStyle}>Vendor Information</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Vendor Name *</label><input value={form.vendor_name} onChange={e => setForm({...form, vendor_name: e.target.value})} style={inputStyle} placeholder="Company / Vendor name" /></div>
          <div><label style={labelStyle}>Vendor Type</label>
            <select value={form.vendor_type} onChange={e => setForm({...form, vendor_type: e.target.value})} style={inputStyle}>
              <option value="">Select type...</option>
              {vendorTypes.map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Contact Person *</label><input value={form.contact_person} onChange={e => setForm({...form, contact_person: e.target.value})} style={inputStyle} placeholder="Full name" /></div>
          <div><label style={labelStyle}>Contact Email *</label><input type="email" value={form.contact_email} onChange={e => setForm({...form, contact_email: e.target.value})} style={inputStyle} placeholder="email@company.com" /></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Phone Number</label><input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} style={inputStyle} placeholder="+233 XX XXX XXXX" /></div>
          <div><label style={labelStyle}>Country *</label>
            <select value={form.country} onChange={e => setForm({...form, country: e.target.value})} style={inputStyle}>
              <option value="">Select country...</option>
              <option value="Ghana">Ghana</option>
              <option value="Nigeria">Nigeria</option>
            </select>
          </div>
        </div>
        <div style={{ marginBottom: 14 }}><label style={labelStyle}>Address</label><textarea value={form.address} onChange={e => setForm({...form, address: e.target.value})} rows={2} style={{...inputStyle, resize: "vertical"}} placeholder="Full address" /></div>

        {/* Documents */}
        <div style={sectionStyle}>Documents</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div>
            <label style={labelStyle}>Business Registration Certificate</label>
            <div onClick={() => busRegRef.current.click()} style={{ border: `2px dashed ${T.border}`, borderRadius: 8, padding: "14px", textAlign: "center", cursor: "pointer", background: T.bg }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.cyan + "60"}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.border}>
              <div style={{ color: T.textMuted, fontSize: 12 }}>{busRegFile ? ` ${busRegFile.name}` : "Drop file here or browse"}</div>
            </div>
            <input ref={busRegRef} type="file" onChange={e => setBusRegFile(e.target.files[0])} style={{ display: "none" }} />
          </div>
          <div>
            <label style={labelStyle}>VAT Certificate (if any)</label>
            <div onClick={() => vatRef.current.click()} style={{ border: `2px dashed ${T.border}`, borderRadius: 8, padding: "14px", textAlign: "center", cursor: "pointer", background: T.bg }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.cyan + "60"}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.border}>
              <div style={{ color: T.textMuted, fontSize: 12 }}>{vatFile ? ` ${vatFile.name}` : "Drop file here or browse"}</div>
            </div>
            <input ref={vatRef} type="file" onChange={e => setVatFile(e.target.files[0])} style={{ display: "none" }} />
          </div>
        </div>

        {/* Bank Details */}
        <div style={sectionStyle}>Bank Details</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Bank Name</label><input value={form.bank_name} onChange={e => setForm({...form, bank_name: e.target.value})} style={inputStyle} placeholder="Bank name" /></div>
          <div><label style={labelStyle}>Bank Account Name</label><input value={form.bank_account_name} onChange={e => setForm({...form, bank_account_name: e.target.value})} style={inputStyle} placeholder="Account name" /></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Account Number</label><input value={form.account_no} onChange={e => setForm({...form, account_no: e.target.value})} style={inputStyle} placeholder="Account number" /></div>
          <div><label style={labelStyle}>Swift Code</label><input value={form.swift_code} onChange={e => setForm({...form, swift_code: e.target.value})} style={inputStyle} placeholder="SWIFT/BIC code" /></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Bank Address</label><input value={form.bank_address} onChange={e => setForm({...form, bank_address: e.target.value})} style={inputStyle} placeholder="Bank branch address" /></div>
          <div><label style={labelStyle}>Bank Telephone</label><input value={form.bank_phone} onChange={e => setForm({...form, bank_phone: e.target.value})} style={inputStyle} placeholder="+233 XX XXX XXXX" /></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Bank Email</label><input value={form.bank_email} onChange={e => setForm({...form, bank_email: e.target.value})} style={inputStyle} placeholder="bank@email.com" /></div>
          <div><label style={labelStyle}>Payment Terms</label><input value={form.payment_terms} onChange={e => setForm({...form, payment_terms: e.target.value})} style={inputStyle} placeholder="e.g. Net 30, 50% upfront" /></div>
        </div>



        {error && <div style={{ color: T.red, fontSize: 12, marginBottom: 12, padding: "8px 12px", background: T.red + "12", borderRadius: 8 }}>{error}</div>}

        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={handleSubmit} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "11px 28px", borderRadius: 8, cursor: saving ? "not-allowed" : "pointer", fontWeight: 800, fontSize: 13, opacity: saving ? 0.7 : 1 }}>{saving ? "Submitting..." : "Submit for CEO Approval"}</button>
          <button onClick={onClose} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "11px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

const VendorApprovalsPanel = ({ user, onLoginCreated }) => {
  const [apps, setApps] = useState([]);
  const [previewApp, setPreviewApp] = useState(null);
  const [loginModal, setLoginModal] = useState(null);
  const [declineModal, setDeclineModal] = useState(null);
  const [ceoNotes, setCeoNotes] = useState("");
  const [password, setPassword] = useState("");
  const [vendorPresence, setVendorPresence] = useState("GH");
  const [saving, setSaving] = useState(false);
  const [createdCreds, setCreatedCreds] = useState(null);

  const load = async () => {
    const [{ data: appData }, { data: vpData }] = await Promise.all([
      supabase.from("vendor_applications").select("*").order("created_at", { ascending: false }),
      supabase.from("profiles").select("*").eq("role", "Vendor").order("name"),
    ]);
    setApps(appData || []);
    setVendorProfiles(vpData || []);
  };

  useEffect(() => { load(); }, []);

  const handleApprove = async (app) => {
    await supabase.from("vendor_applications").update({ status: "approved", approved_by: user.id }).eq("id", app.id);
    // Notify vendor manager who submitted
    if (app.submitted_by) {
      await supabase.from("notifications").insert({
        user_id: app.submitted_by,
        title: "Vendor Application Approved",
        message: `${app.vendor_name} has been approved by the CEO. You can now create their login.`,
        type: "task",
      });
    }
    setPreviewApp(null);
    load();
  };

  const handleDecline = async () => {
    if (!ceoNotes.trim()) { alert("Please add notes explaining the decline reason."); return; }
    setSaving(true);
    await supabase.from("vendor_applications").update({ status: "declined", ceo_notes: ceoNotes }).eq("id", declineModal.id);
    // Notify vendor manager
    if (declineModal.submitted_by) {
      await supabase.from("notifications").insert({
        user_id: declineModal.submitted_by,
        title: "Vendor Application Declined",
        message: `${declineModal.vendor_name} was declined. CEO notes: ${ceoNotes.slice(0, 100)}`,
        type: "task",
      });
    }
    setSaving(false);
    setDeclineModal(null);
    setCeoNotes("");
    setPreviewApp(null);
    load();
  };

  const handleCreateLogin = async () => {
    if (!password || password.length < 8) { alert("Password must be at least 8 characters."); return; }
    setSaving(true);
    const app = loginModal;
    const { data: { session } } = await supabase.auth.getSession();
    const res = await fetch("https://okbduzenceoknkjqnrha.supabase.co/functions/v1/create-vendor-login", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token}` },
      body: JSON.stringify({
        email: app.contact_email, password,
        name: app.vendor_name, phone: app.phone,
        company_name: app.vendor_name, service_category: app.vendor_type,
        application_id: app.id,
      }),
    });
    const result = await res.json();
    if (result.error) { alert("Failed: " + result.error); setSaving(false); return; }
    setCreatedCreds({ email: app.contact_email, password });
    // Send welcome email to vendor
    await sendEmail(
      app.contact_email,
      "Welcome to Stretchfield WorkRoom — Your Vendor Portal Access",
      welcomeEmailHtml({ name: app.vendor_name, email: app.contact_email, password, role: "Vendor" })
    );
    setLoginModal(null);
    setSaving(false);
    load();
    if (onLoginCreated) onLoginCreated();
  };

  const statusColor = { pending: T.amber, approved: T.teal, declined: T.red, "login-created": "#10B981" };
  const statusLabel = { pending: "Pending Review", approved: "Approved", declined: "Declined", "login-created": "Login Created" };

  const FieldRow = ({ label, value }) => value ? (
    <div style={{ display: "grid", gridTemplateColumns: "160px 1fr", gap: 8, padding: "7px 0", borderBottom: `1px solid ${T.border}44` }}>
      <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em" }}>{label}</div>
      <div style={{ color: T.textPrimary, fontSize: 12 }}>{value}</div>
    </div>
  ) : null;

  return (
    <div>
      {createdCreds && (
        <div style={{ background: T.teal + "15", border: `1px solid ${T.teal}40`, borderRadius: 10, padding: "14px 18px", marginBottom: 20 }}>
          <div style={{ color: T.teal, fontWeight: 800, fontSize: 14, marginBottom: 8 }}> Vendor Login Created</div>
          <div style={{ color: T.textPrimary, fontSize: 13 }}>Email: <strong>{createdCreds.email}</strong></div>
          <div style={{ color: T.textPrimary, fontSize: 13 }}>Password: <strong>{createdCreds.password}</strong></div>
          <div style={{ color: T.textMuted, fontSize: 11, marginTop: 6 }}>Share these credentials with the vendor securely.</div>
          <button onClick={() => setCreatedCreds(null)} style={{ marginTop: 8, background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "4px 12px", borderRadius: 6, cursor: "pointer", fontSize: 11 }}>Dismiss</button>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {apps.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: 30 }}>No vendor applications yet.</div>}
        {apps.map(app => (
          <div key={app.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderLeft: `3px solid ${statusColor[app.status] || T.textMuted}`, borderRadius: 10, padding: "14px 18px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div style={{ flex: 1 }}>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>{app.vendor_name}</div>
                <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{app.vendor_type} · {app.contact_person} · {app.contact_email}</div>
                <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{app.country} · Submitted {new Date(app.created_at).toLocaleDateString("en-GB")}</div>
                {app.ceo_notes && app.status === "declined" && (
                  <div style={{ marginTop: 8, padding: "8px 10px", background: T.red + "12", border: `1px solid ${T.red}30`, borderRadius: 6 }}>
                    <div style={{ color: T.red, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>CEO Notes</div>
                    <div style={{ color: T.textSecondary, fontSize: 12 }}>{app.ceo_notes}</div>
                  </div>
                )}
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8, marginLeft: 12 }}>
                <span style={{ background: (statusColor[app.status] || T.textMuted) + "18", color: statusColor[app.status] || T.textMuted, border: `1px solid ${(statusColor[app.status] || T.textMuted)}30`, borderRadius: 20, padding: "3px 12px", fontSize: 10, fontWeight: 800, textTransform: "uppercase" }}>{statusLabel[app.status] || app.status}</span>
                <button onClick={() => setPreviewApp(app)} style={{ background: T.cyan + "15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "5px 14px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>Preview Form</button>
              </div>
            </div>
            {user?.role === "CEO" && (
              <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
                {app.status === "pending" && (
                  <>
                    <button onClick={() => handleApprove(app)} style={{ background: T.teal + "18", border: `1px solid ${T.teal}40`, color: T.teal, padding: "6px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Approve</button>
                    <button onClick={() => { setDeclineModal(app); setCeoNotes(""); }} style={{ background: T.red + "18", border: `1px solid ${T.red}40`, color: T.red, padding: "6px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Decline with Notes</button>
                  </>
                )}
                {app.status === "approved" && (
                  <button onClick={() => { setLoginModal(app); setPassword(generatePassword(app.contact_email || "")); }} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "6px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Create Login</button>
                )}
                {app.status === "login-created" && <span style={{ color: "#10B981", fontSize: 12, fontWeight: 700 }}> Portal access granted</span>}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Preview Modal */}
      {previewApp && (
        <div style={{ position: "fixed", inset: 0, zIndex: 700, background: "rgba(0,0,0,0.8)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setPreviewApp(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 680, maxHeight: "90vh", overflow: "auto", padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
              <div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 4 }}>Vendor Application</div>
                <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 20 }}>{previewApp.vendor_name}</div>
                <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>Submitted {new Date(previewApp.created_at).toLocaleDateString("en-GB")}</div>
              </div>
              <button onClick={() => setPreviewApp(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, width: 32, height: 32, borderRadius: 8, cursor: "pointer", fontSize: 18, display:"flex", alignItems:"center", justifyContent:"center" }}>×</button>
            </div>

            {/* Vendor Info */}
            <div style={{ color: T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 10, paddingBottom: 6, borderBottom: `1px solid ${T.cyan}30` }}>Vendor Information</div>
            <FieldRow label="Vendor Name" value={previewApp.vendor_name} />
            <FieldRow label="Vendor Type" value={previewApp.vendor_type} />
            <FieldRow label="Contact Person" value={previewApp.contact_person} />
            <FieldRow label="Contact Email" value={previewApp.contact_email} />
            <FieldRow label="Phone" value={previewApp.phone} />
            <FieldRow label="Address" value={previewApp.address} />
            <FieldRow label="Country" value={previewApp.country} />

            {/* Documents */}
            <div style={{ color: T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", margin: "16px 0 10px", paddingBottom: 6, borderBottom: `1px solid ${T.cyan}30` }}>Documents</div>
            <div style={{ display: "flex", gap: 12, marginBottom: 8 }}>
              {previewApp.business_reg_url ? <a href={previewApp.business_reg_url} target="_blank" rel="noopener noreferrer" style={{ color: T.cyan, fontSize: 12, fontWeight: 700 }}> Business Registration</a> : <span style={{ color: T.textMuted, fontSize: 12 }}>No business registration uploaded</span>}
              {previewApp.vat_cert_url && <a href={previewApp.vat_cert_url} target="_blank" rel="noopener noreferrer" style={{ color: T.cyan, fontSize: 12, fontWeight: 700 }}> VAT Certificate</a>}
            </div>

            {/* Bank Details */}
            <div style={{ color: T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", margin: "16px 0 10px", paddingBottom: 6, borderBottom: `1px solid ${T.cyan}30` }}>Bank Details</div>
            <FieldRow label="Bank Name" value={previewApp.bank_name} />
            <FieldRow label="Account Name" value={previewApp.bank_account_name} />
            <FieldRow label="Account Number" value={previewApp.account_no} />
            <FieldRow label="Swift Code" value={previewApp.swift_code} />
            <FieldRow label="Bank Address" value={previewApp.bank_address} />
            <FieldRow label="Bank Phone" value={previewApp.bank_phone} />
            <FieldRow label="Bank Email" value={previewApp.bank_email} />
            <FieldRow label="Payment Terms" value={previewApp.payment_terms} />

            {/* CEO Notes if declined */}
            {previewApp.ceo_notes && (
              <div style={{ marginTop: 16, padding: "12px 14px", background: T.red + "12", border: `1px solid ${T.red}30`, borderRadius: 8 }}>
                <div style={{ color: T.red, fontSize: 11, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>CEO Decline Notes</div>
                <div style={{ color: T.textSecondary, fontSize: 13 }}>{previewApp.ceo_notes}</div>
              </div>
            )}

            {/* Action buttons in preview */}
            {user?.role === "CEO" && previewApp.status === "pending" && (
              <div style={{ display: "flex", gap: 10, marginTop: 20, paddingTop: 16, borderTop: `1px solid ${T.border}` }}>
                <button onClick={() => handleApprove(previewApp)} style={{ background: `linear-gradient(135deg, ${T.teal}, #10B981)`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}> Approve</button>
                <button onClick={() => { setDeclineModal(previewApp); setCeoNotes(""); setPreviewApp(null); }} style={{ background: T.red + "18", border: `1px solid ${T.red}40`, color: T.red, padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 13 }}> Decline with Notes</button>
                <button onClick={() => setPreviewApp(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Close</button>
              </div>
            )}
            {user?.role === "CEO" && previewApp.status === "approved" && (
              <div style={{ display: "flex", gap: 10, marginTop: 20, paddingTop: 16, borderTop: `1px solid ${T.border}` }}>
                <button onClick={() => { setLoginModal(previewApp); setPassword(generatePassword(previewApp.contact_email || "")); setPreviewApp(null); }} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}> Create Login</button>
                <button onClick={() => setPreviewApp(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Close</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Decline with Notes Modal */}
      {declineModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 800, background: "rgba(0,0,0,0.8)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setDeclineModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.red}30`, borderRadius: 16, padding: 28, width: "100%", maxWidth: 480 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Decline Application</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>{declineModal.vendor_name} — Add notes for the Vendor Manager</div>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Reason / Notes *</label>
            <textarea value={ceoNotes} onChange={e => setCeoNotes(e.target.value)} rows={4} placeholder="Explain what needs to be corrected or why this is being declined..." style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box", resize: "vertical", marginBottom: 20 }} />
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleDecline} disabled={saving || !ceoNotes.trim()} style={{ background: `linear-gradient(135deg, ${T.red}, #C0192A)`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13, opacity: !ceoNotes.trim() ? 0.5 : 1 }}>{saving ? "Declining..." : "Decline & Notify"}</button>
              <button onClick={() => setDeclineModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Create Login Modal */}
      {loginModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 700, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => setLoginModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, padding: 28, width: 400 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Create Vendor Login</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>{loginModal.vendor_name} · {loginModal.contact_email}</div>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Password</label>
            <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
              <input type="text" value={password} onChange={e => setPassword(e.target.value)} placeholder="Auto-generated from email" style={{ flex: 1, padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }} />
              <button onClick={() => setPassword(generatePassword(loginModal.contact_email || ""))} style={{ background: T.cyan+"15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "9px 14px", borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}> Generate</button>
            </div>
            {password && <div style={{ color: T.teal, fontSize: 11, marginBottom: 16 }}> Password will be emailed to vendor on login creation</div>}
            {!password && <div style={{ color: T.amber, fontSize: 11, marginBottom: 16 }}>Click Generate to auto-create from vendor email</div>}
            <div style={{ marginBottom: 16 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Country Presence</label>
              <select value={vendorPresence} onChange={e => setVendorPresence(e.target.value)} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
                <option value="GH">🇬🇭 Ghana Only</option>
                <option value="NG">🇳🇬 Nigeria Only</option>
                <option value="GH+NG">🇬🇭 Ghana + 🇳🇬 Nigeria</option>
                <option value="GH+NG+KE">🇬🇭 Ghana + 🇳🇬 Nigeria + 🇰🇪 Kenya</option>
              </select>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleCreateLogin} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Creating..." : "Create Login"}</button>
              <button onClick={() => setLoginModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};



const EditVendorAppModal = ({ app, user, onClose, onResubmitted }) => {
  const [form, setForm] = useState({
    vendor_name: app.vendor_name || "",
    vendor_type: app.vendor_type || "",
    contact_person: app.contact_person || "",
    contact_email: app.contact_email || "",
    phone: app.phone || "",
    address: app.address || "",
    country: app.country || "",
    bank_name: app.bank_name || "",
    bank_address: app.bank_address || "",
    bank_account_name: app.bank_account_name || "",
    account_no: app.account_no || "",
    swift_code: app.swift_code || "",
    bank_phone: app.bank_phone || "",
    bank_email: app.bank_email || "",
    payment_terms: app.payment_terms || "",
  });
  const [saving, setSaving] = useState(false);

  const vendorTypes = ["Event Lighting","Events Ushering","Photography","Videography","Catering","Entertainment Provider (MC, DJ, Live Band, Performers)","Event Decor","Event Production Company","Event Refreshment","Furniture & Equipment Rental","Gift & Merchandise Supplier","Health & Safety Provider","Printing Company","Registration & Badging Service","Security Service","Technology Provider","Transportation (Shuttle, Car Rental)","Venue Provider","Other"];
  const inputStyle = { width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };
  const labelStyle = { color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 };
  const sectionStyle = { color: T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 12, marginTop: 20, paddingBottom: 6, borderBottom: `1px solid ${T.cyan}30` };

  const handleResubmit = async () => {
    setSaving(true);
    await supabase.from("vendor_applications").update({
      ...form,
      status: "pending",
      ceo_notes: null,
    }).eq("id", app.id);

    // Notify CEO
    const { data: ceos } = await supabase.from("profiles").select("id").eq("role", "CEO");
    for (const ceo of ceos || []) {
      await supabase.from("notifications").insert({
        user_id: ceo.id,
        title: "Vendor Application Resubmitted",
        message: `${form.vendor_name} application has been updated and resubmitted for approval.`,
        type: "task",
      });
    }
    setSaving(false);
    onResubmitted();
  };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 700, background: "rgba(0,0,0,0.8)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={onClose}>
      <div style={{ background: T.surface, border: `1px solid ${T.amber}40`, borderRadius: 16, width: "100%", maxWidth: 700, maxHeight: "90vh", overflow: "auto", padding: 28 }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
          <div>
            <div style={{ color: T.amber, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 4 }}>Edit & Resubmit</div>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 20 }}>{app.vendor_name}</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, width: 32, height: 32, borderRadius: 8, cursor: "pointer", fontSize: 18 }}>×</button>
        </div>

        {/* CEO Notes */}
        {app.ceo_notes && (
          <div style={{ background: T.red + "10", border: `1px solid ${T.red}30`, borderRadius: 8, padding: "12px 14px", marginBottom: 20 }}>
            <div style={{ color: T.red, fontSize: 11, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>CEO Feedback — Please address before resubmitting</div>
            <div style={{ color: T.textSecondary, fontSize: 13 }}>{app.ceo_notes}</div>
          </div>
        )}

        {/* Vendor Info */}
        <div style={sectionStyle}>Vendor Information</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Vendor Name</label><input value={form.vendor_name} onChange={e => setForm({...form, vendor_name: e.target.value})} style={inputStyle} /></div>
          <div><label style={labelStyle}>Vendor Type</label>
            <select value={form.vendor_type} onChange={e => setForm({...form, vendor_type: e.target.value})} style={inputStyle}>
              <option value="">Select type...</option>
              {vendorTypes.map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Contact Person</label><input value={form.contact_person} onChange={e => setForm({...form, contact_person: e.target.value})} style={inputStyle} /></div>
          <div><label style={labelStyle}>Contact Email</label><input value={form.contact_email} onChange={e => setForm({...form, contact_email: e.target.value})} style={inputStyle} /></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Phone</label><input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} style={inputStyle} /></div>
          <div><label style={labelStyle}>Country</label><input value={form.country} onChange={e => setForm({...form, country: e.target.value})} style={inputStyle} /></div>
        </div>
        <div style={{ marginBottom: 14 }}><label style={labelStyle}>Address</label><textarea value={form.address} onChange={e => setForm({...form, address: e.target.value})} rows={2} style={{...inputStyle, resize: "vertical"}} /></div>

        {/* Bank Details */}
        <div style={sectionStyle}>Bank Details</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Bank Name</label><input value={form.bank_name} onChange={e => setForm({...form, bank_name: e.target.value})} style={inputStyle} /></div>
          <div><label style={labelStyle}>Account Name</label><input value={form.bank_account_name} onChange={e => setForm({...form, bank_account_name: e.target.value})} style={inputStyle} /></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Account Number</label><input value={form.account_no} onChange={e => setForm({...form, account_no: e.target.value})} style={inputStyle} /></div>
          <div><label style={labelStyle}>Swift Code</label><input value={form.swift_code} onChange={e => setForm({...form, swift_code: e.target.value})} style={inputStyle} /></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
          <div><label style={labelStyle}>Bank Address</label><input value={form.bank_address} onChange={e => setForm({...form, bank_address: e.target.value})} style={inputStyle} /></div>
          <div><label style={labelStyle}>Payment Terms</label><input value={form.payment_terms} onChange={e => setForm({...form, payment_terms: e.target.value})} style={inputStyle} /></div>
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 24 }}>
          <button onClick={handleResubmit} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.amber}, ${T.amber})`, border: "none", color: "#fff", padding: "11px 28px", borderRadius: 8, cursor: saving ? "not-allowed" : "pointer", fontWeight: 800, fontSize: 13, opacity: saving ? 0.7 : 1 }}>{saving ? "Resubmitting..." : "Resubmit for Approval"}</button>
          <button onClick={onClose} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "11px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

const ApprovedVendorsTab = ({ apps, user, load }) => {
  const [loginModal, setLoginModal] = React.useState(null);
  const [loginPwd, setLoginPwd] = React.useState("");
  const [loginSaving, setLoginSaving] = React.useState(false);
  const [loginSuccess, setLoginSuccess] = React.useState("");
  const [editModal, setEditModal] = React.useState(null);
  const [editForm, setEditForm] = React.useState({});
  const [savingEdit, setSavingEdit] = React.useState(false);
  const pendingApps = apps.filter(a => a.status === "pending");
  const approvedApps = apps.filter(a => ["approved","login-created"].includes(a.status));
  const VTYPES = ["Event Lighting","Events Ushering","Photography","Videography","Catering","Entertainment Provider (MC, DJ, Live Band, Performers)","Event Decor","Event Production Company","Event Refreshment","Furniture & Equipment Rental","Gift & Merchandise Supplier","Health & Safety Provider","Printing Company","Registration & Badging Service","Security Service","Technology Provider","Transportation (Shuttle, Car Rental)","Venue Provider","Other"];

  const PAYMENT_TERMS = [
    "50% Upfront, balance after event",
    "50% upfront",
    "60% Upfront Payment",
    "70% down payment",
    "80% upfront",
    "Full payment upfront",
    "30 days",
    "50% paid before event, balance paid after event",
    "Other",
  ];

  const saveEdit = async () => {
    if (!editModal) return;
    setSavingEdit(true);
    // Update vendor_applications using the app ID
    const { error: appError } = await supabase.from("vendor_applications").update({
      vendor_name: editForm.vendor_name,
      vendor_type: editForm.vendor_type,
      phone: editForm.phone,
      contact_person: editForm.contact_person,
      contact_email: editForm.contact_email,
      bank_name: editForm.bank_name,
      bank_account_name: editForm.bank_account_name,
      account_no: editForm.account_number,
      payment_terms: editForm.payment_terms,
      address: editForm.address,
      presence: editForm.presence || "GH",
    }).eq("id", editModal.id);
    if (appError) { alert("Save failed: " + appError.message); setSavingEdit(false); return; }
    // Update profiles using the original email (before any email change)
    const { data: profile } = await supabase.from("profiles").select("id").eq("email", editModal.contact_email).maybeSingle();
    if (profile) {
      await supabase.from("profiles").update({
        name: editForm.vendor_name,
        company_name: editForm.vendor_name,
        phone: editForm.phone,
        service_category: editForm.vendor_type,
        presence: editForm.presence || "GH",
        email: editForm.contact_email,
      }).eq("id", profile.id);
    }
    setSavingEdit(false);
    setEditModal(null);
    if (load) load();
    alert("Vendor updated successfully.");
  };

  return (
    <div>
      <div style={{ color: T.textMuted, fontSize: 13, marginBottom: 16 }}>
        {approvedApps.length === 0 ? "No approved vendors yet. CEO will approve your submissions." : `${approvedApps.length} approved vendor${approvedApps.length !== 1 ? "s" : ""}`}
      </div>
      {/* Pending CEO Approval */}
      {pendingApps.length > 0 && (
        <div style={{ marginBottom:20 }}>
          <div style={{ color:T.amber, fontWeight:800, fontSize:14, marginBottom:10 }}>{pendingApps.length} Pending Your Approval</div>
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {pendingApps.map(app => (
              <div key={app.id} style={{ background:T.surface, border:`1px solid ${T.amber}30`, borderLeft:`3px solid ${T.amber}`, borderRadius:10, padding:"16px 18px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15 }}>{app.vendor_name}</div>
                    <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{app.vendor_type} · {app.contact_person} · {app.contact_email}</div>
                    <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{app.country} · Submitted {new Date(app.created_at).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</div>
                  </div>
                  <span style={{ background:T.amber+"18", color:T.amber, border:`1px solid ${T.amber}30`, borderRadius:20, padding:"3px 12px", fontSize:10, fontWeight:800 }}>PENDING</span>
                </div>
                {app.bank_name && (
                  <div style={{ background:T.bg, borderRadius:8, padding:"10px 14px", marginBottom:10, display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8 }}>
                    <div><div style={{ color:T.textMuted, fontSize:10, fontWeight:700 }}>BANK</div><div style={{ color:T.textPrimary, fontSize:12 }}>{app.bank_name}</div></div>
                    <div><div style={{ color:T.textMuted, fontSize:10, fontWeight:700 }}>ACCOUNT NAME</div><div style={{ color:T.textPrimary, fontSize:12 }}>{app.bank_account_name||"—"}</div></div>
                    <div><div style={{ color:T.textMuted, fontSize:10, fontWeight:700 }}>ACCOUNT NO</div><div style={{ color:T.textPrimary, fontSize:12 }}>{app.account_no||"—"}</div></div>
                  </div>
                )}
                {(app.business_reg_url || app.vat_cert_url) && (
                  <div style={{ display:"flex", gap:8, marginBottom:10 }}>
                    {app.business_reg_url && <a href={app.business_reg_url} target="_blank" rel="noreferrer" style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"5px 12px", borderRadius:8, fontSize:11, fontWeight:700, textDecoration:"none" }}>View Business Reg</a>}
                    {app.vat_cert_url && <a href={app.vat_cert_url} target="_blank" rel="noreferrer" style={{ background:T.teal+"15", border:`1px solid ${T.teal}30`, color:T.teal, padding:"5px 12px", borderRadius:8, fontSize:11, fontWeight:700, textDecoration:"none" }}>View VAT Certificate</a>}
                  </div>
                )}
                <div style={{ display:"flex", gap:8 }}>
                  <button onClick={async () => {
                    await supabase.from("vendor_applications").update({ status:"approved", approved_by:user?.id }).eq("id", app.id);
                    const { data: vms } = await supabase.from("profiles").select("id").eq("role","Vendor Manager");
                    for (const vm of vms||[]) {
                      await supabase.from("notifications").insert({ user_id:vm.id, title:"Vendor Approved — "+app.vendor_name, message:"CEO has approved "+app.vendor_name+". Please create their portal login.", type:"vendor_application", resource_id:app.id });
                    }
                    load();
                    alert(app.vendor_name + " approved! VM notified to create login.");
                  }} style={{ background:`linear-gradient(135deg,${T.teal},#10B981)`, border:"none", color:"#fff", padding:"8px 18px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:12 }}>Approve</button>
                  <button onClick={async () => {
                    const notes = window.prompt("Reason for declining:");
                    if (!notes) return;
                    await supabase.from("vendor_applications").update({ status:"declined", ceo_notes:notes }).eq("id", app.id);
                    load();
                  }} style={{ background:T.red+"15", border:`1px solid ${T.red}30`, color:T.red, padding:"8px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}>Decline</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {approvedApps.map(app => (
          <div key={app.id} style={{ background: T.surface, border: `1px solid ${app.status === "login-created" ? T.teal+"50" : T.amber+"50"}`, borderLeft: `3px solid ${app.status === "login-created" ? T.teal : T.amber}`, borderRadius: 10, padding: "16px 18px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>{app.vendor_name}</div>
                <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{app.vendor_type} · {app.contact_email}</div>
                <div style={{ color: T.textMuted, fontSize: 11, marginTop: 1 }}>{app.contact_person} · {app.phone}</div>
              </div>
              <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                <button onClick={() => { setEditModal(app); setEditForm({ vendor_name: app.vendor_name, vendor_type: app.vendor_type, phone: app.phone, contact_person: app.contact_person, contact_email: app.contact_email, bank_name: app.bank_name||"", bank_account_name: app.bank_account_name||"", account_number: app.account_no||"", payment_terms: app.payment_terms||"", address: app.address||"" }); }} style={{ background: T.amber+"15", border: `1px solid ${T.amber}30`, color: T.amber, borderRadius: 8, padding: "5px 12px", fontSize: 11, fontWeight: 700, cursor: "pointer" }}> Edit</button>
                {app.status === "login-created" ? (
                  <button onClick={() => { setLoginModal(app); setLoginPwd(generatePassword(app.contact_email || "")); setLoginSuccess("view"); }} style={{ background: T.teal+"18", border: `1px solid ${T.teal}40`, color: T.teal, borderRadius: 20, padding: "3px 12px", fontSize: 11, fontWeight: 700, cursor: "pointer" }}> Portal Active — View Login</button>
                ) : (
                  <button onClick={() => { setLoginModal(app); setLoginPwd(generatePassword(app.contact_email || "")); setLoginSuccess(""); }} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "7px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Create Login</button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {editModal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.75)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setEditModal(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.amber}30`, borderRadius:16, width:"100%", maxWidth:520, maxHeight:"85vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Edit Vendor — {editModal.vendor_name}</div>
            <div style={{ color:T.textMuted, fontSize:12, marginBottom:20 }}>{editModal.contact_email}</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              {[["Vendor Name","vendor_name"],["Phone","phone"],["Contact Person","contact_person"],["Contact Email","contact_email"],["Bank Name","bank_name"],["Account Name","bank_account_name"],["Account Number","account_number"],["Address","address"]].map(([label,key]) => (
                <div key={key}>
                  <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>{label}</div>
                  <input value={editForm[key]||""} onChange={e=>setEditForm(f=>({...f,[key]:e.target.value}))}
                    style={{ width:"100%", padding:"8px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                </div>
              ))}
              <div>
                <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Payment Terms</div>
                <select value={editForm.payment_terms||""} onChange={e=>setEditForm(f=>({...f,payment_terms:e.target.value}))}
                  style={{ width:"100%", padding:"8px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">Select payment terms...</option>
                  {PAYMENT_TERMS.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
              <div>
                <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Service Category</div>
                <select value={editForm.vendor_type||""} onChange={e=>setEditForm(f=>({...f,vendor_type:e.target.value}))}
                  style={{ width:"100%", padding:"8px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {VTYPES.map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
              <div>
                <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Country Presence</div>
                <select value={editForm.presence||"GH"} onChange={e=>setEditForm(f=>({...f,presence:e.target.value}))}
                  style={{ width:"100%", padding:"8px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="GH">🇬🇭 Ghana Only</option>
                  <option value="NG">🇳🇬 Nigeria Only</option>
                  <option value="GH+NG">🇬🇭 Ghana + 🇳🇬 Nigeria</option>
                  <option value="GH+NG+KE">🇬🇭 Ghana + 🇳🇬 Nigeria + 🇰🇪 Kenya</option>
                </select>
              </div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={saveEdit} disabled={savingEdit} style={{ background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"10px 24px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{savingEdit?"Saving...":"Save Changes"}</button>
              <button onClick={() => setEditModal(null)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"10px 20px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {loginModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 700, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setLoginModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 480, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Create Vendor Portal Login</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 16 }}>{loginModal.vendor_name} · {loginModal.contact_email}</div>
            <div style={{ background: T.cyan+"12", border: `1px solid ${T.cyan}30`, borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: T.cyan }}>
              Login details will be sent to <strong>{loginModal.contact_email}</strong>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Password</label>
              <div style={{ display: "flex", gap: 8 }}>
                <input type="text" value={loginPwd} onChange={e => setLoginPwd(e.target.value)} style={{ flex: 1, padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }} />
                <button onClick={() => setLoginPwd(generatePassword(loginModal.contact_email || ""))} style={{ background: T.cyan+"15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "9px 14px", borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 700 }}> Generate</button>
              </div>
              {loginPwd && <div style={{ color: T.teal, fontSize: 11, marginTop: 5 }}> Will be emailed to vendor</div>}
            </div>
            {loginSuccess && <div style={{ color: T.teal, fontSize: 12, marginBottom: 12, padding: "8px 12px", background: T.teal+"12", borderRadius: 6 }}>{loginSuccess}</div>}
            {loginSuccess === "view" ? (
              <div>
                <div style={{ background: T.teal+"12", border: `1px solid ${T.teal}30`, borderRadius: 8, padding: "14px 16px", marginBottom: 14 }}>
                  <div style={{ color: T.teal, fontSize: 11, fontWeight: 800, textTransform: "uppercase", marginBottom: 10 }}>Login Details</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <div><span style={{ color: T.textMuted, fontSize: 11 }}>Email: </span><span style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{loginModal.contact_email}</span></div>
                    <div><span style={{ color: T.textMuted, fontSize: 11 }}>Password: </span><span style={{ color: T.cyan, fontWeight: 700, fontSize: 13, fontFamily: "monospace" }}>{loginPwd}</span></div>
                    <div style={{ color: T.textMuted, fontSize: 10, marginTop: 4 }}>Password shown is the auto-generated one. If vendor changed it, this may differ.</div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <button onClick={() => { navigator.clipboard.writeText("Email: " + loginModal.contact_email + "\nPassword: " + loginPwd); alert("Copied!"); }} style={{ background: T.cyan+"15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Copy Details</button>
                  <button onClick={() => setLoginModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>Close</button>
                </div>
              </div>
            ) : !loginSuccess ? (
              <div style={{ display: "flex", gap: 10 }}>
                <button onClick={async () => {
                  setLoginSaving(true);
                  const { data: { session } } = await supabase.auth.getSession();
                  const res = await fetch("https://okbduzenceoknkjqnrha.supabase.co/functions/v1/create-vendor-login", {
                    method: "POST",
                    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token}` },
                    body: JSON.stringify({ email: loginModal.contact_email, password: loginPwd, name: loginModal.vendor_name, role: "Vendor", company_name: loginModal.vendor_name, service_category: loginModal.vendor_type, application_id: loginModal.id, country: loginModal.country || activeCountry || "Ghana" }),
                  });
                  const result = await res.json();
                  if (result.error) { alert("Failed: " + result.error); setLoginSaving(false); return; }
                  await sendEmail(loginModal.contact_email, "Welcome to Stretchfield WorkRoom", welcomeEmailHtml({ name: loginModal.vendor_name, email: loginModal.contact_email, password: loginPwd, role: "Vendor" }));
                  setLoginSuccess("Portal login created. Login details sent to " + loginModal.contact_email);
                  setLoginSaving(false);
                  if (load) load();
                }} disabled={loginSaving || !loginPwd} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13, opacity: !loginPwd ? 0.6 : 1 }}>
                  {loginSaving ? "Creating..." : " Create Login & Send Email"}
                </button>
                <button onClick={() => setLoginModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
              </div>
            ) : (
              <button onClick={() => setLoginModal(null)} style={{ background: `linear-gradient(135deg, ${T.teal}, ${T.cyan})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>Done </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const VendorAssignmentPanel = ({ rffId, quoteDeadline }) => {
  const [vendors, setVendors] = React.useState([]);
  React.useEffect(() => {
    supabase.from("rff_vendor_assignments").select("*, profiles(name, email, service_category)").eq("rff_id", rffId).then(({ data }) => setVendors(data || []));
  }, [rffId]);
  if (vendors.length === 0) return null;
  return (
    <div style={{ marginTop: 12, background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 14px" }}>
      <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>
        Assigned Vendors ({vendors.length})
        {quoteDeadline && <span style={{ color: T.amber, marginLeft: 10, fontWeight: 700 }}> Quote Due: {new Date(quoteDeadline).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</span>}
      </div>
      {vendors.map(v => {
        const statusColors = { pending: T.textMuted, "quote-submitted": T.amber, "quote-approved": T.teal, "invoice-submitted": "#10B981" };
        const statusLabels = { pending: "Awaiting Quote", "quote-submitted": "Quote Submitted", "quote-approved": "Quote Approved", "invoice-submitted": "Invoice Submitted" };
        return (
          <div key={v.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: `1px solid ${T.border}33` }}>
            <div>
              <div style={{ color: T.textPrimary, fontSize: 12, fontWeight: 700 }}>{v.profiles?.name || "Unknown"}</div>
              <div style={{ color: T.textMuted, fontSize: 10 }}>{v.profiles?.service_category || v.profiles?.email}</div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {v.quote_amount && <span style={{ color: T.amber, fontSize: 12, fontWeight: 700 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(v.quote_amount).toLocaleString()).toLocaleString()}</span>}
              <span style={{ color: statusColors[v.status] || T.textMuted, fontSize: 10, fontWeight: 700, background: (statusColors[v.status] || T.textMuted)+"15", padding: "2px 8px", borderRadius: 20 }}>{statusLabels[v.status] || v.status}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const VendorOnboardingView = ({ user, activeCountry = "All" }) => {
  const getDefaultTab = () => {
    if (user?.role === "CEO") return "applications";
    if (user?.role === "Vendor Manager") return "external";
    return "form";
  };
  const [tab, setTab] = useState(getDefaultTab());
  const [apps, setApps] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [editApp, setEditApp] = useState(null);

  const load = async () => {
    const [{ data: appData }, { data: vpData }] = await Promise.all([
      supabase.from("vendor_applications").select("*").order("created_at", { ascending: false }),
      (!activeCountry || activeCountry === "All")
        ? supabase.from("profiles").select("*").eq("role", "Vendor").order("name")
        : supabase.from("profiles").select("*").eq("role", "Vendor").or(`country.eq.${activeCountry},presence.like.%${activeCountry}%`).order("name"),
    ]);
    setApps(appData || []);
    setVendorProfiles(vpData || []);
  };

  useEffect(() => { load(); }, []);

  const tabs = user?.role === "CEO"
    ? [{ id: "applications", label: "Applications" }, { id: "active-vendors", label: "Active Vendors" }]
    : user?.role === "Vendor Manager"
    ? [{ id: "external", label: "New Applications" }, { id: "form", label: "Add Vendor Manually" }, { id: "approved", label: "Approved — Create Login" }]
    : [{ id: "form", label: "New Vendor Form" }, { id: "submitted", label: "Submitted Applications" }];
  const [vendorProfiles, setVendorProfiles] = useState([]);
  const [editVendorModal, setEditVendorModal] = useState(null);
  const [editVendorForm, setEditVendorForm] = useState({});
  const [savingVendor, setSavingVendor] = useState(false);
  const VTYPES = ["Event Lighting","Events Ushering","Photography","Videography","Catering","Entertainment Provider (MC, DJ, Live Band, Performers)","Event Decor","Event Production Company","Event Refreshment","Furniture & Equipment Rental","Gift & Merchandise Supplier","Health & Safety Provider","Printing Company","Registration & Badging Service","Security Service","Technology Provider","Transportation (Shuttle, Car Rental)","Venue Provider","Other"];

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Procurement</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>
          {user?.role === "CEO" ? "Vendor Applications" : user?.role === "Vendor Manager" ? "Vendor Onboarding" : "Add New Vendor"}
        </h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>
          {user?.role === "CEO" ? `${apps.filter(a => a.status === "pending").length} pending approval` : user?.role === "Vendor Manager" ? `${apps.filter(a => a.submitted_by === user.id && a.status === "pending").length} pending · ${apps.filter(a => a.submitted_by === user.id && a.status === "approved").length} approved` : "Submit a new vendor for CEO approval"}
        </div>
      </div>

      {/* Tabs */}
      {tabs.length > 1 && (
        <div style={{ display: "flex", gap: 6, marginBottom: 20 }}>
          {tabs.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{
              padding: "6px 18px", borderRadius: 20, cursor: "pointer", fontSize: 11, fontWeight: 700,
              border: `1px solid ${tab === t.id ? T.cyan : T.border}`,
              background: tab === t.id ? T.cyan + "20" : "none",
              color: tab === t.id ? T.cyan : T.textMuted,
              textTransform: "uppercase", letterSpacing: "0.06em",
            }}>{t.label}</button>
          ))}
        </div>
      )}

      {/* Active Vendors Tab — CEO only */}
      {tab === "active-vendors" && user?.role === "CEO" && (
        <div>
          <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 16 }}>{vendorProfiles.length} active vendors with portal access</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {vendorProfiles.map(v => {
              const linked = apps.find(a => a.contact_email === v.email);
              const tierColor = v.vendor_scorecard_count > 0 ? (v.vendor_score >= 85 ? "#10B981" : v.vendor_score >= 70 ? T.teal : v.vendor_score >= 50 ? T.amber : T.red) : T.textMuted;
              return (
                <div key={v.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{ width: 40, height: 40, borderRadius: "50%", background: tierColor+"20", border: `1px solid ${tierColor}40`, display: "flex", alignItems: "center", justifyContent: "center", color: tierColor, fontWeight: 800, fontSize: 13 }}>{(v.name||"?").slice(0,2).toUpperCase()}</div>
                    <div>
                      <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>{v.name}</div>
                      <div style={{ color: T.textMuted, fontSize: 11 }}>{v.company_name || ""} {v.company_name && v.service_category ? "·" : ""} {v.service_category || "No category"}</div>
                      <div style={{ color: T.textMuted, fontSize: 11 }}>{v.email} {v.phone ? "· " + v.phone : ""}</div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    {v.vendor_scorecard_count > 0 && <span style={{ color: tierColor, fontWeight: 700, fontSize: 13 }}>{v.vendor_score}%</span>}
                    <button onClick={() => {
                      setEditVendorModal(v);
                      setEditVendorForm({
                        name: v.name || "",
                        company_name: v.company_name || "",
                        phone: v.phone || "",
                        service_category: v.service_category || "",
                        // Bank & payment from linked application
                        bank_name: linked?.bank_name || "",
                        bank_account_name: linked?.bank_account_name || "",
                        account_number: linked?.account_no || "",
                        swift_code: linked?.swift_code || "",
                        bank_address: linked?.bank_address || "",
                        payment_terms: linked?.payment_terms || "",
                        country: linked?.country || "",
                        address: linked?.address || "",
                        contact_person: linked?.contact_person || v.name || "",
                      });
                    }} style={{ background: T.cyan+"15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "6px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Edit</button>
                  </div>
                </div>
              );
            })}
            {vendorProfiles.length === 0 && <div style={{ textAlign: "center", padding: 40, color: T.textMuted }}>No active vendors yet. Approve vendor applications first.</div>}
          </div>

          {/* Vendor Edit Modal */}
          {editVendorModal && (
            <div style={{ position: "fixed", inset: 0, zIndex: 900, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={e => { e.stopPropagation(); setEditVendorModal(null); }}>
              <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 640, maxHeight: "90vh", overflow: "auto", padding: 28 }} onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()}>
                <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Edit Vendor — {editVendorModal.name}</div>
                <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>{editVendorModal.email}</div>

                {[
                  { section: "Contact Details", fields: [
                    ["name", "Vendor / Contact Name", "text"],
                    ["company_name", "Company Name", "text"],
                    ["phone", "Phone Number", "text"],
                    ["country", "Country", "text"],
                    ["address", "Address", "text"],
                  ]},
                  { section: "Service", fields: [
                    ["contact_person", "Contact Person", "text"],
                  ]},
                  { section: "Bank Details", fields: [
                    ["bank_name", "Bank Name", "text"],
                    ["bank_account_name", "Account Name", "text"],
                    ["account_number", "Account Number", "text"],
                    ["swift_code", "Swift Code", "text"],
                    ["bank_address", "Bank Address", "text"],
                    ["payment_terms", "Payment Terms", "text"],
                  ]},
                ].map(({ section, fields }) => (
                  <div key={section}>
                    <div style={{ color: T.cyan, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 10, marginTop: 18, paddingBottom: 6, borderBottom: `1px solid ${T.cyan}30` }}>{section}</div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 10 }}>
                      {fields.map(([key, label]) => (
                        <div key={key}>
                          <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 4 }}>{label}</label>
                          {key === "payment_terms" ? (
                            <select value={editVendorForm[key] || ""} onChange={e => setEditVendorForm({...editVendorForm, [key]: e.target.value})} style={{ width: "100%", padding: "8px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", appearance: "none", boxSizing: "border-box" }}>
                              <option value="">Select payment terms...</option>
                              {["Immediate", "Net 7 days", "Net 14 days", "Net 30 days", "50% upfront, balance on completion", "50% upfront paid, balance now", "100% upfront", "Custom"].map(t => <option key={t} value={t}>{t}</option>)}
                            </select>
                          ) : (
                            <input value={editVendorForm[key] || ""} onChange={e => setEditVendorForm({...editVendorForm, [key]: e.target.value})} style={{ width: "100%", padding: "8px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}

                <div style={{ marginTop: 16 }}>
                  <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 }}>Service Category</label>
                  <select value={editVendorForm.service_category} onChange={e => setEditVendorForm({...editVendorForm, service_category: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
                    <option value="">Select category...</option>
                    {VTYPES.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>

                <div style={{ display: "flex", gap: 10, marginTop: 24 }}>
                  <button onClick={async () => {
                    setSavingVendor(true);
                    // Update profile
                    await supabase.from("profiles").update({
                      name: editVendorForm.name,
                      company_name: editVendorForm.company_name,
                      phone: editVendorForm.phone,
                      service_category: editVendorForm.service_category,
                    }).eq("id", editVendorModal.id);
                    // Update linked application if exists
                    const linked = apps.find(a => a.contact_email === editVendorModal.email);
                    if (linked) {
                      await supabase.from("vendor_applications").update({
                        contact_person: editVendorForm.contact_person,
                        country: editVendorForm.country,
                        address: editVendorForm.address,
                        bank_name: editVendorForm.bank_name,
                        bank_account_name: editVendorForm.bank_account_name,
                        account_number: editVendorForm.account_number,
                        swift_code: editVendorForm.swift_code,
                        bank_address: editVendorForm.bank_address,
                        payment_terms: editVendorForm.payment_terms,
                      }).eq("id", linked.id);
                    }
                    setSavingVendor(false);
                    setEditVendorModal(null);
                    load();
                  }} disabled={savingVendor} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{savingVendor ? "Saving..." : "Save All Changes"}</button>
                  <button onClick={() => setEditVendorModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* New Vendor Form */}
      {tab === "form" && !submitted && (
        <VendorApplicationModal
          user={user}
          onClose={() => setTab("submitted")}
          inline={true}
          onSubmitted={() => { setSubmitted(true); load(); setTab("submitted"); }}
        />
      )}

      {submitted && tab === "form" && (
        <div style={{ textAlign: "center", padding: "60px 0", background: T.surface, borderRadius: 12, border: `1px solid ${T.teal}30` }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 18, marginBottom: 8 }}>Application Submitted!</div>
          <div style={{ color: T.textMuted, fontSize: 13, marginBottom: 20 }}>The CEO has been notified and will review the application.</div>
          <button onClick={() => { setSubmitted(false); }} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 13 }}>Submit Another</button>
        </div>
      )}

      {/* Submitted Applications — Vendor Manager */}
      {tab === "external" && user?.role === "Vendor Manager" && (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
            <div>
              <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16 }}>New External Applications</div>
              <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>Vendors who submitted via the public registration link</div>
            </div>
            <button onClick={() => { const link = window.location.origin + "/applyvendor"; navigator.clipboard.writeText(link); alert("Link copied!\n\n" + link); }} style={{ background:T.surface, border:"1px solid "+T.border, color:T.textMuted, padding:"8px 14px", borderRadius:8, cursor:"pointer", fontSize:11, fontWeight:700 }}>Copy Form Link</button>
          </div>
          {apps.filter(a => ["submitted","declined"].includes(a.status)).length === 0 ? (
            <div style={{ textAlign:"center", padding:40, color:T.textMuted, fontSize:13 }}>No new external applications yet.</div>
          ) : apps.filter(a => ["submitted","declined"].includes(a.status)).map(app => (
            <div key={app.id} style={{ background:T.surface, border:"1px solid "+T.amber+"30", borderLeft:"3px solid "+T.amber, borderRadius:10, padding:"16px 18px", marginBottom:10 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                <div>
                  <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15 }}>{app.vendor_name}</div>
                  <div style={{ color:T.cyan, fontSize:12, marginTop:2, fontWeight:600 }}>{app.vendor_type}</div>
                  <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>Submitted {new Date(app.created_at).toLocaleDateString("en-GB", {day:"numeric",month:"short",year:"numeric"})}</div>
                </div>
                <span style={{ background:T.amber+"18", color:T.amber, border:"1px solid "+T.amber+"30", borderRadius:20, padding:"3px 12px", fontSize:10, fontWeight:800 }}>NEW</span>
              </div>
              {/* Full details grid */}
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))", gap:10, marginBottom:12 }}>
                {[
                  ["Contact Person", app.contact_person],
                  ["Email", app.contact_email],
                  ["Phone", app.phone],
                  ["Country", app.country],
                  ["Address", app.address],
                  ["Position", app.position_in_company],
                  ["Form Completed By", app.form_completed_by],
                  ["Payment Terms", app.payment_terms],
                ].filter(([,v])=>v).map(([label,val]) => (
                  <div key={label} style={{ background:T.bg, borderRadius:6, padding:"8px 10px" }}>
                    <div style={{ color:T.textMuted, fontSize:9, fontWeight:700, textTransform:"uppercase", marginBottom:3 }}>{label}</div>
                    <div style={{ color:T.textPrimary, fontSize:12, fontWeight:600 }}>{val}</div>
                  </div>
                ))}
              </div>
              {/* Bank details */}
              {app.bank_name && (
                <div style={{ background:T.bg, border:"1px solid "+T.border, borderRadius:8, padding:"10px 14px", marginBottom:10, display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8 }}>
                  <div><div style={{ color:T.textMuted, fontSize:10, fontWeight:700 }}>BANK</div><div style={{ color:T.textPrimary, fontSize:12 }}>{app.bank_name}</div></div>
                  <div><div style={{ color:T.textMuted, fontSize:10, fontWeight:700 }}>ACCOUNT NAME</div><div style={{ color:T.textPrimary, fontSize:12 }}>{app.bank_account_name||"—"}</div></div>
                  <div><div style={{ color:T.textMuted, fontSize:10, fontWeight:700 }}>ACCOUNT NO</div><div style={{ color:T.textPrimary, fontSize:12 }}>{app.account_no||"—"}</div></div>
                </div>
              )}
              {/* Documents */}
              {(app.business_reg_url || app.vat_cert_url) && (
                <div style={{ display:"flex", gap:8, marginBottom:10 }}>
                  {app.business_reg_url && <a href={app.business_reg_url} target="_blank" rel="noreferrer" style={{ background:T.cyan+"15", border:"1px solid "+T.cyan+"30", color:T.cyan, padding:"5px 12px", borderRadius:8, fontSize:11, fontWeight:700, textDecoration:"none" }}>View Business Reg</a>}
                  {app.vat_cert_url && <a href={app.vat_cert_url} target="_blank" rel="noreferrer" style={{ background:T.teal+"15", border:"1px solid "+T.teal+"30", color:T.teal, padding:"5px 12px", borderRadius:8, fontSize:11, fontWeight:700, textDecoration:"none" }}>View VAT Certificate</a>}
                </div>
              )}
              {app.status === "declined" && app.ceo_notes && (
                <div style={{ background:T.red+"10", border:`1px solid ${T.red}25`, borderRadius:8, padding:"8px 12px", marginBottom:10 }}>
                  <div style={{ color:T.red, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:3 }}>CEO Feedback — Please address before resubmitting</div>
                  <div style={{ color:T.textSecondary, fontSize:12 }}>{app.ceo_notes}</div>
                </div>
              )}
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {app.status === "declined" && (
                  <button onClick={() => setEditApp(app)} style={{ background:T.amber+"15", border:`1px solid ${T.amber}30`, color:T.amber, padding:"8px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}>Edit & Resubmit</button>
                )}
                {app.status === "submitted" && (
                  <button onClick={async () => {
                    await supabase.from("vendor_applications").update({ status:"pending", submitted_by: user?.id }).eq("id", app.id);
                    const { data: ceos } = await supabase.from("profiles").select("id").eq("role","CEO");
                    for (const ceo of ceos||[]) {
                      await supabase.from("notifications").insert({ user_id:ceo.id, title:"Vendor Application — "+app.vendor_name, message:"VM has reviewed and approved "+app.vendor_name+" ("+app.vendor_type+") for onboarding. Awaiting your final approval.", type:"vendor_application", resource_id:app.id });
                    }
                    load();
                    alert(app.vendor_name + " approved and sent to CEO for final approval.");
                  }} style={{ background:"linear-gradient(135deg,"+T.teal+",#10B981)", border:"none", color:"#fff", padding:"8px 18px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:12 }}>Approve & Send to CEO</button>
                )}
                {app.status === "submitted" && (
                  <button onClick={() => setEditApp(app)} style={{ background:T.cyan+"15", border:"1px solid "+T.cyan+"30", color:T.cyan, padding:"8px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}>Edit Details</button>
                )}
                {app.status === "submitted" && (
                  <button onClick={async () => {
                    const reason = window.prompt("Reason for rejection:");
                    if (!reason) return;
                    await supabase.from("vendor_applications").update({ status:"declined", ceo_notes:reason }).eq("id", app.id);
                    load();
                  }} style={{ background:T.red+"15", border:"1px solid "+T.red+"30", color:T.red, padding:"8px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}>Reject</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === "submitted" && (
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {apps.filter(a => a.submitted_by === user?.id).length === 0 && (
              <div style={{ textAlign: "center", padding: 40, color: T.textMuted, fontSize: 13 }}>No applications submitted yet.</div>
            )}
            {apps.filter(a => a.submitted_by === user?.id).map(app => {
              const statusColor = { pending: T.amber, approved: T.teal, declined: T.red, "login-created": "#10B981" };
              const statusLabel = { pending: "Pending CEO Approval", approved: "Approved", declined: "Declined — Edit & Resubmit", "login-created": "Portal Access Granted" };
              return (
                <div key={app.id} style={{ background: T.surface, border: `1px solid ${statusColor[app.status] || T.border}22`, borderLeft: `3px solid ${statusColor[app.status] || T.textMuted}`, borderRadius: 10, padding: "16px 18px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: app.ceo_notes ? 10 : 0 }}>
                    <div>
                      <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>{app.vendor_name}</div>
                      <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{app.vendor_type} · {app.contact_person} · {app.contact_email}</div>
                      <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{app.country} · Submitted {new Date(app.created_at).toLocaleDateString("en-GB")}</div>
                    </div>
                    <span style={{ background: (statusColor[app.status] || T.textMuted) + "18", color: statusColor[app.status] || T.textMuted, border: `1px solid ${(statusColor[app.status] || T.textMuted)}30`, borderRadius: 20, padding: "3px 12px", fontSize: 10, fontWeight: 800, textTransform: "uppercase", whiteSpace: "nowrap" }}>{statusLabel[app.status] || app.status}</span>
                  </div>
                  {app.ceo_notes && (
                    <div style={{ background: T.red + "10", border: `1px solid ${T.red}25`, borderRadius: 8, padding: "8px 12px", marginBottom: 10 }}>
                      <div style={{ color: T.red, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>CEO Feedback</div>
                      <div style={{ color: T.textSecondary, fontSize: 12 }}>{app.ceo_notes}</div>
                    </div>
                  )}
                  {app.status === "declined" && (
                    <button onClick={() => setEditApp(app)} style={{ background: T.amber + "18", border: `1px solid ${T.amber}40`, color: T.amber, padding: "6px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Edit & Resubmit</button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {tab === "approved" && user?.role === "Vendor Manager" && (
        <ApprovedVendorsTab apps={apps} user={user} load={load} />
      )}

            {/* CEO — All Applications */}
      {tab === "applications" && (
        <VendorApprovalsPanel user={user} onLoginCreated={load} />
      )}

      {/* Edit & Resubmit Modal */}
      {editApp && (
        <EditVendorAppModal
          app={editApp}
          user={user}
          onClose={() => setEditApp(null)}
          onResubmitted={() => { setEditApp(null); load(); alert(" Application resubmitted for CEO approval."); }}
        />
      )}
    </div>
  );
};

const VendorAssignmentView = ({ user, activeCountry = "All" }) => {
  const [rffs, setRffs] = useState([]);
  const [events, setEvents] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [saving, setSaving] = useState(false);
  const [expandedEvent, setExpandedEvent] = useState(null);
  const [basketModal, setBasketModal] = useState(null);
  const [selectedRff, setSelectedRff] = useState(null);
  const [rffActivities, setRffActivities] = useState({});
  const [actModal, setActModal] = useState(null);
  const [actForm, setActForm] = useState({ type: "call", notes: "", scheduled_date: "", scheduled_time: "" });
  const [addingAct, setAddingAct] = useState(false);

  const loadActivities = async (assignmentId) => {
    const { data } = await supabase.from("crm_activities").select("*").eq("vendor_assignment_id", assignmentId).order("created_at", { ascending: false });
    setRffActivities(prev => ({ ...prev, [assignmentId]: data || [] }));
  };

  const handleLogActivity = async (assignment, vendorName) => {
    if (!actForm.notes) return;
    setAddingAct(true);
    await supabase.from("crm_activities").insert({
      vendor_assignment_id: assignment.id,
      type: actForm.type,
      notes: actForm.notes,
      activity_type: actForm.type,
      scheduled_date: actForm.scheduled_date || null,
      scheduled_time: actForm.scheduled_time || null,
      created_by: user.id,
      created_by_name: user.name,
    });
    if (actForm.scheduled_date && ["call","meeting","follow-up"].includes(actForm.type)) {
      await supabase.from("itineraries").insert({
        title: actForm.type + " — " + vendorName,
        week_start: actForm.scheduled_date,
        items: JSON.stringify([{ date: actForm.scheduled_date, time: actForm.scheduled_time || "09:00", company: vendorName, action: actForm.type, notes: actForm.notes }]),
        created_by: user.id,
      });
    }
    setActForm({ type: "call", notes: "", scheduled_date: "", scheduled_time: "" });
    setAddingAct(false);
    loadActivities(assignment.id);
    setActModal(null);
  };

  const load = async () => {
    const [r, e, v, a] = await Promise.all([
      (!activeCountry || activeCountry === "All") ? supabase.from("rffs").select("*").order("created_at", { ascending: false }) : supabase.from("rffs").select("*").eq("country", activeCountry).order("created_at", { ascending: false }),
      (!activeCountry || activeCountry === "All") ? supabase.from("projects").select("*") : supabase.from("projects").select("*").eq("country", activeCountry),
      (!activeCountry || activeCountry === "All") ? supabase.from("profiles").select("*").eq("role", "Vendor") : supabase.from("profiles").select("*").eq("role", "Vendor").or(`country.eq.${activeCountry},presence.like.%${activeCountry === "Nigeria" ? "NG" : "GH"}%`),
      supabase.from("rff_vendor_assignments").select("*"),
    ]);
    setRffs(r.data || []);
    setEvents(e.data || []);
    // Include vendors from profiles (all with role=Vendor)
    setVendors(v.data || []);
    setAssignments(a.data || []);
  };

  useEffect(() => { load(); }, [activeCountry]);

  //  Upcoming Events Assignment Dashboard 
  const today = new Date().toISOString().slice(0,10);
  const upcomingEvents = events
    .filter(e => !e.event_date || e.event_date >= today)
    .sort((a,b) => {
      if (!a.event_date && !b.event_date) return 0;
      if (!a.event_date) return 1;
      if (!b.event_date) return -1;
      return a.event_date > b.event_date ? 1 : -1;
    })
    .slice(0, 3);

  const getEventVendorMap = (eventId) => {
    const eventRffs = rffs.filter(r => r.project_id === eventId);
    return eventRffs.map(rff => {
      const rffAssignments = assignments.filter(a => a.rff_id === rff.id);
      return { rff, vendors: rffAssignments };
    }).filter(x => x.vendors.length > 0);
  };

  const daysUntil = (dateStr) => {
    const diff = Math.ceil((new Date(dateStr) - new Date()) / (1000*60*60*24));
    return diff;
  };

  const assignedVendorIds = (rffId) => assignments.filter(a => a.rff_id === rffId).map(a => a.vendor_id);

  const addVendor = async (rff, vendor) => {
    setSaving(true);
    await supabase.from("rff_vendor_assignments").insert({ rff_id: rff.id, vendor_id: vendor.id, vendor_name: vendor.name, assigned_by: user.id });
    // Notify vendor
    await supabase.from("notifications").insert({ user_id: vendor.id, title: "New RFF Assignment", message: `You have been assigned to RFF: "${rff.title}" for ${rff.event_name}. Please submit your quote.`, type: "rff" });
    const { data: vendorProf } = await supabase.from("profiles").select("email,name").eq("id", vendor.id).single();
    if (vendorProf?.email) await sendEmail(vendorProf.email, `Request for Quote — ${rff.title}`, rffEmailHtml({ vendorName: vendor.name, rffTitle: rff.title || "Request for Quote", eventName: rff.event_name || "", deadline: rff.quote_deadline, category: rff.category || "", notes: rff.description || "" }));
    // Update RFF status to show vendors are being assigned
    await supabase.from("rffs").update({ status: "vendor-assigned" }).eq("id", rff.id);
    setSaving(false); load();
  };

  const removeVendor = async (rffId, vendorId) => {
    setSaving(true);
    await supabase.from("rff_vendor_assignments").delete().eq("rff_id", rffId).eq("vendor_id", vendorId);
    // Check if any vendors remain
    const { data: remaining } = await supabase.from("rff_vendor_assignments").select("id").eq("rff_id", rffId);
    if (!remaining || remaining.length === 0) await supabase.from("rffs").update({ status: "approved" }).eq("id", rffId);
    setSaving(false); load();
  };

  // Group approved RFFs by event
  const grouped = events.reduce((acc, ev) => {
    const evRffs = rffs.filter(r => r.project_id === ev.id);
    if (evRffs.length > 0) acc[ev.id] = { event: ev, rffs: evRffs };
    return acc;
  }, {});

  const TierBadge = ({ vendor }) => {
    const score = vendor.vendor_score || 0;
    const count = vendor.vendor_scorecard_count || 0;
    const isUnrated = count === 0;
    let grade, gradeColor, gradeBg, gradeLabel;
    if (isUnrated) { grade = "—"; gradeColor = T.textMuted; gradeBg = T.bg; gradeLabel = "Unrated"; }
    else if (score >= 85) { grade = "A"; gradeColor = "#10B981"; gradeBg = "#10B98115"; gradeLabel = "Excellent"; }
    else if (score >= 70) { grade = "B"; gradeColor = T.cyan; gradeBg = T.cyan + "15"; gradeLabel = "Good"; }
    else if (score >= 50) { grade = "C"; gradeColor = T.amber; gradeBg = T.amber + "15"; gradeLabel = "Fair"; }
    else { grade = "D"; gradeColor = "#F43F5E"; gradeBg = "#F43F5E15"; gradeLabel = "Do Not Engage"; }
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <div style={{ width: 24, height: 24, borderRadius: 6, background: gradeBg, border: "1.5px solid " + gradeColor + "66", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 900, color: gradeColor }}>{grade}</div>
        <span style={{ fontSize: 11, color: gradeColor, fontWeight: 600 }}>{gradeLabel}</span>
      </div>
    );
  };

  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Procurement</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Vendor Assignment</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Assign vendors to approved RFFs by event</div>
      </div>

      {Object.keys(grouped).length === 0 ? (
        <Card style={{ textAlign: "center", padding: 60 }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16 }}>No approved RFFs yet</div>
          <div style={{ color: T.textMuted, fontSize: 13, marginTop: 8 }}>RFFs approved by CEO will appear here for vendor assignment.</div>
        </Card>
      ) : Object.values(grouped).map(({ event: ev, rffs: evRffs }) => (
        <div key={ev.id} style={{ marginBottom: 24 }}>
          <button onClick={() => setExpandedEvent(expandedEvent === ev.id ? null : ev.id)} style={{ width: "100%", background: T.surface, border: "1px solid " + T.border, borderRadius: 8, padding: "14px 20px", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: expandedEvent === ev.id ? 12 : 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 3, height: 20, background: T.cyan, borderRadius: 2 }} />
              <div style={{ textAlign: "left" }}>
                <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>{ev.name}</div>
                <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{ev.client} · {evRffs.length} RFF{evRffs.length > 1 ? "s" : ""}</div>
              </div>
            </div>
            <span style={{ color: T.textMuted, fontSize: 16 }}>{expandedEvent === ev.id ? "" : ""}</span>
          </button>

          {expandedEvent === ev.id && (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))", gap: 14 }}>
              {evRffs.map(rff => {
                const assigned = assignments.filter(a => a.rff_id === rff.id);
                const assignedIds = assigned.map(a => a.vendor_id);
                return (
                  <Card key={rff.id} style={{ borderLeft: "3px solid " + T.teal, marginBottom: 0, cursor: "pointer" }} onClick={() => setSelectedRff(selectedRff?.id === rff.id ? null : rff)}>
                    <div style={{ marginBottom: 12 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14 }}>{rff.title}</div>
                        <span style={{ color: T.textMuted, fontSize: 12 }}>{selectedRff?.id === rff.id ? "" : ""}</span>
                      </div>
                      <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}> Due {rff.deadline}</div>
                      {rff.quote_deadline && <div style={{ color: T.amber, fontSize: 11, fontWeight: 700, marginTop: 3 }}> Quote Deadline: {new Date(rff.quote_deadline).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</div>}
                      {rff.description && <div style={{ color: T.textSecondary, fontSize: 12, marginTop: 4 }}>{rff.description}</div>}
                      {/* Upload RFF doc if missing */}
                      {!rff.document_url && (
                        <label style={{ display:"inline-flex", alignItems:"center", gap:6, marginTop:8, background:T.amber+"15", border:`1px solid ${T.amber}30`, color:T.amber, padding:"5px 12px", borderRadius:8, cursor:"pointer", fontSize:11, fontWeight:700 }}>
                           Upload RFF Document
                          <input type="file" style={{ display:"none" }} accept=".pdf,.doc,.docx" onChange={async e => {
                            const f = e.target.files?.[0];
                            if (!f) return;
                            const ext = f.name.split('.').pop();
                            const fname = `rff_doc_${rff.id}.${ext}`;
                            const { error: upErr } = await supabase.storage.from('rffs').upload(fname, f, { upsert: true });
                            if (!upErr) {
                              const { data: urlData } = supabase.storage.from('rffs').getPublicUrl(fname);
                              await supabase.from('rffs').update({ document_url: urlData.publicUrl, document_name: f.name }).eq('id', rff.id);
                              load();
                              alert('RFF document uploaded. Vendors can now download it.');
                            }
                          }} />
                        </label>
                      )}
                      {rff.document_url && (
                        <a href={rff.document_url} target="_blank" rel="noreferrer" style={{ display:"inline-flex", alignItems:"center", gap:6, marginTop:8, background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"5px 12px", borderRadius:8, fontSize:11, fontWeight:700, textDecoration:"none" }}> View RFF Document</a>
                      )}
                    </div>

                    {/* Summary badges */}
                    <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
                      <span style={{ color: T.cyan, fontSize: 11, fontWeight: 700, background: T.cyan+"12", padding: "2px 8px", borderRadius: 20 }}>{assigned.length} vendor{assigned.length !== 1 ? "s" : ""}</span>
                      {assigned.filter(a => a.status === "quote-submitted").length > 0 && <span style={{ color: T.amber, fontSize: 11, fontWeight: 700, background: T.amber+"12", padding: "2px 8px", borderRadius: 20 }}>{assigned.filter(a => a.status === "quote-submitted").length} quote{assigned.filter(a => a.status === "quote-submitted").length !== 1 ? "s" : ""} in</span>}
                    </div>

                    {/* Expanded vendor list with activity */}
                    {selectedRff?.id === rff.id && (
                      <div onClick={e => e.stopPropagation()} style={{ borderTop: "1px solid " + T.border, paddingTop: 12, marginTop: 4 }}>
                        {assigned.length === 0 ? (
                          <div style={{ color: T.textMuted, fontSize: 12, padding: "8px 0" }}>No vendors assigned yet</div>
                        ) : assigned.map(a => {
                          const vp = vendors.find(v => v.id === a.vendor_id);
                          const statusColors = { pending: T.textMuted, "quote-submitted": T.amber, "quote-approved": T.teal, "invoice-submitted": "#10B981" };
                          const statusLabels = { pending: "Awaiting Quote", "quote-submitted": "Quote Submitted", "quote-approved": "Quote Approved", "invoice-submitted": "Invoice Submitted" };
                          const acts = rffActivities[a.id] || [];
                          const tIcons = { note: "", call: "", meeting: "", email: "", "follow-up": "" };
                          return (
                            <div key={a.id} style={{ background: T.bg, border: "1px solid " + T.border, borderRadius: 10, padding: "12px 14px", marginBottom: 10 }}>
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                                <div>
                                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13 }}>{a.vendor_name}</div>
                                  {vp && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 1 }}>{vp.service_category || vp.email}</div>}
                                  {a.quote_amount && <div style={{ color: T.amber, fontWeight: 700, fontSize: 13, marginTop: 4 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(a.quote_amount).toLocaleString()).toLocaleString()}</div>}
                                </div>
                                <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                                  <span style={{ color: statusColors[a.status] || T.textMuted, fontSize: 10, fontWeight: 700, background: (statusColors[a.status] || T.textMuted)+"15", padding: "2px 8px", borderRadius: 20 }}>{statusLabels[a.status] || a.status}</span>
                                  <button onClick={() => { if (!rffActivities[a.id]) loadActivities(a.id); setActModal(a); setActForm({ type: "call", notes: "", scheduled_date: "", scheduled_time: "" }); }} style={{ background: T.cyan+"15", border: "1px solid " + T.cyan+"30", color: T.cyan, padding: "3px 8px", borderRadius: 5, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Log</button>
                                  <button onClick={() => removeVendor(rff.id, a.vendor_id)} style={{ background: "none", border: "none", color: "#F43F5E", cursor: "pointer", fontSize: 14, padding: 0, lineHeight: 1 }}></button>
                                </div>
                              </div>
                              {/* Activity timeline */}
                              {rffActivities[a.id] && rffActivities[a.id].length > 0 && (
                                <div style={{ borderTop: "1px solid " + T.border+"44", paddingTop: 8, marginTop: 4 }}>
                                  {rffActivities[a.id].slice(0,3).map((act, i) => (
                                    <div key={act.id} style={{ display: "flex", gap: 8, marginBottom: 6 }}>
                                      <span style={{ fontSize: 12 }}>{tIcons[act.type] || ""}</span>
                                      <div style={{ flex: 1 }}>
                                        <div style={{ color: T.textSecondary, fontSize: 11 }}>{act.notes}</div>
                                        <div style={{ color: T.textMuted, fontSize: 10, marginTop: 1 }}>{act.created_by_name} · {new Date(act.created_at).toLocaleDateString("en-GB")}{act.scheduled_date ? " ·  " + act.scheduled_date : ""}</div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                              {!rffActivities[a.id] && <button onClick={() => loadActivities(a.id)} style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 11, padding: 0 }}>Load activity history</button>}
                            </div>
                          );
                        })}
                        <button onClick={() => setBasketModal({ rff, assignedIds })} style={{ width: "100%", padding: "8px", background: T.cyan+"15", border: "1px solid " + T.cyan+"33", borderRadius: 8, cursor: "pointer", color: T.cyan, fontSize: 12, fontWeight: 700, marginTop: 4 }}>+ Add Vendor</button>
                      </div>
                    )}
                    {selectedRff?.id !== rff.id && (
                      <button onClick={e => { e.stopPropagation(); setBasketModal({ rff, assignedIds }); }} style={{ width: "100%", padding: "8px", background: T.cyan+"15", border: "1px solid " + T.cyan+"33", borderRadius: 8, cursor: "pointer", color: T.cyan, fontSize: 12, fontWeight: 700 }}>+ Add Vendor</button>
                    )}
                  </Card>
                );
              })}
            </div>
          )}
        </div>
      ))}

      {/* Activity Log Modal */}
      {actModal && (
        <Modal title={"Log Activity — " + actModal.vendor_name} onClose={() => setActModal(null)}>
          <div style={{ marginBottom: 12 }}>
            <div style={{ display: "flex", gap: 4, marginBottom: 10, flexWrap: "wrap" }}>
              {["call","meeting","email","note","follow-up"].map(t => {
                const tIcons = { note: "", call: "", meeting: "", email: "", "follow-up": "" };
                return <button key={t} onClick={() => setActForm(f => ({...f, type: t}))} style={{ padding: "4px 10px", borderRadius: 20, border: "1px solid " + (actForm.type === t ? T.cyan : T.border), background: actForm.type === t ? T.cyan+"20" : "none", color: actForm.type === t ? T.cyan : T.textMuted, fontSize: 10, fontWeight: 700, cursor: "pointer", textTransform: "uppercase" }}>{tIcons[t]} {t}</button>;
              })}
            </div>
            <textarea value={actForm.notes} onChange={e => setActForm(f => ({...f, notes: e.target.value}))} placeholder={"Log " + actForm.type + "..."} rows={3} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: "1px solid " + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", resize: "none", boxSizing: "border-box", marginBottom: 8 }} />
            {["call","meeting","follow-up"].includes(actForm.type) && (
              <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                <input type="date" value={actForm.scheduled_date} onChange={e => setActForm(f => ({...f, scheduled_date: e.target.value}))} style={{ flex: 1, padding: "8px 12px", background: T.bg, border: "1px solid " + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }} />
                <input type="time" value={actForm.scheduled_time} onChange={e => setActForm(f => ({...f, scheduled_time: e.target.value}))} style={{ flex: 1, padding: "8px 12px", background: T.bg, border: "1px solid " + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }} />
              </div>
            )}
            {actForm.scheduled_date && <div style={{ color: "#8B5CF6", fontSize: 11, fontWeight: 700, marginBottom: 8 }}> {actForm.scheduled_date}{actForm.scheduled_time ? " at " + actForm.scheduled_time : ""} → calendar</div>}
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn onClick={() => handleLogActivity(actModal, actModal.vendor_name)} disabled={addingAct || !actForm.notes}>{addingAct ? "Logging..." : "Log Activity"}</Btn>
            <Btn variant="ghost" onClick={() => setActModal(null)}>Cancel</Btn>
          </div>
        </Modal>
      )}

      {/* Vendor Picker Modal */}
      {basketModal && (
        <Modal title={"Assign Vendors — " + basketModal.rff.title} onClose={() => setBasketModal(null)}>
          <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 16 }}> {basketModal.rff.event_name} · Select vendors in good standing</div>
          <div style={{ maxHeight: 400, overflowY: "auto" }}>
            {vendors.map(v => {
              const score = v.vendor_score || 0;
              const isPoor = v.vendor_scorecard_count > 0 && score < 50;
              const isAssigned = basketModal.assignedIds.includes(v.id);
              return (
                <div key={v.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid " + T.border + "66", opacity: isPoor ? 0.5 : 1 }}>
                  <div>
                    <div style={{ color: isPoor ? T.textMuted : T.textPrimary, fontWeight: 600, fontSize: 14 }}>{v.name}</div>
                    <div style={{ marginTop: 4, display: "flex", alignItems: "center", gap: 6 }}>
                    <TierBadge vendor={v} />
                    {v.vendor_scorecard_count >= 2 && <span style={{ color: T.textMuted, fontSize: 9 }}>(avg 2 events)</span>}
                    {v.vendor_scorecard_count === 1 && <span style={{ color: T.textMuted, fontSize: 9 }}>(1 event)</span>}
                  </div>
                  </div>
                  {isPoor ? (
                    <span style={{ color: "#F43F5E", fontSize: 11, fontWeight: 600 }}> Cannot assign</span>
                  ) : isAssigned ? (
                    <button onClick={() => { removeVendor(basketModal.rff.id, v.id); setBasketModal({ ...basketModal, assignedIds: basketModal.assignedIds.filter(id => id !== v.id) }); }} style={{ padding: "6px 14px", background: "#F43F5E15", border: "1px solid #F43F5E44", borderRadius: 20, cursor: "pointer", color: "#F43F5E", fontSize: 12, fontWeight: 700 }}> Remove</button>
                  ) : (
                    <button onClick={() => { addVendor(basketModal.rff, v); setBasketModal({ ...basketModal, assignedIds: [...basketModal.assignedIds, v.id] }); }} disabled={saving} style={{ padding: "6px 14px", background: T.cyan + "15", border: "1px solid " + T.cyan + "33", borderRadius: 20, cursor: "pointer", color: T.cyan, fontSize: 12, fontWeight: 700 }}>+ Assign</button>
                  )}
                </div>
              );
            })}
          </div>
          <div style={{ marginTop: 16 }}>
            <Btn onClick={() => setBasketModal(null)}>Done</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};

//  FINANCE APPROVALS VIEW 
const FinanceApprovalsView = ({ user }) => {
  const [expenses, setExpenses] = useState([]);
  const [budgetRequests, setBudgetRequests] = useState([]);
  const [paymentRequests, setPaymentRequests] = useState([]);
  const [saving, setSaving] = useState(null);
  const canApprove = ["CEO", "Country Manager"].includes(user?.role);

  const load = async () => {
    const [ex, br, pr] = await Promise.all([
      supabase.from("expenses").select("*").eq("approval_required", true).order("created_at", { ascending: false }),
      supabase.from("budget_requests").select("*").order("created_at", { ascending: false }),
      supabase.from("invoice_payments").select("*").order("created_at", { ascending: false }),
    ]);
    setExpenses(ex.data || []);
    setBudgetRequests(br.data || []);
    setPaymentRequests(pr.data || []);
  };

  useEffect(() => { load(); }, []);

  const pendingExpenses = expenses.filter(e => e.approval_status === "pending");
  const pendingBudgets = budgetRequests.filter(b => b.status === "pending");
  const pendingPayments = paymentRequests.filter(p => p.status === "pending");
  const totalPending = pendingExpenses.length + pendingBudgets.length + pendingPayments.length;

  const handleExpense = async (id, status, notes) => {
    setSaving(id);
    await supabase.from("expenses").update({ approval_status: status, approved_by: user.id, approval_notes: notes || "" }).eq("id", id);
    setSaving(null);
    load();
  };

  const handleBudget = async (req, status) => {
    setSaving(req.id);
    await supabase.from("budget_requests").update({ status, approved_by: user.id }).eq("id", req.id);
    if (status === "approved") {
      const { data: existing } = await supabase.from("budgets").select("*").eq("project_id", req.project_id).single();
      if (existing) {
        await supabase.from("budgets").update({ total_budget: existing.total_budget + req.requested_amount }).eq("id", existing.id);
      }
    }
    setSaving(null);
    load();
  };

  const handlePayment = async (req, status) => {
    setSaving(req.id);
    await supabase.from("invoice_payments").update({ status, approved_by: user.id }).eq("id", req.id);
    if (status === "approved") {
      await supabase.from("invoices").update({ status: "paid" }).eq("id", req.invoice_id);
    }
    setSaving(null);
    load();
  };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Finance</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
          <div>
            <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Finance Approvals</h2>
            <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{totalPending} item{totalPending !== 1 ? "s" : ""} pending your approval</div>
          </div>
          {totalPending > 0 && <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "5px 14px", background: T.amber + "15", border: `1px solid ${T.amber}40`, borderRadius: 20 }}>
            <div style={{ width: 6, height: 6, borderRadius: "50%", background: T.amber, boxShadow: `0 0 6px ${T.amber}` }} />
            <span style={{ color: T.amber, fontSize: 11, fontWeight: 700 }}>{totalPending} pending</span>
          </div>}
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Pending Expenses", value: pendingExpenses.length, color: pendingExpenses.length > 0 ? T.amber : T.teal },
          { label: "Budget Requests", value: pendingBudgets.length, color: pendingBudgets.length > 0 ? T.magenta : T.teal },
          { label: "Payment Requests", value: pendingPayments.length, color: pendingPayments.length > 0 ? T.cyan : T.teal },
        ].map((k, i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 24, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 600, marginTop: 4, textTransform: "uppercase", letterSpacing: "0.06em" }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Expense Approvals */}
      {expenses.length > 0 && (
        <div style={{ marginBottom: 28 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
            <div style={{ width: 3, height: 20, background: T.amber, borderRadius: 2 }} />
            <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>Expense Approvals</div>
          </div>
          {expenses.map(e => (
            <Card key={e.id} style={{ marginBottom: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14 }}>{e.description}</div>
                  <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>
                    {e.category && <span style={{ background: T.cyan + "20", color: T.cyan, padding: "2px 8px", borderRadius: 4, fontSize: 11, fontWeight: 600, marginRight: 8 }}>{e.category}</span>}
                    {e.event_name && <span> {e.event_name} · </span>}
                    {e.vendor && <span> {e.vendor} · </span>}
                    {e.date}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ color: T.amber, fontWeight: 800, fontSize: 18 }}>{getCurrency(user?.country||"Ghana")+" "+((e.amount || 0).toLocaleString()).toLocaleString()}</div>
                  <span style={{ fontSize: 11, fontWeight: 600, color: e.approval_status === "approved" ? T.teal : e.approval_status === "rejected" ? "#F43F5E" : T.amber }}>
                    {e.approval_status === "approved" ? " Approved" : e.approval_status === "rejected" ? " Rejected" : "⏳ Pending"}
                  </span>
                </div>
              </div>
              {e.receipt_url && <a href={e.receipt_url} target="_blank" rel="noopener noreferrer" style={{ color: T.cyan, fontSize: 12, fontWeight: 600, textDecoration: "none", display: "block", marginBottom: 10 }}> View Receipt</a>}
              {canApprove && e.approval_status === "pending" && (
                <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                  <button onClick={() => handleExpense(e.id, "approved")} disabled={saving === e.id} style={{ flex: 1, background: T.teal + "20", border: "1px solid " + T.teal, color: T.teal, padding: "8px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Approve</button>
                  <button onClick={() => handleExpense(e.id, "rejected")} disabled={saving === e.id} style={{ flex: 1, background: "#F43F5E20", border: "1px solid #F43F5E", color: "#F43F5E", padding: "8px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Reject</button>
                </div>
              )}
            </Card>
          ))}
        </div>
      )}

      {/* Budget Requests */}
      {budgetRequests.length > 0 && (
        <div style={{ marginBottom: 28 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
            <div style={{ width: 3, height: 20, background: T.magenta, borderRadius: 2 }} />
            <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>Budget Increase Requests</div>
          </div>
          {budgetRequests.map(b => (
            <Card key={b.id} style={{ marginBottom: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14 }}> {b.event_name}</div>
                  <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Current: GHS {(b.current_budget || 0).toLocaleString()} · Requesting: GHS {(b.requested_amount || 0).toLocaleString()}</div>
                  {b.reason && <div style={{ color: T.textSecondary, fontSize: 12, marginTop: 6, fontStyle: "italic" }}>{b.reason}</div>}
                </div>
                <span style={{ fontSize: 11, fontWeight: 600, color: b.status === "approved" ? T.teal : b.status === "rejected" ? "#F43F5E" : T.amber }}>
                  {b.status === "approved" ? " Approved" : b.status === "rejected" ? " Rejected" : "⏳ Pending"}
                </span>
              </div>
              {canApprove && b.status === "pending" && (
                <div style={{ display: "flex", gap: 8 }}>
                  <button onClick={() => handleBudget(b, "approved")} disabled={saving === b.id} style={{ flex: 1, background: T.teal + "20", border: "1px solid " + T.teal, color: T.teal, padding: "8px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Approve + GHS {(b.requested_amount || 0).toLocaleString()}</button>
                  <button onClick={() => handleBudget(b, "rejected")} disabled={saving === b.id} style={{ flex: 1, background: "#F43F5E20", border: "1px solid #F43F5E", color: "#F43F5E", padding: "8px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Reject</button>
                </div>
              )}
            </Card>
          ))}
        </div>
      )}

      {/* Payment Requests */}
      {paymentRequests.length > 0 && (
        <div style={{ marginBottom: 28 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
            <div style={{ width: 3, height: 20, background: T.cyan, borderRadius: 2 }} />
            <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>Invoice Payment Requests</div>
          </div>
          {paymentRequests.map(p => (
            <Card key={p.id} style={{ marginBottom: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14 }}> {p.vendor}</div>
                  <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}> {p.event_name}</div>
                  {p.notes && <div style={{ color: T.textSecondary, fontSize: 12, marginTop: 6, fontStyle: "italic" }}>{p.notes}</div>}
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ color: T.cyan, fontWeight: 800, fontSize: 18 }}>{getCurrency(user?.country||"Ghana")+" "+((p.amount || 0).toLocaleString()).toLocaleString()}</div>
                  <span style={{ fontSize: 11, fontWeight: 600, color: p.status === "approved" ? T.teal : p.status === "rejected" ? "#F43F5E" : T.amber }}>
                    {p.status === "approved" ? " Payment Approved" : p.status === "rejected" ? " Rejected" : "⏳ Pending"}
                  </span>
                </div>
              </div>
              {canApprove && p.status === "pending" && (
                <div style={{ display: "flex", gap: 8 }}>
                  <button onClick={() => handlePayment(p, "approved")} disabled={saving === p.id} style={{ flex: 1, background: T.teal + "20", border: "1px solid " + T.teal, color: T.teal, padding: "8px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Approve Payment</button>
                  <button onClick={() => handlePayment(p, "rejected")} disabled={saving === p.id} style={{ flex: 1, background: "#F43F5E20", border: "1px solid #F43F5E", color: "#F43F5E", padding: "8px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}> Reject</button>
                </div>
              )}
            </Card>
          ))}
        </div>
      )}

      {totalPending === 0 && (
        <Card style={{ textAlign: "center", padding: 60 }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>All caught up!</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>No pending finance approvals.</div>
        </Card>
      )}
    </div>
  );
};


const OpportunitiesView = ({ user, onNavigate, activeCountry = "All" }) => {
  const [opportunities, setOpportunities] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [sectorFilter, setSectorFilter] = useState("all");
  const [presenceFilter, setPresenceFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ company: "", sector: "", presence: activeCountry === "Nigeria" ? "NG" : "GH", event_fit: "", notes: "", status: "New", contact_name: "", contact_email: "", contact_phone: "", contact_title: "", estimated_value: "", expected_event_date: "", event_type: "", source: "Direct Outreach", city: activeCountry === "Nigeria" ? "Lagos" : "Accra", website: "" });
  const [expandedOpp, setExpandedOpp] = useState(null);
  const [oppActivities, setOppActivities] = useState({});
  const [actForm, setActForm] = useState({ type: "note", content: "", scheduled_date: "", scheduled_time: "" });
  const [addingAct, setAddingAct] = useState(false);

  const canManage = ["CEO", "Sales & Marketing", "Country Manager"].includes(user?.role) || user?.has_sm_access;

  const load = async () => {
    const acFilter = activeCountry && activeCountry !== "All";
    let query = acFilter ? supabase.from("opportunities").select("*").eq("country",activeCountry).order("company") : supabase.from("opportunities").select("*").order("company");
    // Kofi (has_sm_access but not CEO/S&M) only sees assigned or created by him
    if (user?.has_sm_access && !["CEO","Sales & Marketing","Country Manager"].includes(user?.role)) {
      query = supabase.from("opportunities").select("*").or(`assigned_to.eq.${user.id},created_by.eq.${user.id}`).order("company");
    }
    const { data } = await query;
    setOpportunities(data || []);
  };

  const loadActivities = async (oppId) => {
    const { data } = await supabase.from("opportunity_activities").select("*").eq("opportunity_id", oppId).order("created_at", { ascending: false });
    setOppActivities(prev => ({ ...prev, [oppId]: data || [] }));
  };

  const addActivity = async (oppId, company) => {
    if (!actForm.content) return;
    setAddingAct(true);
    const { error: actErr } = await supabase.from("opportunity_activities").insert({
      opportunity_id: oppId,
      type: actForm.type,
      content: actForm.content,
      scheduled_date: actForm.scheduled_date || null,
      scheduled_time: actForm.scheduled_time || null,
      created_by: user?.id,
      created_by_name: user?.name,
    });
    if (actErr) { alert("Error saving activity: " + actErr.message); setAddingAct(false); return; }
    // Notify CEO if logged by non-CEO
    if (user?.role !== "CEO") {
      const { data: ceos } = await supabase.from("profiles").select("id").eq("role","CEO");
      for (const ceo of ceos||[]) {
        await supabase.from("notifications").insert({ user_id: ceo.id, title: "S&M Activity — " + company, message: user.name + " logged a " + actForm.type + " on " + company + ": " + actForm.content, type: "crm" });
      }
    }
    // If scheduled — add to itineraries for calendar
    if (af.scheduled_date && ["call","meeting","demo","follow-up"].includes(af.type)) {
      await supabase.from("itineraries").insert({
        title: `${af.type.charAt(0).toUpperCase()+actForm.type.slice(1)} — ${company}`,
        week_start: actForm.scheduled_date,
        items: JSON.stringify([{
          date: actForm.scheduled_date,
          time: actForm.scheduled_time || "09:00",
          company,
          action: actForm.type,
          notes: actForm.content,
        }]),
        created_by: user.id,
      });
      // Notify assigned sales team
      const { data: sales } = await supabase.from("profiles").select("id, email, name").eq("role", "Sales & Marketing");
      for (const s of sales || []) {
        await supabase.from("notifications").insert({ user_id: s.id, title: `Follow-up Scheduled — ${company}`, message: `${actForm.type} scheduled on ${actForm.scheduled_date}${actForm.scheduled_time ? " at " + actForm.scheduled_time : ""} for ${company}`, type: "crm" });
        if (s.email) await sendEmail(s.email, `Follow-up Scheduled — ${company}`, notifEmailHtml({ name: s.name, title: `${actForm.type} Scheduled`, message: `A <strong>${actForm.type}</strong> has been scheduled for <strong>${company}</strong> on <strong>${actForm.scheduled_date}${actForm.scheduled_time ? " at " + actForm.scheduled_time : ""}</strong>.<br><br><em>${actForm.content}</em>`, actionUrl: BASE_URL, actionLabel: "View in WorkRoom" }));
      }
    }
    setActForm({ type: "note", content: "", scheduled_date: "", scheduled_time: "" });
    setAddingAct(false);
    loadActivities(oppId);
  };

  useEffect(() => { load(); }, [activeCountry]);

  useEffect(() => {
    let f = [...opportunities];
    // Hide converted by default unless specifically filtered
    if (statusFilter === "all") f = f.filter(o => o.status !== "Converted");
    if (search) f = f.filter(o => o.company.toLowerCase().includes(search.toLowerCase()) || o.sector?.toLowerCase().includes(search.toLowerCase()));
    if (sectorFilter !== "all") f = f.filter(o => o.sector === sectorFilter);
    if (presenceFilter !== "all") f = f.filter(o => o.presence === presenceFilter);
    if (statusFilter !== "all") f = f.filter(o => o.status === statusFilter);
    setFiltered(f);
  }, [opportunities, search, sectorFilter, presenceFilter, statusFilter]);

  const sectors = [...new Set(opportunities.map(o => o.sector).filter(Boolean))].sort();
  const statuses = ["New", "Contacted", "Qualified", "Converted"];
  const statusColors = { New: T.cyan, Contacted: T.amber, Qualified: T.teal, Converted: "#10B981" };
  const presenceColors = { GH: T.cyan, NG: T.amber, KE: T.teal };

  const handleAdd = async () => {
    if (!form.company) return;
    setSaving(true);
    await supabase.from("opportunities").insert({
      company: form.company,
      sector: form.sector,
      presence: form.presence,
      event_fit: form.event_fit,
      notes: form.notes,
      status: form.status || "New",
      contact_name: form.contact_name,
      contact_email: form.contact_email,
      contact_phone: form.contact_phone,
      contact_title: form.contact_title,
      value: parseFloat(form.estimated_value) || 0,
      event_type: form.event_type,
      event_date: form.expected_event_date || null,
      source: form.source,
      city: form.city,
      website: form.website,
      country: user?.country || activeCountry || 'Ghana',
      created_by: user?.id,
      assigned_to: user?.id,
    });
    setSaving(false);
    setModal(false);
    setForm({ company: "", sector: "", presence: activeCountry === "Nigeria" ? "NG" : "GH", event_fit: "", notes: "", status: "New", contact_name: "", contact_email: "", contact_phone: "", contact_title: "", estimated_value: "", expected_event_date: "", event_type: "", source: "Direct Outreach", city: activeCountry === "Nigeria" ? "Lagos" : "Accra", website: "" });
    load();
  };

  const handleUpdate = async () => {
    setSaving(true);
    await supabase.from("opportunities").update({
      company: editModal.company, sector: editModal.sector,
      presence: editModal.presence, event_fit: editModal.event_fit,
      notes: editModal.notes, status: editModal.status,
      contact_name: editModal.contact_name || "",
      contact_email: editModal.contact_email || "",
      contact_phone: editModal.contact_phone || "",
      contact_title: editModal.contact_title || "",
      city: editModal.city || "",
      value: parseFloat(editModal.value) || 0,
      event_type: editModal.event_type || "",
      website: editModal.website || "",
      updated_at: new Date().toISOString(),
    }).eq("id", editModal.id);
    if (user.role !== "CEO") {
      const { data: ceos } = await supabase.from("profiles").select("id").eq("role","CEO");
      for (const ceo of ceos||[]) {
        await supabase.from("notifications").insert({ user_id: ceo.id, title: "Opportunity Updated — " + editModal.company, message: user.name + " updated " + editModal.company + " to: " + editModal.status, type: "crm" });
      }
    }
    setSaving(false);
    setEditModal(null);
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Remove this opportunity?")) return;
    await supabase.from("opportunities").delete().eq("id", id);
    load();
  };

  const handleConvert = async (opp) => {
    if (!window.confirm('Convert ' + opp.company + ' to a Lead?')) return;
    setSaving(true);
    const res = await supabase.from('leads').insert({
      company: opp.company,
      contact_name: opp.contact_name || '',
      email: opp.contact_email || opp.email || '',
      phone: opp.contact_phone || opp.phone || '',
      status: 'new',
      value: 0,
      notes: 'Converted from Opportunities.',
      source: 'Opportunities',
      created_by: user?.id,
      assigned_to: opp.assigned_to || user?.id,
      assigned_name: opp.assigned_name || user?.name || '',
      sales_rep_id: opp.assigned_to || user?.id,
      sales_rep_name: opp.assigned_name || user?.name || '',
      country: opp.country || user?.country || 'Ghana',
    }).select().single();
    if (!res.error && res.data) {
      await supabase.from('opportunities').update({ status: 'Converted', converted_at: new Date().toISOString() }).eq('id', opp.id);
      setSaving(false);
      load();
      if (onNavigate) onNavigate('crm');
    } else {
      alert('Failed: ' + (res.error && res.error.message));
      setSaving(false);
    }
  };

  const inputStyle = { width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };
  const labelStyle = { color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 };

  const PresencePills = ({ presence }) => (
    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
      {(presence || "").split("+").map(p => (
        <span key={p} style={{ background: (presenceColors[p] || T.textMuted) + "18", color: presenceColors[p] || T.textMuted, border: `1px solid ${presenceColors[p] || T.textMuted}30`, borderRadius: 20, padding: "1px 8px", fontSize: 9, fontWeight: 800 }}>{p}</span>
      ))}
    </div>
  );

  const converted = opportunities.filter(o => o.status === "Converted").length;
  const qualified = opportunities.filter(o => o.status === "Qualified").length;
  const contacted = opportunities.filter(o => o.status === "Contacted").length;
  const panAfrica = opportunities.filter(o => o.presence === "GH+NG+KE").length;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>CRM</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Opportunities</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{opportunities.length} target companies · {converted} converted to leads</div>
        </div>
        <div style={{ display:"flex", gap:8 }}>
          {canManage && <button onClick={() => setModal(true)} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700, letterSpacing: "0.06em" }}>+ Add Opportunity</button>}
        </div>
      </div>

      {/* Workflow banner */}
      <div style={{ display:"flex", alignItems:"center", gap:0, marginBottom:20, background:T.surface, border:`1px solid ${T.border}`, borderRadius:10, overflow:"hidden" }}>
        {[
          { step:"1", label:"Add Opportunity", desc:"Identify prospect", color:T.cyan },
          { step:"2", label:"Qualify & Contact", desc:"Research and reach out", color:T.teal },
          { step:"3", label:"Convert to Lead", desc:"Assign to sales rep", color:"#10B981" },
          { step:"4", label:"Won", desc:"Client confirmed", color:T.amber },
          { step:"5", label:"Client & Event", desc:"Create event", color:"#8B5CF6" },
        ].map((s, i) => (
          <div key={s.step} style={{ flex:1, padding:"10px 14px", borderRight:i<4?`1px solid ${T.border}`:"none", display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ width:24, height:24, borderRadius:"50%", background:s.color+"20", border:`1px solid ${s.color}40`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <span style={{ color:s.color, fontSize:10, fontWeight:800 }}>{s.step}</span>
            </div>
            <div>
              <div style={{ color:T.textPrimary, fontSize:11, fontWeight:700 }}>{s.label}</div>
              <div style={{ color:T.textMuted, fontSize:9 }}>{s.desc}</div>
            </div>
          </div>
        ))}
      </div>

      {/* KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Total", value: opportunities.length, color: T.blue },
          { label: "Contacted", value: contacted, color: T.amber },
          { label: "Qualified", value: qualified, color: T.teal },
          { label: "Converted", value: converted, color: "#10B981" },
          { label: "Pan-Africa", value: panAfrica, color: T.magenta },
        ].map((k, i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 20, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search company or sector..." style={{ ...inputStyle, width: 220, flex: "none" }} />
        <select value={sectorFilter} onChange={e => setSectorFilter(e.target.value)} style={{ ...inputStyle, width: "auto", flex: "none" }}>
          <option value="all">All Sectors</option>
          {sectors.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <select value={presenceFilter} onChange={e => setPresenceFilter(e.target.value)} style={{ ...inputStyle, width: "auto", flex: "none" }}>
          <option value="all">All Presence</option>
          <option value="GH+NG+KE">GH + NG + KE</option>
          <option value="GH+NG">GH + NG</option>
          <option value="GH+KE">GH + KE</option>
          <option value="GH">GH Only</option>
        </select>
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} style={{ ...inputStyle, width: "auto", flex: "none" }}>
          <option value="all">All Status</option>
          {statuses.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <span style={{ color: T.textMuted, fontSize: 11, marginLeft: "auto" }}>{filtered.length} results</span>
      </div>

      {/* Table */}
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
            <thead>
              <tr style={{ borderBottom: `1px solid ${T.border}`, background: T.bg }}>
                {["Company", "Sector", "Presence", "Event Fit", "Notes", "Status", ""].map((h, i) => (
                  <th key={i} style={{ padding: "12px 16px", textAlign: "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((o, i) => {
                const statusColor = statusColors[o.status] || T.textMuted;
                return (
                  <React.Fragment key={o.id}>
                  <tr style={{ borderBottom: expandedOpp !== o.id && i < filtered.length - 1 ? `1px solid ${T.border}44` : "none", transition: "background 0.15s" }}
                    onMouseEnter={e => e.currentTarget.style.background = T.bg}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                    <td style={{ padding: "12px 16px" }}>
                      <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13 }}>{o.company}</div>
                      {o.contact_name && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}> {o.contact_name}</div>}
                      {o.contact_email && <div style={{ color: T.cyan, fontSize: 11 }}> {o.contact_email}</div>}
                      {o.contact_phone && <div style={{ color: T.textMuted, fontSize: 11 }}> {o.contact_phone}</div>}
                    </td>
                    <td style={{ padding: "12px 16px" }}>
                      <span style={{ color: T.textMuted, fontSize: 12 }}>{o.sector}</span>
                      {o.city && <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>{o.city}</div>}
                    </td>
                    <td style={{ padding: "12px 16px" }}>
                      <PresencePills presence={o.presence} />
                    </td>
                    <td style={{ padding: "12px 16px", maxWidth: 200 }}>
                      <span style={{ color: T.textSecondary, fontSize: 12, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{o.event_fit}</span>
                    </td>
                    <td style={{ padding: "12px 16px", maxWidth: 200 }}>
                      <span style={{ color: T.textMuted, fontSize: 12, fontStyle: "italic", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{o.notes}</span>
                    </td>
                    <td style={{ padding: "12px 16px" }}>
                      <span style={{ background: statusColor + "18", color: statusColor, border: `1px solid ${statusColor}30`, borderRadius: 20, padding: "3px 10px", fontSize: 10, fontWeight: 700, textTransform: "uppercase", whiteSpace: "nowrap" }}>{o.status}</span>
                    </td>
                    <td style={{ padding: "12px 16px" }}>
                      {canManage && (
                        <div style={{ display: "flex", gap: 6 }}>
                          <button onClick={() => setEditModal({ ...o })} style={{ background: T.cyan + "15", border: `1px solid ${T.cyan}30`, color: T.cyan, padding: "4px 10px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}>Edit</button>
                          <button onClick={() => { const isOpen = expandedOpp === o.id; setExpandedOpp(isOpen ? null : o.id); if (!isOpen) loadActivities(o.id); }} style={{ background: expandedOpp === o.id ? "#8B5CF620" : T.surface, border: `1px solid ${expandedOpp === o.id ? "#8B5CF6" : T.border}`, color: expandedOpp === o.id ? "#8B5CF6" : T.textMuted, padding: "4px 10px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}>
                             {(oppActivities[o.id]||[]).length > 0 ? oppActivities[o.id].length : "Notes"}
                          </button>
                          {o.status !== "Converted" && (
                            <button onClick={() => handleConvert(o)} style={{ background: "linear-gradient(135deg,#10B981,#059669)", border: "none", color: "#fff", padding: "6px 14px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 800, whiteSpace: "nowrap" }}>Convert to Lead</button>
                          )}
                          {["CEO","Administrator"].includes(user?.role) && (
                            <button onClick={async () => {
                              const { data: smUsers } = await supabase.from("profiles").select("id,name").or("role.eq.Sales & Marketing,has_sm_access.eq.true").neq("id", user.id);
                              if (!smUsers?.length) { alert("No S&M staff found"); return; }
                              const names = smUsers.map((u,i) => (i+1)+". "+u.name).join("\n");
                              const choice = window.prompt("Assign to:\n"+names+"\n\nEnter number:");
                              const picked = smUsers[parseInt(choice)-1];
                              if (!picked) return;
                              await supabase.from("opportunities").update({ assigned_to: picked.id, assigned_name: picked.name }).eq("id", o.id);
                              await supabase.from("notifications").insert({ user_id: picked.id, title: "Opportunity Assigned — "+o.company, message: "CEO assigned "+o.company+" to you. Check your Opportunities pipeline.", type: "crm" });
                              load();
                            }} style={{ background: T.amber+"15", border: `1px solid ${T.amber}30`, color: T.amber, padding: "4px 10px", borderRadius: 6, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Assign</button>
                          )}
                          <button onClick={() => handleDelete(o.id)} style={{ background: T.red + "15", border: `1px solid ${T.red}30`, color: T.red, padding: "4px 8px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>×</button>
                        </div>
                      )}
                    </td>
                  </tr>
                  {/* Notes Thread Row */}
                  {expandedOpp === o.id && (
                    <tr key={o.id + "_notes"}>
                      <td colSpan={8} style={{ padding: "0 12px 12px", background: T.bg }}>
                        <div style={{ border: `1px solid #8B5CF630`, borderRadius: 10, padding: "14px 16px", background: T.surface }}>
                          <div style={{ color: "#8B5CF6", fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>Notes & Follow-ups — {o.company}</div>

                          {/* Add Activity */}
                          {canManage && (
                            <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "12px 14px", marginBottom: 12 }}>
                              <div style={{ display: "flex", gap: 6, marginBottom: 8, flexWrap: "wrap" }}>
                                {["note","call","meeting","email","demo","follow-up"].map(t => (
                                  <button key={t} onClick={() => setActForm(f => ({...f, type: t}))} style={{ padding: "3px 10px", borderRadius: 20, border: `1px solid ${actForm.type === t ? "#8B5CF6" : T.border}`, background: actForm.type === t ? "#8B5CF620" : "none", color: actForm.type === t ? "#8B5CF6" : T.textMuted, fontSize: 10, fontWeight: 700, cursor: "pointer", textTransform: "uppercase" }}>{t}</button>
                                ))}
                              </div>
                              <textarea value={actForm.content} onChange={e => setActForm(f => ({...f, content: e.target.value}))} placeholder={`Add ${actForm.type}...`} rows={2} style={{ width: "100%", padding: "8px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none", resize: "none", boxSizing: "border-box", marginBottom: 6 }} />
                              {["call","meeting","demo","follow-up"].includes(actForm.type) && (
                                <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                                  <input type="date" value={actForm.scheduled_date} onChange={e => setActForm(f => ({...f, scheduled_date: e.target.value}))} style={{ flex: 1, padding: "6px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                                  <input type="time" value={actForm.scheduled_time} onChange={e => setActForm(f => ({...f, scheduled_time: e.target.value}))} style={{ flex: 1, padding: "6px 10px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 6, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                                </div>
                              )}
                              {actForm.scheduled_date && <div style={{ color: "#8B5CF6", fontSize: 11, fontWeight: 700, marginBottom: 6 }}> Will be added to calendar on {actForm.scheduled_date}{actForm.scheduled_time ? " at " + actForm.scheduled_time : ""}</div>}
                              <button onClick={() => addActivity(o.id, o.company)} disabled={addingAct || !actForm.content} style={{ background: "#8B5CF6", border: "none", color: "#fff", padding: "6px 16px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 700, opacity: !actForm.content ? 0.5 : 1 }}>{addingAct ? "Adding..." : "Add"}</button>
                            </div>
                          )}

                          {/* Thread */}
                          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                            {(oppActivities[o.id]||[]).length === 0 && <div style={{ color: T.textMuted, fontSize: 12, textAlign: "center", padding: "8px 0" }}>No notes yet.</div>}
                            {(oppActivities[o.id]||[]).map(act => {
                              const typeColors = { note: T.textMuted, call: T.teal, meeting: T.cyan, email: T.blue, demo: T.amber, "follow-up": "#8B5CF6" };
                              const color = typeColors[act.type] || T.textMuted;
                              return (
                                <div key={act.id} style={{ background: T.bg, border: `1px solid ${T.border}`, borderLeft: `3px solid ${color}`, borderRadius: 6, padding: "10px 12px" }}>
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                                    <span style={{ background: color+"18", color, borderRadius: 20, padding: "1px 8px", fontSize: 9, fontWeight: 800, textTransform: "uppercase" }}>{act.type}</span>
                                    <span style={{ color: T.textMuted, fontSize: 10 }}>{new Date(act.created_at).toLocaleDateString("en-GB")} · {act.created_by_name}</span>
                                  </div>
                                  <div style={{ color: T.textPrimary, fontSize: 12, lineHeight: 1.5 }}>{act.content}</div>
                                  {act.scheduled_date && <div style={{ color: "#8B5CF6", fontSize: 11, fontWeight: 700, marginTop: 4 }}> {act.scheduled_date}{act.scheduled_time ? " at " + act.scheduled_time : ""} — on calendar</div>}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
          {filtered.length === 0 && (
            <div style={{ textAlign: "center", padding: "40px 0", color: T.textMuted, fontSize: 13 }}>No leads match your filters.</div>
          )}
        </div>
      </div>

      {/* Add Modal */}
      {modal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 500, background: "rgba(0,0,0,0.7)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setModal(false)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 540, padding: 28, boxShadow: `0 24px 80px rgba(0,0,0,0.4)`, animation: "fadeUp 0.25s ease" }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 20 }}>Add Opportunity</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
              <div><label style={labelStyle}>Company Name *</label><input value={form.company} onChange={e => setForm({ ...form, company: e.target.value })} style={inputStyle} placeholder="e.g. GTBank Nigeria" /></div>
              <div><label style={labelStyle}>Sector *</label>
                <select value={form.sector} onChange={e => setForm({ ...form, sector: e.target.value })} style={inputStyle}>
                  <option value="">Select sector...</option>
                  {["Banking & Finance","Insurance","Oil & Gas","Telecoms","FMCG","Healthcare","Technology","Real Estate","Aviation","Government & Public Sector","NGO & Development","Manufacturing","Retail","Education","Professional Services","Media & Entertainment","Agriculture","Other"].map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
              <div><label style={labelStyle}>Contact Person</label><input value={form.contact_name} onChange={e => setForm({ ...form, contact_name: e.target.value })} style={inputStyle} placeholder="Full name" /></div>
              <div><label style={labelStyle}>Title / Position</label><input value={form.contact_title} onChange={e => setForm({ ...form, contact_title: e.target.value })} style={inputStyle} placeholder="e.g. Head of Events" /></div>
              <div><label style={labelStyle}>Email</label><input type="email" value={form.contact_email} onChange={e => setForm({ ...form, contact_email: e.target.value })} style={inputStyle} placeholder="contact@company.com" /></div>
              <div><label style={labelStyle}>Phone</label><input value={form.contact_phone} onChange={e => setForm({ ...form, contact_phone: e.target.value })} style={inputStyle} placeholder="+234 XXX XXX XXXX" /></div>
              <div><label style={labelStyle}>City</label>
                <select value={form.city} onChange={e => setForm({ ...form, city: e.target.value })} style={inputStyle}>
                  {activeCountry === "Nigeria" ? ["Lagos","Abuja","Port Harcourt","Kano","Ibadan","Other"].map(c => <option key={c}>{c}</option>) : ["Accra","Kumasi","Takoradi","Tamale","Other"].map(c => <option key={c}>{c}</option>)}
                </select>
              </div>
              <div><label style={labelStyle}>Estimated Value ({activeCountry === "Nigeria" ? "NGN" : "GHS"})</label><input type="number" value={form.estimated_value} onChange={e => setForm({ ...form, estimated_value: e.target.value })} style={inputStyle} placeholder="0" /></div>
              <div><label style={labelStyle}>Event Type</label>
                <select value={form.event_type} onChange={e => setForm({ ...form, event_type: e.target.value })} style={inputStyle}>
                  <option value="">Select...</option>
                  {["Conference","Summit","Awards Ceremony","Product Launch","Corporate Retreat","Annual General Meeting","Exhibition/Expo","Workshop/Training","Gala Dinner","Team Building","Hybrid Event","Virtual Event","Other"].map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
              <div><label style={labelStyle}>Expected Event Date</label><input type="date" value={form.expected_event_date} onChange={e => setForm({ ...form, expected_event_date: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>Source</label>
                <select value={form.source} onChange={e => setForm({ ...form, source: e.target.value })} style={inputStyle}>
                  {["Direct Outreach","Referral","LinkedIn","Conference","Website","Cold Call","Partnership","Other"].map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
              <div><label style={labelStyle}>Website</label><input value={form.website} onChange={e => setForm({ ...form, website: e.target.value })} style={inputStyle} placeholder="www.company.com" /></div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 14 }}>
              <div><label style={labelStyle}>Presence</label>
                <select value={form.presence} onChange={e => setForm({ ...form, presence: e.target.value })} style={inputStyle}>
                  <option value="GH">GH Only</option>
                  <option value="GH+NG">GH + NG</option>
                  <option value="GH+KE">GH + KE</option>
                  <option value="GH+NG+KE">GH + NG + KE</option>
                </select>
              </div>
              <div><label style={labelStyle}>Status</label>
                <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })} style={inputStyle}>
                  {statuses.map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
            </div>
            <div style={{ marginBottom: 14 }}><label style={labelStyle}>Event Fit</label><input value={form.event_fit} onChange={e => setForm({ ...form, event_fit: e.target.value })} style={inputStyle} placeholder="e.g. Brand activations, product launches" /></div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14, marginBottom: 14 }}>
              <div><label style={labelStyle}>Contact Name</label><input value={form.contact_name} onChange={e => setForm({ ...form, contact_name: e.target.value })} style={inputStyle} placeholder="John Mensah" /></div>
              <div><label style={labelStyle}>Email</label><input value={form.contact_email} onChange={e => setForm({ ...form, contact_email: e.target.value })} style={inputStyle} placeholder="john@company.com" /></div>
              <div><label style={labelStyle}>Phone</label><input value={form.contact_phone} onChange={e => setForm({ ...form, contact_phone: e.target.value })} style={inputStyle} placeholder="+233 XX XXX XXXX" /></div>
            </div>
            <div style={{ marginBottom: 20 }}><label style={labelStyle}>Notes</label><textarea value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} rows={3} style={{ ...inputStyle, resize: "vertical" }} placeholder="Follow-up notes, strategy, contact info..." /></div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleAdd} disabled={saving || !form.company} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 13, opacity: !form.company ? 0.5 : 1 }}>{saving ? "Saving..." : "Add Opportunity"}</button>
              <button onClick={() => setModal(false)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 500, background: "rgba(0,0,0,0.7)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setEditModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 16, width: "100%", maxWidth: 540, padding: 28, boxShadow: `0 24px 80px rgba(0,0,0,0.4)`, animation: "fadeUp 0.25s ease" }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 20 }}>Edit — {editModal.company}</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
              <div><label style={labelStyle}>Company Name</label><input value={editModal.company} onChange={e => setEditModal({ ...editModal, company: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>Sector</label>
                <select value={editModal.sector || ""} onChange={e => setEditModal({ ...editModal, sector: e.target.value })} style={inputStyle}>
                  <option value="">Select sector...</option>
                  {["Banking & Finance","Insurance","Oil & Gas","Telecoms","FMCG","Healthcare","Technology","Real Estate","Aviation","Government & Public Sector","NGO & Development","Manufacturing","Retail","Education","Professional Services","Media & Entertainment","Agriculture","Other"].map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
              <div><label style={labelStyle}>Contact Person</label><input value={editModal.contact_name || ""} onChange={e => setEditModal({ ...editModal, contact_name: e.target.value })} style={inputStyle} placeholder="Full name" /></div>
              <div><label style={labelStyle}>Title / Position</label><input value={editModal.contact_title || ""} onChange={e => setEditModal({ ...editModal, contact_title: e.target.value })} style={inputStyle} placeholder="e.g. Head of Events" /></div>
              <div><label style={labelStyle}>Email</label><input value={editModal.contact_email || ""} onChange={e => setEditModal({ ...editModal, contact_email: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>Phone</label><input value={editModal.contact_phone || ""} onChange={e => setEditModal({ ...editModal, contact_phone: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>City</label>
                <select value={editModal.city || ""} onChange={e => setEditModal({ ...editModal, city: e.target.value })} style={inputStyle}>
                  {(editModal.country === "Nigeria" ? ["Lagos","Abuja","Port Harcourt","Kano","Ibadan","Other"] : ["Accra","Kumasi","Takoradi","Tamale","Other"]).map(c => <option key={c}>{c}</option>)}
                </select>
              </div>
              <div><label style={labelStyle}>Estimated Value</label><input type="number" value={editModal.value || ""} onChange={e => setEditModal({ ...editModal, value: e.target.value })} style={inputStyle} /></div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
              <div><label style={labelStyle}>Presence</label>
                <select value={editModal.presence || "GH"} onChange={e => setEditModal({ ...editModal, presence: e.target.value })} style={inputStyle}>
                  <option value="GH">GH Only</option>
                  <option value="NG">NG Only</option>
                  <option value="GH+NG">GH + NG</option>
                  <option value="GH+KE">GH + KE</option>
                  <option value="GH+NG+KE">GH + NG + KE</option>
                </select>
              </div>
              <div><label style={labelStyle}>Status</label>
                <select value={editModal.status || "New"} onChange={e => setEditModal({ ...editModal, status: e.target.value })} style={inputStyle}>
                  {statuses.map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
            </div>
            <div style={{ marginBottom: 14 }}><label style={labelStyle}>Event Fit</label><input value={editModal.event_fit || ""} onChange={e => setEditModal({ ...editModal, event_fit: e.target.value })} style={inputStyle} /></div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14, marginBottom: 14 }}>
              <div><label style={labelStyle}>Contact Name</label><input value={editModal.contact_name || ""} onChange={e => setEditModal({ ...editModal, contact_name: e.target.value })} style={inputStyle} placeholder="John Mensah" /></div>
              <div><label style={labelStyle}>Email</label><input value={editModal.contact_email || ""} onChange={e => setEditModal({ ...editModal, contact_email: e.target.value })} style={inputStyle} placeholder="john@company.com" /></div>
              <div><label style={labelStyle}>Phone</label><input value={editModal.contact_phone || ""} onChange={e => setEditModal({ ...editModal, contact_phone: e.target.value })} style={inputStyle} placeholder="+233 XX XXX XXXX" /></div>
            </div>
            <div style={{ marginBottom: 20 }}><label style={labelStyle}>Notes / Follow-up</label><textarea value={editModal.notes || ""} onChange={e => setEditModal({ ...editModal, notes: e.target.value })} rows={3} style={{ ...inputStyle, resize: "vertical" }} /></div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={handleUpdate} disabled={saving} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 13 }}>{saving ? "Saving..." : "Save Changes"}</button>
              <button onClick={() => setEditModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "10px 20px", borderRadius: 8, cursor: "pointer", fontSize: 13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};



const VendorsView = ({ user, activeCountry = "All" }) => {
  const [rffs, setRffs] = useState([]);
  const [events, setEvents] = useState([]);
  const [clients, setClients] = useState([]);
  const [modal, setModal] = useState(false);
  const [expandedEvent, setExpandedEvent] = useState(null);
  const [showAppModal, setShowAppModal] = useState(false);
  const [showApprovalsPanel, setShowApprovalsPanel] = useState(false);
  const [vendorApps, setVendorApps] = useState([]);
  const [expandedRff, setExpandedRff] = useState(null);
  const [form, setForm] = useState({ title: '', description: '', client_id: '', client_name: '', project_id: '', event_name: '', deadline: '', event_type: '' });
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [resubmitModal, setResubmitModal] = useState(null);
  const [resubmitFile, setResubmitFile] = useState(null);
  const [resubmitNotes, setResubmitNotes] = useState('');
  const isVendorManager = user?.role === 'Vendor Manager';

  const load = async () => {
    const [r, e, c, apps] = await Promise.all([
      (activeCountry && activeCountry !== "All") ? supabase.from('rffs').select('*').eq('country',activeCountry).order('created_at',{ascending:false}) : supabase.from('rffs').select('*').order('created_at',{ascending:false}),
      (activeCountry && activeCountry !== "All") ? supabase.from('projects').select('*').eq('country',activeCountry) : supabase.from('projects').select('*'),
      (activeCountry && activeCountry !== "All") ? supabase.from('clients').select('*').eq('country',activeCountry) : supabase.from('clients').select('*'),
      supabase.from('vendor_applications').select('*').order('created_at', { ascending: false }),
    ]);
    // Show all RFFs for Vendor Manager/CEO/Admin
    setRffs(r.data || []);
    setEvents(e.data || []);
    setClients(c.data || []);
    setVendorApps(apps.data || []);
  };

  useEffect(() => { load(); }, [activeCountry]);

  const generateRffCode = async (eventType) => {
    const typeMap = { "Conference/Seminar": "CS", "Product Launch": "PL", "Awards Ceremony": "AWD", "Corporate Party": "CP", "Other": "OTH" };
    const prefix = typeMap[eventType] || "GEN";
    const year = new Date().getFullYear().toString().slice(-2);
    // Get or create sequence for this type+year
    const { data: seq } = await supabase.from("rff_sequences").select("*").eq("event_type", prefix).eq("year", parseInt("20"+year)).single();
    let nextSeq = 1;
    if (seq) {
      nextSeq = (seq.last_sequence || 0) + 1;
      await supabase.from("rff_sequences").update({ last_sequence: nextSeq }).eq("id", seq.id);
    } else {
      await supabase.from("rff_sequences").insert({ event_type: prefix, year: parseInt("20"+year), last_sequence: 1 });
    }
    const countryPrefix = (user?.country === "Nigeria" || activeCountry === "Nigeria") ? "NG" : "ST";
    return `${countryPrefix}/${prefix}/${year}/${String(nextSeq).padStart(3, "0")}`;
  };

  const handleCreate = async () => {
    if (!form.client_id || !form.project_id) { setError('Client and event are required.'); return; }
    if (!form.event_type) { setError('Please select an event type.'); return; }
    setSaving(true); setError('');
    let document_url = '';
    let document_name = '';
    if (file) {
      const ext = file.name.split('.').pop();
      const filename = `rff_${Date.now()}.${ext}`;
      const { error: uploadErr } = await supabase.storage.from('rffs').upload(filename, file);
      if (uploadErr) { setError('Upload failed: ' + uploadErr.message); setSaving(false); return; }
      const { data: urlData } = supabase.storage.from('rffs').getPublicUrl(filename);
      document_url = urlData.publicUrl;
      document_name = file.name;
    }
    const rffCode = await generateRffCode(form.event_type);
    const { error } = await supabase.from('rffs').insert({
      title: rffCode, description: form.description, quote_deadline: form.quote_deadline || null,
      client_id: form.client_id, client_name: form.client_name,
      project_id: form.project_id, event_name: form.event_name,
      deadline: form.deadline || null, document_url, document_name,
      status: 'pending', submitted_for_approval: true, approved: false,
      event_type: form.event_type, rff_code: rffCode,
      country: user?.country || activeCountry || 'Ghana',
    });
    if (error) { setError(error.message); setSaving(false); return; }
    // Notify CEO of new RFF pending approval
    const { data: ceos } = await supabase.from('profiles').select('id,email,name').in('role', ['CEO', 'Country Manager']);
    if (ceos) await Promise.all(ceos.map(c => supabase.from('notifications').insert({
      user_id: c.id,
      title: 'New RFF Pending Approval — ' + rffCode,
      message: `${user.name} has submitted RFF ${rffCode} for ${form.event_name}. Please review and approve.`,
      type: 'rff'
    })));
    setModal(false);
    setForm({ title: '', description: '', client_id: '', client_name: '', project_id: '', event_name: '', deadline: '', event_type: '' });
    setFile(null); setSaving(false); load();
  };

  const handleResubmit = async () => {
    setSaving(true);
    let document_url = resubmitModal.document_url || '';
    let document_name = resubmitModal.document_name || '';
    if (resubmitFile) {
      const ext = resubmitFile.name.split('.').pop();
      const filename = `rff_${Date.now()}.${ext}`;
      const { error: uploadErr } = await supabase.storage.from('rffs').upload(filename, resubmitFile);
      if (!uploadErr) {
        const { data: urlData } = supabase.storage.from('rffs').getPublicUrl(filename);
        document_url = urlData.publicUrl;
        document_name = resubmitFile.name;
      }
    }
    await supabase.from('rffs').update({
      status: 'pending',
      approved: false,
      submitted_for_approval: true,
      declined_notes: null,
      document_url,
      document_name,
      status_notes: resubmitNotes,
    }).eq('id', resubmitModal.id);
    // Notify CEO
    const { data: ceos } = await supabase.from('profiles').select('id').in('role', ['CEO', 'Country Manager']);
    if (ceos) await Promise.all(ceos.map(c => supabase.from('notifications').insert({ user_id: c.id, title: 'RFF Resubmitted', message: `RFF "${resubmitModal.title}" has been revised and resubmitted for approval.`, type: 'rff' })));
    setResubmitModal(null); setResubmitFile(null); setResubmitNotes('');
    setSaving(false); load();
  };

  // Group RFFs by event
  const grouped = events.reduce((acc, e) => {
    const eventRffs = rffs.filter(r => r.project_id === e.id);
    if (eventRffs.length > 0) acc[e.id] = { event: e, rffs: eventRffs };
    return acc;
  }, {});

  const totalPending = rffs.filter(r => r.status === 'pending').length;
  const totalApproved = rffs.filter(r => r.approved).length;
  const totalQuotes = rffs.filter(r => r.status === 'quote-submitted').length;
  const totalDeclined = rffs.filter(r => r.status === 'declined').length;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Procurement</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Vendors & RFFs</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{rffs.length} requests across {Object.keys(grouped).length} event{Object.keys(grouped).length !== 1 ? "s" : ""}</div>
        </div>
        <Btn onClick={() => setModal(true)}>+ New RFF</Btn>
      </div>

      {/* Vendor Applications Panel — CEO */}
      {showApprovalsPanel && user?.role === "CEO" && (
        <div style={{ marginBottom: 24, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: 20 }}>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 16, marginBottom: 16 }}>Vendor Applications</div>
          <VendorApprovalsPanel user={user} onLoginCreated={load} />
        </div>
      )}

      {/* Vendor Manager — approved vendors with account status */}
      {user?.role === "Vendor Manager" && vendorApps.filter(a => ["approved","login-created"].includes(a.status)).length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 12 }}>Approved Vendors — Account Status</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 12 }}>
            {vendorApps.filter(a => ["approved","login-created"].includes(a.status)).map(app => (
              <div key={app.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${app.status === "login-created" ? "#10B981" : T.amber}`, borderRadius: 10, padding: "14px 16px" }}>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, marginBottom: 2 }}>{app.vendor_name}</div>
                <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 6 }}>{app.vendor_type} · {app.contact_person}</div>
                <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 8 }}>{app.contact_email}</div>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: app.status === "login-created" ? "#10B981" : T.amber }} />
                  <span style={{ color: app.status === "login-created" ? "#10B981" : T.amber, fontSize: 11, fontWeight: 700 }}>
                    {app.status === "login-created" ? "Portal Access Granted" : "Awaiting Login Creation"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* KPI strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px,1fr))", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Pending Approval", value: totalPending, color: T.amber },
          { label: "CEO Approved", value: totalApproved, color: T.teal },
          { label: "Quotes In", value: totalQuotes, color: T.cyan },
          { label: "Declined", value: totalDeclined, color: T.red },
        ].map((k, i) => (
          <div key={i} style={{ padding: "16px 18px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 22, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {Object.keys(grouped).length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No RFFs yet</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>Create an RFF and assign it to a client event.</div>
        </div>
      ) : <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>{Object.values(grouped).map(({ event: e, rffs: eventRffs }) => (
        <div key={e.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
          {/* Event Group Header */}
          <button onClick={() => setExpandedEvent(expandedEvent === e.id ? null : e.id)} style={{
            width: "100%", background: expandedEvent === e.id ? T.cyan + "08" : "none",
            border: "none", borderBottom: expandedEvent === e.id ? `1px solid ${T.border}` : "none",
            padding: "16px 20px", cursor: "pointer",
            display: "flex", justifyContent: "space-between", alignItems: "center",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 4, height: 36, background: `linear-gradient(180deg, ${T.cyan}, ${T.teal})`, borderRadius: 2, flexShrink: 0 }} />
              <div style={{ textAlign: "left" }}>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>{e.name}</div>
                <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{e.client} · {eventRffs.length} RFF{eventRffs.length > 1 ? "s" : ""}</div>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ display: "flex", gap: 5 }}>
                {["pending","quote-received","quote-submitted","quote-approved","approved","declined"].map(s => {
                  const count = eventRffs.filter(r => r.status === s).length;
                  if (!count) return null;
                  return <Badge key={s} status={s} />;
                })}
              </div>
              <span style={{ color: T.textMuted, fontSize: 16, transition: "transform 0.2s", display: "inline-block", transform: expandedEvent === e.id ? "rotate(180deg)" : "rotate(0deg)" }}></span>
            </div>
          </button>

          {expandedEvent === e.id && (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 12, padding: "16px 20px" }}>
              {eventRffs.map(r => (
                <div key={r.id} style={{ marginBottom: 0 }}>
                  <div onClick={() => setExpandedRff(expandedRff === r.id ? null : r.id)} style={{ cursor: "pointer", background: T.bg, border: `1px solid ${T.border}`, borderTop: `2px solid ${T.cyan}`, borderRadius: 10, padding: "16px 18px", transition: "box-shadow 0.2s" }}
                    onMouseEnter={e => e.currentTarget.style.boxShadow = `0 4px 20px ${T.cyan}12`}
                    onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                      <div>
                        <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14 }}>{r.title}</div>
                        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}> Due {r.deadline}</div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}>
                          <div style={{ color: r.quote_deadline ? T.amber : T.textMuted, fontSize: 11, fontWeight: r.quote_deadline ? 700 : 400 }}>
                            {r.quote_deadline ? " Quote Due: " + new Date(r.quote_deadline).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "No quote deadline set"}
                          </div>
                          {isVendorManager && <button onClick={e => { e.stopPropagation(); const dl = window.prompt("Set quote deadline (YYYY-MM-DDTHH:MM):", r.quote_deadline ? r.quote_deadline.slice(0,16) : new Date(Date.now()+7*24*60*60*1000).toISOString().slice(0,16)); if (dl) { supabase.from("rffs").update({ quote_deadline: dl }).eq("id", r.id).then(() => load()); } }} style={{ background: T.amber+"15", border: "1px solid " + T.amber + "30", color: T.amber, padding: "2px 8px", borderRadius: 4, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Set Deadline</button>}
                          {user?.role === "CEO" && (
                            <button onClick={async e => {
                              e.stopPropagation();
                              if (!window.confirm(`Delete RFF "${r.rff_code}" and all related records? This cannot be undone.`)) return;
                              await Promise.all([
                                supabase.from("rff_vendor_assignments").delete().eq("rff_id", r.id),
                                supabase.from("rff_budgets").delete().eq("rff_id", r.id),
                                supabase.from("rff_awards").delete().eq("rff_id", r.id),
                              ]);
                              await supabase.from("rffs").delete().eq("id", r.id);
                              load();
                            }} style={{ background: T.red+"15", border: "1px solid "+T.red+"30", color: T.red, padding: "2px 8px", borderRadius: 4, cursor: "pointer", fontSize: 10, fontWeight: 700 }}> Delete RFF</button>
                          )}
                        </div>
                        {/* Status indicators for Vendor Manager */}
                        {isVendorManager && r.status === 'pending' && r.submitted_for_approval && (
                          <div style={{ marginTop: 6, display: "inline-flex", alignItems: "center", gap: 6, padding: "3px 10px", background: T.amber + "15", border: "1px solid " + T.amber + "33", borderRadius: 20 }}>
                            <div style={{ width: 6, height: 6, borderRadius: "50%", background: T.amber }} />
                            <span style={{ color: T.amber, fontSize: 11, fontWeight: 700 }}>Pending CEO Approval</span>
                          </div>
                        )}
                        {isVendorManager && r.status === 'approved' && (
                          <div style={{ marginTop: 6, display: "inline-flex", alignItems: "center", gap: 6, padding: "3px 10px", background: T.teal + "15", border: "1px solid " + T.teal + "33", borderRadius: 20 }}>
                            <span style={{ color: T.teal, fontSize: 11, fontWeight: 700 }}> Approved by CEO</span>
                          </div>
                        )}
                        {r.status === 'declined' && r.declined_notes && (
                          <div style={{ marginTop: 6, padding: "8px 10px", background: "#F43F5E10", border: "1px solid #F43F5E33", borderRadius: 6 }}>
                            <div style={{ color: "#F43F5E", fontSize: 11, fontWeight: 700 }}> Declined by CEO</div>
                            <div style={{ color: T.textSecondary, fontSize: 11, marginTop: 2 }}>{r.declined_notes}</div>
                            {isVendorManager && (
                              <button onClick={e => { e.stopPropagation(); setResubmitModal(r); setResubmitNotes(''); setResubmitFile(null); }} style={{ marginTop: 8, padding: "5px 12px", background: T.cyan + "20", border: "1px solid " + T.cyan + "44", borderRadius: 6, cursor: "pointer", color: T.cyan, fontSize: 11, fontWeight: 700 }}>
                                 Revise & Resubmit
                              </button>
                            )}
                          </div>
                        )}
                        {r.description && <div style={{ color: T.textSecondary, fontSize: 12, marginTop: 4 }}>{r.description}</div>}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Badge status={r.status} />
                        <span style={{ color: T.textMuted, fontSize: 14 }}>{expandedRff === r.id ? '' : ''}</span>
                      </div>
                    </div>
                    {r.document_url && (
                      <a href={r.document_url} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} style={{
                        display: 'inline-flex', alignItems: 'center', gap: 6,
                        color: T.cyan, fontSize: 12, fontWeight: 600, textDecoration: 'none',
                        background: T.cyan + '15', padding: '5px 12px', borderRadius: 6,
                        border: `1px solid ${T.cyan}33`,
                      }}> {r.document_name || 'Download RFF'}</a>
                    )}
                    {['CEO','Country Manager'].includes(user?.role) && !r.approved && (
                      <button onClick={async (e) => { e.stopPropagation(); await supabase.from('rffs').update({ approved: true, approved_by: user.id }).eq('id', r.id); load(); }} style={{
                        marginLeft: 8, background: T.teal + '20', border: `1px solid ${T.teal}`, color: T.teal,
                        padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600,
                      }}> Approve RFF</button>
                    )}
                    {r.approved && <span style={{ marginLeft: 8, color: T.teal, fontSize: 12, fontWeight: 600 }}> Approved for Vendors</span>}
                  </div>

                  {/* Quotes submitted for this RFF */}
                  {expandedRff === r.id && (
                    <div style={{ marginTop: 8, paddingLeft: 16 }}>
                      {r.status === 'pending' ? (
                        <div style={{ color: T.textMuted, fontSize: 13, padding: '12px 16px', background: T.surface, borderRadius: 8, border: `1px solid ${T.border}` }}>
                          ⏳ No quotes submitted yet
                        </div>
                      ) : (
                        <Card style={{ borderLeft: `3px solid ${T.cyan}` }}>
                          <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 12 }}>Quote Received</div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>{r.vendor || 'Vendor'}</div>
                            {(() => { const vp = vendors.find(v => v.name === r.vendor); if (!vp || !vp.vendor_scorecard_count) return <span style={{ fontSize: 10, color: T.textMuted, padding: '2px 8px', borderRadius: 20, border: '1px solid ' + T.border }}>Unrated</span>; const t = getTier(vp.vendor_score || 0); return <span style={{ fontSize: 10, fontWeight: 700, color: t.color, padding: '2px 8px', borderRadius: 20, background: t.bg, border: '1px solid ' + t.color + '44' }}>{t.label} {vp.vendor_score}%</span>; })()}
                          </div>
                              <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Amount: <span style={{ color: T.amber, fontWeight: 700 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+((r.amount || 0).toLocaleString()).toLocaleString()}</span></div>
                            </div>
                            <Badge status={r.status} />
                          </div>
                          {r.quote_url && (
                            <a href={r.quote_url} target="_blank" rel="noopener noreferrer" style={{
                              display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 12,
                              color: T.teal, fontSize: 12, fontWeight: 600, textDecoration: 'none',
                              background: T.teal + '15', padding: '5px 12px', borderRadius: 6,
                              border: `1px solid ${T.teal}33`,
                            }}> {r.quote_filename || 'View Quote'}</a>
                          )}
                          {(r.status === 'quote-submitted' || r.status === 'quote-received') && (
                            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                              <Btn small onClick={async () => {
                                // Update RFF status
                                await supabase.from('rffs').update({ status: 'quote-approved' }).eq('id', r.id);
                                // Update vendor assignment status
                                await supabase.from('rff_vendor_assignments').update({ status: 'quote-approved' }).eq('rff_id', r.id);
                                // Notify vendor
                                const { data: assigns } = await supabase.from('rff_vendor_assignments').select('vendor_id, profiles(name, email)').eq('rff_id', r.id);
                                for (const a of assigns || []) {
                                  await supabase.from('notifications').insert({ user_id: a.vendor_id, title: 'Quote Approved — ' + r.title, message: 'Your quote for "' + r.title + '" has been approved. You may now submit your invoice.', type: 'rff' });
                                }
                                load();
                              }}> Approve Quote</Btn>
                              <Btn small variant="ghost" onClick={async () => {
                                await supabase.from('rffs').update({ status: 'pending', quote_url: null, quote_filename: null }).eq('id', r.id);
                                await supabase.from('rff_vendor_assignments').update({ status: 'pending' }).eq('rff_id', r.id);
                                load();
                              }}> Reject</Btn>
                            </div>
                          )}
                          {r.status === 'quote-approved' && <div style={{ color: T.teal, fontSize: 12, fontWeight: 600, marginTop: 12 }}> Quote Approved — Awaiting Invoice</div>}
                          {/* Vendors assigned + deadline */}
                          <VendorAssignmentPanel rffId={r.id} quoteDeadline={r.quote_deadline} />
                        </Card>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}</div>}

      }{modal && (
        <Modal title="New RFF" onClose={() => { setModal(false); setError(''); }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: "0.06em", textTransform: "uppercase" }}>Event Type *</div>
            <select value={form.event_type} onChange={e => setForm({ ...form, event_type: e.target.value })} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${form.event_type ? T.border : T.amber}`, borderRadius: 8, color: form.event_type ? T.textPrimary : T.textMuted, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
              <option value="">Select event type...</option>
              <option value="Conference/Seminar">Conference / Seminar (ST/CS)</option>
              <option value="Product Launch">Product Launch (ST/PL)</option>
              <option value="Awards Ceremony">Awards Ceremony (ST/AWD)</option>
              <option value="Corporate Party">Corporate Party (ST/CP)</option>
              <option value="Other">Other (ST/OTH)</option>
            </select>
          </div>
          {form.event_type && (
            <div style={{ marginBottom: 14, padding: "8px 12px", background: T.cyan+"12", border: `1px solid ${T.cyan}30`, borderRadius: 8 }}>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>RFF Code Preview</div>
              <div style={{ color: T.cyan, fontWeight: 900, fontSize: 16 }}>ST/{{"Conference/Seminar":"CS","Product Launch":"PL","Awards Ceremony":"AWD","Corporate Party":"CP","Other":"OTH"}[form.event_type]}/{new Date().getFullYear().toString().slice(-2)}/###</div>
            </div>
          )}
          <Input label="Description" placeholder="Brief description of what's needed" value={form.description} onChange={v => setForm({ ...form, description: v })} />
          <Select label="Client" options={[{ value: '', label: 'Select client...' }, ...clients.map(c => ({ value: c.id, label: c.company || c.name }))]}
            value={form.client_id}
            onChange={v => { const c = clients.find(x => x.id === v); setForm({ ...form, client_id: v, client_name: c ? (c.company || c.name) : '', project_id: '', event_name: '' }); }} />
          <Select label="Event" options={[{ value: '', label: form.client_id ? 'Select event...' : 'Select client first...' }, ...events.filter(e => e.client_id === form.client_id).map(e => ({ value: e.id, label: e.name }))]}
            value={form.project_id}
            onChange={v => { const e = events.find(x => x.id === v); setForm({ ...form, project_id: v, event_name: e ? e.name : '' }); }} />
          <Input label="Deadline" type="date" value={form.deadline} onChange={v => setForm({ ...form, deadline: v })} />
          <div style={{ marginBottom: 16 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Upload RFF Document (PDF)</div>
            <input type="file" accept=".pdf" onChange={e => setFile(e.target.files[0])} style={{
              width: '100%', padding: '10px', background: T.bg,
              border: `1px solid ${T.border}`, borderRadius: 6,
              color: T.textSecondary, fontSize: 13, cursor: 'pointer',
            }} />
            {file && <div style={{ color: T.cyan, fontSize: 12, marginTop: 6 }}> {file.name}</div>}
          </div>
          {error && <div style={{ color: '#F43F5E', fontSize: 12, marginTop: 4 }}>{error}</div>}
          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <Btn onClick={handleCreate} disabled={saving}>{saving ? 'Uploading...' : 'Create RFF'}</Btn>
            <Btn variant="ghost" onClick={() => { setModal(false); setError(''); }}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};



const EventClientPortalPanel = ({ event, client, user, onClose }) => {
  const [milestones, setMilestones] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [messages, setMessages] = useState([]);
  const [feedback, setFeedback] = useState([]);
  const [activeSection, setActiveSection] = useState("milestones");
  const [milestoneForm, setMilestoneForm] = useState({ title: "", description: "", due_date: "", requires_approval: false, priority: "Medium" });
  const [showMilestoneForm, setShowMilestoneForm] = useState(false);
  const [docForm, setDocForm] = useState({ title: "", document_type: "Event Brief", requires_approval: false });
  const [docFile, setDocFile] = useState(null);
  const [showDocForm, setShowDocForm] = useState(false);
  const [reply, setReply] = useState("");
  const [saving, setSaving] = useState(false);
  const [sending, setSending] = useState(false);

  const load = async () => {
    const [ms, dc, mg, fb] = await Promise.all([
      supabase.from("client_milestones").select("*").eq("project_id", event.id).order("due_date"),
      supabase.from("event_documents").select("*").eq("project_id", event.id).order("created_at", { ascending: false }),
      supabase.from("client_messages").select("*").eq("project_id", event.id).order("created_at", { ascending: true }),
      supabase.from("client_feedback").select("*").eq("project_id", event.id).order("created_at", { ascending: false }),
    ]);
    setMilestones(ms.data || []);
    setDocuments(dc.data || []);
    setMessages(mg.data || []);
    setFeedback(fb.data || []);
  };

  useEffect(() => { load(); }, [event.id]);

  const notifyClient = async (title, message) => {
    const { data: cp } = await supabase.from("profiles").select("id").eq("email", client.email).single();
    if (cp) await supabase.from("notifications").insert({ user_id: cp.id, title, message, type: "task" });
  };

  const addMilestone = async () => {
    if (!milestoneForm.title) return;
    setSaving(true);
    await supabase.from("client_milestones").insert({
      project_id: event.id, title: milestoneForm.title,
      description: milestoneForm.description || null,
      due_date: milestoneForm.due_date || null,
      status: "pending", requires_approval: milestoneForm.requires_approval,
      priority: milestoneForm.priority || "Medium",
      created_by: user?.id,
    });
    await notifyClient("New Milestone — " + event.name, milestoneForm.title + " has been added to your event timeline.");
    setMilestoneForm({ title: "", description: "", due_date: "", requires_approval: false, priority: "Medium" });
    setShowMilestoneForm(false);
    setSaving(false);
    load();
  };

  const updateMilestoneStatus = async (id, status) => {
    await supabase.from("client_milestones").update({ status, completed_at: status === "completed" ? new Date().toISOString() : null }).eq("id", id);
    if (status === "completed") {
      const ms = milestones.find(m => m.id === id);
      if (ms) await notifyClient("Milestone Completed — " + ms.title, ms.title + " has been completed for " + event.name + ".");
    }
    load();
  };

  const shareDocument = async () => {
    if (!docForm.title) return;
    setSaving(true);
    let document_url = null;
    if (docFile) {
      const ext = docFile.name.split(".").pop();
      const fname = "client_doc_" + Date.now() + "." + ext;
      const { error: upErr } = await supabase.storage.from("vendor-docs").upload(fname, docFile);
      if (!upErr) {
        const { data: urlData } = supabase.storage.from("vendor-docs").getPublicUrl(fname);
        document_url = urlData.publicUrl;
      }
    }
    await supabase.from("event_documents").insert({
      project_id: event.id, client_id: client.id,
      title: docForm.title, document_type: docForm.document_type,
      document_url, shared_by: user.id, shared_by_name: user.name,
      requires_approval: docForm.requires_approval,
    });
    await notifyClient("Document Shared — " + docForm.title, docForm.title + " has been shared with you." + (docForm.requires_approval ? " Your approval is required." : ""));
    setDocForm({ title: "", document_type: "Event Brief", requires_approval: false });
    setDocFile(null);
    setShowDocForm(false);
    setSaving(false);
    load();
  };

  const sendReply = async () => {
    if (!reply.trim()) return;
    setSending(true);
    await supabase.from("client_messages").insert({
      project_id: event.id, client_id: client.id,
      sender_id: user.id, sender_name: user.name, sender_role: user.role,
      message: reply.trim(), read_by_client: false, read_by_team: true,
    });
    await notifyClient("New Message from Stretchfield", user.name + ": " + reply.trim().slice(0, 80));
    setReply("");
    setSending(false);
    load();
  };

  const unreadCount = messages.filter(m => m.sender_role === "Client" && !m.read_by_team).length;
  const inputStyle = { width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 4 }}>Client Portal</div>
          <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18 }}>{event.name}</div>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{client.company || client.name} · {event.phase}</div>
        </div>
        <button onClick={onClose} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, width: 32, height: 32, borderRadius: 8, cursor: "pointer", fontSize: 18 }}>×</button>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 4, marginBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        {[
          { id: "milestones", label: "Milestones (" + milestones.length + ")" },
          { id: "documents", label: "Documents (" + documents.length + ")" },
          { id: "messages", label: "Messages" + (unreadCount > 0 ? " (" + unreadCount + " new)" : "") },
          { id: "feedback", label: "Feedback (" + feedback.length + ")" },
        ].map(tab => (
          <button key={tab.id} onClick={() => setActiveSection(tab.id)} style={{ padding: "9px 16px", border: "none", background: "none", cursor: "pointer", color: activeSection === tab.id ? T.cyan : T.textMuted, fontWeight: activeSection === tab.id ? 800 : 400, fontSize: 12, borderBottom: activeSection === tab.id ? `2px solid ${T.cyan}` : "2px solid transparent", marginBottom: -1 }}>{tab.label}</button>
        ))}
      </div>

      {/* Milestones */}
      {activeSection === "milestones" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 12 }}>Visible to {client.company || client.name}</div>
            <button onClick={() => setShowMilestoneForm(!showMilestoneForm)} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "7px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>+ Add Milestone</button>
          </div>
          {showMilestoneForm && (
            <div style={{ background: T.surface, border: `1px solid ${T.cyan}30`, borderRadius: 10, padding: "16px", marginBottom: 14 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
                <div style={{ gridColumn: "1/-1" }}>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Title</label>
                  <input value={milestoneForm.title} onChange={e => setMilestoneForm(f => ({...f, title: e.target.value}))} placeholder="e.g. Venue Confirmed" style={inputStyle} />
                </div>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Due Date</label>
                  <input type="date" value={milestoneForm.due_date} onChange={e => setMilestoneForm(f => ({...f, due_date: e.target.value}))} style={inputStyle} />
                </div>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Priority</label>
                  <select value={milestoneForm.priority||"Medium"} onChange={e => setMilestoneForm(f => ({...f, priority: e.target.value}))} style={inputStyle}>
                    <option value="Critical">🔴 Critical</option>
                    <option value="High">🟠 High</option>
                    <option value="Medium">🟡 Medium</option>
                    <option value="Low">🟢 Low</option>
                  </select>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8, paddingTop: 18 }}>
                  <input type="checkbox" checked={milestoneForm.requires_approval} onChange={e => setMilestoneForm(f => ({...f, requires_approval: e.target.checked}))} id="ms_appr" />
                  <label htmlFor="ms_appr" style={{ color: T.textMuted, fontSize: 12 }}>Requires client approval</label>
                </div>
              </div>
              <textarea value={milestoneForm.description} onChange={e => setMilestoneForm(f => ({...f, description: e.target.value}))} placeholder="Description (optional)" rows={2} style={{ ...inputStyle, resize: "none", marginBottom: 10 }} />
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={addMilestone} disabled={saving || !milestoneForm.title} style={{ background: `linear-gradient(135deg, ${T.cyan}, ${T.teal})`, border: "none", color: "#fff", padding: "7px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>{saving ? "Saving..." : "Add"}</button>
                <button onClick={() => setShowMilestoneForm(false)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "7px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>Cancel</button>
              </div>
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {milestones.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "30px 0" }}>No milestones yet.</div>}
            {milestones.map(m => {
              const sc = { pending: T.textMuted, "in-progress": T.cyan, completed: T.teal };
              const c = sc[m.status] || T.textMuted;
              return (
                <div key={m.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderLeft: `3px solid ${c}`, borderRadius: 10, padding: "12px 16px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                      <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                        <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{m.title}</div>
                        {m.priority && <span style={{ background: m.priority==="Critical"?T.red+"20":m.priority==="High"?T.amber+"20":m.priority==="Medium"?T.cyan+"20":"#10B98120", color: m.priority==="Critical"?T.red:m.priority==="High"?T.amber:m.priority==="Medium"?T.cyan:"#10B981", borderRadius:20, padding:"1px 8px", fontSize:9, fontWeight:800 }}>{m.priority}</span>}
                      </div>
                      {m.description && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{m.description}</div>}
                      {m.due_date && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 3 }}>Due: {new Date(m.due_date).toLocaleDateString("en-GB")}</div>}
                      {m.requires_approval && <div style={{ color: m.approved_by_client ? T.teal : T.amber, fontSize: 10, fontWeight: 700, marginTop: 3 }}>{m.approved_by_client ? " Approved by client" : "Awaiting client approval"}</div>}
                    </div>
                    <div style={{ display: "flex", gap: 4 }}>
                      {["pending","in-progress","completed"].map(s => (
                        <button key={s} onClick={() => updateMilestoneStatus(m.id, s)} style={{ padding: "3px 8px", borderRadius: 5, border: `1px solid ${m.status === s ? c : T.border}`, background: m.status === s ? c+"20" : "none", color: m.status === s ? c : T.textMuted, fontSize: 9, fontWeight: 700, cursor: "pointer", textTransform: "uppercase" }}>{s}</button>
                      ))}
                    </div>
                  </div>
                  {/* Comment thread */}
                  <TaskCommentThread taskId={t.id} user={user} />
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Documents */}
      {activeSection === "documents" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 12 }}>Internal event documents</div>
            <button onClick={() => setShowDocForm(!showDocForm)} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "7px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>+ Upload</button>
          </div>
          {showDocForm && (
            <div style={{ background: T.surface, border: "1px solid " + T.cyan+"30", borderRadius: 12, padding: "16px 18px", marginBottom: 16 }}>
              <div style={{ display: "grid", gap: 10, marginBottom: 10 }}>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Title</label>
                  <input value={docForm.title} onChange={e => setDocForm(f => ({...f, title: e.target.value}))} placeholder="Document title" style={{ width: "100%", padding: "8px 12px", background: T.bg, border: "1px solid " + T.border, borderRadius: 7, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
                </div>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Type</label>
                  <select value={docForm.document_type} onChange={e => setDocForm(f => ({...f, document_type: e.target.value}))} style={{ width: "100%", padding: "8px 12px", background: T.bg, border: "1px solid " + T.border, borderRadius: 7, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
                    {["Event Brief","Run of Show","Proposal","Contract","Programme","Invoice","Other"].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
              </div>
              <input type="file" onChange={e => setDocFile(e.target.files[0])} style={{ width: "100%", padding: "8px", marginBottom: 10, cursor: "pointer" }} />
              {docFile && <div style={{ color: T.cyan, fontSize: 11, marginBottom: 10 }}> {docFile.name}</div>}
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={shareDocument} disabled={uploadingDoc || !docForm.title} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "7px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>{uploadingDoc ? "Uploading..." : "Upload"}</button>
                <button onClick={() => setShowDocForm(false)} style={{ background: "none", border: "1px solid " + T.border, color: T.textMuted, padding: "7px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>Cancel</button>
              </div>
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {documents.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "30px 0" }}>No documents yet.</div>}
            {documents.map(d => (
              <div key={d.id} style={{ background: T.surface, border: "1px solid " + T.border, borderRadius: 10, padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{d.title}</div>
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{d.document_type} · {new Date(d.created_at).toLocaleDateString("en-GB")}</div>
                  {d.requires_approval && <div style={{ color: d.approved_by_client ? T.teal : T.amber, fontSize: 10, fontWeight: 700, marginTop: 2 }}>{d.approved_by_client ? " Client approved" : "Awaiting approval"}</div>}
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  {d.document_url && <a href={d.document_url} target="_blank" rel="noreferrer" style={{ color: T.cyan, fontSize: 11, fontWeight: 700, textDecoration: "none", padding: "4px 8px", border: "1px solid " + T.cyan+"30", borderRadius: 5 }}>↓ View</a>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}


      {activeSection === "payment-rates" && ["CEO","Finance Manager"].includes(user.role) && (
        <div>
          <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15, marginBottom:4 }}>Staff Payment Rates</div>
          <div style={{ color:T.textMuted, fontSize:12, marginBottom:16 }}>Set project fee, per diem and transport allowance per staff member. Amounts are locked for staff when they submit payment requests.</div>
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {staffProfiles.length === 0 && <div style={{ color:T.textMuted, fontSize:13, textAlign:"center", padding:"24px 0" }}>Loading staff...</div>}
            {staffProfiles.map(staff => {
              const existing = paymentRates.find(r => r.staff_id === staff.id);
              return (
                <div key={staff.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:10, padding:"14px 16px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                    <div>
                      <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{staff.name}</div>
                      <div style={{ color:T.textMuted, fontSize:11 }}>{staff.role}</div>
                    </div>
                    {existing && <span style={{ color:T.teal, fontSize:10, fontWeight:700, background:T.teal+"15", padding:"2px 8px", borderRadius:20 }}> Rates Set</span>}
                  </div>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:10 }}>
                    {[["Project Fee","project_fee"],["Per Diem","per_diem"],["Transport","transport_allowance"]].map(([label,field]) => (
                      <div key={field}>
                        <label style={{ color:T.textMuted, fontSize:9, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:3 }}>{label} (${getCurrency(user?.country||"Ghana")})</label>
                        <input type="number" id={"rate-"+staff.id+"-"+field} defaultValue={existing?.[field]||""} placeholder="0.00"
                          style={{ width:"100%", padding:"7px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:6, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                      </div>
                    ))}
                  </div>
                  <button onClick={async () => {
                    setSavingRates(true);
                    const pf = parseFloat(document.getElementById("rate-"+staff.id+"-project_fee")?.value||0);
                    const pd = parseFloat(document.getElementById("rate-"+staff.id+"-per_diem")?.value||0);
                    const ta = parseFloat(document.getElementById("rate-"+staff.id+"-transport_allowance")?.value||0);
                    const payload = { staff_id:staff.id, staff_name:staff.name, project_id:event.id, project_name:event.name, project_fee:pf, per_diem:pd, transport_allowance:ta, set_by:user.id, updated_at:new Date().toISOString() };
                    if (existing) { await supabase.from("staff_event_payments").update(payload).eq("id", existing.id); }
                    else { await supabase.from("staff_event_payments").insert(payload); }
                    await supabase.from("notifications").insert({ user_id:staff.id, title:"Payment Rates Set — "+event.name, message:"Your payment rates for "+event.name+" have been configured. You can now submit payment requests.", type:"finance" });
                    const { data: pr } = await supabase.from("staff_event_payments").select("*").eq("project_id", event.id);
                    setPaymentRates(pr||[]);
                    setSavingRates(false);
                  }} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"7px 16px", borderRadius:7, cursor:"pointer", fontWeight:800, fontSize:12 }}>{savingRates?"Saving...":existing?"Update Rates":"Set Rates"}</button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Messages */}
      {activeSection === "messages" && (
        <div>
          <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "16px", marginBottom: 14, maxHeight: 360, overflowY: "auto", display: "flex", flexDirection: "column", gap: 10 }}>
            {messages.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "20px 0" }}>No messages yet. Start the conversation.</div>}
            {messages.map(m => {
              const isTeam = m.sender_role !== "Client";
              return (
                <div key={m.id} style={{ display: "flex", flexDirection: "column", alignItems: isTeam ? "flex-end" : "flex-start" }}>
                  <div style={{ maxWidth: "80%", background: isTeam ? T.teal+"18" : T.bg, border: `1px solid ${isTeam ? T.teal+"30" : T.border}`, borderRadius: isTeam ? "12px 12px 2px 12px" : "12px 12px 12px 2px", padding: "10px 14px" }}>
                    <div style={{ color: T.textPrimary, fontSize: 13, lineHeight: 1.5 }}>{m.message}</div>
                  </div>
                  <div style={{ color: T.textMuted, fontSize: 10, marginTop: 3 }}>{m.sender_name} · {new Date(m.created_at).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
                </div>
              );
            })}
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <textarea value={reply} onChange={e => setReply(e.target.value)} onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendReply(); }}} placeholder="Message to client..." rows={2} style={{ flex: 1, padding: "10px 14px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", resize: "none" }} />
            <button onClick={sendReply} disabled={sending || !reply.trim()} style={{ background: `linear-gradient(135deg, ${T.teal}, ${T.cyan})`, border: "none", color: "#fff", padding: "10px 18px", borderRadius: 10, cursor: "pointer", fontWeight: 800, fontSize: 13, opacity: !reply.trim() ? 0.6 : 1 }}>{sending ? "..." : "Send"}</button>
          </div>
        </div>
      )}

      {/* Feedback */}
      {activeSection === "feedback" && (
        <div>
          {feedback.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px 0", color: T.textMuted, fontSize: 13 }}>No feedback submitted yet. Feedback appears here after the event.</div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {feedback.map(f => (
                <div key={f.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "16px 20px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                    <div style={{ color: T.textPrimary, fontWeight: 700 }}>{f.submitted_by_name || client.name}</div>
                    <div style={{ display: "flex", gap: 2 }}>
                      {[1,2,3,4,5].map(n => <span key={n} style={{ color: n <= (f.rating||0) ? T.amber : T.border, fontSize: 14 }}></span>)}
                    </div>
                  </div>
                  {f.feedback && <div style={{ color: T.textSecondary, fontSize: 13, lineHeight: 1.6 }}>{f.feedback}</div>}
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 8 }}>{new Date(f.created_at).toLocaleDateString("en-GB")}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};




//  RUN OF SHOW 
const RunOfShowSection = ({ event, user, members }) => {
  const [rows, setRows] = useState([]);
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ time_slot:"", duration_mins:"", segment_title:"", responsible_person:"", notes:"" });
  const [saving, setSaving] = useState(false);
  const canEdit = ["CEO","Strategy & Events Lead","Country Manager"].includes(user?.role);

  const load = async () => {
    const { data } = await supabase.from("run_of_show").select("*").eq("project_id", event.id).order("order_index");
    setRows(data || []);
  };
  useEffect(() => { load(); }, [event.id]);

  const addRow = async () => {
    if (!form.segment_title) return;
    setSaving(true);
    await supabase.from("run_of_show").insert({ project_id: event.id, ...form, duration_mins: parseInt(form.duration_mins)||0, order_index: rows.length, created_by: user.id });
    setForm({ time_slot:"", duration_mins:"", segment_title:"", responsible_person:"", notes:"" });
    setAdding(false); setSaving(false); load();
  };

  const deleteRow = async (id) => {
    await supabase.from("run_of_show").delete().eq("id", id);
    load();
  };

  const totalMins = rows.reduce((s,r) => s + (r.duration_mins||0), 0);

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
        <div>
          <div style={{ color:T.textPrimary, fontWeight:900, fontSize:16 }}>Run of Show</div>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>Programme timeline — {rows.length} segments · {Math.floor(totalMins/60)}h {totalMins%60}m total</div>
        </div>
        {canEdit && <button onClick={() => setAdding(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"8px 18px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Add Segment</button>}
      </div>

      {adding && canEdit && (
        <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:12, padding:16, marginBottom:16 }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 2fr 1fr", gap:10, marginBottom:10 }}>
            <div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Time</div>
              <input value={form.time_slot} onChange={e=>setForm(f=>({...f,time_slot:e.target.value}))} placeholder="e.g. 09:00" style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
            </div>
            <div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Duration (mins)</div>
              <input type="number" value={form.duration_mins} onChange={e=>setForm(f=>({...f,duration_mins:e.target.value}))} placeholder="30" style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
            </div>
            <div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Segment Title *</div>
              <input value={form.segment_title} onChange={e=>setForm(f=>({...f,segment_title:e.target.value}))} placeholder="e.g. Welcome Address" style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
            </div>
            <div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Responsible</div>
              <input value={form.responsible_person} onChange={e=>setForm(f=>({...f,responsible_person:e.target.value}))} placeholder="Name or role" style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
            </div>
          </div>
          <div style={{ marginBottom:10 }}>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Notes</div>
            <input value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} placeholder="Additional notes..." style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <button onClick={addRow} disabled={saving||!form.segment_title} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"8px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Add"}</button>
            <button onClick={() => setAdding(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"8px 16px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
          </div>
        </div>
      )}

      {rows.length === 0 ? (
        <div style={{ color:T.textMuted, fontSize:13, textAlign:"center", padding:"32px 0", background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}>No segments added yet{canEdit ? " — click + Add Segment to start building the run of show" : ""}</div>
      ) : (
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ background:T.bg }}>
                {["Time","Duration","Segment","Responsible","Notes",""].map(h => (
                  <th key={h} style={{ padding:"10px 14px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id} style={{ borderBottom: i<rows.length-1?`1px solid ${T.border}44`:"none", background:i%2===0?"transparent":T.bg+"30" }}>
                  <td style={{ padding:"10px 14px", color:T.cyan, fontWeight:700, fontSize:13, whiteSpace:"nowrap" }}>{r.time_slot||"—"}</td>
                  <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:12 }}>{r.duration_mins?r.duration_mins+"m":"—"}</td>
                  <td style={{ padding:"10px 14px", color:T.textPrimary, fontWeight:600, fontSize:13 }}>{r.segment_title}</td>
                  <td style={{ padding:"10px 14px", color:T.textSecondary, fontSize:12 }}>{r.responsible_person||"—"}</td>
                  <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:12 }}>{r.notes||"—"}</td>
                  <td style={{ padding:"10px 14px" }}>{canEdit && <button onClick={() => deleteRow(r.id)} style={{ background:"none", border:"none", color:T.textMuted, cursor:"pointer", fontSize:14, padding:"2px 6px" }}>×</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

//  PRE-EVENT CHECKLIST 
const CHECKLIST_CATEGORIES = ["Venue","Suppliers","Client","Logistics","Technical","Protocol","Vendor"];
const DEFAULT_CHECKLIST = [
  { category:"Venue", item:"Venue confirmed and contract signed", responsible_role:"Strategy & Events Lead" },
  { category:"Venue", item:"Site visit completed", responsible_role:"Strategy & Events Lead" },
  { category:"Venue", item:"Seating layout approved", responsible_role:"Strategy & Events Lead" },
  { category:"Suppliers", item:"All suppliers briefed", responsible_role:"Strategy & Events Lead" },
  { category:"Client", item:"Client programme approved", responsible_role:"Strategy & Events Lead" },
  { category:"Client", item:"Client final headcount confirmed", responsible_role:"Strategy & Events Lead" },
  { category:"Logistics", item:"Transport arrangements confirmed", responsible_role:"Strategy & Events Lead" },
  { category:"Logistics", item:"Catering orders placed", responsible_role:"Strategy & Events Lead" },
  { category:"Technical", item:"AV equipment tested", responsible_role:"Strategy & Events Lead" },
  { category:"Technical", item:"Microphones and sound checked", responsible_role:"Strategy & Events Lead" },
  { category:"Protocol", item:"MC briefed on run of show", responsible_role:"Strategy & Events Lead" },
  { category:"Protocol", item:"Guest list finalised", responsible_role:"Strategy & Events Lead" },
  { category:"Vendor", item:"All vendors confirmed attendance", responsible_role:"Vendor Manager" },
  { category:"Vendor", item:"Vendor equipment delivery confirmed", responsible_role:"Vendor Manager" },
  { category:"Vendor", item:"Vendor setup time communicated", responsible_role:"Vendor Manager" },
];

const EventChecklistSection = ({ event, user, members }) => {
  const [items, setItems] = useState([]);
  const [adding, setAdding] = useState(false);
  const [newItem, setNewItem] = useState({ category:"Venue", item:"", responsible_role:"" });
  const [saving, setSaving] = useState(false);
  const isVM = user?.role === "Vendor Manager";
  const canEdit = ["CEO","Strategy & Events Lead","Country Manager"].includes(user?.role);
  const canCheck = canEdit || isVM;

  const load = async () => {
    const { data } = await supabase.from("event_checklist").select("*").eq("project_id", event.id).order("category").order("order_index");
    setItems(data || []);
  };

  useEffect(() => { load(); }, [event.id]);

  const initChecklist = async () => {
    setSaving(true);
    for (let i = 0; i < DEFAULT_CHECKLIST.items?.length || DEFAULT_CHECKLIST.length; i++) {
      const d = DEFAULT_CHECKLIST[i];
      await supabase.from("event_checklist").insert({ project_id: event.id, category: d.category, item: d.item, responsible_role: d.responsible_role, order_index: i, created_by: user.id });
    }
    setSaving(false); load();
  };

  const toggle = async (item) => {
    if (isVM && item.responsible_role !== "Vendor Manager") return;
    const completed = !item.completed;
    await supabase.from("event_checklist").update({ completed, completed_by: completed ? user.id : null, completed_at: completed ? new Date().toISOString() : null }).eq("id", item.id);
    load();
  };

  const addItem = async () => {
    if (!newItem.item) return;
    setSaving(true);
    await supabase.from("event_checklist").insert({ project_id: event.id, ...newItem, order_index: items.length, created_by: user.id });
    setNewItem({ category:"Venue", item:"", responsible_role:"" });
    setAdding(false); setSaving(false); load();
  };

  const deleteItem = async (id) => {
    await supabase.from("event_checklist").delete().eq("id", id);
    load();
  };

  const done = items.filter(i => i.completed).length;
  const pct = items.length > 0 ? Math.round((done/items.length)*100) : 0;
  const byCategory = CHECKLIST_CATEGORIES.reduce((acc, cat) => { acc[cat] = items.filter(i => i.category === cat); return acc; }, {});

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
        <div>
          <div style={{ color:T.textPrimary, fontWeight:900, fontSize:16 }}>Pre-Event Checklist</div>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{done}/{items.length} complete · {pct}%</div>
        </div>
        <div style={{ display:"flex", gap:8 }}>
          {items.length === 0 && canEdit && <button onClick={initChecklist} disabled={saving} style={{ background:T.surface, border:`1px solid ${T.border}`, color:T.textMuted, padding:"8px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}>{saving?"Loading...":"Load Default Checklist"}</button>}
          {canEdit && <button onClick={() => setAdding(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"8px 18px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Add Item</button>}
        </div>
      </div>

      {items.length > 0 && (
        <div style={{ height:6, background:T.border, borderRadius:3, marginBottom:20, overflow:"hidden" }}>
          <div style={{ height:"100%", width:pct+"%", background:`linear-gradient(90deg,${T.cyan},${T.teal})`, borderRadius:3, transition:"width 0.3s" }} />
        </div>
      )}

      {adding && canEdit && (
        <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:12, padding:16, marginBottom:16 }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 2fr 1fr", gap:10, marginBottom:10 }}>
            <div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Category</div>
              <select value={newItem.category} onChange={e=>setNewItem(f=>({...f,category:e.target.value}))} style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                {CHECKLIST_CATEGORIES.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Item *</div>
              <input value={newItem.item} onChange={e=>setNewItem(f=>({...f,item:e.target.value}))} placeholder="Checklist item..." style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
            </div>
            <div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Responsible Role</div>
              <input value={newItem.responsible_role} onChange={e=>setNewItem(f=>({...f,responsible_role:e.target.value}))} placeholder="Role..." style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
            </div>
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <button onClick={addItem} disabled={saving||!newItem.item} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"8px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>Add</button>
            <button onClick={() => setAdding(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"8px 16px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
          </div>
        </div>
      )}

      {items.length === 0 ? (
        <div style={{ color:T.textMuted, fontSize:13, textAlign:"center", padding:"32px 0", background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}>No checklist items yet{canEdit ? " — load the default checklist or add items manually" : ""}</div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
          {CHECKLIST_CATEGORIES.filter(cat => byCategory[cat]?.length > 0).map(cat => (
            <div key={cat}>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:8 }}>{cat}</div>
              <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:10, overflow:"hidden" }}>
                {byCategory[cat].map((item, i) => {
                  const canToggle = canCheck && (canEdit || (isVM && item.responsible_role === "Vendor Manager"));
                  return (
                    <div key={item.id} style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 14px", borderBottom: i<byCategory[cat].length-1?`1px solid ${T.border}33`:"none", background: item.completed ? T.teal+"08" : "transparent" }}>
                      <div onClick={() => canToggle && toggle(item)} style={{ width:20, height:20, borderRadius:5, border:`2px solid ${item.completed?T.teal:T.border}`, background:item.completed?T.teal:"transparent", display:"flex", alignItems:"center", justifyContent:"center", cursor:canToggle?"pointer":"default", flexShrink:0 }}>
                        {item.completed && <span style={{ color:"#fff", fontSize:11, fontWeight:900 }}></span>}
                      </div>
                      <div style={{ flex:1 }}>
                        <div style={{ color:item.completed?T.textMuted:T.textPrimary, fontSize:13, fontWeight:600, textDecoration:item.completed?"line-through":"none" }}>{item.item}</div>
                        {item.responsible_role && <div style={{ color:T.textMuted, fontSize:10, marginTop:1 }}>{item.responsible_role}</div>}
                      </div>
                      {item.completed_at && <div style={{ color:T.teal, fontSize:10, fontWeight:600 }}>{new Date(item.completed_at).toLocaleDateString("en-GB",{day:"numeric",month:"short"})}</div>}
                      {canEdit && <button onClick={() => deleteItem(item.id)} style={{ background:"none", border:"none", color:T.textMuted, cursor:"pointer", fontSize:14, padding:"2px 6px", flexShrink:0 }}>×</button>}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

//  CLIENT COMMS LOG 
const ClientCommsSection = ({ event, user }) => {
  const [logs, setLogs] = useState([]);
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ log_date: new Date().toISOString().slice(0,10), type:"call", contact_name:"", summary:"", outcome:"", follow_up_required:false, follow_up_notes:"" });
  const [saving, setSaving] = useState(false);
  const canEdit = ["CEO","Strategy & Events Lead","Country Manager"].includes(user?.role);

  const load = async () => {
    const { data } = await supabase.from("client_comms_log").select("*").eq("project_id", event.id).order("log_date", { ascending:false });
    setLogs(data || []);
  };
  useEffect(() => { load(); }, [event.id]);

  const addLog = async () => {
    if (!form.summary) return;
    setSaving(true);
    await supabase.from("client_comms_log").insert({ project_id: event.id, ...form, logged_by: user.id, logged_by_name: user.name });
    setForm({ log_date: new Date().toISOString().slice(0,10), type:"call", contact_name:"", summary:"", outcome:"", follow_up_required:false, follow_up_notes:"" });
    setAdding(false); setSaving(false); load();
  };

  const typeColors = { call:T.cyan, meeting:T.teal, email:T.amber, whatsapp:"#25D366", "site-visit":"#8B5CF6" };
  const typeIcons = { call:"", meeting:"", email:"", whatsapp:"", "site-visit":"" };

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
        <div>
          <div style={{ color:T.textPrimary, fontWeight:900, fontSize:16 }}>Client Communication Log</div>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{logs.length} entries · {event.client}</div>
        </div>
        {canEdit && <button onClick={() => setAdding(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"8px 18px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Log Communication</button>}
      </div>

      {adding && canEdit && (
        <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:12, padding:16, marginBottom:16 }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:10 }}>
            <div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Date</div>
              <input type="date" value={form.log_date} onChange={e=>setForm(f=>({...f,log_date:e.target.value}))} style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
            </div>
            <div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Type</div>
              <select value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))} style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="call">Phone Call</option>
                <option value="meeting">Meeting</option>
                <option value="email">Email</option>
                <option value="whatsapp">WhatsApp</option>
                <option value="site-visit">Site Visit</option>
              </select>
            </div>
            <div>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Contact Name</div>
              <input value={form.contact_name} onChange={e=>setForm(f=>({...f,contact_name:e.target.value}))} placeholder="Who did you speak to?" style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
            </div>
          </div>
          <div style={{ marginBottom:10 }}>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Summary *</div>
            <textarea value={form.summary} onChange={e=>setForm(f=>({...f,summary:e.target.value}))} rows={3} placeholder="What was discussed?" style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"vertical", boxSizing:"border-box" }} />
          </div>
          <div style={{ marginBottom:10 }}>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Outcome / Decision</div>
            <input value={form.outcome} onChange={e=>setForm(f=>({...f,outcome:e.target.value}))} placeholder="What was agreed or decided?" style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10 }}>
            <input type="checkbox" id="followup" checked={form.follow_up_required} onChange={e=>setForm(f=>({...f,follow_up_required:e.target.checked}))} />
            <label htmlFor="followup" style={{ color:T.textSecondary, fontSize:13 }}>Follow-up required</label>
          </div>
          {form.follow_up_required && (
            <div style={{ marginBottom:10 }}>
              <input value={form.follow_up_notes} onChange={e=>setForm(f=>({...f,follow_up_notes:e.target.value}))} placeholder="Follow-up notes..." style={{ width:"100%", padding:"8px 10px", background:T.bg, border:`1px solid ${T.amber}44`, borderRadius:7, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
            </div>
          )}
          <div style={{ display:"flex", gap:8 }}>
            <button onClick={addLog} disabled={saving||!form.summary} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"8px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>Save Log</button>
            <button onClick={() => setAdding(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"8px 16px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
          </div>
        </div>
      )}

      {logs.length === 0 ? (
        <div style={{ color:T.textMuted, fontSize:13, textAlign:"center", padding:"32px 0", background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}>No communications logged yet</div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          {logs.map(log => (
            <div key={log.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderLeft:`4px solid ${typeColors[log.type]||T.cyan}`, borderRadius:10, padding:"14px 16px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <span style={{ fontSize:16 }}>{typeIcons[log.type]||""}</span>
                  <div>
                    <span style={{ color:typeColors[log.type]||T.cyan, fontSize:11, fontWeight:700, textTransform:"uppercase" }}>{log.type}</span>
                    {log.contact_name && <span style={{ color:T.textMuted, fontSize:11 }}> · {log.contact_name}</span>}
                  </div>
                </div>
                <div style={{ color:T.textMuted, fontSize:11 }}>{new Date(log.log_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})} · {log.logged_by_name}</div>
              </div>
              <div style={{ color:T.textPrimary, fontSize:13, marginBottom: log.outcome ? 6 : 0 }}>{log.summary}</div>
              {log.outcome && <div style={{ color:T.teal, fontSize:12, fontWeight:600, marginBottom:4 }}>→ {log.outcome}</div>}
              {log.follow_up_required && <div style={{ color:T.amber, fontSize:11, fontWeight:700, background:T.amber+"15", padding:"3px 10px", borderRadius:20, display:"inline-block" }}> Follow-up: {log.follow_up_notes||"required"}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

//  POST-EVENT DEBRIEF 
const EventDebriefSection = ({ event, user }) => {
  const [debrief, setDebrief] = useState(null);
  const [form, setForm] = useState({ what_went_well:"", what_to_do_differently:"", client_informal_feedback:"", surprises:"", recommendations:"" });
  const [saving, setSaving] = useState(false);
  const canEdit = ["CEO","Strategy & Events Lead","Country Manager"].includes(user?.role);

  const load = async () => {
    const { data } = await supabase.from("event_debrief").select("*").eq("project_id", event.id).order("submitted_at", { ascending:false });
    if (data && data.length > 0) {
      // Merge all submissions
      const merged = { what_went_well:"", what_to_do_differently:"", client_informal_feedback:"", surprises:"", recommendations:"" };
      data.forEach(d => {
        Object.keys(merged).forEach(k => { if (d[k]) merged[k] = merged[k] ? merged[k]+"\n\n"+d[k] : d[k]; });
      });
      setDebrief(data[0]);
      setForm(merged);
    }
  };
  useEffect(() => { load(); }, [event.id]);

  const save = async () => {
    if (!form.what_went_well && !form.what_to_do_differently) return;
    setSaving(true);
    const existing = await supabase.from("event_debrief").select("id").eq("project_id", event.id).eq("submitted_by", user.id).maybeSingle();
    if (existing.data) {
      await supabase.from("event_debrief").update({ ...form, updated_at: new Date().toISOString() }).eq("id", existing.data.id);
    } else {
      await supabase.from("event_debrief").insert({ project_id: event.id, ...form, submitted_by: user.id, submitted_by_name: user.name });
    }
    setSaving(false); load();
    alert("Debrief saved.");
  };

  const Field = ({ label, field, placeholder }) => (
    <div style={{ marginBottom:16 }}>
      <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:6 }}>{label}</div>
      <textarea value={form[field]} onChange={e=>setForm(f=>({...f,[field]:e.target.value}))} rows={3} placeholder={placeholder}
        disabled={!canEdit}
        style={{ width:"100%", padding:"10px 12px", background:canEdit?T.bg:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"vertical", boxSizing:"border-box" }} />
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <div style={{ color:T.textPrimary, fontWeight:900, fontSize:16 }}>Post-Event Debrief</div>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>Capture learnings after the event — feeds into the Event Intelligence Report</div>
      </div>
      <Field label="What Went Well" field="what_went_well" placeholder="Moments, decisions and elements that delivered..." />
      <Field label="What to Do Differently Next Time" field="what_to_do_differently" placeholder="Changes you would make, gaps identified..." />
      <Field label="Client Informal Feedback" field="client_informal_feedback" placeholder="What the client said informally — reactions, mood, comments..." />
      <Field label="Surprises / Unexpected Moments" field="surprises" placeholder="Things that caught you off guard — positive or negative..." />
      <Field label="Recommendations for Next Edition" field="recommendations" placeholder="What Stretchfield should do differently or build on..." />
      {canEdit && (
        <button onClick={save} disabled={saving} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px 28px", borderRadius:10, cursor:"pointer", fontWeight:800, fontSize:14 }}>{saving?"Saving...":"Save Debrief"}</button>
      )}
    </div>
  );
};


const TaskCommentThread = ({ taskId, user }) => {
  const [comments, setComments] = React.useState([]);
  const [text, setText] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    if (!open) return;
    supabase.from('task_comments').select('*').eq('task_id', taskId).order('created_at', { ascending: true })
      .then(({ data }) => setComments(data || []));
  }, [taskId, open]);

  const submit = async () => {
    if (!text.trim()) return;
    setSaving(true);
    await supabase.from('task_comments').insert({
      task_id: taskId,
      content: text.trim(),
      author_id: user?.id,
      author_name: user?.name,
    });
    setText('');
    const { data } = await supabase.from('task_comments').select('*').eq('task_id', taskId).order('created_at', { ascending: true });
    setComments(data || []);
    setSaving(false);
  };

  return (
    <div style={{ marginTop: 10 }}>
      <button onClick={() => setOpen(!open)} style={{ background: 'none', border: 'none', color: T.textMuted, fontSize: 11, cursor: 'pointer', padding: 0, fontWeight: 700 }}>
        {open ? '▲ Hide' : `▼ Comments${comments.length > 0 ? ` (${comments.length})` : ''}`}
      </button>
      {open && (
        <div style={{ marginTop: 8 }}>
          {comments.length === 0 && <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 6 }}>No comments yet.</div>}
          {comments.map(c => (
            <div key={c.id} style={{ background: T.bg, borderRadius: 8, padding: '8px 10px', marginBottom: 6 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}>
                <span style={{ color: T.cyan, fontSize: 11, fontWeight: 700 }}>{c.author_name || 'Unknown'}</span>
                <span style={{ color: T.textMuted, fontSize: 10 }}>{new Date(c.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
              </div>
              <div style={{ color: T.textPrimary, fontSize: 12 }}>{c.content}</div>
            </div>
          ))}
          <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
            <input value={text} onChange={e => setText(e.target.value)} onKeyDown={e => e.key === 'Enter' && submit()}
              placeholder="Add a comment..." style={{ flex: 1, padding: '7px 10px', background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 12, fontFamily: 'inherit', outline: 'none' }} />
            <button onClick={submit} disabled={saving} style={{ background: `linear-gradient(135deg,${T.cyan},${T.teal})`, border: 'none', color: '#fff', padding: '7px 14px', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 12 }}>{saving ? '...' : 'Post'}</button>
          </div>
        </div>
      )}
    </div>
  );
};

const InternalEventPortal = ({ event, user, allTasks, onClose }) => {
  const [activeSection, setActiveSection] = useState("overview");
  const [tasks, setTasks] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [messages, setMessages] = useState([]);
  const [members, setMembers] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [sendingMsg, setSendingMsg] = useState(false);
  const [showTaskForm, setShowTaskForm] = useState(false);
  const [showDocForm, setShowDocForm] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [docFile, setDocFile] = useState(null);
  const [uploadingDoc, setUploadingDoc] = useState(false);
  const [expandedDoc, setExpandedDoc] = useState(null);
  const [docComments, setDocComments] = useState({});
  const [docComment, setDocComment] = useState("");
  const [taskForm, setTaskForm] = useState({ name: "", deadline: "", assignee_ids: [], status: "pending", notes: "", priority: "Medium" });
  const [docForm, setDocForm] = useState({ title: "", document_type: "Event Brief", share_with_client: false });
  const [savingTask, setSavingTask] = useState(false);

  const [paymentRates, setPaymentRates] = useState([]);
  const [staffProfiles, setStaffProfiles] = useState([]);
  const [savingRates, setSavingRates] = useState(false);
  const isCEO = user?.role === "CEO";
  const canManage = ["CEO", "Country Manager", "Strategy & Events Lead"].includes(user?.role);
  const canSetRates = ["CEO", "Finance Manager"].includes(user?.role);
  const PHASES = ["Brief", "Planning", "Pre-Production", "Production", "Live", "Post-Production", "Completed"];
  const phaseIdx = PHASES.indexOf(event.phase || "Planning");
  const daysToEvent = event.event_date ? Math.ceil((new Date(event.event_date) - new Date()) / (1000*60*60*24)) : null;

  const load = async () => {
    const [tk, dc, mg, mb, sp, pr] = await Promise.all([
      isCEO
        ? supabase.from("tasks").select("*").eq("project_id", event.id).order("created_at", { ascending: false })
        : supabase.from("tasks").select("*").eq("project_id", event.id).or("assignee_id.eq." + user.id + ",assigned_by.eq." + user.id).order("created_at", { ascending: false }),
      supabase.from("event_documents").select("*").eq("project_id", event.id).eq("uploaded_by_client", false).order("created_at", { ascending: false }),
      supabase.from("event_team_messages").select("*").eq("project_id", event.id).order("created_at", { ascending: true }),
      supabase.from("profiles").select("id,name,role,avatar").not("role", "in", "(Client,Vendor,Board of Directors)"),
      supabase.from("profiles").select("id,name,role").not("role", "in", "(Client,Vendor,Board of Directors,CEO)"),
      supabase.from("staff_payment_rates").select("*").eq("project_id", event.id),
    ]);
    setTasks(tk.data || []);
    setDocuments(dc.data || []);
    setMessages(mg.data || []);
    setMembers(mb.data || []);
    setStaffProfiles(sp.data || []);
    setPaymentRates(pr.data || []);
    // Mark messages as read
    const unread = (mg.data || []).filter(m => m.sender_id !== user?.id);
    if (unread.length > 0) {
      await supabase.from("event_team_messages").update({ read_by: supabase.rpc }).eq("project_id", event.id);
    }
  };

  useEffect(() => { load(); }, [event.id]);

  const isCM = user?.role === 'Country Manager';
  const myTasks = (isCEO || isCM) ? tasks : tasks.filter(t => t.assignee_id === user?.id || (Array.isArray(t.assignee_ids) && t.assignee_ids.includes(user?.id)));
  const completedTasks = myTasks.filter(t => t.status === "completed").length;
  const unreadMsgs = messages.filter(m => m.sender_id !== user?.id).length;

  const sendMessage = async () => {
    if (!newMessage.trim()) return;
    setSendingMsg(true);
    await supabase.from("event_team_messages").insert({ project_id: event.id, sender_id: user.id, sender_name: user.name, sender_role: user.role, message: newMessage.trim() });
    setNewMessage("");
    setSendingMsg(false);
    load();
  };

  const createTask = async () => {
    if (!taskForm.name) return;
    setSavingTask(true);
    const assigneeIds = taskForm.assignee_ids;
    // Create one task per assignee if multiple, or single task
    if (assigneeIds.length > 1) {
      for (const aid of assigneeIds) {
        const assignee = members.find(m => m.id === aid);
        await supabase.from("tasks").insert({
          name: taskForm.name, project_id: event.id,
          deadline: taskForm.deadline || null, status: "pending",
          assignee_id: aid, assignee_name: assignee?.name || "",
          assigned_by: user?.id, notes: taskForm.notes || null, priority: taskForm.priority || 'Medium',
          assignee_ids: assigneeIds,
        });
        await supabase.from("notifications").insert({ user_id: aid, title: "New Task — " + event.name, message: taskForm.name, type: "task" });
        const { data: assigneeProfile } = await supabase.from("profiles").select("email,name").eq("id", aid).single();
        if (assigneeProfile?.email) await sendEmail(assigneeProfile.email, "New Task Assigned — " + event.name, taskEmailHtml({ staffName: assigneeProfile.name, taskName: taskForm.name, eventName: event.name, deadline: taskForm.deadline || null, assignedBy: user?.name, notes: taskForm.notes || null }));
      }
    } else if (assigneeIds.length === 1) {
      const assignee = members.find(m => m.id === assigneeIds[0]);
      await supabase.from("tasks").insert({
        name: taskForm.name, project_id: event.id,
        deadline: taskForm.deadline || null, status: "pending",
        assignee_id: assigneeIds[0], assignee_name: assignee?.name || "",
        assigned_by: user?.id, notes: taskForm.notes || null,
        assignee_ids: assigneeIds,
      });
      await supabase.from("notifications").insert({ user_id: assigneeIds[0], title: "New Task — " + event.name, message: taskForm.name, type: "task" });
    } else {
      await supabase.from("tasks").insert({
        name: taskForm.name, project_id: event.id,
        deadline: taskForm.deadline || null, status: "pending",
        assigned_by: user?.id, notes: taskForm.notes || null,
      });
    }
    setTaskForm({ name: "", deadline: "", assignee_ids: [], status: "pending", notes: "" });
    setShowTaskForm(false);
    setSavingTask(false);
    load();
  };

  const updateTaskStatus = async (taskId, status) => {
    await supabase.from("tasks").update({ status }).eq("id", taskId);
    load();
  };

  const uploadDoc = async () => {
    if (!docForm.title) return;
    setUploadingDoc(true);
    let document_url = null;
    if (docFile) {
      const ext = docFile.name.split(".").pop();
      const fname = "event_doc_" + Date.now() + "." + ext;
      const { error: upErr } = await supabase.storage.from("vendor-docs").upload(fname, docFile);
      if (!upErr) {
        const { data: urlData } = supabase.storage.from("vendor-docs").getPublicUrl(fname);
        document_url = urlData.publicUrl;
      }
    }
    await supabase.from("event_documents").insert({
      project_id: event.id, title: docForm.title,
      document_type: docForm.document_type, document_url,
      shared_by: user?.id, shared_by_name: user?.name,
      uploaded_by_client: false, requires_approval: false,
    });
    setDocForm({ title: "", document_type: "Event Brief", share_with_client: false });
    setDocFile(null);
    setShowDocForm(false);
    setUploadingDoc(false);
    load();
  };

  const loadDocComments = async (docId) => {
    const { data } = await supabase.from("document_comments").select("*").eq("document_id", docId).order("created_at", { ascending: true });
    setDocComments(prev => ({ ...prev, [docId]: data || [] }));
  };

  const sendDocComment = async (docId) => {
    if (!docComment.trim()) return;
    await supabase.from("document_comments").insert({ document_id: docId, sender_id: user.id, sender_name: user.name, sender_role: user.role, message: docComment.trim() });
    setDocComment("");
    loadDocComments(docId);
  };

  const inputStyle = { width: "100%", padding: "9px 12px", background: T.bg, border: "1px solid " + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };
  const statusColors = { pending: T.textMuted, "in-progress": T.cyan, completed: T.teal };

  return (
    <div style={{ animation: "fadeUp 0.3s ease" }}>
      <button onClick={onClose} style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 12, fontWeight: 700, padding: "0 0 12px 0", display: "flex", alignItems: "center", gap: 4 }}>← Back to Events</button>


      {/* Event Hero */}
      <div style={{ background: "linear-gradient(135deg, " + T.bgDeep + ", " + T.surface + ")", borderRadius: 12, padding: "0 0 20px 0", marginBottom: 20, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: 0, right: 0, width: 200, height: 200, background: "radial-gradient(circle, " + T.cyan + "08, transparent 70%)", pointerEvents: "none" }} />
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", marginBottom: 6 }}>{event.event_category || "Event"}</div>
        <h1 style={{ margin: "0 0 6px", color: T.textPrimary, fontSize: 22, fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.2 }}>{event.name}</h1>
        <div style={{ color: T.textMuted, fontSize: 13, marginBottom: 16 }}>
          {event.event_date ? new Date(event.event_date).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" }) : "Date TBC"}
          {event.client && " · " + event.client}
        </div>

        {/* Countdown */}
        {daysToEvent !== null && (
          <div style={{ display: "inline-flex", alignItems: "center", gap: 12, background: daysToEvent <= 7 ? T.red+"15" : daysToEvent <= 30 ? T.amber+"15" : T.cyan+"12", border: "1px solid " + (daysToEvent <= 7 ? T.red : daysToEvent <= 30 ? T.amber : T.cyan) + "30", borderRadius: 10, padding: "10px 18px", marginBottom: 16 }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ color: daysToEvent <= 7 ? T.red : daysToEvent <= 30 ? T.amber : T.cyan, fontSize: 28, fontWeight: 900, lineHeight: 1 }}>{daysToEvent > 0 ? daysToEvent : daysToEvent === 0 ? "Today" : Math.abs(daysToEvent)}</div>
              <div style={{ color: T.textMuted, fontSize: 9, textTransform: "uppercase", letterSpacing: "0.1em" }}>{daysToEvent > 0 ? "Days to go" : daysToEvent === 0 ? "" : "Days ago"}</div>
            </div>
            <div style={{ width: 1, height: 32, background: T.border }} />
            <div>
              <div style={{ color: T.textPrimary, fontSize: 12, fontWeight: 700 }}>{event.event_date ? new Date(event.event_date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : ""}</div>
              <div style={{ color: T.textMuted, fontSize: 11 }}>Event Date</div>
            </div>
          </div>
        )}

        {/* Phase bar */}
        <div style={{ marginBottom: 8 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
            <span style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em" }}>Event Journey</span>
            <span style={{ color: T.cyan, fontSize: 10, fontWeight: 700 }}>{event.phase || "Planning"}</span>
          </div>
          <div style={{ display: "flex", gap: 3 }}>
            {PHASES.map((phase, i) => (
              <div key={phase} title={phase} style={{ flex: 1, height: 4, borderRadius: 2, background: i <= phaseIdx ? (i === phaseIdx ? T.cyan : T.teal) : T.border+"44" }} />
            ))}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
            <span style={{ color: T.textMuted, fontSize: 9 }}>Brief</span>
            <span style={{ color: T.textMuted, fontSize: 9 }}>Completed</span>
          </div>
        </div>

        {/* KPI strip */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(100px,1fr))", gap: 10, marginTop: 16 }}>
          {[
            { label: "My Tasks", value: completedTasks + "/" + myTasks.length, color: T.teal },
            { label: "Documents", value: documents.length, color: T.amber },
            { label: "Messages", value: messages.length, color: T.cyan },
            { label: "Pending", value: myTasks.filter(t => t.status !== "completed").length, color: myTasks.filter(t => t.status !== "completed").length > 0 ? T.red : T.textMuted },
          ].map(k => (
            <div key={k.label} style={{ background: T.bg, borderRadius: 8, padding: "10px 12px", border: "1px solid " + T.border }}>
              <div style={{ color: k.color, fontWeight: 900, fontSize: 18 }}>{k.value}</div>
              <div style={{ color: T.textMuted, fontSize: 10, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 2 }}>{k.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 4, marginBottom: 20, borderBottom: "1px solid " + T.border, overflowX: "auto", msOverflowStyle: "none", scrollbarWidth: "none" }}>
        {[
          { id: "overview", label: "Overview" },
          { id: "tasks", label: "Tasks (" + myTasks.length + ")" },
          { id: "documents", label: "Documents (" + documents.length + ")" },
          { id: "messages", label: "Messages" + (unreadMsgs > 0 ? " " : "") },
          ...( ["CEO","Strategy & Events Lead","Vendor Manager","Country Manager"].includes(user?.role) ? [{ id: "run-of-show", label: "Run of Show" }] : []),
          ...( ["CEO","Strategy & Events Lead","Vendor Manager","Country Manager"].includes(user?.role) ? [{ id: "checklist", label: "Checklist" }] : []),
          ...( ["CEO","Strategy & Events Lead","Country Manager"].includes(user?.role) ? [{ id: "comms-log", label: "Client Comms" }] : []),
          ...( ["CEO","Strategy & Events Lead","Country Manager","Vendor Manager"].includes(user?.role) ? [{ id: "debrief", label: "Debrief" }] : []),
        ].map(tab => (
          <button key={tab.id} onClick={() => setActiveSection(tab.id)} style={{ padding: "10px 18px", border: "none", background: "none", cursor: "pointer", color: activeSection === tab.id ? T.cyan : T.textMuted, fontWeight: activeSection === tab.id ? 800 : 400, fontSize: 13, borderBottom: activeSection === tab.id ? "2px solid " + T.cyan : "2px solid transparent", marginBottom: -1, transition: "all 0.15s", whiteSpace:"nowrap" }}>{tab.label}</button>
        ))}
      </div>

      {/* Overview */}
      {activeSection === "overview" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {myTasks.filter(t => t.status !== "completed").length > 0 && (
            <div style={{ background: T.surface, border: "1px solid " + T.border, borderRadius: 12, padding: "18px 20px" }}>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 12 }}>Pending Tasks</div>
              {myTasks.filter(t => t.status !== "completed").slice(0,3).map(t => (
                <div key={t.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: "1px solid " + T.border+"22" }}>
                  <div>
                    <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{t.name}</div>
                    {t.deadline && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Due: {new Date(t.deadline).toLocaleDateString("en-GB")}</div>}
                  </div>
                  <span style={{ color: statusColors[t.status] || T.textMuted, fontSize: 10, fontWeight: 700, background: (statusColors[t.status] || T.textMuted)+"18", padding: "2px 8px", borderRadius: 20 }}>{t.status}</span>
                </div>
              ))}
              <button onClick={() => setActiveSection("tasks")} style={{ background: "none", border: "none", color: T.cyan, fontSize: 12, fontWeight: 700, cursor: "pointer", marginTop: 8, padding: 0 }}>View all tasks →</button>
            </div>
          )}
          {messages.length > 0 && (
            <div style={{ background: T.surface, border: "1px solid " + T.border, borderRadius: 12, padding: "18px 20px" }}>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 12 }}>Recent Messages</div>
              {messages.slice(-2).map(m => (
                <div key={m.id} style={{ padding: "8px 0", borderBottom: "1px solid " + T.border+"22" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                    <span style={{ color: m.sender_id === user?.id ? T.cyan : T.teal, fontSize: 11, fontWeight: 700 }}>{m.sender_name}</span>
                    <span style={{ color: T.textMuted, fontSize: 10 }}>{new Date(m.created_at).toLocaleDateString("en-GB")}</span>
                  </div>
                  <div style={{ color: T.textSecondary, fontSize: 13 }}>{m.message}</div>
                </div>
              ))}
              <button onClick={() => setActiveSection("messages")} style={{ background: "none", border: "none", color: T.cyan, fontSize: 12, fontWeight: 700, cursor: "pointer", marginTop: 8, padding: 0 }}>View all messages →</button>
            </div>
          )}
        </div>
      )}

      {/* Tasks */}
      {activeSection === "tasks" && (
        <div>
          {canManage && (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <div style={{ color: T.textMuted, fontSize: 12 }}>{isCEO ? "All event tasks" : "Tasks assigned to you"}</div>
              <button onClick={() => setShowTaskForm(!showTaskForm)} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "7px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>+ Add Task</button>
            </div>
          )}
          {showTaskForm && (
            <div style={{ background: T.surface, border: "1px solid " + T.cyan+"30", borderRadius: 12, padding: "16px 18px", marginBottom: 16 }}>
              <div style={{ display: "grid", gap: 10, marginBottom: 10 }}>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Task Name</label>
                  <input value={taskForm.name} onChange={e => setTaskForm(f => ({...f, name: e.target.value}))} placeholder="What needs to be done?" style={inputStyle} />
                </div>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Assign To (select multiple)</label>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {members.map(m => {
                      const selected = taskForm.assignee_ids.includes(m.id);
                      return (
                        <button key={m.id} onClick={() => setTaskForm(f => ({ ...f, assignee_ids: selected ? f.assignee_ids.filter(id => id !== m.id) : [...f.assignee_ids, m.id] }))} style={{ padding: "4px 10px", borderRadius: 20, border: "1px solid " + (selected ? T.cyan : T.border), background: selected ? T.cyan+"18" : "none", color: selected ? T.cyan : T.textMuted, fontSize: 11, fontWeight: selected ? 700 : 400, cursor: "pointer" }}>
                          {selected ? " " : ""}{m.name} <span style={{ opacity: 0.6 }}>({m.role})</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Deadline</label>
                  <input type="date" value={taskForm.deadline} onChange={e => setTaskForm(f => ({...f, deadline: e.target.value}))} style={inputStyle} />
                </div>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Priority</label>
                  <select value={taskForm.priority||'Medium'} onChange={e => setTaskForm(f => ({...f, priority: e.target.value}))} style={inputStyle}>
                    <option value="Critical">🔴 Critical</option>
                    <option value="High">🟠 High</option>
                    <option value="Medium">🟡 Medium</option>
                    <option value="Low">🟢 Low</option>
                  </select>
                </div>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Notes</label>
                  <textarea value={taskForm.notes} onChange={e => setTaskForm(f => ({...f, notes: e.target.value}))} rows={2} style={{ ...inputStyle, resize: "none" }} />
                </div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={createTask} disabled={savingTask || !taskForm.name} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "8px 18px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700, opacity: !taskForm.name ? 0.6 : 1 }}>{savingTask ? "Saving..." : "Create Task"}</button>
                <button onClick={() => setShowTaskForm(false)} style={{ background: "none", border: "1px solid " + T.border, color: T.textMuted, padding: "8px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>Cancel</button>
              </div>
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {myTasks.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "30px 0" }}>No tasks yet.</div>}
            {myTasks.map(t => {
              const color = statusColors[t.status] || T.textMuted;
              return (
                <div key={t.id} style={{ background: T.surface, border: "1px solid " + T.border, borderLeft: "3px solid " + color, borderRadius: 10, padding: "12px 16px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                        <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{t.name}</div>
                        {t.priority && <span style={{ background: t.priority==='Critical'?T.red+'20':t.priority==='High'?T.amber+'20':t.priority==='Medium'?T.cyan+'20':'#10B98120', color: t.priority==='Critical'?T.red:t.priority==='High'?T.amber:t.priority==='Medium'?T.cyan:'#10B981', borderRadius:20, padding:"1px 8px", fontSize:9, fontWeight:800 }}>{t.priority}</span>}
                      </div>
                      {t.assignee_name && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Assigned to: {t.assignee_name}</div>}
                      {t.deadline && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Due: {new Date(t.deadline).toLocaleDateString("en-GB")}</div>}
                      {t.notes && <div style={{ color: T.textMuted, fontSize: 11, marginTop: 4, fontStyle: "italic" }}>{t.notes}</div>}
                    </div>
                    <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                      {["pending","in-progress","completed"].map(s => (
                        <button key={s} onClick={() => updateTaskStatus(t.id, s)} style={{ padding: "3px 8px", borderRadius: 5, border: "1px solid " + (t.status === s ? color : T.border), background: t.status === s ? color+"20" : "none", color: t.status === s ? color : T.textMuted, fontSize: 9, fontWeight: 700, cursor: "pointer", textTransform: "uppercase" }}>{s}</button>
                      ))}
                    </div>
                  </div>
                  {/* Comment thread */}
                  <TaskCommentThread taskId={t.id} user={user} />
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Documents */}
      {activeSection === "documents" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 12 }}>Internal event documents</div>
            <button onClick={() => setShowDocForm(!showDocForm)} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "7px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>+ Upload</button>
          </div>
          {showDocForm && (
            <div style={{ background: T.surface, border: "1px solid " + T.cyan+"30", borderRadius: 12, padding: "16px 18px", marginBottom: 16 }}>
              <div style={{ display: "grid", gap: 10, marginBottom: 10 }}>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Title</label>
                  <input value={docForm.title} onChange={e => setDocForm(f => ({...f, title: e.target.value}))} placeholder="e.g. Run of Show v2" style={inputStyle} />
                </div>
                <div>
                  <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Type</label>
                  <select value={docForm.document_type} onChange={e => setDocForm(f => ({...f, document_type: e.target.value}))} style={{ ...inputStyle, appearance: "none" }}>
                    {["Event Brief","Run of Show","Vendor Contract","Budget","Programme","Technical Rider","Other"].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <input type="file" onChange={e => setDocFile(e.target.files[0])} style={{ ...inputStyle, cursor: "pointer" }} />
                {docFile && <div style={{ color: T.cyan, fontSize: 11 }}> {docFile.name}</div>}
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={uploadDoc} disabled={uploadingDoc || !docForm.title} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "8px 18px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>{uploadingDoc ? "Uploading..." : "Upload"}</button>
                <button onClick={() => setShowDocForm(false)} style={{ background: "none", border: "1px solid " + T.border, color: T.textMuted, padding: "8px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>Cancel</button>
              </div>
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {documents.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "30px 0" }}>No documents yet.</div>}
            {documents.map(d => (
              <div key={d.id} style={{ background: T.surface, border: "1px solid " + (expandedDoc === d.id ? T.cyan : T.border), borderRadius: 10, overflow: "hidden" }}>
                <div style={{ padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{d.title}</div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{d.document_type} · {d.shared_by_name} · {new Date(d.created_at).toLocaleDateString("en-GB")}</div>
                  </div>
                  <div style={{ display: "flex", gap: 6 }}>
                    {d.document_url && <a href={d.document_url} target="_blank" rel="noreferrer" style={{ color: T.cyan, fontSize: 11, fontWeight: 700, textDecoration: "none", padding: "4px 8px", border: "1px solid " + T.cyan+"30", borderRadius: 5 }}>View</a>}
                    <button onClick={() => { const n = expandedDoc === d.id ? null : d.id; setExpandedDoc(n); if (n) loadDocComments(d.id); }} style={{ background: expandedDoc === d.id ? T.cyan+"15" : "none", border: "1px solid " + (expandedDoc === d.id ? T.cyan : T.border), color: expandedDoc === d.id ? T.cyan : T.textMuted, padding: "4px 8px", borderRadius: 5, cursor: "pointer", fontSize: 11, fontWeight: 700 }}>{expandedDoc === d.id ? "Close" : "Comment"}</button>
                  </div>
                </div>
                {expandedDoc === d.id && (
                  <div style={{ borderTop: "1px solid " + T.border, padding: "12px 16px", background: T.bg }}>
                    <div style={{ maxHeight: 180, overflowY: "auto", display: "flex", flexDirection: "column", gap: 8, marginBottom: 10 }}>
                      {(docComments[d.id] || []).length === 0 && <div style={{ color: T.textMuted, fontSize: 12 }}>No comments yet.</div>}
                      {(docComments[d.id] || []).map(c => {
                        const isMe = c.sender_id === user?.id;
                        return (
                          <div key={c.id} style={{ display: "flex", flexDirection: "column", alignItems: isMe ? "flex-end" : "flex-start" }}>
                            <div style={{ maxWidth: "80%", background: isMe ? T.teal+"18" : T.surface, border: "1px solid " + (isMe ? T.teal+"30" : T.border), borderRadius: isMe ? "12px 12px 2px 12px" : "12px 12px 12px 2px", padding: "8px 12px" }}>
                              <div style={{ color: T.textPrimary, fontSize: 12 }}>{c.message}</div>
                            </div>
                            <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>{c.sender_name} · {new Date(c.created_at).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
                          </div>
                        );
                      })}
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      <input value={docComment} onChange={e => setDocComment(e.target.value)} onKeyDown={e => { if (e.key === "Enter") sendDocComment(d.id); }} placeholder="Comment..." style={{ flex: 1, padding: "7px 10px", background: T.surface, border: "1px solid " + T.border, borderRadius: 7, color: T.textPrimary, fontSize: 12, fontFamily: "inherit", outline: "none" }} />
                      <button onClick={() => sendDocComment(d.id)} disabled={!docComment.trim()} style={{ background: "linear-gradient(135deg, " + T.teal + ", " + T.cyan + ")", border: "none", color: "#fff", padding: "7px 14px", borderRadius: 7, cursor: "pointer", fontSize: 12, fontWeight: 700 }}>Send</button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Messages */}
      {activeSection === "messages" && (
        <div>
          <div style={{ background: T.surface, border: "1px solid " + T.border, borderRadius: 12, padding: "16px", marginBottom: 14, maxHeight: 400, overflowY: "auto", display: "flex", flexDirection: "column", gap: 10 }}>
            {messages.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "20px 0" }}>No messages yet. Start the team conversation.</div>}
            {messages.map(m => {
              const isMe = m.sender_id === user?.id;
              return (
                <div key={m.id} style={{ display: "flex", flexDirection: "column", alignItems: isMe ? "flex-end" : "flex-start" }}>
                  <div style={{ maxWidth: "80%", background: isMe ? T.cyan+"18" : T.bg, border: "1px solid " + (isMe ? T.cyan+"30" : T.border), borderRadius: isMe ? "12px 12px 2px 12px" : "12px 12px 12px 2px", padding: "10px 14px" }}>
                    <div style={{ color: isMe ? T.cyan : T.teal, fontSize: 10, fontWeight: 700, marginBottom: 4 }}>{m.sender_name} · {m.sender_role}</div>
                    <div style={{ color: T.textPrimary, fontSize: 13 }}>{m.message}</div>
                  </div>
                  <div style={{ color: T.textMuted, fontSize: 10, marginTop: 3 }}>{new Date(m.created_at).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
                </div>
              );
            })}
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <textarea value={newMessage} onChange={e => setNewMessage(e.target.value)} onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); }}} placeholder="Message the team..." rows={2} style={{ flex: 1, padding: "10px 14px", background: T.surface, border: "1px solid " + T.border, borderRadius: 10, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", resize: "none" }} />
            <button onClick={sendMessage} disabled={sendingMsg || !newMessage.trim()} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "10px 18px", borderRadius: 10, cursor: "pointer", fontWeight: 800, fontSize: 13, opacity: !newMessage.trim() ? 0.6 : 1 }}>{sendingMsg ? "..." : "Send"}</button>
          </div>
        </div>
      )}

      {/*  RUN OF SHOW  */}
      {activeSection === "run-of-show" && (
        <RunOfShowSection event={event} user={user} members={members} />
      )}

      {/*  PRE-EVENT CHECKLIST  */}
      {activeSection === "checklist" && (
        <EventChecklistSection event={event} user={user} members={members} />
      )}

      {/*  CLIENT COMMS LOG  */}
      {activeSection === "comms-log" && (
        <ClientCommsSection event={event} user={user} />
      )}

      {/*  POST-EVENT DEBRIEF  */}
      {activeSection === "debrief" && (
        <EventDebriefSection event={event} user={user} />
      )}

    </div>
  );
};



const InvoicesView = () => {
  const [invoices, setInvoices] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ vendor: '', amount: '', status: 'pending', date: '' });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const { data } = await supabase.from('vendor_invoices').select('*').order('created_at', { ascending: false });
    setInvoices(data || []);
  };

  useEffect(() => { load(); }, []);

  const handleApprove = async (id) => {
    await supabase.from('vendor_invoices').update({ status: 'approved' }).eq('id', id);
    load();
  };

  // Summary stats
  const totalPending = invoices.filter(i => i.status === "pending").reduce((a, i) => a + (i.amount || 0), 0);
  const totalApproved = invoices.filter(i => i.status === "approved").reduce((a, i) => a + (i.amount || 0), 0);
  const totalPaid = invoices.filter(i => i.status === "paid").reduce((a, i) => a + (i.amount || 0), 0);

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Finance</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Invoices</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Review and approve vendor invoices</div>
      </div>

      {/* Summary strip */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Pending", value: getCurrency(user?.country||"Ghana")+" "+(totalPending).toLocaleString(), count: invoices.filter(i => i.status === "pending").length, color: T.amber },
          { label: "Approved", value: getCurrency(user?.country||"Ghana")+" "+(totalApproved).toLocaleString(), count: invoices.filter(i => i.status === "approved").length, color: T.teal },
          { label: "Paid", value: getCurrency(user?.country||"Ghana")+" "+(totalPaid).toLocaleString(), count: invoices.filter(i => i.status === "paid").length, color: T.cyan },
        ].map((s, i) => (
          <div key={i} style={{ padding: "16px 18px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${s.color}`, borderRadius: 10 }}>
            <div style={{ color: s.color, fontSize: 18, fontWeight: 900 }}>{s.value}</div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 4 }}>
              <div style={{ color: T.textPrimary, fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em" }}>{s.label}</div>
              <div style={{ color: T.textMuted, fontSize: 11 }}>{s.count} invoice{s.count !== 1 ? "s" : ""}</div>
            </div>
          </div>
        ))}
      </div>

      {filteredInvoices.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No invoices yet</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>Invoices submitted by vendors will appear here.</div>
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
          {invoices.map(inv => (
            <div key={inv.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "18px 20px", transition: "box-shadow 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = `0 4px 24px ${T.cyan}10`}
              onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14 }}>{inv.vendor_name || inv.vendor || "—"}</div>
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 4 }}>{inv.event_name || "—"}</div>
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{inv.invoice_number||""} · {inv.created_at?.slice(0,10)||inv.date||"—"}</div>
                </div>
                <Badge status={inv.status} />
              </div>
              <div style={{ color: T.amber, fontSize: 20, fontWeight: 900, marginBottom: 12 }}>{getCurrency(inv.country||user?.country||"Ghana")+" "+(parseFloat(inv.amount||0).toLocaleString()).toLocaleString()}</div>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:8 }}>
                {inv.status === "pending" && (
                  <Btn small onClick={() => handleApprove(inv.id)}> Approve</Btn>
                )}
                {inv.status === "approved" && (
                  <Btn small onClick={async () => {
                    const { data: newV } = await supabase.from("payment_vouchers").insert({
                      payment_type: "project",
                      payee: inv.vendor_name,
                      payee_type: "vendor",
                      description: "Payment for " + (inv.event_name||"services") + " — Invoice " + (inv.invoice_number||inv.id.slice(0,8)),
                      amount: parseFloat(inv.amount||0),
                      currency: user?.country === "Nigeria" ? "NGN" : "GHS",
                      event_name: inv.event_name,
                      invoice_ref: inv.invoice_number,
                      raised_by: user.id,
                      status: "pending_approval",
                      voucher_number: "PV/" + new Date().getFullYear().toString().slice(-2) + "/" + String(Math.floor(Math.random()*900)+100),
                    }).select().single();
                    if (newV) {
                      await supabase.from("vendor_invoices").update({ status: "voucher_created", purchase_order_id: newV.id }).eq("id", inv.id);
                      alert("Payment voucher created: " + newV.voucher_number);
                      load();
                    }
                  }}> Create Voucher</Btn>
                )}
                {inv.invoice_url && <a href={inv.invoice_url} target="_blank" rel="noreferrer" style={{ color:T.cyan, fontSize:11, fontWeight:700, padding:"4px 8px" }}> View</a>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};



const EventImpactView = ({ user, project }) => {
  const [activeTab, setActiveTab] = useState("brief");
  const [brief, setBrief] = useState(null);
  const [postData, setPostData] = useState(null);
  const [scorecard, setScorecard] = useState(null);
  const [report, setReport] = useState(null);
  const [saving, setSaving] = useState(false);
  const [briefForm, setBriefForm] = useState({
    impact_objective: "", target_audience: "", observable_signal: "",
    kpi1_name: "", kpi1_target: "", kpi1_method: "", kpi1_timing: "",
    kpi2_name: "", kpi2_target: "", kpi2_method: "", kpi2_timing: "",
    kpi3_name: "", kpi3_target: "", kpi3_method: "", kpi3_timing: "",
    tool_pre_survey: "No", tool_digital_tracking: "No", tool_live_monitoring: "No",
    tool_post_survey: "No", tool_30day_survey: "No", tool_90day_tracking: "No",
    tool_social_listening: "No", tool_commercial_data: "No",
    story_before: "", story_design: "", story_outcome: "",
  });
  const [postForm, setPostForm] = useState({
    total_attendees: "", target_audience_pct: "", no_show_rate: "",
    avg_dwell_time: "", digital_completion_pct: "", interactive_participation_pct: "",
    satisfaction_score: "", nps_score: "", positive_sentiment_pct: "",
    behaviour_30day: "", behaviour_90day: "", knowledge_recall_pct: "",
    retention_rate: "", revenue_shift_pct: "", opportunities_generated: "",
    organic_posts: "", organic_reach: "", earned_media: "",
  });
  const [scorecardForm, setScorecardForm] = useState({
    revenue_sales_target: "", revenue_sales_score: 0, revenue_sales_actual: "",
    market_share_target: "", market_share_score: 0, market_share_actual: "",
    brand_awareness_target: "", brand_awareness_score: 0, brand_awareness_actual: "",
    org_performance_target: "", org_performance_score: 0, org_performance_actual: "",
    innovation_partnerships_target: "", innovation_partnerships_score: 0, innovation_partnerships_actual: "",
    roi_roe_target: "", roi_roe_score: 0, roi_roe_actual: "",
    event_cost: "", revenue_impact: "", commentary: "",
  });
  const [reportForm, setReportForm] = useState({
    headline: "", problem_challenge: "", problem_previous: "", problem_inaction: "",
    design1_name: "", design1_intent: "", design2_name: "", design2_intent: "", design3_name: "", design3_intent: "",
    metric1_label: "", metric1_value: "", metric2_label: "", metric2_value: "",
    metric3_label: "", metric3_value: "", metric4_label: "", metric4_value: "",
    client_quote: "", quote_attribution: "", one_line_story: "",
  });

  const archetype = EVENT_ARCHETYPES[project?.event_category] || EVENT_ARCHETYPES["Conference/Seminar"];

  const load = async () => {
    const [{ data: b }, { data: pd }, { data: sc }, { data: rp }] = await Promise.all([
      supabase.from("event_impact_briefs").select("*").eq("project_id", project.id).single(),
      supabase.from("event_post_data").select("*").eq("project_id", project.id).single(),
      supabase.from("event_scorecards").select("*").eq("project_id", project.id).single(),
      supabase.from("event_impact_reports").select("*").eq("project_id", project.id).single(),
    ]);
    if (b) { setBrief(b); setBriefForm(b); }
    if (pd) { setPostData(pd); setPostForm(pd); }
    if (sc) { setScorecard(sc); setScorecardForm(sc); }
    if (rp) { setReport(rp); setReportForm(rp); }

    // Auto-fill KPI suggestions if no brief yet
    if (!b && archetype.kpiSuggestions) {
      const s = archetype.kpiSuggestions;
      setBriefForm(prev => ({
        ...prev,
        kpi1_name: s[0]?.name || "", kpi1_target: s[0]?.target || "", kpi1_method: s[0]?.method || "", kpi1_timing: s[0]?.timing || "",
        kpi2_name: s[1]?.name || "", kpi2_target: s[1]?.target || "", kpi2_method: s[1]?.method || "", kpi2_timing: s[1]?.timing || "",
        kpi3_name: s[2]?.name || "", kpi3_target: s[2]?.target || "", kpi3_method: s[2]?.method || "", kpi3_timing: s[2]?.timing || "",
        tool_pre_survey: archetype.tools.pre_survey,
        tool_digital_tracking: archetype.tools.digital_tracking,
        tool_live_monitoring: archetype.tools.live_monitoring,
        tool_post_survey: archetype.tools.post_survey,
        tool_30day_survey: archetype.tools.day30_survey,
        tool_90day_tracking: archetype.tools.day90_tracking,
        tool_social_listening: archetype.tools.social_listening,
        tool_commercial_data: archetype.tools.commercial_data,
        story_before: archetype.storyTemplate.before,
        story_design: archetype.storyTemplate.design,
        story_outcome: archetype.storyTemplate.outcome,
      }));
      setScorecardForm(prev => {
        const updated = { ...prev };
        archetype.dimensions.forEach(d => {
          updated[d.key + "_target"] = d.description;
        });
        return updated;
      });
    }
  };

  useEffect(() => { if (project?.id) load(); }, [project?.id]);

  const saveBrief = async () => {
    setSaving(true);
    if (brief) {
      await supabase.from("event_impact_briefs").update({ ...briefForm, updated_at: new Date().toISOString() }).eq("id", brief.id);
    } else {
      await supabase.from("event_impact_briefs").insert({ ...briefForm, project_id: project.id, event_type: project.event_category, created_by: user.id });
    }
    setSaving(false); load();
  };

  const savePostData = async () => {
    setSaving(true);
    if (postData) {
      await supabase.from("event_post_data").update({ ...postForm, updated_at: new Date().toISOString() }).eq("id", postData.id);
    } else {
      await supabase.from("event_post_data").insert({ ...postForm, project_id: project.id, created_by: user.id });
    }
    setSaving(false); load();
  };

  const calcOverallScore = () => {
    const dims = archetype.dimensions;
    let total = 0;
    dims.forEach(d => {
      const score = parseFloat(scorecardForm[d.key + "_score"]) || 0;
      total += score * d.weight;
    });
    return Math.round(total * 10) / 10;
  };

  const saveScorecard = async () => {
    setSaving(true);
    const overall = calcOverallScore();
    if (scorecard) {
      await supabase.from("event_scorecards").update({ ...scorecardForm, overall_score: overall }).eq("id", scorecard.id);
    } else {
      await supabase.from("event_scorecards").insert({ ...scorecardForm, overall_score: overall, project_id: project.id, created_by: user.id });
    }
    setSaving(false); load();
  };

  const saveReport = async () => {
    setSaving(true);
    if (report) {
      await supabase.from("event_impact_reports").update({ ...reportForm, updated_at: new Date().toISOString() }).eq("id", report.id);
    } else {
      await supabase.from("event_impact_reports").insert({ ...reportForm, project_id: project.id, created_by: user.id });
    }
    setSaving(false); load();
  };

  const overallScore = scorecard ? scorecard.overall_score : calcOverallScore();
  const scoreLabel = getScoreLabel(overallScore);

  const inputStyle = { width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };
  const labelStyle = { color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 5 };
  const sectionStyle = { color: archetype.color, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 12, marginTop: 24, paddingBottom: 6, borderBottom: `1px solid ${archetype.color}30` };

  const tabs = [
    { id: "brief", label: " Impact Brief", done: !!brief },
    { id: "post-data", label: " Post-Event Data", done: !!postData },
    { id: "scorecard", label: " Scorecard", done: !!scorecard },
    { id: "report", label: " Impact Report", done: !!report },
    { id: "consolidated", label: " Consolidated Report", done: !!(brief && scorecard && postData) },
  ];

  return (
    <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
      {/* Header */}
      <div style={{ padding: "16px 20px", background: archetype.color+"12", borderBottom: `1px solid ${archetype.color}30`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ color: archetype.color, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 3 }}>Impact Intelligence — {project?.event_category}</div>
          <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>{project?.name}</div>
        </div>
        {scorecard && (
          <div style={{ textAlign: "right" }}>
            <div style={{ color: scoreLabel.color, fontWeight: 900, fontSize: 28 }}>{overallScore}/10</div>
            <div style={{ color: scoreLabel.color, fontSize: 11, fontWeight: 700 }}>{scoreLabel.label}</div>
          </div>
        )}
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", borderBottom: `1px solid ${T.border}`, background: T.bg }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)} style={{
            padding: "10px 16px", cursor: "pointer", fontSize: 12, fontWeight: 700,
            border: "none", borderBottom: `2px solid ${activeTab === t.id ? archetype.color : "transparent"}`,
            background: "none", color: activeTab === t.id ? archetype.color : T.textMuted,
            display: "flex", alignItems: "center", gap: 6,
          }}>
            {t.label}
            {t.done && <span style={{ background: "#10B98120", color: "#10B981", borderRadius: "50%", width: 14, height: 14, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9 }}></span>}
          </button>
        ))}
      </div>

      <div style={{ padding: "20px 24px", maxHeight: 600, overflowY: "auto" }}>

        {/*  IMPACT BRIEF TAB  */}
        {activeTab === "brief" && (
          <div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 16 }}>Define what success looks like before the event. KPIs pre-filled based on {project?.event_category} archetype.</div>

            <div style={sectionStyle}>Impact Objective</div>
            <div style={{ marginBottom: 12 }}><label style={labelStyle}>In one sentence, what must change as a result of this event?</label><textarea value={briefForm.impact_objective} onChange={e => setBriefForm({...briefForm, impact_objective: e.target.value})} rows={2} style={{...inputStyle, resize: "vertical"}} /></div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 12, marginBottom: 12 }}>
              <div><label style={labelStyle}>Who specifically should change?</label><input value={briefForm.target_audience} onChange={e => setBriefForm({...briefForm, target_audience: e.target.value})} style={inputStyle} placeholder="Target audience segment" /></div>
              <div><label style={labelStyle}>How will you know it changed?</label><input value={briefForm.observable_signal} onChange={e => setBriefForm({...briefForm, observable_signal: e.target.value})} style={inputStyle} placeholder="Observable signal" /></div>
            </div>

            <div style={sectionStyle}>Measurable KPIs</div>
            {[1,2,3].map(n => (
              <div key={n} style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "12px 14px", marginBottom: 10 }}>
                <div style={{ color: archetype.color, fontSize: 11, fontWeight: 800, marginBottom: 8 }}>KPI {n}</div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 10, marginBottom: 8 }}>
                  <div><label style={labelStyle}>Name</label><input value={briefForm[`kpi${n}_name`]} onChange={e => setBriefForm({...briefForm, [`kpi${n}_name`]: e.target.value})} style={inputStyle} /></div>
                  <div><label style={labelStyle}>Target</label><input value={briefForm[`kpi${n}_target`]} onChange={e => setBriefForm({...briefForm, [`kpi${n}_target`]: e.target.value})} style={inputStyle} /></div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 10 }}>
                  <div><label style={labelStyle}>Measurement Method</label><input value={briefForm[`kpi${n}_method`]} onChange={e => setBriefForm({...briefForm, [`kpi${n}_method`]: e.target.value})} style={inputStyle} /></div>
                  <div><label style={labelStyle}>When Measured</label><input value={briefForm[`kpi${n}_timing`]} onChange={e => setBriefForm({...briefForm, [`kpi${n}_timing`]: e.target.value})} style={inputStyle} /></div>
                </div>
              </div>
            ))}

            <div style={sectionStyle}>Measurement Tools</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 8, marginBottom: 16 }}>
              {[
                ["tool_pre_survey", "Pre-Event Survey / Baseline"],
                ["tool_digital_tracking", "Digital Tracking System"],
                ["tool_live_monitoring", "Live Engagement Monitoring"],
                ["tool_post_survey", "Post-Event Pulse Survey"],
                ["tool_30day_survey", "30-Day Follow-Up Survey"],
                ["tool_90day_tracking", "90-Day Behaviour Tracking"],
                ["tool_social_listening", "Social Listening"],
                ["tool_commercial_data", "Commercial Data Pull"],
              ].map(([key, label]) => (
                <div key={key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 6 }}>
                  <span style={{ color: T.textSecondary, fontSize: 12 }}>{label}</span>
                  <select value={briefForm[key]} onChange={e => setBriefForm({...briefForm, [key]: e.target.value})} style={{ padding: "3px 8px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 4, color: briefForm[key] === "Yes" ? archetype.color : T.textMuted, fontSize: 11, fontFamily: "inherit", outline: "none" }}>
                    <option>Yes</option><option>No</option><option>N/A</option>
                  </select>
                </div>
              ))}
            </div>

            <div style={sectionStyle}>Impact Story Intent</div>
            <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "14px 16px", marginBottom: 16 }}>
              <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 10, fontStyle: "italic" }}>Draft the story you intend to tell — complete with actuals after the event</div>
              <div style={{ marginBottom: 10 }}><label style={labelStyle}>Before Stretchfield, [CLIENT] struggled with...</label><input value={briefForm.story_before} onChange={e => setBriefForm({...briefForm, story_before: e.target.value})} style={inputStyle} /></div>
              <div style={{ marginBottom: 10 }}><label style={labelStyle}>We designed [ELEMENT] because...</label><input value={briefForm.story_design} onChange={e => setBriefForm({...briefForm, story_design: e.target.value})} style={inputStyle} /></div>
              <div><label style={labelStyle}>As a result, [OUTCOME] happened...</label><input value={briefForm.story_outcome} onChange={e => setBriefForm({...briefForm, story_outcome: e.target.value})} style={inputStyle} /></div>
            </div>

            <button onClick={saveBrief} disabled={saving} style={{ background: `linear-gradient(135deg, ${archetype.color}, ${archetype.color}99)`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Saving..." : "Save Impact Brief"}</button>
          </div>
        )}

        {/*  SCORECARD TAB  */}
        {activeTab === "scorecard" && (
          <div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 4 }}>Score each dimension 0–10 based on Stretchfield's Impact Framework.</div>
            <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 16 }}>For each dimension: set your target, enter the actual result, then score performance.</div>

            {/* ROI Calculator */}
            <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 10, padding: "14px 16px", marginBottom: 16 }}>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, marginBottom: 10 }}>ROI Calculator</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
                <div>
                  <label style={labelStyle}>Event Cost ({getCurrency(user?.country||"Ghana")})</label>
                  <input type="number" value={scorecardForm.event_cost||""} onChange={e => setScorecardForm({...scorecardForm, event_cost: e.target.value})} style={inputStyle} placeholder="Total event cost" />
                </div>
                <div>
                  <label style={labelStyle}>Revenue Impact ({getCurrency(user?.country||"Ghana")})</label>
                  <input type="number" value={scorecardForm.revenue_impact||""} onChange={e => setScorecardForm({...scorecardForm, revenue_impact: e.target.value})} style={inputStyle} placeholder="Estimated revenue generated" />
                </div>
                <div>
                  <label style={labelStyle}>Calculated ROI</label>
                  <div style={{ padding: "9px 12px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8 }}>
                    {scorecardForm.event_cost && scorecardForm.revenue_impact
                      ? <span style={{ color: ((scorecardForm.revenue_impact - scorecardForm.event_cost)/scorecardForm.event_cost*100) >= 0 ? "#10B981" : T.red, fontWeight: 900, fontSize: 15 }}>
                          {(((scorecardForm.revenue_impact - scorecardForm.event_cost)/scorecardForm.event_cost)*100).toFixed(1)}%
                        </span>
                      : <span style={{ color: T.textMuted, fontSize: 12 }}>Enter costs above</span>}
                  </div>
                </div>
              </div>
            </div>

            {STRETCHFIELD_DIMENSIONS.map(dim => {
              const score = parseFloat(scorecardForm[dim.key+"_score"]||0);
              const scoreColor = score >= 8 ? "#10B981" : score >= 6 ? archetype.color : score >= 4 ? T.amber : T.red;
              return (
              <div key={dim.key} style={{ background: T.bg, border: `1px solid ${T.border}`, borderLeft: `4px solid ${scoreColor}`, borderRadius: 10, padding: "14px 16px", marginBottom: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 3 }}>
                      <span style={{ fontSize: 16 }}>{dim.icon}</span>
                      <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13 }}>{dim.label}</div>
                      <span style={{ background: scoreColor+"20", color: scoreColor, borderRadius: 20, padding: "1px 8px", fontSize: 9, fontWeight: 800 }}>Weight: {Math.round(dim.weight*100)}%</span>
                    </div>
                    <div style={{ color: T.textMuted, fontSize: 11 }}>{dim.description}</div>
                    <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>Key metrics: {dim.metrics.join(" · ")}</div>
                    <div style={{ color: archetype.color, fontSize: 10, marginTop: 2 }}>Benchmark: {dim.benchmark}</div>
                  </div>
                  <div style={{ textAlign: "center", flexShrink: 0, marginLeft: 16 }}>
                    <input type="number" min="0" max="10" step="0.1" value={scorecardForm[dim.key+"_score"]} onChange={e => setScorecardForm({...scorecardForm, [dim.key+"_score"]: parseFloat(e.target.value)||0})} style={{ width: 64, padding: "8px", background: T.surface, border: `2px solid ${scoreColor}60`, borderRadius: 8, color: scoreColor, fontSize: 20, fontWeight: 900, textAlign: "center", fontFamily: "inherit", outline: "none" }} />
                    <div style={{ color: T.textMuted, fontSize: 9, marginTop: 2 }}>/10</div>
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <div>
                    <label style={labelStyle}>Target Set</label>
                    <input value={scorecardForm[dim.key+"_target"]||""} onChange={e => setScorecardForm({...scorecardForm, [dim.key+"_target"]: e.target.value})} style={inputStyle} placeholder={`e.g. ${dim.benchmark}`} />
                  </div>
                  <div>
                    <label style={labelStyle}>Actual Result</label>
                    <input value={scorecardForm[dim.key+"_actual"]||""} onChange={e => setScorecardForm({...scorecardForm, [dim.key+"_actual"]: e.target.value})} style={inputStyle} placeholder="What actually happened..." />
                  </div>
                </div>
              </div>
              );
            })}

            <div style={{ background: archetype.color+"15", border: `2px solid ${archetype.color}40`, borderRadius: 10, padding: "16px 20px", marginBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Overall Impact Score</div>
                <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>Weighted across all 6 Stretchfield dimensions</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ color: archetype.color, fontWeight: 900, fontSize: 32 }}>{calcOverallScore()}</div>
                <div style={{ color: getScoreLabel(calcOverallScore()).color, fontSize: 12, fontWeight: 700 }}>{getScoreLabel(calcOverallScore()).label}</div>
              </div>
            </div>
            <div style={{ marginBottom: 16 }}><label style={labelStyle}>Commentary & Observations</label><textarea value={scorecardForm.commentary} onChange={e => setScorecardForm({...scorecardForm, commentary: e.target.value})} rows={3} style={{...inputStyle, resize: "vertical"}} placeholder="Overall notes on event performance, key wins, areas for improvement..." /></div>
            <button onClick={saveScorecard} disabled={saving} style={{ background: `linear-gradient(135deg, ${archetype.color}, ${archetype.color}99)`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Saving..." : "Save Scorecard"}</button>
          </div>
        )}

        {/*  POST-EVENT DATA TAB  */}
        {activeTab === "post-data" && (
          <div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 16 }}>Enter actuals after the event. Compare against your pre-set targets from the Impact Brief.</div>

            {[
              { section: "Attendance & Reach", fields: [["total_attendees","Total Attendees","number"],["target_audience_pct","% Target Audience","number"],["no_show_rate","No-Show Rate (%)","number"]] },
              { section: "Engagement & Dwell", fields: [["avg_dwell_time","Average Dwell Time (mins)","number"],["digital_completion_pct","Digital Touchpoint Completion (%)","number"],["interactive_participation_pct","Interactive Feature Participation (%)","number"]] },
              { section: "Sentiment & Satisfaction", fields: [["satisfaction_score","Post-Event Satisfaction Score (/10)","number"],["nps_score","NPS Score","number"],["positive_sentiment_pct","Positive Sentiment % (social/survey)","number"]] },
              { section: "Behaviour Change", fields: [["behaviour_30day","30-Day Behaviour Signal","text"],["behaviour_90day","90-Day Behaviour Signal","text"],["knowledge_recall_pct","Knowledge/Recall Score (%)","number"]] },
              { section: "Commercial Outcomes", fields: [["retention_rate","Retention Rate (%)","number"],["revenue_shift_pct","Revenue Contribution Shift (%)","number"],["opportunities_generated","Pipeline/Opportunitys Generated","number"]] },
              { section: "Social & Brand", fields: [["organic_posts","Organic Social Posts Generated","number"],["organic_reach","Total Organic Reach (impressions)","number"],["earned_media","Earned Media Placements","number"]] },
            ].map(({ section, fields }) => (
              <div key={section}>
                <div style={sectionStyle}>{section}</div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginBottom: 8 }}>
                  {fields.map(([key, label, type]) => (
                    <div key={key}>
                      <label style={labelStyle}>{label}</label>
                      <input type={type} value={postForm[key]} onChange={e => setPostForm({...postForm, [key]: e.target.value})} style={inputStyle} placeholder="Enter actual" />
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {/* Benchmark comparison */}
            {(postForm.satisfaction_score || postForm.nps_score) && (
              <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 10, padding: "14px 16px", marginBottom: 16 }}>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 13, marginBottom: 12 }}>vs. Industry Benchmarks</div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 10 }}>
                  {[
                    ["Satisfaction", postForm.satisfaction_score, "7.1/10", "8.5+/10"],
                    ["NPS", postForm.nps_score, "+22", "+50"],
                    ["Sentiment", postForm.positive_sentiment_pct+"%", "64%", "85%+"],
                  ].filter(([,v]) => v && v !== "undefined%").map(([label, actual, industry, sfTarget]) => (
                    <div key={label} style={{ background: T.surface, borderRadius: 8, padding: "10px 12px", border: `1px solid ${T.border}` }}>
                      <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 6 }}>{label}</div>
                      <div style={{ color: archetype.color, fontWeight: 900, fontSize: 18 }}>{actual}</div>
                      <div style={{ color: T.textMuted, fontSize: 10, marginTop: 4 }}>Industry: {industry}</div>
                      <div style={{ color: "#10B981", fontSize: 10 }}>SF Target: {sfTarget}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <button onClick={savePostData} disabled={saving} style={{ background: `linear-gradient(135deg, ${archetype.color}, ${archetype.color}99)`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13 }}>{saving ? "Saving..." : "Save Post-Event Data"}</button>
          </div>
        )}

        {/*  IMPACT REPORT TAB  */}
        {activeTab === "report" && (
          <div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 16 }}>Build your client impact story. This becomes your case study and pitch asset.</div>

            <div style={{ marginBottom: 12 }}><label style={labelStyle}>Headline Impact Statement</label><input value={reportForm.headline} onChange={e => setReportForm({...reportForm, headline: e.target.value})} style={inputStyle} placeholder="One powerful line that captures the entire impact" /></div>

            <div style={sectionStyle}>The Problem (Before Stretchfield)</div>
            <div style={{ marginBottom: 10 }}><label style={labelStyle}>What was the business challenge?</label><textarea value={reportForm.problem_challenge} onChange={e => setReportForm({...reportForm, problem_challenge: e.target.value})} rows={2} style={{...inputStyle, resize:"vertical"}} /></div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 12, marginBottom: 12 }}>
              <div><label style={labelStyle}>What wasn't working?</label><textarea value={reportForm.problem_previous} onChange={e => setReportForm({...reportForm, problem_previous: e.target.value})} rows={2} style={{...inputStyle, resize:"vertical"}} /></div>
              <div><label style={labelStyle}>Cost of inaction?</label><textarea value={reportForm.problem_inaction} onChange={e => setReportForm({...reportForm, problem_inaction: e.target.value})} rows={2} style={{...inputStyle, resize:"vertical"}} /></div>
            </div>

            <div style={sectionStyle}>What Stretchfield Engineered</div>
            {[1,2,3].map(n => (
              <div key={n} style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 10, marginBottom: 10 }}>
                <div><label style={labelStyle}>Design Element {n}</label><input value={reportForm[`design${n}_name`]} onChange={e => setReportForm({...reportForm, [`design${n}_name`]: e.target.value})} style={inputStyle} placeholder="Element name" /></div>
                <div><label style={labelStyle}>Intent (why this?)</label><input value={reportForm[`design${n}_intent`]} onChange={e => setReportForm({...reportForm, [`design${n}_intent`]: e.target.value})} style={inputStyle} placeholder="Strategic reason" /></div>
              </div>
            ))}

            <div style={sectionStyle}>Measured Outcomes</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 10, marginBottom: 16 }}>
              {[1,2,3,4].map(n => (
                <div key={n} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 8, background: T.bg, padding: "10px 12px", borderRadius: 8, border: `1px solid ${T.border}` }}>
                  <div><label style={labelStyle}>Metric {n}</label><input value={reportForm[`metric${n}_label`]} onChange={e => setReportForm({...reportForm, [`metric${n}_label`]: e.target.value})} style={inputStyle} placeholder="Label" /></div>
                  <div><label style={labelStyle}>Value</label><input value={reportForm[`metric${n}_value`]} onChange={e => setReportForm({...reportForm, [`metric${n}_value`]: e.target.value})} style={inputStyle} placeholder="e.g. 87%" /></div>
                </div>
              ))}
            </div>

            <div style={sectionStyle}>Client Voice</div>
            <div style={{ marginBottom: 10 }}><label style={labelStyle}>Client Quote</label><textarea value={reportForm.client_quote} onChange={e => setReportForm({...reportForm, client_quote: e.target.value})} rows={3} style={{...inputStyle, resize:"vertical"}} placeholder="Direct quote from client..." /></div>
            <div style={{ marginBottom: 16 }}><label style={labelStyle}>Attribution</label><input value={reportForm.quote_attribution} onChange={e => setReportForm({...reportForm, quote_attribution: e.target.value})} style={inputStyle} placeholder="Name, Title, Company" /></div>

            <div style={sectionStyle}>The One-Line Story</div>
            <div style={{ background: T.bg, border: `1px solid ${archetype.color}30`, borderRadius: 8, padding: "14px 16px", marginBottom: 16 }}>
              <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 8 }}>Complete this sentence:</div>
              <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 6, fontStyle: "italic" }}>"A [DESIGN ELEMENT] we placed into [EVENT NAME] because [STRATEGIC INTENT] resulted in [MEASURABLE OUTCOME] for [CLIENT], proving that [BUSINESS TRUTH]."</div>
              <textarea value={reportForm.one_line_story} onChange={e => setReportForm({...reportForm, one_line_story: e.target.value})} rows={3} style={{...inputStyle, resize:"vertical"}} placeholder="Write your one-line impact story..." />
            </div>

            {/* Score summary */}
            {scorecard && (
              <div style={{ background: archetype.color+"12", border: `1px solid ${archetype.color}30`, borderRadius: 10, padding: "14px 16px", marginBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Overall Impact Score</div>
                  <div style={{ color: T.textMuted, fontSize: 11 }}>Benchmarked against: Industry avg {BENCHMARKS.satisfaction_score.industry} satisfaction | SF Target {BENCHMARKS.satisfaction_score.sf_target}</div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ color: archetype.color, fontWeight: 900, fontSize: 32 }}>{scorecard.overall_score}/10</div>
                  <div style={{ color: getScoreLabel(scorecard.overall_score).color, fontSize: 12, fontWeight: 700 }}>{getScoreLabel(scorecard.overall_score).label}</div>
                </div>
              </div>
            )}

            <button onClick={saveReport} disabled={saving} style={{ background: `linear-gradient(135deg, ${archetype.color}, ${archetype.color}99)`, border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13, marginRight: 10 }}>{saving ? "Saving..." : "Save Impact Report"}</button>
          </div>
        )}

        {/* CONSOLIDATED IMPACT REPORT TAB */}
        {activeTab === "consolidated" && (
          <div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 16 }}>Auto-generated from your Impact Brief, Post-Event Data and Scorecard.</div>
            <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
              {[["Impact Brief", !!brief], ["Post-Event Data", !!postData], ["Scorecard", !!scorecard]].map(([label, done]) => (
                <div key={label} style={{ flex: 1, background: done ? "#10B98112" : T.amber+"12", border: `1px solid ${done ? "#10B981" : T.amber}30`, borderRadius: 8, padding: "8px 12px", textAlign: "center" }}>
                  <div style={{ fontSize: 16 }}>{done ? "✅" : "⏳"}</div>
                  <div style={{ color: done ? "#10B981" : T.amber, fontSize: 11, fontWeight: 700 }}>{label}</div>
                </div>
              ))}
            </div>
            {brief && (
              <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 10, padding: "14px 16px", marginBottom: 14 }}>
                <div style={{ color: archetype.color, fontSize: 10, fontWeight: 800, textTransform: "uppercase", marginBottom: 8 }}>Impact Objective</div>
                <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{brief.impact_objective || "—"}</div>
                <div style={{ color: T.textMuted, fontSize: 11, marginTop: 4 }}>Target Audience: {brief.target_audience || "—"}</div>
                <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
                  {[["KPI 1", brief.kpi1_name, brief.kpi1_target], ["KPI 2", brief.kpi2_name, brief.kpi2_target], ["KPI 3", brief.kpi3_name, brief.kpi3_target]].filter(([,n]) => n).map(([label, name, target]) => (
                    <div key={label} style={{ background: T.surface, borderRadius: 6, padding: "8px 10px" }}>
                      <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>{label}</div>
                      <div style={{ color: T.textPrimary, fontSize: 12, fontWeight: 700 }}>{name}</div>
                      <div style={{ color: archetype.color, fontSize: 11 }}>Target: {target}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {scorecard && (
              <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 10, padding: "14px 16px", marginBottom: 14 }}>
                <div style={{ color: archetype.color, fontSize: 10, fontWeight: 800, textTransform: "uppercase", marginBottom: 8 }}>Scorecard Summary</div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px,1fr))", gap: 8 }}>
                  {STRETCHFIELD_DIMENSIONS.map(dim => {
                    const sc_score = parseFloat(scorecard[dim.key+"_score"]||0);
                    const sc_color = sc_score >= 8 ? "#10B981" : sc_score >= 6 ? archetype.color : sc_score >= 4 ? T.amber : T.red;
                    return (
                      <div key={dim.key} style={{ background: T.surface, borderRadius: 8, padding: "10px 12px", borderLeft: `3px solid ${sc_color}` }}>
                        <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>{dim.label}</div>
                        <div style={{ color: sc_color, fontWeight: 900, fontSize: 20 }}>{sc_score}/10</div>
                        <div style={{ color: T.textMuted, fontSize: 10 }}>{scorecard[dim.key+"_actual"]||"—"}</div>
                      </div>
                    );
                  })}
                </div>
                <div style={{ marginTop: 10, display: "flex", justifyContent: "space-between", alignItems: "center", background: archetype.color+"12", borderRadius: 8, padding: "10px 14px" }}>
                  <div style={{ color: T.textPrimary, fontWeight: 800 }}>Overall Score</div>
                  <div style={{ color: archetype.color, fontWeight: 900, fontSize: 24 }}>{calcOverallScore()}/10</div>
                </div>
                {scorecard.event_cost && scorecard.revenue_impact && (
                  <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
                    {[
                      ["Event Cost", getCurrency(user?.country||"Ghana")+" "+parseFloat(scorecard.event_cost||0).toLocaleString(), T.textMuted],
                      ["Revenue Impact", getCurrency(user?.country||"Ghana")+" "+parseFloat(scorecard.revenue_impact||0).toLocaleString(), "#10B981"],
                      ["ROI", (((scorecard.revenue_impact-scorecard.event_cost)/scorecard.event_cost)*100).toFixed(1)+"%", ((scorecard.revenue_impact-scorecard.event_cost)/scorecard.event_cost*100)>=0?"#10B981":T.red],
                    ].map(([label, value, color]) => (
                      <div key={label} style={{ background: T.surface, borderRadius: 6, padding: "8px 10px", textAlign: "center" }}>
                        <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>{label}</div>
                        <div style={{ color, fontWeight: 900, fontSize: 14 }}>{value}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {postData && (
              <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 10, padding: "14px 16px", marginBottom: 14 }}>
                <div style={{ color: archetype.color, fontSize: 10, fontWeight: 800, textTransform: "uppercase", marginBottom: 8 }}>Post-Event Data Highlights</div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 8 }}>
                  {[["Attendees",postData.total_attendees],["Satisfaction",postData.satisfaction_score?postData.satisfaction_score+"/10":"—"],["NPS",postData.nps_score||"—"],["Sentiment",postData.positive_sentiment_pct?postData.positive_sentiment_pct+"%":"—"],["Leads",postData.opportunities_generated||"—"],["Revenue Shift",postData.revenue_shift_pct?postData.revenue_shift_pct+"%":"—"]].map(([label,value]) => (
                    <div key={label} style={{ background: T.surface, borderRadius: 8, padding: "10px 12px", textAlign: "center" }}>
                      <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>{label}</div>
                      <div style={{ color: archetype.color, fontWeight: 900, fontSize: 16 }}>{value||"—"}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div style={{ background: `linear-gradient(135deg, ${archetype.color}12, ${archetype.color}05)`, border: `1px solid ${archetype.color}30`, borderRadius: 12, padding: "20px", marginBottom: 16, textAlign: "center" }}>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15, marginBottom: 6 }}>Generate Consolidated Impact Report</div>
              <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 16 }}>Claude AI will synthesise Brief + Scorecard + Post-Event Data into a client-ready narrative.</div>
              {!brief || !scorecard ? (
                <div style={{ color: T.amber, fontSize: 12, fontWeight: 700 }}>Complete Impact Brief and Scorecard first.</div>
              ) : (
                <button onClick={async () => {
                  setSaving(true);
                  try {
                    const resp = await fetch("https://api.anthropic.com/v1/messages", { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ model:"claude-sonnet-4-6", max_tokens:1000, messages:[{ role:"user", content:`Write a professional client-facing impact report for Stretchfield.

Event: ${project?.name}
Category: ${project?.event_category}
Client: ${project?.client}

IMPACT OBJECTIVE: ${brief?.impact_objective||"—"}
TARGET AUDIENCE: ${brief?.target_audience||"—"}
KPIs: ${[brief?.kpi1_name,brief?.kpi2_name,brief?.kpi3_name].filter(Boolean).join(", ")}

SCORECARD:
${STRETCHFIELD_DIMENSIONS.map(d=>`${d.label}: ${scorecard?.[d.key+"_score"]||0}/10 — Actual: ${scorecard?.[d.key+"_actual"]||"—"}`).join("\n")}
Overall: ${calcOverallScore()}/10
${scorecard?.event_cost?`ROI: ${(((scorecard.revenue_impact-scorecard.event_cost)/scorecard.event_cost)*100).toFixed(1)}%`:""}

POST-EVENT DATA:
Attendees: ${postData?.total_attendees||"—"}, Satisfaction: ${postData?.satisfaction_score||"—"}/10, NPS: ${postData?.nps_score||"—"}, Sentiment: ${postData?.positive_sentiment_pct||"—"}%, Leads: ${postData?.opportunities_generated||"—"}, Revenue Shift: ${postData?.revenue_shift_pct||"—"}%

Write: 1) Executive Summary (2-3 sentences) 2) 3 Key Wins 3) Impact Narrative (2 paragraphs) 4) One Recommendation. Be specific, use actual numbers, professional tone.` }] }) });
                    const data = await resp.json();
                    const narrative = data.content?.[0]?.text || "";
                    const existing = await supabase.from("event_impact_reports").select("id").eq("project_id", project.id).maybeSingle();
                    if (existing.data) { await supabase.from("event_impact_reports").update({ headline: project?.name+" — Impact Report", one_line_story: narrative }).eq("id", existing.data.id); }
                    else { await supabase.from("event_impact_reports").insert({ project_id: project.id, headline: project?.name+" — Impact Report", one_line_story: narrative }); }
                    await load();
                    alert("Impact report generated! View in Impact Report tab.");
                  } catch(err) { alert("Generation failed: "+err.message); }
                  setSaving(false);
                }} disabled={saving} style={{ background:`linear-gradient(135deg,${archetype.color},${archetype.color}99)`, border:"none", color:"#fff", padding:"12px 32px", borderRadius:10, cursor:"pointer", fontWeight:800, fontSize:14 }}>
                  {saving ? "Generating..." : "✨ Generate Report with AI"}
                </button>
              )}
            </div>
            {report?.one_line_story && (
              <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 10, padding: "16px 20px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom: 10 }}>
                  <div style={{ color: archetype.color, fontSize: 10, fontWeight: 800, textTransform: "uppercase" }}>Generated Report Narrative</div>
                  <button onClick={() => downloadPDF(generateImpactReportPDF(project, brief, scorecard, postData, report, null), `ImpactReport-${project?.name||"event"}.html`)} style={{ background:`linear-gradient(135deg,${archetype.color},${archetype.color}99)`, border:"none", color:"#fff", padding:"6px 14px", borderRadius:8, cursor:"pointer", fontWeight:700, fontSize:11 }}>↓ Download PDF</button>
                </div>
                <div style={{ color: T.textPrimary, fontSize: 13, lineHeight: 1.7, whiteSpace: "pre-wrap" }}>{report.one_line_story}</div>
              </div>
            )}
          </div>
        )}
        )}
      </div>
    </div>
  );
};



const CEOClientFinanceView = ({ user, activeCountry = "All" }) => {
  const [clients, setClients] = useState([]);
  const [events, setEvents] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [tab, setTab] = useState("budget");
  const [saving, setSaving] = useState(false);

  // Budget form
  const [budgetForm, setBudgetForm] = useState({ agreed_budget: "", management_fee_pct: "15" });
  // Expense form
  const [expenseForm, setExpenseForm] = useState({ category: "Venue", description: "", amount: "" });
  // Invoice form
  const [invoiceForm, setInvoiceForm] = useState({ title: "", file_url: "" });

  const load = async () => {
    const acF = activeCountry && activeCountry !== "All";
    const [cl, ev, bud, exp, inv] = await Promise.all([
      acF ? supabase.from("clients").select("*").eq("country",activeCountry).order("name") : supabase.from("clients").select("*").order("name"),
      acF ? supabase.from("projects").select("*").eq("country",activeCountry).order("name") : supabase.from("projects").select("*").order("name"),
      supabase.from("client_budgets").select("*"),
      supabase.from("client_expenses").select("*").order("created_at", { ascending: false }),
      supabase.from("client_invoices").select("*").order("created_at", { ascending: false }),
    ]);
    setClients(cl.data || []);
    setEvents(ev.data || []);
    setBudgets(bud.data || []);
    setExpenses(exp.data || []);
    setInvoices(inv.data || []);
  };

  useEffect(() => { load(); }, []);

  const clientEvents = events.filter(e => e.client_id === selectedClient);
  const currentBudget = budgets.find(b => b.project_id === selectedEvent && b.client_id === selectedClient);
  const currentExpenses = expenses.filter(e => e.project_id === selectedEvent && e.client_id === selectedClient);
  const currentInvoices = invoices.filter(i => i.project_id === selectedEvent && i.client_id === selectedClient);

  const handleSaveBudget = async () => {
    if (!selectedClient || !selectedEvent) return;
    setSaving(true);
    if (currentBudget) {
      await supabase.from("client_budgets").update({
        agreed_budget: parseFloat(budgetForm.agreed_budget),
        management_fee_pct: parseFloat(budgetForm.management_fee_pct),
        updated_at: new Date().toISOString(),
      }).eq("id", currentBudget.id);
    } else {
      await supabase.from("client_budgets").insert({
        project_id: selectedEvent, client_id: selectedClient,
        agreed_budget: parseFloat(budgetForm.agreed_budget),
        management_fee_pct: parseFloat(budgetForm.management_fee_pct),
      });
    }
    setSaving(false);
    load();
  };

  const handleAddExpense = async () => {
    if (!selectedClient || !selectedEvent || !expenseForm.amount) return;
    setSaving(true);
    await supabase.from("client_expenses").insert({
      project_id: selectedEvent, client_id: selectedClient,
      category: expenseForm.category,
      description: expenseForm.description,
      amount: parseFloat(expenseForm.amount),
    });
    setExpenseForm({ category: "Venue", description: "", amount: "" });
    setSaving(false);
    load();
  };

  const handleDeleteExpense = async (id) => {
    await supabase.from("client_expenses").delete().eq("id", id);
    load();
  };

  const handleUploadInvoice = async () => {
    if (!selectedClient || !selectedEvent || !invoiceForm.title || !invoiceForm.file_url) return;
    setSaving(true);
    await supabase.from("client_invoices").insert({
      project_id: selectedEvent, client_id: selectedClient,
      title: invoiceForm.title, file_url: invoiceForm.file_url,
      uploaded_by: user.id,
    });
    setInvoiceForm({ title: "", file_url: "" });
    setSaving(false);
    load();
  };

  const handleDeleteInvoice = async (id) => {
    await supabase.from("client_invoices").delete().eq("id", id);
    load();
  };

  // Sync budget form when event selected
  useEffect(() => {
    if (currentBudget) {
      setBudgetForm({ agreed_budget: currentBudget.agreed_budget, management_fee_pct: currentBudget.management_fee_pct });
    } else {
      setBudgetForm({ agreed_budget: "", management_fee_pct: "15" });
    }
  }, [selectedEvent, budgets]);

  const totalSpent = currentExpenses.reduce((s, e) => s + (e.amount || 0), 0);
  const agreedBudget = currentBudget?.agreed_budget || 0;
  const spentPct = agreedBudget > 0 ? Math.min(100, Math.round((totalSpent / agreedBudget) * 100)) : 0;

  const categoryColors = {
    "Venue": "#00C8FF", "Catering": "#00E5C8", "Production": "#C9A84C",
    "Logistics": "#3B7BFF", "Management Fee": "#E879F9", "Other": "#8BA3C7",
  };

  const inputStyle = { width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };
  const labelStyle = { color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 5, display: "block" };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>CEO · Finance</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Client Financials</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Set budgets, record spend and upload invoices per client event</div>
      </div>

      {/* Client + Event selectors */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 24 }}>
        <div>
          <label style={labelStyle}>Select Client</label>
          <select value={selectedClient || ""} onChange={e => { setSelectedClient(e.target.value); setSelectedEvent(null); }}
            style={inputStyle}>
            <option value="">— Choose client —</option>
            {clients.map(c => <option key={c.id} value={c.id}>{c.company || c.name}</option>)}
          </select>
        </div>
        <div>
          <label style={labelStyle}>Select Event</label>
          <select value={selectedEvent || ""} onChange={e => setSelectedEvent(e.target.value)} style={inputStyle} disabled={!selectedClient}>
            <option value="">— Choose event —</option>
            {clientEvents.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
          </select>
        </div>
      </div>

      {selectedEvent && (
        <>
          {/* Summary strip */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginBottom: 20 }}>
            {[
              { label: "Agreed Budget", value: agreedBudget > 0 ? `${getCurrency(activeCountry||user?.country||"Ghana")} ${(agreedBudget.toLocaleString())}` : "Not set", color: T.cyan },
              { label: "Total Recorded Spend", value: `${getCurrency(activeCountry||user?.country||"Ghana")} ${(totalSpent.toLocaleString())}`, color: T.amber },
              { label: "Utilisation", value: agreedBudget > 0 ? spentPct + "%" : "—", color: spentPct > 90 ? T.red : T.teal },
            ].map((k, i) => (
              <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
                <div style={{ color: k.color, fontSize: 18, fontWeight: 900 }}>{k.value}</div>
                <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 4 }}>{k.label}</div>
              </div>
            ))}
          </div>

          {/* Tabs */}
          <div style={{ display: "flex", gap: 6, marginBottom: 20, borderBottom: `1px solid ${T.border}`, paddingBottom: 0 }}>
            {["budget", "expenses", "invoices"].map(t => (
              <button key={t} onClick={() => setTab(t)} style={{
                padding: "9px 18px", background: "none", border: "none", borderBottom: `2px solid ${tab === t ? T.cyan : "transparent"}`,
                color: tab === t ? T.cyan : T.textMuted, cursor: "pointer", fontSize: 12, fontWeight: 700,
                textTransform: "uppercase", letterSpacing: "0.06em", transition: "all 0.15s",
              }}>{t}</button>
            ))}
          </div>

          {/* Budget tab */}
          {tab === "budget" && (
            <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "22px 24px" }}>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14, marginBottom: 18 }}>{currentBudget ? "Update Budget" : "Set Budget"}</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 14, marginBottom: 16 }}>
                <div>
                  <label style={labelStyle}>Agreed Budget (${getCurrency(activeCountry||user?.country||"Ghana")})</label>
                  <input type="number" value={budgetForm.agreed_budget} onChange={e => setBudgetForm({ ...budgetForm, agreed_budget: e.target.value })} placeholder="e.g. 50000" style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Management Fee %</label>
                  <input type="number" min="15" max="30" value={budgetForm.management_fee_pct} onChange={e => setBudgetForm({ ...budgetForm, management_fee_pct: e.target.value })} placeholder="15–30" style={inputStyle} />
                </div>
              </div>
              {budgetForm.agreed_budget && (
                <div style={{ padding: "10px 14px", background: T.cyan + "10", border: `1px solid ${T.cyan}30`, borderRadius: 8, marginBottom: 16, fontSize: 12, color: T.cyan }}>
                  Management Fee: GHS {(parseFloat(budgetForm.agreed_budget) * parseFloat(budgetForm.management_fee_pct) / 100).toLocaleString()} ({budgetForm.management_fee_pct}%)
                </div>
              )}
              <button onClick={handleSaveBudget} disabled={saving || !budgetForm.agreed_budget} style={{
                background: T.cyan + "20", border: `1px solid ${T.cyan}40`, color: T.cyan,
                padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700, opacity: !budgetForm.agreed_budget ? 0.5 : 1,
              }}>{saving ? "Saving..." : currentBudget ? "Update Budget" : "Save Budget"}</button>
            </div>
          )}

          {/* Expenses tab */}
          {tab === "expenses" && (
            <div>
              <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "22px 24px", marginBottom: 16 }}>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14, marginBottom: 16 }}>Add Expense Entry</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
                  <div>
                    <label style={labelStyle}>Category</label>
                    <select value={expenseForm.category} onChange={e => setExpenseForm({ ...expenseForm, category: e.target.value })} style={inputStyle}>
                      {["Venue","Catering","Production","Logistics","Management Fee","Other"].map(c => <option key={c}>{c}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Description</label>
                    <input value={expenseForm.description} onChange={e => setExpenseForm({ ...expenseForm, description: e.target.value })} placeholder="Brief description" style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Amount (${getCurrency(activeCountry||user?.country||"Ghana")})</label>
                    <input type="number" value={expenseForm.amount} onChange={e => setExpenseForm({ ...expenseForm, amount: e.target.value })} placeholder="0.00" style={inputStyle} />
                  </div>
                </div>
                <button onClick={handleAddExpense} disabled={saving || !expenseForm.amount} style={{
                  background: T.teal + "20", border: `1px solid ${T.teal}40`, color: T.teal,
                  padding: "9px 20px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700, opacity: !expenseForm.amount ? 0.5 : 1,
                }}>+ Add Entry</button>
              </div>

              {/* Expense list */}
              {currentExpenses.length === 0 ? (
                <div style={{ color: T.textMuted, fontSize: 13, fontStyle: "italic", textAlign: "center", padding: 30 }}>No expenses recorded yet.</div>
              ) : (
                <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ borderBottom: `1px solid ${T.border}` }}>
                        {["Category","Description","Amount",""].map((h, i) => (
                          <th key={i} style={{ padding: "12px 16px", textAlign: i === 2 ? "right" : "left", color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {currentExpenses.map((e, i) => (
                        <tr key={e.id} style={{ borderBottom: i < currentExpenses.length - 1 ? `1px solid ${T.border}44` : "none" }}>
                          <td style={{ padding: "12px 16px" }}>
                            <span style={{ background: (categoryColors[e.category] || T.textMuted) + "20", color: categoryColors[e.category] || T.textMuted, border: `1px solid ${categoryColors[e.category] || T.textMuted}30`, borderRadius: 20, padding: "2px 10px", fontSize: 10, fontWeight: 700 }}>{e.category}</span>
                          </td>
                          <td style={{ padding: "12px 16px", color: T.textPrimary, fontSize: 13 }}>{e.description || "—"}</td>
                          <td style={{ padding: "12px 16px", color: T.amber, fontWeight: 700, fontSize: 13, textAlign: "right" }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(e.amount).toLocaleString()).toLocaleString()}</td>
                          <td style={{ padding: "12px 16px", textAlign: "right" }}>
                            <button onClick={() => handleDeleteExpense(e.id)} style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 16 }}
                              onMouseEnter={el => el.currentTarget.style.color = T.red}
                              onMouseLeave={el => el.currentTarget.style.color = T.textMuted}>×</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr style={{ borderTop: `1px solid ${T.border}` }}>
                        <td colSpan={2} style={{ padding: "12px 16px", color: T.textMuted, fontSize: 12, fontWeight: 700 }}>Total</td>
                        <td style={{ padding: "12px 16px", color: T.amber, fontWeight: 900, fontSize: 14, textAlign: "right" }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalSpent.toLocaleString()).toLocaleString()}</td>
                        <td />
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* Invoices tab */}
          {tab === "invoices" && (
            <div>
              <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "22px 24px", marginBottom: 16 }}>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14, marginBottom: 16 }}>Upload Invoice</div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 12, marginBottom: 12 }}>
                  <div>
                    <label style={labelStyle}>Invoice Title</label>
                    <input value={invoiceForm.title} onChange={e => setInvoiceForm({ ...invoiceForm, title: e.target.value })} placeholder="e.g. Final Invoice — Brand Event 2025" style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>File URL (Supabase Storage / Drive link)</label>
                    <input value={invoiceForm.file_url} onChange={e => setInvoiceForm({ ...invoiceForm, file_url: e.target.value })} placeholder="https://..." style={inputStyle} />
                  </div>
                </div>
                <button onClick={handleUploadInvoice} disabled={saving || !invoiceForm.title || !invoiceForm.file_url} style={{
                  background: T.cyan + "20", border: `1px solid ${T.cyan}40`, color: T.cyan,
                  padding: "9px 20px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700, opacity: (!invoiceForm.title || !invoiceForm.file_url) ? 0.5 : 1,
                }}>Upload Invoice</button>
              </div>

              {currentInvoices.length === 0 ? (
                <div style={{ color: T.textMuted, fontSize: 13, fontStyle: "italic", textAlign: "center", padding: 30 }}>No invoices uploaded yet.</div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {currentInvoices.map(inv => (
                    <div key={inv.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 18px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 10 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{ fontSize: 24 }}></div>
                        <div>
                          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{inv.title}</div>
                          <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{new Date(inv.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}</div>
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: 10 }}>
                        <a href={inv.file_url} target="_blank" rel="noopener noreferrer" style={{ background: T.cyan + "18", border: `1px solid ${T.cyan}40`, color: T.cyan, padding: "7px 14px", borderRadius: 8, fontSize: 11, fontWeight: 700, textDecoration: "none" }}>View</a>
                        <button onClick={() => handleDeleteInvoice(inv.id)} style={{ background: T.red + "18", border: `1px solid ${T.red}40`, color: T.red, padding: "7px 14px", borderRadius: 8, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Delete</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {data.length > 0 && (
                <div style={{ padding: "12px 16px", borderTop: `1px solid ${T.border}`, background: T.bg, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ color: T.textMuted, fontSize: 11 }}>{data.length} records · Read-only view · Create and edit in Zoho Books</span>
                  <a href="https://books.zoho.com" target="_blank" rel="noopener noreferrer" style={{ color: "#E67E22", fontSize: 11, fontWeight: 700, textDecoration: "none" }}>Open Zoho Books ↗</a>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};



const ClientFinanceView = ({ user }) => {
  const [clientInfo, setClientInfo] = useState(null);
  const [events, setEvents] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const load = async () => {
    let clientData = null;
    const { data: byProfile } = await supabase.from("clients").select("*").eq("profile_id", user.id).single();
    if (byProfile) { clientData = byProfile; }
    else {
      const { data: byEmail } = await supabase.from("clients").select("*").eq("email", user.email).single();
      if (byEmail) { clientData = byEmail; await supabase.from("clients").update({ profile_id: user.id }).eq("id", byEmail.id); }
    }
    if (!clientData) return;
    setClientInfo(clientData);
    const [ev, bud, exp, inv] = await Promise.all([
      supabase.from("projects").select("*").eq("client_id", clientData.id).eq("active_for_client", true),
      supabase.from("client_budgets").select("*").eq("client_id", clientData.id),
      supabase.from("client_expenses").select("*").eq("client_id", clientData.id),
      supabase.from("client_invoices").select("*").eq("client_id", clientData.id).order("created_at", { ascending: false }),
    ]);
    setEvents(ev.data || []);
    setBudgets(bud.data || []);
    setExpenses(exp.data || []);
    setInvoices(inv.data || []);
    if ((ev.data || []).length > 0 && !selectedEvent) setSelectedEvent((ev.data || [])[0].id);
  };

  useEffect(() => { load(); }, [user.id]);

  const currentBudget = budgets.find(b => b.project_id === selectedEvent);
  const currentExpenses = expenses.filter(e => e.project_id === selectedEvent);
  const currentInvoices = invoices.filter(i => i.project_id === selectedEvent);
  const currentEvent = events.find(e => e.id === selectedEvent);

  const agreedBudget = currentBudget?.agreed_budget || 0;
  const mgmtFeePct = currentBudget?.management_fee_pct || 15;
  const mgmtFee = agreedBudget * (mgmtFeePct / 100);
  const totalSpent = currentExpenses.reduce((s, e) => s + (e.amount || 0), 0);
  const remaining = agreedBudget - totalSpent;
  const spentPct = agreedBudget > 0 ? Math.min(100, Math.round((totalSpent / agreedBudget) * 100)) : 0;

  const categoryTotals = currentExpenses.reduce((acc, e) => {
    acc[e.category] = (acc[e.category] || 0) + (e.amount || 0);
    return acc;
  }, {});

  const categoryColors = {
    "Venue": "#00C8FF", "Catering": "#00E5C8", "Production": "#C9A84C",
    "Logistics": "#3B7BFF", "Management Fee": "#E879F9", "Other": "#8BA3C7",
  };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Client Portal</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Budget & Financials</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Track your event spend and download invoices</div>
      </div>

      {events.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, background: T.surface, borderRadius: 12, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No financial data yet</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>Budget information will appear here once your event is set up.</div>
        </div>
      ) : (
        <>
          {/* Event selector pills */}
          {events.length > 1 && (
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 24 }}>
              {events.map(e => (
                <button key={e.id} onClick={() => setSelectedEvent(e.id)} style={{
                  padding: "6px 16px", borderRadius: 20, border: `1px solid ${selectedEvent === e.id ? T.cyan : T.border}`,
                  background: selectedEvent === e.id ? T.cyan + "20" : "none", color: selectedEvent === e.id ? T.cyan : T.textMuted,
                  cursor: "pointer", fontSize: 11, fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase", transition: "all 0.15s",
                }}>{e.name}</button>
              ))}
            </div>
          )}

          {currentEvent && (
            <>
              {/* Event title */}
              <div style={{ marginBottom: 20 }}>
                <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18 }}>{currentEvent.name}</div>
                <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{currentEvent.phase} · Due {currentEvent.deadline || "TBD"}</div>
              </div>

              {/* KPI strip */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12, marginBottom: 24 }}>
                {[
                  { label: "Agreed Budget", value: agreedBudget > 0 ? `${getCurrency(user?.country||"Ghana")} ${(agreedBudget.toLocaleString())}` : "—", color: T.cyan },
                  { label: "Total Spent", value: totalSpent > 0 ? `${getCurrency(user?.country||"Ghana")} ${(totalSpent.toLocaleString())}` : "—", color: T.amber },
                  { label: "Remaining", value: agreedBudget > 0 ? `${getCurrency(user?.country||"Ghana")} ${(remaining.toLocaleString())}` : "—", color: remaining < 0 ? T.red : T.teal },
                  { label: "Mgmt Fee", value: agreedBudget > 0 ? `GHS ${mgmtFee.toLocaleString()} (${mgmtFeePct}%)` : "—", color: T.magenta },
                ].map((k, i) => (
                  <div key={i} style={{ padding: "16px 18px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
                    <div style={{ color: k.color, fontSize: 16, fontWeight: 900, marginBottom: 4 }}>{k.value}</div>
                    <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>{k.label}</div>
                  </div>
                ))}
              </div>

              {/* Budget utilisation bar */}
              {agreedBudget > 0 && (
                <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "20px 22px", marginBottom: 20 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                    <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>Budget Utilisation</div>
                    <div style={{ color: spentPct > 90 ? T.red : spentPct > 70 ? T.amber : T.teal, fontWeight: 900, fontSize: 18 }}>{spentPct}%</div>
                  </div>
                  <div style={{ height: 12, background: T.border + "44", borderRadius: 6, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: spentPct + "%", background: spentPct > 90 ? `linear-gradient(90deg,${T.amber},${T.red})` : `linear-gradient(90deg,${T.cyan},${T.teal})`, borderRadius: 6, transition: "width 0.6s ease" }} />
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
                    <div style={{ color: T.textMuted, fontSize: 11 }}>GHS {totalSpent.toLocaleString()} spent</div>
                    <div style={{ color: T.textMuted, fontSize: 11 }}>of GHS {agreedBudget.toLocaleString()}</div>
                  </div>
                </div>
              )}

              {/* Spend by category */}
              {Object.keys(categoryTotals).length > 0 && (
                <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "20px 22px", marginBottom: 20 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14, marginBottom: 16 }}>Spend by Category</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    {Object.entries(categoryTotals).map(([cat, amt]) => {
                      const pct = agreedBudget > 0 ? Math.round((amt / agreedBudget) * 100) : 0;
                      const color = categoryColors[cat] || T.textMuted;
                      return (
                        <div key={cat}>
                          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                              <div style={{ width: 8, height: 8, borderRadius: "50%", background: color, flexShrink: 0 }} />
                              <span style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{cat}</span>
                            </div>
                            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                              <span style={{ color: T.textMuted, fontSize: 11 }}>{pct}%</span>
                              <span style={{ color: color, fontWeight: 700, fontSize: 13 }}>{getCurrency(user?.country||"Ghana")+" "+(amt.toLocaleString()).toLocaleString()}</span>
                            </div>
                          </div>
                          <div style={{ height: 5, background: T.border + "44", borderRadius: 3 }}>
                            <div style={{ height: "100%", width: pct + "%", background: color, borderRadius: 3, transition: "width 0.4s ease" }} />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Invoices */}
              <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: "20px 22px" }}>
                <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14, marginBottom: 16 }}> Invoices</div>
                {currentInvoices.length === 0 ? (
                  <div style={{ color: T.textMuted, fontSize: 13, fontStyle: "italic", textAlign: "center", padding: "20px 0" }}>No invoices uploaded yet.</div>
                ) : (
                  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {currentInvoices.map(inv => (
                      <div key={inv.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", background: T.bg, border: `1px solid ${T.border}44`, borderRadius: 8 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                          <div style={{ fontSize: 22 }}></div>
                          <div>
                            <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{inv.title}</div>
                            <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{new Date(inv.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}</div>
                          </div>
                        </div>
                        <a href={inv.file_url} target="_blank" rel="noopener noreferrer" style={{
                          background: T.cyan + "18", border: `1px solid ${T.cyan}40`, color: T.cyan,
                          padding: "7px 16px", borderRadius: 8, fontSize: 11, fontWeight: 700,
                          textDecoration: "none", letterSpacing: "0.06em",
                        }}>Download</a>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};



const FeedbackView = ({ userRole }) => {
  const [feedback, setFeedback] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("all");
  const [loading, setLoading] = useState(true);
  const canSeeDetailed = ["CEO", "Administrator", "Strategy & Events Lead", "Vendor Manager"].includes(userRole);

  useEffect(() => {
    Promise.all([
      supabase.from("feedback").select("*").order("created_at", { ascending: false }),
      supabase.from("projects").select("*"),
    ]).then(([f, e]) => { setFeedback(f.data || []); setEvents(e.data || []); setLoading(false); });
  }, []);

  const filtered = selectedEvent === "all" ? feedback : feedback.filter(f => f.project_id === selectedEvent);
  const avgRating = filtered.length ? (filtered.reduce((a, f) => a + f.rating, 0) / filtered.length).toFixed(1) : 0;

  return (
    <div>
      <PageHeader title="Client Feedback" subtitle="Event satisfaction and reviews" />
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 24 }}>
        <Stat icon="" label="Avg Rating" value={avgRating + "/5"} color={T.amber} />
        <Stat icon="" label="Total Reviews" value={filtered.length} color={T.cyan} />
        <Stat icon="" label="5-Star" value={filtered.filter(f => f.rating === 5).length} color={T.teal} />
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 24 }}>
        <button onClick={() => setSelectedEvent("all")} style={{ padding: "7px 16px", borderRadius: 20, border: "1px solid " + (selectedEvent === "all" ? T.cyan : T.border), background: selectedEvent === "all" ? T.cyan + "20" : "none", color: selectedEvent === "all" ? T.cyan : T.textMuted, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>All Events</button>
        {events.filter(e => feedback.some(f => f.project_id === e.id)).map(e => (
          <button key={e.id} onClick={() => setSelectedEvent(e.id)} style={{ padding: "7px 16px", borderRadius: 20, border: "1px solid " + (selectedEvent === e.id ? T.cyan : T.border), background: selectedEvent === e.id ? T.cyan + "20" : "none", color: selectedEvent === e.id ? T.cyan : T.textMuted, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>{e.name}</button>
        ))}
      </div>
      {loading ? <div style={{ color: T.textMuted, textAlign: "center", padding: 60 }}>Loading...</div>
      : filtered.length === 0 ? (
        <Card style={{ textAlign: "center", padding: 60 }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No feedback yet</div>
        </Card>
      ) : filtered.map(f => (
        <Card key={f.id} style={{ marginBottom: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>{f.client_name}</div>
              <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}> {f.event_name} · {new Date(f.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}</div>
            </div>
            <div style={{ color: "#F59E0B", fontSize: 18 }}>{"".repeat(f.rating)}{"".repeat(5 - f.rating)}</div>
          </div>
          <div style={{ color: T.textSecondary, fontSize: 13, fontStyle: "italic", marginBottom: canSeeDetailed && f.detailed_feedback ? 10 : 0 }}>"{f.summary}"</div>
          {canSeeDetailed && f.detailed_feedback && (
            <div style={{ padding: "10px 14px", background: T.bg, borderRadius: 6, border: "1px solid " + T.border, marginTop: 8 }}>
              <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Detailed Feedback</div>
              <div style={{ color: T.textSecondary, fontSize: 13 }}>{f.detailed_feedback}</div>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
};

//  STRATEGY OVERVIEW 


const StrategyOverviewView = () => {
  const [clients, setClients] = useState([]);
  const [events, setEvents] = useState([]);
  const [feedback, setFeedback] = useState([]);

  useEffect(() => {
    Promise.all([
      supabase.from("clients").select("*"),
      supabase.from("projects").select("*").eq("status", "active"),
      supabase.from("feedback").select("*").order("created_at", { ascending: false }),
    ]).then(([c, e, f]) => { setClients(c.data || []); setEvents(e.data || []); setFeedback(f.data || []); });
  }, []);

  return (
    <div>
      <PageHeader title="Client & Event Overview" subtitle="Pictorial view of all active clients and events" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 20 }}>
        {clients.map(c => {
          const clientEvents = events.filter(e => e.client_id === c.id);
          const clientFeedback = feedback.filter(f => f.client_id === c.id);
          const avgRating = clientFeedback.length ? (clientFeedback.reduce((a, f) => a + f.rating, 0) / clientFeedback.length).toFixed(1) : null;
          return (
            <Card key={c.id}>
              <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 16, paddingBottom: 14, borderBottom: "1px solid " + T.border }}>
                <Avatar initials={(c.company || c.name).slice(0,2).toUpperCase()} size={48} color={T.blue} />
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>{c.company || c.name}</div>
                  <div style={{ color: T.textMuted, fontSize: 12 }}>{c.name}</div>
                  {avgRating && <div style={{ color: "#F59E0B", fontSize: 12, marginTop: 2 }}>{"".repeat(Math.round(avgRating))} {avgRating}/5</div>}
                </div>
              </div>
              {clientEvents.length === 0 ? <div style={{ color: T.textMuted, fontSize: 12 }}>No active events</div>
              : clientEvents.map(e => (
                <div key={e.id} style={{ marginBottom: 12 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                    <div style={{ color: T.textSecondary, fontSize: 13, fontWeight: 600 }}> {e.name}</div>
                    <span style={{ color: T.cyan, fontSize: 12 }}>{e.completion || 0}%</span>
                  </div>
                  <ProgressBar value={e.completion || 0} />
                  <div style={{ color: T.textMuted, fontSize: 11, marginTop: 4 }}>{e.phase} · Due {e.deadline}</div>
                  {feedback.filter(f => f.project_id === e.id).slice(0,1).map(f => (
                    <div key={f.id} style={{ marginTop: 8, padding: "8px 10px", background: T.cyan + "10", borderRadius: 6, border: "1px solid " + T.cyan + "22" }}>
                      <div style={{ color: "#F59E0B", fontSize: 11 }}>{"".repeat(f.rating)}</div>
                      <div style={{ color: T.textSecondary, fontSize: 12, marginTop: 2, fontStyle: "italic" }}>"{f.summary}"</div>
                    </div>
                  ))}
                </div>
              ))}
            </Card>
          );
        })}
      </div>
    </div>
  );
};

//  CLIENT FEEDBACK FORM 


const BudgetView = ({ user }) => {
  const [budgets, setBudgets] = useState([]);
  const [events, setEvents] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ project_id: "", event_name: "", total_budget: "", notes: "" });
  const [saving, setSaving] = useState(false);
  const canEdit = ["CEO", "Administrator", "Finance Manager"].includes(user?.role);

  const load = async () => {
    const [b, ev, ex, inv] = await Promise.all([
      supabase.from("budgets").select("*"),
      supabase.from("projects").select("*").order("created_at", { ascending: false }),
      supabase.from("expenses").select("*"),
      supabase.from("invoices").select("*"),
    ]);
    setBudgets(b.data || []);
    setEvents(ev.data || []);
    setExpenses(ex.data || []);
    setInvoices(inv.data || []);
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    if (!form.project_id || !form.total_budget) return;
    setSaving(true);
    await supabase.from("budgets").insert({
      project_id: form.project_id, event_name: form.event_name,
      total_budget: parseFloat(form.total_budget), notes: form.notes,
      created_by: user.id,
    });
    setModal(false);
    setForm({ project_id: "", event_name: "", total_budget: "", notes: "" });
    setSaving(false);
    load();
  };

  const eventsWithBudget = events.map(ev => {
    const budget = budgets.find(b => b.project_id === ev.id);
    const spent = expenses.filter(e => e.project_id === ev.id).reduce((a, e) => a + (e.amount || 0), 0);
    const invoiced = invoices.filter(i => i.project_id === ev.id).reduce((a, i) => a + (i.amount || 0), 0);
    const remaining = (budget?.total_budget || 0) - spent - invoiced;
    const pct = budget ? Math.min(100, Math.round(((spent + invoiced) / budget.total_budget) * 100)) : 0;
    return { ...ev, budget, spent, invoiced, remaining, pct };
  });

  const totalBudget = budgets.reduce((a, b) => a + (b.total_budget || 0), 0);
  const totalSpent = expenses.reduce((a, e) => a + (e.amount || 0), 0);
  const totalInvoiced = invoices.reduce((a, i) => a + (i.amount || 0), 0);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <PageHeader title="Budget Management" subtitle="Event budgets vs actual spend" />
        {canEdit && <Btn onClick={() => setModal(true)}>+ Set Budget</Btn>}
      </div>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 24 }}>
        <Stat icon="" label="Total Budgeted" value={getCurrency(user?.country||"Ghana")+" "+(totalBudget).toLocaleString()} color={T.cyan} />
        <Stat icon="" label="Total Expenses" value={getCurrency(user?.country||"Ghana")+" "+(totalSpent).toLocaleString()} color={T.amber} />
        <Stat icon="" label="Total Invoiced" value={getCurrency(user?.country||"Ghana")+" "+(totalInvoiced).toLocaleString()} color={T.magenta} />
        <Stat icon="" label="Remaining" value={getCurrency(user?.country||"Ghana")+" "+((totalBudget - totalSpent - totalInvoiced)).toLocaleString()} color={T.teal} />
      </div>
      {eventsWithBudget.filter(e => e.budget).map(ev => (
        <Card key={ev.id} style={{ marginBottom: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15 }}>{ev.name}</div>
              <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{ev.phase} · Due {ev.deadline}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ color: ev.pct >= 90 ? "#F43F5E" : ev.pct >= 70 ? T.amber : T.teal, fontWeight: 800, fontSize: 18 }}>{ev.pct}%</div>
              <div style={{ color: T.textMuted, fontSize: 11 }}>of budget used</div>
            </div>
          </div>
          <ProgressBar value={ev.pct} height={10} color={ev.pct >= 90 ? "#F43F5E" : ev.pct >= 70 ? T.amber : T.teal} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 12, marginTop: 14 }}>
            {[[" Budget", ev.budget.total_budget, T.cyan], [" Expenses", ev.spent, T.amber], [" Invoiced", ev.invoiced, T.magenta], [" Remaining", ev.remaining, ev.remaining < 0 ? "#F43F5E" : T.teal]].map(([label, val, color]) => (
              <div key={label} style={{ padding: "10px", background: T.bg, borderRadius: 8, border: "1px solid " + T.border }}>
                <div style={{ color: T.textMuted, fontSize: 11, marginBottom: 4 }}>{label}</div>
                <div style={{ color, fontWeight: 700, fontSize: 13 }}>{getCurrency(user?.country||"Ghana")+" "+((val || 0).toLocaleString()).toLocaleString()}</div>
              </div>
            ))}
          </div>
          {ev.budget.notes && <div style={{ color: T.textMuted, fontSize: 12, marginTop: 10, fontStyle: "italic" }}>{ev.budget.notes}</div>}
        </Card>
      ))}
      {eventsWithBudget.filter(e => !e.budget).length > 0 && (
        <Card style={{ marginTop: 8 }}>
          <div style={{ color: T.textMuted, fontSize: 12, fontWeight: 600, marginBottom: 12 }}>Events without budgets</div>
          {eventsWithBudget.filter(e => !e.budget).map(ev => (
            <div key={ev.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: "1px solid " + T.border }}>
              <div style={{ color: T.textSecondary, fontSize: 13 }}>{ev.name}</div>
              {canEdit && <button onClick={() => { setForm({ project_id: ev.id, event_name: ev.name, total_budget: "", notes: "" }); setModal(true); }} style={{ background: "none", border: "1px solid " + T.cyan, color: T.cyan, padding: "4px 12px", borderRadius: 6, cursor: "pointer", fontSize: 12 }}>+ Set Budget</button>}
            </div>
          ))}
        </Card>
      )}
      {modal && (
        <Modal title="Set Event Budget" onClose={() => setModal(false)}>
          <Select label="Event" options={[{ value: "", label: "Select event..." }, ...events.map(e => ({ value: e.id, label: e.name }))]}
            value={form.project_id} onChange={v => { const e = events.find(x => x.id === v); setForm({ ...form, project_id: v, event_name: e ? e.name : "" }); }} />
          <Input label={`Total Budget (${getCurrency(user?.country||"Ghana")})`} type="number" placeholder="0" value={form.total_budget} onChange={v => setForm({ ...form, total_budget: v })} />
          <Input label="Notes" placeholder="Budget notes..." value={form.notes} onChange={v => setForm({ ...form, notes: v })} />
          <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
            <Btn onClick={handleCreate} disabled={saving}>{saving ? "Saving..." : "Set Budget"}</Btn>
            <Btn variant="ghost" onClick={() => setModal(false)}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};

//  EXPENSE TRACKER 


const ExpenseView = ({ user }) => {
  const [expenses, setExpenses] = useState([]);
  const [events, setEvents] = useState([]);
  const [modal, setModal] = useState(false);
  const [receiptFile, setReceiptFile] = useState(null);
  const [form, setForm] = useState({ project_id: "", event_name: "", category: "", description: "", amount: "", date: "", vendor: "" });
  const [saving, setSaving] = useState(false);
  const [filter, setFilter] = useState("all");
  const canEdit = ["CEO", "Administrator", "Finance Manager"].includes(user?.role);
  const canApprove = ["CEO", "Administrator"].includes(user?.role);

  const categories = ["Venue", "Catering", "Equipment", "Staffing", "Marketing", "Transport", "Accommodation", "Decor", "Technology", "Miscellaneous"];

  const load = async () => {
    const [ex, ev] = await Promise.all([
      supabase.from("expenses").select("*").order("created_at", { ascending: false }),
      supabase.from("projects").select("*"),
    ]);
    setExpenses(ex.data || []);
    setEvents(ev.data || []);
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    if (!form.description || !form.amount) return;
    setSaving(true);
    let receipt_url = "", receipt_name = "";
    if (receiptFile) {
      const ext = receiptFile.name.split(".").pop();
      const filename = "receipt_" + Date.now() + "." + ext;
      const { error: uploadErr } = await supabase.storage.from("rffs").upload(filename, receiptFile);
      if (!uploadErr) {
        const { data: urlData } = supabase.storage.from("rffs").getPublicUrl(filename);
        receipt_url = urlData.publicUrl;
        receipt_name = receiptFile.name;
      }
    }
    await supabase.from("expenses").insert({
      project_id: form.project_id || null, event_name: form.event_name,
      category: form.category, description: form.description,
      amount: parseFloat(form.amount), date: form.date || new Date().toISOString().split("T")[0],
      vendor: form.vendor, receipt_url, receipt_name,
      created_by: user.id, approved: false,
    });
    setModal(false);
    setForm({ project_id: "", event_name: "", category: "", description: "", amount: "", date: "", vendor: "" });
    setReceiptFile(null);
    setSaving(false);
    load();
  };

  const filtered = filter === "all" ? expenses : expenses.filter(e => e.category === filter);
  const total = filtered.reduce((a, e) => a + (e.amount || 0), 0);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <PageHeader title="Expense Tracker" subtitle="Log and manage company expenses" />
        {canEdit && <Btn onClick={() => setModal(true)}>+ Log Expense</Btn>}
      </div>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 24 }}>
        <Stat icon="" label="Total Expenses" value={getCurrency(user?.country||"Ghana")+" "+(total).toLocaleString()} color={T.amber} />
        <Stat icon="" label="Approved" value={filtered.filter(e => e.approved).length} color={T.teal} />
        <Stat icon="⏳" label="Pending Approval" value={filtered.filter(e => !e.approved).length} color={T.magenta} />
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 24 }}>
        <button onClick={() => setFilter("all")} style={{ padding: "6px 14px", borderRadius: 20, cursor: "pointer", fontSize: 12, fontWeight: 600, border: "1px solid " + (filter === "all" ? T.cyan : T.border), background: filter === "all" ? T.cyan + "20" : "none", color: filter === "all" ? T.cyan : T.textMuted }}>All</button>
        {categories.map(c => expenses.some(e => e.category === c) && (
          <button key={c} onClick={() => setFilter(c)} style={{ padding: "6px 14px", borderRadius: 20, cursor: "pointer", fontSize: 12, fontWeight: 600, border: "1px solid " + (filter === c ? T.cyan : T.border), background: filter === c ? T.cyan + "20" : "none", color: filter === c ? T.cyan : T.textMuted }}>{c}</button>
        ))}
      </div>
      {filtered.length === 0 ? (
        <Card style={{ textAlign: "center", padding: 60 }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No expenses yet</div>
        </Card>
      ) : filtered.map(e => (
        <Card key={e.id} style={{ marginBottom: 14 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14 }}>{e.description}</div>
              <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>
                {e.category && <span style={{ background: T.cyan + "20", color: T.cyan, padding: "2px 8px", borderRadius: 4, fontSize: 11, fontWeight: 600, marginRight: 8 }}>{e.category}</span>}
                {e.event_name && <span> {e.event_name} · </span>}
                {e.vendor && <span> {e.vendor} · </span>}
                {e.date}
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ color: T.amber, fontWeight: 800, fontSize: 16 }}>{getCurrency(user?.country||"Ghana")+" "+((e.amount || 0).toLocaleString()).toLocaleString()}</div>
              <div style={{ marginTop: 4 }}>
                {e.approved
                  ? <span style={{ color: T.teal, fontSize: 11, fontWeight: 600 }}> Approved</span>
                  : canApprove
                    ? <button onClick={async () => { await supabase.from("expenses").update({ approved: true, approved_by: user.id }).eq("id", e.id); load(); }} style={{ background: T.teal + "20", border: "1px solid " + T.teal, color: T.teal, padding: "3px 10px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 600 }}> Approve</button>
                    : <span style={{ color: T.amber, fontSize: 11, fontWeight: 600 }}>⏳ Pending</span>
                }
              </div>
            </div>
          </div>
          {e.receipt_url && (
            <div style={{ marginTop: 10 }}>
              <a href={e.receipt_url} target="_blank" rel="noopener noreferrer" style={{ color: T.cyan, fontSize: 12, fontWeight: 600, textDecoration: "none" }}> {e.receipt_name || "View Receipt"}</a>
            </div>
          )}
        </Card>
      ))}
      {modal && (
        <Modal title="Log Expense" onClose={() => setModal(false)}>
          <Input label="Description" placeholder="What was this expense for?" value={form.description} onChange={v => setForm({ ...form, description: v })} />
          <Input label={`Amount (${getCurrency(user?.country||"Ghana")})`} type="number" placeholder="0" value={form.amount} onChange={v => setForm({ ...form, amount: v })} />
          <Select label="Category" options={[{ value: "", label: "Select category..." }, ...categories.map(c => ({ value: c, label: c }))]}
            value={form.category} onChange={v => setForm({ ...form, category: v })} />
          <Select label="Event (optional)" options={[{ value: "", label: "Not event specific" }, ...events.map(e => ({ value: e.id, label: e.name }))]}
            value={form.project_id} onChange={v => { const e = events.find(x => x.id === v); setForm({ ...form, project_id: v, event_name: e ? e.name : "" }); }} />
          <Input label="Vendor / Supplier" placeholder="Who was paid?" value={form.vendor} onChange={v => setForm({ ...form, vendor: v })} />
          <Input label="Date" type="date" value={form.date} onChange={v => setForm({ ...form, date: v })} />
          <div style={{ marginBottom: 16 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.06em" }}>Receipt (optional)</div>
            <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e => setReceiptFile(e.target.files[0])} style={{ width: "100%", padding: "10px", background: T.bg, border: "1px solid " + T.border, borderRadius: 6, color: T.textSecondary, fontSize: 13, cursor: "pointer" }} />
            {receiptFile && <div style={{ color: T.cyan, fontSize: 12, marginTop: 6 }}> {receiptFile.name}</div>}
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn onClick={handleCreate} disabled={saving}>{saving ? "Saving..." : "Log Expense"}</Btn>
            <Btn variant="ghost" onClick={() => setModal(false)}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};

//  FINANCIAL REPORTS 


const EventIntelligenceReport = ({ event, user, onClose }) => {
  const [report, setReport] = useState(null);

  const [activeSection, setActiveSection] = useState("overview");
  const [saving, setSaving] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [form, setForm] = useState({
    run_of_show_adherence: "", high_impact_moments: "", low_impact_moments: "",
    logistics_notes: "", estimated_attendance: "", expected_attendance: "",
    audience_energy_arrival: "", audience_energy_mid: "", audience_energy_peak: "",
    audience_energy_close: "", key_engagement_moments: "", audience_feedback_observations: "",
    vendor_performance_summary: "", vendors_recommended: "", vendors_not_recommended: "",
    technical_delivery_quality: "", strategic_intent_achieved: "", client_satisfaction: "",
    business_development_signals: "", next_edition_recommendations: "",
  });

  const isCEO = user?.role === "CEO";
  const isStrategy = user?.role === "Strategy & Events Lead";
  const isVM = user?.role === "Vendor Manager";

  const [impactBrief, setImpactBrief] = useState(null);
  const [impactScorecard, setImpactScorecard] = useState(null);
  const [impactPostData, setImpactPostData] = useState(null);
  const [impactReport, setImpactReport] = useState(null);

  const load = async () => {
    try {
      // Try to get existing report
      const { data: existing } = await supabase.from("event_intelligence_reports").select("*").eq("project_id", event.id).maybeSingle();
      if (existing) {
        setReport(existing);
        setForm(f => ({ ...f, ...existing }));
      } else {
        // Create new one
        const { data: created } = await supabase.from("event_intelligence_reports").insert({ project_id: event.id, status: "draft" }).select().single();
        setReport(created || { id: null, project_id: event.id, status: "draft" });
      }
      // Load impact data in parallel
      const [{ data: ib }, { data: isc }, { data: ipd }, { data: ir }] = await Promise.all([
        supabase.from("event_impact_briefs").select("*").eq("project_id", event.id).maybeSingle(),
        supabase.from("event_scorecards").select("*").eq("project_id", event.id).maybeSingle(),
        supabase.from("event_post_data").select("*").eq("project_id", event.id).maybeSingle(),
        supabase.from("event_impact_reports").select("*").eq("project_id", event.id).maybeSingle(),
      ]);
      setImpactBrief(ib || null);
      setImpactScorecard(isc || null);
      setImpactPostData(ipd || null);
      setImpactReport(ir || null);
    } catch(e) {
      console.error("Report load:", e);
      setReport({ id: null, project_id: event.id, status: "draft" });
    }
  };

  useEffect(() => { load(); }, [event.id]);

  const saveSection = async (section) => {
    if (!report) return;
    setSaving(true);
    const updates = { updated_at: new Date().toISOString() };

    if (section === "operational") {
      Object.assign(updates, {
        run_of_show_adherence: form.run_of_show_adherence,
        high_impact_moments: form.high_impact_moments,
        low_impact_moments: form.low_impact_moments,
        logistics_notes: form.logistics_notes,
        operational_submitted_by: user.id,
        operational_submitted_at: new Date().toISOString(),
      });
    } else if (section === "audience") {
      Object.assign(updates, {
        estimated_attendance: parseInt(form.estimated_attendance) || null,
        expected_attendance: parseInt(form.expected_attendance) || null,
        audience_energy_arrival: form.audience_energy_arrival,
        audience_energy_mid: form.audience_energy_mid,
        audience_energy_peak: form.audience_energy_peak,
        audience_energy_close: form.audience_energy_close,
        key_engagement_moments: form.key_engagement_moments,
        audience_feedback_observations: form.audience_feedback_observations,
        audience_submitted_by: user.id,
        audience_submitted_at: new Date().toISOString(),
      });
    } else if (section === "vendor") {
      Object.assign(updates, {
        vendor_performance_summary: form.vendor_performance_summary,
        vendors_recommended: form.vendors_recommended,
        vendors_not_recommended: form.vendors_not_recommended,
        technical_delivery_quality: form.technical_delivery_quality,
        vendor_submitted_by: user.id,
        vendor_submitted_at: new Date().toISOString(),
      });
    } else if (section === "strategic") {
      Object.assign(updates, {
        strategic_intent_achieved: form.strategic_intent_achieved,
        client_satisfaction: form.client_satisfaction,
        business_development_signals: form.business_development_signals,
        next_edition_recommendations: form.next_edition_recommendations,
        ceo_submitted_by: user.id,
        ceo_submitted_at: new Date().toISOString(),
        status: "ceo_complete",
      });
    }

    await supabase.from("event_intelligence_reports").update(updates).eq("id", report.id);
    // Notify CEO when sections submitted
    if (section !== "strategic") {
      const { data: ceos } = await supabase.from("profiles").select("id").eq("role", "CEO");
      for (const c of ceos || []) {
        await supabase.from("notifications").insert({ user_id: c.id, title: "Report Section Submitted — " + event.name, message: user.name + " submitted the " + section + " section of the Event Intelligence Report.", type: "task" });
      const { data: ceoProfile } = await supabase.from("profiles").select("email,name").eq("id", c.id).single();
      if (ceoProfile?.email) await sendEmail(ceoProfile.email, "Intelligence Report Update — " + event.name, intelligenceReportEmailHtml({ ceoName: ceoProfile.name, eventName: event.name, clientName: event.client || "", submittedBy: user.name, section: section.charAt(0).toUpperCase() + section.slice(1) + " Intelligence" }));
      }
    }
    setSaving(false);
    load();
  };

  const generateAISummary = async () => {
    if (!report) return;
    setGenerating(true);
    try {
      const prompt = `You are Stretchfield's Event Intelligence Analyst. Generate a professional Event Intelligence Report Summary for the following event:

EVENT: ${event.name}
CLIENT: ${event.client || "N/A"}
DATE: ${event.event_date ? new Date(event.event_date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : "N/A"}
CATEGORY: ${event.event_category || "N/A"}

OPERATIONAL INTELLIGENCE:
- Run of Show Adherence: ${form.run_of_show_adherence || "Not provided"}
- High Impact Moments: ${form.high_impact_moments || "Not provided"}
- Low Impact Moments: ${form.low_impact_moments || "Not provided"}
- Logistics Notes: ${form.logistics_notes || "Not provided"}

AUDIENCE & ENGAGEMENT INTELLIGENCE:
- Expected Attendance: ${form.expected_attendance || "N/A"}
- Actual Attendance: ${form.estimated_attendance || "N/A"}
- Arrival Energy: ${form.audience_energy_arrival || "Not provided"}
- Mid-Event Energy: ${form.audience_energy_mid || "Not provided"}
- Peak Moment: ${form.audience_energy_peak || "Not provided"}
- Closing Energy: ${form.audience_energy_close || "Not provided"}
- Key Engagement Moments: ${form.key_engagement_moments || "Not provided"}
- Audience Feedback: ${form.audience_feedback_observations || "Not provided"}

VENDOR & PROCUREMENT REVIEW:
- Performance Summary: ${form.vendor_performance_summary || "Not provided"}
- Recommended Vendors: ${form.vendors_recommended || "Not provided"}
- Not Recommended: ${form.vendors_not_recommended || "Not provided"}
- Technical Delivery: ${form.technical_delivery_quality || "Not provided"}

STRATEGIC OUTCOMES (CEO):
- Strategic Intent Achieved: ${form.strategic_intent_achieved || "Not provided"}
- Client Satisfaction: ${form.client_satisfaction || "Not provided"}
- Business Development Signals: ${form.business_development_signals || "Not provided"}
- Next Edition Recommendations: ${form.next_edition_recommendations || "Not provided"}

Generate a 400-500 word professional Event Intelligence Summary in Stretchfield's voice. Structure it as:
1. Executive Intelligence Summary (2-3 sentences)
2. Audience & Engagement Intelligence (key findings)
3. Operational Performance (what worked, what didn't)
4. Vendor Intelligence (performance insights)
5. Strategic Outcomes & Forward Intelligence (recommendations)

Use professional, consultative language that positions Stretchfield as a strategic partner, not just an event company. Frame challenges as "optimisation opportunities."`;

      // Add impact data to the prompt if available
      const impactSection = impactBrief || impactScorecard ? `

IMPACT INTELLIGENCE DATA:
${impactBrief ? `Impact Objective: ${impactBrief.impact_objective||"—"}
Target Audience: ${impactBrief.target_audience||"—"}
KPI 1: ${impactBrief.kpi1_name||"—"} — Target: ${impactBrief.kpi1_target||"—"}
KPI 2: ${impactBrief.kpi2_name||"—"} — Target: ${impactBrief.kpi2_target||"—"}
KPI 3: ${impactBrief.kpi3_name||"—"} — Target: ${impactBrief.kpi3_target||"—"}` : ""}
${impactScorecard ? `Impact Scorecard Overall: ${STRETCHFIELD_DIMENSIONS.reduce((s,d)=>s+(parseFloat(impactScorecard[d.key+"_score"]||0)*d.weight),0).toFixed(1)}/10
Revenue & Sales: ${impactScorecard.revenue_sales_score||0}/10 — ${impactScorecard.revenue_sales_actual||"—"}
Market Share: ${impactScorecard.market_share_score||0}/10 — ${impactScorecard.market_share_actual||"—"}
Brand Awareness: ${impactScorecard.brand_awareness_score||0}/10 — ${impactScorecard.brand_awareness_actual||"—"}
Org Performance: ${impactScorecard.org_performance_score||0}/10 — ${impactScorecard.org_performance_actual||"—"}
${impactScorecard.event_cost && impactScorecard.revenue_impact ? `ROI: ${(((impactScorecard.revenue_impact-impactScorecard.event_cost)/impactScorecard.event_cost)*100).toFixed(1)}%` : ""}` : ""}
${impactPostData ? `Post-Event: ${impactPostData.total_attendees||"—"} attendees, ${impactPostData.satisfaction_score||"—"}/10 satisfaction, NPS: ${impactPostData.nps_score||"—"}, ${impactPostData.opportunities_generated||"—"} leads generated` : ""}
${impactReport?.one_line_story ? `Impact Report Narrative: ${impactReport.one_line_story.slice(0,300)}...` : ""}` : "";

      const fullPrompt = prompt + impactSection + `

If Impact Intelligence data is provided above, incorporate it into the Strategic Outcomes section with specific metrics and ROI figures.`;

      const response = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ model: "claude-sonnet-4-6", max_tokens: 1000, messages: [{ role: "user", content: fullPrompt }] })
      });
      const data = await response.json();
      const summary = data.content?.[0]?.text || "Unable to generate summary.";
      await supabase.from("event_intelligence_reports").update({ ai_summary: summary, ai_generated_at: new Date().toISOString(), status: "complete" }).eq("id", report.id);
      setGenerating(false);
      load();
    } catch (err) {
      console.error(err);
      setGenerating(false);
    }
  };

  const inputStyle = { width: "100%", padding: "10px 12px", background: T.bg, border: "1px solid " + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };
  const textareaStyle = { ...inputStyle, resize: "vertical", minHeight: 80 };
  const labelStyle = { color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 5 };

  const SectionStatus = ({ submittedAt, submittedBy }) => submittedAt ? (
    <span style={{ color: T.teal, fontSize: 10, fontWeight: 700, background: T.teal+"15", padding: "2px 8px", borderRadius: 20 }}> Submitted</span>
  ) : (
    <span style={{ color: T.amber, fontSize: 10, fontWeight: 700, background: T.amber+"15", padding: "2px 8px", borderRadius: 20 }}>Pending</span>
  );

  const sections = [
    { id: "overview", label: "Overview" },
    { id: "operational", label: "Operational" + (report?.operational_submitted_at ? " " : "") },
    { id: "audience", label: "Audience" + (report?.audience_submitted_at ? " " : "") },
    { id: "vendor", label: "Vendor" + (report?.vendor_submitted_at ? " " : "") },
    { id: "strategic", label: "Strategic" + (report?.ceo_submitted_at ? " " : "") },
    { id: "intelligence", label: "Intelligence Summary" },
  ];

  return (
    <div style={{ animation: "fadeUp 0.3s ease" }}>
      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.14em", marginBottom: 4 }}>Event Intelligence Report</div>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 20 }}>{event.name}</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{event.client} · {event.event_date ? new Date(event.event_date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : "Date TBC"}</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "1px solid " + T.border, color: T.textMuted, width: 32, height: 32, borderRadius: 8, cursor: "pointer", fontSize: 18 }}>×</button>
        </div>
        {/* Progress indicators */}
        <div style={{ display: "flex", gap: 8, marginTop: 14, flexWrap: "wrap" }}>
          {[
            { label: "Operational", done: !!report?.operational_submitted_at },
            { label: "Audience", done: !!report?.audience_submitted_at },
            { label: "Vendor", done: !!report?.vendor_submitted_at },
            { label: "Strategic", done: !!report?.ceo_submitted_at },
            { label: "AI Summary", done: !!report?.ai_summary },
          ].map(s => (
            <div key={s.label} style={{ display: "flex", alignItems: "center", gap: 4, padding: "3px 10px", borderRadius: 20, background: s.done ? T.teal+"15" : T.surface, border: "1px solid " + (s.done ? T.teal+"40" : T.border) }}>
              <div style={{ width: 6, height: 6, borderRadius: "50%", background: s.done ? T.teal : T.textMuted }} />
              <span style={{ color: s.done ? T.teal : T.textMuted, fontSize: 10, fontWeight: 700 }}>{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 2, marginBottom: 20, borderBottom: "1px solid " + T.border, overflowX: "auto" }}>
        {sections.map(tab => (
          <button key={tab.id} onClick={() => setActiveSection(tab.id)} style={{ padding: "8px 14px", border: "none", background: "none", cursor: "pointer", color: activeSection === tab.id ? T.cyan : T.textMuted, fontWeight: activeSection === tab.id ? 800 : 400, fontSize: 12, borderBottom: activeSection === tab.id ? "2px solid " + T.cyan : "2px solid transparent", marginBottom: -1, whiteSpace: "nowrap" }}>{tab.label}</button>
        ))}
      </div>

      {/* Overview */}
      {activeSection === "overview" && (
        <div>
          <div style={{ background: "linear-gradient(135deg, " + T.bgDeep + ", " + T.surface + ")", border: "1px solid " + T.border, borderRadius: 14, padding: "20px 24px", marginBottom: 16 }}>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 12 }}>Report Status</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px,1fr))", gap: 12 }}>
              {[
                { label: "Operational Section", done: !!report?.operational_submitted_at, by: "Strategy Lead" },
                { label: "Audience Section", done: !!report?.audience_submitted_at, by: "Strategy Lead" },
                { label: "Vendor Section", done: !!report?.vendor_submitted_at, by: "Vendor Manager" },
                { label: "Strategic Section", done: !!report?.ceo_submitted_at, by: "CEO" },
                { label: "AI Summary", done: !!report?.ai_summary, by: "Auto-generated" },
              ].map(s => (
                <div key={s.label} style={{ background: T.bg, border: "1px solid " + (s.done ? T.teal+"40" : T.border), borderRadius: 10, padding: "12px 14px" }}>
                  <div style={{ color: s.done ? T.teal : T.amber, fontWeight: 800, fontSize: 12, marginBottom: 3 }}>{s.done ? " Complete" : "Pending"}</div>
                  <div style={{ color: T.textPrimary, fontSize: 12, fontWeight: 600 }}>{s.label}</div>
                  <div style={{ color: T.textMuted, fontSize: 10, marginTop: 2 }}>{s.by}</div>
                </div>
              ))}
            </div>
          </div>
          <div style={{ background: T.surface, border: "1px solid " + T.border, borderRadius: 12, padding: "16px 20px" }}>
            <div style={{ color: T.textMuted, fontSize: 11 }}>
              This Event Intelligence Report captures operational, audience, vendor and strategic insights from <strong style={{ color: T.textPrimary }}>{event.name}</strong>. Each team member contributes their section. The CEO reviews all sections and triggers the AI-powered Intelligence Summary — a branded, client-ready document in Stretchfield's voice.
            </div>
          </div>
        </div>
      )}

      {/* Operational Section - Strategy Lead */}
      {activeSection === "operational" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Operational Intelligence</div>
              <div style={{ color: T.textMuted, fontSize: 12 }}>Completed by Strategy & Events Lead</div>
            </div>
            <SectionStatus submittedAt={report?.operational_submitted_at} />
          </div>
          {(isStrategy || isCEO) ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div>
                <label style={labelStyle}>Run of Show Adherence</label>
                <select value={form.run_of_show_adherence} onChange={e => setForm(f => ({...f, run_of_show_adherence: e.target.value}))} style={{ ...inputStyle, appearance: "none" }}>
                  <option value="">Select...</option>
                  {["Fully on schedule", "Minor delays (under 15 mins)", "Moderate delays (15-30 mins)", "Significant delays (over 30 mins)", "Major programme changes"].map(o => <option key={o}>{o}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>High Impact Moments</label>
                <textarea value={form.high_impact_moments} onChange={e => setForm(f => ({...f, high_impact_moments: e.target.value}))} placeholder="Describe the moments that generated the strongest audience response, energy or engagement..." style={textareaStyle} />
              </div>
              <div>
                <label style={labelStyle}>Low Impact Moments / Challenges</label>
                <textarea value={form.low_impact_moments} onChange={e => setForm(f => ({...f, low_impact_moments: e.target.value}))} placeholder="Describe moments where energy dropped, technical issues occurred, or programme flow was disrupted..." style={textareaStyle} />
              </div>
              <div>
                <label style={labelStyle}>Logistics & Coordination Notes</label>
                <textarea value={form.logistics_notes} onChange={e => setForm(f => ({...f, logistics_notes: e.target.value}))} placeholder="Registration, venue setup, ushering, catering, AV, transport, venue management..." style={textareaStyle} />
              </div>
              <button onClick={() => saveSection("operational")} disabled={saving} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13, alignSelf: "flex-start" }}>{saving ? "Saving..." : "Save & Submit Section"}</button>
            </div>
          ) : (
            <div style={{ background: T.surface, border: "1px solid " + T.border, borderRadius: 12, padding: "20px" }}>
              {report?.run_of_show_adherence ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  {[["Run of Show", report.run_of_show_adherence], ["High Impact Moments", report.high_impact_moments], ["Low Impact Moments", report.low_impact_moments], ["Logistics Notes", report.logistics_notes]].map(([label, val]) => val ? (
                    <div key={label}><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>{label}</div><div style={{ color: T.textPrimary, fontSize: 13, lineHeight: 1.6 }}>{val}</div></div>
                  ) : null)}
                </div>
              ) : <div style={{ color: T.textMuted, fontSize: 13 }}>Awaiting Strategy Lead submission.</div>}
            </div>
          )}
        </div>
      )}

      {/* Audience Section - Strategy Lead */}
      {activeSection === "audience" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Audience & Engagement Intelligence</div>
              <div style={{ color: T.textMuted, fontSize: 12 }}>Completed by Strategy & Events Lead</div>
            </div>
            <SectionStatus submittedAt={report?.audience_submitted_at} />
          </div>
          {(isStrategy || isCEO) ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div>
                  <label style={labelStyle}>Expected Attendance</label>
                  <input type="number" value={form.expected_attendance} onChange={e => setForm(f => ({...f, expected_attendance: e.target.value}))} placeholder="0" style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Actual Attendance</label>
                  <input type="number" value={form.estimated_attendance} onChange={e => setForm(f => ({...f, estimated_attendance: e.target.value}))} placeholder="0" style={inputStyle} />
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                {[
                  ["audience_energy_arrival", "Arrival Energy"],
                  ["audience_energy_mid", "Mid-Event Energy"],
                  ["audience_energy_peak", "Peak Moment"],
                  ["audience_energy_close", "Closing Energy"],
                ].map(([key, label]) => (
                  <div key={key}>
                    <label style={labelStyle}>{label}</label>
                    <select value={form[key]} onChange={e => setForm(f => ({...f, [key]: e.target.value}))} style={{ ...inputStyle, appearance: "none" }}>
                      <option value="">Select...</option>
                      {["Very High — electric, buzzing", "High — engaged and attentive", "Moderate — steady interest", "Low — distracted or disengaged", "Mixed — varied across audience"].map(o => <option key={o}>{o}</option>)}
                    </select>
                  </div>
                ))}
              </div>
              <div>
                <label style={labelStyle}>Key Engagement Moments</label>
                <textarea value={form.key_engagement_moments} onChange={e => setForm(f => ({...f, key_engagement_moments: e.target.value}))} placeholder="What moments drove the strongest audience participation, response or emotional connection?" style={textareaStyle} />
              </div>
              <div>
                <label style={labelStyle}>Audience Feedback Observations</label>
                <textarea value={form.audience_feedback_observations} onChange={e => setForm(f => ({...f, audience_feedback_observations: e.target.value}))} placeholder="What did guests say? What were the recurring themes in informal feedback?" style={textareaStyle} />
              </div>
              <button onClick={() => saveSection("audience")} disabled={saving} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13, alignSelf: "flex-start" }}>{saving ? "Saving..." : "Save & Submit Section"}</button>
            </div>
          ) : (
            <div style={{ background: T.surface, border: "1px solid " + T.border, borderRadius: 12, padding: "20px" }}>
              {report?.audience_submitted_at ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  {report.estimated_attendance && report.expected_attendance && (
                    <div style={{ display: "flex", gap: 16, marginBottom: 8 }}>
                      <div style={{ background: T.bg, borderRadius: 8, padding: "10px 16px" }}><div style={{ color: T.cyan, fontWeight: 800, fontSize: 18 }}>{report.expected_attendance}</div><div style={{ color: T.textMuted, fontSize: 10, textTransform: "uppercase" }}>Expected</div></div>
                      <div style={{ background: T.bg, borderRadius: 8, padding: "10px 16px" }}><div style={{ color: T.teal, fontWeight: 800, fontSize: 18 }}>{report.estimated_attendance}</div><div style={{ color: T.textMuted, fontSize: 10, textTransform: "uppercase" }}>Attended</div></div>
                      <div style={{ background: T.bg, borderRadius: 8, padding: "10px 16px" }}><div style={{ color: T.amber, fontWeight: 800, fontSize: 18 }}>{Math.round((report.estimated_attendance/report.expected_attendance)*100)}%</div><div style={{ color: T.textMuted, fontSize: 10, textTransform: "uppercase" }}>Conversion</div></div>
                    </div>
                  )}
                  {[["Audience Energy", [["Arrival", report.audience_energy_arrival], ["Mid-Event", report.audience_energy_mid], ["Peak", report.audience_energy_peak], ["Closing", report.audience_energy_close]]], ["Key Engagement Moments", report.key_engagement_moments], ["Audience Feedback", report.audience_feedback_observations]].map(([label, val]) => val ? (
                    <div key={label}><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>{label}</div>
                    {Array.isArray(val) ? (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>{val.map(([k,v]) => v ? <div key={k} style={{ background: T.bg, borderRadius: 6, padding: "4px 10px" }}><span style={{ color: T.textMuted, fontSize: 10 }}>{k}: </span><span style={{ color: T.textPrimary, fontSize: 11, fontWeight: 600 }}>{v.split("—")[0]}</span></div> : null)}</div>
                    ) : <div style={{ color: T.textPrimary, fontSize: 13, lineHeight: 1.6 }}>{val}</div>}
                    </div>
                  ) : null)}
                </div>
              ) : <div style={{ color: T.textMuted, fontSize: 13 }}>Awaiting Strategy Lead submission.</div>}
            </div>
          )}
        </div>
      )}

      {/* Vendor Section - VM */}
      {activeSection === "vendor" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Vendor & Procurement Review</div>
              <div style={{ color: T.textMuted, fontSize: 12 }}>Completed by Vendor Manager</div>
            </div>
            <SectionStatus submittedAt={report?.vendor_submitted_at} />
          </div>
          {(isVM || isCEO) ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div>
                <label style={labelStyle}>Overall Vendor Performance Summary</label>
                <textarea value={form.vendor_performance_summary} onChange={e => setForm(f => ({...f, vendor_performance_summary: e.target.value}))} placeholder="How did vendors perform overall? Were deliverables met on time and to standard?" style={textareaStyle} />
              </div>
              <div>
                <label style={labelStyle}>Technical Delivery Quality</label>
                <select value={form.technical_delivery_quality} onChange={e => setForm(f => ({...f, technical_delivery_quality: e.target.value}))} style={{ ...inputStyle, appearance: "none" }}>
                  <option value="">Select...</option>
                  {["Excellent — seamless throughout", "Good — minor issues resolved quickly", "Satisfactory — some disruptions", "Below standard — significant issues", "Poor — major failures"].map(o => <option key={o}>{o}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Vendors Recommended for Future Events</label>
                <textarea value={form.vendors_recommended} onChange={e => setForm(f => ({...f, vendors_recommended: e.target.value}))} placeholder="List vendors who exceeded expectations and should be prioritised for future engagements..." style={textareaStyle} />
              </div>
              <div>
                <label style={labelStyle}>Vendors Not Recommended / Areas for Improvement</label>
                <textarea value={form.vendors_not_recommended} onChange={e => setForm(f => ({...f, vendors_not_recommended: e.target.value}))} placeholder="List vendors who underperformed and the specific issues observed..." style={textareaStyle} />
              </div>
              <button onClick={() => saveSection("vendor")} disabled={saving} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13, alignSelf: "flex-start" }}>{saving ? "Saving..." : "Save & Submit Section"}</button>
            </div>
          ) : (
            <div style={{ background: T.surface, border: "1px solid " + T.border, borderRadius: 12, padding: "20px" }}>
              {report?.vendor_submitted_at ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  {[["Performance Summary", report.vendor_performance_summary], ["Technical Delivery", report.technical_delivery_quality], ["Recommended Vendors", report.vendors_recommended], ["Not Recommended", report.vendors_not_recommended]].map(([label, val]) => val ? (
                    <div key={label}><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>{label}</div><div style={{ color: T.textPrimary, fontSize: 13, lineHeight: 1.6 }}>{val}</div></div>
                  ) : null)}
                </div>
              ) : <div style={{ color: T.textMuted, fontSize: 13 }}>Awaiting Vendor Manager submission.</div>}
            </div>
          )}
        </div>
      )}

      {/* Strategic Section - CEO */}
      {activeSection === "strategic" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Strategic Outcomes & Intelligence</div>
              <div style={{ color: T.textMuted, fontSize: 12 }}>Completed by CEO</div>
            </div>
            <SectionStatus submittedAt={report?.ceo_submitted_at} />
          </div>
          {isCEO ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div>
                <label style={labelStyle}>Was the Strategic Intent Achieved?</label>
                <textarea value={form.strategic_intent_achieved} onChange={e => setForm(f => ({...f, strategic_intent_achieved: e.target.value}))} placeholder="Did the event achieve its core strategic objectives for the client? What was the business outcome?" style={textareaStyle} />
              </div>
              <div>
                <label style={labelStyle}>Client Satisfaction Assessment</label>
                <textarea value={form.client_satisfaction} onChange={e => setForm(f => ({...f, client_satisfaction: e.target.value}))} placeholder="How satisfied was the client? What did they highlight as strengths or concerns?" style={textareaStyle} />
              </div>
              <div>
                <label style={labelStyle}>Business Development Signals</label>
                <textarea value={form.business_development_signals} onChange={e => setForm(f => ({...f, business_development_signals: e.target.value}))} placeholder="What opportunities emerged from this event? Repeat business, referrals, new contacts, upsell opportunities..." style={textareaStyle} />
              </div>
              <div>
                <label style={labelStyle}>Recommendations for Next Edition</label>
                <textarea value={form.next_edition_recommendations} onChange={e => setForm(f => ({...f, next_edition_recommendations: e.target.value}))} placeholder="What would you do differently? What should be elevated, removed or improved?" style={textareaStyle} />
              </div>
              <button onClick={() => saveSection("strategic")} disabled={saving} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "10px 24px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13, alignSelf: "flex-start" }}>{saving ? "Saving..." : "Save & Submit Section"}</button>
            </div>
          ) : (
            <div style={{ background: T.surface, border: "1px solid " + T.border, borderRadius: 12, padding: "20px" }}>
              {report?.ceo_submitted_at ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  {[["Strategic Intent", report.strategic_intent_achieved], ["Client Satisfaction", report.client_satisfaction], ["Business Development", report.business_development_signals], ["Next Edition", report.next_edition_recommendations]].map(([label, val]) => val ? (
                    <div key={label}><div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>{label}</div><div style={{ color: T.textPrimary, fontSize: 13, lineHeight: 1.6 }}>{val}</div></div>
                  ) : null)}
                </div>
              ) : <div style={{ color: T.textMuted, fontSize: 13 }}>Awaiting CEO submission.</div>}
            </div>
          )}
        </div>
      )}

      {/* Intelligence Summary */}
      {activeSection === "intelligence" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div>
              <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Stretchfield Intelligence Summary</div>
              <div style={{ color: T.textMuted, fontSize: 12 }}>AI-generated from all submitted sections</div>
            </div>
            {isCEO && (
              <button onClick={generateAISummary} disabled={generating} style={{ background: "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "none", color: "#fff", padding: "8px 18px", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 12 }}>{generating ? "Generating..." : report?.ai_summary ? "Regenerate" : "Generate Intelligence Summary"}</button>
            )}
          </div>
          {/* Impact Intelligence Summary */}
          {(impactBrief || impactScorecard || impactPostData) && (
            <div style={{ background: T.bg, border: `1px solid ${T.cyan}30`, borderRadius: 12, padding: "16px 20px", marginBottom: 16 }}>
              <div style={{ color: T.cyan, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 12 }}>Impact Intelligence Data</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px,1fr))", gap: 8 }}>
                {impactBrief && <div style={{ background: T.surface, borderRadius: 8, padding: "10px 12px" }}>
                  <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>Objective</div>
                  <div style={{ color: T.textPrimary, fontSize: 11, fontWeight: 600, marginTop: 3 }}>{impactBrief.impact_objective?.slice(0,60)||"—"}</div>
                </div>}
                {impactPostData?.total_attendees && <div style={{ background: T.surface, borderRadius: 8, padding: "10px 12px" }}>
                  <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>Attendees</div>
                  <div style={{ color: T.cyan, fontSize: 18, fontWeight: 900 }}>{impactPostData.total_attendees}</div>
                </div>}
                {impactPostData?.satisfaction_score && <div style={{ background: T.surface, borderRadius: 8, padding: "10px 12px" }}>
                  <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>Satisfaction</div>
                  <div style={{ color: "#10B981", fontSize: 18, fontWeight: 900 }}>{impactPostData.satisfaction_score}/10</div>
                </div>}
                {impactPostData?.nps_score && <div style={{ background: T.surface, borderRadius: 8, padding: "10px 12px" }}>
                  <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>NPS</div>
                  <div style={{ color: parseFloat(impactPostData.nps_score)>=50?"#10B981":parseFloat(impactPostData.nps_score)>=0?T.amber:T.red, fontSize: 18, fontWeight: 900 }}>{impactPostData.nps_score}</div>
                </div>}
                {impactScorecard && <div style={{ background: T.surface, borderRadius: 8, padding: "10px 12px" }}>
                  <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>Impact Score</div>
                  <div style={{ color: T.cyan, fontSize: 18, fontWeight: 900 }}>{STRETCHFIELD_DIMENSIONS.reduce((s,d)=>s+(parseFloat(impactScorecard[d.key+"_score"]||0)*d.weight),0).toFixed(1)}/10</div>
                </div>}
                {impactScorecard?.event_cost && impactScorecard?.revenue_impact && <div style={{ background: T.surface, borderRadius: 8, padding: "10px 12px" }}>
                  <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>ROI</div>
                  <div style={{ color: ((impactScorecard.revenue_impact-impactScorecard.event_cost)/impactScorecard.event_cost*100)>=0?"#10B981":T.red, fontSize: 18, fontWeight: 900 }}>{(((impactScorecard.revenue_impact-impactScorecard.event_cost)/impactScorecard.event_cost)*100).toFixed(1)}%</div>
                </div>}
              </div>
            </div>
          )}

          {report?.ai_summary ? (
            <div style={{ background: "linear-gradient(135deg, " + T.bgDeep + ", " + T.surface + ")", border: "1px solid " + T.teal+"30", borderRadius: 14, padding: "28px 32px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid " + T.border }}>
                <div>
                  <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18 }}>Event Intelligence Report</div>
                  <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{event.name} · {event.client}</div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ color: T.cyan, fontWeight: 900, fontSize: 13 }}>STRETCHFIELD</div>
                  <div style={{ color: T.textMuted, fontSize: 10 }}>Generated {new Date(report.ai_generated_at).toLocaleDateString("en-GB")}</div>
                </div>
              </div>
              <div style={{ color: T.textSecondary, fontSize: 14, lineHeight: 1.8, whiteSpace: "pre-wrap" }}>{report.ai_summary}</div>
              <div style={{ marginTop: 24, paddingTop: 16, borderTop: "1px solid " + T.border, color: T.textMuted, fontSize: 11, fontStyle: "italic" }}>
                Generated by Stretchfield Intelligence Engine · Confidential & Proprietary
              </div>
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: "40px 0", background: T.surface, borderRadius: 12, border: "1px solid " + T.border }}>
              <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 15, marginBottom: 8 }}>Intelligence Summary Not Generated</div>
              <div style={{ color: T.textMuted, fontSize: 13, marginBottom: 16 }}>Complete all sections and generate the AI-powered summary to create a client-ready Event Intelligence Report.</div>
              {!isCEO && <div style={{ color: T.textMuted, fontSize: 12 }}>CEO will generate this summary after all sections are submitted.</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const PaymentAuthorisationView = ({ user, onNavigate, activeCountry = "All" }) => {
  const [auths, setAuths] = useState([]);
  const [staffRequests, setStaffRequests] = useState([]);
  const [expandedReq, setExpandedReq] = useState(null);
  const [vendors, setVendors] = useState([]);
  const [staffProfiles, setStaffProfiles] = useState([]);
  const [awards, setAwards] = useState([]);
  const [rffs, setRffs] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [vendorApps, setVendorApps] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [signModal, setSignModal] = useState(null);
  const [signature, setSignature] = useState("");
  const [signNotes, setSignNotes] = useState("");
  const [rejectModal, setRejectModal] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [pendingVouchers, setPendingVouchers] = useState([]);
  const [voucherSignModal, setVoucherSignModal] = useState(null);
  const [voucherSig, setVoucherSig] = useState("");
  const [voucherSigSaving, setVoucherSigSaving] = useState(false);
  const voucherSigRef = React.useRef(null);
  const [vIsDrawing, setVIsDrawing] = useState(false);
  const [vLastPos, setVLastPos] = useState(null);
  const [savedSig, setSavedSig] = useState(user?.saved_signature || null);
  React.useEffect(() => { supabase.from("profiles").select("saved_signature").eq("id", user.id).single().then(({ data }) => { if (data?.saved_signature) setSavedSig(data.saved_signature); }); }, [user.id]);
  const [form, setForm] = useState({
    payee_id: "", payee_type: "vendor", rff_id: "", invoice_id: "",
    agreed_amount: "", payment_method: "bank_transfer",
    bank_name: "", account_number: "", account_name: "",
    mobile_money_number: "", payment_terms: "", notes: "",
    work_confirmed: false, invoice_matches_po: false,
  });
  const canvasRef = React.useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [lastPos, setLastPos] = useState(null);

  const isFinance = user.role === "Finance Manager";
  const isCEO = user?.role === "CEO";

  const load = async () => {
    try {
      const [au, sr, pv, vp, sp, aw, rf, inv, va] = await Promise.all([
        supabase.from("payment_authorisations").select("*").order("created_at", { ascending: false }),
        (!activeCountry || activeCountry === "All")
        ? supabase.from("staff_payment_requests").select("*").eq("status","pending_ceo").order("submitted_at", { ascending: false })
        : supabase.from("staff_payment_requests").select("*").eq("country", activeCountry).eq("status","pending_ceo").order("submitted_at", { ascending: false }),
        (!activeCountry || activeCountry === "All")
        ? supabase.from("payment_vouchers").select("*").or("status.eq.pending_approval,status.eq.approved,status.eq.fm_signed").order("created_at", { ascending: false })
        : supabase.from("payment_vouchers").select("*").eq("country", activeCountry).or("status.eq.pending_approval,status.eq.approved,status.eq.fm_signed").order("created_at", { ascending: false }),
        supabase.from("profiles").select("*").eq("role", "Vendor"),
        supabase.from("profiles").select("*").in("role", ["Finance Manager","Vendor Manager","Strategy & Events Lead","CEO","Board of Directors","Sales & Marketing","Country Manager"]),
        supabase.from("rff_awards").select("*"),
        supabase.from("rffs").select("*"),
        supabase.from("vendor_invoices").select("*"),
        supabase.from("vendor_applications").select("*").eq("status","login-created"),
      ]);
      setAuths(au.data || []);
      setStaffRequests(sr.data || []);
      setPendingVouchers(pv.data || []);
      setVendors(vp.data || []);
      setStaffProfiles(sp.data || []);
      setAwards(aw.data || []);
      setRffs(rf.data || []);
      setInvoices(inv.data || []);
      setVendorApps(va || []);
    } catch(e) { console.error("PaymentAuth load error:", e); }
  };

  useEffect(() => { load(); }, [activeCountry]);

  // Get payee details based on selection
  const getPayeeDetails = (payeeId, payeeType) => {
    if (payeeType === "vendor") {
      const v = vendors.find(v => v.id === payeeId);
      const app = vendorApps.find(a => a.profile_id === payeeId || a.submitted_by === payeeId);
      return { name: v?.name || "", bank: app?.bank_name || "", account: app?.account_no || "", accountName: app?.bank_account_name || v?.name || "" };
    } else {
      const s = staffProfiles.find(s => s.id === payeeId);
      return { name: s?.name || "", bank: s?.bank_name || "", account: s?.account_number || "", accountName: s?.name || "" };
    }
  };

  // Drawing
  const getPos = (e, canvas) => {
    const r = canvas.getBoundingClientRect();
    if (e.touches) return { x: e.touches[0].clientX - r.left, y: e.touches[0].clientY - r.top };
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const startDraw = (e) => { e.preventDefault(); setIsDrawing(true); setLastPos(getPos(e, canvasRef.current)); };
  const draw = (e) => {
    if (!isDrawing || !canvasRef.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const pos = getPos(e, canvasRef.current);
    ctx.beginPath(); ctx.moveTo(lastPos.x, lastPos.y); ctx.lineTo(pos.x, pos.y);
    ctx.strokeStyle = "#00C8FF"; ctx.lineWidth = 2; ctx.lineCap = "round"; ctx.stroke();
    setLastPos(pos);
  };
  const stopDraw = () => { setIsDrawing(false); if (canvasRef.current) setSignature(canvasRef.current.toDataURL()); };
  const clearSignature = () => { if (canvasRef.current) { canvasRef.current.getContext("2d").clearRect(0,0,canvasRef.current.width,canvasRef.current.height); setSignature(""); }};

  const handleSubmit = async () => {
    if (!form.payee_id || !form.agreed_amount) { alert("Please select a payee and enter amount."); return; }
    setSaving(true);
    const payee = getPayeeDetails(form.payee_id, form.payee_type);
    const { data: auth } = await supabase.from("payment_authorisations").insert({
      vendor_id: form.payee_type === "vendor" ? form.payee_id : null,
      vendor_name: payee.name,
      payee_type: form.payee_type,
      rff_id: form.rff_id || null,
      invoice_id: form.invoice_id || null,
      agreed_amount: parseFloat(form.agreed_amount),
      payment_method: form.payment_method,
      bank_name: form.bank_name || payee.bank,
      account_number: form.account_number || payee.account,
      account_name: form.account_name || payee.accountName,
      mobile_money_number: form.mobile_money_number,
      payment_terms: form.payment_terms,
      notes: form.notes,
      work_confirmed: form.work_confirmed,
      invoice_matches_po: form.invoice_matches_po,
      status: "pending_ceo",
      ceo_only: true,
      created_by: user.id,
    }).select().single();

    // Notify CEO
    const { data: ceos } = await supabase.from("profiles").select("id,email,name").eq("role","CEO");
    for (const ceo of ceos||[]) {
      await supabase.from("notifications").insert({ user_id: ceo.id, title: "Payment Authorisation Request — " + payee.name, message: "Finance has submitted a payment request for " + payee.name + " — GHS " + parseFloat(form.agreed_amount).toLocaleString() + ". Please review and sign.", type: "finance" });
    }

    setSaving(false);
    setShowForm(false);
    setForm({ payee_id:"", payee_type:"vendor", rff_id:"", invoice_id:"", agreed_amount:"", payment_method:"bank_transfer", bank_name:"", account_number:"", account_name:"", mobile_money_number:"", payment_terms:"", notes:"", work_confirmed:false, invoice_matches_po:false });
    load();
  };

  const handleCEOSign = async () => {
    if (!signature) { alert("Please sign first."); return; }
    setSaving(true);
    await supabase.from("payment_authorisations").update({
      ceo_signature: signature,
      ceo_signed_at: new Date().toISOString(),
      status: "approved",
      ceo_notes: signNotes,
    }).eq("id", signModal.id);
    // Notify Finance
    const { data: fms } = await supabase.from("profiles").select("id").eq("role","Finance Manager");
    for (const fm of fms||[]) {
      await supabase.from("notifications").insert({ user_id: fm.id, title: "Payment Approved — " + signModal.vendor_name, message: "CEO has approved the payment of GHS " + (signModal.agreed_amount||0).toLocaleString() + " for " + signModal.vendor_name + ". You can now generate a payment voucher.", type: "finance" });
    }
    setSaving(false);
    setSignModal(null);
    setSignature("");
    setSignNotes("");
    load();
  };

  const handleReject = async () => {
    if (!rejectReason) { alert("Please provide a reason."); return; }
    await supabase.from("payment_authorisations").update({ status: "rejected", rejection_reason: rejectReason }).eq("id", rejectModal.id);
    const { data: fms } = await supabase.from("profiles").select("id").eq("role","Finance Manager");
    for (const fm of fms||[]) {
      await supabase.from("notifications").insert({ user_id: fm.id, title: "Payment Rejected — " + rejectModal.vendor_name, message: "CEO rejected the payment for " + rejectModal.vendor_name + ". Reason: " + rejectReason, type: "finance" });
    }
    setRejectModal(null);
    setRejectReason("");
    load();
  };

  const pendingCEO = auths.filter(a => a.status === "pending_ceo");
  const approved = auths.filter(a => a.status === "approved");
  const rejected = auths.filter(a => a.status === "rejected");

  const inputStyle = { width:"100%", padding:"9px 12px", background:T.bg, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" };
  const selectStyle = { ...inputStyle };

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:"1px solid "+T.border, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Finance</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Payment Authorisation</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{pendingCEO.length} awaiting CEO approval · {approved.length} approved</div>
        </div>
        {isFinance && <button onClick={() => setShowForm(!showForm)} style={{ background:"linear-gradient(135deg,"+T.cyan+","+T.teal+")", border:"none", color:"#060B14", padding:"10px 20px", borderRadius:10, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ New Payment Request</button>}
      </div>

      {/*  PAYMENT VOUCHERS AWAITING CEO SIGNATURE  */}
      {isCEO && pendingVouchers.length > 0 && (
        <div style={{ marginBottom:24 }}>
          <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16, marginBottom:12 }}>
            Payment Vouchers — CEO Signature Required
            <span style={{ color:T.amber, fontSize:13, fontWeight:700, marginLeft:8 }}>({pendingVouchers.length})</span>
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {pendingVouchers.map(v => (
              <div key={v.id} style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderLeft:`3px solid ${T.cyan}`, borderRadius:12, padding:"16px 20px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <div>
                  <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14 }}>{v.voucher_number} — {v.payee}</div>
                  <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{v.event_name||""} · {v.payment_type?.replace(/_/g," ")}</div>
                  <div style={{ color:T.textSecondary, fontSize:12, marginTop:2 }}>{v.description}</div>
                  <div style={{ display:"flex", gap:12, marginTop:6 }}>
                    {v.fm_signature && <span style={{ color:T.teal, fontSize:11, fontWeight:700 }}>FM  Signed</span>}
                    <span style={{ color:T.amber, fontSize:11, fontWeight:700 }}>Awaiting CEO Signature</span>
                  </div>
                </div>
                <div style={{ textAlign:"right", flexShrink:0, marginLeft:16 }}>
                  <div style={{ color:T.teal, fontWeight:900, fontSize:18 }}>{fmtMoney(v.amount||0, v.country||"Ghana")}</div>
                  <button onClick={e => { e.stopPropagation(); setVoucherSignModal(v); setVoucherSig(savedSig||user.saved_signature||""); }} style={{ background:`linear-gradient(135deg,${T.teal},#10B981)`, border:"none", color:"#fff", padding:"7px 16px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:800, marginTop:8 }}> Sign & Approve</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/*  STAFF PAYMENT REQUESTS AWAITING CEO  */}
      {staffRequests.length > 0 && (
        <div style={{ background:T.surface, border:`1px solid ${T.amber}30`, borderRadius:14, padding:"20px 24px", marginBottom:24 }}>
          <div style={{ color:T.amber, fontSize:11, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:16 }}>⏳ Staff Payment Requests — Awaiting CEO Approval ({staffRequests.length})</div>
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {staffRequests.map(req => (
              <div key={req.id} style={{ background:T.bg, border:`1px solid ${T.border}`, borderRadius:10, overflow:"hidden" }}>
                <div style={{ padding:"14px 16px", display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                  <div style={{ flex:1 }}>
                    <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>{req.staff_name}</div>
                    <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{req.project_name} · <span style={{ textTransform:"capitalize" }}>{req.request_type?.replace(/_/g," ")}</span></div>
                    <div style={{ color:T.textSecondary, fontSize:12, marginTop:2 }}>{req.description}</div>
                    <div style={{ display:"flex", gap:12, marginTop:6, alignItems:"center" }}>
                      <div style={{ color:T.textMuted, fontSize:11 }}>Submitted {req.submitted_at ? new Date(req.submitted_at).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : "—"}</div>
                      {req.supporting_doc_url && (
                        <a href={req.supporting_doc_url} target="_blank" rel="noreferrer" style={{ color:T.cyan, fontSize:11, fontWeight:700, textDecoration:"none" }}> View Receipt</a>
                      )}
                      <button onClick={() => setExpandedReq(expandedReq===req.id ? null : req.id)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"2px 10px", borderRadius:6, cursor:"pointer", fontSize:11 }}>{expandedReq===req.id ? "Hide Details " : "View Details "}</button>
                    </div>
                  </div>
                  <div style={{ textAlign:"right", minWidth:160 }}>
                    <div style={{ color:T.teal, fontWeight:900, fontSize:18 }}>{fmtMoney(req.amount||0, req.country||"Ghana")}</div>
                    {isCEO && (
                      <div style={{ display:"flex", gap:8, marginTop:10, justifyContent:"flex-end" }}>
                        <button onClick={async () => {
                          await supabase.from("staff_payment_requests").update({ status:"approved", ceo_approved_by:user.id, ceo_approved_at:new Date().toISOString() }).eq("id", req.id);
                          await supabase.from("notifications").insert({ user_id: req.staff_id, title:"Payment Request Approved", message:"Your payment request of GHS "+parseFloat(req.amount).toLocaleString()+" for "+req.description+" has been approved by CEO.", type:"finance" });
                          const { data: fms } = await supabase.from("profiles").select("id").eq("role","Finance Manager");
                          for (const fm of fms||[]) { await supabase.from("notifications").insert({ user_id:fm.id, title:"Staff Payment Approved — "+req.staff_name, message:"CEO approved "+req.staff_name+"'s payment of GHS "+parseFloat(req.amount).toLocaleString()+". Please process payment.", type:"finance" }); }
                          load();
                        }} style={{ background:T.teal+"20", border:`1px solid ${T.teal}40`, color:T.teal, padding:"6px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}> Approve</button>
                        <button onClick={async () => {
                          const reason = window.prompt("Reason for rejection:");
                          if (!reason) return;
                          await supabase.from("staff_payment_requests").update({ status:"rejected", notes:reason, ceo_approved_by:user.id, ceo_approved_at:new Date().toISOString() }).eq("id", req.id);
                          await supabase.from("notifications").insert({ user_id: req.staff_id, title:"Payment Request Rejected", message:"Your payment request of GHS "+parseFloat(req.amount).toLocaleString()+" was not approved. Reason: "+reason, type:"finance" });
                          load();
                        }} style={{ background:T.red+"15", border:`1px solid ${T.red}30`, color:T.red, padding:"6px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}> Reject</button>
                      </div>
                    )}
                    {isFinance && <div style={{ color:T.amber, fontSize:11, fontWeight:700, marginTop:8 }}>Awaiting CEO approval</div>}
                  </div>
                </div>
                {expandedReq===req.id && (
                  <div style={{ padding:"12px 16px", borderTop:`1px solid ${T.border}`, background:T.surface }}>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 }}>
                      {[["Staff Member",req.staff_name],["Event",req.project_name],["Payment Type",req.request_type?.replace(/_/g," ")],["Amount",getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(req.amount||0)).toLocaleString()],["Date Submitted",req.submitted_at?new Date(req.submitted_at).toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"}):"—"],["Status",req.status?.replace(/_/g," ")]].map(([label,val]) => (
                        <div key={label}>
                          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:3 }}>{label}</div>
                          <div style={{ color:T.textPrimary, fontSize:13, fontWeight:600, textTransform:"capitalize" }}>{val||"—"}</div>
                        </div>
                      ))}
                    </div>
                    {req.description && (
                      <div style={{ marginTop:12 }}>
                        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:3 }}>Description / Notes</div>
                        <div style={{ color:T.textSecondary, fontSize:13 }}>{req.description}</div>
                      </div>
                    )}
                    {req.supporting_doc_url && (
                      <div style={{ marginTop:12 }}>
                        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:6 }}>Supporting Document</div>
                        <a href={req.supporting_doc_url} target="_blank" rel="noreferrer" style={{ display:"inline-flex", alignItems:"center", gap:6, background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"6px 14px", borderRadius:8, textDecoration:"none", fontSize:12, fontWeight:700 }}> View Attached Document →</a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/*  CEO VOUCHER SIGN MODAL  */}
      {voucherSignModal && (
        <div style={{ position:"fixed", inset:0, zIndex:9999, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setVoucherSignModal(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.teal}30`, borderRadius:16, width:"100%", maxWidth:500, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Sign & Approve Voucher</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:4 }}>{voucherSignModal.voucher_number} — {voucherSignModal.payee}</div>
            <div style={{ color:T.teal, fontWeight:900, fontSize:20, marginBottom:20 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(voucherSignModal.amount||0).toLocaleString()).toLocaleString()}</div>
            <div style={{ marginBottom:16 }}>
              <SignatureInput label="CEO Authorisation Signature" canvasRef={voucherSigRef} onSignatureChange={setVoucherSig} savedSignature={savedSig||user.saved_signature} isDrawing={vIsDrawing} setIsDrawing={setVIsDrawing} lastPos={vLastPos} setLastPos={setVLastPos} />
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={async () => {
                try {
                  const sig = voucherSig || savedSig || user.saved_signature || "";
                  if (!sig) { alert("No signature found. Please upload a signature in Settings first."); return; }
                  setVoucherSigSaving(true);
                  const { error: upErr } = await supabase.from("payment_vouchers").update({ 
                    status: "approved", 
                    approved_by: user.id, 
                    approved_at: new Date().toISOString(), 
                    ceo_signature: sig, 
                    ceo_signed_at: new Date().toISOString() 
                  }).eq("id", voucherSignModal.id);
                  if (upErr) { alert("Error: " + upErr.message); setVoucherSigSaving(false); return; }
                  const { data: fms } = await supabase.from("profiles").select("id,email,name").eq("role","Finance Manager");
                  for (const fm of fms||[]) {
                    await supabase.from("notifications").insert({ user_id:fm.id, title:"Voucher CEO Approved — "+voucherSignModal.voucher_number, message:"CEO has approved and signed voucher "+voucherSignModal.voucher_number+" for GHS "+parseFloat(voucherSignModal.amount||0).toLocaleString()+" — "+voucherSignModal.payee+". Proceed with payment.", type:"finance" });
                  }
                  setVoucherSigSaving(false);
                  setVoucherSignModal(null);
                  setVoucherSig("");
                  load();
                } catch(e) { alert("Error: "+e.message); setVoucherSigSaving(false); }
              }} disabled={voucherSigSaving} style={{ flex:1, background:`linear-gradient(135deg,${T.teal},#10B981)`, border:"none", color:"#fff", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{voucherSigSaving?"Saving...":" Sign & Approve"}</button>
              <button onClick={()=>{ setVoucherSignModal(null); setVoucherSig(""); const ctx=voucherSigRef.current?.getContext("2d"); if(ctx) ctx.clearRect(0,0,440,120); }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/*  NEW PAYMENT REQUEST FORM  */}
      {showForm && isFinance && (
        <div style={{ background:T.surface, border:"1px solid "+T.cyan+"30", borderRadius:14, padding:"24px 28px", marginBottom:24 }}>
          <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16, marginBottom:16 }}>New Payment Request</div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:14 }}>
            {/* Payee Type */}
            <div>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Payee Type</label>
              <select value={form.payee_type} onChange={e => setForm(f=>({...f, payee_type:e.target.value, payee_id:"", bank_name:"", account_number:"", account_name:""}))} style={selectStyle}>
                <option value="vendor">Vendor / Supplier</option>
                <option value="staff">Staff Member</option>
              </select>
            </div>
            {/* Payee Name — categorised dropdown */}
            <div>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Payee Name</label>
              <select value={form.payee_id} onChange={e => {
                const id = e.target.value;
                const details = getPayeeDetails(id, form.payee_type);
                setForm(f=>({...f, payee_id:id, bank_name:details.bank, account_number:details.account, account_name:details.accountName}));
              }} style={selectStyle}>
                <option value="">Select {form.payee_type === "vendor" ? "Vendor" : "Staff Member"}...</option>
                {form.payee_type === "vendor" ? (
                  vendors.map(v => <option key={v.id} value={v.id}>{v.name}</option>)
                ) : (
                  staffProfiles.map(s => <option key={s.id} value={s.id}>{s.name} ({s.role})</option>)
                )}
              </select>
            </div>
            {/* Amount */}
            <div>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Amount (${getCurrency(activeCountry||user?.country||"Ghana")})</label>
              <input type="number" value={form.agreed_amount} onChange={e=>setForm(f=>({...f,agreed_amount:e.target.value}))} placeholder="0.00" style={inputStyle} />
            </div>
            {/* Payment Method */}
            <div>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Payment Method</label>
              <select value={form.payment_method} onChange={e=>setForm(f=>({...f,payment_method:e.target.value}))} style={selectStyle}>
                <option value="bank_transfer">Bank Transfer</option>
                <option value="mobile_money">Mobile Money</option>
                <option value="cheque">Cheque</option>
                <option value="cash">Cash</option>
              </select>
            </div>
            {/* Bank Name */}
            <div>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Bank Name</label>
              <input value={form.bank_name} onChange={e=>setForm(f=>({...f,bank_name:e.target.value}))} placeholder="Bank name" style={inputStyle} />
            </div>
            {/* Account Number */}
            <div>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Account Number</label>
              <input value={form.account_number} onChange={e=>setForm(f=>({...f,account_number:e.target.value}))} placeholder="Account number" style={inputStyle} />
            </div>
            {/* Account Name */}
            <div>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Account Name</label>
              <input value={form.account_name} onChange={e=>setForm(f=>({...f,account_name:e.target.value}))} placeholder="Account name" style={inputStyle} />
            </div>
            {/* Payment Terms */}
            <div>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Payment Terms</label>
              <select value={form.payment_terms} onChange={e=>setForm(f=>({...f,payment_terms:e.target.value}))} style={selectStyle}>
                <option value="">Select terms...</option>
                <option value="immediate">Immediate</option>
                <option value="net_7">Net 7 days</option>
                <option value="net_14">Net 14 days</option>
                <option value="net_30">Net 30 days</option>
                <option value="on_completion">On Completion</option>
              </select>
            </div>
          </div>
          {/* Notes */}
          <div style={{ marginBottom:14 }}>
            <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Notes / Description</label>
            <textarea value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} rows={3} placeholder="Purpose of payment, invoice references, etc." style={{ ...inputStyle, resize:"none" }} />
          </div>
          {/* Checklist */}
          <div style={{ display:"flex", gap:20, marginBottom:16 }}>
            {[["work_confirmed","Work/Service Confirmed"],["invoice_matches_po","Invoice Matches PO"]].map(([key,label]) => (
              <label key={key} style={{ display:"flex", alignItems:"center", gap:6, cursor:"pointer", color:T.textSecondary, fontSize:13 }}>
                <input type="checkbox" checked={form[key]} onChange={e=>setForm(f=>({...f,[key]:e.target.checked}))} />
                {label}
              </label>
            ))}
          </div>
          <div style={{ display:"flex", gap:10 }}>
            <button onClick={handleSubmit} disabled={saving||!form.payee_id||!form.agreed_amount} style={{ background:"linear-gradient(135deg,"+T.cyan+","+T.teal+")", border:"none", color:"#060B14", padding:"11px 28px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13, opacity:(!form.payee_id||!form.agreed_amount)?0.5:1 }}>{saving?"Submitting...":"Submit for CEO Approval"}</button>
            <button onClick={() => setShowForm(false)} style={{ background:"none", border:"1px solid "+T.border, color:T.textMuted, padding:"11px 18px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
          </div>
        </div>
      )}

      {/*  PENDING CEO APPROVAL  */}
      {pendingCEO.length > 0 && (
        <div style={{ marginBottom:24 }}>
          <div style={{ color:T.amber, fontSize:11, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:12 }}>⏳ Awaiting CEO Approval ({pendingCEO.length})</div>
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {pendingCEO.map(auth => (
              <div key={auth.id} style={{ background:T.surface, border:"1px solid "+T.amber+"30", borderLeft:"4px solid "+T.amber, borderRadius:12, padding:"16px 20px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:900, fontSize:15 }}>{auth.vendor_name}</div>
                    <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{auth.payee_type === "staff" ? "Staff Payment" : "Vendor Payment"} · {new Date(auth.created_at).toLocaleDateString("en-GB")}</div>
                    {auth.notes && <div style={{ color:T.textSecondary, fontSize:12, marginTop:4, fontStyle:"italic" }}>{auth.notes}</div>}
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ color:T.amber, fontWeight:900, fontSize:20 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(auth.agreed_amount||0).toLocaleString()).toLocaleString()}</div>
                    <span style={{ color:T.amber, fontSize:10, fontWeight:800, background:T.amber+"15", padding:"2px 8px", borderRadius:20 }}>Pending CEO</span>
                  </div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))", gap:8, marginBottom:12 }}>
                  {[["Bank",auth.bank_name],["Account",auth.account_number],["Method",auth.payment_method?.replace("_"," ")]].map(([l,v]) => (
                    <div key={l} style={{ background:T.bg, borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ color:T.textMuted, fontSize:9, fontWeight:700, textTransform:"uppercase" }}>{l}</div>
                      <div style={{ color:T.textPrimary, fontSize:12, fontWeight:600 }}>{v||"—"}</div>
                    </div>
                  ))}
                </div>
                {isCEO && (
                  <div style={{ display:"flex", gap:8 }}>
                    <button onClick={() => setSignModal(auth)} style={{ background:"linear-gradient(135deg,"+T.teal+",#10B981)", border:"none", color:"#fff", padding:"8px 18px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:12 }}> Approve & Sign</button>
                    <button onClick={() => setRejectModal(auth)} style={{ background:T.red+"15", border:"1px solid "+T.red+"30", color:T.red, padding:"8px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}> Reject</button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/*  APPROVED  */}
      {approved.length > 0 && (
        <div style={{ marginBottom:24 }}>
          <div style={{ color:T.teal, fontSize:11, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:12 }}> Approved ({approved.length})</div>
          <div style={{ background:T.surface, border:"1px solid "+T.border, borderRadius:12, overflow:"hidden" }}>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ background:T.bg, borderBottom:"1px solid "+T.border }}>
                  {["Payee","Type","Amount","Method","CEO Signed","Status"].map(h => (
                    <th key={h} style={{ padding:"10px 14px", textAlign:"left", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {approved.map((auth,i) => (
                  <tr key={auth.id} style={{ borderBottom:i<approved.length-1?"1px solid "+T.border+"44":"none" }}>
                    <td style={{ padding:"10px 14px", color:T.textPrimary, fontWeight:600, fontSize:13 }}>{auth.vendor_name}</td>
                    <td style={{ padding:"10px 14px" }}><span style={{ color:auth.payee_type==="staff"?T.teal:T.cyan, fontSize:11, fontWeight:700, background:(auth.payee_type==="staff"?T.teal:T.cyan)+"15", padding:"2px 8px", borderRadius:20 }}>{auth.payee_type==="staff"?"Staff":"Vendor"}</span></td>
                    <td style={{ padding:"10px 14px", color:T.amber, fontWeight:700, fontSize:13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(auth.agreed_amount||0).toLocaleString()).toLocaleString()}</td>
                    <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:12 }}>{auth.payment_method?.replace("_"," ")}</td>
                    <td style={{ padding:"10px 14px", color:T.teal, fontSize:12 }}>{auth.ceo_signed_at ? new Date(auth.ceo_signed_at).toLocaleDateString("en-GB") : "—"}</td>
                    <td style={{ padding:"10px 14px" }}><span style={{ color:T.teal, fontSize:10, fontWeight:800, background:T.teal+"18", padding:"2px 8px", borderRadius:20 }}>Approved</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/*  REJECTED  */}
      {rejected.length > 0 && (
        <div style={{ marginBottom:24 }}>
          <div style={{ color:T.red, fontSize:11, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:12 }}> Rejected ({rejected.length})</div>
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {rejected.map(auth => (
              <div key={auth.id} style={{ background:T.surface, border:"1px solid "+T.red+"20", borderLeft:"3px solid "+T.red, borderRadius:10, padding:"12px 16px", display:"flex", justifyContent:"space-between" }}>
                <div>
                  <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{auth.vendor_name}</div>
                  <div style={{ color:T.red, fontSize:11, marginTop:2 }}>Reason: {auth.rejection_reason}</div>
                </div>
                <div style={{ color:T.amber, fontWeight:700 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(auth.agreed_amount||0).toLocaleString()).toLocaleString()}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/*  CEO SIGN MODAL  */}
      {signModal && isCEO && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setSignModal(null)}>
          <div style={{ background:T.surface, border:"1px solid "+T.teal+"40", borderRadius:16, width:"100%", maxWidth:500, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Approve Payment</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:16 }}>{signModal.vendor_name} — GHS {parseFloat(signModal.agreed_amount||0).toLocaleString()}</div>
            <div style={{ background:T.bg, borderRadius:10, padding:"12px 14px", marginBottom:16 }}>
              {[["Payee",signModal.vendor_name],["Amount",getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(signModal.agreed_amount||0)).toLocaleString()],["Bank",signModal.bank_name||"—"],["Account",signModal.account_number||"—"],["Method",(signModal.payment_method||"").replace("_"," ")]].map(([l,v]) => (
                <div key={l} style={{ display:"flex", justifyContent:"space-between", padding:"4px 0", borderBottom:"1px solid "+T.border+"33" }}>
                  <span style={{ color:T.textMuted, fontSize:12 }}>{l}</span>
                  <span style={{ color:T.textPrimary, fontSize:12, fontWeight:600 }}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{ marginBottom:12 }}>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>CEO Notes (optional)</label>
              <textarea value={signNotes} onChange={e=>setSignNotes(e.target.value)} rows={2} placeholder="Any conditions or notes..." style={{ ...inputStyle, resize:"none" }} />
            </div>
            {/* Signature pad */}
            <div style={{ marginBottom:12 }}>
              <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>CEO Signature</label>
              {user.saved_signature && !signature && (
                <div style={{ background:T.teal+"10", border:"1px solid "+T.teal+"30", borderRadius:8, padding:"10px 14px", marginBottom:8, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <div style={{ color:T.teal, fontSize:11, fontWeight:700, marginBottom:3 }}>Saved Signature</div>
                    <img src={user.saved_signature} style={{ height:32, maxWidth:160, objectFit:"contain" }} alt="saved" />
                  </div>
                  <button onClick={() => setSignature(user.saved_signature)} style={{ background:"linear-gradient(135deg,"+T.teal+","+T.cyan+")", border:"none", color:"#fff", padding:"6px 12px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}>Use</button>
                </div>
              )}
              <div style={{ background:T.bg, border:"2px solid "+T.cyan+"40", borderRadius:10, padding:4, position:"relative" }}>
                <canvas ref={canvasRef} width={440} height={120}
                  style={{ display:"block", width:"100%", height:120, cursor:"crosshair", borderRadius:8, touchAction:"none" }}
                  onMouseDown={startDraw} onMouseMove={draw} onMouseUp={stopDraw} onMouseLeave={stopDraw}
                  onTouchStart={startDraw} onTouchMove={draw} onTouchEnd={stopDraw} />
                <div style={{ position:"absolute", bottom:8, right:10, color:T.textMuted, fontSize:10, pointerEvents:"none" }}>Sign above</div>
                <button onClick={clearSignature} style={{ position:"absolute", top:6, right:6, background:T.surface, border:"1px solid "+T.border, color:T.textMuted, padding:"2px 8px", borderRadius:5, cursor:"pointer", fontSize:10 }}>Clear</button>
              </div>
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={handleCEOSign} disabled={saving||!signature} style={{ flex:1, background:"linear-gradient(135deg,"+T.teal+",#10B981)", border:"none", color:"#fff", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13, opacity:!signature?0.5:1 }}>{saving?"Approving...":" Approve & Sign"}</button>
              <button onClick={() => { setSignModal(null); setSignature(""); }} style={{ background:"none", border:"1px solid "+T.border, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/*  REJECT MODAL  */}
      {rejectModal && isCEO && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.8)", backdropFilter:"blur(6px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setRejectModal(null)}>
          <div style={{ background:T.surface, border:"1px solid "+T.red+"40", borderRadius:14, width:"100%", maxWidth:420, padding:24 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16, marginBottom:12 }}>Reject Payment Request</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:14 }}>{rejectModal.vendor_name} — GHS {parseFloat(rejectModal.agreed_amount||0).toLocaleString()}</div>
            <textarea value={rejectReason} onChange={e=>setRejectReason(e.target.value)} rows={3} placeholder="Reason for rejection..." style={{ ...inputStyle, resize:"none", marginBottom:14 }} />
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={handleReject} disabled={!rejectReason} style={{ flex:1, background:T.red+"15", border:"1px solid "+T.red+"30", color:T.red, padding:"10px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>Reject</button>
              <button onClick={() => setRejectModal(null)} style={{ background:"none", border:"1px solid "+T.border, color:T.textMuted, padding:"10px 16px", borderRadius:8, cursor:"pointer", fontSize:13 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


const EmailTestPanel = ({ user }) => {
  const [sending, setSending] = useState({});
  const [results, setResults] = useState({});
  const [testEmail, setTestEmail] = useState(user?.email || "");

  const send = async (templateId, subject, html) => {
    if (!testEmail) { alert("Enter a test email address"); return; }
    setSending(s => ({ ...s, [templateId]: true }));
    try {
      await sendEmail(testEmail, subject, html);
      setResults(r => ({ ...r, [templateId]: "sent" }));
    } catch(e) {
      setResults(r => ({ ...r, [templateId]: "failed" }));
    }
    setSending(s => ({ ...s, [templateId]: false }));
  };

  const templates = [
    {
      id: "welcome",
      name: "Welcome / Login Details",
      description: "Sent when a new user account is created",
      subject: "Welcome to Stretchfield WorkRoom",
      html: () => welcomeEmailHtml({ name: "Kwesi Yamoah", email: testEmail, password: "Test@Stretch1Sf", role: "CEO" }),
    },
    {
      id: "notification",
      name: "General Notification",
      description: "Used for in-app notifications and alerts",
      subject: "Stretchfield — New Notification",
      html: () => notifEmailHtml({ name: "Kwesi", title: "Test Notification", message: "This is a test notification from Stretchfield WorkRoom. Your account is active and working correctly.", actionUrl: BASE_URL, actionLabel: "Open WorkRoom" }),
    },
    {
      id: "rff",
      name: "RFF — Request for Quote",
      description: "Sent to vendor when assigned to an RFF",
      subject: "Request for Quote — Event Lighting Services",
      html: () => rffEmailHtml({ vendorName: "Akwaaba Ushers", rffTitle: "Event Lighting Services", eventName: "2nd African Health Workforce Forum", deadline: new Date(Date.now() + 7*86400000).toISOString(), category: "Event Lighting", notes: "Please include breakdown of lighting rigs and setup costs." }),
    },
    {
      id: "task",
      name: "Task Assignment",
      description: "Sent when a task is assigned to a staff member",
      subject: "New Task Assigned — Stretchfield WorkRoom",
      html: () => taskEmailHtml({ staffName: "Edem Somevi", taskName: "Confirm Production Run Flow & Stakeholder Activities", eventName: "2nd African Health Workforce Forum", deadline: new Date(Date.now() + 3*86400000).toISOString(), assignedBy: "Kwesi Yamoah", notes: "Please liaise with WHO team and confirm by Friday." }),
    },
    {
      id: "payment_request",
      name: "Payment Request (Finance)",
      description: "Sent to Finance when VM submits a payment request",
      subject: "Payment Authorisation Request — Akwaaba Ushers",
      html: () => paymentRequestEmailHtml({ financeName: "Isaac Obeng", vendorName: "Akwaaba Ushers", amount: 5500, eventName: "2nd African Health Workforce Forum", paymentMethod: "bank_transfer", requestedBy: "Afua Asubonteng-Boateng", workConfirmed: true, invoiceMatchesPO: true }),
    },
    {
      id: "payment_authorised",
      name: "Payment Authorised (Vendor)",
      description: "Sent to vendor when CEO approves payment",
      subject: "Payment Authorised — GHS 5,500",
      html: () => paymentAuthorisedEmailHtml({ vendorName: "Akwaaba Ushers", amount: 5500, eventName: "2nd African Health Workforce Forum", paymentMethod: "bank_transfer", paymentTerms: "Net 7 days", bankName: "Absa Ghana", accountNumber: "1234567890", accountName: "Akwaaba Ushers Ltd" }),
    },
    {
      id: "purchase_order",
      name: "Purchase Order",
      description: "Sent to vendor when a PO is raised",
      subject: "Purchase Order — PO-2026-001",
      html: () => poEmailHtml({ vendorName: "Akwaaba Ushers", poNumber: "PO-2026-001", eventName: "2nd African Health Workforce Forum", amount: 5500, currency: activeCountry === "Nigeria" ? "NGN" : "GHS", notes: "" }),
    },
    {
      id: "intelligence_report",
      name: "Intelligence Report Update",
      description: "Sent to CEO when a report section is submitted",
      subject: "Intelligence Report Update — 2nd African Health Workforce Forum",
      html: () => intelligenceReportEmailHtml({ ceoName: "Kwesi Yamoah", eventName: "2nd African Health Workforce Forum", clientName: "WHO", submittedBy: "Edem Somevi", section: "Operational Intelligence" }),
    },
  ];

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 28, paddingBottom: 20, borderBottom: "1px solid " + T.border }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>System</div>
        <h2 style={{ margin: "0 0 6px", color: T.textPrimary, fontSize: 22, fontWeight: 800 }}>Email Templates & Testing</h2>
        <div style={{ color: T.textMuted, fontSize: 12 }}>Preview and test all Stretchfield email templates. Emails sent via Resend from info@stretchfield.com</div>
      </div>

      {/* Test email input */}
      <div style={{ background: T.surface, border: "1px solid " + T.cyan+"30", borderRadius: 12, padding: "18px 20px", marginBottom: 24, display: "flex", gap: 12, alignItems: "flex-end" }}>
        <div style={{ flex: 1 }}>
          <label style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Send Test Emails To</label>
          <input value={testEmail} onChange={e => setTestEmail(e.target.value)} placeholder="your@email.com" style={{ width: "100%", padding: "10px 14px", background: T.bg, border: "1px solid " + T.border, borderRadius: 8, color: T.textPrimary, fontSize: 14, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
        </div>
        <div style={{ color: T.textMuted, fontSize: 12, paddingBottom: 10 }}>All test emails will be sent to this address</div>
      </div>

      {/* Template list */}
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {templates.map(t => {
          const status = results[t.id];
          const isSending = sending[t.id];
          return (
            <div key={t.id} style={{ background: T.surface, border: "1px solid " + T.border, borderRadius: 12, padding: "18px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14 }}>{t.name}</div>
                  {status === "sent" && <span style={{ color: T.teal, fontSize: 10, fontWeight: 700, background: T.teal+"15", padding: "2px 8px", borderRadius: 20 }}> Sent</span>}
                  {status === "failed" && <span style={{ color: T.red, fontSize: 10, fontWeight: 700, background: T.red+"15", padding: "2px 8px", borderRadius: 20 }}> Failed</span>}
                </div>
                <div style={{ color: T.textMuted, fontSize: 12 }}>{t.description}</div>
                <div style={{ color: T.textMuted, fontSize: 11, marginTop: 3, fontStyle: "italic" }}>Subject: {t.subject}</div>
              </div>
              <button onClick={() => send(t.id, t.subject, t.html())} disabled={isSending || !testEmail} style={{ background: isSending ? T.surface : "linear-gradient(135deg, " + T.cyan + ", " + T.teal + ")", border: "1px solid " + (isSending ? T.border : "transparent"), color: isSending ? T.textMuted : "#fff", padding: "9px 20px", borderRadius: 8, cursor: isSending ? "not-allowed" : "pointer", fontWeight: 700, fontSize: 12, whiteSpace: "nowrap", minWidth: 100 }}>
                {isSending ? "Sending..." : "Send Test"}
              </button>
            </div>
          );
        })}
      </div>

      <div style={{ marginTop: 24, background: T.surface, border: "1px solid " + T.border, borderRadius: 10, padding: "14px 18px" }}>
        <div style={{ color: T.textMuted, fontSize: 11, lineHeight: 1.6 }}>
          <strong style={{ color: T.textPrimary }}>Email Infrastructure:</strong> All emails are sent via Resend using the verified domain <strong style={{ color: T.cyan }}>stretchfield.com</strong>. Sender address is <strong style={{ color: T.cyan }}>info@stretchfield.com</strong>. Check your spam folder if emails don't arrive within 2 minutes.
        </div>
      </div>
    </div>
  );
};


const SalesDashboardView = ({ user, activeCountry = "All" }) => {
  const [payments, setPayments] = useState([]);
  const [targets, setTargets] = useState([]);
  const [reps, setReps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState("all");
  const [editTarget, setEditTarget] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const [{ data: p }, { data: t }, { data: r }] = await Promise.all([
      (!activeCountry || activeCountry === "All") ? supabase.from("client_payments").select("*").order("payment_date", { ascending: false }) : supabase.from("client_payments").select("*").eq("country", activeCountry).order("payment_date", { ascending: false }),
      supabase.from("sales_targets").select("*"),
      supabase.from("profiles").select("id,name,role,has_sm_access,country").or('role.in.("CEO","Sales & Marketing"),has_sm_access.eq.true'),
    ]);
    setPayments(p||[]); setTargets(t||[]); 
    const countryReps = (r||[]).filter(rep => !activeCountry || activeCountry === "All" || (rep.country||"Ghana") === activeCountry);
    setReps(countryReps.filter((m,i,s)=>s.findIndex(x=>x.id===m.id)===i));
    setLoading(false);
  };
  useEffect(() => { load(); }, [activeCountry]);

  const now = new Date();
  const filterByPeriod = (items, dateField) => {
    if (period === "all") return items;
    const d = new Date(now);
    if (period === "this_month") { d.setDate(1); d.setHours(0,0,0,0); }
    if (period === "last_month") { d.setMonth(d.getMonth()-1); d.setDate(1); d.setHours(0,0,0,0); }
    if (period === "this_year") { d.setMonth(0); d.setDate(1); d.setHours(0,0,0,0); }
    return items.filter(i => i[dateField] && new Date(i[dateField]) >= d);
  };

  const filteredPayments = filterByPeriod(payments, "payment_date");
  const totalRevenue = filteredPayments.reduce((s,p) => s+parseFloat(p.amount||0), 0);
  const totalCommission = filteredPayments.reduce((s,p) => s+parseFloat(p.commission_amount||0), 0);

  const repStats = reps.map(rep => {
    const repPayments = filteredPayments.filter(p => p.sales_rep_id === rep.id);
    const repRevenue = repPayments.reduce((s,p) => s+parseFloat(p.amount||0), 0);
    const repCommission = repPayments.reduce((s,p) => s+parseFloat(p.commission_amount||0), 0);
    const target = targets.find(t => t.rep_id === rep.id);
    const targetAmt = parseFloat(target?.target_amount||0);
    const pct = targetAmt > 0 ? Math.min(100, Math.round((repRevenue/targetAmt)*100)) : 0;
    return { ...rep, repPayments, repRevenue, repCommission, target, targetAmt, pct };
  }).filter(r => r.target || r.repPayments.length > 0);

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Finance & Sales</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Sales Dashboard</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Revenue, commissions and rep performance</div>
        </div>
        <select value={period} onChange={e=>setPeriod(e.target.value)} style={{ padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
          <option value="all">All Time</option>
          <option value="this_month">This Month</option>
          <option value="last_month">Last Month</option>
          <option value="this_year">This Year</option>
        </select>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:12, marginBottom:24 }}>
        {[
          { label:"Total Revenue", value:fmtMoney(totalRevenue, activeCountry), color:T.teal },
          { label:"Total Commission", value:fmtMoney(totalCommission, activeCountry), color:T.amber },
          { label:"Payments", value:filteredPayments.length, color:T.cyan },
          { label:"Active Reps", value:repStats.length, color:T.magenta },
          { label:"Unattributed", value:filteredPayments.filter(p=>!p.sales_rep_id).length, color:filteredPayments.filter(p=>!p.sales_rep_id).length>0?T.red:T.teal },
        ].map(k => (
          <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10 }}>
            <div style={{ color:k.color, fontSize:18, fontWeight:900 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))", gap:16, marginBottom:24 }}>
        {repStats.map(rep => {
          const perfColor = rep.pct >= 80 ? T.teal : rep.pct >= 50 ? T.amber : T.red;
          return (
            <div key={rep.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:14, padding:"20px 24px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
                <div>
                  <div style={{ color:T.textPrimary, fontWeight:900, fontSize:16 }}>{rep.name}</div>
                </div>
                <div style={{ textAlign:"right" }}>
                  <div style={{ color:perfColor, fontWeight:900, fontSize:24 }}>{rep.pct}%</div>
                  <div style={{ color:T.textMuted, fontSize:10, textTransform:"uppercase" }}>of target</div>
                </div>
              </div>
              {rep.target && (
                <div style={{ marginBottom:16 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
                    <div style={{ color:T.textMuted, fontSize:11 }}>Revenue vs Target</div>
                    <div style={{ color:T.textPrimary, fontSize:11, fontWeight:700 }}>GHS {rep.repRevenue.toLocaleString()} / GHS {rep.targetAmt.toLocaleString()}</div>
                  </div>
                  <div style={{ height:10, background:T.border, borderRadius:5, overflow:"hidden" }}>
                    <div style={{ height:"100%", width:rep.pct+"%", background:`linear-gradient(90deg,${perfColor},${perfColor}88)`, borderRadius:5, transition:"width 0.5s" }} />
                  </div>
                  <div style={{ display:"flex", justifyContent:"space-between", marginTop:4 }}>
                    <div style={{ color:T.textMuted, fontSize:10 }}>Period: {rep.target.period} · ends {rep.target.end_date?new Date(rep.target.end_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}):"—"}</div>
                    {user.role==="CEO" && <button onClick={()=>setEditTarget({...rep.target})} style={{ background:"none", border:"none", color:T.cyan, fontSize:10, fontWeight:700, cursor:"pointer" }}> Edit Target</button>}
                  </div>
                </div>
              )}
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:12 }}>
                {[
                  { label:"Revenue", value:fmtMoney(Math.round(rep.repRevenue/1000)+"k", activeCountry), color:T.teal },
                  { label:"Commission", value:fmtMoney(Math.round(rep.repCommission/1000)+"k", activeCountry), color:T.amber },
                  { label:"Deals", value:rep.repPayments.length, color:T.cyan },
                ].map(k => (
                  <div key={k.label} style={{ background:T.bg, borderRadius:8, padding:"10px 12px", textAlign:"center" }}>
                    <div style={{ color:k.color, fontWeight:800, fontSize:14 }}>{k.value}</div>
                    <div style={{ color:T.textMuted, fontSize:9, textTransform:"uppercase", marginTop:2 }}>{k.label}</div>
                  </div>
                ))}
              </div>
              <div style={{ background:T.amber+"10", border:`1px solid ${T.amber}30`, borderRadius:8, padding:"10px 14px", display:"flex", justifyContent:"space-between" }}>
                <span style={{ color:T.textMuted, fontSize:12 }}>Commission Rate</span>
                <span style={{ color:T.amber, fontWeight:800, fontSize:13 }}>{rep.target?.commission_rate||5}%</span>
              </div>
            </div>
          );
        })}
        {repStats.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, gridColumn:"1/-1", color:T.textMuted }}>No sales reps with targets yet</div>}
      </div>

      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
        <div style={{ padding:"14px 18px", borderBottom:`1px solid ${T.border}`, color:T.textPrimary, fontWeight:800, fontSize:14 }}>All Sales Transactions</div>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead>
            <tr style={{ background:T.bg }}>
              {["Date","Client","Event","Amount","Sales Rep","Comm. Rate","Commission Payable","Method"].map(h => (
                <th key={h} style={{ padding:"10px 14px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredPayments.map((p,i) => (
              <tr key={p.id} style={{ borderBottom:i<filteredPayments.length-1?`1px solid ${T.border}44`:"none" }}>
                <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12 }}>{p.payment_date?new Date(p.payment_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}):"—"}</td>
                <td style={{ padding:"12px 14px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{p.client_name}</td>
                <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12 }}>{p.event_name||"—"}</td>
                <td style={{ padding:"12px 14px", color:T.teal, fontWeight:800, fontSize:13 }}>{fmtMoney(p.amount||0, p.country||activeCountry)}</td>
                <td style={{ padding:"12px 14px" }}><span style={{ color:T.cyan, fontWeight:700, fontSize:12 }}>{p.sales_rep_name ? "Rep Assigned" : "—"}</span></td>
                <td style={{ padding:"12px 14px", color:T.textMuted, fontSize:12, textAlign:"center" }}>{p.commission_rate||5}%</td>
                <td style={{ padding:"12px 14px", color:T.amber, fontWeight:800, fontSize:13 }}>{fmtMoney(p.commission_amount||0, p.country||activeCountry)}</td>
                <td style={{ padding:"12px 14px" }}><span style={{ background:T.cyan+"18", color:T.cyan, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700 }}>{p.payment_method||"—"}</span></td>
              </tr>
            ))}
            {filteredPayments.length===0 && <tr><td colSpan={8} style={{ padding:"40px 0", textAlign:"center", color:T.textMuted }}>No payments recorded</td></tr>}
          </tbody>
        </table>
      </div>

      {editTarget && user.role==="CEO" && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setEditTarget(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:400, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>Edit Sales Target</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Target Amount (${getCurrency(activeCountry||user?.country||"Ghana")})</label>
              <input type="number" value={editTarget.target_amount} onChange={e=>setEditTarget(t=>({...t,target_amount:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Commission Rate (%)</label>
              <input type="number" value={editTarget.commission_rate||5} onChange={e=>setEditTarget(t=>({...t,commission_rate:parseFloat(e.target.value)||5}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Start Date</label>
                <input type="date" value={editTarget.start_date||""} onChange={e=>setEditTarget(t=>({...t,start_date:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>End Date</label>
                <input type="date" value={editTarget.end_date||""} onChange={e=>setEditTarget(t=>({...t,end_date:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              </div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={async () => { setSaving(true); await supabase.from("sales_targets").update({ target_amount:parseFloat(editTarget.target_amount), commission_rate:parseFloat(editTarget.commission_rate||5), start_date:editTarget.start_date, end_date:editTarget.end_date }).eq("id", editTarget.id); setSaving(false); setEditTarget(null); load(); }} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Save Target"}</button>
              <button onClick={()=>setEditTarget(null)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const CashFlowView = ({ user, activeCountry = "All" }) => {
  const [events, setEvents] = useState([]);
  const [clientPayments, setClientPayments] = useState([]);
  const [vendorInvoices, setVendorInvoices] = useState([]);
  const [staffPayments, setStaffPayments] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [period, setPeriod] = useState("all");
  const [selectedEvent, setSelectedEvent] = useState("all");
  const [drillDown, setDrillDown] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const [{ data: ev }, { data: cp }, { data: vi }, { data: sp }, { data: vo }] = await Promise.all([
        (!activeCountry || activeCountry === "All") ? supabase.from("projects").select("*").order("event_date",{ascending:false}) : supabase.from("projects").select("*").eq("country",activeCountry).order("event_date",{ascending:false}),
        (!activeCountry || activeCountry === "All") ? supabase.from("client_payments").select("*").order("payment_date", { ascending: false }) : supabase.from("client_payments").select("*").eq("country", activeCountry).order("payment_date", { ascending: false }),
        (!activeCountry || activeCountry === "All") ? supabase.from("vendor_invoices").select("*").eq("status","paid").order("created_at",{ascending:false}) : supabase.from("vendor_invoices").select("*").eq("status","paid").eq("country",activeCountry).order("created_at",{ascending:false}),
        (!activeCountry || activeCountry === "All") ? supabase.from("staff_payment_requests").select("*").eq("status","paid").order("submitted_at",{ascending:false}) : supabase.from("staff_payment_requests").select("*").eq("status","paid").eq("country",activeCountry).order("submitted_at",{ascending:false}),
        (!activeCountry || activeCountry === "All") ? supabase.from("payment_vouchers").select("*").in("status",["paid","approved"]).order("created_at",{ascending:false}) : supabase.from("payment_vouchers").select("*").in("status",["paid","approved"]).eq("country",activeCountry).order("created_at",{ascending:false}),
      ]);
      setEvents(ev||[]);
      setClientPayments(cp||[]);
      setVendorInvoices(vi||[]);
      setStaffPayments(sp||[]);
      setVouchers(vo||[]);
      setLoading(false);
    };
    load();
  }, []);

  const now = new Date();
  const filterByPeriod = (items, dateField) => {
    if (period === "all") return items;
    const d = new Date(now);
    if (period === "this_month") { d.setDate(1); d.setHours(0,0,0,0); }
    if (period === "last_month") { d.setMonth(d.getMonth()-1); d.setDate(1); d.setHours(0,0,0,0); }
    if (period === "this_year") { d.setMonth(0); d.setDate(1); d.setHours(0,0,0,0); }
    return items.filter(i => i[dateField] && new Date(i[dateField]) >= d);
  };

  const byEvent = (items, field) => selectedEvent === "all" ? items : items.filter(i => i[field] === selectedEvent || i.project_id === selectedEvent || i.event_id === selectedEvent);
  const filteredInflows = byEvent(filterByPeriod(clientPayments, "payment_date"), "project_id");
  const filteredVendor = byEvent(filterByPeriod(vendorInvoices, "created_at"), "event_id");
  const filteredStaff = byEvent(filterByPeriod(staffPayments, "submitted_at"), "project_id");
  const filteredVouchers = byEvent(filterByPeriod(vouchers, "created_at"), "project_id");

  const totalInflows = filteredInflows.reduce((s,p) => s+parseFloat(p.amount||0), 0);
  const totalVendorOut = filteredVendor.reduce((s,i) => s+parseFloat(i.amount||0), 0);
  const totalStaffOut = filteredStaff.reduce((s,r) => s+parseFloat(r.amount||0), 0);
  const totalVoucherOut = filteredVouchers.reduce((s,v) => s+parseFloat(v.amount||0), 0);
  const totalOutflows = totalVendorOut + totalStaffOut + totalVoucherOut;
  const netCashFlow = totalInflows - totalOutflows;

  // Per event P&L
  const eventPL = events.map(ev => {
    const revenue = clientPayments.filter(p => p.project_id === ev.id).reduce((s,p) => s+parseFloat(p.amount||0), 0);
    const vendorCost = vendorInvoices.filter(i => i.event_id === ev.id).reduce((s,i) => s+parseFloat(i.amount||0), 0);
    const staffCost = staffPayments.filter(r => r.project_id === ev.id).reduce((s,r) => s+parseFloat(r.amount||0), 0);
    const totalCost = vendorCost + staffCost;
    return { ...ev, revenue, totalCost, profit: revenue - totalCost };
  }).filter(e => e.revenue > 0 || e.totalCost > 0);

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Finance</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Cash Flow</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Money in vs money out — syncs with Zoho for full picture</div>
        </div>
        <div style={{ display:"flex", gap:10 }}>
          <select value={selectedEvent} onChange={e=>{ setSelectedEvent(e.target.value); setDrillDown(e.target.value==="all"?null:events.find(ev=>ev.id===e.target.value)||null); }} style={{ padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
            <option value="all">All Events</option>
            {events.map(ev=><option key={ev.id} value={ev.id}>{ev.name}</option>)}
          </select>
          <select value={period} onChange={e=>setPeriod(e.target.value)} style={{ padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
            <option value="all">All Time</option>
            <option value="this_month">This Month</option>
            <option value="last_month">Last Month</option>
            <option value="this_year">This Year</option>
          </select>
        </div>
      </div>

      {/* Event Drill-down */}
      {drillDown && (
        <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:12, padding:"20px 24px", marginBottom:20 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
            <div>
              <div style={{ color:T.cyan, fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:4 }}>Event Breakdown</div>
              <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18 }}>{drillDown.name}</div>
              <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{drillDown.client} · {drillDown.event_date?new Date(drillDown.event_date).toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"}):"TBC"} · {drillDown.phase}</div>
            </div>
            <button onClick={()=>{ setDrillDown(null); setSelectedEvent("all"); }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"5px 12px", borderRadius:6, cursor:"pointer", fontSize:11 }}> Clear</button>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:12, marginBottom:16 }}>
            {[
              { label:"Revenue", value:"GHS "+filteredInflows.reduce((s,p)=>s+parseFloat(p.amount||0),0).toLocaleString(), color:T.teal },
              { label:"Vendor Costs", value:"GHS "+filteredVendor.reduce((s,i)=>s+parseFloat(i.amount||0),0).toLocaleString(), color:T.red },
              { label:"Staff Costs", value:"GHS "+(filteredStaff.reduce((s,r)=>s+parseFloat(r.amount||0),0)+filteredVouchers.reduce((s,v)=>s+parseFloat(v.amount||0),0)).toLocaleString(), color:T.amber },
              { label:"Net Margin", value:(()=>{ const rev=filteredInflows.reduce((s,p)=>s+parseFloat(p.amount||0),0); const costs=filteredVendor.reduce((s,i)=>s+parseFloat(i.amount||0),0)+filteredStaff.reduce((s,r)=>s+parseFloat(r.amount||0),0)+filteredVouchers.reduce((s,v)=>s+parseFloat(v.amount||0),0); return rev>0?((rev-costs)/rev*100).toFixed(1)+"%":"—"; })(), color:T.cyan },
            ].map(k=>(
              <div key={k.label} style={{ background:T.bg, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10, padding:"14px 16px" }}>
                <div style={{ color:k.color, fontWeight:900, fontSize:18 }}>{k.value}</div>
                <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
              </div>
            ))}
          </div>
          {/* Vendor breakdown */}
          {filteredVendor.length > 0 && (
            <div style={{ marginBottom:12 }}>
              <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", marginBottom:8 }}>Vendor Payments</div>
              {filteredVendor.map(i=>(
                <div key={i.id} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:`1px solid ${T.border}22` }}>
                  <div><div style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{i.vendor_name}</div><div style={{ color:T.textMuted, fontSize:11 }}>{i.invoice_number||"Invoice"}</div></div>
                  <div style={{ color:T.red, fontWeight:700 }}>{fmtMoney(i.amount||0, activeCountry)}</div>
                </div>
              ))}
            </div>
          )}
          {/* Staff breakdown */}
          {filteredVouchers.filter(v=>v.event_name===drillDown.name).length > 0 && (
            <div>
              <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", marginBottom:8 }}>Staff Payments & Vouchers</div>
              {filteredVouchers.filter(v=>v.event_name===drillDown.name).map(v=>(
                <div key={v.id} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:`1px solid ${T.border}22` }}>
                  <div><div style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{v.payee}</div><div style={{ color:T.textMuted, fontSize:11 }}>{v.voucher_number} · {v.description?.slice(0,40)}</div></div>
                  <div style={{ color:T.amber, fontWeight:700 }}>{fmtMoney(v.amount||0, v.country||"Ghana")}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Summary KPIs */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:12, marginBottom:24 }}>
        {[
          { label:"Total Inflows", value:fmtMoney(totalInflows, activeCountry), color:T.teal, sub:"Client payments received" },
          { label:"Total Outflows", value:fmtMoney(totalOutflows, activeCountry), color:T.red, sub:"Vendors + Staff + Vouchers" },
          { label:"Net Cash Flow", value:fmtMoney(Math.abs(netCashFlow), activeCountry), color:netCashFlow>=0?T.teal:T.red, sub:netCashFlow>=0?"Surplus":"Deficit" },
          { label:"Vendor Payments", value:fmtMoney(totalVendorOut, activeCountry).toLocaleString(), color:T.amber, sub:"Paid invoices" },
          { label:"Staff Payments", value:fmtMoney((totalStaffOut+totalVoucherOut), activeCountry).toLocaleString(), color:T.cyan, sub:"Approved requests" },
        ].map(k => (
          <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10 }}>
            <div style={{ color:k.color, fontSize:18, fontWeight:900 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
            <div style={{ color:T.textMuted, fontSize:10, marginTop:2 }}>{k.sub}</div>
          </div>
        ))}
      </div>

      {/* Per Event P&L */}
      {eventPL.length > 0 && (
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden", marginBottom:24 }}>
          <div style={{ padding:"14px 18px", borderBottom:`1px solid ${T.border}`, color:T.textPrimary, fontWeight:800, fontSize:14 }}>Event P&L Summary</div>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ background:T.bg }}>
                {["Event","Revenue","Costs","Profit/Loss","Margin"].map(h => (
                  <th key={h} style={{ padding:"10px 14px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {eventPL.map((ev,i) => {
                const margin = ev.revenue > 0 ? ((ev.profit/ev.revenue)*100).toFixed(1) : 0;
                return (
                  <tr key={ev.id} style={{ borderBottom:i<eventPL.length-1?`1px solid ${T.border}44`:"none" }}>
                    <td style={{ padding:"12px 14px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{ev.name}</td>
                    <td style={{ padding:"12px 14px", color:T.teal, fontWeight:700 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(ev.revenue.toLocaleString()).toLocaleString()}</td>
                    <td style={{ padding:"12px 14px", color:T.red, fontWeight:700 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(ev.totalCost.toLocaleString()).toLocaleString()}</td>
                    <td style={{ padding:"12px 14px", color:ev.profit>=0?T.teal:T.red, fontWeight:800 }}>GHS {Math.abs(ev.profit).toLocaleString()} {ev.profit<0?"(Loss)":""}</td>
                    <td style={{ padding:"12px 14px", color:parseFloat(margin)>=0?T.teal:T.red, fontWeight:700 }}>{margin}%</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Inflows */}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
        <div style={{ background:T.surface, border:`1px solid ${T.teal}30`, borderRadius:12, overflow:"hidden" }}>
          <div style={{ padding:"12px 16px", borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between" }}>
            <div style={{ color:T.teal, fontWeight:800, fontSize:13 }}>↑ Inflows — GHS {totalInflows.toLocaleString()}</div>
          </div>
          {filteredInflows.length === 0 ? <div style={{ padding:"24px", color:T.textMuted, fontSize:13, textAlign:"center" }}>No payments recorded</div> : filteredInflows.map(p => (
            <div key={p.id} style={{ padding:"10px 16px", borderBottom:`1px solid ${T.border}22`, display:"flex", justifyContent:"space-between" }}>
              <div><div style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{p.client_name}</div><div style={{ color:T.textMuted, fontSize:11 }}>{p.event_name} · {p.payment_method}</div></div>
              <div style={{ textAlign:"right" }}><div style={{ color:T.teal, fontWeight:700 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(p.amount).toLocaleString()).toLocaleString()}</div><div style={{ color:T.textMuted, fontSize:10 }}>{new Date(p.payment_date).toLocaleDateString("en-GB")}</div></div>
            </div>
          ))}
        </div>
        <div style={{ background:T.surface, border:`1px solid ${T.red}30`, borderRadius:12, overflow:"hidden" }}>
          <div style={{ padding:"12px 16px", borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between" }}>
            <div style={{ color:T.red, fontWeight:800, fontSize:13 }}>↓ Outflows — GHS {totalOutflows.toLocaleString()}</div>
          </div>
          {[...filteredVendor.map(i=>({name:i.vendor_name,desc:i.event_name,amount:i.amount,date:i.created_at,type:"Vendor"})),...filteredStaff.map(r=>({name:r.staff_name,desc:r.description,amount:r.amount,date:r.submitted_at,type:"Staff"})),...filteredVouchers.map(v=>({name:v.payee,desc:v.description,amount:v.amount,date:v.created_at,type:"Voucher"}))].sort((a,b)=>new Date(b.date)-new Date(a.date)).map((item,i) => (
            <div key={i} style={{ padding:"10px 16px", borderBottom:`1px solid ${T.border}22`, display:"flex", justifyContent:"space-between" }}>
              <div><div style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{item.name}</div><div style={{ color:T.textMuted, fontSize:11 }}>{item.desc} · <span style={{ color:T.amber }}>{item.type}</span></div></div>
              <div style={{ textAlign:"right" }}><div style={{ color:T.red, fontWeight:700 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(item.amount||0).toLocaleString()).toLocaleString()}</div><div style={{ color:T.textMuted, fontSize:10 }}>{new Date(item.date).toLocaleDateString("en-GB")}</div></div>
            </div>
          ))}
          {filteredVendor.length===0&&filteredStaff.length===0&&filteredVouchers.length===0&&<div style={{ padding:"24px", color:T.textMuted, fontSize:13, textAlign:"center" }}>No outflows recorded</div>}
        </div>
      </div>
    </div>
  );
};

const ZohoSyncStatusView = ({ user }) => {
  const [vouchers, setVouchers] = useState([]);
  const [clientPayments, setClientPayments] = useState([]);
  const [vendorInvoices, setVendorInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const [{ data: vo }, { data: cp }, { data: vi }] = await Promise.all([
        (!activeCountry || activeCountry === "All") ? supabase.from("payment_vouchers").select("*").order("created_at",{ascending:false}) : supabase.from("payment_vouchers").select("*").eq("country",activeCountry).order("created_at",{ascending:false}),
        (!activeCountry || activeCountry === "All") ? supabase.from("client_payments").select("*").order("created_at",{ascending:false}) : supabase.from("client_payments").select("*").eq("country",activeCountry).order("created_at",{ascending:false}),
        (!activeCountry || activeCountry === "All") ? supabase.from("vendor_invoices").select("*").order("created_at",{ascending:false}) : supabase.from("vendor_invoices").select("*").eq("country",activeCountry).order("created_at",{ascending:false}),
      ]);
      setVouchers(vo||[]);
      setClientPayments(cp||[]);
      setVendorInvoices(vi||[]);
      setLoading(false);
    };
    load();
  }, []);

  const syncedVouchers = vouchers.filter(v => v.zoho_id);
  const unsyncedVouchers = vouchers.filter(v => !v.zoho_id);
  const syncedInvoices = vendorInvoices.filter(i => i.zoho_invoice_id);
  const unsyncedInvoices = vendorInvoices.filter(i => !i.zoho_invoice_id);

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Finance</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Zoho Sync Status</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Track which WorkRoom records have been pushed to Zoho Books</div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))", gap:12, marginBottom:24 }}>
        {[
          { label:"Vouchers Synced", value:syncedVouchers.length+"/"+vouchers.length, color:T.teal },
          { label:"Vouchers Pending", value:unsyncedVouchers.length, color:unsyncedVouchers.length>0?T.amber:T.teal },
          { label:"Invoices Synced", value:syncedInvoices.length+"/"+vendorInvoices.length, color:T.cyan },
          { label:"Invoices Pending", value:unsyncedInvoices.length, color:unsyncedInvoices.length>0?T.amber:T.teal },
        ].map(k => (
          <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10 }}>
            <div style={{ color:k.color, fontSize:20, fontWeight:900 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      <div style={{ background:T.surface, border:`1px solid ${T.amber}30`, borderRadius:12, padding:"16px 20px", marginBottom:20 }}>
        <div style={{ color:T.amber, fontWeight:800, fontSize:14, marginBottom:8 }}> Records Not Yet in Zoho</div>
        <div style={{ color:T.textMuted, fontSize:13 }}>The following WorkRoom records need to be manually entered or synced into Zoho Books:</div>
        {unsyncedVouchers.length > 0 && (
          <div style={{ marginTop:12 }}>
            <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", marginBottom:6 }}>Payment Vouchers ({unsyncedVouchers.length})</div>
            {unsyncedVouchers.slice(0,5).map(v => (
              <div key={v.id} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:`1px solid ${T.border}22` }}>
                <span style={{ color:T.textPrimary, fontSize:12 }}>{v.voucher_number} — {v.payee}</span>
                <span style={{ color:T.amber, fontSize:12, fontWeight:700 }}>{fmtMoney(v.amount||0, v.country||"Ghana")}</span>
              </div>
            ))}
          </div>
        )}
        {unsyncedInvoices.length > 0 && (
          <div style={{ marginTop:12 }}>
            <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", marginBottom:6 }}>Vendor Invoices ({unsyncedInvoices.length})</div>
            {unsyncedInvoices.slice(0,5).map(i => (
              <div key={i.id} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:`1px solid ${T.border}22` }}>
                <span style={{ color:T.textPrimary, fontSize:12 }}>{i.vendor_name} — {i.event_name}</span>
                <span style={{ color:T.amber, fontSize:12, fontWeight:700 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(i.amount||0).toLocaleString()).toLocaleString()}</span>
              </div>
            ))}
          </div>
        )}
        {unsyncedVouchers.length===0 && unsyncedInvoices.length===0 && (
          <div style={{ color:T.teal, fontSize:13, fontWeight:700, marginTop:8 }}> All records are in Zoho</div>
        )}
      </div>

      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"16px 20px" }}>
        <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14, marginBottom:12 }}>All Payment Vouchers</div>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead>
            <tr style={{ background:T.bg }}>
              {["Voucher #","Payee","Amount","Status","Zoho Status"].map(h => (
                <th key={h} style={{ padding:"8px 12px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {vouchers.map((v,i) => (
              <tr key={v.id} style={{ borderBottom:i<vouchers.length-1?`1px solid ${T.border}44`:"none" }}>
                <td style={{ padding:"10px 12px", color:T.cyan, fontWeight:700, fontSize:12 }}>{v.voucher_number}</td>
                <td style={{ padding:"10px 12px", color:T.textPrimary, fontSize:12 }}>{v.payee}</td>
                <td style={{ padding:"10px 12px", color:T.amber, fontWeight:700, fontSize:12 }}>{fmtMoney(v.amount||0, v.country||"Ghana")}</td>
                <td style={{ padding:"10px 12px" }}><span style={{ background:v.status==="paid"?"#10B98118":T.amber+"18", color:v.status==="paid"?"#10B981":T.amber, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700 }}>{v.status}</span></td>
                <td style={{ padding:"10px 12px" }}><span style={{ background:v.zoho_id?T.teal+"18":T.red+"18", color:v.zoho_id?T.teal:T.red, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700 }}>{v.zoho_id?" In Zoho":"Not Synced"}</span></td>
              </tr>
            ))}
            {vouchers.length===0 && <tr><td colSpan={5} style={{ padding:"30px 0", textAlign:"center", color:T.textMuted }}>No vouchers yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const AuditTrailView = ({ user, activeCountry = "All" }) => {
  const [notifications, setNotifications] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [staffRequests, setStaffRequests] = useState([]);
  const [pos, setPOs] = useState([]);
  const [clientPayments, setClientPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const load = async () => {
      const [{ data: no }, { data: vo }, { data: sr }, { data: po }, { data: cp }] = await Promise.all([
        supabase.from("notifications").select("*").order("created_at", { ascending: false }).limit(200),
        (!activeCountry || activeCountry === "All") ? supabase.from("payment_vouchers").select("*").order("created_at",{ascending:false}) : supabase.from("payment_vouchers").select("*").eq("country",activeCountry).order("created_at",{ascending:false}),
        (!activeCountry || activeCountry === "All") ? supabase.from("staff_payment_requests").select("*").order("submitted_at",{ascending:false}) : supabase.from("staff_payment_requests").select("*").eq("country",activeCountry).order("submitted_at",{ascending:false}),
        (!activeCountry || activeCountry === "All") ? supabase.from("purchase_orders").select("*").order("created_at", { ascending: false }) : supabase.from("purchase_orders").select("*").eq("country", activeCountry).order("created_at", { ascending: false }),
        (!activeCountry || activeCountry === "All") ? supabase.from("client_payments").select("*").order("created_at",{ascending:false}) : supabase.from("client_payments").select("*").eq("country",activeCountry).order("created_at",{ascending:false}),
      ]);
      setNotifications(no||[]);
      setVouchers(vo||[]);
      setStaffRequests(sr||[]);
      setPOs(po||[]);
      setClientPayments(cp||[]);
      setLoading(false);
    };
    load();
  }, []);

  // Build unified audit log
  const auditLog = [
    ...vouchers.map(v => ({ id:"v-"+v.id, type:"payment", category:"Voucher", action:"Payment Voucher "+v.voucher_number+" raised for "+v.payee, amount:v.amount, status:v.status, date:v.created_at, actor:v.raised_by })),
    ...staffRequests.map(r => ({ id:"sr-"+r.id, type:"staff", category:"Staff Payment", action:r.staff_name+" requested GHS "+parseFloat(r.amount||0).toLocaleString()+" — "+r.description, amount:r.amount, status:r.status, date:r.submitted_at, actor:r.staff_id })),
    ...pos.map(p => ({ id:"po-"+p.id, type:"procurement", category:"Purchase Order", action:"PO "+p.internal_po_number+" created for "+p.vendor_name, amount:p.amount, status:p.status, date:p.created_at, actor:null })),
    ...clientPayments.map(p => ({ id:"cp-"+p.id, type:"revenue", category:"Client Payment", action:"Payment of GHS "+parseFloat(p.amount||0).toLocaleString()+" received from "+p.client_name+" for "+p.event_name, amount:p.amount, status:"received", date:p.created_at, actor:p.recorded_by })),
  ].sort((a,b) => new Date(b.date) - new Date(a.date));

  const filtered = auditLog.filter(e => {
    if (filter !== "all" && e.type !== filter) return false;
    if (search && !e.action.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const typeColors = { payment:T.amber, staff:T.cyan, procurement:T.teal, revenue:"#10B981" };
  const typeIcons = { payment:"", staff:"", procurement:"", revenue:"" };

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Finance</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Audit Trail</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Immutable record of all financial actions — {auditLog.length} entries</div>
      </div>

      <div style={{ display:"flex", gap:12, marginBottom:20 }}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search actions..."
          style={{ flex:1, padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }} />
        <select value={filter} onChange={e=>setFilter(e.target.value)} style={{ padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
          <option value="all">All Types</option>
          <option value="payment">Vouchers</option>
          <option value="staff">Staff Payments</option>
          <option value="procurement">Purchase Orders</option>
          <option value="revenue">Client Payments</option>
        </select>
      </div>

      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
        {filtered.length === 0 ? (
          <div style={{ padding:"60px 0", textAlign:"center", color:T.textMuted }}>No entries found</div>
        ) : filtered.map((entry, i) => (
          <div key={entry.id} style={{ display:"flex", alignItems:"flex-start", gap:14, padding:"14px 18px", borderBottom:i<filtered.length-1?`1px solid ${T.border}44`:"none" }}>
            <div style={{ width:36, height:36, borderRadius:8, background:(typeColors[entry.type]||T.textMuted)+"18", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, flexShrink:0 }}>{typeIcons[entry.type]||""}</div>
            <div style={{ flex:1 }}>
              <div style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{entry.action}</div>
              <div style={{ display:"flex", gap:10, marginTop:4, alignItems:"center" }}>
                <span style={{ background:(typeColors[entry.type]||T.textMuted)+"18", color:typeColors[entry.type]||T.textMuted, padding:"1px 8px", borderRadius:20, fontSize:10, fontWeight:700 }}>{entry.category}</span>
                <span style={{ color:T.textMuted, fontSize:11 }}>{entry.date ? new Date(entry.date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"}) : "—"}</span>
                {entry.status && <span style={{ color:T.textMuted, fontSize:11, textTransform:"capitalize" }}>· {entry.status.replace(/_/g," ")}</span>}
              </div>
            </div>
            {entry.amount && <div style={{ color:T.amber, fontWeight:800, fontSize:14, flexShrink:0 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(entry.amount||0).toLocaleString()).toLocaleString()}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};




const CEOBroadcastView = ({ user }) => {
  const [broadcasts, setBroadcasts] = useState([]);
  const [staff, setStaff] = useState([]);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ title:"", message:"", audience:"all", specific_roles:[], specific_ids:[], priority:"normal" });

  const ROLES = ["Finance Manager","Vendor Manager","Strategy & Events Lead","Sales & Marketing","Country Manager"];
  const PRIORITIES = ["normal","important","urgent"];
  const priorityColors = { normal:T.cyan, important:T.amber, urgent:T.red };

  const load = async () => {
    const [{ data: b }, { data: s }] = await Promise.all([
      supabase.from("notifications").select("*").eq("type","broadcast").order("created_at", { ascending: false }).limit(50),
      supabase.from("profiles").select("id,name,role").not("role","in","(Client,Vendor,Board of Directors)").order("name"),
    ]);
    setBroadcasts(b||[]); setStaff(s||[]);
  };
  useEffect(() => { load(); }, []);

  const handleSend = async () => {
    if (!form.title || !form.message) { alert("Title and message required."); return; }
    setSaving(true);

    let targets = [];
    if (form.audience === "all") {
      targets = staff.map(s => s.id);
    } else if (form.audience === "roles") {
      targets = staff.filter(s => form.specific_roles.includes(s.role)).map(s => s.id);
    } else if (form.audience === "specific") {
      targets = form.specific_ids;
    }

    // Get email addresses for targets
    const { data: targetProfiles } = await supabase.from("profiles").select("id,name,email").in("id", targets);

    // Insert notification + send email for each target
    for (const profile of targetProfiles||[]) {
      if (profile.id !== user.id) {
        const notifTitle = (form.priority === "urgent" ? " URGENT: " : form.priority === "important" ? " " : "") + form.title;
        await supabase.from("notifications").insert({
          user_id: profile.id,
          title: notifTitle,
          message: form.message,
          type: "broadcast",
        });
        // Send email
        if (profile.email) {
          const priorityLabel = form.priority === "urgent" ? "URGENT" : form.priority === "important" ? "IMPORTANT" : "Team Update";
          const priorityColor = form.priority === "urgent" ? "#EF4444" : form.priority === "important" ? "#F59E0B" : "#00C8FF";
          const emailHtml = `<!DOCTYPE html><html><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head><body style="margin:0;padding:0;background:#F1F5F9;font-family:'DM Sans',Arial,sans-serif">
<table width="100%" cellpadding="0" cellspacing="0" style="background:#F1F5F9;padding:40px 20px">
<tr><td align="center">
<table width="600" cellpadding="0" cellspacing="0" style="background:#ffffff;border-radius:16px;overflow:hidden;box-shadow:0 4px 24px rgba(0,0,0,0.08)">
<tr><td style="background:#060B14;padding:28px 36px;text-align:left">
  <table width="100%"><tr>
    <td><img src="https://workroom.stretchfield.com/logo512.png" alt="Stretchfield" style="height:36px;vertical-align:middle;margin-right:10px"><span style="color:#00C8FF;font-size:13px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;vertical-align:middle">Stretchfield WorkRoom</span></td>
    <td align="right"><span style="background:${priorityColor};color:${form.priority==="normal"?"#060B14":"#ffffff"};padding:4px 12px;border-radius:20px;font-size:11px;font-weight:800;text-transform:uppercase">${priorityLabel}</span></td>
  </tr></table>
</td></tr>
<tr><td style="padding:36px 36px 20px">
  <p style="margin:0 0 6px;color:#94A3B8;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.1em">Message from CEO</p>
  <h1 style="margin:0 0 24px;color:#0F172A;font-size:24px;font-weight:900;line-height:1.2">${form.title}</h1>
  <div style="background:#F8FAFC;border-left:4px solid ${priorityColor};border-radius:0 8px 8px 0;padding:20px 24px;margin-bottom:24px">
    <p style="margin:0;color:#334155;font-size:15px;line-height:1.7;white-space:pre-wrap">${form.message}</p>
  </div>
  <p style="margin:0 0 4px;color:#64748B;font-size:13px">Hi ${profile.name},</p>
  <p style="margin:0;color:#64748B;font-size:13px">This is an official communication from ${user.name}, CEO of Stretchfield. Please log in to WorkRoom to respond or take any required action.</p>
</td></tr>
<tr><td style="padding:20px 36px" align="center">
  <a href="https://workroom.stretchfield.com" style="background:linear-gradient(135deg,#00C8FF,#00E5C8);color:#060B14;padding:12px 28px;border-radius:8px;text-decoration:none;font-weight:800;font-size:14px;display:inline-block">Open WorkRoom →</a>
</td></tr>
<tr><td style="background:#F8FAFC;padding:20px 36px;border-top:1px solid #E2E8F0">
  <p style="margin:0;color:#94A3B8;font-size:11px;text-align:center">© ${new Date().getFullYear()} Stretchfield. All rights reserved. · <a href="https://workroom.stretchfield.com" style="color:#00C8FF">workroom.stretchfield.com</a></p>
</td></tr>
</table>
</td></tr></table>
</body></html>`;
          await fetch("/api/send-email", {
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body: JSON.stringify({ to: profile.email, subject: (form.priority==="urgent"?" URGENT: ":form.priority==="important"?" ":"")+form.title+" — Stretchfield WorkRoom", html: emailHtml })
          });
        }
      }
    }

    setSaving(false); setModal(false);
    setForm({ title:"", message:"", audience:"all", specific_roles:[], specific_ids:[], priority:"normal" });
    load();
    alert(`Broadcast sent to ${targets.length} team member${targets.length!==1?"s":""}. Notifications and emails delivered.`);
  };

  const audienceLabel = (b) => {
    if (!b.title) return "All Staff";
    return "Team";
  };

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Communications</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>CEO Broadcast</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Send announcements directly to your team</div>
        </div>
        <button onClick={() => setModal(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}> New Broadcast</button>
      </div>

      {/* Recent broadcasts */}
      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {broadcasts.length === 0 ? (
          <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}>
            <div style={{ fontSize:40, marginBottom:12 }}></div>
            <div style={{ color:T.textPrimary, fontWeight:700, fontSize:16 }}>No broadcasts yet</div>
            <div style={{ color:T.textMuted, fontSize:13, marginTop:6 }}>Send your first broadcast to the team.</div>
          </div>
        ) : broadcasts.map((b,i) => {
          const isUrgent = b.title?.startsWith("");
          const isImportant = b.title?.startsWith("");
          const color = isUrgent ? T.red : isImportant ? T.amber : T.cyan;
          return (
            <div key={b.id} style={{ background:T.surface, border:`1px solid ${color}30`, borderLeft:`3px solid ${color}`, borderRadius:12, padding:"16px 20px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                <div style={{ flex:1 }}>
                  <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14, marginBottom:4 }}>{b.title}</div>
                  <div style={{ color:T.textSecondary, fontSize:13, lineHeight:1.6 }}>{b.message}</div>
                </div>
                <div style={{ color:T.textMuted, fontSize:11, marginLeft:16, flexShrink:0 }}>{new Date(b.created_at).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</div>
              </div>
            </div>
          );
        })}
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:520, maxHeight:"90vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>New Broadcast</div>
            <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Priority</label>
                <select value={form.priority} onChange={e=>setForm(f=>({...f,priority:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${priorityColors[form.priority]}40`, borderRadius:8, color:priorityColors[form.priority], fontSize:13, fontFamily:"inherit", outline:"none", fontWeight:700 }}>
                  {PRIORITIES.map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Audience</label>
                <select value={form.audience} onChange={e=>setForm(f=>({...f,audience:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="all">All Staff</option>
                  <option value="roles">Specific Roles</option>
                  <option value="specific">Specific People</option>
                </select></div>
              </div>

              {form.audience === "roles" && (
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:6 }}>Select Roles</label>
                <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                  {ROLES.map(r => (
                    <button key={r} onClick={() => setForm(f => ({ ...f, specific_roles: f.specific_roles.includes(r) ? f.specific_roles.filter(x=>x!==r) : [...f.specific_roles, r] }))}
                      style={{ padding:"5px 12px", borderRadius:20, border:`1px solid ${form.specific_roles.includes(r)?T.cyan:T.border}`, background:form.specific_roles.includes(r)?T.cyan+"20":"none", color:form.specific_roles.includes(r)?T.cyan:T.textMuted, fontSize:11, fontWeight:700, cursor:"pointer" }}>{r}</button>
                  ))}
                </div></div>
              )}

              {form.audience === "specific" && (
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:6 }}>Select People</label>
                <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                  {staff.filter(s=>s.id!==user.id).map(s => (
                    <label key={s.id} style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer", padding:"6px 10px", background:form.specific_ids.includes(s.id)?T.cyan+"12":"none", borderRadius:8 }}>
                      <input type="checkbox" checked={form.specific_ids.includes(s.id)} onChange={e => setForm(f=>({ ...f, specific_ids: e.target.checked ? [...f.specific_ids,s.id] : f.specific_ids.filter(x=>x!==s.id) }))} />
                      <span style={{ color:T.textPrimary, fontSize:13 }}>{s.name}</span>
                      <span style={{ color:T.textMuted, fontSize:11 }}>{s.role}</span>
                    </label>
                  ))}
                </div></div>
              )}

              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Subject *</label>
              <input value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} placeholder="e.g. Important update on WHO event" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Message *</label>
              <textarea value={form.message} onChange={e=>setForm(f=>({...f,message:e.target.value}))} rows={5} placeholder="Your message to the team..." style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} /></div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSend} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${priorityColors[form.priority]},${form.priority==="urgent"?"#F97316":form.priority==="important"?"#F59E0B":T.teal})", border:"none`, color:form.priority==="normal"?"#060B14":"#fff", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Sending...":" Send Broadcast"}</button>
              <button onClick={()=>setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ApprovalQueueView = ({ user, onNavigate, activeCountry = "All" }) => {
  const [rffs, setRffs] = useState([]);
  const [pos, setPOs] = useState([]);
  const [staffRequests, setStaffRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const [{ data: rf }, { data: po }, { data: sr }] = await Promise.all([
      (!activeCountry || activeCountry === "All") ? supabase.from("rffs").select("*,projects(name)").eq("approved",false).order("created_at",{ascending:false}) : supabase.from("rffs").select("*,projects(name)").eq("approved",false).eq("country",activeCountry).order("created_at",{ascending:false}),
      (!activeCountry || activeCountry === "All") ? supabase.from("purchase_orders").select("*").in("status",["vm_signed","finance_signed","fully_signed","pending_ceo"]).order("created_at",{ascending:false}) : supabase.from("purchase_orders").select("*").eq("country",activeCountry).in("status",["vm_signed","finance_signed","fully_signed","pending_ceo"]).order("created_at",{ascending:false}),
      (!activeCountry || activeCountry === "All")
        ? supabase.from("staff_payment_requests").select("*").eq("status","pending_ceo").order("submitted_at", { ascending: false })
        : supabase.from("staff_payment_requests").select("*").eq("country", activeCountry).eq("status","pending_ceo").order("submitted_at", { ascending: false }),
    ]);
    setRffs(rf||[]); setPOs(po||[]); setStaffRequests(sr||[]);
    setLoading(false);
  };
  useEffect(() => { load(); }, [activeCountry]);

  const totalPending = rffs.length + pos.filter(p=>["vm_signed","finance_signed","fully_signed"].includes(p.status)).length + staffRequests.length;

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>CEO</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Approval Queue</h2>
        <div style={{ color:totalPending>0?T.amber:T.teal, fontSize:12, marginTop:4, fontWeight:700 }}>{totalPending} item{totalPending!==1?"s":""} awaiting your attention</div>
      </div>

      {totalPending === 0 && (
        <div style={{ textAlign:"center", padding:80, background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}>
          <div style={{ fontSize:48, marginBottom:16 }}></div>
          <div style={{ color:T.teal, fontWeight:800, fontSize:18 }}>All clear</div>
          <div style={{ color:T.textMuted, fontSize:13, marginTop:8 }}>Nothing awaiting your approval right now.</div>
        </div>
      )}

      {/* RFFs awaiting approval */}
      {rffs.length > 0 && (
        <div style={{ marginBottom:24 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16 }}>RFFs Awaiting Approval <span style={{ color:T.amber, fontSize:13 }}>({rffs.length})</span></div>
            <button onClick={() => onNavigate && onNavigate("rff-approvals")} style={{ background:"none", border:`1px solid ${T.border}`, color:T.cyan, padding:"5px 14px", borderRadius:6, cursor:"pointer", fontSize:12, fontWeight:700 }}>View All RFFs →</button>
          </div>
          {rffs.slice(0,3).map(r => (
            <div key={r.id} style={{ background:T.surface, border:`1px solid ${T.amber}30`, borderLeft:`3px solid ${T.amber}`, borderRadius:10, padding:"14px 18px", marginBottom:8, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div>
                <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{r.title}</div>
                  <span style={{ background:(r.country||"Ghana")==="Nigeria"?"#10B98120":T.amber+"20", color:(r.country||"Ghana")==="Nigeria"?"#10B981":T.amber, borderRadius:20, padding:"1px 8px", fontSize:10, fontWeight:800 }}>{(r.country||"Ghana")==="Nigeria"?"NG":"GH"}</span>
                </div>
                <div style={{ color:T.textMuted, fontSize:12 }}>{r.projects?.name} · {r.event_name}</div>
                <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{new Date(r.created_at).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</div>
              </div>
              <button onClick={() => onNavigate && onNavigate("rff-approvals")} style={{ background:T.amber+"20", border:`1px solid ${T.amber}40`, color:T.amber, padding:"6px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}>Review →</button>
            </div>
          ))}
          {rffs.length > 3 && <div style={{ color:T.textMuted, fontSize:12, textAlign:"center", marginTop:4 }}>+{rffs.length-3} more RFFs</div>}
        </div>
      )}

      {/* POs awaiting CEO signature */}
      {pos.filter(p=>["vm_signed","finance_signed","fully_signed"].includes(p.status)).length > 0 && (
        <div style={{ marginBottom:24 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16 }}>Purchase Orders to Sign <span style={{ color:T.cyan, fontSize:13 }}>({pos.filter(p=>["vm_signed","finance_signed","fully_signed"].includes(p.status)).length})</span></div>
            <button onClick={() => onNavigate && onNavigate("purchase-orders")} style={{ background:"none", border:`1px solid ${T.border}`, color:T.cyan, padding:"5px 14px", borderRadius:6, cursor:"pointer", fontSize:12, fontWeight:700 }}>View All POs →</button>
          </div>
          {pos.filter(p=>["vm_signed","finance_signed","fully_signed"].includes(p.status)).slice(0,3).map(p => (
            <div key={p.id} style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderLeft:`3px solid ${T.cyan}`, borderRadius:10, padding:"14px 18px", marginBottom:8, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div>
                <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{p.internal_po_number} — {p.vendor_name}</div>
                <div style={{ color:T.teal, fontWeight:700, fontSize:13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(p.amount||0).toLocaleString()).toLocaleString()}</div>
                <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>Status: {p.status?.replace(/_/g," ")}</div>
              </div>
              <button onClick={() => onNavigate && onNavigate("purchase-orders")} style={{ background:T.cyan+"20", border:`1px solid ${T.cyan}40`, color:T.cyan, padding:"6px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}>Sign →</button>
            </div>
          ))}
        </div>
      )}

      {/* Staff payments awaiting CEO approval */}
      {staffRequests.length > 0 && (
        <div style={{ marginBottom:24 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16 }}>Staff Payment Requests <span style={{ color:T.teal, fontSize:13 }}>({staffRequests.length})</span></div>
            <button onClick={() => onNavigate && onNavigate("payment-authorisation")} style={{ background:"none", border:`1px solid ${T.border}`, color:T.cyan, padding:"5px 14px", borderRadius:6, cursor:"pointer", fontSize:12, fontWeight:700 }}>View All →</button>
          </div>
          {staffRequests.slice(0,3).map(r => (
            <div key={r.id} style={{ background:T.surface, border:`1px solid ${T.teal}30`, borderLeft:`3px solid ${T.teal}`, borderRadius:10, padding:"14px 18px", marginBottom:8, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div>
                <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{r.staff_name}</div>
                <div style={{ color:T.textMuted, fontSize:12 }}>{r.request_type?.replace(/_/g," ")} · {r.project_name}</div>
                <div style={{ color:T.textSecondary, fontSize:12, marginTop:2 }}>{r.description}</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ color:T.teal, fontWeight:900, fontSize:16 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(r.amount||0).toLocaleString()).toLocaleString()}</div>
                <button onClick={() => onNavigate && onNavigate("payment-authorisation")} style={{ background:T.teal+"20", border:`1px solid ${T.teal}40`, color:T.teal, padding:"5px 12px", borderRadius:7, cursor:"pointer", fontSize:11, fontWeight:700, marginTop:6 }}>Approve →</button>
              </div>
            </div>
          ))}
          {staffRequests.length > 3 && <div style={{ color:T.textMuted, fontSize:12, textAlign:"center", marginTop:4 }}>+{staffRequests.length-3} more requests</div>}
        </div>
      )}
    </div>
  );
};

const RiskRegisterView = ({ user }) => {
  const [risks, setRisks] = useState([]);
  const [events, setEvents] = useState([]);
  const [staff, setStaff] = useState([]);
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [filter, setFilter] = useState("all");
  const [form, setForm] = useState({ project_id:"", event_name:"", title:"", description:"", category:"operational", likelihood:"medium", impact:"medium", status:"open", owner_id:"", owner_name:"", mitigation:"" });

  const CATEGORIES = ["operational","financial","reputational","vendor","client","weather","technical","security"];
  const LEVELS = ["low","medium","high","critical"];
  const levelColors = { low:T.teal, medium:T.amber, high:"#F97316", critical:T.red };

  const load = async () => {
    const [{ data: r }, { data: ev }, { data: st }] = await Promise.all([
      supabase.from("risk_register").select("*").order("created_at", { ascending: false }),
      supabase.from("projects").select("id,name").order("name"),
      supabase.from("profiles").select("id,name,role").not("role","in","(Client,Vendor,Board of Directors)"),
    ]);
    setRisks(r||[]); setEvents(ev||[]); setStaff(st||[]);
  };
  useEffect(() => { load(); }, []);

  const riskScore = (r) => {
    const l = { low:1, medium:2, high:3, critical:4 };
    return (l[r.likelihood]||2) * (l[r.impact]||2);
  };

  const getRiskColor = (r) => {
    const s = riskScore(r);
    if (s >= 12) return T.red;
    if (s >= 6) return "#F97316";
    if (s >= 3) return T.amber;
    return T.teal;
  };

  const handleSave = async () => {
    if (!form.title) { alert("Title required."); return; }
    setSaving(true);
    if (editModal) {
      await supabase.from("risk_register").update({ ...form }).eq("id", editModal.id);
    } else {
      await supabase.from("risk_register").insert({ ...form, created_by: user.id });
    }
    setSaving(false); setModal(false); setEditModal(null);
    setForm({ project_id:"", event_name:"", title:"", description:"", category:"operational", likelihood:"medium", impact:"medium", status:"open", owner_id:"", owner_name:"", mitigation:"" });
    load();
  };

  const filtered = filter === "all" ? risks : risks.filter(r => r.status === filter);
  const openRisks = risks.filter(r => r.status === "open");
  const criticalRisks = openRisks.filter(r => riskScore(r) >= 9);

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Risk Register</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{openRisks.length} open risks · {criticalRisks.length} critical</div>
        </div>
        <button onClick={() => { setForm({ project_id:"", event_name:"", title:"", description:"", category:"operational", likelihood:"medium", impact:"medium", status:"open", owner_id:"", owner_name:"", mitigation:"" }); setModal(true); }} style={{ background:`linear-gradient(135deg,${T.red},#F97316)`, border:"none", color:"#fff", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Log Risk</button>
      </div>

      {criticalRisks.length > 0 && (
        <div style={{ background:T.red+"12", border:`1px solid ${T.red}30`, borderRadius:12, padding:"14px 18px", marginBottom:20 }}>
          <div style={{ color:T.red, fontWeight:800, fontSize:13, marginBottom:6 }}> {criticalRisks.length} Critical Risk{criticalRisks.length>1?"s":""} Require Immediate Attention</div>
          {criticalRisks.map(r => <div key={r.id} style={{ color:T.textSecondary, fontSize:12, padding:"3px 0" }}>• {r.title} {r.event_name?"— "+r.event_name:""}</div>)}
        </div>
      )}

      <div style={{ display:"flex", gap:8, marginBottom:20 }}>
        {["all","open","mitigated","closed"].map(s => (
          <button key={s} onClick={() => setFilter(s)} style={{ padding:"6px 16px", borderRadius:20, border:`1px solid ${filter===s?T.cyan:T.border}`, background:filter===s?T.cyan+"20":"none", color:filter===s?T.cyan:T.textMuted, fontWeight:700, fontSize:12, cursor:"pointer", textTransform:"capitalize" }}>{s} {s==="all"?`(${risks.length})`:s==="open"?`(${openRisks.length})`:""}</button>
        ))}
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {filtered.map(r => {
          const color = getRiskColor(r);
          const score = riskScore(r);
          return (
            <div key={r.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderLeft:`3px solid ${color}`, borderRadius:12, padding:"16px 20px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:4 }}>
                    <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>{r.title}</div>
                    <span style={{ background:color+"18", color:color, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700 }}>Score: {score}</span>
                    <span style={{ background:T.bg, color:T.textMuted, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{r.category}</span>
                    {r.status !== "open" && <span style={{ background:T.teal+"18", color:T.teal, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{r.status}</span>}
                  </div>
                  {r.event_name && <div style={{ color:T.textMuted, fontSize:12 }}>{r.event_name}</div>}
                  {r.description && <div style={{ color:T.textSecondary, fontSize:13, marginTop:4 }}>{r.description}</div>}
                  <div style={{ display:"flex", gap:12, marginTop:6 }}>
                    <span style={{ color:levelColors[r.likelihood], fontSize:11, fontWeight:700 }}>Likelihood: {r.likelihood}</span>
                    <span style={{ color:levelColors[r.impact], fontSize:11, fontWeight:700 }}>Impact: {r.impact}</span>
                    {r.owner_name && <span style={{ color:T.textMuted, fontSize:11 }}>Owner: {r.owner_name}</span>}
                  </div>
                  {r.mitigation && <div style={{ color:T.textMuted, fontSize:12, marginTop:6, fontStyle:"italic" }}>Mitigation: {r.mitigation}</div>}
                </div>
                <div style={{ display:"flex", gap:6, marginLeft:12 }}>
                  <button onClick={() => { setEditModal(r); setForm({...r}); setModal(true); }} style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}>Edit</button>
                  {r.status === "open" && <button onClick={async () => { await supabase.from("risk_register").update({ status:"mitigated" }).eq("id",r.id); load(); }} style={{ background:T.teal+"15", border:`1px solid ${T.teal}30`, color:T.teal, padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}> Mitigate</button>}
                </div>
              </div>
            </div>
          );
        })}
        {filtered.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, color:T.textMuted }}>No risks logged</div>}
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => { setModal(false); setEditModal(null); }}>
          <div style={{ background:T.surface, border:`1px solid ${T.red}30`, borderRadius:16, width:"100%", maxWidth:540, maxHeight:"90vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>{editModal?"Edit Risk":"Log New Risk"}</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Event (Optional)</label>
              <select value={form.project_id} onChange={e=>{ const ev=events.find(x=>x.id===e.target.value); setForm(f=>({...f,project_id:e.target.value,event_name:ev?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Company-wide risk</option>
                {events.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Risk Title *</label>
              <input value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} placeholder="e.g. Key vendor may not deliver on time" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Description</label>
              <textarea value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} rows={2} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} /></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 }}>
                {[["Category","category",CATEGORIES],["Likelihood","likelihood",LEVELS],["Impact","impact",LEVELS]].map(([label,key,opts])=>(
                  <div key={key}><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>{label}</label>
                  <select value={form[key]} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                    {opts.map(o=><option key={o} value={o}>{o.charAt(0).toUpperCase()+o.slice(1)}</option>)}
                  </select></div>
                ))}
              </div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Risk Owner</label>
              <select value={form.owner_id} onChange={e=>{ const s=staff.find(x=>x.id===e.target.value); setForm(f=>({...f,owner_id:e.target.value,owner_name:s?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Unassigned</option>
                {staff.map(s=><option key={s.id} value={s.id}>{s.name} ({s.role})</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Mitigation Plan</label>
              <textarea value={form.mitigation} onChange={e=>setForm(f=>({...f,mitigation:e.target.value}))} rows={2} placeholder="How will this risk be managed or reduced?" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} /></div>
              {editModal && <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Status</label>
              <select value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                {["open","mitigated","closed"].map(s=><option key={s}>{s}</option>)}
              </select></div>}
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.red},#F97316)`, border:"none", color:"#fff", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":editModal?"Save Changes":"Log Risk"}</button>
              <button onClick={()=>{ setModal(false); setEditModal(null); }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const DecisionLogView = ({ user }) => {
  const [decisions, setDecisions] = useState([]);
  const [events, setEvents] = useState([]);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [search, setSearch] = useState("");
  const [catFilter, setCatFilter] = useState("all");
  const [form, setForm] = useState({ project_id:"", event_name:"", title:"", decision:"", rationale:"", alternatives_considered:"", made_by_name:user?.name, decision_date:new Date().toISOString().slice(0,10), category:"operational" });

  const CATEGORIES = ["operational","financial","vendor","client","strategic","hr","marketing"];
  const catColors = { operational:T.cyan, financial:T.amber, vendor:T.teal, client:T.magenta, strategic:"#8B5CF6", hr:"#F59E0B", marketing:T.blue };

  const load = async () => {
    const [{ data: d }, { data: ev }] = await Promise.all([
      supabase.from("decision_log").select("*").order("decision_date", { ascending: false }),
      supabase.from("projects").select("id,name").order("name"),
    ]);
    setDecisions(d||[]); setEvents(ev||[]);
  };
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    if (!form.title || !form.decision) { alert("Title and decision are required."); return; }
    setSaving(true);
    await supabase.from("decision_log").insert({ ...form, made_by: user.id });
    setSaving(false); setModal(false);
    setForm({ project_id:"", event_name:"", title:"", decision:"", rationale:"", alternatives_considered:"", made_by_name:user.name, decision_date:new Date().toISOString().slice(0,10), category:"operational" });
    load();
  };

  const filtered = decisions.filter(d => {
    if (catFilter !== "all" && d.category !== catFilter) return false;
    if (search && !d.title.toLowerCase().includes(search.toLowerCase()) && !d.decision.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Decision Log</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Institutional memory — {decisions.length} decisions recorded</div>
        </div>
        <button onClick={() => setModal(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Log Decision</button>
      </div>

      <div style={{ display:"flex", gap:12, marginBottom:20 }}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search decisions..." style={{ flex:1, padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }} />
        <select value={catFilter} onChange={e=>setCatFilter(e.target.value)} style={{ padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
          <option value="all">All Categories</option>
          {CATEGORIES.map(c=><option key={c} value={c}>{c.charAt(0).toUpperCase()+c.slice(1)}</option>)}
        </select>
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
        {filtered.map(d => {
          const color = catColors[d.category] || T.cyan;
          return (
            <div key={d.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderLeft:`3px solid ${color}`, borderRadius:12, padding:"18px 22px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:4 }}>
                    <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14 }}>{d.title}</div>
                    <span style={{ background:color+"18", color:color, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{d.category}</span>
                  </div>
                  {d.event_name && <div style={{ color:T.textMuted, fontSize:12, marginBottom:6 }}>{d.event_name}</div>}
                  <div style={{ color:T.textSecondary, fontSize:13, lineHeight:1.6 }}>{d.decision}</div>
                  {d.rationale && <div style={{ color:T.textMuted, fontSize:12, marginTop:8 }}><span style={{ fontWeight:700 }}>Rationale:</span> {d.rationale}</div>}
                  {d.alternatives_considered && <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}><span style={{ fontWeight:700 }}>Alternatives considered:</span> {d.alternatives_considered}</div>}
                </div>
                <div style={{ textAlign:"right", marginLeft:16, flexShrink:0 }}>
                  <div style={{ color:T.textMuted, fontSize:11 }}>{d.decision_date ? new Date(d.decision_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : "—"}</div>
                  <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{d.made_by_name}</div>
                </div>
              </div>
            </div>
          );
        })}
        {filtered.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}><div style={{ fontSize:40, marginBottom:12 }}></div><div style={{ color:T.textPrimary, fontWeight:700 }}>No decisions logged yet</div></div>}
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:560, maxHeight:"90vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>Log Decision</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Event (Optional)</label>
              <select value={form.project_id} onChange={e=>{ const ev=events.find(x=>x.id===e.target.value); setForm(f=>({...f,project_id:e.target.value,event_name:ev?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Company-wide</option>
                {events.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
              </select></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Category</label>
                <select value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {CATEGORIES.map(c=><option key={c} value={c}>{c.charAt(0).toUpperCase()+c.slice(1)}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Decision Date</label>
                <input type="date" value={form.decision_date} onChange={e=>setForm(f=>({...f,decision_date:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              </div>
              {[["Decision Title *","title","e.g. Award catering contract to Vendor X"],["The Decision *","decision","What was decided?"],["Rationale","rationale","Why was this decision made?"],["Alternatives Considered","alternatives_considered","What other options were evaluated?"]].map(([label,key,ph])=>(
                <div key={key}><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>{label}</label>
                {key==="title" ? <input value={form[key]} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} placeholder={ph} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                : <textarea value={form[key]} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} rows={2} placeholder={ph} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} />}
                </div>
              ))}
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Log Decision"}</button>
              <button onClick={()=>setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const CompetitorIntelView = ({ user }) => {
  const [competitors, setCompetitors] = useState([]);
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ competitor_name:"", category:"direct", website:"", strengths:"", weaknesses:"", recent_activity:"", events_known_of:0, pricing_notes:"", win_loss:"unknown", notes:"" });

  const CATEGORIES = ["direct","indirect","aspirational"];
  const WIN_LOSS = ["unknown","more wins","even","more losses"];
  const catColors = { direct:T.red, indirect:T.amber, aspirational:T.cyan };

  const load = async () => {
    const { data } = await supabase.from("competitor_intel").select("*").order("created_at", { ascending: false });
    setCompetitors(data||[]);
  };
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    if (!form.competitor_name) { alert("Competitor name required."); return; }
    setSaving(true);
    if (editModal) {
      await supabase.from("competitor_intel").update({ ...form, updated_at:new Date().toISOString() }).eq("id", editModal.id);
    } else {
      await supabase.from("competitor_intel").insert({ ...form, created_by: user.id });
    }
    setSaving(false); setModal(false); setEditModal(null);
    setForm({ competitor_name:"", category:"direct", website:"", strengths:"", weaknesses:"", recent_activity:"", events_known_of:0, pricing_notes:"", win_loss:"unknown", notes:"" });
    load();
  };

  const wlColors = { "more wins":T.teal, "even":T.amber, "more losses":T.red, "unknown":T.textMuted };

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Competitor Intelligence</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{competitors.length} competitors tracked</div>
        </div>
        <button onClick={() => { setForm({ competitor_name:"", category:"direct", website:"", strengths:"", weaknesses:"", recent_activity:"", events_known_of:0, pricing_notes:"", win_loss:"unknown", notes:"" }); setEditModal(null); setModal(true); }} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Add Competitor</button>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(340px,1fr))", gap:14 }}>
        {competitors.map(c => {
          const color = catColors[c.category] || T.cyan;
          return (
            <div key={c.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderTop:`3px solid ${color}`, borderRadius:12, padding:"18px 20px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                <div>
                  <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15 }}>{c.competitor_name}</div>
                  <div style={{ display:"flex", gap:8, marginTop:4 }}>
                    <span style={{ background:color+"18", color:color, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{c.category}</span>
                    <span style={{ background:wlColors[c.win_loss]+"18", color:wlColors[c.win_loss], padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{c.win_loss}</span>
                  </div>
                </div>
                <button onClick={() => { setEditModal(c); setForm({...c}); setModal(true); }} style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}>Edit</button>
              </div>
              {c.website && <div style={{ color:T.cyan, fontSize:12, marginBottom:8 }}><a href={c.website} target="_blank" rel="noreferrer" style={{ color:T.cyan }}> {c.website}</a></div>}
              {c.strengths && <div style={{ marginBottom:6 }}><span style={{ color:T.teal, fontSize:11, fontWeight:700 }}>Strengths: </span><span style={{ color:T.textSecondary, fontSize:12 }}>{c.strengths}</span></div>}
              {c.weaknesses && <div style={{ marginBottom:6 }}><span style={{ color:T.red, fontSize:11, fontWeight:700 }}>Weaknesses: </span><span style={{ color:T.textSecondary, fontSize:12 }}>{c.weaknesses}</span></div>}
              {c.recent_activity && <div style={{ marginBottom:6 }}><span style={{ color:T.amber, fontSize:11, fontWeight:700 }}>Recent Activity: </span><span style={{ color:T.textSecondary, fontSize:12 }}>{c.recent_activity}</span></div>}
              {c.pricing_notes && <div style={{ marginBottom:6 }}><span style={{ color:T.textMuted, fontSize:11, fontWeight:700 }}>Pricing: </span><span style={{ color:T.textSecondary, fontSize:12 }}>{c.pricing_notes}</span></div>}
              <div style={{ color:T.textMuted, fontSize:11, marginTop:8 }}>Known events: {c.events_known_of} · Updated: {new Date(c.updated_at).toLocaleDateString("en-GB")}</div>
            </div>
          );
        })}
        {competitors.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, gridColumn:"1/-1" }}><div style={{ fontSize:40, marginBottom:12 }}></div><div style={{ color:T.textPrimary, fontWeight:700 }}>No competitors tracked yet</div><div style={{ color:T.textMuted, fontSize:13, marginTop:6 }}>Add competitors to track their activity and wins/losses.</div></div>}
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => { setModal(false); setEditModal(null); }}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:540, maxHeight:"90vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>{editModal?"Edit Competitor":"Add Competitor"}</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Competitor Name *</label>
              <input value={form.competitor_name} onChange={e=>setForm(f=>({...f,competitor_name:e.target.value}))} placeholder="e.g. EventPro Ghana" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Category</label>
                <select value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {CATEGORIES.map(c=><option key={c}>{c}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Win/Loss</label>
                <select value={form.win_loss} onChange={e=>setForm(f=>({...f,win_loss:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {WIN_LOSS.map(w=><option key={w}>{w}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Events Known</label>
                <input type="number" value={form.events_known_of} onChange={e=>setForm(f=>({...f,events_known_of:parseInt(e.target.value)||0}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              </div>
              {[["Website","website","https://..."],["Strengths","strengths","What are they good at?"],["Weaknesses","weaknesses","Where do they fall short?"],["Recent Activity","recent_activity","Latest news, events, campaigns"],["Pricing Notes","pricing_notes","What do they charge?"],["Notes","notes","Other intelligence"]].map(([label,key,ph])=>(
                <div key={key}><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>{label}</label>
                {key==="website"?<input value={form[key]||""} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} placeholder={ph} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                :<textarea value={form[key]||""} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} rows={2} placeholder={ph} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} />}
                </div>
              ))}
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":editModal?"Save Changes":"Add Competitor"}</button>
              <button onClick={()=>{ setModal(false); setEditModal(null); }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const RevenueForecastView = ({ user, activeCountry = "All" }) => {
  const [opportunities, setOpportunities] = useState([]);
  const [forecasts, setForecasts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const [{ data: op }, { data: fc }] = await Promise.all([
        (activeCountry && activeCountry !== "All") ? supabase.from("opportunities").select("*").not("status","in","(won,lost,Converted)").eq("country",activeCountry).order("company") : supabase.from("opportunities").select("*").not("status","in","(won,lost,Converted)").order("company"),
        supabase.from("revenue_forecast").select("*"),
      ]);
      setOpportunities(op||[]); setForecasts(fc||[]);
      setLoading(false);
    };
    load();
  }, [activeCountry]);

  const updateForecast = async (oppId, company, field, value) => {
    const existing = forecasts.find(f => f.opportunity_id === oppId);
    if (existing) {
      const updated = { ...existing, [field]: value };
      await supabase.from("revenue_forecast").update({ [field]: value }).eq("id", existing.id);
      setForecasts(prev => prev.map(f => f.id===existing.id ? updated : f));
    } else {
      const { data } = await supabase.from("revenue_forecast").insert({ opportunity_id:oppId, company, [field]:value, win_probability:50, estimated_value:0, created_by:user.id }).select().single();
      if (data) setForecasts(prev => [...prev, data]);
    }
  };

  const getForecast = (oppId) => forecasts.find(f => f.opportunity_id === oppId) || { win_probability:50, estimated_value:0, expected_close_date:"" };

  const now = new Date();
  const next30 = opportunities.filter(o => {
    const fc = getForecast(o.id);
    if (!fc.expected_close_date) return false;
    const d = new Date(fc.expected_close_date);
    return d >= now && d <= new Date(now.getTime()+30*86400000);
  });
  const next90 = opportunities.filter(o => {
    const fc = getForecast(o.id);
    if (!fc.expected_close_date) return false;
    const d = new Date(fc.expected_close_date);
    return d >= now && d <= new Date(now.getTime()+90*86400000);
  });

  const weightedForecast = (ops) => ops.reduce((s,o) => {
    const fc = getForecast(o.id);
    return s + (parseFloat(fc.estimated_value||0) * (fc.win_probability||50) / 100);
  }, 0);

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Revenue Forecast</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Pipeline weighted by probability — {opportunities.length} active opportunities</div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))", gap:12, marginBottom:24 }}>
        {[
          { label:"Weighted 30-Day", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(Math.round(weightedForecast(next30))).toLocaleString(), color:T.teal, sub:next30.length+" opportunities" },
          { label:"Weighted 90-Day", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(Math.round(weightedForecast(next90))).toLocaleString(), color:T.cyan, sub:next90.length+" opportunities" },
          { label:"Total Pipeline", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(Math.round(weightedForecast(opportunities))).toLocaleString(), color:T.amber, sub:"Weighted by probability" },
          { label:"Opportunities", value:opportunities.length, color:T.magenta, sub:"Active pipeline" },
        ].map(k => (
          <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10 }}>
            <div style={{ color:k.color, fontSize:18, fontWeight:900 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
            <div style={{ color:T.textMuted, fontSize:10, marginTop:2 }}>{k.sub}</div>
          </div>
        ))}
      </div>

      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead>
            <tr style={{ background:T.bg }}>
              {["Company","Status",`Est. Value (${getCurrency(activeCountry||user?.country||"Ghana")})`,"Win Prob %","Weighted","Close Date"].map(h => (
                <th key={h} style={{ padding:"10px 14px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {opportunities.map((o,i) => {
              const fc = getForecast(o.id);
              const weighted = Math.round(parseFloat(fc.estimated_value||0) * (fc.win_probability||50) / 100);
              const probColor = fc.win_probability >= 70 ? T.teal : fc.win_probability >= 40 ? T.amber : T.red;
              return (
                <tr key={o.id} style={{ borderBottom:i<opportunities.length-1?`1px solid ${T.border}44`:"none" }}>
                  <td style={{ padding:"10px 14px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{o.company}</td>
                  <td style={{ padding:"10px 14px" }}><span style={{ background:T.cyan+"18", color:T.cyan, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700 }}>{o.status}</span></td>
                  <td style={{ padding:"10px 14px" }}>
                    <input type="number" defaultValue={fc.estimated_value||""} onBlur={e=>updateForecast(o.id,o.company,"estimated_value",parseFloat(e.target.value)||0)} placeholder="0" style={{ width:100, padding:"4px 8px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:6, color:T.textPrimary, fontSize:12, fontFamily:"inherit", outline:"none" }} />
                  </td>
                  <td style={{ padding:"10px 14px" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <input type="range" min="0" max="100" value={fc.win_probability||50} onChange={e=>updateForecast(o.id,o.company,"win_probability",parseInt(e.target.value))} style={{ width:80 }} />
                      <span style={{ color:probColor, fontWeight:700, fontSize:12, minWidth:30 }}>{fc.win_probability||50}%</span>
                    </div>
                  </td>
                  <td style={{ padding:"10px 14px", color:T.teal, fontWeight:700, fontSize:13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(weighted.toLocaleString()).toLocaleString()}</td>
                  <td style={{ padding:"10px 14px" }}>
                    <input type="date" defaultValue={fc.expected_close_date||""} onBlur={e=>updateForecast(o.id,o.company,"expected_close_date",e.target.value)} style={{ padding:"4px 8px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:6, color:T.textPrimary, fontSize:12, fontFamily:"inherit", outline:"none" }} />
                  </td>
                </tr>
              );
            })}
            {opportunities.length===0 && <tr><td colSpan={6} style={{ padding:"40px 0", textAlign:"center", color:T.textMuted }}>No active opportunities in pipeline</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const BoardReportView = ({ user, activeCountry = "All" }) => {
  const [events, setEvents] = useState([]);
  const [clients, setClients] = useState([]);
  const [opportunities, setOpportunities] = useState([]);
  const [clientPayments, setClientPayments] = useState([]);
  const [satisfaction, setSatisfaction] = useState([]);
  const [goals, setGoals] = useState([]);
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [report, setReport] = useState(null);

  useEffect(() => {
    const load = async () => {
      const [{ data: ev }, { data: cl }, { data: op }, { data: cp }, { data: sat }, { data: go }, { data: aw }] = await Promise.all([
        (activeCountry && activeCountry !== "All") ? supabase.from("projects").select("*").eq("country",activeCountry).order("event_date",{ascending:false}) : supabase.from("projects").select("*").order("event_date",{ascending:false}),
        (activeCountry && activeCountry !== "All") ? supabase.from("clients").select("*").eq("country",activeCountry) : supabase.from("clients").select("*"),
        (activeCountry && activeCountry !== "All") ? supabase.from("opportunities").select("*").eq("country",activeCountry) : supabase.from("opportunities").select("*"),
        (activeCountry && activeCountry !== "All") ? supabase.from("client_payments").select("*").eq("country",activeCountry) : supabase.from("client_payments").select("*"),
        supabase.from("client_satisfaction").select("*"),
        supabase.from("company_goals").select("*").eq("status","active"),
        (activeCountry && activeCountry !== "All") ? supabase.from("rff_awards").select("*").eq("country",activeCountry) : supabase.from("rff_awards").select("*"),
      ]);
      setEvents(ev||[]); setClients(cl||[]); setOpportunities(op||[]);
      setClientPayments(cp||[]); setSatisfaction(sat||[]); setGoals(go||[]); setAwards(aw||[]);
      setLoading(false);
    };
    load();
  }, [activeCountry]);

  const now = new Date();
  const activeEvents = events.filter(e => !["Completed","Cancelled","completed","cancelled"].includes(e.phase||""));
  const completedEvents = events.filter(e => ["Completed","completed","Post-Event"].includes(e.phase||""));
  const revenueYTD = clientPayments.filter(p => new Date(p.payment_date).getFullYear() === now.getFullYear()).reduce((s,p) => s+parseFloat(p.amount||0), 0);
  const totalRevenue = clientPayments.reduce((s,p) => s+parseFloat(p.amount||0), 0);
  const pipeline = opportunities.filter(o => !["won","lost","Converted"].includes(o.status||""));
  const pipelineValue = pipeline.reduce((s,o) => s+(o.value||0), 0);
  const avgSat = satisfaction.length > 0 ? (satisfaction.reduce((s,r)=>s+(r.rating||0),0)/satisfaction.length).toFixed(1) : null;
  const vendorSpend = awards.reduce((s,a) => s+parseFloat(a.agreed_amount||0), 0);

  const generateReport = async () => {
    setGenerating(true);
    const prompt = `You are preparing a board report for Stretchfield, a premium event management company. Write a professional executive summary in 400-500 words covering:

COMPANY PERFORMANCE SNAPSHOT:
- Active Events: ${activeEvents.length}
- Completed Events: ${completedEvents.length}
- Revenue YTD: GHS ${revenueYTD.toLocaleString()}
- Total Revenue: GHS ${totalRevenue.toLocaleString()}
- Pipeline Value: GHS ${pipelineValue.toLocaleString()}
- Vendor Spend: GHS ${vendorSpend.toLocaleString()}
- Client Satisfaction: ${avgSat ? avgSat+"/5" : "No data yet"}
- Active Clients: ${clients.length}
- Pipeline Opportunities: ${pipeline.length}

STRATEGIC GOALS:
${goals.map(g => `- ${g.title}: ${g.current_value}/${g.target_value} ${g.unit} (${Math.round((g.current_value/g.target_value)*100)}%)`).join("\n") || "No goals set"}

Write in a confident, strategic tone befitting a premium events company presenting to its board. Include: key achievements, operational highlights, pipeline health, financial position, and forward outlook. Use flowing paragraphs, no bullet points or markdown.`;

    const response = await fetch("/api/generate-report", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ prompt })
    });
    const data = await response.json();
    console.log("Board report API response:", data);
    if (data.error) {
      setReport("Error: " + data.error);
    } else {
      setReport(data.text || "No content returned.");
    }
    setGenerating(false);
  };

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Board Report</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Executive summary for board & investors — {now.toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"})}</div>
        </div>
        <button onClick={generateReport} disabled={generating} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{generating?"Generating...":" Generate AI Summary"}</button>
      </div>

      {/* KPIs */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:12, marginBottom:24 }}>
        {[
          { label:"Revenue YTD", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(revenueYTD).toLocaleString(), color:T.teal },
          { label:"Total Revenue", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalRevenue).toLocaleString(), color:T.cyan },
          { label:"Pipeline Value", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(pipelineValue).toLocaleString(), color:T.amber },
          { label:"Active Events", value:activeEvents.length, color:T.cyan },
          { label:"Events Delivered", value:completedEvents.length, color:T.teal },
          { label:"Client Satisfaction", value:avgSat?avgSat+"/5":"—", color:avgSat&&parseFloat(avgSat)>=4?T.teal:T.amber },
          { label:"Active Clients", value:clients.length, color:T.magenta },
          { label:"Vendor Spend", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(vendorSpend).toLocaleString(), color:T.textMuted },
        ].map(k => (
          <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10 }}>
            <div style={{ color:k.color, fontSize:18, fontWeight:900 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Goals progress */}
      {goals.length > 0 && (
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"20px 24px", marginBottom:20 }}>
          <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15, marginBottom:16 }}>Strategic Goals Progress</div>
          {goals.map(g => {
            const pct = g.target_value > 0 ? Math.min(100, Math.round((g.current_value/g.target_value)*100)) : 0;
            const color = pct >= 80 ? T.teal : pct >= 50 ? T.amber : T.red;
            return (
              <div key={g.id} style={{ marginBottom:16 }}>
                <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
                  <div style={{ color:T.textPrimary, fontSize:13, fontWeight:700 }}>{g.title}</div>
                  <div style={{ color:color, fontSize:13, fontWeight:800 }}>{g.current_value?.toLocaleString()} / {g.target_value?.toLocaleString()} {g.unit} ({pct}%)</div>
                </div>
                <div style={{ height:8, background:T.border, borderRadius:4, overflow:"hidden" }}>
                  <div style={{ height:"100%", width:pct+"%", background:`linear-gradient(90deg,${color},${color}88)`, borderRadius:4, transition:"width 0.3s" }} />
                </div>
                {g.target_date && <div style={{ color:T.textMuted, fontSize:10, marginTop:3 }}>Target: {new Date(g.target_date).toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"})}</div>}
              </div>
            );
          })}
        </div>
      )}

      {/* AI Report */}
      {report && (
        <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:12, padding:"24px 28px", marginBottom:20 }}>
          <div style={{ color:T.cyan, fontSize:11, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:12 }}>AI-Generated Executive Summary</div>
          <div style={{ color:T.textSecondary, fontSize:14, lineHeight:1.8, whiteSpace:"pre-wrap" }}>{report}</div>
        </div>
      )}

      {/* Active events table */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
        <div style={{ padding:"14px 18px", borderBottom:`1px solid ${T.border}`, color:T.textPrimary, fontWeight:800, fontSize:14 }}>Active Events</div>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead><tr style={{ background:T.bg }}>{["Event","Client","Phase","Date"].map(h=><th key={h} style={{ padding:"8px 14px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>)}</tr></thead>
          <tbody>
            {activeEvents.map((e,i) => (
              <tr key={e.id} style={{ borderBottom:i<activeEvents.length-1?`1px solid ${T.border}44`:"none" }}>
                <td style={{ padding:"10px 14px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{e.name}</td>
                <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:12 }}>{e.client||"—"}</td>
                <td style={{ padding:"10px 14px" }}><span style={{ background:T.cyan+"18", color:T.cyan, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700 }}>{e.phase||"Planning"}</span></td>
                <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:12 }}>{e.event_date?new Date(e.event_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}):"TBC"}</td>
              </tr>
            ))}
            {activeEvents.length===0 && <tr><td colSpan={4} style={{ padding:"30px 0", textAlign:"center", color:T.textMuted }}>No active events</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const StrategicGoalsView = ({ user }) => {
  const [goals, setGoals] = useState([]);
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ title:"", description:"", category:"revenue", target_value:"", current_value:"0", unit:"GHS", target_date:"", status:"active" });

  const CATEGORIES = ["revenue","events","clients","satisfaction","team","marketing","operational"];

  const load = async () => {
    const { data } = await supabase.from("company_goals").select("*").order("created_at", { ascending: false });
    setGoals(data||[]);
  };
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    if (!form.title || !form.target_value) { alert("Title and target are required."); return; }
    setSaving(true);
    if (editModal) {
      await supabase.from("company_goals").update({ ...form, target_value:parseFloat(form.target_value), current_value:parseFloat(form.current_value||0) }).eq("id", editModal.id);
    } else {
      await supabase.from("company_goals").insert({ ...form, target_value:parseFloat(form.target_value), current_value:parseFloat(form.current_value||0), created_by:user.id });
    }
    setSaving(false);
    setModal(false);
    setEditModal(null);
    setForm({ title:"", description:"", category:"revenue", target_value:"", current_value:"0", unit:"GHS", target_date:"", status:"active" });
    load();
  };

  const catColors = { revenue:T.teal, events:T.cyan, clients:T.magenta, satisfaction:"#F59E0B", team:"#8B5CF6", marketing:T.amber, operational:T.textMuted };

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Strategic Goals & OKRs</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{goals.filter(g=>g.status==="active").length} active goals</div>
        </div>
        <button onClick={() => { setForm({ title:"", description:"", category:"revenue", target_value:"", current_value:"0", unit:"GHS", target_date:"", status:"active" }); setModal(true); }} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Add Goal</button>
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
        {goals.map(g => {
          const pct = g.target_value > 0 ? Math.min(100, Math.round(((g.current_value||0)/g.target_value)*100)) : 0;
          const color = catColors[g.category] || T.cyan;
          const statusColor = pct >= 100 ? T.teal : pct >= 60 ? T.amber : T.red;
          return (
            <div key={g.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderLeft:`3px solid ${color}`, borderRadius:12, padding:"20px 24px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:4 }}>
                    <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15 }}>{g.title}</div>
                    <span style={{ background:color+"18", color:color, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{g.category}</span>
                    {g.status==="completed" && <span style={{ background:T.teal+"18", color:T.teal, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700 }}> Completed</span>}
                  </div>
                  {g.description && <div style={{ color:T.textMuted, fontSize:13, marginBottom:8 }}>{g.description}</div>}
                </div>
                <div style={{ display:"flex", gap:8, marginLeft:16 }}>
                  <button onClick={() => { setEditModal(g); setForm({ title:g.title, description:g.description||"", category:g.category, target_value:g.target_value, current_value:g.current_value||0, unit:g.unit||"GHS", target_date:g.target_date||"", status:g.status }); setModal(true); }} style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"4px 12px", borderRadius:6, cursor:"pointer", fontSize:11, fontWeight:700 }}>Edit</button>
                </div>
              </div>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
                <div style={{ color:T.textMuted, fontSize:12 }}>Progress</div>
                <div style={{ color:statusColor, fontWeight:800, fontSize:14 }}>{(g.current_value||0).toLocaleString()} / {g.target_value?.toLocaleString()} {g.unit} <span style={{ fontSize:12 }}>({pct}%)</span></div>
              </div>
              <div style={{ height:10, background:T.border, borderRadius:5, overflow:"hidden", marginBottom:8 }}>
                <div style={{ height:"100%", width:pct+"%", background:`linear-gradient(90deg,${statusColor},${statusColor}88)`, borderRadius:5, transition:"width 0.5s" }} />
              </div>
              {g.target_date && <div style={{ color:T.textMuted, fontSize:11 }}>Target date: {new Date(g.target_date).toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"})}</div>}
            </div>
          );
        })}
        {goals.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}><div style={{ fontSize:40, marginBottom:12 }}></div><div style={{ color:T.textPrimary, fontWeight:700, fontSize:16 }}>No goals set yet</div><div style={{ color:T.textMuted, fontSize:13, marginTop:6 }}>Set your first strategic goal to track company progress.</div></div>}
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => { setModal(false); setEditModal(null); }}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:520, maxHeight:"90vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>{editModal?"Edit Goal":"New Strategic Goal"}</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              {[["Goal Title *","title","e.g. Achieve GHS 1M Revenue"],["Description","description","What does success look like?"],["Unit","unit","GHS, events, clients, %"]].map(([label,key,ph]) => (
                <div key={key}><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>{label}</label>
                <input value={form[key]} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} placeholder={ph} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              ))}
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Category</label>
                <select value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {CATEGORIES.map(c=><option key={c} value={c}>{c.charAt(0).toUpperCase()+c.slice(1)}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Status</label>
                <select value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {["active","completed","paused"].map(s=><option key={s}>{s}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Target Value *</label>
                <input type="number" value={form.target_value} onChange={e=>setForm(f=>({...f,target_value:e.target.value}))} placeholder="e.g. 1000000" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Current Value</label>
                <input type="number" value={form.current_value} onChange={e=>setForm(f=>({...f,current_value:e.target.value}))} placeholder="0" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              </div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Target Date</label>
              <input type="date" value={form.target_date} onChange={e=>setForm(f=>({...f,target_date:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":editModal?"Save Changes":"Add Goal"}</button>
              <button onClick={() => { setModal(false); setEditModal(null); }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ClientHealthView = ({ user, activeCountry = "All" }) => {
  const [clients, setClients] = useState([]);
  const [events, setEvents] = useState([]);
  const [satisfaction, setSatisfaction] = useState([]);
  const [clientPayments, setClientPayments] = useState([]);
  const [healthScores, setHealthScores] = useState([]);
  const [editModal, setEditModal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const acFilter = activeCountry && activeCountry !== "All";
      const [{ data: cl }, { data: ev }, { data: sat }, { data: cp }, { data: hs }] = await Promise.all([
        acFilter ? supabase.from("clients").select("*").eq("country",activeCountry).order("name") : supabase.from("clients").select("*").order("name"),
        acFilter ? supabase.from("projects").select("*").eq("country",activeCountry) : supabase.from("projects").select("*"),
        supabase.from("client_satisfaction").select("*"),
        acFilter ? supabase.from("client_payments").select("*").eq("country",activeCountry) : supabase.from("client_payments").select("*"),
        supabase.from("client_health_scores").select("*"),
      ]);
      setClients(cl||[]); setEvents(ev||[]); setSatisfaction(sat||[]);
      setClientPayments(cp||[]); setHealthScores(hs||[]);
      setLoading(false);
    };
    load();
  }, [activeCountry]);

  const getClientMetrics = (client) => {
    const clientEvents = events.filter(e => e.client_id === client.id);
    const clientSat = satisfaction.filter(s => clientEvents.some(e => e.id === s.project_id));
    const avgSat = clientSat.length > 0 ? (clientSat.reduce((s,r)=>s+(r.rating||0),0)/clientSat.length).toFixed(1) : null;
    // Match payments by client_id OR client_name (company or name)
    const revenue = clientPayments.filter(p => 
      p.client_id === client.id || 
      p.client_name === client.company || 
      p.client_name === client.name
    ).reduce((s,p) => s+parseFloat(p.amount||0), 0);
    const stored = healthScores.find(h => h.client_id === client.id);
    // Auto-calculate health score from real data
    let healthScore = stored?.health_score;
    if (!healthScore) {
      let score = 50; // base
      if (revenue > 0) score += 20; // has paid
      if (revenue > 100000) score += 10; // significant revenue
      if (clientEvents.length > 0) score += 10; // has events
      if (avgSat) score = Math.round((score + parseFloat(avgSat)*20) / 2); // blend with satisfaction
      healthScore = Math.min(100, score);
    }
    const renewalLikelihood = stored?.renewal_likelihood || (healthScore >= 80 ? "high" : healthScore >= 60 ? "medium" : "low");
    return { clientEvents, avgSat, revenue, healthScore, renewalLikelihood, notes: stored?.notes || "", lastTouchpoint: stored?.last_touchpoint };
  };

  const renewalColors = { high:T.teal, medium:T.amber, low:T.red };

  const saveHealthScore = async () => {
    if (!editModal) return;
    setSaving(true);
    const existing = healthScores.find(h => h.client_id === editModal.client.id);
    if (existing) {
      await supabase.from("client_health_scores").update({ renewal_likelihood:editModal.renewal_likelihood, health_score:editModal.health_score, notes:editModal.notes, last_touchpoint:editModal.last_touchpoint, updated_at:new Date().toISOString(), updated_by:user.id }).eq("id", existing.id);
    } else {
      await supabase.from("client_health_scores").insert({ client_id:editModal.client.id, client_name:editModal.client.name||editModal.client.company, renewal_likelihood:editModal.renewal_likelihood, health_score:editModal.health_score, notes:editModal.notes, last_touchpoint:editModal.last_touchpoint, updated_by:user.id });
    }
    setSaving(false);
    setEditModal(null);
    const { data: hs } = await supabase.from("client_health_scores").select("*");
    setHealthScores(hs||[]);
  };

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Client Health</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Satisfaction, revenue and renewal likelihood per client</div>
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
        {clients.map(client => {
          const m = getClientMetrics(client);
          const healthColor = m.healthScore >= 80 ? T.teal : m.healthScore >= 50 ? T.amber : T.red;
          return (
            <div key={client.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"20px 24px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
                <div>
                  <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16 }}>{client.company||client.name}</div>
                  <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{client.email}</div>
                </div>
                <div style={{ display:"flex", gap:12, alignItems:"center" }}>
                  <div style={{ textAlign:"center" }}>
                    <div style={{ color:healthColor, fontWeight:900, fontSize:24 }}>{m.healthScore}</div>
                    <div style={{ color:T.textMuted, fontSize:9, textTransform:"uppercase" }}>Health Score</div>
                  </div>
                  <div style={{ width:1, height:40, background:T.border }} />
                  <div style={{ textAlign:"center" }}>
                    <div style={{ color:renewalColors[m.renewalLikelihood]||T.amber, fontWeight:800, fontSize:13, textTransform:"capitalize" }}>{m.renewalLikelihood}</div>
                    <div style={{ color:T.textMuted, fontSize:9, textTransform:"uppercase" }}>Renewal</div>
                  </div>
                </div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:12, marginBottom:12 }}>
                {[
                  { label:"Events", value:m.clientEvents.length },
                  { label:"Satisfaction", value:m.avgSat?m.avgSat+"/5":"—" },
                  { label:"Revenue", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+((m.revenue)).toLocaleString() },
                  { label:"Last Touchpoint", value:m.lastTouchpoint?new Date(m.lastTouchpoint).toLocaleDateString("en-GB"):"—" },
                ].map(k => (
                  <div key={k.label} style={{ background:T.bg, borderRadius:8, padding:"10px 12px" }}>
                    <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>{k.value}</div>
                    <div style={{ color:T.textMuted, fontSize:10, textTransform:"uppercase", marginTop:2 }}>{k.label}</div>
                  </div>
                ))}
              </div>
              {m.notes && <div style={{ color:T.textMuted, fontSize:12, marginBottom:10, fontStyle:"italic" }}>{m.notes}</div>}
              <button onClick={() => setEditModal({ client, health_score:m.healthScore, renewal_likelihood:m.renewalLikelihood, notes:m.notes, last_touchpoint:m.lastTouchpoint||"" })} style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"5px 14px", borderRadius:7, cursor:"pointer", fontSize:11, fontWeight:700 }}> Update Health</button>
            </div>
          );
        })}
        {clients.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, color:T.textMuted }}>No clients yet</div>}
      </div>

      {editModal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setEditModal(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:460, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Update Client Health</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:20 }}>{editModal.client.company||editModal.client.name}</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Health Score (0-100)</label>
              <input type="number" min="0" max="100" value={editModal.health_score} onChange={e=>setEditModal(m=>({...m,health_score:parseInt(e.target.value)||0}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Renewal Likelihood</label>
              <select value={editModal.renewal_likelihood} onChange={e=>setEditModal(m=>({...m,renewal_likelihood:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="high">High</option><option value="medium">Medium</option><option value="low">Low</option>
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Last Touchpoint</label>
              <input type="date" value={editModal.last_touchpoint} onChange={e=>setEditModal(m=>({...m,last_touchpoint:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Notes</label>
              <textarea value={editModal.notes} onChange={e=>setEditModal(m=>({...m,notes:e.target.value}))} rows={3} placeholder="Relationship notes, concerns, opportunities..." style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} /></div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={saveHealthScore} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Save"}</button>
              <button onClick={()=>setEditModal(null)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const TeamPerformanceView = ({ user }) => {
  const [staff, setStaff] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [events, setEvents] = useState([]);
  const [staffRequests, setStaffRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStaff, setSelectedStaff] = useState(null);

  useEffect(() => {
    const load = async () => {
      const [{ data: st }, { data: tk }, { data: ev }, { data: sr }] = await Promise.all([
        supabase.from("profiles").select("*").not("role","in","(Client,Vendor,Board of Directors)").order("name"),
        supabase.from("tasks").select("*").order("created_at", { ascending: false }),
        supabase.from("projects").select("*"),
        supabase.from("staff_payment_requests").select("*"),
      ]);
      setStaff(st||[]); setTasks(tk||[]); setEvents(ev||[]); setStaffRequests(sr||[]);
      setLoading(false);
    };
    load();
  }, []);

  const getStaffMetrics = (member) => {
    const myTasks = tasks.filter(t => t.assignee_id === member.id);
    const completed = myTasks.filter(t => t.status === "completed");
    const pending = myTasks.filter(t => t.status !== "completed");
    const overdue = pending.filter(t => t.deadline && new Date(t.deadline) < new Date());
    const completionRate = myTasks.length > 0 ? Math.round((completed.length/myTasks.length)*100) : 0;
    const myEvents = events.filter(e => e.assigned_to === member.id || (Array.isArray(e.assigned_to_ids) && e.assigned_to_ids.includes(member.id)));
    const myPayments = staffRequests.filter(r => r.staff_id === member.id);
    return { myTasks, completed, pending, overdue, completionRate, myEvents, myPayments };
  };

  const roleColors = { CEO:T.cyan, "Finance Manager":T.amber, "Vendor Manager":T.teal, "Strategy & Events Lead":"#E879F9", "Sales & Marketing":T.blue };

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Team Performance</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Task completion, event load and activity per team member</div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))", gap:14 }}>
        {staff.map(member => {
          const m = getStaffMetrics(member);
          const perfColor = m.completionRate >= 80 ? T.teal : m.completionRate >= 50 ? T.amber : T.red;
          const roleColor = roleColors[member.role] || T.textMuted;
          return (
            <div key={member.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"18px 20px", cursor:"pointer" }} onClick={() => setSelectedStaff(selectedStaff?.id===member.id?null:member)}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
                <div style={{ display:"flex", gap:12, alignItems:"center" }}>
                  <div style={{ width:40, height:40, borderRadius:20, background:roleColor+"20", border:`2px solid ${roleColor}40`, display:"flex", alignItems:"center", justifyContent:"center", color:roleColor, fontWeight:800, fontSize:14 }}>{member.name?.split(" ").map(n=>n[0]).join("").substring(0,2)}</div>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14 }}>{member.name}</div>
                    <div style={{ color:roleColor, fontSize:11, fontWeight:700 }}>{member.role}</div>
                  </div>
                </div>
                <div style={{ textAlign:"center" }}>
                  <div style={{ color:perfColor, fontWeight:900, fontSize:22 }}>{m.completionRate}%</div>
                  <div style={{ color:T.textMuted, fontSize:9, textTransform:"uppercase" }}>Completion</div>
                </div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:8, marginBottom:10 }}>
                {[
                  { label:"Tasks", value:m.myTasks.length, color:T.textPrimary },
                  { label:"Done", value:m.completed.length, color:T.teal },
                  { label:"Pending", value:m.pending.length, color:T.amber },
                  { label:"Overdue", value:m.overdue.length, color:m.overdue.length>0?T.red:T.textMuted },
                ].map(k => (
                  <div key={k.label} style={{ background:T.bg, borderRadius:6, padding:"8px 10px", textAlign:"center" }}>
                    <div style={{ color:k.color, fontWeight:800, fontSize:16 }}>{k.value}</div>
                    <div style={{ color:T.textMuted, fontSize:9, textTransform:"uppercase" }}>{k.label}</div>
                  </div>
                ))}
              </div>
              <div style={{ height:6, background:T.border, borderRadius:3, overflow:"hidden" }}>
                <div style={{ height:"100%", width:m.completionRate+"%", background:`linear-gradient(90deg,${perfColor},${perfColor}88)`, borderRadius:3 }} />
              </div>
              {selectedStaff?.id === member.id && (
                <div style={{ marginTop:14, paddingTop:14, borderTop:`1px solid ${T.border}` }}>
                  <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", marginBottom:8 }}>Active Tasks</div>
                  {m.pending.slice(0,5).map(t => (
                    <div key={t.id} style={{ display:"flex", justifyContent:"space-between", padding:"5px 0", borderBottom:`1px solid ${T.border}22` }}>
                      <div style={{ color:T.textSecondary, fontSize:12 }}>{t.name}</div>
                      {t.deadline && <div style={{ color:new Date(t.deadline)<new Date()?T.red:T.textMuted, fontSize:11 }}>{new Date(t.deadline).toLocaleDateString("en-GB")}</div>}
                    </div>
                  ))}
                  {m.pending.length===0 && <div style={{ color:T.teal, fontSize:12 }}> All tasks completed</div>}
                  <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", marginTop:12, marginBottom:6 }}>Assigned Events ({m.myEvents.length})</div>
                  {m.myEvents.slice(0,3).map(e => <div key={e.id} style={{ color:T.textSecondary, fontSize:12, padding:"3px 0" }}>{e.name}</div>)}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};


const VendorPerformanceView = ({ user, activeCountry = "All" }) => {
  const [vendors, setVendors] = useState([]);
  const [scorecards, setScorecards] = useState([]);
  const [awards, setAwards] = useState([]);
  const [watchlist, setWatchlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const load = async () => {
      const [{ data: v }, { data: sc }, { data: aw }, { data: wl }] = await Promise.all([
        (!activeCountry || activeCountry === "All") ? supabase.from("profiles").select("*").eq("role","Vendor").order("name") : supabase.from("profiles").select("*").eq("role","Vendor").eq("country", activeCountry).order("name"),
        supabase.from("vendor_scorecards").select("*").order("created_at", { ascending: false }),
        supabase.from("rff_awards").select("*"),
        supabase.from("vendor_watchlist").select("*").eq("status","active"),
      ]);
      setVendors(v||[]); setScorecards(sc||[]); setAwards(aw||[]); setWatchlist(wl||[]);
      setLoading(false);
    };
    load();
  }, []);

  const getVendorMetrics = (v) => {
    const vScores = scorecards.filter(s => s.vendor_id === v.id || s.vendor_name?.trim() === v.name?.trim());
    const vAwards = awards.filter(a => a.vendor_id === v.id);
    const avgScore = vScores.length > 0 ? (vScores.reduce((s,sc) => s+(sc.total_pct||0), 0)/vScores.length).toFixed(1) : null;
    const totalEarned = vAwards.reduce((s,a) => s+parseFloat(a.agreed_amount||0), 0);
    const isWatched = watchlist.some(w => w.vendor_id === v.id);
    const tier = v.vendor_tier || (avgScore >= 85 ? "Gold" : avgScore >= 70 ? "Silver" : avgScore ? "Bronze" : "Unrated");
    return { vScores, vAwards, avgScore, totalEarned, isWatched, tier };
  };

  const tierColors = { Gold:"#F59E0B", Silver:"#94A3B8", Bronze:"#CD7F32", Unrated:T.textMuted };
  const filtered = vendors.filter(v => v.name?.toLowerCase().includes(search.toLowerCase()) || v.service_category?.toLowerCase().includes(search.toLowerCase()));

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Vendor Management</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Vendor Performance</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Scorecard history, tier progression and earnings per vendor</div>
        </div>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search vendors..." style={{ padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", width:220 }} />
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))", gap:14 }}>
        {filtered.map(v => {
          const m = getVendorMetrics(v);
          const tierColor = tierColors[m.tier] || T.textMuted;
          return (
            <div key={v.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"18px 20px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                    <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14 }}>{v.name}</div>
                    {m.isWatched && <span style={{ background:T.red+"18", color:T.red, padding:"1px 6px", borderRadius:20, fontSize:9, fontWeight:800 }}> WATCH</span>}
                  </div>
                  <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{v.service_category||"—"}</div>
                </div>
                <div style={{ textAlign:"center" }}>
                  <div style={{ color:tierColor, fontWeight:900, fontSize:11, textTransform:"uppercase" }}>{m.tier}</div>
                  <div style={{ color:tierColor, fontWeight:900, fontSize:22 }}>{m.avgScore||"—"}</div>
                  <div style={{ color:T.textMuted, fontSize:9 }}>AVG SCORE</div>
                </div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:10 }}>
                {[
                  { label:"Scorecards", value:m.vScores.length, color:T.cyan },
                  { label:"Jobs", value:m.vAwards.length, color:T.teal },
                  { label:"Earned", value:"GHS "+(m.totalEarned/1000).toFixed(0)+"k", color:T.amber },
                ].map(k => (
                  <div key={k.label} style={{ background:T.bg, borderRadius:8, padding:"8px 10px", textAlign:"center" }}>
                    <div style={{ color:k.color, fontWeight:800, fontSize:14 }}>{k.value}</div>
                    <div style={{ color:T.textMuted, fontSize:9, textTransform:"uppercase" }}>{k.label}</div>
                  </div>
                ))}
              </div>
              {m.vScores.length > 0 && (
                <div style={{ height:6, background:T.border, borderRadius:3, overflow:"hidden" }}>
                  <div style={{ height:"100%", width:parseFloat(m.avgScore)+"%", background:`linear-gradient(90deg,${tierColor},${tierColor}88)`, borderRadius:3 }} />
                </div>
              )}
              {m.vScores.slice(0,2).map(sc => (
                <div key={sc.id} style={{ display:"flex", justifyContent:"space-between", padding:"4px 0", borderBottom:`1px solid ${T.border}22`, marginTop:6 }}>
                  <div style={{ color:T.textMuted, fontSize:11 }}>{sc.event_name||"Event"}</div>
                  <div style={{ color:T.teal, fontWeight:700, fontSize:11 }}>{sc.total_pct}%</div>
                </div>
              ))}
            </div>
          );
        })}
        {filtered.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, gridColumn:"1/-1", color:T.textMuted }}>No vendors found</div>}
      </div>
    </div>
  );
};

const VendorContractsView = ({ user, activeCountry = "All" }) => {
  const [contracts, setContracts] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ vendor_id:"", vendor_name:"", contract_title:"", contract_type:"service", start_date:"", end_date:"", value:"", status:"active", document_url:"", terms:"", renewal_reminder_days:30 });

  const load = async () => {
    const [{ data: c }, { data: v }] = await Promise.all([
      supabase.from("vendor_contracts").select("*").order("end_date", { ascending: true }),
      supabase.from("profiles").select("id,name,service_category").eq("role","Vendor").order("name"),
    ]);
    setContracts(c||[]); setVendors(v||[]);
  };
  useEffect(() => { load(); }, []);

  const now = new Date();
  const expiringSoon = contracts.filter(c => {
    if (!c.end_date || c.status !== "active") return false;
    const d = new Date(c.end_date);
    const daysLeft = Math.ceil((d-now)/86400000);
    return daysLeft <= (c.renewal_reminder_days||30) && daysLeft > 0;
  });
  const expired = contracts.filter(c => c.end_date && new Date(c.end_date) < now && c.status === "active");

  const handleSave = async () => {
    if (!form.contract_title || !form.vendor_id) { alert("Title and vendor required."); return; }
    setSaving(true);
    if (editModal) {
      await supabase.from("vendor_contracts").update({ ...form, value:parseFloat(form.value)||0 }).eq("id", editModal.id);
    } else {
      await supabase.from("vendor_contracts").insert({ ...form, value:parseFloat(form.value)||0, created_by:user.id });
    }
    setSaving(false); setModal(false); setEditModal(null);
    setForm({ vendor_id:"", vendor_name:"", contract_title:"", contract_type:"service", start_date:"", end_date:"", value:"", status:"active", document_url:"", terms:"", renewal_reminder_days:30 });
    load();
  };

  const statusColors = { active:T.teal, expired:T.red, terminated:T.textMuted, renewed:T.cyan };

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Vendor Management</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Contract Management</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{contracts.length} contracts · {expiringSoon.length} expiring soon · {expired.length} expired</div>
        </div>
        <button onClick={() => { setForm({ vendor_id:"", vendor_name:"", contract_title:"", contract_type:"service", start_date:"", end_date:"", value:"", status:"active", document_url:"", terms:"", renewal_reminder_days:30 }); setEditModal(null); setModal(true); }} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Add Contract</button>
      </div>

      {(expiringSoon.length > 0 || expired.length > 0) && (
        <div style={{ background:T.amber+"12", border:`1px solid ${T.amber}30`, borderRadius:12, padding:"14px 18px", marginBottom:20 }}>
          <div style={{ color:T.amber, fontWeight:800, fontSize:13, marginBottom:6 }}> Attention Required</div>
          {expired.map(c => <div key={c.id} style={{ color:T.red, fontSize:12, padding:"2px 0" }}>• {c.vendor_name} — {c.contract_title} EXPIRED {new Date(c.end_date).toLocaleDateString("en-GB")}</div>)}
          {expiringSoon.map(c => { const days = Math.ceil((new Date(c.end_date)-now)/86400000); return <div key={c.id} style={{ color:T.amber, fontSize:12, padding:"2px 0" }}>• {c.vendor_name} — {c.contract_title} expires in {days} days</div>; })}
        </div>
      )}

      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead><tr style={{ background:T.bg }}>{["Vendor","Contract","Type","Value","Start","End","Status",""].map(h=><th key={h} style={{ padding:"10px 14px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>)}</tr></thead>
          <tbody>
            {contracts.map((c,i) => {
              const daysLeft = c.end_date ? Math.ceil((new Date(c.end_date)-now)/86400000) : null;
              const isExpired = daysLeft !== null && daysLeft < 0;
              return (
                <tr key={c.id} style={{ borderBottom:i<contracts.length-1?`1px solid ${T.border}44`:"none" }}>
                  <td style={{ padding:"10px 14px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{c.vendor_name}</td>
                  <td style={{ padding:"10px 14px", color:T.textSecondary, fontSize:12 }}>{c.contract_title}</td>
                  <td style={{ padding:"10px 14px" }}><span style={{ background:T.cyan+"18", color:T.cyan, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{c.contract_type}</span></td>
                  <td style={{ padding:"10px 14px", color:T.amber, fontWeight:700, fontSize:12 }}>{c.value?`${getCurrency(activeCountry||user?.country||"Ghana")} ${(parseFloat(c.value).toLocaleString())}`:"—"}</td>
                  <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:11 }}>{c.start_date?new Date(c.start_date).toLocaleDateString("en-GB"):"—"}</td>
                  <td style={{ padding:"10px 14px", color:isExpired?T.red:daysLeft&&daysLeft<=30?T.amber:T.textMuted, fontSize:11, fontWeight:isExpired||daysLeft<=30?700:400 }}>{c.end_date?new Date(c.end_date).toLocaleDateString("en-GB"):"—"}{daysLeft!==null&&daysLeft>0&&daysLeft<=30?` (${daysLeft}d)`:""}</td>
                  <td style={{ padding:"10px 14px" }}><span style={{ background:(statusColors[c.status]||T.textMuted)+"18", color:statusColors[c.status]||T.textMuted, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{c.status}</span></td>
                  <td style={{ padding:"10px 14px" }}>
                    <div style={{ display:"flex", gap:6 }}>
                      {c.document_url && <a href={c.document_url} target="_blank" rel="noreferrer" style={{ color:T.cyan, fontSize:11, fontWeight:700 }}></a>}
                      <button onClick={() => { setEditModal(c); setForm({...c}); setModal(true); }} style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"2px 8px", borderRadius:5, cursor:"pointer", fontSize:10, fontWeight:700 }}>Edit</button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {contracts.length===0 && <tr><td colSpan={8} style={{ padding:"40px 0", textAlign:"center", color:T.textMuted }}>No contracts yet</td></tr>}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={()=>{ setModal(false); setEditModal(null); }}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:540, maxHeight:"90vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>{editModal?"Edit Contract":"Add Contract"}</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Vendor *</label>
              <select value={form.vendor_id} onChange={e=>{ const v=vendors.find(x=>x.id===e.target.value); setForm(f=>({...f,vendor_id:e.target.value,vendor_name:v?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Select vendor...</option>{vendors.map(v=><option key={v.id} value={v.id}>{v.name}</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Contract Title *</label>
              <input value={form.contract_title} onChange={e=>setForm(f=>({...f,contract_title:e.target.value}))} placeholder="e.g. Event Services Agreement 2026" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Type</label>
                <select value={form.contract_type} onChange={e=>setForm(f=>({...f,contract_type:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {["service","retainer","one-off","framework","nda"].map(t=><option key={t}>{t}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Contract Value (${getCurrency(activeCountry||user?.country||"Ghana")})</label>
                <input type="number" value={form.value} onChange={e=>setForm(f=>({...f,value:e.target.value}))} placeholder="0" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Start Date</label>
                <input type="date" value={form.start_date} onChange={e=>setForm(f=>({...f,start_date:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>End Date</label>
                <input type="date" value={form.end_date} onChange={e=>setForm(f=>({...f,end_date:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Status</label>
                <select value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {["active","expired","terminated","renewed"].map(s=><option key={s}>{s}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Remind (days before)</label>
                <input type="number" value={form.renewal_reminder_days} onChange={e=>setForm(f=>({...f,renewal_reminder_days:parseInt(e.target.value)||30}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              </div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Document URL</label>
              <input value={form.document_url} onChange={e=>setForm(f=>({...f,document_url:e.target.value}))} placeholder="https://..." style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Key Terms</label>
              <textarea value={form.terms} onChange={e=>setForm(f=>({...f,terms:e.target.value}))} rows={2} placeholder="Key terms, payment conditions, deliverables..." style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} /></div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":editModal?"Save Changes":"Add Contract"}</button>
              <button onClick={()=>{ setModal(false); setEditModal(null); }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const PreferredVendorsView = ({ user, activeCountry = "All" }) => {
  const [preferred, setPreferred] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ vendor_id:"", vendor_name:"", service_category:"", tier:"preferred", reason:"" });

  const TIERS = ["preferred","approved","restricted"];
  const tierColors = { preferred:T.teal, approved:T.cyan, restricted:T.amber };

  const load = async () => {
    const [{ data: p }, { data: v }] = await Promise.all([
      supabase.from("preferred_vendors").select("*").order("tier"),
      supabase.from("profiles").select("id,name,service_category").eq("role","Vendor").order("name"),
    ]);
    setPreferred(p||[]); setVendors(v||[]);
  };
  useEffect(() => { load(); }, [activeCountry]);

  const handleSave = async () => {
    if (!form.vendor_id) { alert("Select a vendor."); return; }
    setSaving(true);
    await supabase.from("preferred_vendors").insert({ ...form, added_by: user.id });
    setSaving(false); setModal(false);
    setForm({ vendor_id:"", vendor_name:"", service_category:"", tier:"preferred", reason:"" });
    load();
  };

  const grouped = TIERS.reduce((acc, tier) => {
    acc[tier] = preferred.filter(p => p.tier === tier);
    return acc;
  }, {});

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Vendor Management</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Preferred Vendor List</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Pre-approved vendors for fast deployment per category</div>
        </div>
        <button onClick={() => setModal(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Add to List</button>
      </div>

      {TIERS.map(tier => (
        <div key={tier} style={{ marginBottom:24 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:12 }}>
            <span style={{ background:tierColors[tier]+"18", color:tierColors[tier], padding:"3px 12px", borderRadius:20, fontSize:11, fontWeight:800, textTransform:"capitalize" }}>{tier}</span>
            <span style={{ color:T.textMuted, fontSize:12 }}>{grouped[tier].length} vendor{grouped[tier].length!==1?"s":""}</span>
          </div>
          {grouped[tier].length === 0 ? (
            <div style={{ color:T.textMuted, fontSize:13, padding:"16px 0", fontStyle:"italic" }}>No {tier} vendors yet</div>
          ) : (
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:10 }}>
              {grouped[tier].map(p => (
                <div key={p.id} style={{ background:T.surface, border:`1px solid ${tierColors[p.tier]}30`, borderLeft:`3px solid ${tierColors[p.tier]}`, borderRadius:10, padding:"14px 16px", display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{p.vendor_name}</div>
                    <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{p.service_category}</div>
                    {p.reason && <div style={{ color:T.textMuted, fontSize:11, marginTop:4, fontStyle:"italic" }}>{p.reason}</div>}
                  </div>
                  <button onClick={async () => { await supabase.from("preferred_vendors").delete().eq("id",p.id); load(); }} style={{ background:T.red+"15", border:`1px solid ${T.red}30`, color:T.red, padding:"3px 8px", borderRadius:5, cursor:"pointer", fontSize:11, fontWeight:700 }}>×</button>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:460, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>Add to Preferred List</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Vendor *</label>
              <select value={form.vendor_id} onChange={e=>{ const v=vendors.find(x=>x.id===e.target.value); setForm(f=>({...f,vendor_id:e.target.value,vendor_name:v?.name||"",service_category:v?.service_category||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Select vendor...</option>{vendors.map(v=><option key={v.id} value={v.id}>{v.name} — {v.service_category}</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Tier</label>
              <select value={form.tier} onChange={e=>setForm(f=>({...f,tier:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                {TIERS.map(t=><option key={t}>{t}</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Reason</label>
              <textarea value={form.reason} onChange={e=>setForm(f=>({...f,reason:e.target.value}))} rows={2} placeholder="Why is this vendor preferred?" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} /></div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Add to List"}</button>
              <button onClick={()=>setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const VendorWatchlistView = ({ user, activeCountry = "All" }) => {
  const [watchlist, setWatchlist] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ vendor_id:"", vendor_name:"", flag_type:"monitor", reason:"", status:"active" });

  const FLAG_TYPES = ["monitor","warning","blacklist","payment-dispute","performance-issue"];
  const flagColors = { monitor:T.amber, warning:"#F97316", blacklist:T.red, "payment-dispute":T.red, "performance-issue":T.amber };

  const load = async () => {
    const [{ data: w }, { data: v }] = await Promise.all([
      supabase.from("vendor_watchlist").select("*").order("created_at", { ascending: false }),
      supabase.from("profiles").select("id,name,service_category").eq("role","Vendor").order("name"),
    ]);
    setWatchlist(w||[]); setVendors(v||[]);
  };
  useEffect(() => { load(); }, [activeCountry]);

  const active = watchlist.filter(w => w.status === "active");
  const resolved = watchlist.filter(w => w.status === "resolved");

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Vendor Management</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Watchlist & Flags</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{active.length} active flags · {resolved.length} resolved</div>
        </div>
        <button onClick={() => setModal(true)} style={{ background:`linear-gradient(135deg,${T.red},#F97316)`, border:"none", color:"#fff", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}> Flag Vendor</button>
      </div>

      {active.length > 0 && (
        <div style={{ marginBottom:20 }}>
          <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15, marginBottom:12 }}>Active Flags</div>
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {active.map(w => {
              const color = flagColors[w.flag_type] || T.amber;
              return (
                <div key={w.id} style={{ background:T.surface, border:`1px solid ${color}30`, borderLeft:`3px solid ${color}`, borderRadius:12, padding:"16px 20px", display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                  <div style={{ flex:1 }}>
                    <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:4 }}>
                      <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>{w.vendor_name}</div>
                      <span style={{ background:color+"18", color:color, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{w.flag_type?.replace(/-/g," ")}</span>
                    </div>
                    <div style={{ color:T.textSecondary, fontSize:13 }}>{w.reason}</div>
                    <div style={{ color:T.textMuted, fontSize:11, marginTop:4 }}>Flagged by {w.flagged_by_name} · {new Date(w.created_at).toLocaleDateString("en-GB")}</div>
                  </div>
                  <button onClick={async () => { await supabase.from("vendor_watchlist").update({ status:"resolved", resolved_at:new Date().toISOString() }).eq("id",w.id); load(); }} style={{ background:T.teal+"15", border:`1px solid ${T.teal}30`, color:T.teal, padding:"5px 12px", borderRadius:7, cursor:"pointer", fontSize:11, fontWeight:700, flexShrink:0, marginLeft:12 }}> Resolve</button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {resolved.length > 0 && (
        <div>
          <div style={{ color:T.textMuted, fontWeight:700, fontSize:13, marginBottom:10 }}>Resolved ({resolved.length})</div>
          {resolved.map(w => (
            <div key={w.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:10, padding:"12px 16px", marginBottom:8, opacity:0.6 }}>
              <div style={{ display:"flex", justifyContent:"space-between" }}>
                <div><div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{w.vendor_name}</div><div style={{ color:T.textMuted, fontSize:12 }}>{w.reason}</div></div>
                <div style={{ color:T.teal, fontSize:11, fontWeight:700 }}> Resolved</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {active.length===0 && resolved.length===0 && (
        <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}><div style={{ fontSize:40, marginBottom:12 }}></div><div style={{ color:T.textPrimary, fontWeight:700 }}>No flags</div><div style={{ color:T.textMuted, fontSize:13, marginTop:6 }}>All vendors are in good standing.</div></div>
      )}

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.red}30`, borderRadius:16, width:"100%", maxWidth:460, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>Flag Vendor</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Vendor *</label>
              <select value={form.vendor_id} onChange={e=>{ const v=vendors.find(x=>x.id===e.target.value); setForm(f=>({...f,vendor_id:e.target.value,vendor_name:v?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Select vendor...</option>{vendors.map(v=><option key={v.id} value={v.id}>{v.name}</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Flag Type</label>
              <select value={form.flag_type} onChange={e=>setForm(f=>({...f,flag_type:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                {FLAG_TYPES.map(t=><option key={t} value={t}>{t.replace(/-/g," ").replace(/\w/g,l=>l.toUpperCase())}</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Reason *</label>
              <textarea value={form.reason} onChange={e=>setForm(f=>({...f,reason:e.target.value}))} rows={3} placeholder="Why is this vendor being flagged?" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} /></div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={async () => {
                if (!form.vendor_id || !form.reason) { alert("Vendor and reason required."); return; }
                setSaving(true);
                await supabase.from("vendor_watchlist").insert({ ...form, flagged_by:user.id, flagged_by_name:user.name });
                setSaving(false); setModal(false);
                setForm({ vendor_id:"", vendor_name:"", flag_type:"monitor", reason:"", status:"active" });
                load();
              }} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.red},#F97316)`, border:"none", color:"#fff", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Flag Vendor"}</button>
              <button onClick={()=>setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const VendorCommsView = ({ user, activeCountry = "All" }) => {
  const [comms, setComms] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [events, setEvents] = useState([]);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [filter, setFilter] = useState("all");
  const [form, setForm] = useState({ vendor_id:"", vendor_name:"", project_id:"", event_name:"", type:"call", subject:"", notes:"", outcome:"", follow_up_date:"" });

  const TYPES = ["call","email","meeting","site-visit","whatsapp","other"];
  const typeColors = { call:T.cyan, email:T.teal, meeting:T.amber, "site-visit":"#8B5CF6", whatsapp:"#25D366", other:T.textMuted };

  const load = async () => {
    const [{ data: c }, { data: v }, { data: e }] = await Promise.all([
      supabase.from("vendor_comms_log").select("*").order("created_at", { ascending: false }),
      supabase.from("profiles").select("id,name,service_category").eq("role","Vendor").order("name"),
      supabase.from("projects").select("id,name").order("name"),
    ]);
    setComms(c||[]); setVendors(v||[]); setEvents(e||[]);
  };
  useEffect(() => { load(); }, [activeCountry]);

  const filtered = filter === "all" ? comms : comms.filter(c => c.type === filter);
  const followUps = comms.filter(c => c.follow_up_date && new Date(c.follow_up_date) >= new Date());

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Vendor Management</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Vendor Communications</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{comms.length} logged · {followUps.length} follow-ups pending</div>
        </div>
        <button onClick={() => setModal(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Log Communication</button>
      </div>

      {followUps.length > 0 && (
        <div style={{ background:T.amber+"12", border:`1px solid ${T.amber}30`, borderRadius:12, padding:"14px 18px", marginBottom:20 }}>
          <div style={{ color:T.amber, fontWeight:800, fontSize:13, marginBottom:6 }}> Upcoming Follow-ups</div>
          {followUps.map(f => <div key={f.id} style={{ color:T.textSecondary, fontSize:12, padding:"2px 0" }}>• {f.vendor_name} — {f.subject} → {new Date(f.follow_up_date).toLocaleDateString("en-GB")}</div>)}
        </div>
      )}

      <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap" }}>
        {["all",...TYPES].map(t => (
          <button key={t} onClick={() => setFilter(t)} style={{ padding:"5px 14px", borderRadius:20, border:`1px solid ${filter===t?(typeColors[t]||T.cyan):T.border}`, background:filter===t?(typeColors[t]||T.cyan)+"20":"none", color:filter===t?(typeColors[t]||T.cyan):T.textMuted, fontSize:11, fontWeight:700, cursor:"pointer", textTransform:"capitalize" }}>{t}</button>
        ))}
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {filtered.map(c => {
          const color = typeColors[c.type] || T.textMuted;
          return (
            <div key={c.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderLeft:`3px solid ${color}`, borderRadius:12, padding:"14px 18px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:4 }}>
                    <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>{c.vendor_name}</div>
                    <span style={{ background:color+"18", color:color, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{c.type}</span>
                  </div>
                  <div style={{ color:T.textSecondary, fontSize:13, fontWeight:600 }}>{c.subject}</div>
                  {c.event_name && <div style={{ color:T.textMuted, fontSize:12 }}>{c.event_name}</div>}
                  {c.notes && <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{c.notes}</div>}
                  {c.outcome && <div style={{ color:T.teal, fontSize:12, marginTop:4, fontWeight:600 }}>Outcome: {c.outcome}</div>}
                  {c.follow_up_date && <div style={{ color:T.amber, fontSize:11, marginTop:4 }}>Follow up: {new Date(c.follow_up_date).toLocaleDateString("en-GB")}</div>}
                </div>
                <div style={{ color:T.textMuted, fontSize:11, marginLeft:12, flexShrink:0 }}>
                  <div>{new Date(c.created_at).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</div>
                  <div>{c.logged_by_name}</div>
                </div>
              </div>
            </div>
          );
        })}
        {filtered.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, color:T.textMuted }}>No communications logged</div>}
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:520, maxHeight:"90vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>Log Communication</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Vendor *</label>
                <select value={form.vendor_id} onChange={e=>{ const v=vendors.find(x=>x.id===e.target.value); setForm(f=>({...f,vendor_id:e.target.value,vendor_name:v?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">Select...</option>{vendors.map(v=><option key={v.id} value={v.id}>{v.name}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Type</label>
                <select value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {TYPES.map(t=><option key={t}>{t}</option>)}
                </select></div>
              </div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Event (Optional)</label>
              <select value={form.project_id} onChange={e=>{ const ev=events.find(x=>x.id===e.target.value); setForm(f=>({...f,project_id:e.target.value,event_name:ev?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">No specific event</option>{events.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
              </select></div>
              {[["Subject *","subject","What was discussed?"],["Notes","notes","Key discussion points..."],["Outcome","outcome","What was agreed or decided?"]].map(([label,key,ph])=>(
                <div key={key}><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>{label}</label>
                {key==="subject"?<input value={form[key]} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} placeholder={ph} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                :<textarea value={form[key]} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} rows={2} placeholder={ph} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} />}
                </div>
              ))}
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Follow-up Date</label>
              <input type="date" value={form.follow_up_date} onChange={e=>setForm(f=>({...f,follow_up_date:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={async () => {
                if (!form.vendor_id || !form.subject) { alert("Vendor and subject required."); return; }
                setSaving(true);
                await supabase.from("vendor_comms_log").insert({ ...form, logged_by:user.id, logged_by_name:user.name });
                setSaving(false); setModal(false);
                setForm({ vendor_id:"", vendor_name:"", project_id:"", event_name:"", type:"call", subject:"", notes:"", outcome:"", follow_up_date:"" });
                load();
              }} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Log Communication"}</button>
              <button onClick={()=>setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const VendorSLAView = ({ user, activeCountry = "All" }) => {
  const [slas, setSlas] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [events, setEvents] = useState([]);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ vendor_id:"", vendor_name:"", project_id:"", event_name:"", sla_item:"", agreed_standard:"", actual_delivery:"", status:"pending", breach_notes:"" });

  const statusColors = { pending:T.textMuted, met:T.teal, breached:T.red, "partially-met":T.amber };

  const load = async () => {
    const [{ data: s }, { data: v }, { data: e }] = await Promise.all([
      supabase.from("vendor_sla").select("*").order("created_at", { ascending: false }),
      supabase.from("profiles").select("id,name").eq("role","Vendor").order("name"),
      supabase.from("projects").select("id,name").order("name"),
    ]);
    setSlas(s||[]); setVendors(v||[]); setEvents(e||[]);
  };
  useEffect(() => { load(); }, [activeCountry]);

  const breaches = slas.filter(s => s.status === "breached");
  const met = slas.filter(s => s.status === "met");
  const compliance = slas.length > 0 ? Math.round((met.length/slas.length)*100) : 0;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>SLA Tracker</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{slas.length} SLAs tracked · {compliance}% compliance · {breaches.length} breaches</div>
        </div>
        <button onClick={() => setModal(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Add SLA</button>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:12, marginBottom:24 }}>
        {[
          { label:"Total SLAs", value:slas.length, color:T.cyan },
          { label:"Met", value:met.length, color:T.teal },
          { label:"Breached", value:breaches.length, color:breaches.length>0?T.red:T.teal },
          { label:"Compliance", value:compliance+"%", color:compliance>=80?T.teal:compliance>=60?T.amber:T.red },
        ].map(k => (
          <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10 }}>
            <div style={{ color:k.color, fontSize:20, fontWeight:900 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {slas.map(s => {
          const color = statusColors[s.status] || T.textMuted;
          return (
            <div key={s.id} style={{ background:T.surface, border:`1px solid ${s.status==="breached"?T.red+"30":T.border}`, borderLeft:`3px solid ${color}`, borderRadius:12, padding:"14px 18px", display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:4 }}>
                  <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>{s.vendor_name}</div>
                  <span style={{ background:color+"18", color:color, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"capitalize" }}>{s.status}</span>
                </div>
                <div style={{ color:T.textSecondary, fontSize:13, fontWeight:600 }}>{s.sla_item}</div>
                {s.event_name && <div style={{ color:T.textMuted, fontSize:12 }}>{s.event_name}</div>}
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginTop:8 }}>
                  <div><div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase" }}>Agreed</div><div style={{ color:T.textSecondary, fontSize:12 }}>{s.agreed_standard||"—"}</div></div>
                  <div><div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase" }}>Actual</div><div style={{ color:T.textSecondary, fontSize:12 }}>{s.actual_delivery||"Pending"}</div></div>
                </div>
                {s.breach_notes && <div style={{ color:T.red, fontSize:12, marginTop:6 }}> {s.breach_notes}</div>}
              </div>
              <div style={{ display:"flex", gap:6, marginLeft:12 }}>
                {s.status === "pending" && (
                  <>
                    <button onClick={async()=>{ await supabase.from("vendor_sla").update({status:"met"}).eq("id",s.id); load(); }} style={{ background:T.teal+"15", border:`1px solid ${T.teal}30`, color:T.teal, padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:10, fontWeight:700 }}> Met</button>
                    <button onClick={async()=>{ const notes=window.prompt("Breach details:"); if(!notes) return; await supabase.from("vendor_sla").update({status:"breached",breach_notes:notes}).eq("id",s.id); load(); }} style={{ background:T.red+"15", border:`1px solid ${T.red}30`, color:T.red, padding:"4px 10px", borderRadius:6, cursor:"pointer", fontSize:10, fontWeight:700 }}> Breach</button>
                  </>
                )}
              </div>
            </div>
          );
        })}
        {slas.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, color:T.textMuted }}>No SLAs tracked yet</div>}
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:500, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>Add SLA</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Vendor *</label>
                <select value={form.vendor_id} onChange={e=>{ const v=vendors.find(x=>x.id===e.target.value); setForm(f=>({...f,vendor_id:e.target.value,vendor_name:v?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">Select...</option>{vendors.map(v=><option key={v.id} value={v.id}>{v.name}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Event</label>
                <select value={form.project_id} onChange={e=>{ const ev=events.find(x=>x.id===e.target.value); setForm(f=>({...f,project_id:e.target.value,event_name:ev?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  <option value="">General</option>{events.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
                </select></div>
              </div>
              {[["SLA Item *","sla_item","e.g. Deliver setup by 7am"],["Agreed Standard","agreed_standard","What was the agreed benchmark?"],["Actual Delivery","actual_delivery","What actually happened? (fill after event)"]].map(([label,key,ph])=>(
                <div key={key}><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>{label}</label>
                <input value={form[key]} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} placeholder={ph} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} />
                </div>
              ))}
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={async()=>{ if(!form.vendor_id||!form.sla_item){alert("Vendor and SLA item required.");return;} setSaving(true); await supabase.from("vendor_sla").insert({...form,created_by:user.id}); setSaving(false); setModal(false); setForm({vendor_id:"",vendor_name:"",project_id:"",event_name:"",sla_item:"",agreed_standard:"",actual_delivery:"",status:"pending",breach_notes:""}); load(); }} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Add SLA"}</button>
              <button onClick={()=>setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const MarketRatesView = ({ user, activeCountry = "All" }) => {
  const [rates, setRates] = useState([]);
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ category:"", service_description:"", min_rate:"", max_rate:"", unit:"per event", source:"", last_updated:new Date().toISOString().slice(0,10) });
  const CATEGORIES = ["Event Lighting","Events Ushering","Photography","Videography","Catering","Entertainment Provider (MC, DJ, Live Band, Performers)","Event Decor","Event Production Company","Event Refreshment","Furniture & Equipment Rental","Security Service","Transportation","Venue Provider","Other"];

  const load = async () => { const { data } = await supabase.from("vendor_market_rates").select("*").order("category"); setRates(data||[]); };
  useEffect(() => { load(); }, [activeCountry]);

  const handleSave = async () => {
    if (!form.category) { alert("Category required."); return; }
    setSaving(true);
    if (editModal) {
      await supabase.from("vendor_market_rates").update({ ...form, min_rate:parseFloat(form.min_rate)||0, max_rate:parseFloat(form.max_rate)||0 }).eq("id", editModal.id);
    } else {
      await supabase.from("vendor_market_rates").insert({ ...form, min_rate:parseFloat(form.min_rate)||0, max_rate:parseFloat(form.max_rate)||0, updated_by:user.id });
    }
    setSaving(false); setModal(false); setEditModal(null);
    setForm({ category:"", service_description:"", min_rate:"", max_rate:"", unit:"per event", source:"", last_updated:new Date().toISOString().slice(0,10) });
    load();
  };

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Market Rates</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Benchmark vendor quotes against market rates per category</div>
        </div>
        <button onClick={() => { setForm({ category:"", service_description:"", min_rate:"", max_rate:"", unit:"per event", source:"", last_updated:new Date().toISOString().slice(0,10) }); setEditModal(null); setModal(true); }} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Add Rate</button>
      </div>

      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead><tr style={{ background:T.bg }}>{["Category","Service","Min Rate","Max Rate","Unit","Source","Updated",""].map(h=><th key={h} style={{ padding:"10px 14px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>)}</tr></thead>
          <tbody>
            {rates.map((r,i) => (
              <tr key={r.id} style={{ borderBottom:i<rates.length-1?`1px solid ${T.border}44`:"none" }}>
                <td style={{ padding:"10px 14px", color:T.textPrimary, fontWeight:700, fontSize:12 }}>{r.category}</td>
                <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:12 }}>{r.service_description||"—"}</td>
                <td style={{ padding:"10px 14px", color:T.teal, fontWeight:700, fontSize:12 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(r.min_rate||0).toLocaleString()).toLocaleString()}</td>
                <td style={{ padding:"10px 14px", color:T.amber, fontWeight:700, fontSize:12 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(parseFloat(r.max_rate||0).toLocaleString()).toLocaleString()}</td>
                <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:11 }}>{r.unit}</td>
                <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:11 }}>{r.source||"—"}</td>
                <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:11 }}>{r.last_updated?new Date(r.last_updated).toLocaleDateString("en-GB"):"—"}</td>
                <td style={{ padding:"10px 14px" }}><button onClick={()=>{ setEditModal(r); setForm({...r}); setModal(true); }} style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"2px 8px", borderRadius:5, cursor:"pointer", fontSize:10, fontWeight:700 }}>Edit</button></td>
              </tr>
            ))}
            {rates.length===0 && <tr><td colSpan={8} style={{ padding:"40px 0", textAlign:"center", color:T.textMuted }}>No market rates defined yet</td></tr>}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={()=>{ setModal(false); setEditModal(null); }}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:480, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>{editModal?"Edit Rate":"Add Market Rate"}</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Category *</label>
              <select value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Select category...</option>{CATEGORIES.map(c=><option key={c}>{c}</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Service Description</label>
              <input value={form.service_description} onChange={e=>setForm(f=>({...f,service_description:e.target.value}))} placeholder="e.g. Full event lighting rig" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Min Rate (${getCurrency(activeCountry||user?.country||"Ghana")})</label>
                <input type="number" value={form.min_rate} onChange={e=>setForm(f=>({...f,min_rate:e.target.value}))} placeholder="0" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Max Rate (${getCurrency(activeCountry||user?.country||"Ghana")})</label>
                <input type="number" value={form.max_rate} onChange={e=>setForm(f=>({...f,max_rate:e.target.value}))} placeholder="0" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Unit</label>
                <select value={form.unit} onChange={e=>setForm(f=>({...f,unit:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {["per event","per day","per hour","per person","per item"].map(u=><option key={u}>{u}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Source</label>
                <input value={form.source} onChange={e=>setForm(f=>({...f,source:e.target.value}))} placeholder="e.g. Industry survey" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              </div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":editModal?"Save Changes":"Add Rate"}</button>
              <button onClick={()=>{ setModal(false); setEditModal(null); }} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ProcurementReportView = ({ user }) => {
  const [awards, setAwards] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [rffs, setRffs] = useState([]);
  const [events, setEvents] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [scorecards, setScorecards] = useState([]);
  const [period, setPeriod] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const [{ data: aw }, { data: inv }, { data: rf }, { data: ev }, { data: vp }, { data: sc }] = await Promise.all([
        supabase.from("rff_awards").select("*"),
        supabase.from("vendor_invoices").select("*"),
        supabase.from("rffs").select("*"),
        supabase.from("projects").select("*"),
        supabase.from("profiles").select("*").eq("role","Vendor"),
        supabase.from("vendor_scorecards").select("*"),
      ]);
      setAwards(aw||[]); setInvoices(inv||[]); setRffs(rf||[]); setEvents(ev||[]); setVendors(vp||[]); setScorecards(sc||[]);
      setLoading(false);
    };
    load();
  }, []);

  const now = new Date();
  const filterByPeriod = (items, dateField) => {
    if (period === "all") return items;
    const d = new Date(now);
    if (period === "this_month") { d.setDate(1); d.setHours(0,0,0,0); }
    if (period === "last_month") { d.setMonth(d.getMonth()-1); d.setDate(1); d.setHours(0,0,0,0); }
    if (period === "this_year") { d.setMonth(0); d.setDate(1); d.setHours(0,0,0,0); }
    return items.filter(i => i[dateField] && new Date(i[dateField]) >= d);
  };

  const filteredAwards = filterByPeriod(awards, "created_at");
  const totalSpend = filteredAwards.reduce((s,a) => s+parseFloat(a.agreed_amount||0), 0);
  const paidInvoices = filterByPeriod(invoices.filter(i=>i.status==="paid"), "created_at");
  const totalPaid = paidInvoices.reduce((s,i) => s+parseFloat(i.amount||0), 0);
  const savings = totalSpend > 0 ? ((totalSpend-totalPaid)/totalSpend*100).toFixed(1) : 0;

  // Spend by category
  const categorySpend = {};
  filteredAwards.forEach(a => {
    const vendor = vendors.find(v => v.id === a.vendor_id);
    const cat = vendor?.service_category || "Other";
    categorySpend[cat] = (categorySpend[cat]||0) + parseFloat(a.agreed_amount||0);
  });
  const topCategories = Object.entries(categorySpend).sort((a,b)=>b[1]-a[1]).slice(0,6);

  // Top vendors by spend
  const vendorSpend = {};
  filteredAwards.forEach(a => {
    vendorSpend[a.vendor_name||"Unknown"] = (vendorSpend[a.vendor_name||"Unknown"]||0) + parseFloat(a.agreed_amount||0);
  });
  const topVendors = Object.entries(vendorSpend).sort((a,b)=>b[1]-a[1]).slice(0,5);

  // Avg score per vendor
  const avgVendorScore = vendors.map(v => {
    const vsc = scorecards.filter(s => s.vendor_id===v.id || s.vendor_name?.trim()===v.name?.trim());
    return { name:v.name, avg:vsc.length?((vsc.reduce((s,sc)=>s+(sc.total_pct||0),0)/vsc.length).toFixed(1)):null, count:vsc.length };
  }).filter(v => v.avg !== null).sort((a,b)=>b.avg-a.avg);

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Procurement Report</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Vendor spend, savings and performance summary</div>
        </div>
        <select value={period} onChange={e=>setPeriod(e.target.value)} style={{ padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
          <option value="all">All Time</option>
          <option value="this_month">This Month</option>
          <option value="last_month">Last Month</option>
          <option value="this_year">This Year</option>
        </select>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:12, marginBottom:24 }}>
        {[
          { label:"Total Awarded", value:getCurrency(user?.country||"Ghana")+" "+(totalSpend).toLocaleString(), color:T.amber },
          { label:"Total Paid", value:getCurrency(user?.country||"Ghana")+" "+(totalPaid).toLocaleString(), color:T.red },
          { label:"Contracts", value:filteredAwards.length, color:T.cyan },
          { label:"Active Vendors", value:vendors.length, color:T.teal },
          { label:"Avg Score", value: scorecards.length>0?(scorecards.reduce((s,sc)=>s+(sc.total_pct||0),0)/scorecards.length).toFixed(1)+"%":"—", color:T.magenta },
        ].map(k => (
          <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10 }}>
            <div style={{ color:k.color, fontSize:18, fontWeight:900 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:20 }}>
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"18px 20px" }}>
          <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14, marginBottom:14 }}>Spend by Category</div>
          {topCategories.map(([cat, spend]) => {
            const pct = totalSpend > 0 ? (spend/totalSpend*100).toFixed(1) : 0;
            return (
              <div key={cat} style={{ marginBottom:10 }}>
                <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                  <div style={{ color:T.textSecondary, fontSize:12 }}>{cat}</div>
                  <div style={{ color:T.amber, fontWeight:700, fontSize:12 }}>GHS {spend.toLocaleString()} ({pct}%)</div>
                </div>
                <div style={{ height:6, background:T.border, borderRadius:3, overflow:"hidden" }}>
                  <div style={{ height:"100%", width:pct+"%", background:`linear-gradient(90deg,${T.amber},${T.amber}88)`, borderRadius:3 }} />
                </div>
              </div>
            );
          })}
          {topCategories.length===0 && <div style={{ color:T.textMuted, fontSize:13 }}>No spend data yet</div>}
        </div>

        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"18px 20px" }}>
          <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14, marginBottom:14 }}>Top Vendors by Spend</div>
          {topVendors.map(([name, spend], i) => (
            <div key={name} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:i<topVendors.length-1?`1px solid ${T.border}33`:"none" }}>
              <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                <div style={{ width:20, height:20, borderRadius:10, background:T.cyan+"20", color:T.cyan, fontSize:10, fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center" }}>{i+1}</div>
                <div style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{name}</div>
              </div>
              <div style={{ color:T.amber, fontWeight:700, fontSize:13 }}>{getCurrency(user?.country||"Ghana")+" "+(spend.toLocaleString()).toLocaleString()}</div>
            </div>
          ))}
          {topVendors.length===0 && <div style={{ color:T.textMuted, fontSize:13 }}>No awards yet</div>}
        </div>
      </div>

      {/* Vendor scorecard league table */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
        <div style={{ padding:"14px 18px", borderBottom:`1px solid ${T.border}`, color:T.textPrimary, fontWeight:800, fontSize:14 }}>Vendor Performance League Table</div>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead><tr style={{ background:T.bg }}>{["#","Vendor","Avg Score","Scorecards","Tier"].map(h=><th key={h} style={{ padding:"8px 14px", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{h}</th>)}</tr></thead>
          <tbody>
            {avgVendorScore.map((v,i) => {
              const tier = v.avg>=85?"Gold":v.avg>=70?"Silver":v.avg>=50?"Bronze":"Unrated";
              const tierColor = { Gold:"#F59E0B", Silver:"#94A3B8", Bronze:"#CD7F32", Unrated:T.textMuted }[tier];
              return (
                <tr key={v.name} style={{ borderBottom:i<avgVendorScore.length-1?`1px solid ${T.border}44`:"none" }}>
                  <td style={{ padding:"10px 14px", color:T.textMuted, fontWeight:700, fontSize:13 }}>#{i+1}</td>
                  <td style={{ padding:"10px 14px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{v.name}</td>
                  <td style={{ padding:"10px 14px" }}><div style={{ display:"flex", alignItems:"center", gap:8 }}><div style={{ width:80, height:6, background:T.border, borderRadius:3, overflow:"hidden" }}><div style={{ height:"100%", width:v.avg+"%", background:tierColor, borderRadius:3 }} /></div><span style={{ color:tierColor, fontWeight:800, fontSize:13 }}>{v.avg}%</span></div></td>
                  <td style={{ padding:"10px 14px", color:T.textMuted, fontSize:12 }}>{v.count}</td>
                  <td style={{ padding:"10px 14px" }}><span style={{ background:tierColor+"18", color:tierColor, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700 }}>{tier}</span></td>
                </tr>
              );
            })}
            {avgVendorScore.length===0 && <tr><td colSpan={5} style={{ padding:"30px 0", textAlign:"center", color:T.textMuted }}>No scorecard data yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};


const EventBriefsView = ({ user }) => {
  const [briefs, setBriefs] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedBrief, setSelectedBrief] = useState(null);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ project_id:"", event_name:"", client_objectives:"", audience_profile:"", key_messages:"", success_metrics:"", dietary_requirements:"", accessibility_needs:"", dress_code:"", tone:"professional", special_instructions:"" });

  const TONES = ["professional","formal","celebratory","corporate","creative","intimate","high-energy"];

  const load = async () => {
    const [{ data: b }, { data: ev }] = await Promise.all([
      supabase.from("event_briefs").select("*").order("created_at", { ascending: false }),
      supabase.from("projects").select("*").order("event_date", { ascending: false }),
    ]);
    setBriefs(b||[]);
    // Filter events assigned to this ESL
    const myEvents = (ev||[]).filter(e =>
      e.assigned_to === user?.id ||
      (Array.isArray(e.assigned_to_ids) && e.assigned_to_ids.includes(user.id)) ||
      user.role === "CEO" || user.role === "Finance Manager"
    );
    setEvents(myEvents);
  };
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    if (!form.project_id) { alert("Select an event."); return; }
    setSaving(true);
    const existing = briefs.find(b => b.project_id === form.project_id);
    if (existing) {
      await supabase.from("event_briefs").update({ ...form, updated_at: new Date().toISOString() }).eq("id", existing.id);
    } else {
      await supabase.from("event_briefs").insert({ ...form, created_by: user.id });
    }
    setSaving(false); setModal(false);
    setForm({ project_id:"", event_name:"", client_objectives:"", audience_profile:"", key_messages:"", success_metrics:"", dietary_requirements:"", accessibility_needs:"", dress_code:"", tone:"professional", special_instructions:"" });
    load();
  };

  const toneColors = { professional:T.cyan, formal:"#8B5CF6", celebratory:"#F59E0B", corporate:T.teal, creative:T.magenta, intimate:"#EC4899", "high-energy":T.red };

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Events</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Event Briefs</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Client objectives, audience profile and key messages per event</div>
        </div>
        <button onClick={() => { setForm({ project_id:"", event_name:"", client_objectives:"", audience_profile:"", key_messages:"", success_metrics:"", dietary_requirements:"", accessibility_needs:"", dress_code:"", tone:"professional", special_instructions:"" }); setModal(true); }} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Create Brief</button>
      </div>

      {selectedBrief ? (
        <div>
          <button onClick={() => setSelectedBrief(null)} style={{ background:"none", border:"none", color:T.textMuted, cursor:"pointer", fontSize:12, fontWeight:700, padding:"0 0 16px 0", display:"flex", alignItems:"center", gap:4 }}>← Back to Briefs</button>
          <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:16, padding:"28px 32px" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:24 }}>
              <div>
                <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>Event Brief</div>
                <div style={{ color:T.textPrimary, fontWeight:900, fontSize:20 }}>{selectedBrief.event_name}</div>
              </div>
              <div style={{ display:"flex", gap:8 }}>
                <span style={{ background:(toneColors[selectedBrief.tone]||T.cyan)+"18", color:toneColors[selectedBrief.tone]||T.cyan, padding:"4px 14px", borderRadius:20, fontSize:11, fontWeight:700, textTransform:"capitalize" }}>{selectedBrief.tone}</span>
                <button onClick={() => { setForm({...selectedBrief}); setModal(true); }} style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"5px 14px", borderRadius:7, cursor:"pointer", fontSize:11, fontWeight:700 }}> Edit</button>
              </div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:20 }}>
              {[
                ["Client Objectives", selectedBrief.client_objectives],
                ["Audience Profile", selectedBrief.audience_profile],
                ["Key Messages", selectedBrief.key_messages],
                ["Success Metrics", selectedBrief.success_metrics],
                ["Dietary Requirements", selectedBrief.dietary_requirements],
                ["Accessibility Needs", selectedBrief.accessibility_needs],
                ["Dress Code", selectedBrief.dress_code],
                ["Special Instructions", selectedBrief.special_instructions],
              ].filter(([,v]) => v).map(([label, value]) => (
                <div key={label} style={{ background:T.bg, borderRadius:10, padding:"16px 18px" }}>
                  <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:8 }}>{label}</div>
                  <div style={{ color:T.textSecondary, fontSize:13, lineHeight:1.7 }}>{value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
          {events.map(ev => {
            const brief = briefs.find(b => b.project_id === ev.id);
            return (
              <div key={ev.id} style={{ background:T.surface, border:`1px solid ${brief?T.teal+"40":T.border}`, borderLeft:`3px solid ${brief?T.teal:T.border}`, borderRadius:12, padding:"16px 20px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <div>
                  <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>{ev.name}</div>
                  <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{ev.client} · {ev.event_date?new Date(ev.event_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}):"TBC"}</div>
                  {brief && <div style={{ color:T.teal, fontSize:11, fontWeight:700, marginTop:4 }}> Brief Created · {new Date(brief.updated_at||brief.created_at).toLocaleDateString("en-GB")}</div>}
                  {!brief && <div style={{ color:T.amber, fontSize:11, fontWeight:700, marginTop:4 }}> No brief yet</div>}
                </div>
                <div style={{ display:"flex", gap:8 }}>
                  {brief && <button onClick={() => setSelectedBrief(brief)} style={{ background:T.teal+"15", border:`1px solid ${T.teal}30`, color:T.teal, padding:"6px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}>View →</button>}
                  <button onClick={() => { if(brief) setForm({...brief}); else setForm(f=>({...f,project_id:ev.id,event_name:ev.name})); setModal(true); }} style={{ background:T.cyan+"15", border:`1px solid ${T.cyan}30`, color:T.cyan, padding:"6px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700 }}>{brief?"Edit":"Create Brief"}</button>
                </div>
              </div>
            );
          })}
          {events.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, color:T.textMuted }}>No events assigned</div>}
        </div>
      )}

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:620, maxHeight:"90vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>Event Brief</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Event *</label>
              <select value={form.project_id} onChange={e=>{ const ev=events.find(x=>x.id===e.target.value); setForm(f=>({...f,project_id:e.target.value,event_name:ev?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Select event...</option>{events.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
              </select></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Tone</label>
                <select value={form.tone} onChange={e=>setForm(f=>({...f,tone:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {TONES.map(t=><option key={t}>{t}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Dress Code</label>
                <input value={form.dress_code} onChange={e=>setForm(f=>({...f,dress_code:e.target.value}))} placeholder="e.g. Business Formal" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              </div>
              {[["Client Objectives","client_objectives","What does the client want to achieve?"],["Audience Profile","audience_profile","Who is attending? Demographics, roles, expectations"],["Key Messages","key_messages","What must attendees take away?"],["Success Metrics","success_metrics","How will we measure success?"],["Dietary Requirements","dietary_requirements","Any dietary needs or restrictions?"],["Accessibility Needs","accessibility_needs","Mobility, hearing, visual or other needs"],["Special Instructions","special_instructions","Any other specific requirements"]].map(([label,key,ph])=>(
                <div key={key}><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>{label}</label>
                <textarea value={form[key]} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} rows={2} placeholder={ph} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} /></div>
              ))}
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Save Brief"}</button>
              <button onClick={()=>setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const EventMilestonesView = ({ user }) => {
  const [milestones, setMilestones] = useState([]);
  const [events, setEvents] = useState([]);
  const [staff, setStaff] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("all");
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ project_id:"", event_name:"", title:"", due_date:"", assigned_to:"", assigned_name:"", category:"logistics", status:"pending", notes:"" });

  const CATEGORIES = ["logistics","venue","vendor","client","content","technical","staffing","marketing","finance"];
  const catColors = { logistics:T.cyan, venue:T.teal, vendor:T.amber, client:T.magenta, content:"#8B5CF6", technical:"#F97316", staffing:"#10B981", marketing:T.blue, finance:T.red };

  const load = async () => {
    const [{ data: m }, { data: ev }, { data: st }] = await Promise.all([
      supabase.from("event_milestones").select("*").order("due_date", { ascending: true }),
      supabase.from("projects").select("*").order("event_date", { ascending: true }),
      supabase.from("profiles").select("id,name,role").not("role","in","(Client,Vendor,Board of Directors)"),
    ]);
    setMilestones(m||[]);
    const myEvents = (ev||[]).filter(e =>
      e.assigned_to === user.id ||
      (Array.isArray(e.assigned_to_ids) && e.assigned_to_ids.includes(user.id)) ||
      user.role === "CEO" || user.role === "Finance Manager" || user.role === "Vendor Manager"
    );
    setEvents(myEvents); setStaff(st||[]);
  };
  useEffect(() => { load(); }, []);

  const filtered = selectedEvent === "all" ? milestones : milestones.filter(m => m.project_id === selectedEvent);
  const overdue = filtered.filter(m => m.due_date && new Date(m.due_date) < new Date() && m.status === "pending");
  const upcoming = filtered.filter(m => m.due_date && new Date(m.due_date) >= new Date() && m.status === "pending");
  const completed = filtered.filter(m => m.status === "completed");

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Events</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Event Timeline</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{overdue.length} overdue · {upcoming.length} upcoming · {completed.length} completed</div>
        </div>
        <div style={{ display:"flex", gap:10 }}>
          <select value={selectedEvent} onChange={e=>setSelectedEvent(e.target.value)} style={{ padding:"9px 14px", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
            <option value="all">All Events</option>
            {events.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
          </select>
          <button onClick={() => setModal(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Add Milestone</button>
        </div>
      </div>

      {overdue.length > 0 && (
        <div style={{ background:T.red+"12", border:`1px solid ${T.red}30`, borderRadius:12, padding:"14px 18px", marginBottom:20 }}>
          <div style={{ color:T.red, fontWeight:800, fontSize:13, marginBottom:6 }}> {overdue.length} Overdue Milestone{overdue.length>1?"s":""}</div>
          {overdue.map(m => <div key={m.id} style={{ color:T.textSecondary, fontSize:12, padding:"2px 0" }}>• {m.title} {m.event_name?"— "+m.event_name:""} (due {new Date(m.due_date).toLocaleDateString("en-GB")})</div>)}
        </div>
      )}

      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        {filtered.map(m => {
          const color = catColors[m.category] || T.cyan;
          const isOverdue = m.due_date && new Date(m.due_date) < new Date() && m.status === "pending";
          const daysLeft = m.due_date ? Math.ceil((new Date(m.due_date)-new Date())/86400000) : null;
          return (
            <div key={m.id} style={{ background:T.surface, border:`1px solid ${isOverdue?T.red+"30":T.border}`, borderLeft:`3px solid ${m.status==="completed"?T.teal:isOverdue?T.red:color}", borderRadius:10, padding:"14px 18px`, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:4 }}>
                  <div style={{ color:m.status==="completed"?T.textMuted:T.textPrimary, fontWeight:700, fontSize:13, textDecoration:m.status==="completed"?"line-through":"none" }}>{m.title}</div>
                  <span style={{ background:color+"18", color:color, padding:"1px 8px", borderRadius:20, fontSize:9, fontWeight:700, textTransform:"capitalize" }}>{m.category}</span>
                  {m.status==="completed" && <span style={{ color:T.teal, fontSize:10, fontWeight:700 }}> Done</span>}
                </div>
                <div style={{ display:"flex", gap:12, alignItems:"center" }}>
                  {m.event_name && <span style={{ color:T.textMuted, fontSize:11 }}>{m.event_name}</span>}
                  {m.assigned_name && <span style={{ color:T.textMuted, fontSize:11 }}>→ {m.assigned_name}</span>}
                  {m.due_date && <span style={{ color:isOverdue?T.red:daysLeft<=3?T.amber:T.textMuted, fontSize:11, fontWeight:isOverdue||daysLeft<=3?700:400 }}>{isOverdue?"Overdue":daysLeft===0?"Today":daysLeft+"d left"} · {new Date(m.due_date).toLocaleDateString("en-GB")}</span>}
                </div>
                {m.notes && <div style={{ color:T.textMuted, fontSize:11, marginTop:4, fontStyle:"italic" }}>{m.notes}</div>}
              </div>
              {m.status === "pending" && (
                <button onClick={async()=>{ await supabase.from("event_milestones").update({status:"completed",completed_at:new Date().toISOString()}).eq("id",m.id); load(); }} style={{ background:T.teal+"15", border:`1px solid ${T.teal}30`, color:T.teal, padding:"5px 12px", borderRadius:7, cursor:"pointer", fontSize:11, fontWeight:700, flexShrink:0, marginLeft:12 }}> Complete</button>
              )}
            </div>
          );
        })}
        {filtered.length===0 && <div style={{ textAlign:"center", padding:60, background:T.surface, borderRadius:12, border:`1px solid ${T.border}`, color:T.textMuted }}>No milestones yet</div>}
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={()=>setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:500, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>Add Milestone</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Event</label>
              <select value={form.project_id} onChange={e=>{ const ev=events.find(x=>x.id===e.target.value); setForm(f=>({...f,project_id:e.target.value,event_name:ev?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Select event...</option>{events.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Milestone Title *</label>
              <input value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} placeholder="e.g. Confirm venue layout with client" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Category</label>
                <select value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {CATEGORIES.map(c=><option key={c}>{c}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Due Date</label>
                <input type="date" value={form.due_date} onChange={e=>setForm(f=>({...f,due_date:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              </div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Assign To</label>
              <select value={form.assigned_to} onChange={e=>{ const s=staff.find(x=>x.id===e.target.value); setForm(f=>({...f,assigned_to:e.target.value,assigned_name:s?.name||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Unassigned</option>{staff.map(s=><option key={s.id} value={s.id}>{s.name} ({s.role})</option>)}
              </select></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Notes</label>
              <textarea value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} rows={2} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} /></div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={async()=>{ if(!form.title){alert("Title required.");return;} setSaving(true); await supabase.from("event_milestones").insert({...form,created_by:user.id}); setSaving(false); setModal(false); setForm({project_id:"",event_name:"",title:"",due_date:"",assigned_to:"",assigned_name:"",category:"logistics",status:"pending",notes:""}); load(); }} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Add Milestone"}</button>
              <button onClick={()=>setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ESLPerformanceView = ({ user }) => {
  const [events, setEvents] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [satisfaction, setSatisfaction] = useState([]);
  const [debriefs, setDebriefs] = useState([]);
  const [milestones, setMilestones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const [{ data: ev }, { data: tk }, { data: sat }, { data: db }, { data: ms }] = await Promise.all([
        supabase.from("projects").select("*").order("event_date", { ascending: false }),
        supabase.from("tasks").select("*").eq("assignee_id", user.id),
        supabase.from("client_satisfaction").select("*"),
        supabase.from("event_debrief").select("*").eq("submitted_by", user.id),
        supabase.from("event_milestones").select("*").eq("assigned_to", user.id),
      ]);
      setEvents(ev||[]); setTasks(tk||[]); setSatisfaction(sat||[]); setDebriefs(db||[]); setMilestones(ms||[]);
      setLoading(false);
    };
    load();
  }, []);

  const myEvents = events.filter(e => e.assigned_to === user.id || (Array.isArray(e.assigned_to_ids) && e.assigned_to_ids.includes(user.id)));
  const completedTasks = tasks.filter(t => t.status === "completed");
  const pendingTasks = tasks.filter(t => t.status !== "completed");
  const overdueTasks = pendingTasks.filter(t => t.deadline && new Date(t.deadline) < new Date());
  const completionRate = tasks.length > 0 ? Math.round((completedTasks.length/tasks.length)*100) : 0;
  const avgSat = satisfaction.length > 0 ? (satisfaction.reduce((s,r)=>s+(r.rating||0),0)/satisfaction.length).toFixed(1) : null;
  const debriefRate = myEvents.length > 0 ? Math.round((debriefs.length/myEvents.length)*100) : 0;
  const milestonesCompleted = milestones.filter(m=>m.status==="completed").length;

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Performance</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>My Performance</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Your event impact and productivity metrics</div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:12, marginBottom:24 }}>
        {[
          { label:"Events Assigned", value:myEvents.length, color:T.cyan },
          { label:"Tasks Completed", value:completedTasks.length+"/"+tasks.length, color:T.teal },
          { label:"Completion Rate", value:completionRate+"%", color:completionRate>=80?T.teal:completionRate>=50?T.amber:T.red },
          { label:"Overdue Tasks", value:overdueTasks.length, color:overdueTasks.length>0?T.red:T.teal },
          { label:"Client Satisfaction", value:avgSat?avgSat+"/5":"—", color:avgSat&&parseFloat(avgSat)>=4?T.teal:T.amber },
          { label:"Debriefs Submitted", value:debriefs.length+"/"+myEvents.length, color:debriefRate>=80?T.teal:T.amber },
          { label:"Milestones Done", value:milestonesCompleted+"/"+milestones.length, color:T.magenta },
        ].map(k => (
          <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:`1px solid ${T.border}`, borderTop:`2px solid ${k.color}`, borderRadius:10 }}>
            <div style={{ color:k.color, fontSize:20, fontWeight:900 }}>{k.value}</div>
            <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Task completion progress */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"20px 24px", marginBottom:20 }}>
        <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15, marginBottom:16 }}>Task Completion Progress</div>
        <div style={{ height:12, background:T.border, borderRadius:6, overflow:"hidden", marginBottom:8 }}>
          <div style={{ height:"100%", width:completionRate+"%", background:`linear-gradient(90deg,${completionRate>=80?T.teal:completionRate>=50?T.amber:T.red},${T.cyan})`, borderRadius:6, transition:"width 0.5s" }} />
        </div>
        <div style={{ display:"flex", justifyContent:"space-between", color:T.textMuted, fontSize:11 }}>
          <span>{completedTasks.length} completed</span>
          <span style={{ color:completionRate>=80?T.teal:T.amber, fontWeight:700 }}>{completionRate}%</span>
          <span>{pendingTasks.length} pending</span>
        </div>
      </div>

      {/* My Events */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
        <div style={{ padding:"14px 18px", borderBottom:`1px solid ${T.border}`, color:T.textPrimary, fontWeight:800, fontSize:14 }}>My Events</div>
        {myEvents.length === 0 ? (
          <div style={{ padding:"40px 0", textAlign:"center", color:T.textMuted }}>No events assigned</div>
        ) : myEvents.map((ev, i) => {
          const evTasks = tasks.filter(t => t.project_id === ev.id);
          const evCompleted = evTasks.filter(t => t.status==="completed");
          const hasDebrief = debriefs.some(d => d.project_id === ev.id);
          const evSat = satisfaction.filter(s => s.project_id === ev.id);
          const evAvgSat = evSat.length > 0 ? (evSat.reduce((s,r)=>s+(r.rating||0),0)/evSat.length).toFixed(1) : null;
          return (
            <div key={ev.id} style={{ padding:"14px 18px", borderBottom:i<myEvents.length-1?`1px solid ${T.border}44`:"none", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div>
                <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{ev.name}</div>
                <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{ev.event_date?new Date(ev.event_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}):"TBC"} · {ev.phase||"Planning"}</div>
              </div>
              <div style={{ display:"flex", gap:16, alignItems:"center" }}>
                <div style={{ textAlign:"center" }}><div style={{ color:T.cyan, fontWeight:700, fontSize:13 }}>{evCompleted.length}/{evTasks.length}</div><div style={{ color:T.textMuted, fontSize:9, textTransform:"uppercase" }}>Tasks</div></div>
                <div style={{ textAlign:"center" }}><div style={{ color:hasDebrief?T.teal:T.amber, fontWeight:700, fontSize:13 }}>{hasDebrief?"":"—"}</div><div style={{ color:T.textMuted, fontSize:9, textTransform:"uppercase" }}>Debrief</div></div>
                {evAvgSat && <div style={{ textAlign:"center" }}><div style={{ color:T.teal, fontWeight:700, fontSize:13 }}>{evAvgSat}/5</div><div style={{ color:T.textMuted, fontSize:9, textTransform:"uppercase" }}>Sat.</div></div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const OutreachPlannerView = ({ user }) => {
  const [activities, setActivities] = useState([]);
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ opportunity_id:"", company:"", type:"call", content:"", scheduled_date:"", scheduled_time:"" });
  const [weekOffset, setWeekOffset] = useState(0);

  const TYPES = ["call","meeting","email","demo","follow-up","proposal"];
  const typeColors = { call:T.cyan, meeting:T.teal, email:T.amber, demo:"#8B5CF6", "follow-up":"#F97316", proposal:T.magenta };

  useEffect(() => {
    const load = async () => {
      const [{ data: act }, { data: opp }] = await Promise.all([
        supabase.from("opportunity_activities").select("*").eq("created_by", user.id).order("scheduled_date", { ascending: true }),
        supabase.from("opportunities").select("*").or(`assigned_to.eq.${user.id},created_by.eq.${user.id}`).order("company"),
      ]);
      setActivities(act||[]); setOpportunities(opp||[]);
      setLoading(false);
    };
    load();
  }, []);

  // Get week dates
  const now = new Date();
  const weekStart = new Date(now);
  weekStart.setDate(now.getDate() - now.getDay() + 1 + weekOffset * 7);
  const weekDays = Array.from({length:7}, (_,i) => { const d = new Date(weekStart); d.setDate(weekStart.getDate()+i); return d; });
  const weekLabel = `${weekDays[0].toLocaleDateString("en-GB",{day:"numeric",month:"short"})} – ${weekDays[6].toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}`;

  const getActivitiesForDay = (date) => {
    const dateStr = date.toISOString().slice(0,10);
    return activities.filter(a => a.scheduled_date === dateStr);
  };

  const scheduledThisWeek = activities.filter(a => {
    if (!a.scheduled_date) return false;
    const d = new Date(a.scheduled_date);
    return d >= weekDays[0] && d <= weekDays[6];
  });

  if (loading) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"40vh" }}><div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.cyan}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} /></div>;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
        <div>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>S&M</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Outreach Planner</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{scheduledThisWeek.length} activities this week</div>
        </div>
        <button onClick={() => setModal(true)} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Schedule Activity</button>
      </div>

      {/* Week navigator */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
        <button onClick={()=>setWeekOffset(w=>w-1)} style={{ background:T.surface, border:`1px solid ${T.border}`, color:T.textMuted, padding:"6px 14px", borderRadius:7, cursor:"pointer", fontSize:12 }}>← Prev</button>
        <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>{weekLabel}</div>
        <button onClick={()=>setWeekOffset(w=>w+1)} style={{ background:T.surface, border:`1px solid ${T.border}`, color:T.textMuted, padding:"6px 14px", borderRadius:7, cursor:"pointer", fontSize:12 }}>Next →</button>
      </div>

      {/* Week grid */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:8, marginBottom:24 }}>
        {weekDays.map((day, i) => {
          const dayActivities = getActivitiesForDay(day);
          const isToday = day.toDateString() === new Date().toDateString();
          const isPast = day < new Date() && !isToday;
          return (
            <div key={i} style={{ background:T.surface, border:`1px solid ${isToday?T.cyan:T.border}`, borderRadius:10, padding:"10px 8px", minHeight:100 }}>
              <div style={{ color:isToday?T.cyan:isPast?T.textMuted:T.textPrimary, fontWeight:isToday?800:600, fontSize:11, marginBottom:6, textAlign:"center" }}>
                <div>{["Mon","Tue","Wed","Thu","Fri","Sat","Sun"][i]}</div>
                <div style={{ fontSize:16, fontWeight:900 }}>{day.getDate()}</div>
              </div>
              {dayActivities.map(a => (
                <div key={a.id} style={{ background:(typeColors[a.type]||T.cyan)+"20", borderRadius:4, padding:"3px 6px", marginBottom:3, fontSize:10, fontWeight:700, color:typeColors[a.type]||T.cyan, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                  {a.scheduled_time?.slice(0,5)} {a.content?.slice(0,15)}
                </div>
              ))}
            </div>
          );
        })}
      </div>

      {/* Activity list */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, overflow:"hidden" }}>
        <div style={{ padding:"14px 18px", borderBottom:`1px solid ${T.border}`, color:T.textPrimary, fontWeight:800, fontSize:14 }}>All Scheduled Activities</div>
        {activities.filter(a=>a.scheduled_date).sort((a,b)=>new Date(a.scheduled_date)-new Date(b.scheduled_date)).map((a,i,arr) => {
          const color = typeColors[a.type] || T.cyan;
          const opp = opportunities.find(o => o.id === a.opportunity_id);
          return (
            <div key={a.id} style={{ padding:"12px 18px", borderBottom:i<arr.length-1?`1px solid ${T.border}44`:"none", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div style={{ display:"flex", gap:12, alignItems:"center" }}>
                <div style={{ width:36, height:36, borderRadius:8, background:color+"18", display:"flex", alignItems:"center", justifyContent:"center", color:color, fontSize:11, fontWeight:800, textTransform:"capitalize", flexShrink:0 }}>{a.type?.slice(0,3)}</div>
                <div>
                  <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{opp?.company||"—"}</div>
                  <div style={{ color:T.textMuted, fontSize:12 }}>{a.content}</div>
                </div>
              </div>
              <div style={{ textAlign:"right", flexShrink:0, marginLeft:12 }}>
                <div style={{ color:T.textPrimary, fontWeight:700, fontSize:12 }}>{a.scheduled_date?new Date(a.scheduled_date).toLocaleDateString("en-GB",{day:"numeric",month:"short"}):"—"}</div>
                {a.scheduled_time && <div style={{ color:T.textMuted, fontSize:11 }}>{a.scheduled_time?.slice(0,5)}</div>}
                <span style={{ background:color+"18", color:color, padding:"1px 8px", borderRadius:20, fontSize:9, fontWeight:700, textTransform:"capitalize" }}>{a.type}</span>
              </div>
            </div>
          );
        })}
        {activities.filter(a=>a.scheduled_date).length===0 && <div style={{ padding:"40px 0", textAlign:"center", color:T.textMuted }}>No scheduled activities yet</div>}
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={()=>setModal(false)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:460, padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:20 }}>Schedule Activity</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Opportunity</label>
              <select value={form.opportunity_id} onChange={e=>{ const o=opportunities.find(x=>x.id===e.target.value); setForm(f=>({...f,opportunity_id:e.target.value,company:o?.company||""})); }} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                <option value="">Select opportunity...</option>{opportunities.map(o=><option key={o.id} value={o.id}>{o.company}</option>)}
              </select></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Type</label>
                <select value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }}>
                  {TYPES.map(t=><option key={t}>{t}</option>)}
                </select></div>
                <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Date</label>
                <input type="date" value={form.scheduled_date} onChange={e=>setForm(f=>({...f,scheduled_date:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              </div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Time</label>
              <input type="time" value={form.scheduled_time} onChange={e=>setForm(f=>({...f,scheduled_time:e.target.value}))} style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }} /></div>
              <div><label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>Notes</label>
              <textarea value={form.content} onChange={e=>setForm(f=>({...f,content:e.target.value}))} rows={2} placeholder="What will you discuss?" style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} /></div>
            </div>
            <div style={{ display:"flex", gap:10, marginTop:20 }}>
              <button onClick={async()=>{ if(!form.opportunity_id&&!form.company){alert("Select an opportunity.");return;} setSaving(true); await supabase.from("opportunity_activities").insert({...form,created_by:user.id,created_by_name:user.name}); setSaving(false); setModal(false); setForm({opportunity_id:"",company:"",type:"call",content:"",scheduled_date:"",scheduled_time:""}); const{data}=await supabase.from("opportunity_activities").select("*").eq("created_by",user.id).order("scheduled_date",{ascending:true}); setActivities(data||[]); }} disabled={saving} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Schedule"}</button>
              <button onClick={()=>setModal(false)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const BudgetVsActualsView = ({ user, activeCountry = "All" }) => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [budgets, setBudgets] = useState([]);
  const [pos, setPos] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    supabase.from("projects").select("*").not("event_category","is",null).order("event_date",{ascending:false}).then(({data}) => setEvents(data||[]));
  }, []);

  const loadEvent = async (eventId) => {
    setLoading(true);
    const [b, p, inv, v, aw] = await Promise.all([
      supabase.from("rff_budgets").select("*,rffs(id,title,project_id)").eq("rffs.project_id", eventId),
      supabase.from("purchase_orders").select("*").eq("event_id", eventId),
      supabase.from("vendor_invoices").select("*").eq("event_id", eventId),
      supabase.from("payment_vouchers").select("*").eq("project_id", eventId),
      supabase.from("rff_awards").select("*,rffs(project_id)").eq("rffs.project_id", eventId),
    ]);
    // Also get budgets directly from rffs linked to this project
    const { data: rffs } = await supabase.from("rffs").select("id").eq("project_id", eventId);
    const rffIds = (rffs||[]).map(r => r.id);
    let allBudgets = [];
    if (rffIds.length > 0) {
      const { data: bd } = await supabase.from("rff_budgets").select("*").in("rff_id", rffIds);
      allBudgets = bd || [];
    }
    setBudgets(allBudgets);
    setPos(p.data||[]);
    setInvoices(inv.data||[]);
    setVouchers(v.data||[]);
    setAwards(aw.data||[]);
    setLoading(false);
  };

  const totalBudget = budgets.reduce((s,b) => s + (parseFloat(b.proposed_amount)||0), 0);
  const totalCommitted = pos.reduce((s,p) => s + (parseFloat(p.amount)||0), 0);
  const totalInvoiced = invoices.reduce((s,i) => s + (parseFloat(i.amount)||0), 0);
  const totalPaid = invoices.filter(i=>i.status==="paid").reduce((s,i) => s + (parseFloat(i.amount)||0), 0);
  const totalVouchers = vouchers.reduce((s,v) => s + (parseFloat(v.amount)||0), 0);
  const variance = totalBudget - totalCommitted;
  const variancePct = totalBudget ? Math.round((variance/totalBudget)*100) : 0;

  // Group by category
  const categories = [...new Set(budgets.map(b => b.category))];

  const inputStyle = { width:"100%", padding:"9px 12px", background:T.bg, border:"1px solid "+T.border, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", appearance:"none", boxSizing:"border-box" };

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      <div style={{ marginBottom:24, paddingBottom:20, borderBottom:"1px solid "+T.border }}>
        <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Finance</div>
        <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Budget vs Actuals</h2>
        <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Per-event budget tracking — committed spend vs actual invoiced vs paid</div>
      </div>

      {/* Event selector */}
      <div style={{ marginBottom:20 }}>
        <select value={selectedEvent?.id||""} onChange={e => {
          const ev = events.find(ev => ev.id === e.target.value);
          setSelectedEvent(ev||null);
          if (ev) loadEvent(ev.id);
        }} style={inputStyle}>
          <option value="">Select an event...</option>
          {events.map(e => <option key={e.id} value={e.id}>{e.name} {e.event_date ? "· "+new Date(e.event_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : ""}</option>)}
        </select>
      </div>

      {loading && <div style={{ color:T.textMuted, textAlign:"center", padding:"40px 0" }}>Loading...</div>}

      {selectedEvent && !loading && (
        <>
          {/* KPI Strip */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))", gap:12, marginBottom:24 }}>
            {[
              { label:"Total Budget", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalBudget).toLocaleString(), color:T.cyan },
              { label:"Committed (POs)", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalCommitted).toLocaleString(), color:T.amber },
              { label:"Invoiced", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalInvoiced).toLocaleString(), color:T.magenta },
              { label:"Paid Out", value:getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalPaid).toLocaleString(), color:T.teal },
              { label:"Variance", value:(variance >= 0 ? "+" : "")+variance.toLocaleString(), color:variance >= 0 ? T.teal : T.red },
            ].map(k => (
              <div key={k.label} style={{ padding:"14px 16px", background:T.surface, border:"1px solid "+T.border, borderTop:"2px solid "+k.color, borderRadius:10 }}>
                <div style={{ color:k.color, fontSize:16, fontWeight:900 }}>{k.value}</div>
                <div style={{ color:T.textMuted, fontSize:10, fontWeight:600, marginTop:4, textTransform:"uppercase" }}>{k.label}</div>
              </div>
            ))}
          </div>

          {/* Budget utilisation bar */}
          {totalBudget > 0 && (
            <div style={{ background:T.surface, border:"1px solid "+T.border, borderRadius:12, padding:"18px 20px", marginBottom:20 }}>
              <div style={{ display:"flex", justifyContent:"space-between", marginBottom:8 }}>
                <span style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>Budget Utilisation</span>
                <span style={{ color:totalCommitted > totalBudget ? T.red : T.teal, fontWeight:800, fontSize:13 }}>{Math.round((totalCommitted/totalBudget)*100)}% committed</span>
              </div>
              <div style={{ height:10, background:T.border+"44", borderRadius:5, overflow:"hidden" }}>
                <div style={{ height:"100%", width:Math.min(100, Math.round((totalCommitted/totalBudget)*100))+"%", background:totalCommitted > totalBudget ? T.red : "linear-gradient(90deg,"+T.cyan+","+T.teal+")", borderRadius:5, transition:"width 0.6s ease" }} />
              </div>
              <div style={{ display:"flex", justifyContent:"space-between", marginTop:6, fontSize:11, color:T.textMuted }}>
                <span>GHS 0</span>
                <span>Budget: GHS {totalBudget.toLocaleString()}</span>
              </div>
            </div>
          )}

          {/* Category breakdown */}
          {categories.length > 0 ? (
            <div style={{ background:T.surface, border:"1px solid "+T.border, borderRadius:12, overflow:"hidden", marginBottom:20 }}>
              <div style={{ padding:"14px 20px", borderBottom:"1px solid "+T.border }}>
                <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14 }}>Category Breakdown</div>
              </div>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse", minWidth:700 }}>
                  <thead>
                    <tr style={{ background:T.bgDeep }}>
                      {["Category","Budgeted","Committed (PO)","Invoiced","Paid","Variance","Status"].map(h => (
                        <th key={h} style={{ padding:"10px 14px", textAlign:"left", color:T.textMuted, fontSize:10, fontWeight:800, textTransform:"uppercase", borderBottom:"1px solid "+T.border }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((cat, i) => {
                      const catBudget = budgets.filter(b=>b.category===cat).reduce((s,b)=>s+(parseFloat(b.proposed_amount)||0),0);
                      const catPOs = pos.filter(p => {
                        const award = awards.find(a => a.id === p.rff_award_id);
                        return award?.category === cat;
                      }).reduce((s,p)=>s+(parseFloat(p.amount)||0),0);
                      const catInvoiced = invoices.filter(inv => inv.category === cat).reduce((s,i)=>s+(parseFloat(i.amount)||0),0);
                      const catPaid = invoices.filter(inv => inv.category === cat && inv.status==="paid").reduce((s,i)=>s+(parseFloat(i.amount)||0),0);
                      const catVariance = catBudget - catPOs;
                      const pct = catBudget ? Math.round((catPOs/catBudget)*100) : 0;
                      const status = catPOs === 0 ? "unspent" : catPOs > catBudget ? "over" : pct > 80 ? "near-limit" : "on-track";
                      const statusColors = { unspent:T.textMuted, over:T.red, "near-limit":T.amber, "on-track":T.teal };
                      return (
                        <tr key={cat} style={{ borderBottom:i<categories.length-1?"1px solid "+T.border+"22":"none" }}>
                          <td style={{ padding:"12px 14px", color:T.textPrimary, fontWeight:700, fontSize:13 }}>{cat}</td>
                          <td style={{ padding:"12px 14px", color:T.textSecondary, fontSize:13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(catBudget.toLocaleString()).toLocaleString()}</td>
                          <td style={{ padding:"12px 14px", color:T.amber, fontSize:13, fontWeight:catPOs>0?700:400 }}>{catPOs > 0 ? getCurrency(activeCountry||user?.country||"Ghana")+" "+(catPOs).toLocaleString() : "—"}</td>
                          <td style={{ padding:"12px 14px", color:T.magenta, fontSize:13, fontWeight:catInvoiced>0?700:400 }}>{catInvoiced > 0 ? getCurrency(activeCountry||user?.country||"Ghana")+" "+(catInvoiced).toLocaleString() : "—"}</td>
                          <td style={{ padding:"12px 14px", color:T.teal, fontSize:13, fontWeight:catPaid>0?700:400 }}>{catPaid > 0 ? getCurrency(activeCountry||user?.country||"Ghana")+" "+(catPaid).toLocaleString() : "—"}</td>
                          <td style={{ padding:"12px 14px", color:catVariance>=0?T.teal:T.red, fontWeight:700, fontSize:13 }}>{catVariance>=0?"+":""}{catVariance.toLocaleString()}</td>
                          <td style={{ padding:"12px 14px" }}>
                            <span style={{ color:statusColors[status], fontSize:10, fontWeight:800, background:statusColors[status]+"15", padding:"2px 8px", borderRadius:20, textTransform:"uppercase" }}>{status}</span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr style={{ background:T.bgDeep, borderTop:"2px solid "+T.border }}>
                      <td style={{ padding:"12px 14px", color:T.textMuted, fontWeight:800, fontSize:12, textTransform:"uppercase" }}>Total</td>
                      <td style={{ padding:"12px 14px", color:T.cyan, fontWeight:900, fontSize:13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalBudget.toLocaleString()).toLocaleString()}</td>
                      <td style={{ padding:"12px 14px", color:T.amber, fontWeight:900, fontSize:13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalCommitted.toLocaleString()).toLocaleString()}</td>
                      <td style={{ padding:"12px 14px", color:T.magenta, fontWeight:900, fontSize:13 }}>{totalInvoiced>0?getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalInvoiced).toLocaleString():"—"}</td>
                      <td style={{ padding:"12px 14px", color:T.teal, fontWeight:900, fontSize:13 }}>{totalPaid>0?getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalPaid).toLocaleString():"—"}</td>
                      <td style={{ padding:"12px 14px", color:variance>=0?T.teal:T.red, fontWeight:900, fontSize:13 }}>{variance>=0?"+":""}{variance.toLocaleString()}</td>
                      <td />
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          ) : (
            <div style={{ textAlign:"center", padding:"40px", color:T.textMuted, background:T.surface, borderRadius:12, border:"1px solid "+T.border }}>No budget lines found for this event. Budget lines are created when RFFs are raised and approved.</div>
          )}

          {/* Vouchers */}
          {vouchers.length > 0 && (
            <div style={{ background:T.surface, border:"1px solid "+T.border, borderRadius:12, padding:"18px 20px" }}>
              <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14, marginBottom:12 }}>Payment Vouchers</div>
              {vouchers.map(v => (
                <div key={v.id} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom:"1px solid "+T.border+"22" }}>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:600, fontSize:13 }}>{v.voucher_number} — {v.payee}</div>
                    <div style={{ color:T.textMuted, fontSize:11 }}>{v.description}</div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ color:T.amber, fontWeight:700, fontSize:13 }}>{fmtMoney(v.amount||0, v.country||"Ghana")}</div>
                    <div style={{ color:v.status==="paid"?T.teal:T.amber, fontSize:10, fontWeight:700 }}>{v.status}</div>
                  </div>
                </div>
              ))}
              <div style={{ marginTop:10, padding:"10px 0", borderTop:"1px solid "+T.border, display:"flex", justifyContent:"space-between" }}>
                <span style={{ color:T.textMuted, fontSize:12, fontWeight:700 }}>Total Vouchers</span>
                <span style={{ color:T.amber, fontWeight:900, fontSize:14 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(totalVouchers.toLocaleString()).toLocaleString()}</span>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const ClientDashboard = ({ user }) => {
  const [events, setEvents] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [messages, setMessages] = useState([]);
  const [milestones, setMilestones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [clientId, setClientId] = useState(null);
  const [actionItems, setActionItems] = useState([]);
  const [satisfaction, setSatisfaction] = useState([]);
  const [reports, setReports] = useState([]);
  const [payments, setPayments] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [sendingMsg, setSendingMsg] = useState(false);
  const [activeSection, setActiveSection] = useState("overview");
  const [satisfactionModal, setSatisfactionModal] = useState(null);
  const [satForm, setSatForm] = useState({ rating:0, nps_score:null, feedback:"", milestone:"" });
  const [savingSat, setSavingSat] = useState(false);

  useEffect(() => {
     const load = async () => {
      setLoading(true);
      try {
        const { data: clientData } = await supabase.from("clients").select("id").eq("email", user?.email).single();
        if (!clientData) { setLoading(false); return; }
        setClientId(clientData.id);
        // Load events first to get IDs
        const { data: evData } = await supabase.from("projects").select("*").eq("client_id", clientData.id).order("event_date", { ascending: true });
        const eventIds = (evData||[]).map(e => e.id);
        setEvents(evData || []);
        // Load rest in parallel
        const [mg, ms, ai, sat, rp, pay] = await Promise.all([
          supabase.from("client_messages").select("*").eq("client_id", clientData.id).order("created_at", { ascending: false }),
          eventIds.length > 0 ? supabase.from("client_milestones").select("*").in("project_id", eventIds).order("created_at", { ascending: false }) : Promise.resolve({ data: [] }),
          supabase.from("client_action_items").select("*").eq("client_id", clientData.id).order("due_date", { ascending: true }),
          supabase.from("client_satisfaction").select("*").eq("client_id", clientData.id).order("submitted_at", { ascending: false }),
          supabase.from("event_intelligence_reports").select("*"),
          supabase.from("client_payments").select("*").eq("client_id", clientData.id).order("payment_date",{ascending:false}),
        ]);
        setMessages(mg.data || []);
        setMilestones(ms.data || []);
        setActionItems(ai.data || []);
        setSatisfaction(sat.data || []);
        setReports(rp.data || []);
        setPayments(pay.data || []);
        // Docs — only client-shared, scoped to their events
        if (eventIds.length > 0) {
          const { data: dcData } = await supabase.from("event_documents").select("*").in("project_id", eventIds).eq("shared_with_client", true).order("created_at", { ascending: false });
          setDocuments(dcData || []);
        }
      } catch(err) { console.error("Client load error:", err); }
      setLoading(false);
    };
    load();
  }, [user?.id]);

  const now = new Date();
  const greeting = now.getHours() < 12 ? "Good Morning" : now.getHours() < 17 ? "Good Afternoon" : "Good Evening";
  const upcomingEvents = events.filter(e => e.event_date && new Date(e.event_date) >= now);
  const unreadMessages = messages.filter(m => !m.read_by_client);

  if (loading) return <div style={{ padding: "60px 0", textAlign: "center", color: T.textMuted, fontSize: 13 }}>Loading...</div>;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>

      {/*  HERO  */}
      <div style={{ background: `linear-gradient(135deg, ${T.bgDeep} 0%, #0D1F36 60%, ${T.bgDeep} 100%)`, border: `1px solid ${T.border}`, borderRadius: 16, padding: "32px 36px", marginBottom: 24, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -60, right: -60, width: 240, height: 240, background: `radial-gradient(circle, ${T.cyan}08, transparent 70%)`, pointerEvents: "none" }} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 16 }}>
          <div>
            <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 6 }}>{now.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
            <h1 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 900, color: T.textPrimary, letterSpacing: "-0.03em" }}>{greeting}, {user.name.split(" ")[0]}.</h1>
            <div style={{ color: T.textMuted, fontSize: 14 }}>{upcomingEvents.length > 0 ? `${upcomingEvents.length} upcoming event${upcomingEvents.length!==1?"s":""}` : "No upcoming events"}{unreadMessages.length > 0 && <span style={{ color: T.cyan, fontWeight: 700 }}> · {unreadMessages.length} new message{unreadMessages.length!==1?"s":""}</span>}</div>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px,1fr))", gap: 12, marginTop: 24, paddingTop: 20, borderTop: `1px solid ${T.border}44` }}>
          {[
            { label: "My Events", value: events.length, color: T.cyan },
            { label: "Documents", value: documents.length, color: T.teal },
            { label: "Messages", value: messages.length, color: T.amber },
            { label: "Milestones", value: milestones.length, color: "#10B981" },
          ].map(k => (
            <div key={k.label} style={{ padding: "12px 14px", background: `${T.bg}80`, border: `1px solid ${T.border}44`, borderRadius: 10 }}>
              <div style={{ color: k.color, fontSize: 18, fontWeight: 900 }}>{k.value}</div>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 3 }}>{k.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/*  SECTION TABS  */}
      <div style={{ display:"flex", gap:4, marginBottom:20, borderBottom:`1px solid ${T.border}`, overflowX:"auto", msOverflowStyle:"none", scrollbarWidth:"none" }}>
        {[
          { id:"overview", label:"Overview" },
          { id:"event-progress", label:"Event Progress" },
          { id:"messages", label:`Messages${unreadMessages.length>0?" ("+unreadMessages.length+")":""}` },
          { id:"payments", label:"Invoices & Payments" },
          { id:"action-items", label:`Action Items${actionItems.filter(a=>a.status==="pending").length>0?" ("+actionItems.filter(a=>a.status==="pending").length+")":""}` },
          { id:"intelligence", label:"Event Intelligence" },
          { id:"satisfaction", label:"Satisfaction" },
        ].map(tab => (
          <button key={tab.id} onClick={() => setActiveSection(tab.id)} style={{ padding:"8px 16px", border:"none", background:"none", cursor:"pointer", color:activeSection===tab.id?T.cyan:T.textMuted, fontWeight:activeSection===tab.id?800:400, fontSize:13, borderBottom:activeSection===tab.id?`2px solid ${T.cyan}`:"2px solid transparent", marginBottom:-1, whiteSpace:"nowrap" }}>{tab.label}</button>
        ))}
      </div>

      {/*  OVERVIEW  */}
      {activeSection === "overview" && <>
      {/*  UPCOMING EVENTS  */}
      {upcomingEvents.length > 0 && (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "20px 22px", marginBottom: 20 }}>
          <div style={{ marginBottom: 16 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Your Events</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Upcoming Events</div>
          </div>
          {upcomingEvents.map(e => {
            const days = Math.ceil((new Date(e.event_date) - now) / 86400000);
            const color = days <= 7 ? T.red : days <= 30 ? T.amber : T.teal;
            const PHASES = ["Brief","Planning","Pre-Production","Production","Live","Post-Production","Completed"];
            const phaseIdx = PHASES.indexOf(e.phase||"Planning");
            return (
              <div key={e.id} style={{ display: "flex", gap: 14, padding: "14px 0", borderBottom: `1px solid ${T.border}33` }}>
                <div style={{ width: 48, height: 48, borderRadius: 10, background: `${color}15`, border: `1px solid ${color}30`, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <div style={{ color, fontSize: 16, fontWeight: 900, lineHeight: 1 }}>{days}</div>
                  <div style={{ color, fontSize: 8, textTransform: "uppercase", fontWeight: 700 }}>days</div>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14 }}>{e.name}</div>
                  <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>{new Date(e.event_date).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
                  <div style={{ display: "flex", gap: 3, marginTop: 8 }}>
                    {PHASES.map((ph,i) => <div key={ph} style={{ flex: 1, height: 4, borderRadius: 2, background: i <= phaseIdx ? (i === phaseIdx ? T.cyan : T.teal+"80") : T.border+"44" }} />)}
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
                    <span style={{ color: T.textMuted, fontSize: 9 }}>Brief</span>
                    <span style={{ color: T.cyan, fontSize: 10, fontWeight: 700 }}>{e.phase||"Planning"}</span>
                    <span style={{ color: T.textMuted, fontSize: 9 }}>Completed</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/*  TWO COLUMN  */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>

        {/* Recent Documents */}
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Shared Files</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Documents</div>
          </div>
          {documents.slice(0,5).map(d => (
            <div key={d.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: `1px solid ${T.border}33` }}>
              <div>
                <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{d.title}</div>
                <div style={{ color: T.textMuted, fontSize: 11 }}>{d.document_type}</div>
              </div>
              {d.document_url && <a href={d.document_url} target="_blank" rel="noreferrer" style={{ color: T.cyan, fontSize: 11, fontWeight: 700, textDecoration: "none" }}>View →</a>}
            </div>
          ))}
          {documents.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "16px 0" }}>No documents shared yet</div>}
        </div>

        {/* Recent Messages */}
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Communications</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Messages</div>
          </div>
          {messages.slice(0,5).map(m => (
            <div key={m.id} style={{ padding: "8px 0", borderBottom: `1px solid ${T.border}33` }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                <span style={{ color: T.cyan, fontSize: 11, fontWeight: 700 }}>{m.sender_name || "Stretchfield"}</span>
                <span style={{ color: T.textMuted, fontSize: 10 }}>{new Date(m.created_at).toLocaleDateString("en-GB")}</span>
              </div>
              <div style={{ color: T.textSecondary, fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{m.message}</div>
            </div>
          ))}
          {messages.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "16px 0" }}>No messages yet</div>}
        </div>
      </div>
      </> }

      {/* EVENT PROGRESS SUMMARY IN OVERVIEW */}
      {activeSection === "overview" && events.length > 0 && (
        <div style={{ marginBottom:20 }}>
          {events.map(ev => {
            const evMs = milestones.filter(m => m.project_id === ev.id);
            const priorityWeight = { Critical:4, High:3, Medium:2, Low:1 };
            const statusPct = { pending:0, "in-progress":50, completed:100 };
            const totalW = evMs.reduce((s,m) => s+(priorityWeight[m.priority||"Medium"]||2), 0);
            const earnedW = evMs.reduce((s,m) => s+(priorityWeight[m.priority||"Medium"]||2)*((statusPct[m.status]||0)/100), 0);
            const progress = totalW > 0 ? Math.round((earnedW/totalW)*100) : 0;
            const completed = evMs.filter(m => m.status==="completed").length;
            return (
              <div key={ev.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"16px 20px", marginBottom:12 }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:800, fontSize:14 }}>{ev.name}</div>
                    <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>{completed}/{evMs.length} milestones complete</div>
                  </div>
                  <div style={{ color:T.cyan, fontWeight:900, fontSize:24 }}>{progress}%</div>
                </div>
                <div style={{ height:6, background:T.border+"44", borderRadius:3 }}>
                  <div style={{ height:"100%", width:progress+"%", background:`linear-gradient(90deg,${T.cyan},${T.teal})`, borderRadius:3, transition:"width 0.4s ease" }} />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/*  ACTION ITEMS  */}
      {/* EVENT PROGRESS */}
      {activeSection === "event-progress" && (
        <div>
          {events.length === 0 ? (
            <div style={{ textAlign:"center", padding:60, color:T.textMuted }}>No events yet.</div>
          ) : events.map(ev => {
            const evMilestones = milestones.filter(m => m.project_id === ev.id);
            const priorityWeight = { Critical:4, High:3, Medium:2, Low:1 };
            const statusPct = { pending:0, "in-progress":50, completed:100 };
            const totalWeight = evMilestones.reduce((s,m) => s+(priorityWeight[m.priority||"Medium"]||2), 0);
            const earnedWeight = evMilestones.reduce((s,m) => s+(priorityWeight[m.priority||"Medium"]||2)*((statusPct[m.status]||0)/100), 0);
            const progress = totalWeight > 0 ? Math.round((earnedWeight/totalWeight)*100) : 0;
            const completed = evMilestones.filter(m => m.status==="completed").length;
            return (
              <div key={ev.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:24, marginBottom:16 }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16 }}>{ev.name}</div>
                    <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{ev.event_date ? new Date(ev.event_date+"T12:00:00").toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"}) : "Date TBC"}</div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ color:T.cyan, fontWeight:900, fontSize:28 }}>{progress}%</div>
                    <div style={{ color:T.textMuted, fontSize:11 }}>{completed}/{evMilestones.length} milestones</div>
                  </div>
                </div>
                <div style={{ height:8, background:T.border+"44", borderRadius:4, marginBottom:20 }}>
                  <div style={{ height:"100%", width:progress+"%", background:`linear-gradient(90deg,${T.cyan},${T.teal})`, borderRadius:4, transition:"width 0.4s ease" }} />
                </div>
                {evMilestones.length === 0 ? (
                  <div style={{ color:T.textMuted, fontSize:13, textAlign:"center", padding:"20px 0" }}>No milestones added yet.</div>
                ) : evMilestones.map(m => {
                  const pw = priorityWeight[m.priority||"Medium"]||2;
                  const sc = m.status==="completed"?"#10B981":m.status==="in-progress"?T.amber:T.textMuted;
                  const pl = m.priority||"Medium";
                  const plColor = pl==="Critical"?T.red:pl==="High"?T.amber:pl==="Medium"?T.cyan:"#10B981";
                  return (
                    <div key={m.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 14px", background:T.bg, borderRadius:8, marginBottom:6, borderLeft:`3px solid ${sc}` }}>
                      <div style={{ flex:1 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <div style={{ color:T.textPrimary, fontWeight:700, fontSize:13 }}>{m.title}</div>
                          <span style={{ background:plColor+"20", color:plColor, borderRadius:20, padding:"1px 8px", fontSize:9, fontWeight:800 }}>{pl}</span>
                        </div>
                        {m.due_date && <div style={{ color:T.textMuted, fontSize:11, marginTop:2 }}>Due {new Date(m.due_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</div>}
                        {m.description && <div style={{ color:T.textMuted, fontSize:11, marginTop:2, fontStyle:"italic" }}>{m.description}</div>}
                      </div>
                      <span style={{ background:sc+"18", color:sc, border:`1px solid ${sc}30`, borderRadius:20, padding:"3px 12px", fontSize:10, fontWeight:800, textTransform:"uppercase", marginLeft:12, whiteSpace:"nowrap" }}>{m.status||"pending"}</span>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}

      {/* MESSAGES */}
      {activeSection === "messages" && (
        <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:24 }}>
          <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16, marginBottom:16 }}>Messages</div>
          <div style={{ maxHeight:400, overflowY:"auto", marginBottom:16, display:"flex", flexDirection:"column", gap:10 }}>
            {messages.length === 0 ? (
              <div style={{ color:T.textMuted, fontSize:13, textAlign:"center", padding:"30px 0" }}>No messages yet.</div>
            ) : messages.slice().reverse().map(m => {
              const isMe = m.sender_id === user?.id;
              return (
                <div key={m.id} style={{ display:"flex", flexDirection:"column", alignItems:isMe?"flex-end":"flex-start" }}>
                  <div style={{ background:isMe?T.cyan+"18":T.bg, border:`1px solid ${isMe?T.cyan+"30":T.border}`, borderRadius:10, padding:"10px 14px", maxWidth:"75%" }}>
                    <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:4 }}>
                      <span style={{ color:isMe?T.cyan:T.teal, fontSize:11, fontWeight:700 }}>{m.sender_name}</span>
                      <span style={{ color:T.textMuted, fontSize:10 }}>{new Date(m.created_at).toLocaleDateString("en-GB",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})}</span>
                    </div>
                    <div style={{ color:T.textPrimary, fontSize:13 }}>{m.message}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ display:"flex", gap:10 }}>
            <input value={newMessage} onChange={e=>setNewMessage(e.target.value)}
              onKeyDown={async e => {
                if (e.key==="Enter" && newMessage.trim()) {
                  setSendingMsg(true);
                  const eventId = events[0]?.id;
                  await supabase.from("client_messages").insert({ project_id:eventId, client_id:clientId, sender_id:user?.id, sender_name:user?.name, sender_role:"Client", message:newMessage.trim(), read_by_team:false, read_by_client:true });
                  setNewMessage("");
                  const { data } = await supabase.from("client_messages").select("*").eq("client_id",clientId).order("created_at",{ascending:false});
                  setMessages(data||[]);
                  setSendingMsg(false);
                }
              }}
              placeholder="Type a message... (Enter to send)"
              style={{ flex:1, padding:"10px 14px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none" }} />
            <button onClick={async () => {
              if (!newMessage.trim()) return;
              setSendingMsg(true);
              const eventId = events[0]?.id;
              await supabase.from("client_messages").insert({ project_id:eventId, client_id:clientId, sender_id:user?.id, sender_name:user?.name, sender_role:"Client", message:newMessage.trim(), read_by_team:false, read_by_client:true });
              setNewMessage("");
              const { data } = await supabase.from("client_messages").select("*").eq("client_id",clientId).order("created_at",{ascending:false});
              setMessages(data||[]);
              setSendingMsg(false);
            }} disabled={sendingMsg||!newMessage.trim()} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#fff", padding:"10px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{sendingMsg?"...":"Send"}</button>
          </div>
        </div>
      )}

      {/* INVOICES & PAYMENTS */}
      {activeSection === "payments" && (
        <div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))", gap:12, marginBottom:20 }}>
            {[
              { label:"Total Paid", value:(user?.country==="Nigeria"?"NGN":"GHS")+" "+payments.reduce((s,p)=>s+parseFloat(p.amount||0),0).toLocaleString(), color:"#10B981" },
              { label:"Last Payment", value:payments[0] ? new Date(payments[0].payment_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : "—", color:T.cyan },
              { label:"Transactions", value:payments.length, color:T.teal },
            ].map(k => (
              <div key={k.label} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"16px 18px" }}>
                <div style={{ color:k.color, fontWeight:900, fontSize:18 }}>{k.value}</div>
                <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginTop:4 }}>{k.label}</div>
              </div>
            ))}
          </div>
          <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:20 }}>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15, marginBottom:14 }}>Payment History</div>
            {payments.length === 0 ? (
              <div style={{ color:T.textMuted, fontSize:13, textAlign:"center", padding:"30px 0" }}>No payments recorded yet.</div>
            ) : (
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead>
                  <tr style={{ borderBottom:`1px solid ${T.border}` }}>
                    {["Event","Amount","Date","Method","Reference"].map(h => (
                      <th key={h} style={{ padding:"8px 12px", textAlign:"left", color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {payments.map(pay => (
                    <tr key={pay.id} style={{ borderBottom:`1px solid ${T.border}44` }}>
                      <td style={{ padding:"10px 12px", color:T.textPrimary, fontSize:13 }}>{pay.event_name||"—"}</td>
                      <td style={{ padding:"10px 12px", color:"#10B981", fontWeight:700, fontSize:13 }}>{(user?.country==="Nigeria"?"NGN":"GHS")+" "+parseFloat(pay.amount||0).toLocaleString()}</td>
                      <td style={{ padding:"10px 12px", color:T.textMuted, fontSize:12 }}>{pay.payment_date ? new Date(pay.payment_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : "—"}</td>
                      <td style={{ padding:"10px 12px", color:T.textMuted, fontSize:12 }}>{pay.payment_method||"—"}</td>
                      <td style={{ padding:"10px 12px", color:T.textMuted, fontSize:12 }}>{pay.reference_number||"—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {activeSection === "action-items" && (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
            <div>
              <div style={{ color:T.textPrimary, fontWeight:800, fontSize:18 }}>Action Items</div>
              <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>Things Stretchfield needs from you to keep your event on track</div>
            </div>
          </div>
          {actionItems.length === 0 ? (
            <div style={{ textAlign:"center", padding:"60px 0", background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}>
              <div style={{ fontSize:40, marginBottom:12 }}></div>
              <div style={{ color:T.textPrimary, fontWeight:700, fontSize:16 }}>No action items</div>
              <div style={{ color:T.textMuted, fontSize:13, marginTop:6 }}>You're all caught up — Stretchfield has everything needed.</div>
            </div>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {actionItems.map(item => {
                const isOverdue = item.due_date && new Date(item.due_date) < new Date() && item.status === "pending";
                const statusColor = item.status==="completed" ? T.teal : isOverdue ? T.red : T.amber;
                return (
                  <div key={item.id} style={{ background:T.surface, border:`1px solid ${isOverdue?T.red+"40":item.status==="completed"?T.teal+"30":T.amber+"30"}`, borderLeft:`3px solid ${statusColor}`, borderRadius:12, padding:"16px 20px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                      <div style={{ flex:1 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                          <div style={{ color:T.textPrimary, fontWeight:700, fontSize:14 }}>{item.title}</div>
                          <span style={{ background:statusColor+"18", color:statusColor, padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:700, textTransform:"uppercase" }}>{item.status==="completed"?"Done":isOverdue?"Overdue":"Pending"}</span>
                        </div>
                        {item.description && <div style={{ color:T.textSecondary, fontSize:13, marginBottom:6 }}>{item.description}</div>}
                        {item.due_date && <div style={{ color:isOverdue?T.red:T.textMuted, fontSize:11, fontWeight:isOverdue?700:400 }}>Due: {new Date(item.due_date).toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"})}</div>}
                      </div>
                      {item.status === "pending" && (
                        <button onClick={async () => {
                          await supabase.from("client_action_items").update({ status:"completed", completed_at:new Date().toISOString() }).eq("id", item.id);
                          setActionItems(prev => prev.map(a => a.id===item.id ? {...a, status:"completed"} : a));
                        }} style={{ background:T.teal+"20", border:`1px solid ${T.teal}40`, color:T.teal, padding:"6px 14px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700, flexShrink:0, marginLeft:12 }}> Mark Done</button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/*  EVENT INTELLIGENCE  */}
      {activeSection === "intelligence" && (
        <div>
          <div style={{ marginBottom:20 }}>
            <div style={{ color:T.textPrimary, fontWeight:800, fontSize:18 }}>Event Intelligence Reports</div>
            <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>Strategic insights and post-event analysis from Stretchfield</div>
          </div>
          {events.length === 0 ? (
            <div style={{ textAlign:"center", padding:"60px 0", background:T.surface, borderRadius:12, border:`1px solid ${T.border}` }}>
              <div style={{ fontSize:40, marginBottom:12 }}></div>
              <div style={{ color:T.textPrimary, fontWeight:700 }}>No reports yet</div>
              <div style={{ color:T.textMuted, fontSize:13, marginTop:6 }}>Intelligence reports will appear here after your events.</div>
            </div>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              {events.map(ev => {
                const report = reports.find(r => r.project_id === ev.id);
                return (
                  <div key={ev.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"20px 24px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                      <div>
                        <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15 }}>{ev.name}</div>
                        <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{ev.event_date ? new Date(ev.event_date).toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"}) : "Date TBC"}</div>
                      </div>
                      <span style={{ background:report?.ai_summary?T.teal+"18":T.amber+"18", color:report?.ai_summary?T.teal:T.amber, padding:"3px 12px", borderRadius:20, fontSize:11, fontWeight:700 }}>{report?.ai_summary?"Report Ready":"Pending"}</span>
                    </div>
                    {report?.ai_summary ? (
                      <div>
                        <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:8 }}>Executive Summary</div>
                        <div style={{ color:T.textSecondary, fontSize:13, lineHeight:1.7, background:T.bg, borderRadius:10, padding:"14px 16px", maxHeight:200, overflowY:"auto" }}>{report.ai_summary.substring(0,800)}{report.ai_summary.length>800?"...":""}</div>
                        {report.ai_summary.length > 800 && (
                          <div style={{ color:T.textMuted, fontSize:12, marginTop:8, fontStyle:"italic" }}>Full report available upon request from your Stretchfield account manager.</div>
                        )}
                      </div>
                    ) : (
                      <div style={{ color:T.textMuted, fontSize:13, fontStyle:"italic" }}>Your post-event intelligence report is being prepared by the Stretchfield team.</div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/*  SATISFACTION  */}
      {activeSection === "satisfaction" && (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
            <div>
              <div style={{ color:T.textPrimary, fontWeight:800, fontSize:18 }}>Satisfaction Pulse</div>
              <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>Share your feedback at every milestone — it makes us better</div>
            </div>
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            {events.map(ev => {
              const eventSat = satisfaction.filter(s => s.project_id === ev.id);
              const avgRating = eventSat.length > 0 ? (eventSat.reduce((s,r)=>s+(r.rating||0),0)/eventSat.length).toFixed(1) : null;
              return (
                <div key={ev.id} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"20px 24px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
                    <div>
                      <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15 }}>{ev.name}</div>
                      <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{ev.event_date ? new Date(ev.event_date).toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"}) : "Date TBC"}</div>
                    </div>
                    {avgRating && <div style={{ textAlign:"center" }}><div style={{ color:T.teal, fontWeight:900, fontSize:24 }}>{avgRating}</div><div style={{ color:T.textMuted, fontSize:10, textTransform:"uppercase" }}>Avg Rating</div></div>}
                  </div>
                  {/* Star ratings history */}
                  {eventSat.length > 0 && (
                    <div style={{ marginBottom:14 }}>
                      {eventSat.map(s => (
                        <div key={s.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:`1px solid ${T.border}33` }}>
                          <div>
                            <div style={{ color:T.textMuted, fontSize:11, fontWeight:700 }}>{s.milestone||"General Feedback"}</div>
                            {s.feedback && <div style={{ color:T.textSecondary, fontSize:12, marginTop:2 }}>{s.feedback}</div>}
                          </div>
                          <div style={{ display:"flex", gap:2 }}>{[1,2,3,4,5].map(n=><span key={n} style={{ fontSize:16, color:n<=s.rating?"#F59E0B":T.border }}></span>)}</div>
                        </div>
                      ))}
                    </div>
                  )}
                  <button onClick={() => { setSatisfactionModal(ev); setSatForm({ rating:0, nps_score:null, feedback:"", milestone:"" }); }} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"8px 20px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>+ Share Feedback</button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Satisfaction Modal */}
      {satisfactionModal && (
        <div style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={() => setSatisfactionModal(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:560, maxHeight:"90vh", overflowY:"auto", padding:28 }} onClick={e=>e.stopPropagation()}>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:18, marginBottom:4 }}>Share Your Feedback</div>
            <div style={{ color:T.textMuted, fontSize:13, marginBottom:20 }}>{satisfactionModal.name}</div>

            {/* Rate each milestone */}
            <div style={{ marginBottom:20 }}>
              <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:12 }}>Rate Each Stage</div>
              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                {["Briefing","Planning","Pre-Production","Event Day","Post-Event","Overall Experience"].map(milestone => (
                  <div key={milestone} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", background:T.bg, borderRadius:10, padding:"12px 16px" }}>
                    <div style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{milestone}</div>
                    <div style={{ display:"flex", gap:4 }}>
                      {[1,2,3,4,5].map(n => (
                        <button key={n} onClick={() => setSatForm(f=>({...f, [milestone]:n}))}
                          style={{ fontSize:24, background:"none", border:"none", cursor:"pointer", color:n<=(satForm[milestone]||0)?"#F59E0B":T.border, transition:"color 0.1s", padding:"0 2px" }}></button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* NPS */}
            <div style={{ marginBottom:16 }}>
              <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", marginBottom:8 }}>How likely are you to recommend Stretchfield? (0-10)</div>
              <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
                {[0,1,2,3,4,5,6,7,8,9,10].map(n => (
                  <button key={n} onClick={() => setSatForm(f=>({...f,nps_score:n}))} style={{ width:36, height:36, borderRadius:6, border:`1px solid ${satForm.nps_score===n?T.cyan:T.border}`, background:satForm.nps_score===n?T.cyan+"20":"none", color:satForm.nps_score===n?T.cyan:T.textMuted, cursor:"pointer", fontWeight:700, fontSize:13 }}>{n}</button>
                ))}
              </div>
            </div>

            {/* Comments */}
            <div style={{ marginBottom:20 }}>
              <div style={{ color:T.textMuted, fontSize:11, fontWeight:700, textTransform:"uppercase", marginBottom:6 }}>Additional Comments</div>
              <textarea value={satForm.feedback||""} onChange={e=>setSatForm(f=>({...f,feedback:e.target.value}))} rows={3} placeholder="Share any additional thoughts on Stretchfield's performance..."
                style={{ width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", resize:"none", boxSizing:"border-box" }} />
            </div>

            <div style={{ display:"flex", gap:10 }}>
              <button onClick={async () => {
                const milestones = ["Briefing","Planning","Pre-Production","Event Day","Post-Event","Overall Experience"];
                const hasRating = milestones.some(m => satForm[m]);
                if (!hasRating) { alert("Please rate at least one stage."); return; }
                setSavingSat(true);
                // Insert one record per rated milestone
                for (const m of milestones) {
                  if (satForm[m]) {
                    await supabase.from("client_satisfaction").insert({ client_id:clientId, project_id:satisfactionModal.id, rating:satForm[m], nps_score:satForm.nps_score||null, feedback:satForm.feedback||"", milestone:m, submitted_by:user.id });
                  }
                }
                const overallRating = satForm["Overall Experience"] || Math.round(milestones.filter(m=>satForm[m]).reduce((s,m)=>s+satForm[m],0)/milestones.filter(m=>satForm[m]).length);
                const { data: ceos } = await supabase.from("profiles").select("id").eq("role","CEO");
                for (const ceo of ceos||[]) { await supabase.from("notifications").insert({ user_id:ceo.id, title:"Client Feedback Submitted — "+satisfactionModal.name, message:user.name+" submitted milestone ratings. Overall: "+overallRating+"/5. NPS: "+(satForm.nps_score!==null?satForm.nps_score+"/10":"not rated")+(satForm.feedback?" — "+satForm.feedback:""), type:"crm" }); }
                const newEntries = milestones.filter(m=>satForm[m]).map(m=>({ project_id:satisfactionModal.id, rating:satForm[m], feedback:satForm.feedback||"", milestone:m }));
                setSatisfaction(prev => [...prev, ...newEntries]);
                setSavingSat(false);
                setSatisfactionModal(null);
              }} disabled={savingSat} style={{ flex:1, background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"11px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{savingSat?"Submitting...":"Submit Feedback"}</button>
              <button onClick={() => setSatisfactionModal(null)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"11px 16px", borderRadius:8, cursor:"pointer" }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

const BoardDashboard = ({ user }) => {
  const [events, setEvents] = useState([]);
  const [opportunities, setOpportunitys] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const [ev, op, inv] = await Promise.all([
        supabase.from("projects").select("*").order("event_date", { ascending: true }),
        (!activeCountry || activeCountry === "All") ? supabase.from("opportunities").select("*").order("created_at", { ascending: false }) : supabase.from("opportunities").select("*").eq("country", activeCountry).order("created_at", { ascending: false }),
        supabase.from("invoices").select("*").order("created_at", { ascending: false }),
      ]);
      setEvents(ev.data || []);
      setOpportunitys(op.data || []);
      setInvoices(inv.data || []);
      setLoading(false);
    };
    load();
  }, []);

  const now = new Date();
  const greeting = now.getHours() < 12 ? "Good Morning" : now.getHours() < 17 ? "Good Afternoon" : "Good Evening";
  const activeEvents = events.filter(e => !["Completed","Cancelled"].includes(e.phase||""));
  const wonOpps = opportunities.filter(o => o.status === "won");
  const revenueYTD = clientPayments.filter(p => p.payment_date && new Date(p.payment_date).getFullYear() === now.getFullYear()).reduce((s,p) => s+parseFloat(p.amount||0), 0);
  const totalClientRevenue = clientPayments.reduce((s,p) => s+parseFloat(p.amount||0), 0);
  const pipeline = opportunities.filter(o => !["won","lost"].includes(o.status));
  const pipelineValue = pipeline.reduce((s,o) => s+(o.value||0), 0);

  if (loading) return <div style={{ padding: "60px 0", textAlign: "center", color: T.textMuted, fontSize: 13 }}>Loading...</div>;

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>

      {/*  HERO  */}
      <div style={{ background: `linear-gradient(135deg, ${T.bgDeep} 0%, #0D1F36 60%, ${T.bgDeep} 100%)`, border: `1px solid ${T.border}`, borderRadius: 16, padding: "32px 36px", marginBottom: 24, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -60, right: -60, width: 240, height: 240, background: `radial-gradient(circle, ${T.amber}08, transparent 70%)`, pointerEvents: "none" }} />
        <div>
          <div style={{ color: T.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 6 }}>{now.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
          <h1 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 900, color: T.textPrimary, letterSpacing: "-0.03em" }}>{greeting}, {user.name.split(" ")[0]}.</h1>
          <div style={{ color: T.textMuted, fontSize: 14 }}>Board of Directors · Executive overview</div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px,1fr))", gap: 12, marginTop: 24, paddingTop: 20, borderTop: `1px solid ${T.border}44` }}>
          {[
            { label: "Active Events", value: activeEvents.length, color: T.cyan },
            { label: "Revenue YTD", value: "GHS "+Math.round(revenueYTD/1000)+"k", color: T.teal },
            { label: "Pipeline Value", value: "GHS "+Math.round(pipelineValue/1000)+"k", color: T.amber },
            { label: "Total Events", value: events.length, color: "#10B981" },
            { label: "Won Clients", value: wonOpps.length, color: T.amber },
          ].map(k => (
            <div key={k.label} style={{ padding: "12px 14px", background: `${T.bg}80`, border: `1px solid ${T.border}44`, borderRadius: 10 }}>
              <div style={{ color: k.color, fontSize: 18, fontWeight: 900 }}>{k.value}</div>
              <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 3 }}>{k.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/*  TWO COLUMN  */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>

        {/* Active Events */}
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Operations</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Active Events</div>
          </div>
          {activeEvents.slice(0,5).map(e => {
            const days = e.event_date ? Math.ceil((new Date(e.event_date) - now) / 86400000) : null;
            const color = days !== null ? (days <= 7 ? T.red : days <= 30 ? T.amber : T.teal) : T.teal;
            return (
              <div key={e.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${T.border}33` }}>
                <div>
                  <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{e.name}</div>
                  <div style={{ color: T.textMuted, fontSize: 11 }}>{e.client} · {e.phase||"Planning"}</div>
                </div>
                {days !== null && <span style={{ color, fontSize: 12, fontWeight: 700 }}>{days}d</span>}
              </div>
            );
          })}
          {activeEvents.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "16px 0" }}>No active events</div>}
        </div>

        {/* Pipeline */}
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textMuted, fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 3 }}>Business Development</div>
            <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 15 }}>Pipeline</div>
          </div>
          {pipeline.slice(0,5).map(o => (
            <div key={o.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${T.border}33` }}>
              <div>
                <div style={{ color: T.textPrimary, fontSize: 13, fontWeight: 600 }}>{o.company}</div>
                <div style={{ color: T.textMuted, fontSize: 11 }}>{o.stage}</div>
              </div>
              <span style={{ color: T.amber, fontSize: 12, fontWeight: 700 }}>{getCurrency(user?.country||"Ghana")+" "+((o.value||0).toLocaleString()).toLocaleString()}</span>
            </div>
          ))}
          {pipeline.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: "16px 0" }}>No active pipeline</div>}
        </div>
      </div>
    </div>
  );
};

const VendorAnalyticsView = ({ user, activeCountry = "All" }) => {
  const [vendors, setVendors] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [awards, setAwards] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [scorecards, setScorecards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("name");
  const [sortDir, setSortDir] = useState("asc");
  const [search, setSearch] = useState("");

  const load = async () => {
    setLoading(true);
    const [vp, asn, aw, inv, sc] = await Promise.all([
      (!activeCountry || activeCountry === "All")
        ? supabase.from("profiles").select("*").eq("role", "Vendor").order("name")
        : supabase.from("profiles").select("*").eq("role", "Vendor").or(`country.eq.${activeCountry},presence.like.%${activeCountry}%`).order("name"),
      supabase.from("rff_vendor_assignments").select("*"),
      supabase.from("rff_awards").select("*"),
      supabase.from("vendor_invoices").select("*"),
      supabase.from("vendor_scorecards").select("*").order("created_at", { ascending: false }),
    ]);
    setVendors(vp.data || []);
    setAssignments(asn.data || []);
    setAwards(aw.data || []);
    setInvoices(inv.data || []);
    setScorecards(sc.data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, [activeCountry]);

  const getVendorStats = (vendor) => {
    const vAssignments = assignments.filter(a => a.vendor_id === vendor.id);
    const vAwards = awards.filter(a => a.vendor_id === vendor.id);
    const vInvoices = invoices.filter(i => i.vendor_id === vendor.id);
    const vScorecards = scorecards.filter(s => s.vendor_id === vendor.id);
    const latestScore = vScorecards.length > 0 ? vScorecards[0] : null;
    const totalBusiness = vAwards.reduce((sum, a) => sum + (parseFloat(a.agreed_amount) || 0), 0);
    const paidAmount = vInvoices.filter(i => i.status === "paid").reduce((sum, i) => sum + (parseFloat(i.amount) || 0), 0);
    const pendingAmount = vInvoices.filter(i => i.status !== "paid").reduce((sum, i) => sum + (parseFloat(i.amount) || 0), 0);
    return {
      quotesSubmitted: vAssignments.filter(a => a.quote_amount).length,
      quotesApproved: vAssignments.filter(a => a.status === "quote-approved" || a.status === "invoice-submitted").length,
      jobsCompleted: vAwards.filter(a => a.status === "confirmed" || a.status === "po_created").length,
      totalBusiness,
      paidAmount,
      pendingAmount,
      rating: latestScore?.total_pct || 0,
      tier: latestScore ? getTier(latestScore.total_pct) : null,
      category: vendor.service_category || "—",
    };
  };

  const handleSort = (col) => {
    if (sortBy === col) setSortDir(d => d === "asc" ? "desc" : "asc");
    else { setSortBy(col); setSortDir("asc"); }
  };

  const filteredVendors = vendors.filter(v => 
    v.name?.toLowerCase().includes(search.toLowerCase()) ||
    v.service_category?.toLowerCase().includes(search.toLowerCase())
  );

  const sortedVendors = [...filteredVendors].sort((a, b) => {
    const sa = getVendorStats(a);
    const sb = getVendorStats(b);
    let av, bv;
    switch (sortBy) {
      case "name": av = a.name; bv = b.name; break;
      case "category": av = sa.category; bv = sb.category; break;
      case "rating": av = sa.rating; bv = sb.rating; break;
      case "jobs": av = sa.jobsCompleted; bv = sb.jobsCompleted; break;
      case "business": av = sa.totalBusiness; bv = sb.totalBusiness; break;
      case "pending": av = sa.pendingAmount; bv = sb.pendingAmount; break;
      default: av = a.name; bv = b.name;
    }
    if (typeof av === "string") return sortDir === "asc" ? av.localeCompare(bv) : bv.localeCompare(av);
    return sortDir === "asc" ? av - bv : bv - av;
  });

  const totals = sortedVendors.reduce((acc, v) => {
    const s = getVendorStats(v);
    acc.business += s.totalBusiness;
    acc.paid += s.paidAmount;
    acc.pending += s.pendingAmount;
    acc.jobs += s.jobsCompleted;
    return acc;
  }, { business: 0, paid: 0, pending: 0, jobs: 0 });

  const SortHeader = ({ col, label }) => (
    <th onClick={() => handleSort(col)} style={{ padding: "10px 14px", color: sortBy === col ? T.cyan : T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", textAlign: "left", cursor: "pointer", whiteSpace: "nowrap", borderBottom: `1px solid ${T.border}`, userSelect: "none" }}>
      {label} {sortBy === col ? (sortDir === "asc" ? "↑" : "↓") : ""}
    </th>
  );

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Procurement</div>
        <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800 }}>Vendor Analytics</h2>
        <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>Performance, business value and invoice summary for all vendors</div>
      </div>

      {/* Summary KPIs */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px,1fr))", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Total Vendors", value: vendors.length, color: T.cyan },
          { label: "Total Jobs", value: totals.jobs, color: T.teal },
          { label: "Total Business", value: getCurrency(activeCountry||user?.country||"Ghana")+" "+(totals.business).toLocaleString(), color: T.amber },
          { label: "Paid Out", value: getCurrency(activeCountry||user?.country||"Ghana")+" "+(totals.paid).toLocaleString(), color: T.teal },
          { label: "Pending Payment", value: getCurrency(activeCountry||user?.country||"Ghana")+" "+(totals.pending).toLocaleString(), color: totals.pending > 0 ? T.amber : T.textMuted },
        ].map((k, i) => (
          <div key={i} style={{ padding: "14px 16px", background: T.surface, border: `1px solid ${T.border}`, borderTop: `2px solid ${k.color}`, borderRadius: 10 }}>
            <div style={{ color: k.color, fontSize: 16, fontWeight: 900 }}>{k.value}</div>
            <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 600, marginTop: 4, textTransform: "uppercase" }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Search */}
      <div style={{ marginBottom: 16 }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search vendors by name or category..." style={{ width: "100%", padding: "10px 14px", background: T.surface, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
      </div>

      {/* Table */}
      {loading ? (
        <div style={{ color: T.textMuted, textAlign: "center", padding: 40 }}>Loading...</div>
      ) : (
        <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
              <thead style={{ background: T.bgDeep }}>
                <tr>
                  <SortHeader col="name" label="Vendor" />
                  <SortHeader col="category" label="Category" />
                  <SortHeader col="rating" label="Rating" />
                  <th style={{ padding: "10px 14px", color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", borderBottom: `1px solid ${T.border}`, textAlign: "center" }}>Quotes</th>
                  <SortHeader col="jobs" label="Jobs Done" />
                  <SortHeader col="business" label="Total Business" />
                  <SortHeader col="pending" label="Pending Invoice" />
                  <th style={{ padding: "10px 14px", color: T.textMuted, fontSize: 10, fontWeight: 800, textTransform: "uppercase", borderBottom: `1px solid ${T.border}`, textAlign: "center" }}>Paid Out</th>
                </tr>
              </thead>
              <tbody>
                {sortedVendors.map((v, idx) => {
                  const s = getVendorStats(v);
                  const tier = s.tier;
                  return (
                    <tr key={v.id} style={{ background: idx % 2 === 0 ? "transparent" : T.bgDeep+"44", borderBottom: `1px solid ${T.border}22` }}>
                      <td style={{ padding: "12px 14px" }}>
                        <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 13 }}>{v.name}</div>
                        <div style={{ color: T.textMuted, fontSize: 11 }}>{v.email}</div>
                      </td>
                      <td style={{ padding: "12px 14px", color: T.textMuted, fontSize: 12 }}>{s.category}</td>
                      <td style={{ padding: "12px 14px" }}>
                        {tier ? (
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <span style={{ color: tier.color, fontWeight: 800, fontSize: 13 }}>{s.rating}%</span>
                            <span style={{ color: tier.color, fontSize: 10, background: tier.color+"18", padding: "1px 6px", borderRadius: 20 }}>{tier.label}</span>
                          </div>
                        ) : <span style={{ color: T.textMuted, fontSize: 12 }}>Unrated</span>}
                      </td>
                      <td style={{ padding: "12px 14px", textAlign: "center" }}>
                        <span style={{ color: T.textPrimary, fontSize: 12 }}>{s.quotesSubmitted} submitted</span>
                        {s.quotesApproved > 0 && <span style={{ color: T.teal, fontSize: 11, display: "block" }}>{s.quotesApproved} approved</span>}
                      </td>
                      <td style={{ padding: "12px 14px", textAlign: "center" }}>
                        <span style={{ color: s.jobsCompleted > 0 ? T.teal : T.textMuted, fontWeight: s.jobsCompleted > 0 ? 700 : 400, fontSize: 13 }}>{s.jobsCompleted}</span>
                      </td>
                      <td style={{ padding: "12px 14px" }}>
                        <span style={{ color: s.totalBusiness > 0 ? T.amber : T.textMuted, fontWeight: 700, fontSize: 13 }}>{s.totalBusiness > 0 ? getCurrency(activeCountry||user?.country||"Ghana")+" "+(s.totalBusiness).toLocaleString() : "—"}</span>
                      </td>
                      <td style={{ padding: "12px 14px" }}>
                        <span style={{ color: s.pendingAmount > 0 ? T.amber : T.textMuted, fontWeight: s.pendingAmount > 0 ? 700 : 400, fontSize: 13 }}>{s.pendingAmount > 0 ? getCurrency(activeCountry||user?.country||"Ghana")+" "+(s.pendingAmount).toLocaleString() : "—"}</span>
                      </td>
                      <td style={{ padding: "12px 14px" }}>
                        <span style={{ color: s.paidAmount > 0 ? T.teal : T.textMuted, fontWeight: s.paidAmount > 0 ? 700 : 400, fontSize: 13 }}>{s.paidAmount > 0 ? getCurrency(activeCountry||user?.country||"Ghana")+" "+(s.paidAmount).toLocaleString() : "—"}</span>
                      </td>
                    </tr>
                  );
                })}
                {/* Totals row */}
                <tr style={{ background: T.bgDeep, borderTop: `2px solid ${T.border}` }}>
                  <td colSpan={4} style={{ padding: "12px 14px", color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Totals ({sortedVendors.length} vendors)</td>
                  <td style={{ padding: "12px 14px", textAlign: "center", color: T.teal, fontWeight: 800, fontSize: 13 }}>{totals.jobs}</td>
                  <td style={{ padding: "12px 14px", color: T.amber, fontWeight: 800, fontSize: 13 }}>{getCurrency(activeCountry||user?.country||"Ghana")+" "+(totals.business.toLocaleString()).toLocaleString()}</td>
                  <td style={{ padding: "12px 14px", color: T.amber, fontWeight: 800, fontSize: 13 }}>{totals.pending > 0 ? getCurrency(activeCountry||user?.country||"Ghana")+" "+(totals.pending).toLocaleString() : "—"}</td>
                  <td style={{ padding: "12px 14px", color: T.teal, fontWeight: 800, fontSize: 13 }}>{totals.paid > 0 ? getCurrency(activeCountry||user?.country||"Ghana")+" "+(totals.paid).toLocaleString() : "—"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};



const EventReportField = ({ label, field, rows=3, placeholder="", form, setForm }) => {
  const inputStyle = { width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" };
  const taStyle = { ...inputStyle, resize:"none" };
  return (
    <div style={{ marginBottom:14 }}>
      <label style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", display:"block", marginBottom:4 }}>{label}</label>
      {rows === 1
        ? <input value={form[field]||""} onChange={e=>setForm(f=>({...f,[field]:e.target.value}))} placeholder={placeholder} style={inputStyle} />
        : <textarea value={form[field]||""} onChange={e=>setForm(f=>({...f,[field]:e.target.value}))} rows={rows} placeholder={placeholder} style={taStyle} />}
    </div>
  );
};

const EventReportsView = ({ user, activeCountry = "All" }) => {
  const [events, setEvents] = useState([]);
  const [reports, setReports] = useState([]);
  const [scorecards, setScorecards] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [activeSection, setActiveSection] = useState("operational");
  const [report, setReport] = useState(null);
  const [saving, setSaving] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [form, setForm] = useState({
    run_of_show_adherence:"", high_impact_moments:"", low_impact_moments:"", logistics_notes:"",
    estimated_attendance:"", expected_attendance:"",
    audience_energy_arrival:"", audience_energy_mid:"", audience_energy_peak:"", audience_energy_close:"",
    key_engagement_moments:"", audience_feedback_observations:"",
    vendor_performance_summary:"", vendors_recommended:"", vendors_not_recommended:"", technical_delivery_quality:"",
    strategic_intent_achieved:"", client_satisfaction:"", business_development_signals:"", next_edition_recommendations:"",
  });

  const isStrategy = user?.role === "Strategy & Events Lead";
  const isVM = user?.role === "Vendor Manager";
  const isCEO = user?.role === "CEO";

  const load = async () => {
    const [{ data: ev }, { data: rp }, { data: sc }] = await Promise.all([
      (activeCountry && activeCountry !== "All") ? supabase.from("projects").select("*").eq("country",activeCountry).order("event_date",{ascending:false}) : supabase.from("projects").select("*").order("event_date",{ascending:false}),
      supabase.from("event_intelligence_reports").select("*"),
      supabase.from("vendor_scorecards").select("*").order("created_at", { ascending: false }),
    ]);
    // ESL only sees events assigned to them
    const allEvents = ev || [];
    const filteredEvents = isStrategy
      ? allEvents.filter(e => e.assigned_to === user.id || (Array.isArray(e.assigned_to_ids) && e.assigned_to_ids.includes(user.id)))
      : allEvents;
    setEvents(filteredEvents);
    setReports(rp || []);
    setScorecards(sc || []);
  };

  useEffect(() => { load(); }, []);

  const openEvent = async (event) => {
    setSelectedEvent(event);
    setForm({
      run_of_show_adherence:"", high_impact_moments:"", low_impact_moments:"", logistics_notes:"",
      estimated_attendance:"", expected_attendance:"",
      audience_energy_arrival:"", audience_energy_mid:"", audience_energy_peak:"", audience_energy_close:"",
      key_engagement_moments:"", audience_feedback_observations:"",
      vendor_performance_summary:"", vendors_recommended:"", vendors_not_recommended:"", technical_delivery_quality:"",
      strategic_intent_achieved:"", client_satisfaction:"", business_development_signals:"", next_edition_recommendations:"",
    });
    if (isStrategy) setActiveSection("operational");
    else if (isVM) setActiveSection("vendor");
    else setActiveSection("overview");

    // Load or create report
    const { data: existing } = await supabase.from("event_intelligence_reports").select("*").eq("project_id", event.id).maybeSingle();
    let reportData = existing;
    if (!existing) {
      const { data: created } = await supabase.from("event_intelligence_reports").insert({ project_id: event.id, status: "draft" }).select().single();
      reportData = created || { project_id: event.id, status: "draft" };
    }
    setReport(reportData);

    // Auto-populate vendor section from scorecard reports
    if (isVM || isCEO) {
      const { data: eventScorecards } = await supabase.from("vendor_scorecards").select("*").eq("project_id", event.id);
      if (eventScorecards && eventScorecards.length > 0) {
        const recommended = eventScorecards.filter(s => (s.total_pct||0) >= 70).map(s => s.vendor_name + " (" + s.total_pct + "%)").join(", ");
        const notRecommended = eventScorecards.filter(s => (s.total_pct||0) < 50).map(s => s.vendor_name + " (" + s.total_pct + "%)").join(", ");
        const avgScore = (eventScorecards.reduce((sum,s) => sum+(s.total_pct||0),0)/eventScorecards.length).toFixed(0);
        const summaryLines = eventScorecards.map(s => {
          const t = getTier(s.total_pct);
          const catNotes = s.category_notes || {};
          const catSummary = SCORECARD_CATEGORIES
            .filter(cat => catNotes[cat.key])
            .map(cat => "  [" + cat.label + "] " + catNotes[cat.key])
            .join("\n");
          return s.vendor_name + ": " + s.total_pct + "% (" + t?.label + ")" + (catSummary ? "\n" + catSummary : "");
        });
        const autoSummary = "Overall vendor average: " + avgScore + "%\n\n" + summaryLines.join("\n\n");
        // Only auto-fill if vendor section not yet submitted
        if (!reportData?.vendor_submitted_at) {
          setForm(f => ({
            ...f,
            ...(reportData || {}),
            vendor_performance_summary: reportData?.vendor_performance_summary || autoSummary,
            vendors_recommended: reportData?.vendors_recommended || recommended,
            vendors_not_recommended: reportData?.vendors_not_recommended || (notRecommended || "None"),
          }));
          return;
        }
      }
    }
    setForm(f => ({ ...f, ...(reportData || {}) }));
  };

  const mergeText = (existing, incoming) => {
    if (!existing || existing.trim() === incoming.trim()) return incoming;
    if (existing.includes(incoming.trim())) return existing;
    return existing.trim() + "\n\n" + incoming.trim();
  };

  const saveSection = async (section) => {
    if (!report) return;
    setSaving(true);
    const updates = { updated_at: new Date().toISOString() };
    // Fetch fresh report to merge (multi-person Strategy Lead consolidation)
    const { data: fresh } = await supabase.from("event_intelligence_reports").select("*").eq("project_id", selectedEvent.id).maybeSingle();
    if (section === "operational") {
      Object.assign(updates, {
        run_of_show_adherence: mergeText(fresh?.run_of_show_adherence || "", form.run_of_show_adherence),
        high_impact_moments: mergeText(fresh?.high_impact_moments || "", form.high_impact_moments),
        low_impact_moments: mergeText(fresh?.low_impact_moments || "", form.low_impact_moments),
        logistics_notes: mergeText(fresh?.logistics_notes || "", form.logistics_notes),
        operational_submitted_by: user.id, operational_submitted_at: new Date().toISOString()
      });
    } else if (section === "audience") {
      // Average numeric fields, merge text fields
      const existingAtt = parseInt(fresh?.estimated_attendance) || 0;
      const newAtt = parseInt(form.estimated_attendance) || 0;
      const avgAtt = existingAtt > 0 && newAtt > 0 ? Math.round((existingAtt + newAtt) / 2) : (newAtt || existingAtt || null);
      Object.assign(updates, {
        estimated_attendance: avgAtt,
        expected_attendance: parseInt(form.expected_attendance) || fresh?.expected_attendance || null,
        audience_energy_arrival: mergeText(fresh?.audience_energy_arrival || "", form.audience_energy_arrival),
        audience_energy_mid: mergeText(fresh?.audience_energy_mid || "", form.audience_energy_mid),
        audience_energy_peak: mergeText(fresh?.audience_energy_peak || "", form.audience_energy_peak),
        audience_energy_close: mergeText(fresh?.audience_energy_close || "", form.audience_energy_close),
        key_engagement_moments: mergeText(fresh?.key_engagement_moments || "", form.key_engagement_moments),
        audience_feedback_observations: mergeText(fresh?.audience_feedback_observations || "", form.audience_feedback_observations),
        audience_submitted_by: user.id, audience_submitted_at: new Date().toISOString()
      });
    } else if (section === "vendor") {
      Object.assign(updates, {
        vendor_performance_summary: form.vendor_performance_summary,
        vendors_recommended: form.vendors_recommended,
        vendors_not_recommended: form.vendors_not_recommended,
        technical_delivery_quality: form.technical_delivery_quality,
        vendor_submitted_by: user.id, vendor_submitted_at: new Date().toISOString()
      });
    } else if (section === "strategic") {
      Object.assign(updates, {
        strategic_intent_achieved: form.strategic_intent_achieved,
        client_satisfaction: form.client_satisfaction,
        business_development_signals: form.business_development_signals,
        next_edition_recommendations: form.next_edition_recommendations,
        ceo_submitted_by: user.id, ceo_submitted_at: new Date().toISOString()
      });
    }
    if (report.id) {
      await supabase.from("event_intelligence_reports").update(updates).eq("id", report.id);
    }
    const { data: updated } = await supabase.from("event_intelligence_reports").select("*").eq("project_id", selectedEvent.id).single();
    setReport(updated);
    setSaving(false);
    // Notify CEO when strategy/VM submits
    if (!isCEO) {
      const { data: ceos } = await supabase.from("profiles").select("id").eq("role","CEO");
      for (const ceo of ceos||[]) {
        await supabase.from("notifications").insert({ user_id:ceo.id, title:"Report Section Submitted — "+selectedEvent.name, message:user.name+" has submitted the "+section+" section of the intelligence report for "+selectedEvent.name+".", type:"rff" });
      }
    }
  };

  const generateAI = async () => {
    if (!report) return;
    setGenerating(true);
    // Get vendor scorecards for this event
    const eventScorecards = scorecards.filter(s => s.project_id === selectedEvent?.id);
    // Get debrief for this event — merge all ESL submissions
    const { data: debriefData } = await supabase.from("event_debrief").select("*").eq("project_id", selectedEvent?.id);
    const debrief = debriefData && debriefData.length > 0 ? debriefData.reduce((merged, d) => {
      ["what_went_well","what_to_do_differently","client_informal_feedback","surprises","recommendations"].forEach(k => {
        if (d[k]) merged[k] = merged[k] ? merged[k]+"\n\n"+d[k] : d[k];
      });
      return merged;
    }, { what_went_well:"", what_to_do_differently:"", client_informal_feedback:"", surprises:"", recommendations:"" }) : null;
    // Build detailed vendor scorecard notes for prompt
    const vendorDetailLines = eventScorecards.map(s => {
      const tier = getTier(s.total_pct);
      const catNotes = s.category_notes || {};
      const catLines = SCORECARD_CATEGORIES
        .filter(cat => catNotes[cat.key])
        .map(cat => "    [" + cat.label + "]: " + catNotes[cat.key])
        .join("\n");
      return s.vendor_name + " — " + s.total_pct + "% (" + tier.label + ")" + (catLines ? "\n" + catLines : "");
    }).join("\n\n");

    const prompt = `You are a strategic event intelligence analyst for Stretchfield — a premium African event management company whose tagline is "We don't plan events. We engineer impact."

Generate a comprehensive post-event intelligence report for the following event. Write in Stretchfield's confident, consultative voice. Use the exact section structure below.

EVENT: ${selectedEvent?.name}
CLIENT: ${selectedEvent?.client}
DATE: ${selectedEvent?.event_date ? new Date(selectedEvent.event_date).toLocaleDateString("en-GB", { day:"numeric", month:"long", year:"numeric" }) : ""}

---
SECTION 1 — EXECUTIVE INTELLIGENCE SUMMARY
Write 3–4 paragraphs summarising the overall event outcome, strategic intent, emotional resonance, and key signals. End with a "Strategic Outcomes at a Glance" list of 4–5 bullet points.

Data:
- Run of Show: ${report.run_of_show_adherence || "Not submitted"}
- High Impact Moments: ${report.high_impact_moments || "Not submitted"}
- Low Impact Moments: ${report.low_impact_moments || "Not submitted"}

---
SECTION 2 — AUDIENCE, ENGAGEMENT & BRAND INTELLIGENCE
Cover: Arrival & Early Engagement, In-Programme Behaviour, Emotional Shifts, Responsiveness & Engagement Quality, Trust & Advocacy Indicators.

Data:
- Estimated Attendance: ${report.estimated_attendance || "N/A"} (Expected: ${report.expected_attendance || "N/A"})
- Audience Energy: Arrival: ${report.audience_energy_arrival || "N/A"} | Mid: ${report.audience_energy_mid || "N/A"} | Peak: ${report.audience_energy_peak || "N/A"} | Close: ${report.audience_energy_close || "N/A"}
- Key Engagement Moments: ${report.key_engagement_moments || "Not submitted"}
- Audience Feedback: ${report.audience_feedback_observations || "Not submitted"}

---
SECTION 3 — EXPERIENCE JOURNEY & OPERATIONAL INTELLIGENCE
Cover: Entry & Registration, Programme Flow, Strengths Observed, High Impact vs Low Impact Moments.

Data:
- Logistics Notes: ${report.logistics_notes || "Not submitted"}
- High Impact: ${report.high_impact_moments || "Not submitted"}
- Low Impact: ${report.low_impact_moments || "Not submitted"}

---
SECTION 4 — VENDOR PERFORMANCE INTELLIGENCE
Cover each vendor's performance with scores and category-level analysis. Include: Overall Assessment, Vendors Recommended, Vendors Not Recommended, Technical Delivery Quality.

Data:
${vendorDetailLines || report.vendor_performance_summary || "Not submitted"}
- Recommended: ${report.vendors_recommended || "Not submitted"}
- Not Recommended: ${report.vendors_not_recommended || "Not submitted"}
- Technical Quality: ${report.technical_delivery_quality || "Not submitted"}

---
SECTION 5 — STRATEGIC INTELLIGENCE & RECOMMENDATIONS
Cover 3–4 strategic recommendation areas, each with a "Strategic Intelligence:" insight line. End with next steps.

Data:
- Strategic Intent Achieved: ${report.strategic_intent_achieved || "Not submitted"}
- Client Satisfaction: ${report.client_satisfaction || "Not submitted"}
- Business Development Signals: ${report.business_development_signals || "Not submitted"}
- Next Edition Recommendations: ${report.next_edition_recommendations || "Not submitted"}

POST-EVENT DEBRIEF (from Strategy Leads):
- What Went Well: ${debrief?.what_went_well || "Not submitted"}
- What to Do Differently: ${debrief?.what_to_do_differently || "Not submitted"}
- Client Informal Feedback: ${debrief?.client_informal_feedback || "Not submitted"}
- Surprises: ${debrief?.surprises || "Not submitted"}
- Recommendations: ${debrief?.recommendations || "Not submitted"}

---
SECTION 6 — CLOSING STRATEGIC INSIGHT
One powerful closing paragraph in Stretchfield's voice about the event's legacy and forward momentum.

Format: Use clear section headers matching the names above. Write in flowing paragraphs with strategic intelligence bullets where appropriate. Maximum 900 words total. Do not use markdown formatting symbols like ** or ##.`;

    try {
      const response = await fetch("/api/generate-report", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ prompt })
      });
      const data = await response.json();
      if (data.error) throw new Error(data.error);
      const summary = data.text || "Unable to generate summary.";
      await supabase.from("event_intelligence_reports").update({ ai_summary: summary, ai_generated_at: new Date().toISOString() }).eq("id", report.id);
      setReport(r => ({ ...r, ai_summary: summary }));
    } catch(e) {
      alert("AI generation failed: " + e.message);
    }
    setGenerating(false);
  };

  const inputStyle = { width:"100%", padding:"9px 12px", background:T.bg, border:`1px solid ${T.border}`, borderRadius:8, color:T.textPrimary, fontSize:13, fontFamily:"inherit", outline:"none", boxSizing:"border-box" };
  const taStyle = { ...inputStyle, resize:"none" };

  //  EVENT LIST VIEW 
  if (!selectedEvent) {
    const getReportStatus = (eventId) => {
      const r = reports.find(r => r.project_id === eventId);
      if (!r) return { label:"Not Started", color:T.textMuted };
      if (isVM) {
        if (r.vendor_submitted_at) return { label:"Vendor Section ", color:T.teal };
        return { label:"Vendor Section Pending", color:T.amber };
      }
      const sections = [r.operational_submitted_at, r.audience_submitted_at, r.vendor_submitted_at, r.ceo_submitted_at];
      const done = sections.filter(Boolean).length;
      if (r.ai_summary) return { label:"Complete ", color:T.teal };
      if (done === 4) return { label:"Ready for AI", color:"#10B981" };
      return { label:`${done}/4 sections`, color:T.amber };
    };

    return (
      <div style={{ animation:"fadeUp 0.35s ease" }}>
        <div style={{ marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${T.border}` }}>
          <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:6 }}>Intelligence</div>
          <h2 style={{ margin:0, color:T.textPrimary, fontSize:22, fontWeight:800 }}>Event Reports</h2>
          <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>Post-event intelligence reports — collaborative, AI-synthesised</div>
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          {events.map(event => {
            const status = getReportStatus(event.id);
            const r = reports.find(r => r.project_id === event.id);
            return (
              <div key={event.id} onClick={() => openEvent(event)}
                style={{ background:T.surface, border:`1px solid ${T.border}`, borderLeft:`4px solid ${status.color}`, borderRadius:12, padding:"16px 20px", cursor:"pointer", transition:"border-color 0.15s" }}
                onMouseEnter={e => e.currentTarget.style.borderColor = T.cyan}
                onMouseLeave={e => e.currentTarget.style.borderLeft = `4px solid ${status.color}`}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                  <div>
                    <div style={{ color:T.textPrimary, fontWeight:800, fontSize:15 }}>{event.name}</div>
                    <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{event.client} · {event.event_date ? new Date(event.event_date).toLocaleDateString("en-GB", { day:"numeric", month:"short", year:"numeric" }) : "No date"}</div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <span style={{ color:status.color, fontSize:11, fontWeight:700, background:status.color+"18", padding:"3px 10px", borderRadius:20 }}>{status.label}</span>
                    {r && !isVM && (
                      <div style={{ display:"flex", gap:6, marginTop:6, justifyContent:"flex-end" }}>
                        {[["Op",r.operational_submitted_at],["Aud",r.audience_submitted_at],["Vnd",r.vendor_submitted_at],["Str",r.ceo_submitted_at]].map(([lbl,val]) => (
                          <span key={lbl} style={{ color:val?T.teal:T.border, fontSize:9, fontWeight:700, background:val?T.teal+"15":T.bg, padding:"1px 5px", borderRadius:10, border:`1px solid ${val?T.teal+"30":T.border}` }}>{lbl}</span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  //  REPORT FORM VIEW 
  // Check if any ESL is assigned to this event
  const eventHasESL = selectedEvent && (
    selectedEvent.assigned_to ||
    (Array.isArray(selectedEvent.assigned_to_ids) && selectedEvent.assigned_to_ids.length > 0)
  );
  const sections = [
    ...(isStrategy || (isCEO && eventHasESL) ? [{ id:"operational", label:"Operational" }, { id:"audience", label:"Audience" }] : []),
    ...(isVM || isCEO ? [{ id:"vendor", label:"Vendor" }] : []),
    ...(isCEO ? [{ id:"strategic", label:"Strategic" }] : []),
    ...(isCEO ? [{ id:"overview", label:"Overview & AI" }] : []),
  ];

  // Role label and colour
  const roleLabel = isVM ? "Vendor Manager" : isStrategy ? "Strategy & Events Lead" : "CEO";
  const roleColor = isVM ? T.amber : isStrategy ? T.magenta : T.cyan;

  // Section completion map
  const sectionDone = {
    operational: !!report?.operational_submitted_at,
    audience: !!report?.audience_submitted_at,
    vendor: !!report?.vendor_submitted_at,
    strategic: !!report?.ceo_submitted_at,
  };
  const mySections = isVM ? ["vendor"] : isStrategy ? ["operational","audience"] : ["operational","audience","vendor","strategic","overview"];
  const myDone = mySections.filter(s => sectionDone[s]).length;
  const myTotal = mySections.filter(s => s !== "overview").length;

  return (
    <div style={{ animation:"fadeUp 0.35s ease" }}>
      {/*  HEADER CARD  */}
      <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:16, padding:"20px 24px", marginBottom:20, position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg,${roleColor},${T.teal})` }} />
        <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:16 }}>
          <div style={{ flex:1 }}>
            <button onClick={() => { setSelectedEvent(null); setReport(null); }} style={{ background:"none", border:"none", color:T.textMuted, padding:"0 0 8px 0", cursor:"pointer", fontSize:12, display:"flex", alignItems:"center", gap:4 }}>← Back to Events</button>
            <div style={{ color:T.textPrimary, fontWeight:900, fontSize:20, lineHeight:1.2 }}>{selectedEvent.name}</div>
            <div style={{ color:T.textMuted, fontSize:12, marginTop:4 }}>{selectedEvent.client} {selectedEvent.event_date ? "· " + new Date(selectedEvent.event_date).toLocaleDateString("en-GB", { day:"numeric", month:"long", year:"numeric" }) : ""}</div>
            <div style={{ marginTop:10, display:"flex", gap:8, flexWrap:"wrap" }}>
              <span style={{ background:roleColor+"18", color:roleColor, fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:20, border:`1px solid ${roleColor}30` }}>{roleLabel}</span>
              {!isCEO && <span style={{ background:T.bg, color:T.textMuted, fontSize:11, padding:"3px 10px", borderRadius:20, border:`1px solid ${T.border}` }}>Your sections: {myDone}/{myTotal} complete</span>}
              {!eventHasESL && isCEO && <span style={{ background:T.amber+"18", color:T.amber, fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:20 }}> No ESL assigned — Operational & Audience skipped</span>}
            </div>
          </div>
          {/* Section status pills */}
          <div style={{ display:"flex", flexDirection:"column", gap:5, minWidth:140 }}>
            {[
              { id:"operational", label:"Operational", show: eventHasESL || isCEO },
              { id:"audience", label:"Audience", show: eventHasESL || isCEO },
              { id:"vendor", label:"Vendor", show:true },
              { id:"strategic", label:"Strategic", show:isCEO },
            ].filter(s => s.show).map(s => (
              <div key={s.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:8 }}>
                <span style={{ color:T.textMuted, fontSize:11 }}>{s.label}</span>
                <span style={{ fontSize:10, fontWeight:700, color:sectionDone[s.id]?T.teal:T.textMuted, background:sectionDone[s.id]?T.teal+"18":T.bg, padding:"1px 8px", borderRadius:10, border:`1px solid ${sectionDone[s.id]?T.teal+"30":T.border}` }}>{sectionDone[s.id]?"Done ":"Pending"}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/*  SECTION TABS  */}
      <div style={{ display:"flex", gap:2, marginBottom:20, borderBottom:`1px solid ${T.border}`, overflowX:"auto" }}>
        {sections.map(s => {
          const done = sectionDone[s.id];
          const isActive = activeSection === s.id;
          return (
            <button key={s.id} onClick={() => setActiveSection(s.id)} style={{ padding:"10px 18px", border:"none", background:"none", cursor:"pointer", color:isActive?T.cyan:done?T.teal:T.textMuted, fontWeight:isActive?800:done?600:400, fontSize:13, borderBottom:isActive?`2px solid ${T.cyan}`:done?`2px solid ${T.teal+"60"}`:"2px solid transparent", marginBottom:-1, whiteSpace:"nowrap", transition:"all 0.15s" }}>
              {s.label}{done ? " " : ""}
            </button>
          );
        })}
      </div>

      {/*  OPERATIONAL SECTION  */}
      {activeSection === "operational" && (isStrategy || isCEO) && (
        <div>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
            <div style={{ width:4, height:36, background:`linear-gradient(180deg,${T.magenta},${T.cyan})`, borderRadius:4 }} />
            <div>
              <div style={{ color:T.textPrimary, fontWeight:900, fontSize:16 }}>Operational Section</div>
              <div style={{ color:T.textMuted, fontSize:11, marginTop:1 }}>Filled by Strategy & Events Lead · covers run of show, high/low impact moments, logistics</div>
            </div>
          </div>
          <EventReportField label="Run of Show Adherence" field="run_of_show_adherence" rows={3} placeholder="How closely was the run of show followed? Any deviations?" form={form} setForm={setForm} />
          <EventReportField label="High Impact Moments" field="high_impact_moments" rows={3} placeholder="What moments created the most impact?" form={form} setForm={setForm} />
          <EventReportField label="Low Impact Moments" field="low_impact_moments" rows={3} placeholder="What moments underperformed?" form={form} setForm={setForm} />
          <EventReportField label="Logistics Notes" field="logistics_notes" rows={3} placeholder="Setup, breakdown, venue, transport observations..." form={form} setForm={setForm} />
          <div style={{ display:"flex", gap:10, alignItems:"center", marginTop:8 }}>
            {(isStrategy || isCEO) && <button onClick={() => saveSection("operational")} disabled={saving} style={{ background:`linear-gradient(135deg,${T.magenta},${T.cyan})`, border:"none", color:"#fff", padding:"11px 28px", borderRadius:10, cursor:"pointer", fontWeight:800, fontSize:13, opacity:saving?0.7:1 }}>{saving?"Saving...":"Save Operational Section "}</button>}
            {report?.operational_submitted_at && <span style={{ color:T.teal, fontSize:12, fontWeight:600 }}>Last saved {new Date(report.operational_submitted_at).toLocaleDateString("en-GB", { day:"numeric", month:"short", hour:"2-digit", minute:"2-digit" })}</span>}
          </div>
        </div>
      )}

      {/*  AUDIENCE SECTION  */}
      {activeSection === "audience" && (isStrategy || isCEO) && (
        <div>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
            <div style={{ width:4, height:36, background:`linear-gradient(180deg,${T.cyan},${T.teal})`, borderRadius:4 }} />
            <div>
              <div style={{ color:T.textPrimary, fontWeight:900, fontSize:16 }}>Audience Section</div>
              <div style={{ color:T.textMuted, fontSize:11, marginTop:1 }}>Filled by Strategy & Events Lead · attendance, energy levels, engagement observations</div>
            </div>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:14 }}>
            <EventReportField label="Estimated Attendance" field="estimated_attendance" rows={1} placeholder="Actual number" form={form} setForm={setForm} />
            <EventReportField label="Expected Attendance" field="expected_attendance" rows={1} placeholder="Planned number" form={form} setForm={setForm} />
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:14 }}>
            <EventReportField label="Audience Energy — Arrival" field="audience_energy_arrival" rows={1} placeholder="Low/Medium/High" form={form} setForm={setForm} />
            <EventReportField label="Audience Energy — Mid" field="audience_energy_mid" rows={1} placeholder="Low/Medium/High" form={form} setForm={setForm} />
            <EventReportField label="Audience Energy — Peak" field="audience_energy_peak" rows={1} placeholder="Low/Medium/High" form={form} setForm={setForm} />
            <EventReportField label="Audience Energy — Close" field="audience_energy_close" rows={1} placeholder="Low/Medium/High" form={form} setForm={setForm} />
          </div>
          <EventReportField label="Key Engagement Moments" field="key_engagement_moments" rows={3} placeholder="What drove the most engagement?" form={form} setForm={setForm} />
          <EventReportField label="Audience Feedback Observations" field="audience_feedback_observations" rows={3} placeholder="Overheard feedback, reactions, mood..." form={form} setForm={setForm} />
          <div style={{ display:"flex", gap:10, alignItems:"center", marginTop:8 }}>
            {(isStrategy || isCEO) && <button onClick={() => saveSection("audience")} disabled={saving} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#fff", padding:"11px 28px", borderRadius:10, cursor:"pointer", fontWeight:800, fontSize:13, opacity:saving?0.7:1 }}>{saving?"Saving...":"Save Audience Section "}</button>}
            {report?.audience_submitted_at && <span style={{ color:T.teal, fontSize:12, fontWeight:600 }}>Last saved {new Date(report.audience_submitted_at).toLocaleDateString("en-GB", { day:"numeric", month:"short", hour:"2-digit", minute:"2-digit" })}</span>}
          </div>
        </div>
      )}

      {/*  VENDOR SECTION  */}
      {activeSection === "vendor" && (isVM || isCEO) && (
        <div>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
            <div style={{ width:4, height:36, background:`linear-gradient(180deg,${T.amber},#F59E0B)`, borderRadius:4 }} />
            <div>
              <div style={{ color:T.textPrimary, fontWeight:900, fontSize:16 }}>Vendor Section</div>
              <div style={{ color:T.textMuted, fontSize:11, marginTop:1 }}>Filled by Vendor Manager · auto-populated from scorecard data · editable before saving</div>
            </div>
          </div>
          {scorecards.filter(s => s.project_id === selectedEvent.id).length > 0 && (
            <div style={{ background:T.bg, border:`1px solid ${T.teal}30`, borderRadius:10, padding:"12px 14px", marginBottom:14 }}>
              <div style={{ color:T.teal, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:8 }}> Auto-populated from Vendor Scorecards</div>
              <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
                {scorecards.filter(s => s.project_id === selectedEvent.id).map(sc => {
                  const t = getTier(sc.total_pct);
                  return (
                    <div key={sc.id} style={{ display:"flex", justifyContent:"space-between", fontSize:12 }}>
                      <span style={{ color:T.textPrimary, fontWeight:600 }}>{sc.vendor_name}</span>
                      <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                        <span style={{ color:t?.color||T.amber, fontWeight:700 }}>{sc.total_pct}% — {t?.label}</span>
                        {sc.visible_to_vendor && <span style={{ color:T.teal, fontSize:10, fontWeight:700 }}>Report sent </span>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <EventReportField label="Overall Vendor Performance Summary" field="vendor_performance_summary" rows={4} placeholder="General assessment of all vendors..." form={form} setForm={setForm} />
          <EventReportField label="Vendors to Recommend for Future Events" field="vendors_recommended" rows={3} placeholder="List vendors who performed excellently..." form={form} setForm={setForm} />
          <EventReportField label="Vendors Not Recommended" field="vendors_not_recommended" rows={3} placeholder="List vendors with performance issues..." form={form} setForm={setForm} />
          <EventReportField label="Technical Delivery Quality" field="technical_delivery_quality" rows={3} placeholder="AV, production, equipment quality..." form={form} setForm={setForm} />
          {/* Vendor Scorecards for this event */}
          {scorecards.filter(s => s.project_id === selectedEvent.id).length > 0 && (
            <div style={{ background:T.bg, border:`1px solid ${T.border}`, borderRadius:10, padding:"14px 16px", marginBottom:14 }}>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:10 }}>Vendor Scorecards — {selectedEvent.name}</div>
              {scorecards.filter(s => s.project_id === selectedEvent.id).map(sc => (
                <div key={sc.id} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:`1px solid ${T.border}33` }}>
                  <span style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{sc.vendor_name}</span>
                  <span style={{ color:getTier(sc.total_pct)?.color||T.amber, fontWeight:700, fontSize:13 }}>{sc.total_pct}% — {getTier(sc.total_pct)?.label}</span>
                </div>
              ))}
            </div>
          )}
          <div style={{ display:"flex", gap:10, alignItems:"center", marginTop:8 }}>
            {(isVM || isCEO) && <button onClick={() => saveSection("vendor")} disabled={saving} style={{ background:`linear-gradient(135deg,${T.amber},#F59E0B)`, border:"none", color:"#060B14", padding:"11px 28px", borderRadius:10, cursor:"pointer", fontWeight:800, fontSize:13, opacity:saving?0.7:1 }}>{saving?"Saving...":"Save Vendor Section "}</button>}
            {report?.vendor_submitted_at && <span style={{ color:T.teal, fontSize:12, fontWeight:600 }}>Last saved {new Date(report.vendor_submitted_at).toLocaleDateString("en-GB", { day:"numeric", month:"short", hour:"2-digit", minute:"2-digit" })}</span>}
          </div>
        </div>
      )}

      {/*  STRATEGIC SECTION  */}
      {activeSection === "strategic" && isCEO && (
        <div>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
            <div style={{ width:4, height:36, background:`linear-gradient(180deg,${T.cyan},#8B5CF6)`, borderRadius:4 }} />
            <div>
              <div style={{ color:T.textPrimary, fontWeight:900, fontSize:16 }}>Strategic Section</div>
              <div style={{ color:T.textMuted, fontSize:11, marginTop:1 }}>Filled by CEO · strategic intent, client satisfaction, business development signals</div>
            </div>
          </div>
          <EventReportField label="Was Strategic Intent Achieved?" field="strategic_intent_achieved" rows={3} placeholder="Did the event achieve its strategic objectives?" form={form} setForm={setForm} />
          <EventReportField label="Client Satisfaction Assessment" field="client_satisfaction" rows={3} placeholder="Client feedback, satisfaction level, relationship status..." form={form} setForm={setForm} />
          <EventReportField label="Business Development Signals" field="business_development_signals" rows={3} placeholder="New leads, repeat business signals, referrals..." form={form} setForm={setForm} />
          <EventReportField label="Recommendations for Next Edition" field="next_edition_recommendations" rows={4} placeholder="What should we do differently next time?" form={form} setForm={setForm} />
          <button onClick={() => saveSection("strategic")} disabled={saving} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"10px 24px", borderRadius:8, cursor:"pointer", fontWeight:800, fontSize:13 }}>{saving?"Saving...":"Save Strategic Section"}</button>
        </div>
      )}

      {/*  OVERVIEW & AI  */}
      {activeSection === "overview" && (
        <div>
          {/* Scorecard summary for CEO */}
          {isCEO && scorecards.filter(s => s.project_id === selectedEvent?.id).length > 0 && (
            <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"16px 18px", marginBottom:16 }}>
              <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", marginBottom:10 }}>Vendor Scorecards — From VM</div>
              {scorecards.filter(s => s.project_id === selectedEvent?.id).map(sc => {
                const t = getTier(sc.total_pct);
                return (
                  <div key={sc.id} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:`1px solid ${T.border}22` }}>
                    <span style={{ color:T.textPrimary, fontSize:13, fontWeight:600 }}>{sc.vendor_name}</span>
                    <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                      <span style={{ color:t?.color||T.amber, fontWeight:700, fontSize:13 }}>{sc.total_pct}%</span>
                      <span style={{ color:t?.color||T.amber, fontSize:10, fontWeight:700, background:(t?.color||T.amber)+"15", padding:"1px 6px", borderRadius:10 }}>{t?.label}</span>
                      {sc.visible_to_vendor && <span style={{ color:T.teal, fontSize:10 }}> Sent</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Section status */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:10, marginBottom:20 }}>
            {[
              { label:"Operational", done:report?.operational_submitted_at, by:"Strategy Lead" },
              { label:"Audience", done:report?.audience_submitted_at, by:"Strategy Lead" },
              { label:"Vendor", done:report?.vendor_submitted_at, by:"Vendor Manager" },
              { label:"Strategic", done:report?.ceo_submitted_at, by:"CEO" },
            ].map(s => (
              <div key={s.label} style={{ background:T.bg, border:`1px solid ${s.done?T.teal+"40":T.border}`, borderRadius:10, padding:"12px 14px" }}>
                <div style={{ color:s.done?T.teal:T.amber, fontWeight:800, fontSize:12 }}>{s.done?" Done":"Pending"}</div>
                <div style={{ color:T.textPrimary, fontSize:12, fontWeight:600, marginTop:2 }}>{s.label}</div>
                <div style={{ color:T.textMuted, fontSize:10, marginTop:2 }}>{s.by}</div>
              </div>
            ))}
          </div>

          {/* AI Summary */}
          {report?.ai_summary ? (
            <div style={{ background:T.surface, border:`1px solid ${T.teal}30`, borderRadius:12, padding:"20px 24px", marginBottom:16 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                <div style={{ color:T.teal, fontWeight:800, fontSize:14 }}> AI Intelligence Report</div>
                {isCEO && <button onClick={generateAI} disabled={generating} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"4px 12px", borderRadius:6, cursor:"pointer", fontSize:11 }}>Regenerate</button>}
              </div>
              <div style={{ color:T.textSecondary, fontSize:13, lineHeight:1.7, whiteSpace:"pre-wrap" }}>{report.ai_summary}</div>
            </div>
          ) : (
            <div style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:"28px", textAlign:"center", marginBottom:16 }}>
              <div style={{ fontSize:32, marginBottom:12 }}></div>
              <div style={{ color:T.textPrimary, fontWeight:800, fontSize:16, marginBottom:8 }}>AI Report Not Yet Generated</div>
              <div style={{ color:T.textMuted, fontSize:13, marginBottom:20 }}>{isCEO ? "Fill in the strategic section and generate the comprehensive AI intelligence report." : "The CEO will generate the AI report once all sections are complete."}</div>
              {isCEO && (
                <button onClick={generateAI} disabled={generating} style={{ background:`linear-gradient(135deg,${T.cyan},${T.teal})`, border:"none", color:"#060B14", padding:"12px 28px", borderRadius:10, cursor:"pointer", fontWeight:800, fontSize:14 }}>{generating?"Generating...":" Generate AI Report"}</button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const EventsView = ({ user, userRole, activeCountry = "All" }) => {
  const [events, setEvents] = useState([]);
  const [clients, setClients] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ name: '', client: '', client_id: '', event_date: '', event_end_date: '', deadline: '', phase: 'Planning', event_category: '', country: user?.country || activeCountry || 'Ghana', assigned_to: '', assigned_to_name: '' });
  const [saving, setSaving] = useState(false);
  const [taskModalEvent, setTaskModalEvent] = useState(null);
  const [impactEvent, setImpactEvent] = useState(null);
  const [assignModal, setAssignModal] = useState(null);
  const [strategyLeads, setStrategyLeads] = useState([]);
  const [editEvent, setEditEvent] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [portalEvent, setPortalEvent] = useState(null);
  const [internalPortalEvent, setInternalPortalEvent] = useState(null);

  const canManage = ['CEO','Country Manager'].includes(user?.role);
  const userCountry = user?.country || 'Ghana';
  const canSeeTasks = ['CEO','Country Manager','Strategy & Events Lead','Vendor Manager'].includes(user?.role);

  const load = async () => {
    const [p, c, t, sl] = await Promise.all([
      (!activeCountry || activeCountry === "All")
        ? supabase.from('projects').select('*').order('created_at', { ascending: false })
        : supabase.from('projects').select('*').eq('country', activeCountry).order('created_at', { ascending: false }),
      (!activeCountry || activeCountry === "All")
        ? supabase.from('clients').select('*').order('name')
        : supabase.from('clients').select('*').eq('country', activeCountry).order('name'),
      supabase.from('tasks').select('*').order('created_at', { ascending: false }),
      supabase.from('profiles').select('id, name, email, avatar').eq('role', 'Strategy & Events Lead'),
    ]);
    setEvents(p.data || []);
    setClients(c.data || []);
    setTasks(t.data || []);
    setStrategyLeads(sl.data || []);
  };

  useEffect(() => { load(); }, [activeCountry]);

  const handleCreate = async () => {
    if (!form.name) { alert('Event name is required'); return; }
    setSaving(true);
    if (!form.event_category) { alert('Please select an event category.'); setSaving(false); return; }
    const { error } = await supabase.from('projects').insert({
      name: form.name,
      client: form.client || '',
      client_id: form.client_id || null,
      deadline: form.deadline || null,
      event_date: form.event_date || null,
      phase: form.phase,
      completion: 0,
      status: 'active',
      tasks: 0,
      completed: 0,
      event_category: form.event_category,
      country: form.country || user?.country || activeCountry || 'Ghana',
      assigned_to: form.assigned_to || null,
      assigned_to_name: form.assigned_to_name || null,
    });
    if (error) { alert('Error: ' + error.message); setSaving(false); return; }
    setModal(false);
    setForm({ name: '', client: '', client_id: '', event_date: '', event_end_date: '', deadline: '', phase: 'Planning', event_category: '', country: 'Ghana', assigned_to: '', assigned_to_name: '' });
    setSaving(false);
    load();
  };

  const handleEdit = (p) => {
    setEditEvent(p);
    setEditForm({
      name: p.name || '',
      client_id: p.client_id || '',
      client: p.client || '',
      event_date: p.event_date || '',
      deadline: p.deadline || '',
      phase: p.phase || 'Planning',
      completion: p.completion || 0,
      status: p.status || 'active',
      event_category: p.event_category || '',
      country: p.country || 'Ghana',
    });
  };

  const handleUpdate = async () => {
    if (!editForm.name) return;
    setSaving(true);
    await supabase.from('projects').update({
      name: editForm.name,
      client: editForm.client,
      client_id: editForm.client_id || null,
      event_date: editForm.event_date || null,
      event_end_date: editForm.event_end_date || null,
      deadline: editForm.deadline || null,
      phase: editForm.phase,
      completion: parseInt(editForm.completion) || 0,
      status: editForm.status,
      event_category: editForm.event_category || null,
      country: editForm.country || 'Ghana',
      assigned_to: editForm.assigned_to || null,
      assigned_to_name: editForm.assigned_to_name || null,
    }).eq('id', editEvent.id);
    setSaving(false);
    setEditEvent(null);
    load();
  };

  const openEdit = (u) => {
    setEditModal(u);
    setEditForm({ name: u.name || '', role: u.role || '', country: u.country || 'Ghana', phone: u.phone || '', newPassword: '' });
    setError('');
  };

  const handleUserUpdate = async () => {
    if (!editForm.name) { setError('Name is required.'); return; }
    setSaving(true); setError('');
    await supabase.from('profiles').update({
      name: editForm.name,
      role: editForm.role,
      country: editForm.role === 'Country Manager' ? editForm.country : null,
      phone: editForm.phone || null,
    }).eq('id', editModal.id);
    // Update password if provided
    if (editForm.newPassword) {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        await fetch('https://okbduzenceoknkjqnrha.supabase.co/functions/v1/delete-user', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session?.access_token}` },
          body: JSON.stringify({ userId: editModal.id, action: 'reset-password', newPassword: editForm.newPassword }),
        });
      } catch (e) { console.error(e); }
    }
    setSaving(false);
    setEditModal(null);
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this event? This cannot be undone.')) return;
    try {
      // Step 1 — delete task comments via task IDs
      const { data: taskList } = await supabase.from('tasks').select('id').eq('project_id', id);
      if (taskList?.length) {
        const taskIds = taskList.map(t => t.id);
        await supabase.from('task_comments').delete().in('task_id', taskIds);
      }
      // Step 2 — delete tasks
      await supabase.from('tasks').delete().eq('project_id', id);
      // Step 3 — delete impact data
      await Promise.all([
        supabase.from('event_impact_briefs').delete().eq('project_id', id),
        supabase.from('event_post_data').delete().eq('project_id', id),
        supabase.from('event_scorecards').delete().eq('project_id', id),
        supabase.from('event_impact_reports').delete().eq('project_id', id),
        supabase.from('vendor_scorecards').delete().eq('project_id', id),
        supabase.from('expenses').delete().eq('project_id', id),
        supabase.from('budgets').delete().eq('project_id', id),
        supabase.from('client_budgets').delete().eq('project_id', id),
        supabase.from('client_expenses').delete().eq('project_id', id),
        supabase.from('client_invoices').delete().eq('project_id', id),
        supabase.from('feedback').delete().eq('project_id', id),
      ]);
      // Step 4 — delete RFF chain
      const { data: rffList } = await supabase.from('rffs').select('id').eq('project_id', id);
      if (rffList?.length) {
        const rffIds = rffList.map(r => r.id);
        // Delete invoices referencing RFFs first
        await supabase.from('invoices').delete().in('rff_id', rffIds);
        await Promise.all([
          supabase.from('rff_vendor_assignments').delete().in('rff_id', rffIds),
          supabase.from('rff_budgets').delete().in('rff_id', rffIds),
          supabase.from('rff_awards').delete().in('rff_id', rffIds),
        ]);
        await supabase.from('rffs').delete().in('id', rffIds);
      }
      // Step 5 — delete POs and vendor invoices
      await supabase.from('vendor_invoices').delete().eq('event_id', id);
      await supabase.from('purchase_orders').delete().eq('event_id', id);
      // Step 6 — delete event
      const { error } = await supabase.from('projects').delete().eq('id', id);
      if (error) { alert('Delete failed: ' + error.message); return; }
      load();
    } catch (e) {
      alert('Delete failed: ' + e.message);
    }
  };

  return (
    <div style={{ animation: "fadeUp 0.35s ease" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, paddingBottom: 20, borderBottom: `1px solid ${T.border}` }}>
        <div>
          <div style={{ color: T.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 6 }}>Portfolio</div>
          <h2 style={{ margin: 0, color: T.textPrimary, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>Events</h2>
          <div style={{ color: T.textMuted, fontSize: 12, marginTop: 4 }}>{events.length} active engagement{events.length !== 1 ? "s" : ""}</div>
        </div>
        {canManage && <Btn onClick={() => setModal(true)}>+ New Event</Btn>}
      </div>
      {events.length === 0 ? (
        <Card style={{ textAlign: 'center', padding: 60 }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}></div>
          <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>No events yet</div>
          <div style={{ color: T.textMuted, fontSize: 13 }}>Click "+ New Event" to get started.</div>
        </Card>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
          {(userRole === "Strategy & Events Lead" 
            ? events.filter(e => e.assigned_to === user?.id || (Array.isArray(e.assigned_to_ids) && e.assigned_to_ids.includes(user?.id)))
            : userRole === "Country Manager" 
            ? events.filter(e => (e.country || 'Ghana') === (user?.country || 'Ghana')) 
            : events).map((p, idx) => (
            <div key={p.id} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden", transition: "box-shadow 0.2s, border-color 0.2s", animationDelay: idx * 0.04 + "s" }}>
              {/* Card header — always visible */}
              <div style={{ padding: "20px 22px" }}
                onMouseEnter={e => { e.currentTarget.parentElement.style.boxShadow = `0 4px 28px ${T.cyan}10`; e.currentTarget.parentElement.style.borderColor = T.cyan + "40"; }}
                onMouseLeave={e => { e.currentTarget.parentElement.style.boxShadow = "none"; e.currentTarget.parentElement.style.borderColor = T.border; }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: T.textPrimary, fontWeight: 800, fontSize: 14, letterSpacing: "-0.01em", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p.name}</div>
                    <div style={{ color: T.textMuted, fontSize: 11, marginTop: 2 }}>{p.client}</div>
                    {p.assigned_to_name && <div style={{ color: T.amber, fontSize: 10, fontWeight: 700, marginTop: 2 }}> {p.assigned_to_name}</div>}
                  </div>
                  <Badge status={p.status} />
                </div>

                {/* Category badge + Phase row */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    <div style={{ background: T.cyan + "18", color: T.cyan, padding: "2px 10px", borderRadius: 20, fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase" }}>{p.phase}</div>
                    {p.event_category && (
                      <div style={{ background: (EVENT_ARCHETYPES[p.event_category]?.color||T.teal)+"18", color: EVENT_ARCHETYPES[p.event_category]?.color||T.teal, border: `1px solid ${(EVENT_ARCHETYPES[p.event_category]?.color||T.teal)}30`, padding: "2px 8px", borderRadius: 20, fontSize: 10, fontWeight: 800 }}>{p.event_category}</div>
                    )}
                  </div>
                  {p.deadline && <div style={{ color: T.textMuted, fontSize: 11 }}>Due {p.deadline}</div>}
                </div>

                {/* Progress bar — weighted by priority × status */}
                {(() => {
                  const priorityWeight = { Critical: 4, High: 3, Medium: 2, Low: 1 };
                  const statusPct = { pending: 0, 'in-progress': 50, completed: 100, done: 100 };
                  const eventTasks = tasks.filter(t => t.project_id === p.id || t.event_id === p.id);
                  const totalTasks = eventTasks.length;
                  const completedTasks = eventTasks.filter(t => t.status === 'completed' || t.status === 'done').length;
                  let taskCompletion = 0;
                  if (totalTasks > 0) {
                    const totalWeight = eventTasks.reduce((s, t) => s + (priorityWeight[t.priority] || 2), 0);
                    const earnedWeight = eventTasks.reduce((s, t) => s + (priorityWeight[t.priority] || 2) * ((statusPct[t.status] || 0) / 100), 0);
                    taskCompletion = totalWeight > 0 ? Math.round((earnedWeight / totalWeight) * 100) : 0;
                  }
                  return (
                    <div>
                      <div style={{ height: 4, background: T.border + "44", borderRadius: 2, marginBottom: 6 }}>
                        <div style={{ height: "100%", width: taskCompletion + "%", background: `linear-gradient(90deg, ${T.cyan}, ${T.teal})`, borderRadius: 2, transition: "width 0.4s ease" }} />
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ color: T.textMuted, fontSize: 10 }}>
                          {totalTasks > 0 ? `${completedTasks}/${totalTasks} tasks · ${taskCompletion}% complete` : `${taskCompletion}% complete`}
                        </div>
                        {canManage ? (
                          <button onClick={async (e) => {
                            e.stopPropagation();
                            await supabase.from("projects").update({ active_for_client: !p.active_for_client }).eq("id", p.id);
                            load();
                          }} style={{
                            background: p.active_for_client ? T.teal + "18" : "none",
                            border: `1px solid ${p.active_for_client ? T.teal + "60" : T.border}`,
                            color: p.active_for_client ? T.teal : T.textMuted,
                            padding: "3px 10px", borderRadius: 20, cursor: "pointer", fontSize: 10, fontWeight: 700,
                          }}>
                            {p.active_for_client ? " Client Visible" : " Hidden"}
                          </button>
                        ) : (
                          <span style={{ color: p.active_for_client ? T.teal : T.textMuted, fontSize: 10, fontWeight: 600 }}>
                            {p.active_for_client ? " Visible" : " Hidden"}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* Edit + Delete buttons — canManage roles */}
                {canManage && (
                  <div style={{ display: "flex", gap: 6, marginTop: 10 }}>
                    <button onClick={e => { e.stopPropagation(); handleEdit(p); }} style={{ flex: 1, padding: "6px 10px", background: T.cyan+"15", border: `1px solid ${T.cyan}30`, borderRadius: 6, cursor: "pointer", color: T.cyan, fontSize: 11, fontWeight: 700 }}> Edit</button>
                    <button onClick={e => { e.stopPropagation(); handleDelete(p.id); }} style={{ flex: 1, padding: "6px 10px", background: T.red+"15", border: `1px solid ${T.red}30`, borderRadius: 6, cursor: "pointer", color: T.red, fontSize: 11, fontWeight: 700 }}> Delete</button>
                  </div>
                )}

                {/* Assign Event + Impact buttons — CEO and CM */}
                {(user?.role === "CEO" || user?.role === "Country Manager") && (
                  <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
                    <button onClick={e => { e.stopPropagation(); setAssignModal(p); }} style={{ flex: 1, padding: "6px 10px", background: T.amber+"15", border: `1px solid ${T.amber}30`, borderRadius: 6, cursor: "pointer", color: T.amber, fontSize: 11, fontWeight: 700 }}>
                       {p.assigned_to_name ? p.assigned_to_name.split(" ")[0] : "Assign Event"}
                    </button>
                    <button onClick={e => { e.stopPropagation(); setInternalPortalEvent(p); }} style={{ flex: 1, padding: "6px 10px", background: T.cyan+"15", border: `1px solid ${T.cyan}30`, borderRadius: 6, cursor: "pointer", color: T.cyan, fontSize: 11, fontWeight: 700 }}>Open</button>
                    {p.event_category && (
                      <button onClick={e => { e.stopPropagation(); setImpactEvent(impactEvent?.id === p.id ? null : p); }} style={{ flex: 1, padding: "6px 10px", background: (EVENT_ARCHETYPES[p.event_category]?.color||T.teal)+"15", border: `1px solid ${(EVENT_ARCHETYPES[p.event_category]?.color||T.teal)}30`, borderRadius: 6, cursor: "pointer", color: EVENT_ARCHETYPES[p.event_category]?.color||T.teal, fontSize: 11, fontWeight: 700 }}>Impact</button>
                    )}
                    {p.client_id && canManage && (
                      <button onClick={e => { e.stopPropagation(); setPortalEvent(p); }} style={{ flex: 1, padding: "6px 10px", background: T.teal+"15", border: `1px solid ${T.teal}30`, borderRadius: 6, cursor: "pointer", color: T.teal, fontSize: 11, fontWeight: 700 }}>Client Portal</button>
                    )}
                  </div>
                )}

                {/* View Tasks button — privileged roles only */}
                {canSeeTasks && (() => {
                  const eventTaskCount = tasks.filter(t => t.project_id === p.id).length;
                  return (
                    <button onClick={e => { e.stopPropagation(); setInternalPortalEvent(p); }} style={{
                      marginTop: 14, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center",
                      background: T.bg, border: `1px solid ${T.border}80`,
                      borderRadius: 8, padding: "7px 12px", cursor: "pointer", transition: "all 0.15s",
                    }}
                      onMouseEnter={e => { e.currentTarget.style.borderColor = T.cyan + "60"; e.currentTarget.style.background = T.cyan + "10"; }}
                      onMouseLeave={e => { e.currentTarget.style.borderColor = T.border + "80"; e.currentTarget.style.background = T.bg; }}
                    >
                      <span style={{ color: T.textMuted, fontSize: 11, fontWeight: 700 }}>
                         {eventTaskCount} Task{eventTaskCount !== 1 ? "s" : ""}
                      </span>
                      <span style={{ color: T.cyan, fontSize: 11, fontWeight: 700 }}>View →</span>
                    </button>
                  );
                })()}
              </div>
            </div>
          ))}
        </div>
      )}
      {/* Impact Intelligence Panel */}
      {impactEvent && (
        <div style={{ position:"fixed", inset:0, zIndex:600, background:"rgba(0,0,0,0.85)", backdropFilter:"blur(8px)", display:"flex", alignItems:"flex-start", justifyContent:"center", padding:24, overflowY:"auto" }} onClick={() => setImpactEvent(null)}>
          <div style={{ background:T.surface, border:`1px solid ${T.cyan}30`, borderRadius:16, width:"100%", maxWidth:860, padding:28 }} onClick={e => e.stopPropagation()}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
              <div>
                <div style={{ color:T.textMuted, fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.1em" }}>Impact Intelligence</div>
                <div style={{ color:T.textPrimary, fontWeight:900, fontSize:20, marginTop:4 }}>{impactEvent.name}</div>
                <div style={{ color:T.textMuted, fontSize:12, marginTop:2 }}>{impactEvent.event_category} · {impactEvent.client}</div>
              </div>
              <button onClick={() => setImpactEvent(null)} style={{ background:"none", border:`1px solid ${T.border}`, color:T.textMuted, padding:"6px 14px", borderRadius:8, cursor:"pointer", fontSize:12 }}>Close</button>
            </div>
            <EventImpactView user={user} project={impactEvent} />
          </div>
        </div>
      )}

      {/*  Assign Strategy Lead Modal  */}
      {assignModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setAssignModal(null)}>
          <div style={{ background: T.surface, border: `1px solid ${T.amber}30`, borderRadius: 16, width: "100%", maxWidth: 480, padding: 28 }} onClick={e => e.stopPropagation()}>
            <div style={{ color: T.textPrimary, fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Assign Strategy Lead</div>
            <div style={{ color: T.textMuted, fontSize: 12, marginBottom: 20 }}>Event: <strong style={{ color: T.textPrimary }}>{assignModal.name}</strong></div>
            {assignModal.assigned_to_name && (
              <div style={{ background: T.amber+"12", border: `1px solid ${T.amber}30`, borderRadius: 8, padding: "10px 14px", marginBottom: 16, color: T.amber, fontSize: 12 }}>
                Currently assigned to: <strong>{assignModal.assigned_to_name}</strong>
              </div>
            )}
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 20 }}>
              {strategyLeads.map(sl => (
                <div key={sl.id} onClick={async () => {
                  // Toggle assignment - if already assigned, keep + add; support multiple
                  const currentIds = (assignModal.assigned_to_ids || (assignModal.assigned_to ? [assignModal.assigned_to] : []));
                  const isAssigned = currentIds.includes(sl.id);
                  const newIds = isAssigned ? currentIds.filter(id => id !== sl.id) : [...currentIds, sl.id];
                  const newNames = strategyLeads.filter(l => newIds.includes(l.id)).map(l => l.name).join(", ");
                  await supabase.from("projects").update({ assigned_to: newIds[0] || null, assigned_to_name: newNames || null, assigned_to_ids: newIds }).eq("id", assignModal.id);
                  if (!isAssigned) {
                    await supabase.from("notifications").insert({ user_id: sl.id, title: "Event Assigned to You", message: `CEO assigned you to "${assignModal.name}". Check your Events tab.`, type: "task" });
                    if (sl.email) await sendEmail(sl.email, `Event Assigned — ${assignModal.name}`, notifEmailHtml({ name: sl.name, title: "Event Assigned to You", message: `CEO has assigned you as Strategy Lead for <strong>${assignModal.name}</strong>. Please log in to view the event details.`, actionUrl: "https://workroom.stretchfield.com", actionLabel: "View Event" }));
                  }
                  setAssignModal(prev => ({...prev, assigned_to: newIds[0] || null, assigned_to_ids: newIds, assigned_to_name: newNames}));
                  load();
                }} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 16px", background: (assignModal.assigned_to_ids || [assignModal.assigned_to]).includes(sl.id) ? T.amber+"15" : T.bg, border: `1px solid ${(assignModal.assigned_to_ids || [assignModal.assigned_to]).includes(sl.id) ? T.amber : T.border}`, borderRadius: 10, cursor: "pointer" }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = T.amber}
                  onMouseLeave={e => { const assigned = (assignModal.assigned_to_ids || [assignModal.assigned_to]).includes(sl.id); e.currentTarget.style.borderColor = assigned ? T.amber : T.border; }}>
                  <div style={{ width: 36, height: 36, borderRadius: "50%", background: T.amber+"20", border: `1px solid ${T.amber}40`, display: "flex", alignItems: "center", justifyContent: "center", color: T.amber, fontWeight: 800, fontSize: 13 }}>{(sl.name||"?").slice(0,2).toUpperCase()}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ color: T.textPrimary, fontWeight: 700, fontSize: 14 }}>{sl.name}</div>
                    <div style={{ color: T.textMuted, fontSize: 11 }}>{sl.email}</div>
                  </div>
                  {(assignModal.assigned_to_ids || [assignModal.assigned_to]).includes(sl.id) && <div style={{ color: T.amber, fontWeight: 900, fontSize: 16 }}></div>}
                </div>
              ))}
              {strategyLeads.length === 0 && <div style={{ color: T.textMuted, fontSize: 13, textAlign: "center", padding: 20 }}>No Strategy & Events Lead users found.</div>}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              {assignModal.assigned_to && (
                <button onClick={async () => {
                  await supabase.from("projects").update({ assigned_to: null, assigned_to_name: null }).eq("id", assignModal.id);
                  setAssignModal(null); load();
                }} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>Remove Assignment</button>
              )}
              <button onClick={() => setAssignModal(null)} style={{ background: "none", border: `1px solid ${T.border}`, color: T.textMuted, padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/*  Event Tasks Modal  */}
      {/* Internal Event Portal */}
      {internalPortalEvent && (
        <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", overflowY: "auto" }} onClick={() => setInternalPortalEvent(null)}>
          <div style={{ minHeight: "100vh", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "24px 20px" }}>
            <div style={{ background: T.bg, borderRadius: 16, width: "100%", maxWidth: 800, padding: 28 }} onClick={e => e.stopPropagation()}>
              <InternalEventPortal event={internalPortalEvent} user={user} allTasks={tasks} onClose={() => setInternalPortalEvent(null)} />
            </div>
          </div>
        </div>
      )}

      {/* Client Portal Manager */}
      {portalEvent && (() => {
        const portalClient = clients.find(c => c.id === portalEvent.client_id);
        if (!portalClient) return null;
        return (
          <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", overflowY: "auto" }} onClick={() => setPortalEvent(null)}>
            <div style={{ minHeight: "100vh", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "40px 20px" }}>
              <div style={{ background: T.bg, borderRadius: 16, width: "100%", maxWidth: 720, padding: 28 }} onClick={e => e.stopPropagation()}>
                <EventClientPortalPanel event={portalEvent} client={portalClient} user={user} onClose={() => setPortalEvent(null)} />
              </div>
            </div>
          </div>
        );
      })()}


      {/* Edit Event Modal */}
      {editEvent && canManage && (
        <Modal title="Edit Event" onClose={() => setEditEvent(null)}>
          <Input label="Event Name" value={editForm.name} onChange={v => setEditForm({ ...editForm, name: v })} />
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: "0.06em", textTransform: "uppercase" }}>Event Category</div>
            <select value={editForm.event_category || ""} onChange={e => setEditForm({...editForm, event_category: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
              <option value="">Select category...</option>
              <option value="Conference/Seminar">Conference / Seminar</option>
              <option value="Product Launch">Product Launch</option>
              <option value="Awards Ceremony">Awards Ceremony</option>
              <option value="Corporate Party">Corporate Party</option>
              <option value="Other">Other</option>
            </select>
          </div>
          {clients.length > 0 ? (
            <Select label="Client" options={[{ value: '', label: 'Select a client...' }, ...clients.map(c => ({ value: c.id, label: c.company || c.name }))]}
              value={editForm.client_id}
              onChange={v => {
                const c = clients.find(cl => cl.id === v);
                setEditForm({ ...editForm, client_id: v, client: c ? (c.company || c.name) : '' });
              }} />
          ) : (
            <Input label="Client Name" value={editForm.client} onChange={v => setEditForm({ ...editForm, client: v })} />
          )}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Input label="Event Start Date" type="date" value={editForm.event_date} onChange={v => setEditForm({ ...editForm, event_date: v })} />
            <Input label="Event End Date" type="date" value={editForm.event_end_date || ""} onChange={v => setEditForm({ ...editForm, event_end_date: v })} />
          </div>
          <Input label="Planning Deadline" type="date" value={editForm.deadline} onChange={v => setEditForm({ ...editForm, deadline: v })} />
          <Select label="Phase" options={[
            { value: 'Planning', label: 'Planning' },
            { value: 'Design', label: 'Design' },
            { value: 'Execution', label: 'Execution' },
            { value: 'Review', label: 'Review' },
          ]} value={editForm.phase} onChange={v => setEditForm({ ...editForm, phase: v })} />
          <Select label="Status" options={[
            { value: 'active', label: 'Active' },
            { value: 'completed', label: 'Completed' },
            { value: 'on-hold', label: 'On Hold' },
          ]} value={editForm.status} onChange={v => setEditForm({ ...editForm, status: v })} />

          <div style={{ marginBottom: 12 }}>
            <label style={{ color: T.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", display: "block", marginBottom: 6 }}>Assign Strategy & Events Lead</label>
            <select value={editForm.assigned_to||""} onChange={e => { const sl = strategyLeads.find(s => s.id === e.target.value); setEditForm({...editForm, assigned_to: e.target.value, assigned_to_name: sl?.name || ''}); }} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
              <option value="">Unassigned</option>
              {strategyLeads.map(sl => <option key={sl.id} value={sl.id}>{sl.name}</option>)}
            </select>
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <Btn onClick={handleUpdate} disabled={saving}>{saving ? 'Saving...' : 'Save Changes'}</Btn>
            <Btn variant="ghost" onClick={() => setEditEvent(null)}>Cancel</Btn>
          </div>
        </Modal>
      )}

      {modal && (
        <Modal title="New Event" onClose={() => setModal(false)}>
          <Input label="Event Name" placeholder="e.g. Brand Campaign" value={form.name} onChange={v => setForm({ ...form, name: v })} />
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: "0.06em", textTransform: "uppercase" }}>Event Category *</div>
            <select value={form.event_category} onChange={e => setForm({...form, event_category: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${form.event_category ? T.border : "#F59E0B"}`, borderRadius: 8, color: form.event_category ? T.textPrimary : T.textMuted, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
              <option value="">Select event category...</option>
              <option value="Conference/Seminar">Conference / Seminar</option>
              <option value="Product Launch">Product Launch</option>
              <option value="Awards Ceremony">Awards Ceremony</option>
              <option value="Corporate Party">Corporate Party</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: "0.06em", textTransform: "uppercase" }}>Country</div>
            <select value={form.country} onChange={e => setForm({...form, country: e.target.value})} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
              <option value="Ghana">Ghana</option>
              <option value="Nigeria">Nigeria</option>
            </select>
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ color: T.textSecondary, fontSize: 12, fontWeight: 600, marginBottom: 8, letterSpacing: "0.06em", textTransform: "uppercase" }}>Assign Strategy & Events Lead</div>
            <select value={form.assigned_to} onChange={e => { const sl = strategyLeads.find(s => s.id === e.target.value); setForm({...form, assigned_to: e.target.value, assigned_to_name: sl?.name || ''}); }} style={{ width: "100%", padding: "9px 12px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8, color: T.textPrimary, fontSize: 13, fontFamily: "inherit", outline: "none" }}>
              <option value="">Unassigned</option>
              {strategyLeads.map(sl => <option key={sl.id} value={sl.id}>{sl.name}</option>)}
            </select>
          </div>
          {clients.length > 0 ? (
            <Select label="Client" options={[{ value: '', label: 'Select a client...' }, ...clients.map(c => ({ value: c.id, label: c.company || c.name }))]}
              value={form.client_id}
              onChange={v => {
                const c = clients.find(cl => cl.id === v);
                setForm({ ...form, client_id: v, client: c ? (c.company || c.name) : '' });
              }} />
          ) : (
            <Input label="Client Name" placeholder="Client company name" value={form.client} onChange={v => setForm({ ...form, client: v })} />
          )}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Input label="Event Start Date" type="date" value={form.event_date} onChange={v => setForm({ ...form, event_date: v })} />
            <Input label="Event End Date" type="date" value={form.event_end_date} onChange={v => setForm({ ...form, event_end_date: v })} />
          </div>
          <Input label="Planning Deadline" type="date" value={form.deadline} onChange={v => setForm({ ...form, deadline: v })} />
          <Select label="Phase" options={[
            { value: 'Planning', label: 'Planning' },
            { value: 'Design', label: 'Design' },
            { value: 'Execution', label: 'Execution' },
            { value: 'Review', label: 'Review' },
          ]} value={form.phase} onChange={v => setForm({ ...form, phase: v })} />
          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <Btn onClick={handleCreate} disabled={saving}>{saving ? 'Saving...' : 'Create Event'}</Btn>
            <Btn variant="ghost" onClick={() => setModal(false)}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};




